import * as i0 from '@angular/core';
import { Injectable, EventEmitter, SecurityContext, Component, Input, Output, NgModule } from '@angular/core';
import * as i4 from '@bento/bento-ng';
import { BentoNotification, WindowRef, BentoBusyLoaderModule, BentoUtilsModule } from '@bento/bento-ng';
import * as d3 from 'd3';
import * as geoProjection from 'd3-geo-projection';
import * as topojson from 'topojson';
import * as i2 from '@angular/common/http';
import * as i5 from '@angular/platform-browser';

// @ts-nocheck
// @ts-ignore
/* eslint-disable */
let parser = (function () {
    /*
     * Generated by PEG.js 0.8.0.
     *
     * http://pegjs.majda.cz/
     */
    function peg$subclass(child, parent) {
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
    }
    function SyntaxError(message, expected, found, offset, line, column) {
        this.message = message;
        this.expected = expected;
        this.found = found;
        this.offset = offset;
        this.line = line;
        this.column = column;
        this.name = 'SyntaxError';
    }
    peg$subclass(SyntaxError, Error);
    function parse(input) {
        let options = arguments.length > 1 ? arguments[1] : {}, peg$FAILED = {}, peg$startRuleFunctions = { svg_path: peg$parsesvg_path }, peg$startRuleFunction = peg$parsesvg_path, peg$c0 = peg$FAILED, peg$c1 = [], peg$c2 = null, peg$c3 = function (d) {
            return ops;
        }, peg$c4 = /^[Mm]/, peg$c5 = { type: 'class', value: '[Mm]', description: '[Mm]' }, peg$c6 = function (ch, args) {
            let moveCh = ch;
            // If this is the first move cmd then force it to be absolute.
            if (firstSubPath) {
                moveCh = 'M';
                firstSubPath = false;
            }
            ops.push({ type: 'moveTo', args: makeAbsolute(moveCh, args[0]) });
            for (let i = 1; i < args.length; i++) {
                // The lineTo args are either abs or relative, depending on the
                // original moveto command.
                ops.push({ type: 'lineTo', args: makeAbsolute(ch, args[i]) });
            }
        }, peg$c7 = function (one, rest) {
            return concatSequence(one, rest);
        }, peg$c8 = /^[Zz]/, peg$c9 = { type: 'class', value: '[Zz]', description: '[Zz]' }, peg$c10 = function () {
            ops.push({ type: 'closePath', args: [] });
        }, peg$c11 = /^[Ll]/, peg$c12 = { type: 'class', value: '[Ll]', description: '[Ll]' }, peg$c13 = function (ch, args) {
            for (let i = 0; i < args.length; i++) {
                ops.push({ type: 'lineTo', args: makeAbsolute(ch, args[i]) });
            }
        }, peg$c14 = /^[Hh]/, peg$c15 = { type: 'class', value: '[Hh]', description: '[Hh]' }, peg$c16 = function (ch, args) {
            for (let i = 0; i < args.length; i++) {
                ops.push({ type: 'lineTo', args: makeAbsoluteFromX(ch, args[i]) });
            }
        }, peg$c17 = /^[Vv]/, peg$c18 = { type: 'class', value: '[Vv]', description: '[Vv]' }, peg$c19 = function (ch, args) {
            for (let i = 0; i < args.length; i++) {
                ops.push({ type: 'lineTo', args: makeAbsoluteFromY(ch, args[i]) });
            }
        }, peg$c20 = /^[Cc]/, peg$c21 = { type: 'class', value: '[Cc]', description: '[Cc]' }, peg$c22 = function (ch, args) {
            for (let i = 0; i < args.length; i++) {
                ops.push({ type: 'bezierCurveTo', args: makeAbsoluteMultiple(ch, args[i]) });
            }
        }, peg$c23 = function (cp1, cp2, last) {
            return cp1.concat(cp2, last);
        }, peg$c24 = /^[Ss]/, peg$c25 = { type: 'class', value: '[Ss]', description: '[Ss]' }, peg$c26 = function (ch, args) {
            for (let i = 0; i < args.length; i++) {
                ops.push({ type: 'bezierCurveTo', args: makeReflected().concat(makeAbsoluteMultiple(ch, args[i])) });
            }
        }, peg$c27 = function (cp1, last) {
            return cp1.concat(last);
        }, peg$c28 = /^[Qq]/, peg$c29 = { type: 'class', value: '[Qq]', description: '[Qq]' }, peg$c30 = function (ch, args) {
            for (let i = 0; i < args.length; i++) {
                ops.push({ type: 'quadraticCurveTo', args: makeAbsoluteMultiple(ch, args[i]) });
            }
        }, peg$c31 = /^[Tt]/, peg$c32 = { type: 'class', value: '[Tt]', description: '[Tt]' }, peg$c33 = function (ch, args) {
            for (let i = 0; i < args.length; i++) {
                let reflected = makeReflected();
                ops.push({ type: 'quadraticCurveTo', args: reflected.concat(makeAbsoluteMultiple(ch, args[i])) });
                lastControl = reflected.slice(0);
            }
        }, peg$c34 = /^[Aa]/, peg$c35 = { type: 'class', value: '[Aa]', description: '[Aa]' }, peg$c36 = function (ch, args) {
            for (let i = 0; i < args.length; i++) {
                let x1 = [lastCoord.slice()];
                let x2 = [makeAbsolute(ch, args[i].slice(-2))];
                absArgs = x1.concat(args[i].slice(0, -2), x2);
                ellipseFromEllipticalArc.apply(this, absArgs);
            }
        }, peg$c37 = function (rx, ry, xrot, large, sweep, last) {
            return [
                parseFloat(rx),
                parseFloat(ry),
                parseFloat(flatten(xrot).join('')),
                parseInt(large),
                parseInt(sweep),
                last[0],
                last[1]
            ];
        }, peg$c38 = function (x, y) {
            return [x, y];
        }, peg$c39 = function (number) {
            return parseFloat(flatten(number).join(''));
        }, peg$c40 = '0', peg$c41 = { type: 'literal', value: '0', description: '"0"' }, peg$c42 = '1', peg$c43 = { type: 'literal', value: '1', description: '"1"' }, peg$c44 = ',', peg$c45 = { type: 'literal', value: ',', description: '","' }, peg$c46 = '.', peg$c47 = { type: 'literal', value: '.', description: '"."' }, peg$c48 = /^[eE]/, peg$c49 = { type: 'class', value: '[eE]', description: '[eE]' }, peg$c50 = '+', peg$c51 = { type: 'literal', value: '+', description: '"+"' }, peg$c52 = '-', peg$c53 = { type: 'literal', value: '-', description: '"-"' }, peg$c54 = /^[0-9]/, peg$c55 = { type: 'class', value: '[0-9]', description: '[0-9]' }, peg$c56 = function (digits) {
            return digits.join('');
        }, peg$c57 = /^[ \t\n\r]/, peg$c58 = { type: 'class', value: '[ \\t\\n\\r]', description: '[ \\t\\n\\r]' }, peg$currPos = 0, peg$reportedPos = 0, peg$cachedPos = 0, peg$cachedPosDetails = { line: 1, column: 1, seenCR: false }, peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
        if ('startRule' in options) {
            if (!(options.startRule in peg$startRuleFunctions)) {
                throw new Error('Can\'t start parsing from rule "' + options.startRule + '".');
            }
            peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function text() {
            return input.substring(peg$reportedPos, peg$currPos);
        }
        function offset() {
            return peg$reportedPos;
        }
        function line() {
            return peg$computePosDetails(peg$reportedPos).line;
        }
        function column() {
            return peg$computePosDetails(peg$reportedPos).column;
        }
        function expected(description) {
            throw peg$buildException(null, [{ type: 'other', description: description }], peg$reportedPos);
        }
        function error(message) {
            throw peg$buildException(message, null, peg$reportedPos);
        }
        function peg$computePosDetails(pos) {
            function advance(details, startPos, endPos) {
                let p, ch;
                for (p = startPos; p < endPos; p++) {
                    ch = input.charAt(p);
                    if (ch === '\n') {
                        if (!details.seenCR) {
                            details.line++;
                        }
                        details.column = 1;
                        details.seenCR = false;
                    }
                    else if (ch === '\r' || ch === '\u2028' || ch === '\u2029') {
                        details.line++;
                        details.column = 1;
                        details.seenCR = true;
                    }
                    else {
                        details.column++;
                        details.seenCR = false;
                    }
                }
            }
            if (peg$cachedPos !== pos) {
                if (peg$cachedPos > pos) {
                    peg$cachedPos = 0;
                    peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
                }
                advance(peg$cachedPosDetails, peg$cachedPos, pos);
                peg$cachedPos = pos;
            }
            return peg$cachedPosDetails;
        }
        function peg$fail(expected) {
            if (peg$currPos < peg$maxFailPos) {
                return;
            }
            if (peg$currPos > peg$maxFailPos) {
                peg$maxFailPos = peg$currPos;
                peg$maxFailExpected = [];
            }
            peg$maxFailExpected.push(expected);
        }
        function peg$buildException(message, expected, pos) {
            function cleanupExpected(expected) {
                let i = 1;
                expected.sort(function (a, b) {
                    if (a.description < b.description) {
                        return -1;
                    }
                    else if (a.description > b.description) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                });
                while (i < expected.length) {
                    if (expected[i - 1] === expected[i]) {
                        expected.splice(i, 1);
                    }
                    else {
                        i++;
                    }
                }
            }
            function buildMessage(expected, found) {
                function stringEscape(s) {
                    function hex(ch) {
                        return ch
                            .charCodeAt(0)
                            .toString(16)
                            .toUpperCase();
                    }
                    return s
                        .replace(/\\/g, '\\\\')
                        .replace(/"/g, '\\"')
                        .replace(/\x08/g, '\\b')
                        .replace(/\t/g, '\\t')
                        .replace(/\n/g, '\\n')
                        .replace(/\f/g, '\\f')
                        .replace(/\r/g, '\\r')
                        .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function (ch) {
                        return '\\x0' + hex(ch);
                    })
                        .replace(/[\x10-\x1F\x80-\xFF]/g, function (ch) {
                        return '\\x' + hex(ch);
                    })
                        .replace(/[\u0180-\u0FFF]/g, function (ch) {
                        return '\\u0' + hex(ch);
                    })
                        .replace(/[\u1080-\uFFFF]/g, function (ch) {
                        return '\\u' + hex(ch);
                    });
                }
                let expectedDescs = new Array(expected.length), expectedDesc, foundDesc, i;
                for (i = 0; i < expected.length; i++) {
                    expectedDescs[i] = expected[i].description;
                }
                expectedDesc =
                    expected.length > 1
                        ? expectedDescs.slice(0, -1).join(', ') + ' or ' + expectedDescs[expected.length - 1]
                        : expectedDescs[0];
                foundDesc = found ? '"' + stringEscape(found) + '"' : 'end of input';
                return 'Expected ' + expectedDesc + ' but ' + foundDesc + ' found.';
            }
            let posDetails = peg$computePosDetails(pos), found = pos < input.length ? input.charAt(pos) : null;
            if (expected !== null) {
                cleanupExpected(expected);
            }
            return new SyntaxError(message !== null ? message : buildMessage(expected, found), expected, found, pos, posDetails.line, posDetails.column);
        }
        function peg$parsesvg_path() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsewsp();
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parsewsp();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsemoveTo_drawTo_commandGroups();
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parsewsp();
                    while (s4 !== peg$FAILED) {
                        s3.push(s4);
                        s4 = peg$parsewsp();
                    }
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c3(s2);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsemoveTo_drawTo_commandGroups() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parsemoveTo_drawTo_commandGroup();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = [];
                s4 = peg$parsewsp();
                while (s4 !== peg$FAILED) {
                    s3.push(s4);
                    s4 = peg$parsewsp();
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsemoveTo_drawTo_commandGroups();
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsemoveTo_drawTo_commandGroup() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parsemoveto();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = [];
                s4 = peg$parsewsp();
                while (s4 !== peg$FAILED) {
                    s3.push(s4);
                    s4 = peg$parsewsp();
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsedrawto_commands();
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsedrawto_commands() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parsedrawto_command();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = [];
                s4 = peg$parsewsp();
                while (s4 !== peg$FAILED) {
                    s3.push(s4);
                    s4 = peg$parsewsp();
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsedrawto_commands();
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsedrawto_command() {
            let s0;
            s0 = peg$parseclosepath();
            if (s0 === peg$FAILED) {
                s0 = peg$parselineto();
                if (s0 === peg$FAILED) {
                    s0 = peg$parsehorizontal_lineto();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parsevertical_lineto();
                        if (s0 === peg$FAILED) {
                            s0 = peg$parsecurveto();
                            if (s0 === peg$FAILED) {
                                s0 = peg$parsesmooth_curveto();
                                if (s0 === peg$FAILED) {
                                    s0 = peg$parsequadratic_bezier_curveto();
                                    if (s0 === peg$FAILED) {
                                        s0 = peg$parsesmooth_quadratic_bezier_curveto();
                                        if (s0 === peg$FAILED) {
                                            s0 = peg$parseelliptical_arc();
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parsemoveto() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            if (peg$c4.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c5);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsemoveto_argument_sequence();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c6(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsemoveto_argument_sequence() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parsecoordinate_pair();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parsecomma_wsp();
                if (s3 === peg$FAILED) {
                    s3 = peg$c2;
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parselineto_argument_sequence();
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c7(s1, s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parseclosepath() {
            let s0, s1;
            s0 = peg$currPos;
            if (peg$c8.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c9);
                }
            }
            if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c10();
            }
            s0 = s1;
            return s0;
        }
        function peg$parselineto() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            if (peg$c11.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c12);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parselineto_argument_sequence();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c13(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parselineto_argument_sequence() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parsecoordinate_pair();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parsecomma_wsp();
                if (s3 === peg$FAILED) {
                    s3 = peg$c2;
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parselineto_argument_sequence();
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c7(s1, s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsehorizontal_lineto() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            if (peg$c14.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c15);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsecoordinate_sequence();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c16(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsecoordinate_sequence() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parsecoordinate();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parsecomma_wsp();
                if (s3 === peg$FAILED) {
                    s3 = peg$c2;
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsecoordinate_sequence();
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c7(s1, s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsevertical_lineto() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            if (peg$c17.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c18);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsecoordinate_sequence();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c19(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsecurveto() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            if (peg$c20.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c21);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsecurveto_argument_sequence();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c22(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsecurveto_argument_sequence() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parsecurveto_argument();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parsecomma_wsp();
                if (s3 === peg$FAILED) {
                    s3 = peg$c2;
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsecurveto_argument_sequence();
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c7(s1, s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsecurveto_argument() {
            let s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = peg$parsecoordinate_pair();
            if (s1 !== peg$FAILED) {
                s2 = peg$parsecomma_wsp();
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsecoordinate_pair();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsecomma_wsp();
                        if (s4 === peg$FAILED) {
                            s4 = peg$c2;
                        }
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsecoordinate_pair();
                            if (s5 !== peg$FAILED) {
                                peg$reportedPos = s0;
                                s1 = peg$c23(s1, s3, s5);
                                s0 = s1;
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$c0;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$c0;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsesmooth_curveto() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            if (peg$c24.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c25);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsesmooth_curveto_argument_sequence();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c26(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsesmooth_curveto_argument_sequence() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parsesmooth_curveto_argument();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parsecomma_wsp();
                if (s3 === peg$FAILED) {
                    s3 = peg$c2;
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsesmooth_curveto_argument_sequence();
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c7(s1, s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsesmooth_curveto_argument() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$parsecoordinate_pair();
            if (s1 !== peg$FAILED) {
                s2 = peg$parsecomma_wsp();
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsecoordinate_pair();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c27(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsequadratic_bezier_curveto() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            if (peg$c28.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c29);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsequadratic_bezier_curveto_argument_sequence();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c30(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsequadratic_bezier_curveto_argument_sequence() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parsequadratic_bezier_curveto_argument();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parsecomma_wsp();
                if (s3 === peg$FAILED) {
                    s3 = peg$c2;
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsequadratic_bezier_curveto_argument_sequence();
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c7(s1, s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsequadratic_bezier_curveto_argument() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$parsecoordinate_pair();
            if (s1 !== peg$FAILED) {
                s2 = peg$parsecomma_wsp();
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsecoordinate_pair();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c27(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsesmooth_quadratic_bezier_curveto() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            if (peg$c31.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c32);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsesmooth_quadratic_bezier_curveto_argument_sequence();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c33(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsesmooth_quadratic_bezier_curveto_argument_sequence() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parsecoordinate_pair();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parsecomma_wsp();
                if (s3 === peg$FAILED) {
                    s3 = peg$c2;
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsesmooth_quadratic_bezier_curveto_argument_sequence();
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c7(s1, s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parseelliptical_arc() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            if (peg$c34.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c35);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseelliptical_arc_argument_sequence();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c36(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parseelliptical_arc_argument_sequence() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parseelliptical_arc_argument();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parsecomma_wsp();
                if (s3 === peg$FAILED) {
                    s3 = peg$c2;
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseelliptical_arc_argument_sequence();
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c7(s1, s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parseelliptical_arc_argument() {
            let s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
            s0 = peg$currPos;
            s1 = peg$parsenonnegative_number();
            if (s1 !== peg$FAILED) {
                s2 = peg$parsecomma_wsp();
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsenonnegative_number();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsecomma_wsp();
                        if (s4 === peg$FAILED) {
                            s4 = peg$c2;
                        }
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsenumber();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parsecomma_wsp();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseflag();
                                    if (s7 !== peg$FAILED) {
                                        s8 = peg$parsecomma_wsp();
                                        if (s8 === peg$FAILED) {
                                            s8 = peg$c2;
                                        }
                                        if (s8 !== peg$FAILED) {
                                            s9 = peg$parseflag();
                                            if (s9 !== peg$FAILED) {
                                                s10 = peg$parsecomma_wsp();
                                                if (s10 === peg$FAILED) {
                                                    s10 = peg$c2;
                                                }
                                                if (s10 !== peg$FAILED) {
                                                    s11 = peg$parsecoordinate_pair();
                                                    if (s11 !== peg$FAILED) {
                                                        peg$reportedPos = s0;
                                                        s1 = peg$c37(s1, s3, s5, s7, s9, s11);
                                                        s0 = s1;
                                                    }
                                                    else {
                                                        peg$currPos = s0;
                                                        s0 = peg$c0;
                                                    }
                                                }
                                                else {
                                                    peg$currPos = s0;
                                                    s0 = peg$c0;
                                                }
                                            }
                                            else {
                                                peg$currPos = s0;
                                                s0 = peg$c0;
                                            }
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$c0;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$c0;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$c0;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$c0;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$c0;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsecoordinate_pair() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$parsecoordinate();
            if (s1 !== peg$FAILED) {
                s2 = peg$parsecomma_wsp();
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsecoordinate();
                    if (s3 !== peg$FAILED) {
                        peg$reportedPos = s0;
                        s1 = peg$c38(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsecoordinate() {
            let s0, s1;
            s0 = peg$currPos;
            s1 = peg$parsenumber();
            if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c39(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parsenonnegative_number() {
            let s0;
            s0 = peg$parsefloating_point_constant();
            if (s0 === peg$FAILED) {
                s0 = peg$parsedigit_sequence();
            }
            return s0;
        }
        function peg$parsenumber() {
            let s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsesign();
            if (s1 === peg$FAILED) {
                s1 = peg$c2;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsefloating_point_constant();
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsesign();
                if (s1 === peg$FAILED) {
                    s1 = peg$c2;
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsedigit_sequence();
                    if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            return s0;
        }
        function peg$parseflag() {
            let s0;
            if (input.charCodeAt(peg$currPos) === 48) {
                s0 = peg$c40;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c41);
                }
            }
            if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 49) {
                    s0 = peg$c42;
                    peg$currPos++;
                }
                else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c43);
                    }
                }
            }
            return s0;
        }
        function peg$parsecomma_wsp() {
            let s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsewsp();
            if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                    s1.push(s2);
                    s2 = peg$parsewsp();
                }
            }
            else {
                s1 = peg$c0;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsecomma();
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parsewsp();
                    while (s4 !== peg$FAILED) {
                        s3.push(s4);
                        s4 = peg$parsewsp();
                    }
                    if (s3 !== peg$FAILED) {
                        s1 = [s1, s2, s3];
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsecomma();
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parsewsp();
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsewsp();
                    }
                    if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            return s0;
        }
        function peg$parsecomma() {
            let s0;
            if (input.charCodeAt(peg$currPos) === 44) {
                s0 = peg$c44;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c45);
                }
            }
            return s0;
        }
        function peg$parsefloating_point_constant() {
            let s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsefractional_constant();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseexponent();
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsedigit_sequence();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseexponent();
                    if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            return s0;
        }
        function peg$parsefractional_constant() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$parsedigit_sequence();
            if (s1 === peg$FAILED) {
                s1 = peg$c2;
            }
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 46) {
                    s2 = peg$c46;
                    peg$currPos++;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c47);
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsedigit_sequence();
                    if (s3 !== peg$FAILED) {
                        s1 = [s1, s2, s3];
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsedigit_sequence();
                if (s1 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s2 = peg$c46;
                        peg$currPos++;
                    }
                    else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c47);
                        }
                    }
                    if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            return s0;
        }
        function peg$parseexponent() {
            let s0, s1, s2, s3;
            s0 = peg$currPos;
            if (peg$c48.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c49);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsesign();
                if (s2 === peg$FAILED) {
                    s2 = peg$c2;
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsedigit_sequence();
                    if (s3 !== peg$FAILED) {
                        s1 = [s1, s2, s3];
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$c0;
            }
            return s0;
        }
        function peg$parsesign() {
            let s0;
            if (input.charCodeAt(peg$currPos) === 43) {
                s0 = peg$c50;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c51);
                }
            }
            if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 45) {
                    s0 = peg$c52;
                    peg$currPos++;
                }
                else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c53);
                    }
                }
            }
            return s0;
        }
        function peg$parsedigit_sequence() {
            let s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            if (peg$c54.test(input.charAt(peg$currPos))) {
                s2 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c55);
                }
            }
            if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                    s1.push(s2);
                    if (peg$c54.test(input.charAt(peg$currPos))) {
                        s2 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c55);
                        }
                    }
                }
            }
            else {
                s1 = peg$c0;
            }
            if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c56(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parsewsp() {
            let s0;
            if (peg$c57.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c58);
                }
            }
            return s0;
        }
        // The last coordinate we are at in the path. In absolute coords.
        let lastCoord = [0, 0];
        // The last control point we encountered in the path. In absolute coords.
        let lastControl = [0, 0];
        // The list of operations we've parsed so far.
        let ops = [];
        // Have we parsed the first sub-path yet?
        let firstSubPath = true;
        // The letter of the last parsed command.
        let lastCh = '';
        // Flatten an array.
        function flatten(a) {
            let flat = [];
            for (let i = 0; i < a.length; i++) {
                if (a[i] instanceof Array) {
                    flat.push.apply(flat, flatten(a[i]));
                }
                else {
                    flat.push(a[i]);
                }
            }
            return flat;
        }
        // Convert a position into an absolute position.
        function makeAbsolute(c, coord) {
            if ('mlazhvcsqt'.indexOf(c) === -1) {
                lastCoord = coord;
            }
            else {
                lastCoord[0] += coord[0];
                lastCoord[1] += coord[1];
            }
            lastCh = c;
            return lastCoord.slice(0);
        }
        // Convert a sequence of coordinates into absolute coordinates.
        //
        // For arguments that take multiple coord pairs, such as bezier.
        function makeAbsoluteMultiple(c, seq) {
            let r = [];
            let lastPosCopy = lastCoord.slice(0);
            for (let i = 0; i < seq.length; i += 2) {
                // Only the last point should update lastCoord.
                lastCoord = lastPosCopy.slice(0);
                let coord = makeAbsolute(c, seq.slice(i, i + 2));
                r = r.concat(coord);
                // Record the last control point, it might be needed for
                // shorthand operations.
                if (i == seq.length - 4) {
                    lastControl = coord.slice(0);
                }
            }
            return r;
        }
        // Find the reflection of the last control point over
        // the last postion in the path.
        function makeReflected() {
            if ('CcSsQqTt'.indexOf(lastCh) == -1) {
                lastControl = lastCoord.slice(0);
            }
            // reflected = 2*lastCoord - lastControl
            // Note the result is absolute, not relative.
            let r = [0, 0];
            r[0] = 2 * lastCoord[0] - lastControl[0];
            r[1] = 2 * lastCoord[1] - lastControl[1];
            return r;
        }
        function makeAbsoluteFromX(c, x) {
            let coord = [x, 0];
            if (c == 'H') {
                coord[1] = lastCoord[1];
            }
            return makeAbsolute(c, coord);
        }
        function makeAbsoluteFromY(c, y) {
            let coord = [0, y];
            if (c == 'V') {
                coord[0] = lastCoord[0];
            }
            return makeAbsolute(c, coord);
        }
        function concatSequence(one, rest) {
            let r = [one];
            if (rest && rest.length > 1) {
                let rem = rest[1];
                for (let i = 0; i < rem.length; i++) {
                    r.push(rem[i]);
                }
            }
            return r;
        }
        function mag(v) {
            return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2));
        }
        function dot(u, v) {
            return u[0] * v[0] + u[1] * v[1];
        }
        function ratio(u, v) {
            return dot(u, v) / (mag(u) * mag(v));
        }
        function angle(u, v) {
            let sign = 1.0;
            if (u[0] * v[1] - u[1] * v[0] < 0) {
                sign = -1.0;
            }
            return sign * Math.acos(ratio(u, v));
        }
        function rotClockwise(v, angle) {
            let cost = Math.cos(angle);
            let sint = Math.sin(angle);
            return [cost * v[0] + sint * v[1], -1 * sint * v[0] + cost * v[1]];
        }
        function rotCounterClockwise(v, angle) {
            let cost = Math.cos(angle);
            let sint = Math.sin(angle);
            return [cost * v[0] - sint * v[1], sint * v[0] + cost * v[1]];
        }
        function midPoint(u, v) {
            return [(u[0] - v[0]) / 2.0, (u[1] - v[1]) / 2.0];
        }
        function meanVec(u, v) {
            return [(u[0] + v[0]) / 2.0, (u[1] + v[1]) / 2.0];
        }
        function pointMul(u, v) {
            return [u[0] * v[0], u[1] * v[1]];
        }
        function scale(c, v) {
            return [c * v[0], c * v[1]];
        }
        function sum(u, v) {
            return [u[0] + v[0], u[1] + v[1]];
        }
        // Convert an SVG elliptical arc to a series of canvas commands.
        //
        // x1, x2: start and stop coordinates of the ellipse.
        // rx, ry: radii of the ellipse.
        // phi: rotation of the ellipse.
        // fA: large arc flag.
        // fS: sweep flag.
        function ellipseFromEllipticalArc(x1, rx, ry, phi, fA, fS, x2) {
            // Convert from endpoint to center parametrization, as detailed in:
            //   http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
            if (rx == 0 || ry == 0) {
                ops.push({ type: 'lineTo', args: x2 });
                return;
            }
            phi = phi * (Math.PI / 180.0);
            rx = Math.abs(rx);
            ry = Math.abs(ry);
            let xPrime = rotClockwise(midPoint(x1, x2), phi); // F.6.5.1
            let xPrime2 = pointMul(xPrime, xPrime);
            let rx2 = Math.pow(rx, 2);
            let ry2 = Math.pow(ry, 2);
            let lambda = Math.sqrt(xPrime2[0] / rx2 + xPrime2[1] / ry2);
            if (lambda > 1) {
                rx *= lambda;
                ry *= lambda;
                rx2 = Math.pow(rx, 2);
                ry2 = Math.pow(ry, 2);
            }
            let factor = Math.sqrt((rx2 * ry2 - rx2 * xPrime2[1] - ry2 * xPrime2[0]) / (rx2 * xPrime2[1] + ry2 * xPrime2[0]));
            if (fA == fS) {
                factor *= -1.0;
            }
            let cPrime = scale(factor, [(rx * xPrime[1]) / ry, (-ry * xPrime[0]) / rx]); // F.6.5.2
            let c = sum(rotCounterClockwise(cPrime, phi), meanVec(x1, x2)); // F.6.5.3
            let x1UnitVector = [(xPrime[0] - cPrime[0]) / rx, (xPrime[1] - cPrime[1]) / ry];
            let x2UnitVector = [(-1.0 * xPrime[0] - cPrime[0]) / rx, (-1.0 * xPrime[1] - cPrime[1]) / ry];
            let theta = angle([1, 0], x1UnitVector); // F.6.5.5
            let deltaTheta = angle(x1UnitVector, x2UnitVector); // F.6.5.6
            let start = theta;
            let end = theta + deltaTheta;
            ops.push({ type: 'save', args: [] }, { type: 'translate', args: [c[0], c[1]] }, { type: 'rotate', args: [phi] }, { type: 'scale', args: [rx, ry] }, { type: 'arc', args: [0, 0, 1, start, end, 1 - fS] }, { type: 'restore', args: [] });
        }
        peg$result = peg$startRuleFunction();
        if (peg$result !== peg$FAILED && peg$currPos === input.length) {
            return peg$result;
        }
        else {
            if (peg$result !== peg$FAILED && peg$currPos < input.length) {
                peg$fail({ type: 'end', description: 'end of input' });
            }
            throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
        }
    }
    return {
        SyntaxError: SyntaxError,
        parse: parse
    };
})();
(function (CanvasRenderingContext2D, nodeRequire) {
    /**
     * Copyright 2014 Google Inc. All rights reserved.
     *
     * Use of this source code is governed by a BSD-style
     * license that can be found in the LICENSE file.
     *
     * @fileoverview Description of this file.
     *
     * A polyfill for HTML Canvas features, including
     * Path2D support.
     */
    if (CanvasRenderingContext2D == undefined) {
        CanvasRenderingContext2D = function () { };
        // CanvasRenderingContext2D = nodeRequire('canvas').Context2d;
    }
    if (CanvasRenderingContext2D.prototype.ellipse == undefined) {
        CanvasRenderingContext2D.prototype.ellipse = function (x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
            this.save();
            this.translate(x, y);
            this.rotate(rotation);
            this.scale(radiusX, radiusY);
            this.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
            this.restore();
        };
    }
    if (typeof Path2D !== 'function' || typeof new Path2D().addPath !== 'function') {
        (function () {
            // Include the SVG path parser.
            // = svgpath.js
            function Path_(arg) {
                this.ops_ = [];
                if (arg == undefined) {
                    return;
                }
                if (typeof arg == 'string') {
                    try {
                        this.ops_ = parser.parse(arg);
                    }
                    catch (e) {
                        // Treat an invalid SVG path as an empty path.
                    }
                }
                else if (arg.hasOwnProperty('ops_')) {
                    this.ops_ = arg.ops_.slice(0);
                }
                else {
                    throw new Error('Error: ' + typeof arg + 'is not a valid argument to Path');
                }
            }
            // TODO(jcgregorio) test for arcTo and implement via something.
            // Path methods that map simply to the CanvasRenderingContext2D.
            let simple_mapping = [
                'closePath',
                'moveTo',
                'lineTo',
                'quadraticCurveTo',
                'bezierCurveTo',
                'rect',
                'arc',
                'arcTo',
                'ellipse',
                'isPointInPath',
                'isPointInStroke'
            ];
            function createFunction(name) {
                return function () {
                    this.ops_.push({ type: name, args: Array.prototype.slice.call(arguments, 0) });
                };
            }
            // Add simple_mapping methods to Path2D.
            for (let i = 0; i < simple_mapping.length; i++) {
                let name = simple_mapping[i];
                Path_.prototype[name] = createFunction(name);
            }
            Path_.prototype['addPath'] = function (path, tr) {
                let hasTx = false;
                if (tr &&
                    tr.a != undefined &&
                    tr.b != undefined &&
                    tr.c != undefined &&
                    tr.d != undefined &&
                    tr.e != undefined &&
                    tr.f != undefined) {
                    hasTx = true;
                    this.ops_.push({ type: 'save', args: [] });
                    this.ops_.push({ type: 'transform', args: [tr.a, tr.b, tr.c, tr.d, tr.e, tr.f] });
                }
                this.ops_ = this.ops_.concat(path.ops_);
                if (hasTx) {
                    this.ops_.push({ type: 'restore', args: [] });
                }
            };
            let original_fill = CanvasRenderingContext2D.prototype.fill;
            let original_stroke = CanvasRenderingContext2D.prototype.stroke;
            let original_clip = CanvasRenderingContext2D.prototype.clip;
            let original_is_point_in_path = CanvasRenderingContext2D.prototype.isPointInPath;
            let original_is_point_in_stroke = CanvasRenderingContext2D.prototype.isPointInStroke;
            // Replace methods on CanvasRenderingContext2D with ones that understand Path2D.
            CanvasRenderingContext2D.prototype.fill = function (arg) {
                if (arg instanceof Path_) {
                    this.beginPath();
                    for (let i = 0, len = arg.ops_.length; i < len; i++) {
                        let op = arg.ops_[i];
                        CanvasRenderingContext2D.prototype[op.type].apply(this, op.args);
                    }
                    original_fill.apply(this, Array.prototype.slice.call(arguments, 1));
                }
                else {
                    original_fill.apply(this, arguments);
                }
            };
            CanvasRenderingContext2D.prototype.stroke = function (arg) {
                if (arg instanceof Path_) {
                    this.beginPath();
                    for (let i = 0, len = arg.ops_.length; i < len; i++) {
                        let op = arg.ops_[i];
                        CanvasRenderingContext2D.prototype[op.type].apply(this, op.args);
                    }
                    original_stroke.call(this);
                }
                else {
                    original_stroke.call(this);
                }
            };
            CanvasRenderingContext2D.prototype.clip = function (arg) {
                if (arg instanceof Path_) {
                    // Note that we don't save and restore the context state, since the
                    // clip region is part of the state. Not really a problem since the
                    // HTML 5 spec doesn't say that clip(path) doesn't affect the current
                    // path.
                    this.beginPath();
                    for (let i = 0, len = arg.ops_.length; i < len; i++) {
                        let op = arg.ops_[i];
                        CanvasRenderingContext2D.prototype[op.type].apply(this, op.args);
                    }
                    original_clip.apply(this, Array.prototype.slice.call(arguments, 1));
                }
                else {
                    original_clip.apply(this, arguments);
                }
            };
            CanvasRenderingContext2D.prototype.isPointInPath = function (arg) {
                if (arg instanceof Path_) {
                    this.beginPath();
                    for (let i = 0, len = arg.ops_.length; i < len; i++) {
                        let op = arg.ops_[i];
                        CanvasRenderingContext2D.prototype[op.type].apply(this, op.args);
                    }
                    return original_is_point_in_path.apply(this, Array.prototype.slice.call(arguments, 1));
                }
                else {
                    return original_is_point_in_path.apply(this, arguments);
                }
            };
            CanvasRenderingContext2D.prototype.isPointInStroke = function (arg) {
                if (arg instanceof Path_) {
                    this.beginPath();
                    for (let i = 0, len = arg.ops_.length; i < len; i++) {
                        let op = arg.ops_[i];
                        CanvasRenderingContext2D.prototype[op.type].apply(this, op.args);
                    }
                    return original_is_point_in_stroke.apply(this, Array.prototype.slice.call(arguments, 1));
                }
                else {
                    return original_is_point_in_stroke.apply(this, arguments);
                }
            };
            // Set up externs.
            Path2D = Path_;
        })();
    }
})(typeof CanvasRenderingContext2D === 'undefined' ? undefined : CanvasRenderingContext2D, typeof require === 'undefined' ? undefined : require);

/* eslint-disable */
const data = {
    type: 'Topology',
    arcs: [
        [[33984, 57124], [-13, -8], [-38, 61], [9, 37], [19, -26], [23, -64]],
        [[78676, 70940], [-39, 10], [-12, 23], [-52, -30], [-57, -44], [52, -75]],
        [
            [78568, 70824],
            [-167, -111],
            [-72, 36],
            [-201, -11],
            [-38, -9],
            [-114, -13],
            [-60, -35],
            [-56, -18],
            [-28, -19],
            [-19, -37],
            [-85, -82],
            [-15, -31],
            [-47, 3],
            [-48, -80],
            [-71, -95],
            [-15, -45],
            [48, -58],
            [27, -58],
            [28, -132],
            [16, -28],
            [9, -77],
            [-17, -67],
            [23, -59],
            [-51, -120],
            [-50, -56],
            [-21, -49],
            [-34, -54],
            [-15, -46],
            [-31, -39],
            [18, -55],
            [22, -34],
            [-1, -139],
            [-12, -40],
            [-63, -38],
            [-60, -16],
            [-74, -1],
            [-50, 14],
            [-80, 42],
            [-32, -24],
            [-7, -62],
            [58, -99],
            [24, -55],
            [27, -92],
            [20, -48],
            [-7, -45],
            [-106, -98],
            [-66, -10],
            [-42, -17],
            [-21, -25],
            [-15, -104],
            [-15, -38],
            [0, -46],
            [-14, -51],
            [-21, -34],
            [-15, -54],
            [12, -277],
            [-61, -110],
            [-34, -40],
            [-32, -19],
            [-27, 7],
            [-34, 63],
            [-23, 25],
            [-48, -27],
            [-38, 7],
            [-32, 22],
            [-61, -72],
            [-86, -73],
            [-35, -5],
            [-15, -18],
            [22, -54],
            [28, -36],
            [-44, -37],
            [-44, -24],
            [-51, -10],
            [-53, 14],
            [-27, 32],
            [-32, 3],
            [-60, -62],
            [-33, -82],
            [-18, -28],
            [-52, -47],
            [-16, -61],
            [-18, -109],
            [6, -160],
            [-8, -71],
            [-13, -47],
            [3, -36],
            [20, -42],
            [-25, -58],
            [-17, -16],
            [-158, -75],
            [-176, -79],
            [-177, 2],
            [-79, -32],
            [-29, -26],
            [-23, -38],
            [-39, 21],
            [-124, 38],
            [-337, -50],
            [-32, 10],
            [-115, 58],
            [-240, 123],
            [-117, 60]
        ],
        [
            [74340, 66829],
            [80, 151],
            [210, 392],
            [8, 45],
            [1, 89],
            [-18, 119],
            [-29, 54],
            [-249, 56],
            [-10, 7],
            [-9, 92],
            [4, 41],
            [-5, 141],
            [12, 146],
            [-78, 416],
            [-5, 80],
            [49, 103],
            [61, 102],
            [-34, 29],
            [-47, 1],
            [-44, 44],
            [-8, 41],
            [13, 72],
            [-13, 141],
            [49, 119],
            [76, 7],
            [-50, 111],
            [69, 75],
            [2, 31],
            [38, 82],
            [-3, 36],
            [24, 96],
            [-15, 100],
            [27, 22],
            [18, 90],
            [10, 23],
            [-5, 59]
        ],
        [
            [74469, 70042],
            [25, 5],
            [24, -47],
            [38, -49],
            [54, -21],
            [82, 14],
            [32, -36],
            [51, -72],
            [17, -45],
            [48, 45],
            [45, -10],
            [35, 21],
            [103, 98],
            [8, 68],
            [27, 61],
            [-19, 79],
            [22, 22],
            [37, 0],
            [174, 86],
            [45, -1],
            [25, 57],
            [82, 63],
            [48, 64],
            [17, 48],
            [11, 71],
            [66, 322],
            [84, 59],
            [144, 7],
            [27, 121],
            [38, 57],
            [106, -86],
            [112, -40],
            [16, 3]
        ],
        [[76093, 71006], [94, 12], [74, -20], [39, -56], [39, -14], [61, 32], [27, -25], [29, 3], [18, -31]],
        [
            [76474, 70907],
            [24, -60],
            [38, -51],
            [34, -13],
            [44, 40],
            [54, 65],
            [49, 26],
            [38, 41],
            [35, 0],
            [23, 33],
            [32, 5],
            [68, -93],
            [26, -28],
            [46, 55],
            [5, 46],
            [-9, 61],
            [6, 49],
            [22, 37],
            [41, 23],
            [61, 8],
            [37, -5],
            [32, -30],
            [44, 20],
            [20, 46],
            [1, 56],
            [-17, 67],
            [4, 22],
            [63, 84],
            [31, 65],
            [30, 79],
            [37, 49],
            [44, 19],
            [54, -21],
            [63, -62],
            [23, -76],
            [-15, -91],
            [-1, -50],
            [34, -6],
            [50, 15],
            [9, -39],
            [-11, -38],
            [-12, -108],
            [-23, -265],
            [30, -157],
            [21, -63],
            [21, -20],
            [42, -1],
            [43, 40],
            [66, 75],
            [63, 46],
            [92, 25],
            [31, 81],
            [43, 52],
            [97, 79],
            [53, 30],
            [31, 5],
            [73, -29],
            [-1, -50],
            [-19, -50],
            [29, -4],
            [102, 47],
            [27, 7],
            [29, 48],
            [27, 2],
            [54, -21],
            [42, 7],
            [72, -91]
        ],
        [
            [62957, 44119],
            [18, -247],
            [7, -50],
            [-24, -129],
            [4, -50],
            [-7, -219],
            [11, -129],
            [-1, -40],
            [-26, -120],
            [-8, -90],
            [27, -88],
            [-2, -18],
            [-37, -7],
            [-247, 0],
            [-177, 0],
            [-151, 0],
            [0, -445],
            [0, -358],
            [0, -357],
            [0, -487],
            [19, -172],
            [34, -186],
            [47, -52],
            [48, -70],
            [27, -53],
            [126, -209],
            [131, -198]
        ],
        [
            [62776, 40345],
            [-233, -79],
            [-205, -68],
            [-168, -54],
            [-40, 21],
            [-54, 4],
            [-63, -28],
            [-50, -7],
            [-37, 13],
            [-37, 24],
            [-35, 36],
            [-61, 14],
            [-87, -10],
            [-85, 7],
            [-80, 24],
            [-58, 9],
            [-35, -5],
            [-38, 8],
            [-40, 21],
            [-33, 35],
            [-40, 74],
            [-31, 71],
            [-28, 25],
            [-173, 3],
            [-167, 1],
            [-236, 0],
            [-236, 1],
            [-236, 1],
            [-181, 0],
            [-123, -12],
            [-24, 12],
            [-116, 138],
            [-27, 56],
            [-22, 18],
            [-94, 22],
            [-42, -26],
            [-55, -52],
            [-73, -58],
            [-104, 1],
            [-30, 26],
            [-31, -3],
            [-35, -32],
            [-49, -13]
        ],
        [
            [59184, 40563],
            [12, 211],
            [12, 93],
            [0, 112],
            [-7, 288],
            [-14, 87],
            [30, 35],
            [37, 75],
            [14, 67],
            [18, 148],
            [64, 341],
            [30, 333],
            [39, 158],
            [14, 177],
            [108, 229],
            [26, 141],
            [55, 69],
            [79, 73],
            [56, 131],
            [27, 90],
            [31, 174],
            [-1, 181],
            [20, 241],
            [-5, 70],
            [-29, 96],
            [-5, 69],
            [-27, 68],
            [-29, 51],
            [-14, 91],
            [-50, 144],
            [-14, 96],
            [-24, 69],
            [-4, 85],
            [-13, 90],
            [-48, 190],
            [17, 23],
            [94, 178],
            [6, 35],
            [-4, 87],
            [4, 55],
            [-89, 329],
            [-70, 306],
            [-12, 154],
            [-94, 203],
            [-36, 133],
            [-31, 145],
            [151, 49],
            [67, 54],
            [18, 24]
        ],
        [
            [59593, 46911],
            [36, 5],
            [37, -15],
            [21, 12],
            [187, 2],
            [130, -20],
            [108, 7],
            [302, 10],
            [181, -1],
            [36, -20],
            [33, -36],
            [32, -83],
            [17, -28],
            [7, -43],
            [-6, -58],
            [3, -70],
            [10, -82],
            [22, -86],
            [33, -90],
            [14, -72],
            [-4, -53],
            [10, -56],
            [53, -113],
            [27, -91],
            [90, -252],
            [14, -13],
            [61, 16],
            [42, 2],
            [29, -23],
            [57, 47],
            [90, 31],
            [24, 18],
            [28, 0],
            [76, -35],
            [75, -1],
            [61, 19],
            [10, 174],
            [33, 102],
            [1, 107],
            [14, 75],
            [41, 60],
            [66, 29],
            [188, 39],
            [36, -11],
            [-19, -104],
            [6, -68],
            [15, -19],
            [180, -4],
            [173, -11],
            [17, -13],
            [11, -52],
            [-2, -100],
            [-17, -148],
            [7, -137],
            [29, -128],
            [3, -196],
            [-24, -265],
            [-5, -167],
            [14, -70],
            [28, -74],
            [44, -76],
            [33, -99],
            [24, -122],
            [8, -77],
            [-5, -86],
            [7, -78],
            [-8, -52],
            [-24, -25],
            [-8, -35],
            [12, -67],
            [3, -61],
            [16, -41],
            [35, 20],
            [29, 40],
            [23, 18],
            [79, -14],
            [80, -4],
            [25, 7],
            [75, 55],
            [50, -1],
            [42, -17],
            [42, -3],
            [21, 17],
            [8, 51],
            [12, 11]
        ],
        [[59329, 46970], [-18, 70], [16, 92], [-9, 80], [-49, 179]],
        [
            [59269, 47391],
            [18, 29],
            [40, 97],
            [32, 7],
            [11, 23],
            [12, 59],
            [80, 49],
            [48, 56],
            [25, -8],
            [28, -60],
            [32, -46]
        ],
        [
            [59595, 47597],
            [-75, -57],
            [-48, -94],
            [-32, -51],
            [-37, -42],
            [22, -43],
            [-1, -154],
            [-5, -151],
            [-6, -13],
            [-84, -22]
        ],
        [[61753, 73904], [12, -12], [42, -104], [33, -17], [43, -47], [27, -118], [-2, -77]],
        [
            [61908, 73529],
            [-19, -94],
            [3, -73],
            [-21, -30],
            [14, -72],
            [-1, -66],
            [24, -81],
            [27, -37],
            [26, -87],
            [40, 7],
            [29, -38]
        ],
        [
            [62030, 72958],
            [-2, -42],
            [23, -65],
            [-25, -91],
            [-44, -28],
            [-34, -111],
            [-12, -72],
            [-16, -19],
            [-46, -9],
            [-45, -48],
            [22, -77],
            [-24, -25],
            [-10, -54],
            [-20, -26],
            [-64, 31]
        ],
        [
            [61733, 72322],
            [-11, 91],
            [-35, 95],
            [-113, 93],
            [-27, 42],
            [-23, 68],
            [36, -18],
            [0, 53],
            [-30, 85],
            [13, 94],
            [23, 79],
            [-1, 97],
            [7, 72],
            [-12, 105],
            [18, 77],
            [24, 44],
            [0, 82],
            [-33, 38],
            [-39, 7]
        ],
        [[61530, 73526], [6, 112], [-7, 22]],
        [[61529, 73660], [43, -1], [-37, 101]],
        [[61535, 73760], [91, 190], [27, -12], [-1, -46], [15, -27], [86, 39]],
        [
            [61730, 83831],
            [30, 2],
            [53, -52],
            [-20, -38],
            [-47, -7],
            [-3, -48],
            [-89, 3],
            [-18, 94],
            [57, 19],
            [-26, 29],
            [31, 29],
            [32, -31]
        ],
        [[56086, 73880], [-68, -39], [-18, 15], [0, 75]],
        [[56000, 73931], [23, 27], [64, -22], [-1, -56]],
        [[72205, 63662], [0, -19], [-40, -5], [-50, 19], [17, 23], [44, 27], [29, -45]],
        [[72021, 63707], [-23, -3], [-20, 21], [43, 28], [25, 39], [10, -22], [-19, -51], [-16, -12]],
        [[72937, 64483], [20, -45], [3, -307], [4, -22]],
        [
            [72964, 64109],
            [-10, -4],
            [-27, -59],
            [-49, -66],
            [-14, -5],
            [-28, 67],
            [9, 52],
            [-26, 11],
            [-37, -58],
            [2, -129],
            [-11, -82],
            [12, -78],
            [-14, -60],
            [52, -15],
            [17, -85],
            [-64, -26],
            [-25, 4],
            [-46, -18],
            [-24, -28],
            [19, -68],
            [-7, -53],
            [-48, -188],
            [-47, -196],
            [-5, -185]
        ],
        [
            [72593, 62840],
            [-25, -46],
            [-195, 43],
            [-197, 44],
            [-254, 56],
            [-141, 31],
            [-200, 432],
            [-97, 207],
            [-6, 27],
            [-1, 88]
        ],
        [
            [71477, 63722],
            [29, -20],
            [32, 3],
            [8, -101],
            [35, -49],
            [66, -8],
            [40, 13],
            [81, 66],
            [42, 23],
            [117, -4],
            [93, -27],
            [146, -16],
            [28, 4],
            [79, 52],
            [48, 47],
            [29, 13],
            [19, 45],
            [23, 96],
            [28, 50],
            [11, 53],
            [27, 53],
            [108, 129],
            [64, 108],
            [5, 36],
            [35, 52],
            [27, 58],
            [130, 165],
            [25, 68],
            [18, 82]
        ],
        [[72870, 64713], [26, -9], [2, -57], [-9, -142], [33, -36], [15, 14]],
        [
            [35636, 19673],
            [34, -13],
            [103, 10],
            [68, -1],
            [16, -25],
            [-61, -14],
            [-91, -2],
            [-57, -24],
            [-40, -35],
            [-37, 42],
            [65, 62]
        ],
        [[34369, 19596], [4, 295], [1, 299], [1, 305], [1, 328]],
        [
            [34376, 20823],
            [90, -138],
            [18, -46],
            [-47, -40],
            [-27, -68],
            [10, -47],
            [29, -19],
            [77, -13],
            [42, -137],
            [102, -124],
            [54, -75],
            [64, -72],
            [133, -96],
            [60, -51],
            [64, -71],
            [70, -51],
            [151, -67],
            [116, 12],
            [59, -26],
            [-51, -111],
            [-80, -28],
            [-74, 10],
            [-67, -26],
            [-70, -12],
            [-69, -30],
            [-36, 10],
            [-94, 49],
            [-60, 12],
            [-206, 20],
            [-132, 28],
            [-34, 1],
            [-99, -21]
        ],
        [[36461, 28340], [-13, -31], [-39, 34], [24, 30], [28, -33]],
        [
            [36221, 37784],
            [8, -32],
            [78, -82],
            [49, -97],
            [46, -143],
            [43, -106],
            [40, -69],
            [36, -48],
            [34, -28],
            [20, -41],
            [31, -36],
            [61, -56],
            [38, -55],
            [16, -55],
            [59, -58],
            [104, -58],
            [75, -29],
            [47, 3],
            [67, -47],
            [87, -96],
            [54, -68],
            [19, -37],
            [58, -60],
            [143, -125],
            [63, -32],
            [29, -28],
            [18, -37],
            [35, 3],
            [36, -13],
            [54, -40],
            [43, -48],
            [55, -107],
            [17, -43],
            [5, -72],
            [-17, -36],
            [-39, -55],
            [-9, -48],
            [-25, -69],
            [-8, -56],
            [-59, -73],
            [-31, -94],
            [-7, -42],
            [4, -138],
            [-17, -56],
            [-22, -37],
            [-2, -34],
            [-50, -62],
            [-19, -64],
            [-22, -27],
            [-7, -36],
            [11, -66],
            [135, 23],
            [110, -24],
            [130, -63],
            [86, -23],
            [43, 20],
            [31, -3],
            [21, -25],
            [27, -5],
            [35, 15],
            [29, -11],
            [22, -37],
            [21, 9],
            [18, 55],
            [46, 65],
            [30, 8],
            [35, -10],
            [50, -51],
            [23, 1],
            [26, 32],
            [12, 39],
            [-1, 45],
            [31, 51],
            [21, 59],
            [25, 21],
            [43, 7],
            [22, 16],
            [15, 48],
            [23, 21],
            [24, 58],
            [34, 28],
            [22, 67],
            [23, 125],
            [15, 169],
            [5, 239]
        ],
        [
            [38702, 35920],
            [24, 0],
            [29, -27],
            [34, 30],
            [25, 1],
            [30, 26],
            [21, -27],
            [23, -4],
            [18, -38],
            [19, -12],
            [21, -162],
            [47, -148],
            [-12, -71],
            [-13, -221],
            [11, -75],
            [-37, -133],
            [-30, -22],
            [-33, -46],
            [-51, -26],
            [-17, -51],
            [-20, -24],
            [-49, -18],
            [-22, 1],
            [-51, -50],
            [-33, -3],
            [-15, -28],
            [-10, -61],
            [-40, -33],
            [-19, -55],
            [-44, -18],
            [-32, -31],
            [-40, -75],
            [-33, -17],
            [-44, -47],
            [-6, -28],
            [17, -27],
            [1, -44],
            [-53, 15],
            [-22, -66],
            [-28, -29],
            [-25, -70],
            [-38, -48],
            [-30, -64],
            [-22, -81],
            [-26, -53],
            [-29, -26],
            [-20, -36],
            [-11, -47],
            [-31, -73],
            [-51, -98],
            [-47, -68],
            [-42, -37],
            [-23, -41],
            [-5, -46],
            [-27, -53],
            [-49, -59],
            [-14, -27]
        ],
        [
            [37778, 33349],
            [-13, -60],
            [-19, -50],
            [-37, -61],
            [-13, -54],
            [17, -67],
            [2, -82],
            [-27, -65],
            [10, -72],
            [-25, -109],
            [-26, -65],
            [-7, -44],
            [21, -45],
            [-17, -108],
            [-39, -57],
            [-6, -29],
            [10, -71],
            [-3, -74],
            [14, -36],
            [-1, -41],
            [-24, -83]
        ],
        [
            [37595, 32076],
            [-6, -52],
            [15, -220],
            [-24, -67],
            [-39, 4],
            [-15, -22],
            [-9, -97],
            [-29, -211],
            [5, -50],
            [23, -81],
            [15, -90],
            [5, -74],
            [-13, -33],
            [-28, -25],
            [18, -90],
            [57, -126],
            [160, -117],
            [67, -70],
            [75, -94],
            [41, -97],
            [4, -80],
            [-61, -120],
            [-6, -100],
            [12, -71],
            [22, -65],
            [58, -85],
            [43, -31],
            [58, 3],
            [16, -44],
            [9, -173],
            [-1, -64],
            [-17, -60],
            [-111, -272],
            [-95, -166],
            [-35, -92],
            [-12, -99],
            [-31, -46],
            [-164, -149],
            [-256, -132],
            [-206, -69],
            [-47, -23],
            [-332, -76],
            [-65, -10],
            [-83, 6],
            [-68, -10],
            [-143, 45],
            [-38, 59],
            [-45, 7],
            [-12, -29],
            [22, -76],
            [-11, -90],
            [13, -52],
            [27, -10],
            [48, -63],
            [-39, -3],
            [32, -46],
            [-2, -59],
            [-15, -144],
            [-48, -39],
            [-12, -30],
            [-24, -138],
            [-7, -88],
            [10, -58],
            [45, -120],
            [-17, -78],
            [-29, -43],
            [-174, -122],
            [-78, -23],
            [-126, -5],
            [-47, 6],
            [-108, 79],
            [-154, 86],
            [-71, 22],
            [15, 32],
            [-35, 14],
            [-47, -41],
            [-20, -42],
            [-6, -125],
            [8, -75],
            [34, -183],
            [3, -99],
            [-16, -125],
            [23, -74],
            [27, -33],
            [61, -33],
            [54, -44],
            [-14, -65],
            [46, -10],
            [99, 22],
            [12, 72],
            [-52, 26],
            [104, 52],
            [30, 6],
            [34, -41],
            [17, -53],
            [11, -69],
            [0, -83],
            [-7, -78],
            [-23, -61],
            [-106, -42],
            [-29, 11],
            [-28, 59],
            [-9, 61],
            [-23, 41],
            [-51, 33],
            [-50, -10],
            [-50, -57],
            [-49, -19],
            [-17, -51],
            [123, -84],
            [96, -33],
            [-35, -51],
            [-88, -42],
            [-38, -30],
            [-45, -58],
            [-92, -188],
            [-7, -88],
            [21, -145],
            [-22, -61],
            [13, -68],
            [-29, -110],
            [-89, -103],
            [-15, -75],
            [30, -44],
            [-12, -74],
            [-37, 0],
            [-133, 24],
            [-49, -39],
            [-73, -83],
            [-92, -25],
            [-18, -16],
            [-97, -179],
            [-42, -110],
            [-51, -109],
            [-13, -46],
            [-3, -63],
            [14, -100],
            [18, -54],
            [37, -62],
            [188, -252],
            [39, -22],
            [201, -27],
            [45, -35],
            [26, -56],
            [10, -49],
            [-12, -125],
            [-34, -74],
            [-89, -87],
            [74, 17],
            [22, -15],
            [16, -49],
            [-31, -20],
            [-33, -59],
            [-116, -144],
            [-62, -43],
            [-58, -58],
            [-77, -59],
            [-30, -33],
            [-41, -71],
            [-63, -76],
            [-67, -165],
            [7, -53],
            [-38, -288],
            [-40, -70],
            [-72, -60],
            [-34, -7],
            [-46, 35],
            [-25, 36],
            [-25, 62],
            [-29, -39],
            [-77, -18],
            [97, -23],
            [20, -15],
            [34, -68],
            [-13, -20],
            [-88, -48],
            [-59, -57],
            [-32, -65],
            [-30, -141],
            [-4, -63],
            [-25, -48],
            [28, -81],
            [36, -195],
            [-9, -56],
            [-50, -8],
            [-29, -22],
            [41, -35],
            [46, 15],
            [35, -44],
            [70, -166],
            [92, -164],
            [-15, -28]
        ],
        [
            [34434, 20988],
            [-6, 37],
            [-78, 20],
            [-152, 66],
            [-87, 0],
            [-146, 72],
            [-161, 3],
            [-443, 7],
            [-11, 61],
            [-57, 76],
            [-40, 29],
            [-43, 84],
            [32, 135],
            [1, 42],
            [-24, 72],
            [22, 34],
            [9, 69],
            [-19, 127],
            [-16, 27],
            [-37, 15],
            [-34, -23],
            [-56, 6],
            [-86, -69],
            [-22, 13],
            [-31, 100],
            [-18, 110],
            [-23, 72],
            [-36, 59],
            [-8, 120],
            [18, 65],
            [-33, 118],
            [7, 66],
            [22, 37],
            [7, 47],
            [100, 7],
            [-4, 63],
            [36, 97],
            [16, 21],
            [78, 45],
            [35, 57],
            [9, 73],
            [-7, 80],
            [34, 57],
            [44, 29],
            [19, 76],
            [-11, 66],
            [-24, 53],
            [-31, 23],
            [-3, 54],
            [54, 170],
            [-1, 44],
            [75, 84],
            [19, 56],
            [42, 23],
            [-18, 103],
            [7, 103],
            [64, 70],
            [12, 71],
            [-26, 167],
            [-30, 66],
            [59, 66],
            [16, 49],
            [-36, 64],
            [-7, 64],
            [8, 81],
            [16, 25],
            [58, 12],
            [5, 42],
            [44, 59],
            [-2, 57],
            [-28, 34],
            [-47, 106],
            [-66, 27],
            [-71, 15],
            [-7, 73],
            [33, -11],
            [155, 24],
            [30, -20],
            [30, 12],
            [12, 74],
            [22, 76],
            [-19, 30],
            [-35, 9],
            [-153, 23],
            [-4, 30],
            [7, 125],
            [40, 98],
            [-35, 98],
            [18, 27],
            [-4, 64],
            [-48, 84],
            [0, 52],
            [44, 29],
            [-6, 71],
            [-84, 37],
            [-28, 62],
            [10, 119],
            [-10, 111],
            [28, 58],
            [-7, 64],
            [-15, 34],
            [31, 83],
            [25, -10],
            [56, 36],
            [-2, 74],
            [-23, 110],
            [-21, 68],
            [12, 50],
            [-6, 93],
            [6, 279],
            [-21, 58],
            [3, 54],
            [39, 141],
            [30, 32],
            [4, 26],
            [-33, 51],
            [-5, 38],
            [17, 45],
            [18, 0],
            [14, 41],
            [6, 75],
            [-10, 30],
            [-15, 110],
            [20, 23],
            [36, -4],
            [4, 44],
            [33, 132],
            [3, 45],
            [-5, 123],
            [7, 28],
            [36, 50],
            [61, 49],
            [42, 10],
            [17, 33],
            [15, 77],
            [-37, 54],
            [-10, 73],
            [-8, 152],
            [-43, 156],
            [-6, 73],
            [16, 104],
            [-20, 80],
            [25, 104],
            [-13, 108],
            [-10, 43],
            [10, 46],
            [29, 65],
            [3, 67],
            [47, 58],
            [48, 15],
            [8, 61],
            [49, 77],
            [33, 7],
            [16, 40],
            [-3, 102],
            [11, 60],
            [-13, 90],
            [2, 48],
            [-13, 40],
            [-4, 70],
            [-26, 44],
            [50, 56],
            [32, 231],
            [24, 84],
            [34, 84],
            [15, 73],
            [53, 26],
            [9, 16],
            [-13, 275],
            [3, 73],
            [26, 113],
            [-6, 64],
            [-24, 18],
            [-38, -11],
            [-20, 39],
            [-3, 97],
            [22, 79],
            [-29, 43],
            [-19, 102],
            [3, 86],
            [-19, 23],
            [-9, 67],
            [-19, 24],
            [-13, 102],
            [22, 29],
            [12, 41],
            [-24, 43],
            [-37, 22],
            [-23, 98],
            [-19, 54],
            [10, 140],
            [11, 94],
            [14, 20],
            [26, -4],
            [25, 55],
            [-12, 67],
            [24, 125],
            [33, 132],
            [19, 29],
            [45, 17],
            [28, 133],
            [-30, 23],
            [11, 114],
            [-1, 59],
            [-30, 248],
            [9, 41],
            [30, 56],
            [22, 26],
            [26, 178],
            [3, 80],
            [14, 44],
            [10, 82],
            [40, 72],
            [12, 47],
            [16, 5],
            [57, 122],
            [24, 27],
            [17, 101],
            [37, 164],
            [18, 25],
            [29, 140],
            [42, 27],
            [18, -24],
            [35, 35],
            [60, 32],
            [8, 84],
            [-51, 115],
            [-30, 85],
            [-3, 56],
            [19, 79],
            [35, 68],
            [-3, 50],
            [-26, 181],
            [-28, 142],
            [18, 139],
            [14, 41],
            [20, 7],
            [15, 32],
            [-14, 23],
            [-12, 70],
            [-29, 49],
            [0, 51],
            [17, 65],
            [26, 47],
            [38, 48],
            [15, 38],
            [112, 83],
            [164, 116],
            [42, 223],
            [65, 353],
            [-57, 100]
        ],
        [
            [34819, 37456],
            [43, 96],
            [7, 55],
            [13, 23],
            [59, 56],
            [15, 78],
            [12, 30],
            [22, 6],
            [85, 51],
            [13, 34],
            [23, 124],
            [9, 16],
            [37, -19],
            [13, -24],
            [61, -79],
            [27, -44],
            [27, -6],
            [62, 7],
            [132, -3],
            [66, -23],
            [73, -47],
            [25, -80],
            [47, -217],
            [20, -19],
            [13, 107],
            [89, 296],
            [17, 24],
            [32, 13],
            [31, -12],
            [13, 13],
            [257, 4],
            [31, -91],
            [28, -41]
        ],
        [[69909, 71874], [-53, 4], [-45, -25], [-18, 5]],
        [
            [69793, 71858],
            [-50, 168],
            [8, 36],
            [-65, 75],
            [9, 62],
            [-14, 41],
            [-43, -7],
            [-48, -31],
            [-33, 20],
            [-30, 36],
            [-30, -7],
            [-2, 42],
            [-36, 60],
            [-81, -34]
        ],
        [
            [69378, 72319],
            [-64, 102],
            [-50, 61],
            [-34, 25],
            [-88, -15],
            [-66, 31],
            [-38, 31],
            [13, 23],
            [-31, 106],
            [-12, 70],
            [30, 51],
            [17, 81],
            [-28, 117],
            [-35, 42],
            [-24, 57]
        ],
        [[68968, 73101], [109, 14], [134, 46], [76, -13], [28, 10], [85, 1], [-9, 27], [59, 18]],
        [
            [69450, 73204],
            [26, -53],
            [32, -39],
            [-26, -32],
            [52, -35],
            [29, -1],
            [68, -88],
            [-3, -23],
            [-55, -55],
            [-8, -38],
            [60, -124],
            [51, -49],
            [71, -53],
            [1, -33],
            [-34, -91],
            [-70, 2],
            [10, -32],
            [39, -42],
            [23, -41],
            [24, -18],
            [80, -101],
            [37, 13],
            [50, -35],
            [-1, -45],
            [-31, -23],
            [0, -28],
            [39, -47],
            [14, -54],
            [-40, 3],
            [-6, -22],
            [27, -55],
            [0, -91]
        ],
        [[2862, 42179], [-29, 22], [41, 30], [-12, -52]],
        [[5558, 3836], [-96, -13], [-229, 25], [-156, 61], [-75, 81], [307, -12], [360, -91], [-111, -51]],
        [[6794, 4401], [-172, 88], [88, 0], [132, -46], [-48, -42]],
        [[6029, 4689], [-32, -5], [-828, 65], [-158, 21], [-32, 67], [206, 24], [230, -18], [469, -84], [145, -70]],
        [[8047, 5557], [-129, 4], [-183, 33], [-32, 37], [-218, 39], [23, 36], [352, -95], [157, -29], [30, -25]],
        [
            [37122, 5383],
            [-28, -217],
            [-93, -60],
            [-141, -60],
            [-445, 33],
            [-200, 31],
            [-83, 38],
            [-63, 95],
            [-284, -31],
            [-63, -54],
            [-591, 171],
            [-181, 82],
            [121, 40],
            [65, -69],
            [58, -21],
            [1068, 6],
            [274, 16],
            [98, 21],
            [-117, 96],
            [3, 64],
            [118, 13],
            [-13, 61],
            [98, 44],
            [138, 38],
            [218, -20],
            [51, -55],
            [-25, -126],
            [90, -8],
            [-10, -52],
            [-63, -76]
        ],
        [
            [45954, 5688],
            [142, 36],
            [243, -50],
            [80, -48],
            [-128, -15],
            [-122, -42],
            [-130, 40],
            [-232, 29],
            [-70, 21],
            [-55, 65],
            [122, 49],
            [150, -85]
        ],
        [[45577, 5757], [-75, 9], [64, 69], [137, -19], [-126, -59]],
        [
            [35134, 5532],
            [-73, 58],
            [-152, 36],
            [-54, 82],
            [-198, 79],
            [-28, 41],
            [257, -12],
            [59, -22],
            [238, -9],
            [45, -64],
            [90, -18],
            [23, -102],
            [-207, -69]
        ],
        [
            [34798, 5880],
            [-53, -27],
            [-224, 13],
            [-120, 23],
            [39, 58],
            [120, 59],
            [173, 2],
            [125, -25],
            [-53, -33],
            [-7, -70]
        ],
        [[45085, 5954], [-35, -20], [-751, 35], [-26, 47], [160, 16], [158, 51], [353, -75], [141, -54]],
        [
            [6466, 5683],
            [-386, -21],
            [-156, 18],
            [-327, 60],
            [-570, 146],
            [-158, 68],
            [-17, 42],
            [48, 139],
            [96, 37],
            [172, 116],
            [268, -22],
            [230, -78],
            [605, -280],
            [82, -59],
            [130, -126],
            [-17, -40]
        ],
        [
            [33850, 5754],
            [-201, 3],
            [-167, 28],
            [-50, 31],
            [-29, 69],
            [35, 111],
            [128, 103],
            [219, 99],
            [177, 41],
            [177, 69],
            [592, 180],
            [136, 26],
            [96, -38],
            [-232, -166],
            [-358, -185],
            [-189, -110],
            [-134, -129],
            [-14, -98],
            [-186, -34]
        ],
        [
            [107305, 6611],
            [-82, -60],
            [-136, 15],
            [-96, -34],
            [-156, 5],
            [-33, 96],
            [30, 7],
            [232, -59],
            [85, 37],
            [88, 69],
            [53, -9],
            [15, -67]
        ],
        [
            [41601, 6238],
            [365, 3],
            [98, -7],
            [55, -47],
            [85, -145],
            [18, -77],
            [76, -98],
            [-8, -181],
            [-86, -99],
            [-151, -23],
            [83, -42],
            [-12, -54],
            [-1747, -251],
            [-136, -39],
            [-45, -40],
            [-1355, -48],
            [-58, 61],
            [1, 107],
            [94, 45],
            [173, 167],
            [366, 26],
            [181, 85],
            [323, 202],
            [101, 82],
            [-13, 79],
            [-109, 31],
            [66, 100],
            [5, 86],
            [81, 65],
            [-42, 29],
            [49, 98],
            [86, 80],
            [181, 133],
            [84, 98],
            [429, 115],
            [267, 31],
            [175, -11],
            [225, -43],
            [209, -59],
            [158, -58],
            [164, -108],
            [10, -55],
            [-52, -119],
            [-346, -36],
            [-88, -72],
            [40, -11]
        ],
        [[9501, 7060], [-68, -19], [-69, 39], [89, 12], [48, -32]],
        [[9137, 7042], [-292, 41], [100, 42], [192, -83]],
        [
            [107132, 7069],
            [117, -41],
            [305, 5],
            [255, -39],
            [24, -39],
            [-185, -71],
            [-133, -17],
            [-125, 22],
            [-163, -3],
            [-204, -113],
            [-61, 84],
            [-91, 86],
            [120, 95],
            [-66, 69],
            [94, 51],
            [83, -14],
            [30, -75]
        ],
        [[9693, 7244], [-129, -7], [-71, 15], [2, 52], [225, -31], [-27, -29]],
        [[9497, 7181], [-153, -5], [-40, 16], [-187, 14], [-100, 52], [122, 46], [161, 14], [197, -137]],
        [[10307, 7269], [-115, -24], [-33, 94], [260, -26], [25, -36], [-137, -8]],
        [[9466, 7405], [207, -1], [86, -14], [-185, -56], [-150, 49], [42, 22]],
        [[9188, 7372], [-130, -6], [-57, 41], [204, 13], [-17, -48]],
        [[10251, 7452], [-37, -45], [-138, 53], [68, 49], [80, -18], [27, -39]],
        [[10282, 7668], [-64, -8], [-139, 64], [-4, 46], [127, -19], [80, -83]],
        [[105862, 8047], [-56, -72], [-60, 15], [39, 40], [77, 17]],
        [[10730, 7966], [-94, 11], [-155, 45], [-10, 44], [97, 10], [106, -41], [56, -69]],
        [[106173, 8456], [-66, 17], [-6, 51], [80, 46], [64, 12], [-72, -126]],
        [[14695, 8674], [-48, -31], [-96, 20], [94, 42], [50, -31]],
        [[15104, 8595], [-35, -12], [-204, 35], [-99, 65], [123, 57], [163, -50], [78, 0], [5, -57], [-31, -38]],
        [
            [16246, 8573],
            [-47, -10],
            [-92, 37],
            [-86, 61],
            [-12, 77],
            [87, -2],
            [113, -41],
            [79, -11],
            [26, -31],
            [-68, -80]
        ],
        [[19527, 8829], [-152, -16], [-45, 61], [307, 122], [70, -25], [-140, -89], [-40, -53]],
        [[18659, 8859], [-110, 16], [75, 52], [-43, 97], [88, 22], [93, -1], [79, -18], [25, -38], [-56, -67], [-151, -63]],
        [
            [18348, 9057],
            [55, -56],
            [33, -74],
            [-222, -94],
            [-22, -100],
            [-378, -37],
            [-177, 34],
            [-30, 57],
            [59, 12],
            [-35, 66],
            [79, 75],
            [-127, 71],
            [-96, -3],
            [30, 58],
            [42, 32],
            [209, 0],
            [290, -28],
            [290, -13]
        ],
        [
            [49199, 8984],
            [-15, -122],
            [17, -51],
            [55, -67],
            [2, -71],
            [-23, -27],
            [-110, 30],
            [-40, 119],
            [-59, 52],
            [-236, 42],
            [199, 38],
            [81, 60],
            [49, 114],
            [88, 32],
            [18, -100],
            [-26, -49]
        ],
        [[107984, 9141], [-41, -11], [-71, 47], [93, 120], [55, -106], [-36, -50]],
        [
            [16566, 9319],
            [82, -16],
            [101, -51],
            [54, -73],
            [73, -45],
            [15, -41],
            [-170, -15],
            [-9, -35],
            [56, -23],
            [108, 15],
            [103, -20],
            [92, 45],
            [48, 6],
            [127, -53],
            [26, -26],
            [-34, -35],
            [109, -74],
            [-11, -83],
            [-320, 9],
            [-67, 15],
            [-102, 63],
            [-81, 19],
            [-63, 45],
            [-110, 35],
            [-71, 44],
            [-7, 63],
            [-106, 24],
            [-52, -39],
            [-69, 7],
            [-1, 72],
            [-56, 38],
            [6, 75],
            [40, 44],
            [89, -3],
            [118, 17],
            [82, -4]
        ],
        [[32756, 9279], [-83, 23], [30, 53], [67, 60], [90, -6], [-56, -96], [-48, -34]],
        [[23292, 9385], [-37, -25], [-68, 6], [-54, 42], [-24, 75], [49, 28], [134, -126]],
        [
            [32609, 9423],
            [-52, -81],
            [-45, -17],
            [93, -106],
            [-64, -82],
            [-409, 156],
            [-47, 43],
            [-14, 58],
            [25, 37],
            [75, 17],
            [83, -31],
            [20, 64],
            [-90, 64],
            [109, 33],
            [279, -41],
            [77, -57],
            [-40, -57]
        ],
        [[26608, 9523], [-52, 0], [-46, 33], [34, 23], [64, -56]],
        [
            [27421, 9377],
            [-108, -8],
            [19, 127],
            [29, 33],
            [-97, 159],
            [113, 43],
            [110, -5],
            [44, -31],
            [8, -67],
            [-36, -52],
            [37, -16],
            [0, -78],
            [-68, -80],
            [-51, -25]
        ],
        [[26228, 9665], [-58, 37], [143, 45], [73, 15], [28, -68], [-186, -29]],
        [[50589, 9657], [-66, -13], [-42, 28], [-20, 68], [66, 29], [62, -112]],
        [[76691, 9868], [-8, 23], [72, 87], [53, -35], [-7, -35], [-110, -40]],
        [[51698, 9939], [-65, -8], [-52, 28], [-23, 41], [54, 32], [86, -93]],
        [
            [25282, 10085],
            [-26, -60],
            [3, -58],
            [75, 4],
            [33, 110],
            [72, 20],
            [34, -65],
            [-34, -53],
            [38, -52],
            [67, 31],
            [48, 105],
            [67, 52],
            [150, 8],
            [80, -33],
            [-53, -83],
            [-129, -49],
            [-81, -50],
            [55, -21],
            [367, 107],
            [0, -60],
            [25, -41],
            [-14, -90],
            [-155, -24],
            [8, -69],
            [-198, 16],
            [-103, -14],
            [-69, 29],
            [-179, -20],
            [-178, 5],
            [-72, 33],
            [-157, 10],
            [-323, 111],
            [-50, -3],
            [-384, 57],
            [-130, -5],
            [-75, 27],
            [-7, 58],
            [49, 26],
            [533, 67],
            [98, 16],
            [78, -117],
            [83, 56],
            [95, -15],
            [53, 22],
            [37, 44],
            [107, 50],
            [132, -31],
            [30, -51]
        ],
        [[54647, 10474], [-32, -13], [-77, 20], [-29, 45], [43, 38], [95, -90]],
        [[36869, 10564], [-73, 6], [-48, 41], [50, 30], [52, -3], [30, -44], [-11, -30]],
        [
            [54778, 10723],
            [33, -18],
            [103, -12],
            [-86, -124],
            [-73, -54],
            [-68, 15],
            [8, 73],
            [-50, 24],
            [-14, 49],
            [-148, 65],
            [-15, 29],
            [153, 5],
            [90, -11],
            [67, -41]
        ],
        [
            [32809, 10797],
            [48, -49],
            [-44, -40],
            [-158, -72],
            [-185, -50],
            [-423, -67],
            [-76, 24],
            [-24, 83],
            [77, 43],
            [66, 16],
            [255, 35],
            [46, 37],
            [16, 54],
            [67, -12],
            [62, -90],
            [38, 37],
            [4, 78],
            [71, -16],
            [58, 35],
            [102, -46]
        ],
        [[36811, 10755], [-48, 11], [-24, 51], [28, 45], [102, 5], [31, -20], [-11, -57], [-78, -35]],
        [[53740, 10843], [-81, -33], [-87, 88], [114, 27], [37, -15], [17, -67]],
        [[56497, 10818], [-105, -15], [-20, 69], [136, 66], [58, -37], [-28, -59], [-41, -24]],
        [[54547, 10853], [-67, 26], [65, 80], [104, 36], [73, -23], [9, -79], [-17, -25], [-167, -15]],
        [[33430, 11003], [81, -1], [28, -28], [-65, -68], [-41, -2], [-34, 86], [31, 13]],
        [[77784, 10798], [-50, 6], [-56, 70], [-4, 89], [47, 41], [25, -79], [37, -29], [30, -66], [-29, -32]],
        [[56956, 10884], [-49, -13], [-73, 47], [-18, 71], [57, 28], [74, -6], [38, -66], [-29, -61]],
        [[63849, 10938], [-119, -37], [-144, 42], [-7, 96], [99, 71], [93, -3], [26, -20], [58, -120], [-6, -29]],
        [[55961, 11009], [-28, -71], [-68, 88], [-12, 72], [23, 25], [119, 5], [15, -53], [-49, -66]],
        [[36682, 11164], [-76, 25], [24, 42], [54, -15], [-2, -52]],
        [
            [32414, 11303],
            [54, -14],
            [81, -61],
            [34, -49],
            [-43, -27],
            [-29, -75],
            [-55, -26],
            [-129, 17],
            [-142, 29],
            [-26, 63],
            [40, 57],
            [106, 23],
            [23, 51],
            [86, 12]
        ],
        [
            [60567, 11147],
            [-20, -36],
            [-97, 50],
            [-71, 24],
            [-16, 42],
            [42, 50],
            [65, 25],
            [104, 13],
            [117, -25],
            [-96, -52],
            [-28, -91]
        ],
        [[33340, 11319], [-67, -23], [-177, 53], [-56, 64], [7, 34], [65, 31], [121, -44], [107, -115]],
        [
            [36423, 11306],
            [-54, 47],
            [-13, 79],
            [-87, 116],
            [-22, 60],
            [39, 19],
            [100, -38],
            [93, -90],
            [3, -78],
            [-31, -40],
            [-28, -75]
        ],
        [
            [33937, 11603],
            [43, -44],
            [63, -29],
            [90, -147],
            [57, -181],
            [44, -101],
            [111, -178],
            [84, -153],
            [2, -75],
            [36, -21],
            [18, -135],
            [15, -350],
            [-4, -54],
            [-68, -147],
            [-55, -69],
            [-157, -121],
            [-19, -60],
            [-263, -51],
            [-149, -22],
            [-58, 23],
            [-344, -9],
            [-161, -17],
            [-50, 45],
            [-110, 24],
            [-62, 77],
            [72, 58],
            [73, 16],
            [149, -31],
            [164, -15],
            [226, -5],
            [137, 25],
            [68, 53],
            [-67, 33],
            [-67, -1],
            [-165, -53],
            [-73, -11],
            [-77, 19],
            [-73, 72],
            [244, 41],
            [67, 34],
            [22, 45],
            [-165, 39],
            [-68, -8],
            [-75, 16],
            [-136, 101],
            [-48, -12],
            [-159, -145],
            [-73, 10],
            [-144, 39],
            [-61, -20],
            [90, -85],
            [-112, -72],
            [-95, 5],
            [-68, 49],
            [-110, -5],
            [-175, 104],
            [-9, 28],
            [27, 118],
            [60, 34],
            [73, 6],
            [70, -41],
            [75, -12],
            [-10, 102],
            [74, 41],
            [77, -31],
            [121, -75],
            [51, 25],
            [-66, 44],
            [-4, 55],
            [64, 16],
            [117, -26],
            [123, -11],
            [126, 29],
            [-67, 34],
            [-147, 29],
            [-48, 54],
            [108, 30],
            [110, -1],
            [197, -40],
            [66, 19],
            [95, 71],
            [140, -5],
            [112, 26],
            [34, -10],
            [109, -94],
            [25, 23],
            [1, 99],
            [-144, 44],
            [-112, 10],
            [-120, 31],
            [-43, 57],
            [40, 68],
            [154, 75],
            [72, 23],
            [109, 1],
            [110, -21],
            [-219, 133],
            [-121, 11],
            [-64, -29],
            [-60, -3],
            [-177, 72],
            [-49, 55],
            [0, 90],
            [42, 158],
            [-8, 57],
            [-104, 86],
            [-18, 86],
            [25, 63],
            [58, 33],
            [148, 38],
            [300, 47],
            [96, -95],
            [17, -128]
        ],
        [[34771, 12396], [-60, -10], [-46, 12], [-15, 57], [57, 32], [96, 3], [30, -29], [-62, -65]],
        [[106438, 12522], [-60, 23], [17, 51], [40, 46], [29, -68], [-26, -52]],
        [[34767, 12882], [-71, 11], [29, 40], [52, 28], [23, -49], [-33, -30]],
        [[82050, 12850], [-64, 1], [-79, 54], [-6, 73], [66, -3], [78, -26], [40, -66], [-35, -33]],
        [[70544, 12944], [-75, -8], [17, 53], [86, 1], [42, -43], [-70, -3]],
        [[105965, 12923], [-43, 1], [-23, 67], [46, -5], [20, -63]],
        [[82272, 12953], [-63, -11], [-33, 31], [47, 32], [83, -24], [-34, -28]],
        [
            [34574, 12559],
            [-58, -47],
            [-63, 2],
            [-18, -56],
            [-44, -43],
            [-99, -6],
            [-60, 79],
            [-13, 48],
            [17, 63],
            [81, 94],
            [125, 212],
            [25, 29],
            [156, 99],
            [37, -5],
            [9, -42],
            [-78, -76],
            [-11, -104],
            [87, -65],
            [-151, -109],
            [52, -41],
            [6, -32]
        ],
        [[81897, 13040], [-59, -14], [-21, 30], [16, 36], [64, -52]],
        [[86070, 13119], [-59, 9], [-18, 40], [47, 7], [62, -28], [-32, -28]],
        [[105752, 13115], [-31, -24], [-65, 67], [3, 83], [93, -126]],
        [[35004, 13269], [-69, -62], [12, 112], [46, 25], [11, -75]],
        [[85380, 13361], [99, -12], [26, -59], [-25, -21], [-167, -13], [-27, 22], [28, 58], [66, 25]],
        [[84142, 13488], [-83, 1], [-9, 56], [60, 2], [42, -16], [-10, -43]],
        [
            [35235, 13469],
            [-67, -21],
            [-34, 8],
            [6, 51],
            [32, 17],
            [-5, 43],
            [30, 53],
            [42, 25],
            [61, -12],
            [-10, -58],
            [-45, -19],
            [-10, -87]
        ],
        [
            [86729, 13561],
            [-134, -13],
            [-61, 16],
            [-25, 38],
            [43, 77],
            [61, 39],
            [86, 10],
            [60, -14],
            [44, -39],
            [5, -51],
            [-79, -63]
        ],
        [[87475, 13690], [-80, 6], [-8, 69], [-100, 42], [-9, 38], [41, 21], [75, -34], [15, -78], [66, -64]],
        [[36016, 14016], [-75, -25], [31, 61], [44, -36]],
        [[37891, 14180], [-59, 15], [-4, 45], [131, 60], [22, -17], [-13, -48], [-77, -55]],
        [
            [36058, 14235],
            [-30, -58],
            [45, 0],
            [63, 30],
            [28, -30],
            [-58, -21],
            [-77, -60],
            [-88, -9],
            [-27, -38],
            [-111, 19],
            [-82, 39],
            [31, 65],
            [94, 40],
            [-15, 29],
            [75, 20],
            [-3, 44],
            [61, 46],
            [47, -3],
            [32, -32],
            [-13, -32],
            [28, -49]
        ],
        [
            [36322, 14260],
            [-56, -17],
            [-23, -33],
            [-51, 23],
            [82, 146],
            [-40, 52],
            [20, 40],
            [67, 18],
            [18, -43],
            [65, -27],
            [-39, -128],
            [-43, -31]
        ],
        [
            [37705, 14466],
            [32, 4],
            [46, 45],
            [106, -73],
            [-24, -78],
            [-27, -33],
            [8, -46],
            [-60, 16],
            [-37, 32],
            [-99, -16],
            [-59, -27],
            [-28, 31],
            [88, 40],
            [-37, 20],
            [-2, 61],
            [-78, -21],
            [-8, 38],
            [46, 84],
            [108, 61],
            [45, -34],
            [-20, -104]
        ],
        [[37850, 14604], [66, -5], [-18, -33], [-123, 12], [75, 26]],
        [[36838, 14571], [-48, 16], [4, 67], [25, 27], [47, -15], [-39, -63], [11, -32]],
        [[38314, 14755], [-26, -24], [-69, 37], [-9, 42], [108, 17], [43, -47], [-47, -25]],
        [
            [37959, 14846],
            [29, -74],
            [45, -37],
            [-16, -33],
            [-88, -4],
            [-10, 89],
            [-96, -19],
            [-122, -80],
            [-125, -60],
            [-83, -85],
            [-95, -151],
            [-64, -26],
            [76, -33],
            [-29, -54],
            [27, -31],
            [6, -44],
            [-32, -7],
            [-49, 48],
            [-55, 4],
            [-98, 47],
            [-21, -45],
            [12, -51],
            [-49, -15],
            [-10, 60],
            [-61, 11],
            [-215, -166],
            [-79, -99],
            [-44, -42],
            [-84, -24],
            [-84, 21],
            [-41, -26],
            [49, -85],
            [-27, -29],
            [-59, 2],
            [-29, 24],
            [-61, -78],
            [29, -70],
            [92, -63],
            [-73, -11],
            [-97, -140],
            [4, -42],
            [38, -64],
            [51, -46],
            [51, -3],
            [82, 26],
            [66, 7],
            [29, 44],
            [70, -6],
            [16, 28],
            [114, 4],
            [16, -25],
            [-55, -70],
            [-35, 22],
            [-47, -25],
            [33, -45],
            [-39, -81],
            [-32, 25],
            [-5, 44],
            [-87, 37],
            [-29, -45],
            [-47, -13],
            [-24, -100],
            [-27, 15],
            [-10, 59],
            [-75, 49],
            [-38, 6],
            [-136, -22],
            [-23, -41],
            [43, -70],
            [-12, -67],
            [35, -36],
            [-50, -33],
            [-90, 127],
            [-57, 56],
            [-24, 49],
            [-101, 12],
            [-52, -20],
            [31, -58],
            [-32, -15],
            [-64, -100],
            [-35, -37],
            [83, -59],
            [17, -63],
            [-89, -30],
            [-199, 68],
            [-33, -93],
            [-26, -29],
            [18, -158],
            [-132, -19],
            [-60, 9],
            [-25, -66],
            [32, -120],
            [-48, -72],
            [-8, -49],
            [40, -74],
            [-52, -68],
            [130, -5],
            [103, 47],
            [-4, -63],
            [-144, -66],
            [10, -43],
            [75, -3],
            [28, -21],
            [-75, -98],
            [106, -50],
            [145, -41],
            [108, -14],
            [-24, 47],
            [-4, 58],
            [115, 63],
            [179, 28],
            [-41, -44],
            [-111, -52],
            [-12, -63],
            [94, -33],
            [31, -26],
            [-42, -78],
            [7, -51],
            [142, -160],
            [126, -83],
            [42, -59],
            [14, -136],
            [63, -112],
            [74, -51],
            [9, -44],
            [-25, -45],
            [-63, 26],
            [-35, -26],
            [-14, -48],
            [116, -73],
            [153, 3],
            [4, -44],
            [-63, -59],
            [-92, -29],
            [-14, -41],
            [24, -55],
            [80, 24],
            [120, -6],
            [19, -75],
            [73, -92],
            [4, -85],
            [-45, -12],
            [-68, -62],
            [-45, -15],
            [-85, -76],
            [70, -33],
            [108, 62],
            [41, -14],
            [41, -88],
            [-27, -41],
            [-188, -24],
            [-91, -23],
            [-98, -63],
            [112, -30],
            [82, 10],
            [98, -33],
            [111, 35],
            [72, -13],
            [17, -161],
            [-21, -36],
            [-98, -25],
            [-71, 2],
            [-2, -74],
            [107, -55],
            [66, 29],
            [59, -15],
            [0, -88],
            [46, -98],
            [73, 39],
            [43, 0],
            [16, -52],
            [-18, -88],
            [-33, -48],
            [-135, 35],
            [-104, -60],
            [-57, -5],
            [-107, 76],
            [-179, 25],
            [68, -60],
            [46, -137],
            [72, 19],
            [100, -40],
            [62, -41],
            [28, -56],
            [-35, -88],
            [-93, -48],
            [-62, 34],
            [-88, -16],
            [-46, -60],
            [160, -2],
            [86, -48],
            [-57, -48],
            [-106, 7],
            [-84, -53],
            [158, -22],
            [169, 49],
            [24, -37],
            [-94, -95],
            [-195, -20],
            [-183, 41],
            [3, -36],
            [102, -116],
            [-10, -83],
            [-138, -50],
            [-60, 31],
            [-43, 89],
            [-55, 25],
            [-90, 4],
            [16, -92],
            [-134, -31],
            [-113, -55],
            [182, -17],
            [50, -45],
            [-18, -22],
            [-193, -29],
            [-130, -48],
            [95, -21],
            [206, -12],
            [-18, -56],
            [-213, -71],
            [-306, -116],
            [-86, -15],
            [-199, -77],
            [-125, -34],
            [-354, -54],
            [-551, -134],
            [-189, -96],
            [-55, -73],
            [-141, -36],
            [-106, -12],
            [-279, -7],
            [-285, 35],
            [-232, 8],
            [-126, -12],
            [-428, 64],
            [-121, -15],
            [-180, 13],
            [-292, -25],
            [-30, -40],
            [37, -74],
            [283, -245],
            [96, -34],
            [170, -78],
            [249, -2],
            [340, -32],
            [194, -30],
            [-7, -58],
            [-117, -112],
            [-244, -120],
            [-237, -38],
            [-181, 11],
            [-321, 64],
            [-403, 58],
            [-598, 54],
            [-284, 51],
            [-259, -75],
            [596, -150],
            [510, -109],
            [131, -47],
            [-35, -125],
            [-100, -48],
            [-260, -4],
            [-326, -38],
            [-162, -1],
            [-162, 38],
            [-343, 109],
            [-210, 81],
            [-361, 239],
            [28, -91],
            [136, -117],
            [-92, 1],
            [-67, -59],
            [52, -83],
            [103, -91],
            [89, -24],
            [118, -56],
            [287, -102],
            [135, -110],
            [18, -58],
            [84, -56],
            [110, -6],
            [15, 107],
            [104, 29],
            [214, -20],
            [913, -12],
            [87, -34],
            [57, -134],
            [-96, -108],
            [-66, -46],
            [-205, -51],
            [-148, -8],
            [-306, 8],
            [-299, -1],
            [458, -95],
            [314, 8],
            [232, 32],
            [130, -111],
            [86, -49],
            [66, -131],
            [80, -103],
            [132, -47],
            [92, 27],
            [177, 12],
            [280, -56],
            [147, 35],
            [117, 50],
            [245, 46],
            [112, 35],
            [141, -15],
            [99, -118],
            [144, -58],
            [183, -24],
            [182, 20],
            [193, -100],
            [738, -174],
            [254, -34],
            [393, -18],
            [305, -2],
            [100, -44],
            [-116, -24],
            [-379, 2],
            [-286, 13],
            [-285, -43],
            [41, -26],
            [209, -15],
            [191, 4],
            [17, -41],
            [-549, -19],
            [-68, -28],
            [108, -51],
            [-40, -77],
            [62, -54],
            [89, 0],
            [156, -51],
            [162, -2],
            [192, 39],
            [348, 23],
            [230, -4],
            [321, 47],
            [13, -50],
            [-394, -106],
            [-198, -34],
            [84, -106],
            [104, -59],
            [65, -86],
            [216, -8],
            [5, -59],
            [-120, -136],
            [187, -48],
            [453, -17],
            [668, 344],
            [319, 116],
            [160, 86],
            [156, 8],
            [404, 147],
            [200, 31],
            [285, 6],
            [211, 41],
            [333, 48],
            [192, 4],
            [515, 42],
            [147, -18],
            [162, -44],
            [105, 0],
            [235, 32],
            [66, -118],
            [-124, -101],
            [-22, -64],
            [106, -32],
            [349, 41],
            [424, 93],
            [151, 141],
            [190, 143],
            [160, 91],
            [104, 106],
            [85, 62],
            [161, 69],
            [146, 4],
            [209, 75],
            [306, 83],
            [235, -40],
            [247, -61],
            [123, 50],
            [261, 46],
            [197, 134],
            [617, 62],
            [192, 15],
            [139, 29],
            [292, 6],
            [91, 79],
            [182, 16],
            [339, 60],
            [1570, 62],
            [206, 54],
            [52, 59],
            [-211, 24],
            [-65, 25],
            [-296, 5],
            [-1448, 91],
            [-81, 63],
            [11, 101],
            [-43, 79],
            [-102, 22],
            [-236, -12],
            [-349, -43],
            [-140, -4],
            [-371, 66],
            [-246, 74],
            [-161, 25],
            [-223, 89],
            [-8, 88],
            [26, 82],
            [207, 238],
            [130, 114],
            [86, 9],
            [80, 52],
            [80, 115],
            [67, 54],
            [149, 63],
            [302, 95],
            [170, -10],
            [119, 70],
            [367, 151],
            [82, 57],
            [102, 35],
            [296, 127],
            [263, 63],
            [132, 17],
            [160, 39],
            [332, 111],
            [552, 106],
            [331, 28],
            [226, 31],
            [160, -18],
            [159, 6],
            [200, 50],
            [92, 57],
            [307, -27],
            [198, 39],
            [169, 22],
            [-66, 23],
            [-72, 82],
            [72, 106],
            [91, 43],
            [92, 154],
            [151, 178],
            [42, 25],
            [96, 8],
            [172, -2],
            [234, -47],
            [118, 71],
            [62, 66],
            [159, 125],
            [-12, 48],
            [-200, -20],
            [-151, -32],
            [-145, 17],
            [-19, 27],
            [86, 28],
            [21, 33],
            [-50, 27],
            [-130, 36],
            [26, 122],
            [88, 51],
            [107, 101],
            [64, 31],
            [181, 28],
            [212, -42],
            [48, 11],
            [51, 57],
            [-92, 149],
            [215, -33],
            [121, 4],
            [143, 87],
            [201, 73],
            [185, 48],
            [116, 212],
            [50, 72],
            [-16, 81],
            [-100, -16],
            [-112, 37],
            [-139, 59],
            [-63, 125],
            [86, 52],
            [45, 4],
            [82, -23],
            [155, -84],
            [59, -44],
            [44, 4],
            [51, 61],
            [43, 83],
            [151, 91],
            [-28, 39],
            [-64, 21],
            [18, 49],
            [53, 5],
            [65, -56],
            [150, -50],
            [53, -32],
            [82, -104],
            [99, -174],
            [225, 21],
            [63, 50],
            [13, 123],
            [25, 57],
            [-9, 57],
            [-79, 101],
            [38, 54],
            [112, 31],
            [170, -32],
            [90, 15],
            [188, 58],
            [75, -18],
            [33, -62],
            [-38, -62],
            [-114, -104],
            [-12, -95],
            [52, -9],
            [463, 8],
            [140, -7],
            [87, -20],
            [147, 8],
            [132, 22],
            [170, -20],
            [76, -42],
            [158, 11],
            [45, 15],
            [43, 57],
            [46, 10],
            [53, -46],
            [17, -107],
            [25, -50],
            [67, -46],
            [67, 39],
            [148, 136],
            [119, 69],
            [91, 40],
            [222, 69],
            [110, 42],
            [216, 58],
            [277, 31],
            [496, 105],
            [164, 11],
            [266, 28],
            [276, 51],
            [85, 77],
            [194, -59],
            [67, -6],
            [91, 46],
            [100, 115],
            [146, -47],
            [84, -75],
            [102, -58],
            [232, -101],
            [73, -22],
            [153, -22],
            [41, 17],
            [72, 67],
            [75, 97],
            [47, 41],
            [144, 87],
            [-20, 28],
            [-83, 25],
            [10, 29],
            [135, 7],
            [72, -98],
            [162, -63],
            [207, 24],
            [176, 3],
            [154, -21],
            [76, 4],
            [67, 73],
            [110, 27],
            [63, -33],
            [38, -108],
            [141, -30],
            [296, -49],
            [33, 12],
            [62, 127],
            [60, 12],
            [77, 38],
            [41, -6],
            [58, -46],
            [-20, -110],
            [-33, -102],
            [74, -127],
            [119, -10],
            [147, 1],
            [291, 42],
            [83, 194],
            [113, 132],
            [79, -24],
            [125, -97],
            [9, -48],
            [-50, -45],
            [66, -55],
            [164, -39],
            [53, 8],
            [79, 41],
            [80, 82],
            [43, 95],
            [133, -24],
            [46, -49],
            [0, -94],
            [115, -105],
            [133, -44],
            [143, -10],
            [100, -27],
            [162, 10],
            [79, 30],
            [139, 31],
            [152, 77],
            [212, 51],
            [162, 55],
            [171, 98],
            [166, 60],
            [327, 42],
            [98, -1],
            [241, 70],
            [143, 56],
            [58, 50],
            [55, 159],
            [-26, 137],
            [-51, 69],
            [-53, 101],
            [23, 115],
            [41, 47],
            [107, 53],
            [106, 10],
            [225, -18],
            [8, -49],
            [-45, -53],
            [-93, -75],
            [13, -44],
            [75, -6],
            [166, 9],
            [47, -41],
            [118, -178],
            [29, -84],
            [41, -24],
            [65, 11],
            [139, -1],
            [97, 13],
            [119, -7],
            [43, -41],
            [80, -47],
            [137, 51],
            [70, -4],
            [110, -55],
            [110, -129],
            [119, -65],
            [-8, 93],
            [49, 45],
            [145, 176],
            [67, 102],
            [18, 141],
            [31, 115],
            [55, 55],
            [136, 72],
            [103, 9],
            [98, 82],
            [69, 34],
            [144, 46],
            [181, 45],
            [126, 127],
            [109, 36],
            [118, 8],
            [193, 40],
            [60, 7],
            [101, 31],
            [89, 76],
            [64, 21],
            [115, -3],
            [98, 43],
            [83, 1],
            [75, 22],
            [12, 47],
            [-36, 32],
            [-1, 41],
            [75, 75],
            [100, -4],
            [83, -46],
            [61, -2],
            [16, -27],
            [-53, -32],
            [-35, -59],
            [115, -86],
            [66, 6],
            [79, 32],
            [77, -22],
            [35, -48],
            [0, -74],
            [70, -5],
            [30, 74],
            [-5, 152],
            [130, 94],
            [52, 70],
            [-92, 15],
            [-64, -9],
            [-36, 25],
            [-41, 71],
            [113, 59],
            [128, -2],
            [75, -50],
            [160, -80],
            [88, 2],
            [80, -13],
            [17, 25],
            [-30, 118],
            [3, 66],
            [-66, 37],
            [-19, 84],
            [27, 88],
            [79, 49],
            [108, 23],
            [232, 136],
            [60, 29],
            [153, 28],
            [178, 14],
            [221, 48],
            [394, -32],
            [106, -21],
            [66, -27],
            [63, -43],
            [82, -73],
            [119, -91],
            [154, -28],
            [43, -29],
            [58, -77],
            [-62, -51],
            [-50, -4],
            [-163, 61],
            [-46, -13],
            [45, -53],
            [50, -33],
            [8, -44],
            [-28, -64],
            [-181, -126],
            [108, -36],
            [66, 29],
            [60, 54],
            [102, 33],
            [145, 2],
            [82, 22],
            [62, -15],
            [61, -35],
            [220, -70],
            [158, -143],
            [123, 15],
            [67, 31],
            [190, 10],
            [164, -64],
            [91, -23],
            [267, -19],
            [159, -40],
            [102, 47],
            [68, 20],
            [142, 10],
            [72, -10],
            [198, -52],
            [350, -54],
            [241, -27],
            [212, -2],
            [101, -23],
            [184, -25],
            [71, -19],
            [176, 15],
            [83, 21],
            [77, 45],
            [44, -11],
            [30, -56],
            [-17, -99],
            [58, -133],
            [59, -103],
            [-16, -39],
            [-52, -36],
            [-70, -77],
            [4, -67],
            [31, -42],
            [-36, -51],
            [31, -116],
            [-25, -34],
            [-55, -21],
            [-95, -4],
            [-49, -19],
            [-8, -54],
            [25, -40],
            [54, -21],
            [16, -43],
            [-32, -118],
            [-105, -30],
            [-101, 10],
            [-73, 37],
            [-186, -140],
            [-95, -103],
            [120, -30],
            [87, -54],
            [191, 6],
            [143, 49],
            [43, -5],
            [28, -54],
            [-20, -153],
            [-97, -184],
            [-77, -82],
            [-181, -117],
            [-50, -105],
            [-56, -87],
            [-81, -149],
            [-98, -356],
            [-68, -171],
            [-122, -99],
            [22, -46],
            [134, -16],
            [98, -35],
            [201, 119],
            [13, 94],
            [-13, 93],
            [42, 56],
            [96, 76],
            [351, 78],
            [125, 135],
            [103, 43],
            [86, 69],
            [13, 50],
            [143, 59],
            [61, 62],
            [22, 62],
            [10, 114],
            [26, 86],
            [95, 197],
            [41, 53],
            [110, 28],
            [48, 32],
            [106, 113],
            [-5, 88],
            [24, 79],
            [68, 48],
            [87, 90],
            [109, 13],
            [82, 46],
            [194, -76],
            [178, 13],
            [85, -20],
            [65, 24],
            [58, 69],
            [21, 84],
            [68, 49],
            [77, -2],
            [127, 84],
            [130, 75],
            [108, 17],
            [85, 59],
            [61, 99],
            [66, 75],
            [80, 73],
            [23, 129],
            [50, 65],
            [96, 57],
            [78, 31],
            [332, 97],
            [254, 64],
            [256, 79],
            [79, -1],
            [103, 44],
            [216, 5],
            [58, 91],
            [127, 83],
            [79, 26],
            [100, 73],
            [81, 7],
            [210, -33],
            [87, 0],
            [126, 59],
            [195, 10],
            [103, 54],
            [277, 85],
            [103, -17],
            [147, 15],
            [280, -18],
            [184, 30],
            [78, 20],
            [147, 73],
            [161, 17],
            [163, 36],
            [128, -54],
            [75, -11],
            [106, 30],
            [88, -8],
            [187, -58],
            [108, 23],
            [84, 58],
            [78, 24],
            [75, -15],
            [142, -58],
            [272, 18],
            [209, 56],
            [89, -44],
            [102, -16],
            [166, 78],
            [143, -48],
            [43, -66],
            [157, 13],
            [260, 97],
            [117, 27],
            [92, 38],
            [136, 143],
            [-2, 45],
            [47, 38],
            [216, -1],
            [67, 12],
            [87, 37],
            [152, -28],
            [146, -46],
            [96, 6],
            [105, -29],
            [116, -54],
            [103, -15],
            [428, -138],
            [242, -33],
            [154, -61],
            [36, -47],
            [64, -5],
            [51, 19],
            [67, -71],
            [165, -53],
            [171, -26],
            [111, 41],
            [189, 119],
            [58, 54],
            [-11, 118],
            [98, 131],
            [169, 65],
            [209, 34],
            [129, 29],
            [170, 27],
            [189, -73],
            [75, -73],
            [118, -167],
            [87, -60],
            [143, -14],
            [71, -38],
            [100, -117],
            [-60, -104],
            [-52, -39],
            [-217, -45],
            [-179, -58],
            [-24, -86],
            [35, -41],
            [91, 19],
            [104, 10],
            [159, 45],
            [65, 39],
            [155, 20],
            [193, 52],
            [63, 34],
            [65, -4],
            [64, -33],
            [189, -8],
            [64, 24],
            [58, 2],
            [117, -44],
            [60, -6],
            [78, 15],
            [248, 85],
            [129, 14],
            [58, -9],
            [-130, -52],
            [-208, -68],
            [-111, -68],
            [66, -28],
            [391, 75],
            [178, 56],
            [157, 25],
            [215, 129],
            [139, 30],
            [182, 34],
            [137, 38],
            [93, 38],
            [70, 4],
            [124, -60],
            [69, 8],
            [85, 30],
            [93, 121],
            [145, 33],
            [246, -74],
            [65, -146],
            [152, -129],
            [54, -34],
            [132, 13],
            [142, -51],
            [119, 22],
            [52, -10],
            [78, 31],
            [156, 320],
            [117, 99],
            [141, 46],
            [116, 9],
            [86, -13],
            [185, -11],
            [151, 39],
            [171, -7],
            [85, 46],
            [91, 8],
            [123, -40],
            [104, -69],
            [34, -112],
            [33, -1],
            [115, 70],
            [62, 13],
            [118, 113],
            [62, -29],
            [198, -63],
            [111, -82],
            [57, 18],
            [46, 38],
            [138, -4],
            [129, -33],
            [119, -77],
            [73, 2],
            [267, -19],
            [115, -35],
            [89, -44],
            [309, -20],
            [118, -45],
            [72, 21],
            [140, -7],
            [110, -79],
            [111, -36],
            [62, 8],
            [173, 68],
            [87, 0],
            [41, -34],
            [15, -85],
            [63, 2],
            [71, 39],
            [63, -10],
            [22, -59],
            [-33, -79],
            [-79, -109],
            [-32, -93],
            [-66, -83],
            [11, -39],
            [65, -20],
            [67, 59],
            [146, 41],
            [77, 53],
            [133, 19],
            [129, -18],
            [263, -190],
            [21, -87],
            [-30, -86],
            [91, -53],
            [147, -3],
            [274, -51],
            [131, 20],
            [258, 7],
            [193, -10],
            [183, 43],
            [41, -15],
            [22, -211],
            [46, -30],
            [84, 69],
            [304, -20],
            [83, -21],
            [82, -50],
            [80, 22],
            [113, 50],
            [19, 49],
            [5, 162],
            [38, 15],
            [90, -53],
            [117, -121],
            [127, -115],
            [164, -102],
            [151, -30],
            [148, -59],
            [172, 4],
            [134, -74],
            [91, 58],
            [49, 14],
            [69, -16],
            [85, -50],
            [66, -12],
            [228, -83],
            [123, -30],
            [106, -118],
            [0, -59],
            [25, -75],
            [137, -59],
            [119, -132],
            [119, -284],
            [62, -50],
            [90, 5],
            [85, -74],
            [29, 40],
            [-76, 191],
            [-5, 104],
            [60, 59],
            [141, 16],
            [109, -110],
            [99, -66],
            [68, -12],
            [133, 3],
            [125, 70],
            [96, -25],
            [153, -8],
            [199, -42],
            [85, 7],
            [153, -17],
            [186, -60],
            [105, -22],
            [71, -64],
            [52, -93],
            [63, -51],
            [65, -8],
            [128, -43],
            [268, -132],
            [153, -66],
            [28, 34],
            [8, 70],
            [49, 14],
            [52, -103],
            [54, -79],
            [25, -69],
            [-57, -56],
            [-139, 12],
            [-60, -94],
            [-24, -160],
            [94, 18],
            [9, -59],
            [-25, -49],
            [-49, -20],
            [-84, 37],
            [-103, 26],
            [-114, 10],
            [-109, 47],
            [-90, 1],
            [121, -94],
            [139, -39],
            [172, -60],
            [5, -36],
            [-41, -46],
            [-51, -97],
            [-158, -84],
            [-92, 61],
            [-109, 14],
            [-55, -35],
            [-108, 4],
            [-216, -14],
            [-84, 76],
            [-133, 42],
            [5, -34],
            [113, -127],
            [241, -63],
            [29, -32],
            [-54, -29],
            [-73, 4],
            [-93, -58],
            [-175, 9],
            [-83, -3],
            [-58, -55],
            [41, -58],
            [-114, -73],
            [-58, 11],
            [-62, -18],
            [-30, 54],
            [-1, 118],
            [-36, 105],
            [-98, -8],
            [-19, -90],
            [42, -156],
            [29, -49],
            [-63, -57],
            [81, -131],
            [69, -91],
            [42, -30],
            [-29, -63],
            [-139, 8],
            [-210, 31],
            [-135, -23],
            [-56, 82],
            [-89, -5],
            [-31, -98],
            [-128, -75],
            [-45, -48],
            [-22, -192],
            [-38, -39],
            [-100, -14],
            [-126, 25],
            [-237, -66],
            [98, -28],
            [208, -10],
            [89, -35],
            [15, -87],
            [35, -36],
            [124, -59],
            [19, -30],
            [-52, -113],
            [-65, -59],
            [90, -39],
            [30, -133],
            [-47, -59],
            [27, -98],
            [-84, -69],
            [-12, -48],
            [71, -29],
            [126, -14],
            [160, -198],
            [4, -109],
            [45, -65],
            [86, -42],
            [-2, -44],
            [118, -17],
            [3, -88],
            [-140, -102],
            [99, -6],
            [102, -45],
            [131, 50],
            [113, 103],
            [76, -147],
            [168, -82],
            [183, -39],
            [79, 2],
            [23, -49],
            [-25, -44],
            [-162, -5],
            [-126, 69],
            [-458, -18],
            [-103, -15],
            [-123, -49],
            [-311, -71],
            [-79, -29],
            [-205, 113],
            [-67, 83],
            [-76, -14],
            [-3, -59],
            [139, -197],
            [-66, -17],
            [-169, 46],
            [-98, -40],
            [-120, -85],
            [58, -87],
            [-8, -38],
            [-135, -71],
            [35, -46],
            [-18, -56],
            [-121, -30],
            [8, -38],
            [151, -12],
            [53, -73],
            [-117, -43],
            [-436, -114],
            [-64, -31],
            [4, -42],
            [152, -11],
            [456, 10],
            [-6, -88],
            [93, -51],
            [2, -31],
            [-176, -32],
            [5, -33],
            [136, -34],
            [0, -163],
            [-76, -78],
            [135, -28],
            [208, -122],
            [128, -25],
            [255, -118],
            [10, -31],
            [231, -111],
            [24, -37],
            [-387, -71],
            [-389, -52],
            [36, -46],
            [613, 15],
            [226, 37],
            [230, 23],
            [72, -17],
            [452, -188],
            [158, -23],
            [97, -64],
            [-12, -41],
            [114, -53],
            [151, 41],
            [159, -51],
            [-113, -92],
            [-180, -23],
            [140, -50],
            [533, -21],
            [153, -45],
            [150, 24],
            [124, -21],
            [21, -45],
            [194, -50],
            [295, -16],
            [293, -76],
            [367, -16],
            [96, -57],
            [697, -75],
            [563, -73],
            [184, -81],
            [0, -3149],
            [-111119, 0],
            [0, 232],
            [0, 162],
            [0, 393],
            [0, 394],
            [0, 393],
            [0, 394],
            [0, 394],
            [0, 393],
            [0, 394],
            [497, 8],
            [204, -33],
            [444, -12],
            [128, -52],
            [374, 27],
            [914, -45],
            [937, -78],
            [191, -25],
            [172, -59],
            [179, 8],
            [1064, -45],
            [164, -1],
            [652, -47],
            [1140, -111],
            [206, 0],
            [-163, 113],
            [-144, 39],
            [298, 13],
            [-154, 44],
            [-406, 18],
            [-1625, 139],
            [-169, 46],
            [-247, 8],
            [-65, 32],
            [379, 12],
            [41, 16],
            [-284, 95],
            [57, 46],
            [116, 10],
            [13, 60],
            [-268, 78],
            [-181, 28],
            [-119, -19],
            [-503, -12],
            [-77, 11],
            [-168, 86],
            [-253, 105],
            [-624, 107],
            [-109, 30],
            [-779, 169],
            [-53, 60],
            [360, -69],
            [385, 38],
            [244, -53],
            [491, -85],
            [316, -74],
            [679, 15],
            [185, -8],
            [217, -41],
            [145, -99],
            [220, 52],
            [192, 25],
            [166, -46],
            [116, -60],
            [495, 16],
            [207, -2],
            [148, -27],
            [622, 109],
            [124, 63],
            [-174, 26],
            [-27, 32],
            [204, 30],
            [481, 53],
            [95, 68],
            [410, 106],
            [131, 46],
            [120, 76],
            [-270, 153],
            [-257, 131],
            [163, 73],
            [72, 61],
            [-163, 75],
            [-131, 31],
            [-656, 107],
            [156, 87],
            [187, 16],
            [1200, 58],
            [1207, 72],
            [31, 36],
            [-160, 42],
            [-187, 23],
            [-20, 64],
            [-284, 53],
            [-118, 56],
            [-19, 31],
            [44, 79],
            [66, 35],
            [198, 24],
            [251, -1],
            [138, 21],
            [-36, 78],
            [94, 13],
            [-14, 73],
            [-270, 66],
            [-445, 62],
            [-172, 48],
            [-181, 80],
            [-141, 42],
            [-47, 77],
            [-141, -17],
            [-252, 9],
            [-309, 40],
            [-213, 45],
            [-279, 123],
            [-110, 61],
            [170, 70],
            [371, 62],
            [131, 78],
            [-124, 23],
            [-200, 14],
            [-379, 4],
            [-215, -8],
            [-179, 70],
            [-136, 69],
            [-66, 96],
            [84, 156],
            [5, 190],
            [114, 44],
            [117, -85],
            [100, -6],
            [146, 16],
            [141, 60],
            [90, 4],
            [173, -19],
            [168, 3],
            [279, -56],
            [94, -46],
            [45, -59],
            [118, -15],
            [333, 17],
            [86, -8],
            [236, -82],
            [201, -88],
            [181, -37],
            [75, 46],
            [108, 41],
            [242, 51],
            [57, 49],
            [-32, 28],
            [-150, 38],
            [-30, 34],
            [20, 88],
            [64, 11],
            [116, -59],
            [144, -55],
            [88, -6],
            [159, 34],
            [166, -119],
            [220, -8],
            [24, 18],
            [-64, 102],
            [90, 41],
            [-73, 53],
            [-66, 20],
            [104, 64],
            [-37, 114],
            [-317, 135],
            [-174, 38],
            [-389, -31],
            [-138, 20],
            [-187, 52],
            [234, 52],
            [81, 58],
            [96, 35],
            [142, -15],
            [322, -104],
            [288, -59],
            [137, 8],
            [-62, 47],
            [-229, 126],
            [19, 44],
            [103, 73],
            [273, 6],
            [118, 26],
            [155, 56],
            [199, 94],
            [171, 11],
            [213, 29],
            [73, -21],
            [182, -90],
            [114, -31],
            [81, 0],
            [-108, 112],
            [159, 27],
            [128, 51],
            [186, 107],
            [167, 30],
            [473, 47],
            [163, -43],
            [167, 7],
            [99, 169],
            [61, 40],
            [206, 42],
            [161, -2],
            [223, -76],
            [199, -12],
            [149, 25],
            [197, 9],
            [94, 14],
            [105, -26],
            [263, -8],
            [204, -36],
            [125, 0],
            [170, 34],
            [92, 5],
            [333, 57],
            [260, 11],
            [196, -24],
            [318, 15],
            [322, -12],
            [130, -20],
            [724, 12],
            [577, 54],
            [78, 18],
            [124, 58],
            [67, 53],
            [143, 23],
            [165, -12],
            [228, -39],
            [196, 14],
            [373, -22],
            [37, 18],
            [97, 260],
            [51, 48],
            [86, -13],
            [259, -91],
            [5, -39],
            [-69, -38],
            [-12, -78],
            [92, -15],
            [38, -34],
            [-176, -106],
            [-25, -110],
            [-39, -78],
            [55, 0],
            [259, 50],
            [431, 56],
            [34, 23],
            [-63, 100],
            [29, 38],
            [-34, 130],
            [54, 49],
            [139, -3],
            [50, -24],
            [150, -32],
            [70, -44],
            [24, -94],
            [-22, -98],
            [-72, -70],
            [-134, -64],
            [-153, -101],
            [32, -49],
            [79, 17],
            [344, -5],
            [221, 8],
            [314, -38],
            [139, -38],
            [166, -7],
            [103, 14],
            [97, -20],
            [377, 82],
            [153, 46],
            [88, -23],
            [141, 20],
            [80, -18],
            [147, 29],
            [530, -15],
            [25, -53],
            [100, -80],
            [81, -31],
            [178, 38],
            [118, -10],
            [170, 35],
            [170, -11],
            [70, 6],
            [60, 71],
            [-52, 27],
            [-148, 35],
            [-137, 73],
            [-61, 15],
            [-98, -9],
            [-95, 36],
            [64, 28],
            [78, 89],
            [-32, 82],
            [-128, 15],
            [-108, -29],
            [-114, 31],
            [-28, 75],
            [-76, 142],
            [-39, 40],
            [-121, 37],
            [-204, 41],
            [-30, 56],
            [20, 77],
            [120, 16],
            [115, -7],
            [225, -36],
            [100, -35],
            [83, 0],
            [289, 21],
            [74, 41],
            [117, 3],
            [-12, 39],
            [-253, 94],
            [-129, 27],
            [-232, 20],
            [-119, -7],
            [-74, 11],
            [-266, -6],
            [-72, 20],
            [-51, 56],
            [-72, 134],
            [-21, 70],
            [82, 55],
            [193, -8],
            [66, -56],
            [-43, -85],
            [118, -6],
            [107, -18],
            [108, 20],
            [158, 8],
            [173, -34],
            [139, 23],
            [494, -12],
            [61, -6],
            [111, -62],
            [54, 10],
            [161, -45],
            [86, -35],
            [162, -22],
            [84, 8],
            [198, 41],
            [201, -16],
            [105, -35],
            [81, 14],
            [86, 40],
            [271, 28],
            [181, -7],
            [331, -72],
            [76, -7],
            [152, 43],
            [48, 69],
            [-6, 78],
            [80, 10],
            [67, 55],
            [147, -15],
            [66, 109],
            [107, 6],
            [78, -11],
            [103, -47],
            [0, -40],
            [-42, -42],
            [-71, -104],
            [44, -61],
            [149, -6],
            [101, 26],
            [64, 1],
            [112, -90],
            [135, 0],
            [191, 81],
            [56, 9],
            [67, -37],
            [100, -86],
            [86, -50],
            [126, -30],
            [111, -9],
            [129, -41],
            [71, -33],
            [161, -1],
            [70, -14],
            [195, -70],
            [179, 34],
            [91, 33],
            [45, 59],
            [-30, 177],
            [73, 44],
            [213, -100],
            [-32, 106],
            [-54, 79],
            [8, 59],
            [45, 18],
            [90, -31],
            [106, -16],
            [88, -34],
            [172, -124],
            [55, -108],
            [117, -28],
            [81, 5],
            [216, 33],
            [96, -4],
            [88, 19],
            [26, -59],
            [-83, -84],
            [-31, -56],
            [117, 16],
            [143, -9],
            [116, 39],
            [99, 14],
            [93, 40],
            [135, -11],
            [81, -32],
            [77, 18],
            [108, -9],
            [329, 140],
            [169, 6],
            [119, 33],
            [168, 14],
            [134, 51],
            [214, -7],
            [110, 27],
            [212, 32],
            [142, 35],
            [253, 95],
            [103, 56],
            [111, 125],
            [70, 125],
            [78, 165],
            [-38, 108],
            [-157, 207],
            [-22, 135],
            [8, 126],
            [-58, 207],
            [-60, 148],
            [-159, 224],
            [0, 117],
            [-21, 92],
            [-51, 66],
            [-22, 52],
            [175, 48],
            [237, -36],
            [21, 52],
            [60, 39],
            [42, 49],
            [-15, 73],
            [-51, 31],
            [-63, 63],
            [29, 50],
            [51, 0],
            [24, 56],
            [-19, 54],
            [69, 154],
            [31, 32],
            [-110, 120],
            [13, 53],
            [59, 132],
            [65, 93],
            [-129, 23],
            [-112, -34],
            [-31, 62],
            [29, 180],
            [60, 23],
            [43, 66],
            [63, -18],
            [16, -151],
            [90, 26],
            [43, -19],
            [-19, 147],
            [21, 58],
            [-19, 75],
            [48, 74],
            [59, 9],
            [70, -30],
            [58, 12],
            [15, 29],
            [12, 95],
            [-30, 33],
            [49, 116],
            [93, -3],
            [44, 13],
            [-29, 68],
            [83, 27],
            [119, -40],
            [30, 33],
            [-43, 51],
            [2, 67],
            [54, -19],
            [26, 41],
            [-15, 38],
            [69, 4],
            [46, 44],
            [63, -1],
            [19, 42],
            [-78, 35],
            [-6, 78],
            [10, 55],
            [86, 81],
            [86, -29],
            [67, 7],
            [27, -30],
            [45, 26],
            [-27, 77],
            [106, 56],
            [77, 5],
            [-16, 43],
            [23, 55],
            [51, -40],
            [61, 1],
            [80, 57],
            [77, 11],
            [41, 33],
            [32, 66],
            [97, 63],
            [60, 92],
            [7, 42],
            [181, 84],
            [89, 8],
            [148, 49],
            [90, 60],
            [56, 24],
            [51, 66],
            [61, 10],
            [141, 46],
            [108, 74],
            [147, 52],
            [97, -20],
            [17, -62]
        ],
        [
            [38420, 14957],
            [19, -14],
            [96, -3],
            [25, -67],
            [-25, -16],
            [-135, 10],
            [-49, 21],
            [-79, -25],
            [-23, -22],
            [-92, -31],
            [-39, 58],
            [37, 55],
            [106, 43],
            [140, 16],
            [19, -25]
        ],
        [[38256, 15010], [-62, -53], [-29, 3], [-80, 69], [39, 35], [131, -17], [1, -37]],
        [[36884, 15072], [-58, -16], [-15, 27], [32, 29], [41, -40]],
        [[36232, 15015], [-7, 21], [35, 60], [35, -26], [-63, -55]],
        [
            [36847, 15299],
            [15, -7],
            [134, 14],
            [43, -39],
            [-68, -71],
            [-31, 21],
            [-17, 51],
            [-212, -35],
            [-27, 50],
            [55, -1],
            [75, 56],
            [33, -39]
        ],
        [[37228, 15364], [-42, -4], [-42, 54], [82, -7], [2, -43]],
        [[37398, 15443], [-68, -25], [-44, 36], [43, 24], [69, -35]],
        [
            [37664, 15661],
            [93, -17],
            [11, -44],
            [-51, 5],
            [-49, -37],
            [-57, 8],
            [-10, -59],
            [-49, 28],
            [-39, -10],
            [-13, -49],
            [-26, -13],
            [-70, 43],
            [-42, 4],
            [76, 67],
            [8, 20],
            [88, 39],
            [41, -9],
            [89, 24]
        ],
        [[38532, 16046], [-41, -16], [-27, 99], [221, -25], [-12, -13], [-108, -16], [-33, -29]],
        [[41448, 16436], [67, -14], [32, -58], [-96, 3], [-22, 33], [-49, -19], [1, 52], [67, 3]],
        [[76944, 22827], [-40, 78], [5, 20], [62, -4], [8, -34], [-35, -60]],
        [
            [76914, 22799],
            [40, 2],
            [68, 73],
            [18, 2],
            [-6, -88],
            [-42, 3],
            [-10, -32],
            [43, -42],
            [38, -5],
            [58, 24],
            [64, 48],
            [45, 1],
            [35, 42],
            [50, -14],
            [22, -65],
            [-21, -71],
            [-58, -54],
            [-41, 46],
            [-77, -3],
            [-4, -23],
            [-47, -33],
            [33, -53],
            [63, -26],
            [4, 40],
            [53, -7],
            [19, -29],
            [-31, -46],
            [-41, -24],
            [-48, 11],
            [-53, 48],
            [-42, -27],
            [-80, 49],
            [-61, 19],
            [-21, -69],
            [-29, -29],
            [-55, 3],
            [-10, 27],
            [28, 115],
            [-17, 51],
            [7, 38],
            [-13, 30],
            [6, 54],
            [-15, 38],
            [21, 78],
            [-2, 43],
            [40, 87],
            [30, 20],
            [20, -61],
            [4, -53],
            [-32, -87],
            [6, -36],
            [41, -15]
        ],
        [[71559, 24287], [-43, 7], [-11, 30], [25, 26], [29, -63]],
        [[36510, 59680], [-10, -22], [-34, 9], [-9, 48], [22, 39], [40, -39], [-9, -35]],
        [[36500, 59980], [-29, 12], [-3, 66], [32, -29], [0, -49]],
        [[101043, 25984], [-15, -58], [-45, 39], [22, 56], [25, 28], [13, -65]],
        [[101067, 26071], [-26, 5], [-9, 48], [24, 15], [11, -68]],
        [[101274, 26367], [-25, 39], [15, 26], [30, -32], [-20, -33]],
        [
            [100329, 27439],
            [74, 10],
            [45, -49],
            [32, -4],
            [14, -22],
            [48, -32],
            [27, -35],
            [90, -52],
            [63, -26],
            [80, 12],
            [46, 36],
            [34, -17],
            [7, 28],
            [41, 37],
            [71, 5],
            [31, 15],
            [41, -25],
            [52, 87],
            [78, -15],
            [29, 51],
            [20, 0],
            [56, -42],
            [24, -51],
            [-2, -94],
            [8, -130],
            [-7, -65],
            [0, -195],
            [8, -63],
            [-4, -62],
            [-14, -35],
            [-23, 21],
            [-36, -59],
            [-13, -50],
            [-4, -98],
            [-27, -76],
            [-2, -136],
            [13, -81],
            [7, -109],
            [-60, -35],
            [-27, 54],
            [-16, 57],
            [39, 9],
            [8, 42],
            [-33, 32],
            [-37, 14],
            [-12, -18],
            [5, -53],
            [-30, -33],
            [-14, 78],
            [-19, -19],
            [-7, -48],
            [-20, -32],
            [-4, -81],
            [-23, -22],
            [-54, 55],
            [-3, -35],
            [28, -31],
            [-22, -53],
            [-16, -74],
            [-25, -61],
            [-54, 6],
            [-46, 52],
            [-112, -3],
            [-44, -19],
            [-15, 96],
            [35, 12],
            [5, 24],
            [-46, 19],
            [-32, -9],
            [-21, 27],
            [-60, 137],
            [-38, 40],
            [-67, 213],
            [-10, 50],
            [-12, 125],
            [54, -60],
            [19, -38],
            [25, 29],
            [-48, 71],
            [-39, 17],
            [8, 50],
            [-7, 49],
            [-56, 108],
            [-43, 101],
            [-43, 126],
            [-25, 127],
            [-15, 117],
            [19, 111],
            [3, 61],
            [31, -27],
            [69, -37]
        ],
        [[101315, 27591], [-15, -43], [-22, 39], [37, 4]],
        [[101342, 27707], [46, -70], [-37, -36], [-11, 35], [-67, -10], [-25, 27], [12, 26], [43, 0], [39, 28]],
        [
            [101242, 28013],
            [55, -101],
            [37, -26],
            [-3, -44],
            [11, -44],
            [-35, -50],
            [-33, -16],
            [-66, 138],
            [-16, 102],
            [29, 59],
            [21, -18]
        ],
        [
            [99985, 27813],
            [-16, 29],
            [3, 45],
            [-15, 45],
            [7, 92],
            [43, 88],
            [28, -32],
            [9, -82],
            [-4, -50],
            [11, -44],
            [-9, -38],
            [-57, -53]
        ],
        [[100466, 28795], [-47, -36], [-17, 16], [5, 40], [40, 3], [19, -23]],
        [
            [98031, 30254],
            [73, -13],
            [29, 20],
            [36, -16],
            [24, -54],
            [-34, -31],
            [-55, 22],
            [-50, -17],
            [-25, -72],
            [-44, -26],
            [-21, 30],
            [-53, 21],
            [-19, -31],
            [-38, 8],
            [-34, -13],
            [-49, 8],
            [-66, 80],
            [30, 78],
            [140, 48],
            [75, 40],
            [60, -7],
            [33, -29],
            [-12, -46]
        ],
        [[102951, 34883], [-26, -153], [-18, 26], [2, 89], [10, 56], [32, -18]],
        [[102922, 34950], [-21, 45], [1, 104], [27, 6], [-12, -91], [5, -64]],
        [[90495, 35655], [-8, -24], [-60, 174], [-17, 119], [23, 28], [35, -165], [11, -76], [16, -56]],
        [
            [102809, 35823],
            [-22, 12],
            [-9, 99],
            [7, 58],
            [19, 81],
            [-7, 61],
            [46, 68],
            [17, 83],
            [-17, 50],
            [-2, 38],
            [31, 15],
            [5, -99],
            [19, -35],
            [-3, -47],
            [-64, -251],
            [-18, -95],
            [-2, -38]
        ],
        [[102213, 37083], [29, -21], [-4, -37], [21, -70], [-18, -31], [-16, 20], [-47, 117], [8, 39], [27, -17]],
        [[91194, 38590], [-18, -43], [-25, 30], [39, 80], [4, -67]],
        [[101564, 38867], [-32, 4], [13, 73], [19, -77]],
        [[100710, 40016], [20, -94], [-13, -48], [-20, 19], [-14, 49], [-23, 40], [50, 34]],
        [[98606, 40638], [10, 70], [21, -29], [3, -29], [-34, -12]],
        [
            [98621, 40940],
            [-24, -49],
            [-24, -20],
            [-60, -25],
            [1, 65],
            [40, 88],
            [51, 16],
            [40, 25],
            [34, -67],
            [-42, -8],
            [-16, -25]
        ],
        [[97875, 41384], [-13, -26], [-33, 63], [20, 65], [17, -38], [9, -64]],
        [[97720, 41467], [-23, 1], [2, 47], [28, -1], [-7, -47]],
        [[94018, 41593], [-11, -15], [-24, 50], [11, 40], [27, -49], [-3, -26]],
        [[94204, 42052], [-20, -35], [-13, 28], [8, 56], [25, 9], [0, -58]],
        [
            [97758, 42484],
            [28, -21],
            [13, 51],
            [18, -43],
            [-36, -66],
            [-13, -70],
            [13, -48],
            [30, -22],
            [3, -53],
            [-41, 11],
            [-35, -4],
            [-58, 25],
            [-30, 3],
            [20, 57],
            [-5, 65],
            [4, 81],
            [34, 40],
            [15, 41],
            [22, 25],
            [18, -72]
        ],
        [[97611, 42473], [-35, 4], [3, 36], [25, 49], [13, -23], [6, -48], [-12, -18]],
        [[97642, 43712], [-22, 14], [56, 50], [7, -12], [-41, -52]],
        [
            [95828, 43669],
            [25, -13],
            [20, -64],
            [-32, -10],
            [-57, 35],
            [-58, -29],
            [-27, 21],
            [9, 59],
            [21, -9],
            [18, 22],
            [-3, 65],
            [-11, 35],
            [30, 66],
            [28, 13],
            [11, -47],
            [3, -50],
            [23, -94]
        ],
        [
            [95877, 43838],
            [41, -5],
            [50, 42],
            [34, -14],
            [36, 40],
            [24, 11],
            [15, 30],
            [16, -32],
            [36, -37],
            [12, -39],
            [20, -30],
            [-22, -40],
            [-3, -44],
            [-23, 3],
            [-28, -72],
            [-106, -120],
            [-94, 103],
            [-41, 69],
            [-28, 96],
            [-5, 79],
            [-11, 50],
            [18, 18],
            [59, -108]
        ],
        [[97723, 43836], [-12, 12], [27, 82], [19, 29], [7, 75], [15, 7], [-12, -102], [-44, -103]],
        [[96486, 43879], [-30, 77], [6, 27], [-10, 44], [34, 22], [1, -61], [10, -35], [-11, -74]],
        [
            [99754, 43516],
            [-8, -68],
            [-15, -52],
            [1, -75],
            [45, -53],
            [11, -56],
            [34, -79],
            [-1, -53],
            [19, -67],
            [16, -133],
            [6, -117],
            [18, -78],
            [-12, -166],
            [29, -124],
            [35, -214],
            [20, -30],
            [43, -34],
            [45, 38],
            [32, 52],
            [81, 39],
            [35, -69],
            [19, -77],
            [83, -101],
            [46, -65],
            [35, -37],
            [34, -48],
            [-12, -86],
            [13, -128],
            [-6, -83],
            [24, -126],
            [8, -100],
            [25, -98],
            [-2, -100],
            [-8, -95],
            [38, -122],
            [64, -142],
            [48, -18],
            [-3, -88],
            [46, -173],
            [23, -142],
            [-16, -191],
            [-16, -110],
            [3, -54],
            [59, -133],
            [34, -24],
            [-11, -160],
            [27, -76],
            [30, -57],
            [65, -60],
            [42, -27],
            [54, -12],
            [42, -76],
            [43, -12],
            [43, 20],
            [28, -53],
            [24, -83],
            [48, -82],
            [34, -14],
            [20, -42],
            [51, -16],
            [33, -32],
            [55, -73],
            [49, -12],
            [23, -20],
            [49, -81],
            [39, -107],
            [-25, -6],
            [-23, 14],
            [-14, -63],
            [32, -87],
            [84, -125],
            [45, -92],
            [11, -70],
            [12, -27],
            [15, -98],
            [39, -58],
            [1, -104],
            [20, -144],
            [22, -130],
            [34, -102],
            [36, 28],
            [47, -90],
            [10, 17],
            [-20, 119],
            [12, 69],
            [30, 11],
            [49, -117],
            [94, -103],
            [9, 97],
            [16, 10],
            [16, -29],
            [28, -88],
            [6, -182],
            [0, -153],
            [18, -157],
            [27, -41],
            [49, -91],
            [20, -49],
            [26, -23],
            [81, -105],
            [59, -14],
            [43, -47],
            [22, -44],
            [48, -163],
            [23, -58],
            [100, -114],
            [14, -90],
            [47, -133],
            [42, -40],
            [38, -88],
            [3, -143],
            [33, -102],
            [42, -52],
            [-25, -189],
            [24, -379],
            [-14, -118],
            [25, -117],
            [58, -203],
            [13, -72],
            [8, -84],
            [38, -107],
            [-2, -163],
            [14, -78],
            [-3, -101],
            [-44, -110],
            [-35, -134],
            [-1, -114],
            [-23, -221],
            [-15, -59],
            [-11, -93],
            [-48, -222],
            [-3, -88],
            [8, -104],
            [-8, -100],
            [-12, -68],
            [-12, -126],
            [-49, -196],
            [-70, -145],
            [-4, -110],
            [-23, -109],
            [-69, -95],
            [-26, -83],
            [-65, -35],
            [-43, -45],
            [-45, -110],
            [-19, -57],
            [-38, -82],
            [-16, -97],
            [-43, -33],
            [9, -66],
            [-13, -127],
            [-48, -43],
            [33, -14],
            [-83, -149],
            [-28, -113],
            [-15, -139],
            [-13, -80],
            [9, -57],
            [-35, -26],
            [8, -52],
            [-10, -24],
            [-38, -21],
            [-59, -206],
            [-56, -139],
            [-20, -160],
            [-21, -239],
            [-23, -97],
            [-8, -68],
            [-3, -131],
            [11, -99],
            [-8, -104],
            [-9, -47],
            [-38, -11],
            [-75, -101],
            [-26, -23],
            [-56, -17],
            [-110, 7],
            [-210, -23],
            [-41, -14],
            [-78, -44],
            [-76, -68],
            [-73, -91],
            [-166, -248],
            [-130, -27],
            [-44, 7],
            [-23, -15],
            [-1, -31],
            [37, -62],
            [28, 41],
            [12, -11],
            [6, -126],
            [-26, -44],
            [-75, 156],
            [-27, 17],
            [-42, -38],
            [-44, 131],
            [-57, 6],
            [-65, 68],
            [21, 66],
            [24, 13],
            [-20, 83],
            [-57, 4],
            [-31, -82],
            [-72, -65],
            [-74, 89],
            [59, -2],
            [48, 78],
            [17, 63],
            [-42, 78],
            [-29, 29],
            [-109, -99],
            [-44, -33],
            [60, -12],
            [23, -29],
            [-37, -41],
            [-66, -36],
            [-71, -64],
            [-89, -131],
            [-39, -38],
            [-45, -30],
            [-62, 35],
            [-35, 8],
            [-44, 54],
            [-75, 36],
            [-70, 72],
            [-49, 37],
            [-34, 8],
            [-48, -15],
            [-81, 64],
            [-62, 7],
            [-41, -65],
            [-52, 14],
            [-65, 106],
            [-63, 53],
            [-118, 27],
            [-73, 74],
            [-55, 142],
            [-104, 162],
            [-28, 59],
            [-14, 104],
            [33, 173],
            [3, 48],
            [-39, 162],
            [-56, 153],
            [-25, 49],
            [-69, 102],
            [-64, 77],
            [-21, 60],
            [30, -10],
            [35, 42],
            [16, -41],
            [18, -8],
            [1, 70],
            [10, 33],
            [-13, 29],
            [-28, 15],
            [-85, -79],
            [-13, -26],
            [-45, -8],
            [-64, -51],
            [-41, -2],
            [-63, 18],
            [21, 71],
            [46, 89],
            [34, 168],
            [-7, 146],
            [-16, 60],
            [-53, 120],
            [-54, 151],
            [-24, -92],
            [-29, -68],
            [-14, -151],
            [-56, -232],
            [-72, 7],
            [-57, -27],
            [-40, -32],
            [-55, -10],
            [-25, 8],
            [40, 181],
            [35, -5],
            [81, 6],
            [20, 83],
            [12, 93],
            [-11, 122],
            [11, 122],
            [48, 168],
            [40, 87],
            [47, 69],
            [-5, 66],
            [-15, 82],
            [-4, 63],
            [43, 60],
            [-25, 180],
            [-15, 54],
            [-25, 53],
            [3, -136],
            [-35, -87],
            [-44, -62],
            [-29, -58],
            [-27, -132],
            [-36, -111],
            [-33, -41],
            [-60, -26],
            [-93, -82],
            [-34, -49],
            [-29, -25],
            [-96, -223],
            [-71, -129],
            [19, -59],
            [14, -99],
            [-24, -10],
            [-39, 55],
            [-45, -42],
            [-51, 101],
            [-78, 99],
            [-31, 24],
            [27, 28],
            [50, -62],
            [22, 10],
            [-25, 114],
            [-18, 101],
            [-28, 131],
            [-11, 30],
            [-91, 156],
            [-13, 101],
            [-17, 65],
            [-23, 41],
            [-34, 36],
            [-95, 14],
            [-39, 104],
            [-23, 128],
            [40, 10],
            [6, 40],
            [-4, 62],
            [-94, 76],
            [-44, 80],
            [-38, 34],
            [-35, 14],
            [-105, -1],
            [-140, 127],
            [-34, 4],
            [-100, -39],
            [-34, 7],
            [-152, 173],
            [-101, 82],
            [-77, 30],
            [-61, -39],
            [-51, -22],
            [-201, 14],
            [-291, -45],
            [-74, -24],
            [-124, -103],
            [-148, -99],
            [-120, -48],
            [-110, -63],
            [-73, -18],
            [-94, -8],
            [-199, 30],
            [-67, -22],
            [-108, -116],
            [-32, -29],
            [-61, -32],
            [-157, -149],
            [-72, -33],
            [-47, -10],
            [-40, -31],
            [-36, -64],
            [-49, -177],
            [-31, -83],
            [-67, -134],
            [-44, -45],
            [-44, 6],
            [-49, -46],
            [-43, 49],
            [-35, 9],
            [-55, -4],
            [-193, -56],
            [-28, 66],
            [-35, 9],
            [-67, -3],
            [-100, 20],
            [-182, -25],
            [-88, -27],
            [-35, -24],
            [-64, 16],
            [-110, -22],
            [-67, -71],
            [-57, -149],
            [-63, -49],
            [-109, -13],
            [-116, -143],
            [-118, -140],
            [-84, -38],
            [-87, -24],
            [-135, 36],
            [-86, 4],
            [-108, 22],
            [-92, 68],
            [-72, 39],
            [-80, 150],
            [-50, 56],
            [-88, 68],
            [-47, -21],
            [-36, 48],
            [-1, 62],
            [-10, 52],
            [0, 138],
            [6, 161],
            [58, -72],
            [55, 2],
            [48, 61],
            [27, 89],
            [25, 100],
            [-4, 106],
            [-16, 187],
            [27, 55],
            [6, 93],
            [4, 286],
            [-13, 108],
            [-75, 219],
            [-49, 190],
            [-37, 85],
            [-30, 138],
            [-26, 192],
            [-8, 97],
            [-8, 179],
            [9, 101],
            [-4, 60],
            [-31, 162],
            [-71, 151],
            [-12, 56],
            [1, 59],
            [-17, 68],
            [-57, 139],
            [-58, 119],
            [-10, 58],
            [-10, 241],
            [-22, 110],
            [-99, 278],
            [-116, 240],
            [-31, 99],
            [35, 18],
            [-1, 46],
            [15, 11],
            [48, -184],
            [11, -68],
            [47, -21],
            [32, 53],
            [5, 94],
            [-24, 42],
            [-21, 18],
            [-37, 70],
            [-23, 112],
            [-36, 103],
            [0, 37],
            [17, 27],
            [27, -15],
            [54, -115],
            [-7, -145],
            [23, -38],
            [35, 74],
            [19, -129],
            [46, -75],
            [39, 58],
            [-4, 91],
            [8, 88],
            [-5, 65],
            [-68, 171],
            [-62, 211],
            [-37, 105],
            [-32, 159],
            [-47, 143],
            [2, 169],
            [21, 147],
            [19, 76],
            [63, 176],
            [3, 132],
            [9, 88],
            [0, 60],
            [-8, 57],
            [-27, 98],
            [35, 170],
            [50, 219],
            [51, 62],
            [6, -45],
            [-15, -152],
            [22, -79],
            [-7, -89],
            [50, 32],
            [23, 47],
            [69, 223],
            [33, 66],
            [46, 49],
            [94, 58],
            [91, 78],
            [43, 74],
            [54, 65],
            [38, 70],
            [36, 48],
            [184, 177],
            [31, 33],
            [89, -2],
            [44, 9],
            [48, -40],
            [35, -5],
            [85, 44],
            [46, 39],
            [79, 86],
            [34, 24],
            [171, 64],
            [109, 148],
            [78, -9],
            [70, -15],
            [56, 45],
            [133, 27],
            [73, 38],
            [137, 98],
            [37, 34],
            [56, 71],
            [49, 88],
            [48, 119],
            [42, 161],
            [48, 157],
            [15, 33],
            [53, 46],
            [79, 131],
            [26, 26],
            [5, 42],
            [-38, 38],
            [-14, 139],
            [-14, 95],
            [-1, 67],
            [5, 64],
            [31, 100],
            [53, 92],
            [28, 15],
            [23, 44],
            [38, 43],
            [16, 43],
            [44, 155],
            [17, -3],
            [32, -155],
            [21, -82],
            [38, -97],
            [36, -143],
            [44, -108],
            [12, 40],
            [14, 109],
            [-7, 76],
            [24, 33],
            [42, -58],
            [10, 4],
            [-1, 69],
            [14, 44],
            [-6, 30],
            [-24, -2],
            [-30, 80],
            [-22, 31],
            [-36, 99],
            [28, 11],
            [20, 72],
            [-12, 66],
            [12, 25],
            [25, -7],
            [40, -106],
            [18, 10],
            [14, 43],
            [26, 12],
            [26, -8],
            [17, -30],
            [36, -31],
            [70, -3],
            [51, 5],
            [-8, 26],
            [-66, 2],
            [-15, 20],
            [-5, 54],
            [14, 55],
            [44, -6],
            [10, 99],
            [12, 37],
            [-13, 27],
            [-32, -84],
            [-15, 68],
            [-22, 52],
            [4, 73],
            [13, 74],
            [38, -1],
            [40, 76],
            [1, 48],
            [17, -7],
            [69, -66],
            [14, -35],
            [14, 14],
            [3, 75],
            [-51, -1],
            [-21, 83],
            [23, 28],
            [20, 2],
            [14, 46],
            [51, -12],
            [51, -41],
            [9, 58],
            [-43, 39],
            [-2, 39],
            [-18, 45],
            [0, 44],
            [27, 37],
            [21, 51],
            [31, 1],
            [21, 30],
            [23, 11],
            [6, 114],
            [33, -7],
            [-7, -54],
            [17, -32],
            [25, -14],
            [10, -71],
            [12, -12],
            [18, 55],
            [23, 14],
            [-2, 69],
            [12, 86],
            [14, 18],
            [4, 39],
            [-18, 77],
            [20, 11],
            [20, -25],
            [23, -90],
            [20, 56],
            [25, 24],
            [51, -79],
            [34, 40],
            [31, 75],
            [-1, 93],
            [39, 25],
            [32, -19],
            [28, -50],
            [60, -38],
            [51, -54],
            [66, -91],
            [28, -58],
            [39, -103],
            [90, -127],
            [6, -22],
            [-23, -96],
            [-14, -92],
            [-3, -134],
            [13, 9],
            [13, 49],
            [23, 6],
            [-17, 62],
            [0, 33],
            [34, 59],
            [37, 38],
            [23, 46],
            [49, 4],
            [130, -58],
            [33, -58],
            [3, -71],
            [20, 20],
            [-2, 97],
            [11, 19],
            [59, -34],
            [33, -64],
            [26, -22],
            [-12, 90],
            [8, 42],
            [39, 3],
            [-3, 31],
            [-28, 38],
            [-18, 41],
            [29, 40],
            [-28, 9],
            [-38, 39],
            [-33, 54],
            [25, 100],
            [49, 98],
            [28, 32],
            [3, 33],
            [37, 194],
            [31, 40],
            [61, 30],
            [38, 81],
            [-39, 87],
            [11, 105],
            [46, 42],
            [25, 109],
            [17, 16],
            [50, 6],
            [-2, 87],
            [19, 47],
            [20, -11],
            [13, -38],
            [28, -35],
            [9, 19],
            [-7, 87],
            [46, 14],
            [-2, 72],
            [9, 13],
            [53, 7],
            [29, 46],
            [9, -64],
            [30, -37],
            [89, -1],
            [50, 26],
            [54, -27],
            [58, 52],
            [37, -29],
            [21, 35],
            [44, 37],
            [40, -8],
            [-25, 50],
            [0, 111],
            [13, 104],
            [-61, 88],
            [-61, 13],
            [-45, -18],
            [-18, 14],
            [-40, 70],
            [-38, 26],
            [-3, 17],
            [46, 51],
            [18, -9],
            [27, -47],
            [28, -13],
            [20, 56],
            [22, -11],
            [69, -80],
            [39, -77],
            [54, 64],
            [32, -9],
            [19, -26],
            [28, -94],
            [22, -47],
            [53, -12],
            [54, -49],
            [38, 2],
            [77, -11],
            [73, -60],
            [30, -38],
            [55, -25],
            [38, -5],
            [59, 43],
            [38, -66],
            [54, -51],
            [58, -15],
            [42, 51],
            [60, 38],
            [43, 59],
            [31, 27],
            [32, -48],
            [-58, -88],
            [13, -51],
            [60, 50],
            [21, -22],
            [7, -77],
            [16, -51],
            [55, -7],
            [21, 72],
            [-18, 97],
            [54, 100],
            [30, -3],
            [21, -98],
            [34, -52],
            [36, 4],
            [19, -14],
            [15, -59],
            [-126, -242],
            [-6, -27],
            [17, -44],
            [6, -52],
            [-41, -123],
            [-15, -6],
            [-36, 55],
            [-40, -24],
            [-74, -69],
            [1, -177],
            [19, -105],
            [-33, -191],
            [-43, -75],
            [-64, -166],
            [-41, -97],
            [15, -92],
            [24, -43],
            [93, -89],
            [42, -61],
            [73, -74],
            [27, -93],
            [90, -77],
            [37, 12],
            [-2, -83],
            [27, -33],
            [67, 9],
            [92, -105],
            [70, -56],
            [55, -37],
            [64, -136],
            [49, -78],
            [54, -57],
            [80, -39],
            [37, 6],
            [60, -46],
            [59, -22],
            [31, -64],
            [13, -85],
            [29, -90],
            [60, -29],
            [77, -89],
            [63, -40],
            [44, -50],
            [53, -1],
            [93, 44],
            [43, 45],
            [56, 72],
            [26, 124],
            [16, 99],
            [78, 206],
            [22, 101],
            [20, 136],
            [17, 84],
            [-6, 92],
            [18, 167],
            [54, 306],
            [-7, 114],
            [-24, 213],
            [22, 177],
            [-36, 126],
            [-2, 72],
            [19, 136],
            [34, 164],
            [-10, 176],
            [53, 92],
            [28, 0],
            [17, 22],
            [-24, 89],
            [-18, 7],
            [-36, 42],
            [4, 78],
            [36, 152],
            [20, 58],
            [28, -44],
            [-3, 88],
            [27, 147],
            [31, 200],
            [9, 183],
            [49, 34],
            [24, 46],
            [16, 53],
            [27, 0],
            [19, -23],
            [-17, -70],
            [53, -76],
            [17, -59],
            [18, -106],
            [5, -70],
            [-1, -112],
            [7, -105],
            [36, -55],
            [59, -19]
        ],
        [[99475, 44212], [-26, -32], [-17, 17], [-2, 51], [21, 27], [24, -63]],
        [[99494, 44498], [-18, -34], [-19, 10], [0, 48], [25, 5], [12, -29]],
        [[99441, 44519], [-21, 18], [16, 39], [13, -18], [-8, -39]],
        [[60792, 77278], [-28, -87], [1, -31], [33, -105], [54, -107]],
        [
            [60852, 76948],
            [-18, -24],
            [-18, -70],
            [11, -72],
            [-98, -12],
            [-31, 29],
            [-30, 5],
            [-36, -51],
            [64, -26],
            [11, -41],
            [-17, -49],
            [-58, -45],
            [9, -53],
            [-14, -27],
            [23, -57],
            [-12, -64],
            [-62, -20],
            [-49, -60]
        ],
        [
            [60527, 76311],
            [-36, -35],
            [-6, -69],
            [-59, 19],
            [-41, -7],
            [-60, -38],
            [-69, 7],
            [-66, -10],
            [-50, -25],
            [-26, -45],
            [-78, -46],
            [-124, 25],
            [-83, 27],
            [-41, 6]
        ],
        [
            [59788, 76120],
            [-65, 19],
            [-99, 10],
            [-213, 55],
            [-28, 17],
            [-72, 130],
            [-7, 28],
            [12, 54],
            [-122, -54],
            [-76, 7],
            [-88, -13],
            [-34, -22],
            [-33, -77],
            [-31, -16],
            [-51, 14],
            [-22, 29],
            [-73, 11]
        ],
        [[58786, 76312], [-12, 55], [-20, 12], [-52, -69], [-57, 13], [-37, 29], [-10, 39], [-81, 28]],
        [[58517, 76419], [9, 28], [-26, 91]],
        [[58500, 76538], [25, 67], [6, 42], [-22, 25]],
        [[58509, 76672], [43, 18]],
        [
            [58552, 76690],
            [17, 18],
            [88, -57],
            [19, -52],
            [32, -9],
            [-5, -48],
            [40, 20],
            [28, 58],
            [8, 69],
            [70, 3],
            [67, -15],
            [33, -68],
            [98, 15],
            [29, 35],
            [100, 53],
            [145, 20],
            [3, 50],
            [52, -11],
            [37, -29],
            [62, 18],
            [27, -16],
            [3, -42],
            [30, -33],
            [42, -15],
            [10, 56],
            [-5, 67],
            [-41, 13],
            [17, 47],
            [0, 47],
            [-60, 103],
            [17, 47],
            [82, 64],
            [75, 31],
            [26, 35],
            [24, 105],
            [59, -33],
            [34, 36],
            [9, 100]
        ],
        [
            [59824, 77372],
            [53, -41],
            [19, -50],
            [43, -14],
            [55, -1],
            [38, 27],
            [62, -14],
            [5, 40],
            [35, 57],
            [32, -1],
            [15, 118],
            [29, 8],
            [41, -28],
            [34, 15],
            [29, -10],
            [92, -54],
            [38, 3],
            [72, -62],
            [95, -8],
            [35, 34],
            [38, -10],
            [34, -27],
            [53, -17],
            [21, -59]
        ],
        [[69793, 71858], [-166, 53], [-30, 19], [-69, 105], [-35, 33], [-22, 61], [-22, 34], [-56, 126]],
        [[69393, 72289], [-15, 30]],
        [
            [70552, 73512],
            [29, -32],
            [49, -87],
            [87, -183],
            [21, -104],
            [16, -50],
            [71, -126],
            [31, -47],
            [68, -73],
            [66, -4],
            [59, -41],
            [38, -51],
            [19, -74],
            [-69, 24],
            [-69, -4],
            [-77, -37],
            [-37, -31],
            [-23, -59],
            [-19, -138],
            [-28, -129],
            [1, -60],
            [11, -85],
            [-29, -36],
            [-21, -118],
            [-58, 34],
            [-16, -31],
            [-11, -65],
            [-23, -82],
            [6, -211]
        ],
        [
            [70644, 71612],
            [-72, -21],
            [-14, 7],
            [-54, 98],
            [-34, 15],
            [-31, 62],
            [-56, 53],
            [-10, 36],
            [18, 28],
            [59, 25],
            [16, 22],
            [-6, 45],
            [-46, 40],
            [-6, 39],
            [9, 40],
            [58, 48],
            [-13, 27],
            [-88, 132],
            [-32, 0],
            [-37, -20],
            [-180, -171],
            [-62, -90],
            [-42, -18],
            [-92, -136],
            [-20, 1]
        ],
        [
            [69450, 73204],
            [86, 88],
            [44, -13],
            [90, -49],
            [-6, -27],
            [30, -36],
            [74, -32],
            [43, 17],
            [88, -71],
            [24, 10],
            [28, 40],
            [15, 70],
            [-17, 32],
            [-97, 92],
            [-15, 52],
            [-23, 31],
            [6, 44],
            [31, 12],
            [40, 74]
        ],
        [
            [69891, 73538],
            [33, -11],
            [4, -33],
            [43, 11],
            [18, -10],
            [56, -80],
            [25, -46],
            [41, -40],
            [19, -33],
            [17, -79],
            [18, -18],
            [62, -30],
            [84, -16],
            [22, 7],
            [60, 137],
            [74, 48],
            [29, 32],
            [56, 135]
        ],
        [
            [64990, 48843],
            [-40, -135],
            [16, -29],
            [-16, -73],
            [3, -28],
            [25, -24],
            [60, -33],
            [22, -4],
            [10, -74],
            [-7, -88],
            [-33, -19],
            [-22, -32],
            [6, -29],
            [-63, -95],
            [-15, -79],
            [-34, -67],
            [-37, -131],
            [-62, -124],
            [-71, -82],
            [-22, 0]
        ],
        [[64710, 47697], [-5, 50], [-33, 91], [-49, 193], [-9, 108], [-1, 152], [-37, 27]],
        [[64576, 48318], [4, 160], [-64, 142], [-1, 44]],
        [
            [64515, 48664],
            [15, 66],
            [42, -10],
            [30, -29],
            [17, -66],
            [12, -10],
            [95, 8],
            [53, 43],
            [13, 94],
            [6, 117],
            [13, 1],
            [37, -42],
            [15, -1],
            [29, 37],
            [54, 19],
            [22, -35],
            [22, -13]
        ],
        [[57317, 78492], [42, 19], [19, -32]],
        [[57378, 78479], [32, -1]],
        [[57410, 78478], [74, -86], [-10, -54], [43, -26], [7, -76], [-58, -47], [-19, -62]],
        [[57447, 78127], [-43, 26], [-34, -47], [-38, -91], [-5, -62], [48, -91], [-28, -60]],
        [
            [57347, 77802],
            [-88, -15],
            [-70, 93],
            [-84, 56],
            [-43, 6],
            [-8, 70],
            [-16, 25],
            [22, 99],
            [-48, -22],
            [-15, -53],
            [-35, -23],
            [-54, -9],
            [-59, 9],
            [-13, 22],
            [17, 52],
            [-17, 28],
            [12, 57],
            [-40, 42],
            [-92, 12],
            [-25, -10],
            [-12, 74],
            [-109, 41],
            [-12, 73],
            [-40, 65],
            [-82, -37],
            [-75, 91],
            [1, 44],
            [-23, 79]
        ],
        [[56339, 78671], [134, 94], [121, 63]],
        [[56594, 78828], [9, -48], [28, -28], [34, 25], [99, -44], [83, 56], [17, 44]],
        [
            [56864, 78833],
            [55, -11],
            [-6, 34],
            [37, 26],
            [40, -30],
            [37, 39],
            [29, -49],
            [65, 28],
            [13, -59],
            [35, -38],
            [30, -11],
            [61, 9],
            [31, -43],
            [44, -16],
            [23, -25],
            [-28, -108],
            [-30, -49],
            [17, -38]
        ],
        [
            [56669, 56703],
            [-32, -110],
            [-1, -58],
            [71, -176],
            [12, -174],
            [23, -64],
            [1, -26],
            [-16, -95],
            [-32, -5],
            [-23, -43],
            [-9, -46],
            [22, -60],
            [-14, -87],
            [-14, -54],
            [-24, -31],
            [-23, -7],
            [-24, -34],
            [1, -62],
            [-33, -56],
            [-26, -64],
            [3, -73],
            [-11, -74],
            [-21, -58],
            [-83, -20],
            [-13, -148],
            [-3, -190],
            [-6, -39],
            [2, -55],
            [-7, -223],
            [6, -26],
            [4, -117],
            [20, -78],
            [-11, -46],
            [2, -182],
            [-11, -49],
            [4, -71],
            [13, -79],
            [-12, -64],
            [-9, -127]
        ],
        [[56395, 53732], [-130, -23], [-144, -37], [-61, -25]],
        [
            [56060, 53647],
            [-3, 19],
            [51, 25],
            [-10, 73],
            [-52, 146],
            [8, 28],
            [-6, 77],
            [-16, 65],
            [29, 3],
            [0, 406],
            [0, 304],
            [-6, 160],
            [-2, 274],
            [-10, 49],
            [-44, 82],
            [-12, 43],
            [-2, 56],
            [-10, 59],
            [-1, 220],
            [-4, 19],
            [-170, 202],
            [-5, 15],
            [8, 181],
            [10, 23],
            [24, 135]
        ],
        [
            [55837, 56311],
            [27, 47],
            [23, -11],
            [26, 108],
            [53, 24],
            [34, 85],
            [41, 1],
            [12, -27],
            [80, 24],
            [38, -14],
            [77, 117],
            [17, 35],
            [32, 115]
        ],
        [
            [56297, 56815],
            [7, 57],
            [-14, 124],
            [32, 22],
            [55, 19],
            [48, 49],
            [23, -9],
            [84, -139],
            [65, -133],
            [27, -16],
            [26, -36],
            [19, -50]
        ],
        [
            [55627, 58495],
            [-17, -231],
            [68, -140],
            [-9, -59],
            [23, -93],
            [58, -150],
            [40, -16],
            [47, -36],
            [24, -33],
            [13, -47],
            [56, -61],
            [-9, -16],
            [-56, 20],
            [-5, -109],
            [4, -71],
            [34, -23],
            [125, -181],
            [20, -23],
            [69, -12],
            [51, 52],
            [37, 4],
            [26, -43],
            [16, -55],
            [-2, -70],
            [-42, -19],
            [7, -56],
            [32, -79],
            [60, -133]
        ],
        [[55837, 56311], [-79, -6], [-29, -15], [-20, 20], [-100, 43], [-71, 26]],
        [
            [55538, 56379],
            [-71, 28],
            [-14, -44],
            [-26, 3],
            [-19, -47],
            [-49, -45],
            [-16, 34],
            [-62, -2],
            [-43, 14],
            [-59, -7],
            [-94, 14],
            [-19, -14],
            [-195, -3],
            [-161, -3],
            [-24, 6],
            [-24, -150],
            [-2, -76],
            [11, -47],
            [28, -59],
            [-10, -44],
            [13, -23],
            [-2, -111],
            [10, -97],
            [1, -62],
            [-10, -29],
            [5, -49],
            [21, -98]
        ],
        [
            [54727, 55468],
            [-21, -32],
            [-16, 1],
            [-26, 60],
            [-27, 85],
            [-33, 37],
            [-20, 54],
            [-19, 25],
            [-21, -7],
            [-90, 24],
            [-65, -4],
            [-26, -13],
            [-121, -84],
            [-20, -55],
            [-23, 2],
            [-37, 42],
            [-30, -6],
            [-30, 24],
            [-29, 47],
            [-48, 50],
            [-7, 65],
            [-33, 108],
            [-50, 44],
            [-37, -3],
            [-43, 62]
        ],
        [
            [53855, 55994],
            [13, 78],
            [7, 115],
            [-10, 151],
            [44, 49],
            [15, 42],
            [15, 95],
            [6, 82],
            [-18, 89],
            [0, 81],
            [18, 35],
            [38, 43],
            [96, 36],
            [30, 24],
            [35, 44],
            [12, 40],
            [37, 62],
            [2, 136],
            [-19, 51],
            [79, 67],
            [0, 48],
            [-32, 134],
            [55, 104],
            [31, 43],
            [32, 11],
            [29, -16],
            [86, -100],
            [32, 1],
            [52, 47],
            [11, 67],
            [-1, 98],
            [7, 46],
            [15, 8],
            [50, -19],
            [37, 22],
            [-3, 60],
            [16, 92],
            [30, 68],
            [59, 86],
            [40, 26],
            [106, -59],
            [18, 15],
            [25, 146],
            [64, 16],
            [34, 23],
            [50, 55],
            [90, 76],
            [48, 32],
            [89, 127],
            [69, 17],
            [25, -10],
            [15, -26],
            [53, 26],
            [140, -83]
        ],
        [[83941, 62173], [-19, -2], [-10, 114], [24, 8], [9, -63], [-4, -57]],
        [[83694, 62545], [-32, -39], [10, 231], [25, -86], [6, -46], [-9, -60]],
        [[83820, 62661], [-28, -2], [-17, 54], [8, 69], [14, -13], [23, -108]],
        [
            [83579, 62497],
            [-53, -19],
            [-28, 6],
            [51, 146],
            [-9, 119],
            [-26, 43],
            [-20, 121],
            [29, 16],
            [24, -28],
            [20, -97],
            [40, -86],
            [-1, -53],
            [-11, -128],
            [-16, -40]
        ],
        [
            [84134, 62435],
            [6, -284],
            [12, -90],
            [-29, 7],
            [-64, 67],
            [-38, -45],
            [-9, -36],
            [11, -101],
            [15, -29],
            [19, -150]
        ],
        [
            [84057, 61774],
            [-83, 214],
            [-14, 190],
            [-1, 94],
            [-29, 110],
            [-20, 153],
            [-16, 79],
            [-32, 115],
            [-51, 113],
            [-14, 50],
            [-23, 0],
            [-29, -34],
            [-30, -52],
            [-20, -16],
            [-64, -9],
            [-37, 69],
            [-52, 169],
            [-7, 39],
            [7, 99],
            [-13, 95],
            [0, 50],
            [-16, 3],
            [-2, -65],
            [-46, 6],
            [-5, -36],
            [41, -12],
            [21, -44],
            [1, -74],
            [-40, -45],
            [4, -37],
            [23, -46],
            [-28, -13],
            [-8, -72],
            [19, -65],
            [-3, -26],
            [33, -85],
            [6, -41],
            [-8, -58],
            [-72, -117],
            [-21, -83],
            [-18, -39],
            [-22, -7],
            [-27, 39],
            [5, 72],
            [18, 68],
            [-59, -65],
            [-18, 101],
            [-26, -123],
            [-17, -35],
            [-27, -24],
            [-31, -61],
            [-6, 121],
            [-30, -91],
            [-30, -56],
            [-37, 1],
            [-43, 84],
            [-4, 79],
            [-10, 44]
        ],
        [
            [83046, 62500],
            [0, 101],
            [-40, 199],
            [-6, 118],
            [-16, 110],
            [24, 81],
            [-62, 38],
            [-7, 22],
            [12, 80],
            [-45, 92],
            [-9, 40],
            [41, 183],
            [10, 128],
            [-3, 24],
            [-25, 29],
            [-44, 11],
            [-32, 24],
            [-33, 50],
            [-20, -10],
            [-24, 14],
            [-38, 79],
            [7, 47],
            [32, 113],
            [51, -18],
            [18, 44],
            [26, 126],
            [90, -10],
            [44, 14],
            [16, 54],
            [-38, 41],
            [-16, 70],
            [-54, 3],
            [-43, 44],
            [-28, 69],
            [-34, 51],
            [-33, 12],
            [-19, 43],
            [20, 111],
            [90, 157],
            [-1, 38],
            [-28, 37],
            [22, 38],
            [31, -30],
            [50, -92],
            [1, -34],
            [45, -22],
            [43, -1],
            [-14, 69],
            [9, 21],
            [35, -20],
            [11, -38],
            [2, -59],
            [24, -54],
            [32, -38],
            [55, -30],
            [25, 12],
            [13, 37],
            [-6, 34],
            [15, 46],
            [28, -25],
            [35, -128],
            [-8, -56],
            [8, -156],
            [-9, -103],
            [6, -39],
            [135, -67],
            [58, -16],
            [90, 1],
            [173, 11],
            [58, -20],
            [176, 15],
            [48, -33],
            [52, -53],
            [29, -40],
            [-8, -53],
            [-18, 0],
            [-41, 26],
            [-16, -117],
            [-42, -173],
            [-34, -10],
            [-23, -90],
            [-33, 8],
            [-32, -11],
            [-44, -56],
            [-49, 2],
            [-9, -42],
            [-32, -55],
            [-23, -144],
            [2, -45],
            [27, -115],
            [19, -151],
            [17, 53],
            [21, 1],
            [23, -93],
            [33, -30],
            [23, 14],
            [25, 56],
            [-6, 101],
            [11, 42],
            [45, 80],
            [-2, 101],
            [35, -5],
            [26, 24],
            [18, -25],
            [19, 4],
            [27, -200],
            [2, -142],
            [6, -78],
            [10, -18],
            [30, -118],
            [13, -154],
            [9, -202],
            [4, -39]
        ],
        [
            [64383, 74571],
            [-7, -135],
            [-30, -62],
            [-45, 21],
            [-58, -18],
            [-30, -71],
            [-33, -45],
            [-10, -93],
            [-2, -151],
            [-42, -24],
            [-83, -133],
            [69, -66],
            [35, -79],
            [50, -89],
            [10, -44]
        ],
        [
            [64207, 73582],
            [-42, 10],
            [-24, -17],
            [-44, 3],
            [-38, -23],
            [-19, 15],
            [-56, 73],
            [-87, -11],
            [-39, -37],
            [-83, -15],
            [-32, -78],
            [-47, -13],
            [-12, -48]
        ],
        [
            [63684, 73441],
            [-37, 15],
            [-29, -10],
            [-13, -29],
            [14, -36],
            [14, -97],
            [-6, -27],
            [-66, -42],
            [-43, 11],
            [-79, -17],
            [-85, -32],
            [-37, 41],
            [-88, 43],
            [-23, -21],
            [-55, 48],
            [-24, 62],
            [-40, -17],
            [-102, 3],
            [-7, -33],
            [-47, -7],
            [-76, -39],
            [-62, 7],
            [-60, -8],
            [-26, -35],
            [-74, 8]
        ],
        [[62633, 73229], [11, 150], [17, 62], [-20, 33], [-33, 122], [-12, 17], [-66, 45], [-26, 33], [-48, 83]],
        [
            [62456, 73774],
            [24, 9],
            [32, 62],
            [-27, 105],
            [9, 119],
            [28, 20],
            [46, 3],
            [29, 57],
            [44, 62],
            [11, 51],
            [-37, 35],
            [-28, 57],
            [-66, 56],
            [-49, 141],
            [-9, 86],
            [17, 81],
            [55, 38],
            [9, 67],
            [24, 24]
        ],
        [
            [62568, 74847],
            [100, -89],
            [-14, -34],
            [-36, -39],
            [0, -46],
            [16, -17],
            [94, 22],
            [96, -11],
            [128, -38],
            [85, -13],
            [63, 18],
            [225, -61],
            [105, -8],
            [58, 23],
            [41, 30],
            [35, 58],
            [87, 76],
            [85, 43],
            [110, 35],
            [74, 12],
            [105, -82],
            [76, -13],
            [20, -23],
            [45, 17],
            [52, -92],
            [53, -27],
            [62, -18],
            [50, 1]
        ],
        [[71180, 64613], [-19, -28], [-24, 74], [7, 52], [-12, 73], [33, 5], [16, -42], [-1, -134]],
        [
            [33019, 61997],
            [-10, -41],
            [-33, -78],
            [-73, -19],
            [-80, -4],
            [-8, 40],
            [2, 53],
            [29, 12],
            [20, 36],
            [30, 7],
            [38, -26],
            [20, -1],
            [31, 28],
            [24, 61],
            [14, -8],
            [-4, -60]
        ],
        [[33053, 62173], [-41, -28], [-4, 32], [21, 26], [24, -30]],
        [[33014, 62687], [65, -24], [26, -33], [-11, -20], [-33, 39], [-68, 4], [-5, 49], [26, -15]],
        [
            [32655, 62567],
            [-17, 12],
            [41, 49],
            [41, 70],
            [18, 16],
            [7, 50],
            [-19, 38],
            [7, 45],
            [23, -20],
            [13, -79],
            [-43, -99],
            [-36, -31],
            [-35, -51]
        ],
        [[32701, 62851], [-13, -32], [-54, 25], [-13, 52], [29, 4], [14, -29], [37, -20]],
        [
            [32459, 62946],
            [-41, 97],
            [-49, 28],
            [-28, 26],
            [25, 22],
            [-5, 74],
            [-47, 141],
            [29, -24],
            [13, -60],
            [20, -59],
            [14, -102],
            [39, -35],
            [28, -49],
            [2, -59]
        ],
        [[32205, 63256], [-36, 12], [-54, 67], [-25, 6], [8, 39], [19, -14], [60, -88], [28, -22]],
        [[32586, 63601], [-25, -61], [-13, 6], [8, 75], [23, 12], [7, -32]],
        [
            [31589, 63702],
            [-30, -48],
            [22, -25],
            [21, 54],
            [17, -44],
            [13, -149],
            [-17, -73],
            [-61, 8],
            [-1, 61],
            [-9, 12],
            [-15, 87],
            [-19, 29],
            [-26, 71],
            [92, 38],
            [13, -21]
        ],
        [
            [32315, 63674],
            [-19, -22],
            [-31, -11],
            [18, 70],
            [-26, 36],
            [-51, 145],
            [-26, 36],
            [28, 14],
            [42, -141],
            [65, -127]
        ],
        [[31685, 64128], [-35, -11], [-20, 36], [61, 14], [-6, -39]],
        [
            [31563, 63957],
            [-1, -136],
            [-42, -52],
            [-31, -19],
            [-19, -27],
            [-10, 43],
            [-35, 57],
            [-54, 43],
            [-22, 47],
            [60, 14],
            [-18, 56],
            [36, 91],
            [8, 59],
            [-17, 94],
            [15, 6],
            [40, -33],
            [18, -32],
            [1, -45],
            [17, -34],
            [24, -83],
            [30, -49]
        ],
        [
            [31901, 64392],
            [51, -63],
            [43, -23],
            [67, -107],
            [4, -26],
            [-8, -116],
            [-20, -114],
            [-11, 40],
            [11, 102],
            [16, 50],
            [-2, 52],
            [-65, 108],
            [-40, 16],
            [-38, 50],
            [-49, -3],
            [22, 77],
            [19, -43]
        ],
        [
            [31332, 65084],
            [37, -17],
            [32, 14],
            [55, -5],
            [45, 17],
            [6, -45],
            [-95, -15],
            [-88, -43],
            [-47, -30],
            [-40, 13],
            [0, 30],
            [27, 9],
            [24, 34],
            [11, 77],
            [33, -39]
        ],
        [
            [31723, 64625],
            [-33, 51],
            [-22, 16],
            [34, 39],
            [14, 34],
            [0, 74],
            [13, 112],
            [-10, 40],
            [-28, 32],
            [-56, 127],
            [19, -6],
            [25, -49],
            [31, -33],
            [3, -28],
            [59, -60],
            [9, -110],
            [-40, -52],
            [-8, -159],
            [-10, -28]
        ],
        [
            [61426, 75199],
            [71, 25],
            [37, -31],
            [-20, -90],
            [-43, -95],
            [-10, -93],
            [10, -32],
            [58, -43],
            [75, -101],
            [-10, -32],
            [-76, 4],
            [-14, -28],
            [71, -134],
            [-12, -79],
            [-28, 18],
            [-32, -5],
            [-19, -29]
        ],
        [
            [61484, 74454],
            [-35, -9],
            [-33, 14],
            [-10, -25],
            [29, -78],
            [-57, -6],
            [-54, -65],
            [-17, -59],
            [1, -54],
            [-42, -9],
            [-14, -24],
            [7, -106],
            [24, -58],
            [-2, -30],
            [-31, -34]
        ],
        [[61250, 73911], [-41, 22], [-143, 137], [-12, 32], [-41, -3]],
        [[61013, 74099], [-26, 23]],
        [
            [60987, 74122],
            [23, 24],
            [-10, 35],
            [-69, 87],
            [-34, 59],
            [-6, 78],
            [-58, 40],
            [-115, 146],
            [-38, 75],
            [-65, 82],
            [-51, 86],
            [-26, 144],
            [-77, 117],
            [-44, 46],
            [0, 51],
            [16, 180],
            [31, 20],
            [43, -14],
            [40, -66],
            [42, -35],
            [73, 116],
            [80, -11],
            [40, 44],
            [63, -58],
            [62, -5],
            [68, -23],
            [45, 20],
            [38, -45],
            [19, 0],
            [37, 36],
            [44, -13],
            [45, 9],
            [63, -27],
            [54, -5],
            [26, -28],
            [13, -63],
            [15, -17],
            [52, -8]
        ],
        [
            [64248, 81485],
            [42, -49],
            [33, 18],
            [53, 2],
            [71, -83],
            [48, 33],
            [43, 11],
            [89, -46],
            [7, -32],
            [-14, -54],
            [40, -56],
            [62, 48],
            [78, 42],
            [92, 0],
            [68, -33],
            [53, -67],
            [86, -54],
            [-2, -96],
            [-26, -66],
            [44, -79],
            [6, -48],
            [-45, -76],
            [-10, -73],
            [100, -75],
            [10, -21],
            [-25, -67],
            [34, -21],
            [35, -90],
            [33, -54],
            [120, -78],
            [14, -31],
            [-26, -106],
            [138, -16],
            [77, -49],
            [-8, -42],
            [14, -40],
            [66, -55],
            [6, -62],
            [-72, -37],
            [-14, -33],
            [-87, -67],
            [-91, 9],
            [-31, 43],
            [-25, 9],
            [-77, -2],
            [-49, -100],
            [85, -122],
            [9, -37],
            [-12, -55],
            [19, -56],
            [-3, -123],
            [35, -51],
            [23, -67]
        ],
        [
            [65364, 79231],
            [-129, 3],
            [-40, -31],
            [-42, 15],
            [-31, -17],
            [-69, -85],
            [-28, -45],
            [-41, -121],
            [21, -70],
            [10, -65],
            [-28, -50],
            [-65, 34],
            [-7, 41],
            [-46, 44],
            [-188, -24],
            [-63, -29],
            [-15, 17],
            [-50, 113],
            [-106, -59],
            [-19, -43],
            [-26, 13],
            [-15, 48],
            [-128, 36],
            [-54, -27],
            [-47, 19],
            [-36, -62],
            [-16, 50],
            [-27, 17],
            [-78, -4],
            [-24, 10],
            [-40, 78],
            [-58, 1],
            [-154, 33],
            [-163, 56],
            [-203, 13],
            [-62, -4],
            [-62, -17],
            [-156, -18],
            [-25, -52],
            [-47, -61],
            [-55, -44],
            [-26, 21],
            [-49, 10],
            [-30, -17],
            [-1, -52]
        ],
        [
            [62846, 78906],
            [-21, 56],
            [2, 51],
            [25, 56],
            [-6, 39],
            [14, 89],
            [-17, 35],
            [-43, 37],
            [-80, 49],
            [2, 45],
            [64, 100],
            [21, 19],
            [113, 63],
            [21, 59],
            [-8, 144],
            [-31, 136],
            [-58, 183],
            [-36, 189]
        ],
        [
            [62808, 80256],
            [77, -15],
            [43, 13],
            [98, 8],
            [40, -32],
            [93, 49],
            [46, -3],
            [17, 80],
            [14, 15],
            [54, -7],
            [41, 45],
            [59, 21],
            [28, 23],
            [35, -85],
            [54, 10],
            [5, 35],
            [-19, 40],
            [-48, 22],
            [23, 72],
            [32, 58],
            [-1, 85],
            [42, 113],
            [72, 24],
            [26, 22],
            [36, 76],
            [95, -5],
            [15, 41],
            [39, 39],
            [-98, 39],
            [34, 113],
            [8, 68]
        ],
        [[63768, 81220], [71, 23], [40, 58], [31, 10], [79, -15], [82, -3], [21, 63], [78, 92], [42, 32], [36, 5]],
        [[28412, 60176], [-1, 42], [17, 86], [16, -8], [-32, -120]],
        [[28121, 59041], [-68, 6], [-38, -4], [8, 353], [9, 426], [7, 292]],
        [[28039, 60114], [8, 87], [26, 16], [47, -47], [28, 28], [20, 59], [48, 122], [20, 87], [19, 17], [51, -2]],
        [
            [28306, 60481],
            [-17, -64],
            [68, -4],
            [14, -70],
            [-4, -58],
            [-34, -153],
            [-4, -53],
            [-16, -79],
            [21, -52],
            [-19, -69],
            [-9, -112],
            [10, -128],
            [-16, -184],
            [-28, -80],
            [-17, -31],
            [-31, -80],
            [-41, -24],
            [-57, -128],
            [-10, -34],
            [5, -37]
        ],
        [[34268, 41126], [-47, 10]],
        [[34221, 41136], [9, 76], [27, -14], [21, -36], [-10, -36]],
        [
            [37608, 38938],
            [6, 92],
            [-13, 101],
            [-281, 297],
            [-283, -7],
            [-272, -101],
            [-192, -71],
            [-76, -22],
            [-49, -228],
            [-29, -80],
            [-82, -203],
            [0, -281],
            [-62, -356],
            [-47, -267],
            [-7, -28]
        ],
        [
            [34819, 37456],
            [-119, -39],
            [-66, 7],
            [-26, 32],
            [-1, 183],
            [-21, 89],
            [-1, 73],
            [-11, 82],
            [-27, 41],
            [-11, 128],
            [-23, 75],
            [-3, 178],
            [-74, 196],
            [-30, 14],
            [-11, 41],
            [2, 72],
            [19, 60],
            [-76, 86],
            [-4, 45],
            [22, 38],
            [-14, 47],
            [2, 87],
            [39, 14],
            [12, 43],
            [-5, 62],
            [-37, 75],
            [72, 161],
            [-9, 28],
            [-39, 48],
            [-43, 75],
            [-30, 38],
            [-35, 70],
            [-3, 86],
            [-15, 88],
            [-20, 208],
            [-16, 77],
            [16, 53],
            [-68, 59],
            [-14, 96],
            [-42, 85],
            [-5, 63]
        ],
        [[34104, 40420], [-3, 65], [-32, 53], [0, 53], [37, 53], [20, 9], [18, 49], [56, 129], [55, 71], [-5, 61]],
        [
            [34250, 40963],
            [30, -28],
            [26, 20],
            [-15, 68],
            [36, 10],
            [29, 45],
            [33, 14],
            [-2, 35],
            [-73, 27],
            [-18, 59],
            [29, 62],
            [-11, 14],
            [-51, 12],
            [-13, 73],
            [-20, 17],
            [-27, 48],
            [-34, 32],
            [-20, 62]
        ],
        [
            [34149, 41533],
            [20, 62],
            [39, 91],
            [-4, 21],
            [-44, 89],
            [-14, 42],
            [5, 94],
            [25, 27],
            [13, 83],
            [36, 71],
            [33, 52],
            [2, 62],
            [39, 37],
            [-4, 58],
            [-25, 66],
            [-15, 110],
            [-16, 54],
            [17, 49],
            [11, 55],
            [3, 63],
            [-2, 280],
            [35, 70],
            [33, 38],
            [-1, 44],
            [24, 59],
            [-112, 349],
            [-97, 306],
            [-67, 210]
        ],
        [
            [34083, 44075],
            [108, -3],
            [118, -30],
            [19, -19],
            [18, -44],
            [32, 8],
            [70, 50],
            [40, 48],
            [33, 83],
            [27, 45],
            [25, 16],
            [48, 7],
            [35, -12],
            [43, 99],
            [51, 65],
            [42, 40],
            [28, 4],
            [25, 23],
            [117, 164],
            [48, 42],
            [54, 18],
            [42, 23],
            [105, 23],
            [67, 9],
            [22, -22],
            [24, 6],
            [20, 37],
            [30, 11],
            [18, -44],
            [9, -46],
            [-5, -86],
            [8, -67],
            [-4, -59],
            [-39, -109],
            [0, -77],
            [32, -170],
            [3, -74],
            [-14, -48],
            [-6, -76],
            [15, -38],
            [6, -69],
            [12, -40],
            [24, -39],
            [9, -37],
            [4, -66],
            [22, 13],
            [17, -49],
            [14, -81],
            [50, -31],
            [67, -97],
            [31, -26],
            [28, -105],
            [51, -24],
            [98, -26],
            [46, 33],
            [31, -4],
            [32, -23],
            [74, -90],
            [30, -16],
            [41, 32],
            [15, -10],
            [16, -76],
            [77, -107],
            [24, 2],
            [103, -77],
            [55, -1],
            [18, -14],
            [7, -46],
            [46, -92],
            [48, -66],
            [66, 0],
            [20, -9],
            [134, 29],
            [50, -40],
            [126, -128],
            [26, -82],
            [6, -46],
            [-22, -92],
            [5, -44],
            [19, -39],
            [18, -132],
            [12, -27],
            [8, -262],
            [-95, -5],
            [16, -25],
            [89, -188],
            [20, -440],
            [229, -15],
            [277, -18],
            [59, 24],
            [-1, -115],
            [-37, -89],
            [3, -145],
            [13, -95],
            [7, -85],
            [15, -27],
            [44, -45],
            [66, -84],
            [26, -11],
            [23, 12],
            [13, -34],
            [3, -55],
            [60, -251],
            [28, -52],
            [-25, -36],
            [-64, -354],
            [16, -2],
            [4, -70],
            [-25, -21],
            [-103, -370],
            [84, -131],
            [-8, -23],
            [-42, -19],
            [-22, -54],
            [-20, -7]
        ],
        [[40594, 34699], [-22, -25], [4, 132], [24, 77], [27, -8], [-10, -64], [-27, -79], [4, -33]],
        [[40563, 35460], [-25, 63], [39, 66], [13, -27], [-27, -102]],
        [[41589, 36861], [-47, -25], [-12, 21], [46, 94], [22, -54], [-9, -36]],
        [[41938, 37278], [-28, -28], [-31, -12], [-12, 23], [36, 55], [35, -38]],
        [[43551, 42669], [-22, -28], [-14, 43], [13, 26], [22, -1], [1, -40]],
        [[43601, 42878], [-14, 24], [54, 73], [4, -38], [-44, -59]],
        [[41824, 48542], [-20, 9], [-1, 77], [27, 38], [-6, -124]],
        [[41706, 49446], [-26, -40], [-9, 24], [5, 44], [28, -5], [2, -23]],
        [
            [39561, 49382],
            [-33, -11],
            [42, 140],
            [38, 64],
            [0, 129],
            [41, 115],
            [38, 47],
            [52, 13],
            [29, -70],
            [-36, -198],
            [-10, -1],
            [-48, -104],
            [-53, -73],
            [-60, -51]
        ],
        [
            [40241, 50053],
            [70, 8],
            [27, 26],
            [61, 3],
            [102, -29],
            [61, -9],
            [60, -37],
            [4, -31],
            [-26, -101],
            [-10, -73],
            [-21, -11],
            [8, -65],
            [-26, -103],
            [-25, -67],
            [-42, -67],
            [11, -56],
            [-9, -35],
            [-29, -51],
            [-34, -18],
            [-15, 5],
            [-26, 51],
            [-10, -81],
            [-9, -23],
            [-34, 3],
            [-50, 46],
            [-6, -66],
            [-19, -46],
            [-50, -24],
            [-18, -19],
            [-32, 15],
            [-31, 30],
            [-30, -22],
            [-71, -4],
            [-33, -25],
            [-19, 7],
            [-30, 50],
            [-22, 102],
            [-26, 154],
            [9, 63],
            [41, -12],
            [1, 42],
            [-36, -3],
            [-22, 38],
            [-4, 58],
            [7, 145],
            [16, 35],
            [8, 122],
            [15, 51],
            [57, 64],
            [66, 23],
            [191, -63]
        ],
        [[39925, 50108], [-85, -109], [-34, 56], [13, 67], [47, 31], [54, -4], [5, -41]],
        [[40298, 50118], [-82, -17], [-37, 28], [36, 60], [65, 39], [31, -15], [6, -63], [-19, -32]],
        [
            [40207, 50331],
            [13, -30],
            [-44, -116],
            [-50, -20],
            [-35, 34],
            [-53, -2],
            [-16, 8],
            [-2, 51],
            [22, 54],
            [45, -3],
            [77, 44],
            [43, -20]
        ],
        [
            [39995, 50259],
            [-6, -82],
            [-55, 34],
            [4, 84],
            [26, 24],
            [23, 44],
            [8, 55],
            [0, 74],
            [23, 13],
            [6, -180],
            [-29, -66]
        ],
        [[40079, 50400], [-33, -19], [-7, 88], [10, 38], [42, 11], [17, 19], [6, -64], [-35, -73]],
        [[40034, 51262], [-31, -26], [-17, 10], [-17, 67], [6, 55], [22, 18], [24, -11], [15, -90], [-2, -23]],
        [
            [38125, 51264],
            [143, -56],
            [28, 25],
            [4, 85],
            [-66, 145],
            [34, 52],
            [8, 59],
            [18, 10],
            [63, -61],
            [107, 19],
            [13, 27],
            [48, 32],
            [36, 1],
            [20, 25],
            [25, -53],
            [23, -33],
            [40, 1],
            [7, -45],
            [25, -19]
        ],
        [
            [38701, 51478],
            [32, -45],
            [68, -51],
            [50, -18],
            [57, 62],
            [55, 68],
            [11, -26],
            [69, -31],
            [54, 49],
            [32, -76],
            [16, 4],
            [66, -15],
            [29, 46],
            [53, 54],
            [43, 117],
            [2, 41],
            [30, 121],
            [12, 22],
            [19, 83],
            [9, 72],
            [30, 50],
            [21, 52],
            [50, 157],
            [3, 31],
            [50, 94],
            [19, 68],
            [35, 39]
        ],
        [
            [39616, 52446],
            [29, 96],
            [4, 43],
            [26, 1],
            [42, -49],
            [33, -73],
            [44, -236],
            [7, -217],
            [18, -114],
            [52, -237],
            [12, -97],
            [16, -57],
            [24, -137],
            [15, -15],
            [11, -59],
            [36, -94],
            [83, -24],
            [41, -31],
            [31, -39],
            [23, -134],
            [-8, -84],
            [3, -60],
            [-46, -61],
            [-8, -21],
            [-69, -100],
            [-15, -47],
            [-37, -64],
            [-36, -120],
            [-54, -111],
            [-19, -28],
            [-46, -23],
            [-42, -90],
            [-56, -30],
            [-5, -53],
            [-32, -119],
            [-29, -65],
            [-18, -22],
            [-45, -119],
            [-6, -52],
            [0, -91],
            [-30, -55],
            [-32, -35],
            [-4, -78],
            [-26, -44],
            [-65, 20],
            [-100, -84],
            [-34, -21],
            [109, -5],
            [35, -44],
            [77, 29],
            [93, 108],
            [36, 22],
            [72, 73],
            [29, 48],
            [54, 59],
            [11, 25],
            [30, 27],
            [18, -56],
            [-25, -43],
            [23, -62],
            [18, -147],
            [33, -86],
            [-4, -65],
            [89, -142],
            [44, 52],
            [44, 36],
            [37, 15],
            [86, -53],
            [125, 108],
            [-26, -133],
            [-19, -123],
            [-15, -49],
            [-14, -134],
            [-26, -76],
            [35, 33],
            [21, 52],
            [15, 89],
            [61, 238],
            [17, 22],
            [51, 27],
            [86, 191],
            [34, -1],
            [43, -70],
            [5, 52],
            [30, 22],
            [-32, 25],
            [-8, 63],
            [22, 53],
            [-13, 46],
            [44, 59],
            [-3, 44],
            [35, 74],
            [23, 19],
            [4, 32],
            [26, 18],
            [22, -36],
            [24, 42],
            [23, 17],
            [24, -26],
            [24, -5],
            [29, 28],
            [30, -7],
            [19, 31],
            [40, -11],
            [44, -56],
            [56, 2],
            [16, -21],
            [26, 0],
            [12, -31],
            [39, -45],
            [8, -30],
            [61, -33],
            [62, -1],
            [2, -38],
            [23, -11],
            [29, 9],
            [23, -47],
            [59, -35],
            [42, -54],
            [27, 9],
            [30, -14],
            [33, -118],
            [7, -83],
            [15, 11],
            [30, 106],
            [33, 22],
            [48, -68],
            [40, -76],
            [43, -11],
            [33, -112],
            [2, -60],
            [-37, -97],
            [-30, -21],
            [29, -60],
            [26, 79],
            [44, 35],
            [14, -56],
            [2, -54],
            [-42, -22],
            [0, -42],
            [-22, -52],
            [-15, -105],
            [-25, -212],
            [30, 2],
            [57, 108],
            [18, 115],
            [22, 114],
            [25, 35],
            [38, -12],
            [-2, -59],
            [-35, -87],
            [10, -30],
            [55, 93],
            [25, 33],
            [21, -7],
            [42, 43],
            [84, 9],
            [7, 49],
            [17, 21],
            [46, -5],
            [90, -44],
            [33, -36],
            [48, -34],
            [25, -40],
            [107, -73],
            [77, -8],
            [38, 34],
            [47, -35],
            [26, -39],
            [49, -21],
            [50, -11],
            [38, 28],
            [99, 9],
            [123, 41],
            [74, -10],
            [84, -26],
            [59, -70],
            [51, -39],
            [30, -39],
            [49, -40],
            [104, -107],
            [37, -62],
            [64, -85],
            [65, -36],
            [36, -88],
            [27, -40],
            [69, -150],
            [78, -105],
            [53, -104],
            [100, -68],
            [39, -111],
            [68, -14],
            [29, -16],
            [35, -47],
            [48, -26],
            [63, 7],
            [70, -5],
            [56, 22],
            [133, -42],
            [21, -20],
            [27, -48],
            [49, -176],
            [29, -195],
            [14, -150],
            [33, -116],
            [18, -218],
            [15, -69],
            [2, -53],
            [13, -12],
            [8, -147],
            [-3, -59],
            [-13, -77],
            [1, -57],
            [-7, -63],
            [13, -69],
            [0, -56],
            [-17, -67],
            [-23, -176],
            [-59, -291],
            [-57, -168],
            [-79, -173],
            [-52, -90],
            [-20, -9],
            [-17, -72],
            [-52, -127],
            [-52, -83],
            [-54, -145],
            [-74, -59],
            [-41, -45],
            [-52, -83],
            [-48, -131],
            [-27, -7],
            [0, -67],
            [-41, -105],
            [-13, 14],
            [-25, -24],
            [8, -58],
            [-18, -87],
            [-68, -249],
            [-83, -209],
            [-19, -65],
            [-68, -141],
            [-50, -68],
            [-30, 6],
            [-8, 108],
            [-51, 77],
            [-16, -69],
            [-14, -19],
            [8, -70],
            [-22, -70],
            [-1, -63],
            [-60, -122],
            [-18, -124],
            [17, 16],
            [14, -31],
            [-16, -80],
            [2, -130],
            [8, -61],
            [20, 39],
            [-36, -348],
            [14, -157],
            [6, -177],
            [16, -173],
            [19, -167],
            [-24, -180],
            [-32, -177],
            [-19, -145],
            [-12, -156],
            [-12, -75],
            [-4, -77],
            [14, -182],
            [5, -34],
            [-38, -81],
            [-42, -40],
            [-23, -39],
            [-50, -146],
            [-28, -216],
            [0, -115],
            [13, -241],
            [-10, -98],
            [-16, -66],
            [-19, -43],
            [-48, -52],
            [-44, -126],
            [-19, -132],
            [-29, -49],
            [-6, -74],
            [-24, -80],
            [-62, -119],
            [-40, -35],
            [-20, -34],
            [-12, -69],
            [-39, -116],
            [-28, -149],
            [7, -51],
            [11, -180],
            [-4, -44],
            [-38, -48],
            [-142, -88],
            [-37, -37],
            [-85, -151],
            [-2, -87],
            [14, -29],
            [-31, -89],
            [-25, 4],
            [-142, 0],
            [-76, -18],
            [-40, 3],
            [-38, 36],
            [-6, 29],
            [11, 45],
            [-7, 26],
            [-44, -13],
            [-4, -27],
            [15, -80],
            [-9, -29],
            [-45, -4],
            [-51, -27],
            [-62, -11],
            [-50, -20],
            [0, 37],
            [33, -6],
            [35, 21],
            [-8, 24],
            [-50, 31],
            [-56, -19],
            [-31, -37],
            [-68, 3],
            [-83, -28],
            [-14, -29],
            [2, -55],
            [32, -38],
            [-30, -34],
            [-87, -26],
            [-82, -108],
            [-34, -14],
            [-30, -47],
            [-13, -66],
            [-19, -1],
            [-43, 22],
            [-55, 1],
            [-39, -18],
            [-204, -175],
            [-73, -70],
            [-83, -144],
            [-140, -160],
            [-74, -96],
            [-14, -25],
            [-17, -95],
            [-29, -38],
            [-55, -101],
            [5, 60],
            [-67, 21],
            [-17, -22],
            [10, -51],
            [-15, -22],
            [-52, 3],
            [-15, -30],
            [57, -17],
            [33, -42],
            [-45, -122],
            [-21, -33],
            [12, -34],
            [-14, -136],
            [-39, -50],
            [30, -76],
            [-9, -166],
            [20, -97],
            [6, -101],
            [13, -77],
            [-13, -38],
            [7, -60],
            [-22, -104],
            [12, -149],
            [-5, -139],
            [-9, -74],
            [-13, -57],
            [-32, -74],
            [-1, -74],
            [-69, -69],
            [-77, -96],
            [-70, -114],
            [-76, -160],
            [-89, -244],
            [-82, -349],
            [-99, -263],
            [-40, -95],
            [-53, -106],
            [-71, -124],
            [-95, -123],
            [-105, -111],
            [-37, -49],
            [-37, -70],
            [-9, 29],
            [8, 47],
            [-7, 82],
            [21, 9],
            [32, -30],
            [28, 40],
            [38, 12],
            [72, 122],
            [54, 44],
            [30, 77],
            [4, 123],
            [17, 21],
            [39, -7],
            [12, 106],
            [53, 50],
            [25, 61],
            [-9, 155],
            [42, -7],
            [11, 68],
            [-6, 35],
            [-25, 10],
            [-88, -77],
            [-29, 3],
            [-5, 61],
            [-43, 27],
            [-21, 84],
            [-15, 14],
            [5, -116],
            [38, -67],
            [-27, -58],
            [-13, -69],
            [1, -89],
            [-23, 43],
            [-6, -96],
            [-25, -37],
            [-8, -36],
            [7, -42],
            [-14, -29],
            [-65, -78],
            [-64, -53],
            [-15, -25],
            [-16, -120],
            [-29, -53],
            [-23, -107],
            [8, -113],
            [13, -44],
            [-46, -87],
            [-20, -65],
            [-52, -242],
            [-44, -147],
            [-34, -71],
            [-49, -76],
            [-139, -190]
        ],
        [[39086, 31367], [-46, 36], [-4, 73]],
        [
            [39036, 31476],
            [24, 9],
            [1, 101],
            [13, 107],
            [18, 35],
            [38, 22],
            [30, 117],
            [36, 26],
            [37, -62],
            [38, 19],
            [48, 133],
            [7, 77],
            [-30, 85],
            [0, 61],
            [-28, -14],
            [-9, -71],
            [-46, -43],
            [-22, -73],
            [-43, -41]
        ],
        [
            [39148, 31964],
            [-19, 26],
            [-41, 25],
            [-39, 43],
            [-34, 56],
            [-50, 193],
            [-49, 58],
            [-92, 54],
            [-47, 62],
            [-67, 145],
            [-95, 52],
            [-43, 63],
            [-17, -20],
            [-51, 49],
            [-34, 101],
            [-59, 94],
            [-22, 10],
            [-11, -37],
            [-65, -81],
            [-40, -5],
            [-4, 49],
            [6, 86],
            [-55, 116],
            [-71, 101],
            [-97, 146],
            [-35, 44],
            [-61, -1],
            [-28, -20],
            [-29, -77],
            [-52, 1],
            [-52, 11],
            [-17, 41]
        ],
        [
            [38702, 35920],
            [1, 80],
            [43, 119],
            [11, 55],
            [-6, 31],
            [13, 111],
            [31, 189],
            [10, 124],
            [-12, 99],
            [24, 45],
            [-40, 42],
            [-21, 39],
            [-57, 50],
            [-60, -43],
            [-51, -48],
            [-65, -23],
            [-53, 14],
            [-15, 22],
            [-9, 48],
            [-5, 100],
            [-24, 59],
            [6, 92],
            [-11, 54],
            [-2, 92],
            [-13, 33],
            [-16, 159],
            [11, 77],
            [-26, 44],
            [-13, 45],
            [-3, 57],
            [-29, 57],
            [-44, 15],
            [-61, 0],
            [-18, 9],
            [-32, 48],
            [-14, 48],
            [-39, -6],
            [-34, -74],
            [-44, -14],
            [-50, -6],
            [-93, 43],
            [-28, -11],
            [-74, 18],
            [-47, 46],
            [-31, -24],
            [-41, 19],
            [-10, 35],
            [17, 75],
            [-5, 33],
            [10, 85],
            [-9, 115],
            [22, 77],
            [-4, 50],
            [18, 74],
            [-1, 75],
            [-24, 124],
            [-2, 48],
            [-20, 18],
            [-7, 107],
            [-37, 96],
            [-11, 72]
        ],
        [
            [34083, 44075],
            [-29, -2],
            [-89, 14],
            [-80, -66],
            [-53, -6],
            [-44, 62],
            [-33, -35],
            [0, 237],
            [1, 425],
            [22, 66],
            [-10, 47],
            [2, 43],
            [-14, 36],
            [-76, -106],
            [-27, -54],
            [-44, -48],
            [-38, -64],
            [-31, -12],
            [-83, -10],
            [-177, 1],
            [2, 89],
            [-27, 39],
            [-1, 48],
            [-16, 74],
            [-19, 25],
            [-70, 33],
            [-65, 23],
            [-122, -1],
            [74, 163],
            [-1, 71],
            [-71, 152],
            [-30, 37],
            [-17, 48],
            [-1, 49],
            [-58, 75],
            [0, 26],
            [-19, 59],
            [0, 26],
            [-23, 70],
            [-28, 47],
            [13, 34],
            [4, 52],
            [-32, 24],
            [-55, 102],
            [13, 28],
            [-2, 71],
            [67, 24],
            [8, 41],
            [-25, 101],
            [14, 98],
            [20, 40],
            [60, 86],
            [54, 58],
            [26, 6],
            [32, 55],
            [0, 68],
            [-31, 137],
            [23, 92],
            [56, 166],
            [29, 286],
            [58, 31],
            [71, 92],
            [36, 64],
            [29, 21],
            [85, 97],
            [43, 40],
            [99, 19],
            [26, 18],
            [38, 7],
            [25, 20],
            [28, 1],
            [52, 20],
            [54, 99],
            [24, 8],
            [59, -5],
            [39, 10],
            [27, -54],
            [24, -30],
            [34, 8],
            [24, -26],
            [25, 18],
            [2, 36]
        ],
        [
            [33964, 47819],
            [5, 20],
            [30, 301],
            [56, 554],
            [36, 358],
            [23, 225],
            [13, 111],
            [11, 127],
            [-15, 57],
            [0, 52],
            [-29, 46],
            [-24, 109],
            [9, 46],
            [-6, 48],
            [-17, 39],
            [-25, 17],
            [-54, 75],
            [-38, 68],
            [-8, 32],
            [0, 87],
            [5, 313],
            [77, 16],
            [41, 32],
            [11, -3],
            [51, 39],
            [35, -44],
            [23, -13],
            [34, 4],
            [3, 128],
            [-29, 84],
            [-32, 27],
            [-80, 5],
            [-30, -7],
            [-25, 10],
            [-16, -10],
            [1, 362],
            [61, 17],
            [21, 17],
            [81, -27],
            [198, 0],
            [155, -1],
            [-25, 70],
            [20, 79],
            [19, -17],
            [30, -94],
            [14, -20],
            [35, 5],
            [18, 16],
            [64, 137],
            [34, 40],
            [30, 5],
            [15, -17],
            [72, -213],
            [9, -49],
            [-1, -226],
            [9, -18],
            [58, 25]
        ],
        [
            [34917, 50863],
            [138, -224],
            [40, -39],
            [74, 19],
            [20, 14],
            [57, 71],
            [40, 25],
            [36, -32],
            [13, -46],
            [-12, -53],
            [2, -33],
            [25, 1],
            [35, 99],
            [30, 36],
            [49, 98],
            [60, 62],
            [29, 21],
            [26, -2],
            [20, 22],
            [56, 89],
            [56, 1],
            [59, 92],
            [24, 159],
            [18, 27],
            [41, 13],
            [50, 40],
            [35, 40],
            [32, 9],
            [22, 48],
            [6, 66],
            [-4, 40],
            [-61, 12],
            [-105, 10],
            [-31, 17],
            [-7, 24],
            [12, 82],
            [-9, 72],
            [-32, 113],
            [-24, 112],
            [-3, 78],
            [3, 135],
            [-17, 42],
            [-90, 132],
            [-31, 63],
            [-11, 43],
            [-35, 80],
            [29, 23],
            [45, -75],
            [99, 1],
            [20, -8],
            [21, -33],
            [15, -52],
            [16, -25],
            [114, 6],
            [39, -26],
            [45, 27],
            [27, -11],
            [49, -92],
            [28, -39],
            [23, -52],
            [35, 0],
            [28, 44],
            [8, 149],
            [9, 43],
            [31, 14],
            [42, 54],
            [20, 10],
            [79, -33],
            [103, 55],
            [82, 51],
            [23, 64],
            [35, 17],
            [27, 47],
            [54, -7],
            [31, 17],
            [30, 84],
            [51, 49],
            [35, 66],
            [7, 57],
            [-21, 95],
            [-21, 21]
        ],
        [
            [36811, 53082],
            [28, 10],
            [23, -16],
            [74, 4],
            [29, 33],
            [31, -11],
            [20, -53],
            [27, -34],
            [-13, -191],
            [-29, -79],
            [4, -49],
            [46, -5],
            [40, -14],
            [40, -53],
            [-11, -86],
            [37, -114],
            [21, -50],
            [-16, -63],
            [-21, -38],
            [-2, -29],
            [-54, -63],
            [7, -133],
            [-13, -36],
            [-31, -164],
            [-7, -167],
            [33, -182],
            [41, -50],
            [4, -85],
            [-4, -123],
            [27, -33],
            [1, -53],
            [40, -26],
            [94, -181],
            [81, -40],
            [33, -56],
            [23, 3],
            [32, 40],
            [53, 2],
            [8, 36],
            [-6, 50],
            [34, 24],
            [17, 59],
            [52, -22],
            [9, -17],
            [33, 2],
            [16, 71],
            [58, 29],
            [62, 2],
            [29, 39],
            [27, 75],
            [30, 31],
            [13, -3],
            [48, 31],
            [25, -43],
            [62, -31],
            [68, 23],
            [16, -9],
            [25, 20]
        ],
        [[37196, 57475], [-36, 11], [-10, 27], [-1, 86], [17, 8], [32, -68], [18, -24], [-20, -40]],
        [[91064, 52913], [35, 0]],
        [[91099, 52913], [27, -83], [12, -65], [4, -99], [15, -42], [-25, -19], [-43, 24], [-25, 168], [0, 116]],
        [
            [91064, 52913],
            [-75, -81],
            [-11, -20],
            [13, -142],
            [16, -39],
            [-18, -63],
            [-2, -63],
            [-16, -40],
            [-36, -40],
            [-30, 50],
            [-29, 79],
            [-29, 4],
            [-31, 120],
            [-49, 64]
        ],
        [[90767, 52742], [73, 8], [75, 65], [61, 88], [31, 36], [47, 42], [17, -3], [-7, -65]],
        [
            [83843, 65659],
            [-16, -83],
            [4, -30],
            [46, -64],
            [77, 5],
            [28, -89],
            [-16, -43],
            [-12, -64],
            [24, -69],
            [1, -34],
            [-23, -33],
            [-48, -1],
            [-53, -29],
            [-47, 3],
            [-28, 33],
            [-44, -43],
            [-47, 8],
            [-121, -18],
            [-56, 14],
            [-66, 52],
            [-43, -23],
            [-26, -52],
            [-111, -30],
            [-47, 10],
            [0, 24],
            [-86, 48],
            [-57, -18],
            [-89, 81],
            [-7, 58],
            [-30, 61],
            [7, 24],
            [40, 55]
        ],
        [
            [82997, 65412],
            [17, 82],
            [48, 72],
            [18, 66],
            [116, 221],
            [66, 45],
            [21, 38],
            [50, 31],
            [39, -5],
            [75, -33],
            [-5, -69],
            [6, -22],
            [112, -5],
            [59, -25],
            [35, -32],
            [18, 3],
            [46, 54],
            [14, 4],
            [29, -32],
            [74, -39],
            [11, -16],
            [-3, -91]
        ],
        [
            [63356, 40260],
            [-11, -68],
            [18, -70],
            [32, -56],
            [32, -117],
            [21, -51],
            [63, -115],
            [16, -83],
            [39, -79],
            [4, -79],
            [40, -161],
            [27, -94],
            [22, -17],
            [72, -100],
            [63, -81],
            [128, -90],
            [40, -51],
            [11, -48],
            [7, -137],
            [106, -3],
            [23, -26],
            [2, -132],
            [-11, -166],
            [7, -26],
            [47, -84],
            [20, -54],
            [20, -83],
            [22, -37],
            [42, -9],
            [108, -34],
            [67, -32],
            [89, -57],
            [-6, -72],
            [8, -44],
            [20, -26],
            [40, -8],
            [39, -64]
        ],
        [
            [64623, 37806],
            [-72, -10],
            [-36, -37],
            [-21, -65],
            [-33, -48],
            [-44, -30],
            [-47, -21],
            [-50, -11],
            [-53, -56],
            [-56, -101],
            [-29, -63],
            [-14, -48],
            [-24, -19],
            [-29, -63],
            [-39, -18],
            [-9, -40],
            [-20, -25],
            [-30, -8],
            [-27, -23],
            [-22, -36],
            [-29, -20],
            [-50, -100],
            [-46, -299],
            [-68, -86],
            [-68, -122],
            [-82, -32],
            [-67, -42],
            [-10, -23],
            [-9, -82],
            [-46, -205],
            [-13, -75],
            [-24, -94],
            [-43, -61],
            [-71, -23],
            [-66, 1],
            [-40, -33],
            [-38, -2],
            [-129, 41],
            [-42, 62],
            [-69, 4],
            [-23, 14],
            [-69, 93],
            [-46, 50],
            [-41, 29],
            [-38, 14],
            [-75, -32],
            [-22, -26],
            [-23, -49],
            [-73, -342],
            [-29, -59],
            [-24, -23],
            [-78, -95],
            [-39, -106],
            [-25, -31],
            [-54, -24],
            [-30, -72],
            [-28, -26],
            [-59, 12],
            [-119, -11],
            [-61, 24],
            [-41, -22],
            [-17, 15],
            [-13, 44],
            [-7, 90],
            [2, 77],
            [58, 155],
            [-6, 139],
            [-57, 237],
            [-42, 150],
            [-40, 107],
            [-112, 141]
        ],
        [
            [61727, 36366],
            [0, 294],
            [-1, 320],
            [0, 320],
            [0, 319],
            [0, 295],
            [306, 0],
            [3, 22],
            [0, 554],
            [-1, 455],
            [0, 227],
            [0, 455],
            [-1, 340],
            [80, 7],
            [241, 60],
            [138, 46],
            [198, 59],
            [36, 6],
            [25, -16],
            [50, -113],
            [31, -87],
            [6, -37],
            [37, 16],
            [61, 109],
            [71, 84],
            [71, 56],
            [53, -42],
            [81, 105],
            [36, 24],
            [95, 19],
            [13, -3]
        ],
        [
            [62616, 56270],
            [32, -94],
            [90, -164],
            [17, -39],
            [72, -199],
            [31, -116],
            [3, -63],
            [-10, -206],
            [-8, -44],
            [-40, -82],
            [7, -68],
            [19, -27],
            [-4, -71],
            [14, -28],
            [29, -19],
            [75, -13],
            [70, -24]
        ],
        [
            [63013, 55013],
            [23, -32],
            [-13, -82],
            [9, -52],
            [25, -43],
            [51, -29],
            [87, -27],
            [36, -30],
            [47, -96],
            [60, -87],
            [14, -47],
            [-2, -42],
            [-18, -51],
            [3, -21],
            [59, -104],
            [57, -58],
            [99, -92],
            [46, -61],
            [41, -97],
            [59, -81],
            [-16, -101],
            [14, -61],
            [21, -40],
            [8, -50],
            [20, -64],
            [25, -29],
            [41, -10],
            [67, -80],
            [43, -44],
            [19, -30],
            [21, -58],
            [14, -184],
            [45, -100]
        ],
        [
            [64018, 53030],
            [-89, 49],
            [-29, -7],
            [-47, -61],
            [-14, -7],
            [-59, 12],
            [-142, 48],
            [-142, 63],
            [-58, 16],
            [-38, -31],
            [-47, -129],
            [-57, -32],
            [-27, 8],
            [-65, -29],
            [-102, 44],
            [-36, -8],
            [-28, -23],
            [-117, -76],
            [-52, -26],
            [-81, -60],
            [-33, 0],
            [-60, 41],
            [-38, 4],
            [-40, -11],
            [-34, -43],
            [-42, -112],
            [-35, -133],
            [-26, -40],
            [-158, 66],
            [-69, 15],
            [-46, -20],
            [-57, 37],
            [-38, -5],
            [-32, 17],
            [-52, 45],
            [-50, 19],
            [-45, -7],
            [-28, 15],
            [-22, 44],
            [-29, 81],
            [-51, 80],
            [-69, 64],
            [-44, 48],
            [-17, 33],
            [-37, 18],
            [-57, 3],
            [-55, -32],
            [-79, -100],
            [-73, -205],
            [-41, -78],
            [-32, -21],
            [-8, -49],
            [16, -79],
            [4, -90],
            [-11, -154],
            [4, -111]
        ],
        [
            [61304, 52121],
            [-18, 17],
            [-24, 63],
            [-48, -23],
            [-49, -46],
            [-15, 29],
            [-71, 2],
            [-23, 16],
            [-114, 56],
            [-43, -37],
            [-91, -34],
            [-102, -12],
            [-32, -40],
            [-23, -142],
            [-11, -174],
            [3, -36],
            [-88, -313]
        ],
        [
            [60555, 51447],
            [-15, 52],
            [-9, 61],
            [-3, 70],
            [-12, 97],
            [8, 37],
            [-6, 39],
            [-49, 104],
            [-40, 18],
            [-98, 183],
            [-102, 207],
            [-29, 105],
            [25, 5],
            [7, 25],
            [-16, 53],
            [-7, 67],
            [-13, 41],
            [-39, 63],
            [-38, 49],
            [-19, 59],
            [-15, 223],
            [-6, 64],
            [-24, 56],
            [6, 89],
            [10, 31],
            [0, 206],
            [-12, 29],
            [-23, 0],
            [-22, 68],
            [3, 27],
            [22, 42],
            [70, 65],
            [38, 154],
            [37, 106],
            [16, 22],
            [38, 156],
            [15, 79],
            [12, 32],
            [41, 53],
            [32, 92]
        ],
        [
            [60338, 54376],
            [112, -27],
            [35, 18],
            [23, 36],
            [107, 62],
            [8, 50],
            [37, 49],
            [20, -65],
            [24, -52],
            [36, -56],
            [33, 46],
            [70, 38],
            [40, 62],
            [48, 40],
            [28, 14],
            [48, 41],
            [35, -5],
            [55, 7],
            [92, 19],
            [67, 6],
            [42, 17],
            [13, 59],
            [35, 43],
            [49, 89],
            [63, 140],
            [-14, 34],
            [-55, 67],
            [1, 30],
            [49, 58],
            [30, 12],
            [79, -2],
            [82, 5],
            [88, 30],
            [37, 32],
            [83, -3],
            [101, 123],
            [32, 32],
            [66, 129],
            [7, 43],
            [79, 146],
            [27, -3],
            [14, 18],
            [40, 115],
            [33, 17],
            [28, 71],
            [-5, 116],
            [20, 38],
            [59, 53],
            [24, 48],
            [35, 1],
            [25, 38],
            [80, 57],
            [40, -10],
            [73, -32]
        ],
        [[34952, 75094], [-41, -29], [16, 75], [31, 16], [-6, -62]],
        [[36743, 75545], [-36, 26], [16, 23], [35, -6], [-15, -43]],
        [[32812, 75598], [-50, -6], [41, 54], [47, 13], [-38, -61]],
        [[32852, 75533], [-24, -11], [-40, 11], [-24, 26], [51, 26], [51, 78], [14, 2], [-28, -132]],
        [
            [29996, 75816],
            [17, -66],
            [57, 21],
            [77, 48],
            [29, -20],
            [29, -42],
            [27, 47],
            [36, 14],
            [13, -39],
            [41, -49],
            [53, -17],
            [-50, -112],
            [-39, -31],
            [-46, 17],
            [-91, 66],
            [-127, 63],
            [-62, 8],
            [-69, 36],
            [11, 35],
            [49, 4],
            [45, 17]
        ],
        [[29838, 75763], [-46, 14], [27, 46], [38, -23], [-19, -37]],
        [[29691, 75922], [-31, -38], [-22, 6], [-36, 100], [39, 8], [46, -27], [4, -49]],
        [[33636, 76316], [-21, 15], [67, 54], [-11, -43], [-35, -26]],
        [
            [36699, 75799],
            [52, 22],
            [21, -20],
            [-53, -37],
            [21, -25],
            [-37, -50],
            [10, -25],
            [39, 25],
            [39, -6],
            [33, 20],
            [70, 97],
            [-72, -8],
            [-9, 13],
            [50, 59],
            [-4, 30],
            [25, 49],
            [64, 60],
            [22, -65],
            [41, 6],
            [70, -26],
            [5, -26],
            [-26, -52],
            [28, -43],
            [-53, -34],
            [-59, -77],
            [-56, -49],
            [-88, -36],
            [-61, 11],
            [-66, -15],
            [-62, -5],
            [-51, 79],
            [-14, 126],
            [5, 66],
            [22, 61],
            [52, 74],
            [114, 276],
            [78, 100],
            [65, 15],
            [-6, -45],
            [29, -86],
            [-16, -87],
            [-30, -111],
            [-4, -80],
            [-25, -55],
            [-52, -44],
            [-52, -27],
            [-59, -55]
        ],
        [
            [35863, 76091],
            [23, 6],
            [17, 46],
            [97, -30],
            [25, -27],
            [49, -21],
            [51, 3],
            [87, 18],
            [160, 15],
            [43, -36],
            [-91, -80],
            [-64, -42],
            [-8, -21],
            [6, -105],
            [-65, -6],
            [-42, 19],
            [-5, 68],
            [-18, 40],
            [-19, -3],
            [-31, 35],
            [-48, -29],
            [-2, -26],
            [-112, 43],
            [-68, 99],
            [-49, -2],
            [-28, 12],
            [1, 76],
            [-40, 39],
            [-47, 5],
            [11, 71],
            [40, 74],
            [71, 89],
            [4, -82],
            [-33, -77],
            [57, -76],
            [12, -37],
            [-13, -36],
            [29, -22]
        ],
        [[36449, 76546], [-3, 78], [91, 94], [48, 30], [-1, -47], [-33, -2], [-94, -120], [-8, -33]],
        [[29117, 76796], [-59, -8], [10, 48], [57, -13], [-8, -27]],
        [[35648, 76881], [-8, -40], [-27, -35], [-13, 62], [48, 13]],
        [[28388, 77345], [-18, 50], [28, 28], [57, 1], [-1, -51], [-39, -6], [-27, -22]],
        [[17459, 77365], [-25, -2], [-20, 98], [35, -33], [10, -63]],
        [
            [32500, 75274],
            [44, 21],
            [91, 82],
            [68, 29],
            [88, 86],
            [64, 17],
            [12, 19],
            [16, 96],
            [30, 70],
            [36, 59],
            [29, 82],
            [52, 52],
            [79, 44],
            [74, 95],
            [79, 50],
            [16, 39],
            [88, 67],
            [71, 12],
            [72, 37],
            [55, 20],
            [33, 35],
            [49, 19],
            [147, 100],
            [40, 47],
            [53, 97],
            [46, 49],
            [16, 52],
            [66, 85],
            [68, 111],
            [34, 80],
            [51, 45],
            [99, 127],
            [53, 51],
            [81, 51],
            [37, 47],
            [60, 47],
            [108, 58],
            [101, 70],
            [137, 60],
            [160, 91],
            [130, 48],
            [91, 7],
            [111, 23],
            [39, -3],
            [173, -39],
            [83, -48],
            [94, -102],
            [17, -65],
            [-50, 18],
            [-14, -19],
            [52, -63],
            [-2, -79],
            [-30, -70],
            [-87, -35],
            [-41, -74],
            [-60, -38],
            [-24, -30],
            [-69, -48],
            [-67, 6],
            [-86, 45],
            [-53, 43],
            [-48, -48],
            [-51, 8],
            [-34, -32],
            [46, -40],
            [111, -43],
            [29, -29],
            [28, -91],
            [18, -14],
            [38, 9],
            [79, 69],
            [56, -10],
            [53, 3],
            [53, -41],
            [-46, -86],
            [-19, -112],
            [-53, -76],
            [-72, -74],
            [39, -28],
            [46, 22],
            [65, -16],
            [-23, -96],
            [28, -106],
            [28, -15],
            [11, -89],
            [15, -48],
            [-2, -39],
            [28, -25],
            [5, -40],
            [102, -11],
            [20, -15],
            [71, -15],
            [26, -33],
            [-69, -48],
            [56, -34],
            [53, -57],
            [59, 10],
            [47, -36],
            [20, -33],
            [57, 17],
            [61, -3],
            [65, -20],
            [-15, -52],
            [51, 7],
            [31, -21],
            [19, 23],
            [63, 37],
            [81, 77],
            [24, -86],
            [31, -33],
            [37, -7],
            [51, 25],
            [44, -63],
            [21, -74],
            [-55, -42],
            [109, -10],
            [23, -31],
            [-21, -33],
            [-20, 13],
            [-37, -12],
            [-32, -28],
            [-56, -17],
            [-69, -39],
            [-72, -50],
            [-73, -33],
            [-77, -51],
            [-160, -72],
            [-38, -2],
            [-47, -38],
            [-73, 7],
            [0, -63],
            [-21, -35],
            [-46, 4],
            [-40, 33],
            [-34, 55],
            [-31, -88],
            [-21, 55],
            [-36, -20],
            [-16, -59],
            [19, -61],
            [-32, -17],
            [-28, -66],
            [-34, -25],
            [-34, -67],
            [-42, -51],
            [-11, -34],
            [-69, -79],
            [-46, 0],
            [-29, -33],
            [-5, -66],
            [-26, 7],
            [-16, -24],
            [-26, 19],
            [-30, -11],
            [-23, 15],
            [-46, 131],
            [-29, 11],
            [-18, -40],
            [-27, 39],
            [-21, 149],
            [0, 35],
            [29, 125],
            [71, 112],
            [-15, 26],
            [73, 20],
            [29, 43],
            [-21, 18],
            [232, 201],
            [47, 33],
            [93, 43],
            [28, -10],
            [2, -56],
            [36, -13],
            [44, 57],
            [107, 52],
            [89, 6],
            [28, 24],
            [-76, 17],
            [-90, -9],
            [-56, 18],
            [-77, -12],
            [-81, 12],
            [-45, -48],
            [-52, 28],
            [27, 56],
            [82, 84],
            [76, 117],
            [-52, -17],
            [-17, 34],
            [-74, -127],
            [-37, -7],
            [-49, -46],
            [-70, -39],
            [-81, -76],
            [-105, -64],
            [-68, 19],
            [-103, -90],
            [-22, 27],
            [-61, -34],
            [-51, -9],
            [-14, 44],
            [-51, -1],
            [-13, 14]
        ],
        [[34840, 75366], [-38, 18], [-36, -15], [-33, 57], [14, 57], [-20, 53], [21, 32], [-8, 43]],
        [[34740, 75611], [-46, 16], [-62, 66]],
        [
            [34632, 75693],
            [8, 35],
            [-3, 75],
            [-4, 304],
            [-3, 326],
            [-90, 107],
            [-42, 40],
            [-24, 5],
            [-52, -39],
            [-58, -18],
            [-49, -28],
            [-34, 5],
            [-34, 35],
            [-1, 85],
            [-59, 20],
            [-120, -213],
            [-116, -207],
            [-19, -150],
            [-56, -106],
            [-17, -108],
            [3, -84],
            [-35, -58],
            [-4, -36],
            [-54, -52],
            [-33, -52],
            [4, -68],
            [-34, -13],
            [-11, -53],
            [-19, -27],
            [-32, 42],
            [-41, -42],
            [-60, 16],
            [-28, -50],
            [-30, -108],
            [-257, 0],
            [-257, -1],
            [-257, -1],
            [-214, 0]
        ],
        [[16639, 77700], [9, -51], [-51, 18], [6, 47], [36, -14]],
        [[38863, 77917], [35, -46], [-80, -39], [-15, 39], [60, 46]],
        [[17238, 77798], [-65, 32], [-83, 82], [3, 22], [62, -26], [35, -34], [48, -76]],
        [[16470, 77840], [-32, 4], [-60, 59], [4, 66], [31, 20], [27, -16], [27, -55], [3, -78]],
        [
            [36484, 77555],
            [-129, -9],
            [-103, 35],
            [-76, 16],
            [-75, 31],
            [-162, 97],
            [-34, 75],
            [-64, 69],
            [-172, 95],
            [-14, 33],
            [35, 21],
            [74, 9],
            [115, -37],
            [145, -32],
            [133, -62],
            [70, -46],
            [154, -121],
            [28, -9],
            [70, -60],
            [37, -80],
            [-32, -25]
        ],
        [[16983, 78076], [-15, 58], [28, 18], [9, -53], [-22, -23]],
        [[16920, 78114], [-24, 18], [-30, 101], [18, 58], [32, -14], [38, -94], [-34, -69]],
        [
            [16298, 78417],
            [153, -70],
            [154, -34],
            [112, -41],
            [70, -12],
            [41, -24],
            [77, -169],
            [92, -157],
            [1, -49],
            [31, -63],
            [58, -57],
            [141, -71],
            [58, -43],
            [55, -78],
            [21, -74],
            [38, -71],
            [40, -135],
            [12, 52],
            [21, -3],
            [33, -120],
            [-15, -27],
            [-35, 12],
            [-46, -52],
            [-99, 29],
            [-239, 118],
            [-55, 31],
            [-78, 60],
            [-4, 34],
            [62, 75],
            [2, 32],
            [-74, -13],
            [-60, 4],
            [-31, -32],
            [-25, 7],
            [-36, 42],
            [-52, 35],
            [39, 27],
            [-8, 34],
            [-33, 42],
            [-36, -16],
            [-21, 67],
            [-25, 30],
            [-44, 12],
            [-19, -34],
            [-35, 38],
            [-40, -17],
            [2, 95],
            [60, 40],
            [-76, 57],
            [-28, 63],
            [-68, 38],
            [-23, -35],
            [-42, -1],
            [-29, 63],
            [5, 59],
            [-49, -26],
            [-36, 62],
            [-64, 0],
            [-30, -24],
            [-28, 4],
            [11, 47],
            [-7, 57],
            [-35, 18],
            [18, 55],
            [23, 14],
            [58, 5],
            [47, -29],
            [-11, 94],
            [-70, 6],
            [7, -40],
            [-42, -20],
            [-59, 0],
            [-24, 12],
            [-41, 49],
            [-25, 49],
            [1, 27],
            [32, 47],
            [43, 16],
            [57, 2],
            [63, -23],
            [159, -100]
        ],
        [
            [38441, 78916],
            [-38, -82],
            [-46, -17],
            [-92, -17],
            [9, -72],
            [57, -4],
            [5, -88],
            [-22, -70],
            [-64, -71],
            [-18, -72],
            [-76, -131],
            [-22, -20],
            [-9, -61],
            [-65, -118],
            [-17, -52],
            [-1, -47],
            [-30, -65],
            [29, -64],
            [79, 122],
            [38, 36],
            [40, 87],
            [39, -15],
            [-13, -59],
            [73, 34],
            [50, -32],
            [72, 20],
            [1, -34],
            [-59, -60],
            [-99, -69],
            [53, -19],
            [-7, -50],
            [-46, -69],
            [69, 32],
            [43, -45],
            [93, 31],
            [6, -60],
            [48, 15],
            [-18, -79],
            [5, -37],
            [67, 58],
            [36, 7],
            [59, 40],
            [43, 57],
            [30, -12],
            [6, -71],
            [45, 46],
            [111, 10],
            [29, -9],
            [75, -59],
            [16, -32],
            [-2, -68],
            [-57, -59],
            [-27, -61],
            [-78, -79],
            [76, 15],
            [-35, -58],
            [25, -13],
            [58, -2],
            [-30, -86],
            [-84, -60],
            [83, 17],
            [47, 35],
            [29, -17],
            [43, 45],
            [59, 9],
            [51, 45],
            [11, -49],
            [-12, -51],
            [-24, -43],
            [-61, -26],
            [-61, -69],
            [-11, -80],
            [-26, -35],
            [-13, -58],
            [-52, -68],
            [30, -84],
            [50, 7],
            [31, 46],
            [68, 141],
            [61, 40],
            [51, 44],
            [15, -30],
            [-26, -36],
            [-48, -121],
            [-20, -89],
            [2, -78],
            [15, -32],
            [54, 54],
            [22, 37],
            [28, 84],
            [22, -13],
            [18, -110],
            [-9, -68],
            [-71, -180],
            [8, -72],
            [-23, -87],
            [-33, -77],
            [-30, -19],
            [-39, 39],
            [-28, -3],
            [-47, -44],
            [-25, 27],
            [11, 154],
            [-10, 30],
            [11, 68],
            [-18, 3],
            [-69, -111],
            [-46, -55],
            [-21, -11],
            [-30, 33],
            [25, 115],
            [69, 168],
            [6, 30],
            [-16, 38],
            [-27, 138],
            [-18, 27],
            [-45, 30],
            [-13, -49],
            [-52, -120],
            [-9, -52],
            [-34, -21],
            [-97, -22],
            [-72, -118],
            [-15, -71],
            [-54, -79],
            [-67, 5],
            [-79, -26],
            [-50, 34],
            [-2, 25],
            [36, 55],
            [71, 27],
            [36, 23],
            [41, 54],
            [52, 106],
            [67, 38],
            [32, 30],
            [-63, 49],
            [-90, 2],
            [-21, -89],
            [-44, -21],
            [-88, 37],
            [5, 143],
            [-54, -13],
            [-40, 6],
            [-22, -58],
            [-74, -30],
            [-81, -14],
            [-16, -15],
            [-55, 5],
            [-160, 32],
            [-58, -3],
            [-82, 27],
            [-126, 1],
            [-1, 31],
            [-53, -44],
            [-32, -15],
            [-102, -25],
            [-54, -6],
            [-44, 36],
            [-32, 129],
            [28, 72],
            [96, 91],
            [78, 93],
            [32, 48],
            [83, 57],
            [-48, 0],
            [-71, 15],
            [-68, -10],
            [-69, 0],
            [0, 20],
            [100, 105],
            [-20, -54],
            [20, -25],
            [39, -4],
            [69, 226],
            [27, 45],
            [68, -12],
            [26, 8],
            [16, 58],
            [-44, 43],
            [-7, 72],
            [33, 63],
            [28, 24],
            [49, -39],
            [18, 20],
            [-30, 51],
            [-9, 56],
            [66, 181],
            [76, 244],
            [42, 79],
            [10, 52],
            [51, 50],
            [39, 85],
            [9, 49],
            [53, 65],
            [17, 73],
            [21, 32],
            [50, 37],
            [96, 50],
            [56, 44],
            [39, -2],
            [11, -31],
            [54, -21],
            [7, 60],
            [45, 10],
            [19, -34]
        ],
        [[16074, 78882], [-52, 20], [-17, 65], [36, 45], [35, -68], [-2, -62]],
        [[31056, 79148], [-42, 1], [-38, 31], [96, 50], [20, -15], [-36, -67]],
        [[15115, 79153], [-22, 30], [-5, 48], [33, -3], [-6, -75]],
        [[15937, 79398], [-21, 89], [-1, 76], [23, 48], [36, -23], [-23, -157], [-14, -33]],
        [[15761, 79459], [-9, -25], [-57, 78], [-30, 66], [19, 38], [60, -72], [16, -34], [1, -51]],
        [[15645, 79728], [-30, 18], [-28, 58], [16, 26], [42, -102]],
        [
            [30641, 79592],
            [-22, -8],
            [-64, 15],
            [-106, 51],
            [-150, 59],
            [-51, 29],
            [-11, 22],
            [59, 76],
            [158, 22],
            [62, -11],
            [114, -157],
            [17, -51],
            [-6, -47]
        ],
        [
            [14892, 79841],
            [31, -51],
            [6, -101],
            [-84, -31],
            [55, -61],
            [84, -31],
            [-42, -69],
            [64, -90],
            [38, -15],
            [-20, -40],
            [57, -15],
            [8, -40],
            [-33, -36],
            [-62, 47],
            [-43, 90],
            [-76, 79],
            [-88, 118],
            [-22, 17],
            [-29, 84],
            [35, 36],
            [-100, 41],
            [-17, 40],
            [55, -5],
            [96, 24],
            [44, 30],
            [43, -21]
        ],
        [
            [15880, 79699],
            [14, -178],
            [-1, -57],
            [-21, -37],
            [-14, -63],
            [-33, 10],
            [-11, 135],
            [-20, 44],
            [-21, -2],
            [-57, 82],
            [-3, 39],
            [-26, 70],
            [29, 68],
            [16, 79],
            [19, -4],
            [71, -53],
            [33, -37],
            [25, -96]
        ],
        [[15690, 79798], [-48, 14], [22, 80], [23, -15], [3, -79]],
        [[15480, 79826], [-27, 5], [-67, 94], [-47, 35], [-66, 76], [21, 48], [79, -45], [77, -63], [59, -107], [-29, -43]],
        [[15360, 80267], [-45, -64], [-48, 41], [-49, 19], [63, 68], [30, 7], [30, -28], [19, -43]],
        [
            [14614, 80361],
            [28, -33],
            [68, 21],
            [25, -16],
            [30, -68],
            [3, -45],
            [-18, -33],
            [-108, -71],
            [9, -20],
            [107, 18],
            [24, 120],
            [-8, 75],
            [60, 4],
            [84, 56],
            [-10, -87],
            [-37, -80],
            [-21, -71],
            [-10, -71],
            [-2, -116],
            [-26, -64],
            [-103, -42],
            [-54, 3],
            [-70, 65],
            [17, 32],
            [81, -10],
            [-74, 60],
            [-54, 28],
            [-21, 67],
            [-43, 83],
            [-14, 80],
            [10, 124],
            [127, -9]
        ],
        [[15147, 80557], [-8, 35], [14, 50], [40, -7], [-8, -42], [-38, -36]],
        [[15256, 80719], [111, 143]],
        [[15367, 80862], [3, -44], [-45, -74], [-57, -36], [-12, 11]],
        [[36733, 81427], [-61, 5], [32, 52], [37, -24], [-8, -33]],
        [[31229, 81486], [-10, 49], [18, 84], [40, 31], [4, -68], [-16, -58], [-36, -38]],
        [[30873, 81521], [-34, 3], [26, 58], [100, 48], [-2, -43], [-90, -66]],
        [
            [31195, 81554],
            [-46, -111],
            [-28, -102],
            [-30, 21],
            [40, 119],
            [-24, 22],
            [-58, -134],
            [-27, -34],
            [-34, 1],
            [-49, -39],
            [83, 160],
            [-21, 16],
            [-67, -101],
            [-38, -39],
            [-30, 34],
            [65, 102],
            [60, 72],
            [43, -18],
            [20, 36],
            [27, 104],
            [10, 77],
            [46, -45],
            [14, -37],
            [35, -18],
            [18, -56],
            [-9, -30]
        ],
        [[36501, 82272], [26, -17], [7, -60], [-48, 3], [-56, 41], [-11, 30], [50, 17], [32, -14]],
        [[34212, 83100], [-43, -35], [-9, 81], [41, 13], [11, -59]],
        [[30847, 83508], [-18, 29], [25, 26], [44, -9], [-51, -46]],
        [[35679, 83840], [-10, -38], [-114, 62], [-8, 51], [59, 7], [73, -82]],
        [[34498, 83770], [-40, 7], [8, 60], [61, 112], [16, 14], [54, -27], [29, -50], [-8, -32], [-51, -49], [-69, -35]],
        [[35548, 84397], [-173, 110], [-12, 48], [93, 20], [105, -13], [37, -38], [-8, -68], [-42, -59]],
        [[35487, 84683], [22, -4], [35, -61], [-25, -17], [-74, 37], [-14, 73], [56, -28]],
        [
            [31007, 84980],
            [24, -15],
            [56, -76],
            [4, -35],
            [-16, -89],
            [-120, -230],
            [-32, -10],
            [-85, 84],
            [-35, 17],
            [-22, 46],
            [0, 109],
            [13, 55],
            [66, 106],
            [47, 34],
            [100, 4]
        ],
        [[35551, 85062], [95, -4], [30, -36], [-19, -38], [-55, -19], [-75, 20], [24, 77]],
        [[32718, 85095], [-78, 2], [-43, 42], [88, -9], [33, -35]],
        [
            [33849, 85057],
            [-63, 2],
            [-69, 24],
            [-27, 60],
            [-41, 47],
            [-47, 16],
            [1, 34],
            [142, -39],
            [71, -41],
            [47, -66],
            [-14, -37]
        ],
        [
            [30249, 85283],
            [16, -39],
            [-24, -86],
            [-27, -44],
            [-85, -74],
            [-55, -65],
            [-138, -107],
            [-36, -4],
            [-76, 19],
            [-99, -43],
            [-19, 80],
            [-44, 55],
            [1, 41],
            [49, 52],
            [112, 187],
            [27, 9],
            [100, -26],
            [80, 39],
            [76, -4],
            [70, 23],
            [72, -13]
        ],
        [
            [31522, 85571],
            [53, -23],
            [51, -80],
            [-17, -55],
            [-61, -33],
            [-47, -8],
            [-96, 70],
            [-66, 66],
            [-12, 52],
            [84, 21],
            [111, -10]
        ],
        [[31892, 85528], [-33, -6], [-84, 37], [-95, 77], [71, 52], [114, -60], [35, -39], [-8, -61]],
        [[31594, 85861], [-22, -26], [-66, 10], [-1, 29], [97, 13], [-8, -26]],
        [
            [29348, 86569],
            [24, -3],
            [71, 107],
            [34, 6],
            [73, -51],
            [56, -83],
            [111, -27],
            [98, -37],
            [57, -76],
            [71, -35],
            [100, -69],
            [122, -33],
            [69, -43],
            [81, -122],
            [34, -119],
            [-14, -52],
            [-56, -49],
            [58, -5],
            [117, 30],
            [102, -24],
            [55, 32],
            [68, -66],
            [9, -35],
            [98, -60],
            [-13, -22],
            [-126, -92],
            [-75, -65],
            [-29, -10],
            [-283, 113],
            [-128, 23],
            [-27, 123],
            [-32, 19],
            [-143, 35],
            [-10, 75],
            [-73, -8],
            [-59, -25],
            [-38, -48],
            [-14, -78],
            [-20, -33],
            [-91, -86],
            [-88, -41],
            [-62, -109],
            [-39, -45],
            [-101, -63],
            [-133, -43],
            [-32, 11],
            [-22, 73],
            [-45, 216],
            [-28, 27],
            [-154, -28],
            [-84, 3],
            [-84, -48],
            [-102, 11],
            [-4, 43],
            [49, 88],
            [45, 52],
            [143, 72],
            [53, 47],
            [-32, 134],
            [-6, 105],
            [57, 248],
            [23, 227],
            [12, 65],
            [35, 95],
            [46, 71],
            [80, 49],
            [35, -41],
            [62, -28],
            [42, -96],
            [-42, -63],
            [57, -41],
            [42, -98]
        ],
        [
            [29423, 86744],
            [-33, -3],
            [-46, 67],
            [-43, 26],
            [-20, 47],
            [-4, 108],
            [65, -3],
            [76, -120],
            [28, -76],
            [-23, -46]
        ],
        [
            [29716, 86868],
            [152, -56],
            [-45, -37],
            [-79, 34],
            [-55, 53],
            [-60, -20],
            [-34, 12],
            [-7, 80],
            [-95, 83],
            [13, 37],
            [141, -58],
            [77, -60],
            [-8, -68]
        ],
        [[22195, 87541], [89, -3], [-9, -43], [-40, -21], [-40, 67]],
        [[36212, 87570], [-44, 9], [61, 58], [71, 1], [-88, -68]],
        [[22255, 87763], [-32, -20], [-46, 35], [7, 111], [43, -4], [0, -60], [28, -62]],
        [
            [32835, 87976],
            [-232, 3],
            [-62, 22],
            [-53, 87],
            [12, 45],
            [101, 15],
            [154, -40],
            [92, -3],
            [46, -26],
            [8, -98],
            [-66, -5]
        ],
        [
            [28831, 87949],
            [-82, 41],
            [-15, 32],
            [19, 80],
            [-35, 50],
            [23, 50],
            [57, 64],
            [40, -10],
            [46, -58],
            [12, -142],
            [-20, -62],
            [-45, -45]
        ],
        [
            [32201, 88276],
            [161, -49],
            [28, -52],
            [-20, -98],
            [13, -120],
            [-13, -119],
            [-23, -43],
            [-61, -52],
            [-117, -46],
            [-83, -12],
            [-199, -15],
            [-96, 17],
            [-47, 79],
            [-46, 166],
            [24, 80],
            [87, 135],
            [64, 78],
            [116, 49],
            [59, -6],
            [94, 16],
            [59, -8]
        ],
        [[31180, 88204], [-59, 23], [7, 56], [62, 10], [38, -47], [-48, -42]],
        [[23292, 88322], [-49, 7], [-82, 41], [-27, 38], [44, 12], [95, -11], [40, -32], [-21, -55]],
        [[32446, 88290], [-132, 71], [-28, 28], [9, 62], [26, 29], [66, -2], [28, -21], [57, -106], [-26, -61]],
        [[24123, 88423], [-129, 43], [-2, 25], [80, 65], [57, -14], [33, -42], [-4, -40], [-35, -37]],
        [[24626, 88546], [-46, -44], [-77, 31], [1, 115], [61, 21], [73, -69], [-12, -54]],
        [[24695, 88661], [-46, -24], [-31, 39], [64, 26], [13, -41]],
        [[27628, 88777], [-26, -7], [-51, 83], [44, 6], [33, -82]],
        [
            [31110, 88567],
            [-46, 7],
            [-14, 37],
            [50, 70],
            [106, 48],
            [30, 56],
            [43, 15],
            [21, 60],
            [81, 9],
            [32, -46],
            [-94, -88],
            [-19, -37],
            [-79, -91],
            [-111, -40]
        ],
        [[27718, 88887], [7, -34], [-58, -53], [-39, 60], [52, 33], [38, -6]],
        [[31794, 88734], [-68, -3], [-51, 75], [19, 80], [40, 13], [137, -20], [18, -43], [-95, -102]],
        [[24331, 88875], [-36, 25], [59, 55], [30, -44], [-53, -36]],
        [[26078, 88973], [41, -37], [-6, -48], [-30, -39], [-97, 54], [-57, 13], [37, 76], [52, 10], [60, -29]],
        [[34597, 88955], [-89, 22], [-6, 21], [72, 34], [72, -26], [-49, -51]],
        [[31475, 89052], [18, -42], [-154, -76], [-99, 11], [65, 65], [55, 6], [79, 50], [36, -14]],
        [
            [31042, 89093],
            [20, -42],
            [-58, -46],
            [-101, -12],
            [-23, -47],
            [-63, 6],
            [-89, 64],
            [-102, 15],
            [39, 41],
            [58, -7],
            [12, 33],
            [65, 3],
            [28, -36],
            [47, 1],
            [117, 40],
            [50, -13]
        ],
        [
            [25483, 89012],
            [63, 17],
            [112, -91],
            [55, -22],
            [122, -70],
            [36, -48],
            [72, -131],
            [62, -70],
            [51, -35],
            [65, 31],
            [33, -36],
            [-61, -44],
            [-68, -7],
            [-65, -60],
            [-40, -11],
            [-116, -76],
            [-61, -6],
            [-126, 43],
            [-144, 3],
            [-127, 72],
            [-108, 37],
            [-27, 58],
            [-67, -25],
            [-90, 23],
            [-23, 52],
            [-108, -39],
            [-57, 31],
            [-38, 65],
            [33, 54],
            [168, 20],
            [58, 29],
            [83, 64],
            [-32, 71],
            [3, 47],
            [49, 11],
            [31, 35],
            [7, 70],
            [58, 44],
            [89, 16],
            [117, -69],
            [-9, -53]
        ],
        [[28733, 89274], [92, -4], [30, -49], [-67, -23], [-141, 24], [-41, 46], [67, 25], [60, -19]],
        [[24598, 89488], [-96, 28], [-18, 56], [75, 1], [35, -39], [4, -46]],
        [[32500, 75274], [-46, 0], [-43, -19], [-57, -39], [-68, -71], [-123, -157]],
        [
            [32163, 74988],
            [-80, -69],
            [-87, -40],
            [-46, -29],
            [-31, -3],
            [-61, -31],
            [-63, -60],
            [-21, 73],
            [-18, -70],
            [5, -19],
            [66, 12],
            [-42, -45],
            [-9, -58],
            [-30, -9],
            [-43, 31],
            [-11, 27],
            [-55, -5],
            [-25, 43],
            [-128, -33],
            [-58, -8],
            [-105, -34],
            [-44, -1],
            [-121, -38],
            [-74, -81],
            [-45, -23],
            [-38, -39],
            [-63, -144],
            [14, -37],
            [62, -24],
            [59, -7],
            [85, 47]
        ],
        [[31156, 74314], [-1, -98]],
        [
            [31155, 74216],
            [8, -47],
            [32, -64],
            [-38, -25],
            [-101, 10],
            [-64, -15],
            [-47, 3],
            [-147, -47],
            [-71, -90],
            [107, -23],
            [3, -14],
            [-161, 27],
            [-65, 27],
            [-65, 11],
            [-66, -5],
            [-47, -14],
            [-28, -21],
            [-73, -81],
            [-48, -96],
            [-49, -9],
            [-82, -56],
            [-46, -56],
            [-16, -70],
            [-28, 52],
            [-27, 6],
            [-44, -21],
            [-32, 5],
            [-53, 36],
            [1, 80],
            [9, 34],
            [32, 28],
            [32, 5],
            [86, -11],
            [50, 29],
            [3, 58],
            [-60, 30],
            [-10, 18]
        ],
        [[30050, 73910], [31, 37], [17, 64], [22, 155]],
        [
            [30120, 74166],
            [73, 38],
            [46, 56],
            [77, 79],
            [22, 82],
            [-2, 283],
            [-4, 44],
            [42, 140],
            [24, 49],
            [36, 34],
            [38, 102],
            [0, 82],
            [-43, 110],
            [-53, 99],
            [-29, 21],
            [27, 33],
            [92, -7],
            [-5, -52],
            [17, -71],
            [57, -64],
            [16, -62],
            [40, -23],
            [-10, -72],
            [42, 38],
            [43, 11],
            [17, -46],
            [41, -34],
            [73, -38],
            [43, -11],
            [24, 46],
            [3, 45],
            [-34, 86],
            [34, 27],
            [53, -48],
            [17, 28],
            [-18, 65],
            [-79, 97],
            [19, 15],
            [-27, 68],
            [22, 47],
            [-16, 28],
            [-55, -18],
            [-35, 54],
            [-2, 65],
            [-37, 9],
            [-45, 111],
            [-50, 90],
            [-86, -5],
            [-43, 18],
            [-111, 12],
            [-14, 25],
            [8, 44],
            [-48, -8],
            [-131, 16],
            [-48, 33],
            [-97, -9],
            [-17, 17],
            [-94, -14],
            [-134, 31],
            [-63, 29],
            [-56, 7],
            [-12, 17],
            [-65, 16],
            [2, 81],
            [-24, 31],
            [-83, -22],
            [-21, -22],
            [-21, 52],
            [40, 82],
            [-37, 3],
            [2, 43],
            [57, 41],
            [-20, 28],
            [-59, -4],
            [-39, 33],
            [-6, 30],
            [25, 87],
            [29, 72],
            [-37, 59],
            [-68, 63],
            [-24, 55],
            [28, 86],
            [21, 88],
            [-34, 5],
            [-201, -10],
            [-50, 16],
            [-42, 33],
            [-59, 101],
            [-34, 118],
            [-13, 70],
            [-43, 102],
            [-19, 19],
            [-38, -7],
            [-19, 24],
            [-55, -13],
            [-58, 9],
            [-66, -7],
            [-57, 33],
            [-172, 69],
            [-18, 22],
            [-74, -14],
            [12, -59],
            [35, -51],
            [-9, -52],
            [-29, -48],
            [-103, -38],
            [72, 101],
            [1, 37],
            [-20, 39],
            [-33, -7],
            [-19, -108],
            [-44, -91],
            [-9, -51],
            [-47, -26],
            [35, 137],
            [-96, -48],
            [-36, -26],
            [-6, -78],
            [-38, -106],
            [-29, -12],
            [-43, -54]
        ],
        [
            [27910, 76946],
            [-61, 7],
            [-39, -11],
            [-28, 11],
            [-31, 57],
            [-70, -10],
            [-89, 7],
            [-42, -4],
            [-30, 53],
            [-62, -3],
            [-55, -50],
            [-51, -26],
            [-41, 0],
            [-105, 78],
            [-45, 58],
            [-52, 20],
            [-39, -5],
            [-36, -29],
            [-26, 88],
            [-72, 54],
            [-81, 45],
            [-81, 9],
            [-37, -7],
            [-26, -30],
            [-76, -20],
            [-29, 13],
            [-15, 32],
            [-63, 29],
            [-111, 25],
            [-64, 22],
            [-26, 36],
            [-2, 31],
            [-28, 78],
            [-12, 65],
            [-4, 103],
            [-26, 25],
            [-66, 11],
            [-3, -210],
            [-204, 0],
            [-395, 0],
            [-263, 0],
            [-395, 0],
            [-263, 0],
            [-395, 0],
            [-395, 0],
            [-263, 0],
            [-263, 0],
            [-395, 0],
            [-395, 0],
            [-263, 0],
            [-263, 0],
            [-263, 0],
            [-264, 0],
            [-263, 0],
            [-395, 0],
            [-395, 0],
            [-394, 0],
            [-264, 0],
            [-263, 0],
            [-395, 0],
            [-263, 0],
            [-263, 0],
            [-263, 0],
            [-264, 0],
            [-426, 0]
        ],
        [
            [17659, 77498],
            [-42, 46],
            [-24, -8],
            [-14, -38],
            [-46, 87],
            [-10, 62],
            [50, 18],
            [-33, 31],
            [-32, -2],
            [17, 137],
            [-31, -7],
            [-4, -66],
            [-31, -4],
            [-29, -30],
            [-101, 47],
            [-53, 67],
            [-7, 33],
            [18, 42],
            [22, -11],
            [33, -73],
            [16, 40],
            [-34, 44],
            [-30, 87],
            [-53, -56],
            [-43, -11],
            [-62, 20],
            [-92, 118],
            [-1, 29],
            [-84, 193],
            [60, 122],
            [-4, 105],
            [-18, -8],
            [1, -52],
            [-17, -70],
            [-23, -44],
            [-46, -21],
            [-83, 12],
            [-33, 43],
            [-8, -49],
            [-27, -12],
            [-23, 24],
            [-59, -12],
            [-84, 21],
            [-52, 3],
            [-4, 43],
            [15, 33],
            [-45, 8],
            [-1, 25],
            [37, 46],
            [-38, 33],
            [11, 52],
            [-45, -25],
            [-102, -12],
            [-30, -15],
            [-64, 28],
            [-54, 40],
            [-82, 91],
            [-2, 65],
            [25, 89],
            [66, 100],
            [43, 26],
            [96, 9],
            [-20, 26],
            [-94, -5],
            [-32, -16],
            [-63, -112],
            [-21, 7],
            [-33, 63],
            [-15, 96],
            [12, 57],
            [32, 64],
            [-41, -2],
            [20, 112],
            [110, 92],
            [60, 22],
            [36, -13],
            [-25, 71],
            [6, 22],
            [60, 67],
            [-13, 13],
            [-149, -180],
            [-84, -39],
            [-34, -77],
            [-29, -112],
            [-33, -90],
            [-28, 117],
            [-51, 89],
            [99, 89],
            [-7, 61],
            [-38, -11],
            [-28, 16],
            [51, 235],
            [1, 28],
            [-80, -46],
            [-27, 29],
            [-22, 147],
            [-40, 57],
            [-67, 47],
            [-65, 22],
            [-28, 93],
            [18, 60],
            [55, 41],
            [26, -28],
            [-17, -59],
            [22, -5],
            [90, -72],
            [23, 28],
            [-64, 47],
            [-23, 59],
            [-4, 48],
            [15, 35],
            [56, 27],
            [-53, 34],
            [-57, -50],
            [-22, 7],
            [-76, -112],
            [-10, -90],
            [-14, -48],
            [-55, -26],
            [-31, -53],
            [-80, 90],
            [-28, 77],
            [-50, 13],
            [-58, 44],
            [-22, 39],
            [31, 80],
            [46, 61],
            [13, 87],
            [78, 18],
            [-33, 34],
            [-58, -25],
            [-63, 50],
            [-33, 45],
            [-11, 39],
            [19, 111],
            [19, 44],
            [28, 17],
            [101, 242],
            [34, 65],
            [68, 102],
            [-44, -14],
            [-34, 53],
            [-8, -119],
            [-45, -116],
            [-33, -2],
            [29, 87],
            [4, 53],
            [-34, 152],
            [3, 67],
            [18, 76]
        ],
        [
            [15425, 81343],
            [1, 70],
            [-23, 53],
            [-36, -15],
            [-61, 22],
            [-20, 61],
            [-53, 18],
            [-29, 43],
            [-105, 36],
            [-152, 108],
            [-77, -5],
            [-13, 113],
            [-73, 36],
            [22, 95],
            [-94, 29],
            [32, 66],
            [-98, 168],
            [-113, 211],
            [-111, 193],
            [-45, 63],
            [6, 41],
            [-129, 164],
            [-123, 81],
            [-24, 27],
            [-45, 104],
            [-73, 64],
            [-82, 50],
            [-39, 85],
            [6, 77],
            [-131, 119],
            [-142, -73],
            [-119, -32],
            [23, -40],
            [-31, -43],
            [-37, 2],
            [0, -100],
            [-34, -71],
            [-73, -1],
            [-143, -91],
            [-50, -47],
            [-48, 180],
            [-320, 308],
            [-23, 68],
            [-104, 52],
            [-44, 50],
            [33, 109],
            [0, 36],
            [-185, -8],
            [-91, -81],
            [-148, 65],
            [-23, -46],
            [-147, 46],
            [0, 326],
            [0, 326],
            [0, 325],
            [0, 489],
            [0, 326],
            [0, 326],
            [0, 489],
            [0, 488],
            [0, 326],
            [0, 489],
            [0, 489],
            [0, 489],
            [0, 325]
        ],
        [
            [12037, 89016],
            [185, -26],
            [132, 10],
            [245, -59],
            [152, -111],
            [123, -54],
            [50, -38],
            [268, -104],
            [59, -8],
            [109, -34],
            [183, -4],
            [79, -28],
            [156, -76],
            [41, -1],
            [-55, 75],
            [-71, 36],
            [-74, 13],
            [1, 47],
            [88, 4],
            [-99, 58],
            [67, 111],
            [60, 15],
            [75, -8],
            [8, 57],
            [27, 23],
            [89, 11],
            [111, -10],
            [13, 110],
            [65, 2],
            [51, -62],
            [61, -28],
            [-21, -44],
            [-67, -83],
            [67, 12],
            [145, 58],
            [97, 16],
            [99, 120],
            [97, -4],
            [-13, 31],
            [73, 30],
            [52, -26],
            [71, 27],
            [152, 91],
            [94, -6],
            [65, 81],
            [81, 42],
            [51, 9],
            [100, -32],
            [71, 3],
            [67, 56],
            [59, -48],
            [-34, -60],
            [-250, -121],
            [-78, -53],
            [-77, -30],
            [-279, -46],
            [-39, -18],
            [-43, -64],
            [-62, -53],
            [-110, -26],
            [-40, -31],
            [-84, -98],
            [-90, -80],
            [23, -21],
            [185, -19],
            [-20, 110],
            [16, 38],
            [111, 49],
            [136, 69],
            [40, 79],
            [70, 16],
            [68, -15],
            [101, -3],
            [10, -98],
            [99, 127],
            [95, 97],
            [73, 36],
            [168, 60],
            [95, 16],
            [39, -13],
            [1, -46],
            [51, -21],
            [82, 54],
            [98, 84],
            [34, 82],
            [158, 64],
            [-64, 40],
            [-5, 39],
            [-56, 31],
            [13, 58],
            [42, 28],
            [74, -31],
            [116, -83],
            [73, -72],
            [66, -99],
            [52, -117],
            [45, -68],
            [169, -147],
            [104, -48],
            [105, -18],
            [66, 44],
            [2, 29],
            [-59, 82],
            [43, 59],
            [139, 144],
            [-57, 28],
            [64, 22],
            [59, 40],
            [34, -23],
            [-8, -107],
            [20, -84],
            [87, -44],
            [-5, -20],
            [-105, -127],
            [17, -26],
            [252, -1],
            [46, 24],
            [76, 68],
            [32, 109],
            [26, 40],
            [295, 4],
            [166, -23],
            [176, -64],
            [207, -134],
            [135, -43],
            [304, -48],
            [239, -119],
            [297, -76],
            [33, 5],
            [147, -21],
            [149, -13],
            [-57, 57],
            [191, 8],
            [197, -68],
            [115, -58],
            [64, -48],
            [139, -145],
            [-41, -74],
            [-55, -11],
            [-151, 13],
            [-27, -42],
            [-85, -35],
            [-12, -64],
            [-81, -53],
            [91, -58],
            [145, -13],
            [72, -25],
            [166, -24],
            [209, -3],
            [104, -12],
            [137, 2],
            [61, 26],
            [204, 14],
            [118, 37],
            [63, -18],
            [191, 92],
            [101, 12],
            [33, -49],
            [33, -13],
            [62, -74],
            [125, -2],
            [44, -10],
            [27, -41],
            [14, -80],
            [41, -32],
            [31, 81],
            [38, 5],
            [31, -60],
            [45, -45],
            [110, -82],
            [25, -52],
            [-55, -52],
            [-114, -3],
            [109, -113],
            [106, -99],
            [15, 32],
            [-11, 123],
            [37, 23],
            [145, -67],
            [-59, 96],
            [20, 27],
            [-61, 54],
            [-50, 103],
            [-2, 71],
            [-67, 71],
            [-33, 52],
            [5, 48],
            [60, 49],
            [1, 70],
            [126, 16],
            [70, 27],
            [89, 11],
            [52, 49],
            [75, -9],
            [6, 66],
            [41, 36],
            [72, 13],
            [80, 67],
            [2, 47],
            [-49, 14],
            [-162, -67],
            [-47, -89],
            [-53, 17],
            [-51, -7],
            [-62, -39],
            [-47, -5],
            [-99, 20],
            [-37, -26],
            [2, -62],
            [-163, -13],
            [-131, 71],
            [14, 56],
            [101, 130],
            [169, 21],
            [102, 22],
            [187, 67],
            [205, 62],
            [113, -31],
            [35, -20],
            [45, -61],
            [34, -145],
            [73, -72],
            [87, -44],
            [85, -21],
            [-8, -36],
            [54, -48],
            [91, -18],
            [165, 22],
            [57, 25],
            [241, -169],
            [149, -44],
            [101, 7],
            [101, -29],
            [216, 59],
            [123, 23],
            [211, -14],
            [93, -17],
            [100, -34],
            [70, 1],
            [156, 56],
            [-89, 78],
            [23, 60],
            [66, -47],
            [109, -122],
            [41, -33],
            [100, -45],
            [47, -7],
            [92, 61],
            [-16, 71],
            [-105, 59],
            [-59, 10],
            [-115, -42],
            [-25, 11],
            [-76, 79],
            [18, 38],
            [-78, 111],
            [51, 28],
            [77, -36],
            [131, 39],
            [-45, 69],
            [34, 12],
            [59, -28],
            [70, 8],
            [45, -24],
            [89, -111],
            [154, -7],
            [-76, -101],
            [41, -7],
            [47, 57],
            [112, 48],
            [13, -44],
            [-51, -245],
            [-53, -92],
            [1, -24],
            [57, -75],
            [5, -48],
            [48, -10],
            [90, 25],
            [-19, -68],
            [78, 8],
            [35, -30],
            [-1, -79],
            [-43, -23],
            [-65, -3],
            [-77, 29],
            [-105, -16],
            [146, -139],
            [-49, 102],
            [22, 16],
            [108, -20],
            [83, 36],
            [10, 96],
            [20, 61],
            [-12, 55],
            [-52, 139],
            [-57, 71],
            [58, 158],
            [104, 35],
            [81, -24],
            [36, 17],
            [151, 126],
            [101, 98],
            [86, 39],
            [-10, 192],
            [-26, 46],
            [-40, 7],
            [-29, -90],
            [-70, -34],
            [-81, -10],
            [-37, 34],
            [11, 60],
            [148, 118],
            [-53, 16],
            [0, 91],
            [31, 15],
            [168, 34],
            [-58, -68],
            [72, 9],
            [10, 103],
            [-36, 21],
            [-113, -40],
            [-78, 4],
            [-113, 109],
            [-58, -40],
            [-145, 50],
            [-128, 62],
            [-79, 13],
            [-48, 39],
            [-115, 141],
            [-18, 47],
            [1, 66],
            [99, 119],
            [55, 14],
            [44, 73],
            [-87, -33],
            [-53, 23],
            [-59, 72],
            [45, 259],
            [82, 69],
            [66, -2],
            [62, -36],
            [49, 5],
            [49, 86],
            [-131, 19],
            [-2, 40],
            [68, 49],
            [32, 51],
            [96, 71],
            [144, 44],
            [55, -2],
            [24, -73],
            [53, -47],
            [154, 1],
            [14, -71],
            [157, -99],
            [95, -111],
            [20, -108],
            [-7, -85],
            [-24, -36],
            [62, -30],
            [43, -44],
            [79, -38],
            [53, -88],
            [51, -58],
            [-7, -39],
            [78, 13],
            [79, -91],
            [-16, -17],
            [-117, -3],
            [-91, 54],
            [-69, -76],
            [119, -11],
            [47, -25],
            [-95, -82],
            [-144, -99],
            [135, -23],
            [32, -39],
            [92, -40],
            [58, 8],
            [104, 58],
            [67, -16],
            [-37, -43],
            [104, -16],
            [122, -6],
            [-39, -43],
            [-43, -76],
            [-128, -3],
            [152, -100],
            [85, -135],
            [-22, -25],
            [9, -73],
            [-19, -119],
            [100, -116],
            [75, 73],
            [39, 69],
            [-2, 58],
            [32, 61],
            [36, 156],
            [97, 118],
            [91, 22],
            [129, -116],
            [100, -58],
            [84, -79],
            [72, -228],
            [-14, -76],
            [-42, -14],
            [-110, 26],
            [10, -189],
            [37, -103],
            [61, -78],
            [154, -150],
            [25, -79],
            [47, -17],
            [140, 122],
            [62, 27],
            [23, 36],
            [19, 110],
            [32, 62],
            [129, 138],
            [68, 208],
            [0, 103],
            [66, 78],
            [75, -16],
            [126, 18],
            [-74, 40],
            [7, 35],
            [52, 31],
            [17, 62],
            [-78, 51],
            [-40, -2],
            [-44, 39],
            [-14, 68],
            [5, 108],
            [-27, 58],
            [17, 70],
            [-19, 38],
            [151, -23],
            [116, 25],
            [124, -8],
            [100, -50],
            [78, -25],
            [208, -8],
            [115, 3],
            [76, -28],
            [-38, -61],
            [-45, -41],
            [102, -27],
            [50, -90],
            [61, 16],
            [68, -10],
            [98, -34],
            [26, -43],
            [-87, -66],
            [-105, -52],
            [176, -33],
            [36, -39],
            [-5, -68],
            [-76, -57],
            [-148, -52],
            [-63, 24],
            [-106, -33],
            [50, -60],
            [0, -30],
            [52, -78],
            [65, 16],
            [-27, -103],
            [38, -71],
            [83, -78],
            [91, -71],
            [44, -75],
            [-9, -57],
            [-52, -161],
            [-50, -37],
            [-75, -8],
            [-41, -38],
            [-59, -87],
            [-55, -31],
            [-82, -68],
            [-95, -20],
            [-108, -88],
            [-69, -13],
            [-123, 173],
            [-40, 33],
            [-48, -2],
            [-36, 26],
            [16, 32],
            [-82, 74],
            [-95, 32],
            [-83, -68],
            [29, -20],
            [50, 38],
            [37, -4],
            [129, -123],
            [30, -17],
            [40, -87],
            [82, -131],
            [-24, -44],
            [-120, 45],
            [-57, -63],
            [-133, 51],
            [-58, 30],
            [-106, 119],
            [-50, 17],
            [-58, -20],
            [-84, -7],
            [-176, 6],
            [-35, -64],
            [50, -53],
            [87, -29],
            [93, -46],
            [13, -38],
            [-26, -54],
            [-281, -275],
            [-39, -49],
            [-65, -48],
            [-120, -11],
            [-90, 8],
            [-46, 25],
            [-85, 68],
            [-85, 53],
            [-23, 38],
            [-106, 33],
            [-102, 68],
            [-102, 42],
            [-30, -35],
            [-83, 5],
            [-62, 25],
            [-61, -3],
            [-153, 25],
            [-91, -1],
            [6, -39],
            [65, -5],
            [28, 19],
            [120, -19],
            [169, -44],
            [80, -39],
            [169, -162],
            [82, -54],
            [240, -39],
            [249, -10],
            [112, -35],
            [0, -75],
            [-78, -133],
            [-186, -237],
            [-35, -87],
            [-34, -34],
            [-168, -97],
            [-51, -10],
            [-75, 24],
            [-48, -28],
            [-58, 31],
            [-66, -5],
            [-45, 38],
            [-15, 45],
            [-83, -29],
            [39, -26],
            [29, -57],
            [-19, -20],
            [-68, 22],
            [40, -99],
            [-72, -91],
            [-38, -10],
            [-70, 21],
            [-34, -36],
            [-74, -5],
            [-183, 77],
            [-120, 17],
            [-34, 32],
            [-49, -21],
            [-109, 30],
            [-130, 60],
            [-142, 51],
            [-51, 6],
            [-21, -55],
            [32, -42],
            [44, -16],
            [12, 62],
            [262, -104],
            [115, -39],
            [-94, -68],
            [53, -4],
            [66, 43],
            [72, 32],
            [48, -21],
            [110, -85],
            [111, -36],
            [69, -51],
            [11, -26],
            [7, -108],
            [-12, -52],
            [-44, -40],
            [-75, -14],
            [-73, -57],
            [-30, -8],
            [-130, 17],
            [-51, 16],
            [-101, -25],
            [5, -47],
            [31, -28],
            [89, -22],
            [-16, -58],
            [-62, 25],
            [-106, -22],
            [-13, -42],
            [-84, -92],
            [-37, -11],
            [25, -39],
            [-50, -37],
            [16, -32],
            [-47, -33],
            [-56, -2],
            [23, -38],
            [-30, -18],
            [-65, 7],
            [47, -72],
            [36, -18],
            [-33, -41],
            [-89, -58],
            [-72, -89],
            [16, -55],
            [-53, -15],
            [-2, -100],
            [-74, -149],
            [-81, -183],
            [-59, -25],
            [35, -45],
            [-7, -65],
            [-35, -194],
            [2, -265],
            [-3, -117],
            [-26, -100],
            [30, -38],
            [19, -65],
            [41, -19],
            [50, -69],
            [40, -16],
            [25, -50],
            [26, 61],
            [21, 13],
            [85, 7],
            [91, -16],
            [64, 7],
            [38, -34],
            [17, -115],
            [80, -230],
            [43, -167],
            [65, -172],
            [16, -108],
            [-54, -131],
            [96, 3],
            [17, -20],
            [71, 30],
            [280, 99],
            [66, 9],
            [94, -18],
            [160, -96],
            [87, -40],
            [260, -72],
            [38, -21],
            [117, -114],
            [115, -79],
            [61, -70],
            [98, -159],
            [84, -46],
            [114, -33],
            [167, -79],
            [121, -43],
            [95, -53],
            [83, -95],
            [59, -46],
            [1, -69],
            [47, 34],
            [110, -15],
            [58, 0],
            [50, 13],
            [77, 5],
            [60, 13],
            [75, -28],
            [140, -28],
            [71, 10],
            [36, -40],
            [90, -6],
            [57, -46],
            [26, -38],
            [27, -103],
            [-61, -256],
            [7, -97],
            [48, -76],
            [30, -127],
            [-15, -115],
            [14, -137],
            [-4, -56],
            [-31, -58],
            [-10, -53],
            [10, -58],
            [74, -84],
            [49, -89],
            [81, -122],
            [8, -36],
            [-27, -41],
            [60, -50],
            [56, -64],
            [48, -25],
            [49, -41],
            [96, -119],
            [50, -130],
            [17, -76],
            [-71, -69],
            [-2, -41],
            [62, 65],
            [34, 12],
            [81, -26],
            [83, -61],
            [30, 7],
            [15, 90],
            [59, 124],
            [50, 33],
            [22, -43],
            [54, -28],
            [27, -43],
            [33, -85],
            [21, 88],
            [30, 38],
            [-14, 38],
            [-62, 93],
            [46, 128],
            [39, 39],
            [65, 122],
            [-11, 33],
            [-9, 101],
            [-52, 76],
            [-13, 74],
            [14, 53],
            [-55, 105],
            [-28, 204],
            [-38, 171],
            [34, 67],
            [-22, 53],
            [24, 39],
            [-22, 28],
            [-54, 26],
            [32, 33],
            [-48, 33],
            [-42, 67],
            [-52, 148],
            [-35, 29],
            [15, 24],
            [233, 103],
            [187, 104],
            [54, 46],
            [73, 47],
            [175, 178],
            [49, 61],
            [29, 51],
            [96, 134],
            [34, 62],
            [32, 140],
            [9, 194],
            [-2, 103],
            [-15, 162],
            [-25, 111],
            [-73, 210],
            [-82, 146],
            [-163, 152],
            [-101, 60],
            [-105, 101],
            [-34, 12],
            [-16, 45],
            [10, 82],
            [16, 40],
            [57, 74],
            [32, 60],
            [48, 58],
            [44, 33],
            [26, 42],
            [-31, 53],
            [39, 59],
            [2, 53],
            [75, 5],
            [47, 62],
            [-13, 72],
            [19, 65],
            [-73, 11],
            [30, 47],
            [-61, 121],
            [-10, 36],
            [51, 75],
            [-61, 9],
            [-24, 34],
            [40, 84],
            [-65, -2],
            [-89, 37],
            [102, 129],
            [32, 82],
            [-3, 115],
            [69, 66],
            [-57, 39],
            [-77, 76],
            [-40, 90],
            [-19, 102],
            [2, 98],
            [20, 41],
            [143, 98],
            [71, 23],
            [153, -26],
            [81, -34],
            [247, -83],
            [43, -37],
            [103, 35],
            [201, -72],
            [14, 15],
            [136, 62],
            [136, 82],
            [42, -8],
            [134, -98],
            [97, -85],
            [65, -7],
            [12, -48],
            [-30, -105],
            [69, 46],
            [86, -50],
            [45, -58],
            [18, -65],
            [48, 43],
            [70, -40],
            [-5, -37],
            [-57, -47],
            [30, -72],
            [59, -69],
            [40, -30],
            [76, -7],
            [140, -51],
            [56, -7],
            [81, 14],
            [28, -15],
            [29, -90],
            [57, -11],
            [62, 30],
            [26, 76],
            [47, -22],
            [23, -71],
            [-11, -39],
            [-64, -69],
            [-25, -68],
            [-11, -100],
            [38, -94],
            [-12, -80],
            [-38, -26],
            [-52, -7],
            [-168, -1],
            [-34, -17],
            [251, -22],
            [54, -69],
            [16, -82],
            [-35, -104],
            [3, -82],
            [87, -2],
            [16, -34],
            [-31, -54],
            [11, -52],
            [-36, -121],
            [-45, -21],
            [-24, 60],
            [-35, -46],
            [-90, -38],
            [87, -51],
            [70, 17],
            [83, 69],
            [64, 25],
            [72, -4],
            [75, 9],
            [42, -22],
            [45, -46],
            [28, -105],
            [22, -21],
            [6, -88],
            [-38, -132],
            [21, 8],
            [35, 126],
            [20, 39],
            [40, -7],
            [39, -105],
            [15, 52],
            [22, 11],
            [14, -79],
            [37, -17],
            [58, 49],
            [112, 74],
            [92, 32],
            [35, 32],
            [29, 83],
            [47, 52],
            [60, -35],
            [38, -68],
            [36, 3],
            [-29, 69],
            [-7, 48],
            [58, 14],
            [-20, 38],
            [25, 35],
            [42, -3],
            [3, 34],
            [96, 15],
            [-69, 29],
            [0, 57],
            [29, 76],
            [7, 55],
            [43, 17],
            [-38, 77],
            [13, 89],
            [84, 30],
            [-4, 43],
            [75, 192],
            [35, 44],
            [34, 3],
            [64, -38],
            [25, -54],
            [-34, -43],
            [76, -17],
            [31, -51],
            [10, -100],
            [29, 17],
            [24, -39],
            [15, -61],
            [55, -73],
            [-60, -74],
            [51, -17],
            [74, -10],
            [39, -77],
            [-48, -82],
            [75, 19],
            [43, -124],
            [42, 11],
            [38, -63],
            [17, -52],
            [-71, -70],
            [-36, -15],
            [44, -58],
            [74, 36],
            [75, -3],
            [-25, -87],
            [-42, -66],
            [-78, -41],
            [26, -19],
            [121, 36],
            [31, -2],
            [56, -101],
            [58, -5],
            [49, -29],
            [18, -28],
            [-29, -51],
            [20, -56],
            [-12, -32],
            [-114, -71],
            [11, -25],
            [66, 7],
            [73, -40],
            [-39, -74],
            [36, -28],
            [72, -8],
            [91, -96],
            [-18, -88],
            [6, -96],
            [-49, -15],
            [-164, 25],
            [-94, 38],
            [-9, -21],
            [86, -35],
            [39, -42],
            [42, -4],
            [-26, -90],
            [131, -18],
            [5, -35],
            [-64, -22],
            [-2, -32],
            [48, -13],
            [59, 5],
            [20, -95],
            [-46, -28],
            [81, -23],
            [30, -49],
            [29, -3],
            [51, 54],
            [74, -80],
            [77, -17],
            [-20, -75],
            [66, -94],
            [-52, -64],
            [-27, -93],
            [33, -3],
            [40, 23],
            [87, 13],
            [53, 28],
            [22, -63],
            [53, 1],
            [9, -38],
            [-79, -104],
            [-2, -31],
            [99, 94],
            [52, 80],
            [81, -28],
            [35, -110],
            [32, -64],
            [118, -35],
            [54, 21],
            [9, 30],
            [72, 5],
            [10, -57],
            [63, -55],
            [75, -19],
            [24, -39],
            [-49, -72],
            [-42, -30],
            [-59, -2],
            [-81, -19],
            [-21, -35],
            [-66, -33],
            [-61, -99],
            [-65, -3],
            [-42, -19],
            [-19, -26],
            [-50, -19],
            [-91, -53],
            [-101, 0],
            [-59, -41],
            [-40, -92],
            [14, -61],
            [-59, -53],
            [5, -42],
            [39, -6],
            [50, 48],
            [48, 63],
            [65, 18],
            [92, 59],
            [59, 56],
            [65, 73],
            [83, 58],
            [100, 41],
            [74, 21],
            [-28, 23],
            [-43, -9],
            [2, 48],
            [37, 15],
            [178, -20],
            [61, -16],
            [67, -133],
            [16, -43],
            [-3, -51],
            [-102, -69],
            [31, -40],
            [17, -51],
            [99, 113],
            [53, 38],
            [116, 14],
            [34, -78],
            [75, -21],
            [45, -65],
            [33, -71],
            [19, -73],
            [-3, -43],
            [-26, -75],
            [19, -68],
            [-13, -80],
            [7, -63],
            [-98, -27],
            [35, -20],
            [66, -17],
            [41, -44],
            [-39, -66],
            [44, -38],
            [-2, -58],
            [-99, -117],
            [-82, -73],
            [-82, -65],
            [-132, -125],
            [-37, -8],
            [-63, 20],
            [-50, -5],
            [-95, -24],
            [-78, -58],
            [-76, -15],
            [-75, 0],
            [-32, -33],
            [-7, -36],
            [-129, -163],
            [-34, -55],
            [-65, -59],
            [-73, -102],
            [-62, -41],
            [-22, -57],
            [-60, -34],
            [-163, -19],
            [-61, 16],
            [-47, -25],
            [-69, -7],
            [-33, 5],
            [-135, -54],
            [-60, 72],
            [-76, 3],
            [-60, 21],
            [-109, 14],
            [-130, -4],
            [-32, -29],
            [-107, 9],
            [-46, 26],
            [-87, -1],
            [-48, -19],
            [-104, 22],
            [-111, -19],
            [-96, 13],
            [-28, 12],
            [-152, -34],
            [-60, 20],
            [-52, -52],
            [-36, 11],
            [-78, -5],
            [-39, -32],
            [-37, -50],
            [-62, -40],
            [-90, -218],
            [-9, -84],
            [-34, -58],
            [-55, -9],
            [-156, -42],
            [-70, -33],
            [19, -26],
            [-60, -28],
            [-65, -52],
            [-13, -38],
            [-80, -61],
            [-94, -143],
            [-44, -104],
            [-54, -76],
            [-38, -28],
            [-55, 4],
            [-46, 36],
            [-34, 4],
            [-84, 49],
            [-196, 50],
            [55, -50],
            [104, -7],
            [110, -62],
            [87, -39],
            [27, -42],
            [-40, -148],
            [-27, -51],
            [-95, -133],
            [-45, -44],
            [-80, -158],
            [-126, -120],
            [-47, -72],
            [-110, -54],
            [-41, -14],
            [-38, 7],
            [-46, -44],
            [-54, -27],
            [-17, -41],
            [-130, -110],
            [-50, -14],
            [-43, -30],
            [-13, -50],
            [-38, -30],
            [-42, -92],
            [-60, -91],
            [-73, -15],
            [-57, -82],
            [-43, -34],
            [19, -88],
            [-38, -11],
            [-80, -66],
            [-108, -113]
        ],
        [[25686, 90849], [-50, -6], [-46, 39], [8, 75], [64, 32], [81, -64], [-22, -63], [-35, -13]],
        [
            [20211, 90657],
            [55, -1],
            [119, 34],
            [141, 24],
            [16, 94],
            [74, 65],
            [141, 3],
            [217, -54],
            [241, -98],
            [-27, -79],
            [-79, -76],
            [-87, -44],
            [67, -31],
            [113, 86],
            [53, -50],
            [110, 94],
            [106, 56],
            [72, 15],
            [3, 54],
            [-110, 58],
            [-42, 46],
            [8, 36],
            [202, -14],
            [123, -60],
            [43, -38],
            [108, -46],
            [47, -40],
            [-8, -32],
            [61, -16],
            [30, -38],
            [71, -201],
            [59, -133],
            [21, -83],
            [88, -63],
            [43, -5],
            [30, 48],
            [105, 58],
            [13, 42],
            [-73, 72],
            [-47, 70],
            [-31, 85],
            [-9, 78],
            [-33, 44],
            [-95, 326],
            [11, 43],
            [69, 13],
            [-34, 54],
            [19, 25],
            [95, -11],
            [187, -76],
            [51, 47],
            [144, -45],
            [124, -69],
            [83, -34],
            [58, -46],
            [65, -78],
            [56, -208],
            [109, -243],
            [35, -62],
            [117, -163],
            [12, -79],
            [-68, -184],
            [124, -99],
            [66, -92],
            [114, -73],
            [148, -67],
            [32, 17],
            [77, -11],
            [235, -132],
            [79, 1],
            [33, -21],
            [20, -64],
            [128, 8],
            [54, -66],
            [20, -90],
            [-9, -86],
            [-33, -26],
            [-53, 7],
            [-57, 38],
            [-76, -28],
            [-66, 22],
            [-99, 60],
            [-52, -18],
            [-76, -53],
            [19, -54],
            [-27, -39],
            [-92, 7],
            [-136, 68],
            [-32, -23],
            [99, -82],
            [25, -7],
            [7, -65],
            [48, -15],
            [135, 75],
            [91, 7],
            [54, -45],
            [-27, -71],
            [75, -35],
            [10, -48],
            [-21, -60],
            [-195, -75],
            [-125, -37],
            [-83, 3],
            [-94, -11],
            [-185, 32],
            [-88, 35],
            [-68, -32],
            [-165, 27],
            [-19, 20],
            [46, 70],
            [-159, 29],
            [-187, 16],
            [-62, 35],
            [-6, 87],
            [-55, 35],
            [-37, -2],
            [-61, -52],
            [-55, -93],
            [-125, -99],
            [-131, -27],
            [-155, -11],
            [-58, -21],
            [-121, -76],
            [-163, -47],
            [-150, -26],
            [-157, -11],
            [-117, -17],
            [-87, 5],
            [-56, -26],
            [-307, -14],
            [-173, -22],
            [-81, 10],
            [-65, 58],
            [-86, 134],
            [8, 67],
            [-32, 131],
            [-117, 32],
            [-77, 10],
            [-258, -3],
            [-142, 10],
            [-149, 31],
            [-127, 48],
            [-61, 85],
            [-87, 80],
            [-34, 47],
            [-28, 139],
            [18, 26],
            [180, 42],
            [316, 46],
            [289, 30],
            [131, -2],
            [155, -21],
            [140, -4],
            [177, -21],
            [139, 28],
            [125, -2],
            [18, 45],
            [-120, 52],
            [-318, 95],
            [-189, 41],
            [-177, -8],
            [-158, -30],
            [-145, -12],
            [-210, -8],
            [-104, 21],
            [-205, -11],
            [-183, 14],
            [-209, 145],
            [-35, 44],
            [33, 37],
            [141, 69],
            [154, 30],
            [335, 82],
            [77, 61],
            [76, 9],
            [45, 34],
            [-368, -57],
            [-172, -5],
            [-119, -24],
            [-66, 0],
            [-78, 25],
            [12, 50],
            [84, 19],
            [42, 55],
            [-195, -10],
            [-153, 26],
            [-37, 43],
            [14, 123],
            [109, 102],
            [116, 53],
            [-82, 92],
            [33, 59],
            [74, 55],
            [180, 111],
            [91, 46],
            [88, 25],
            [123, 54],
            [315, 88],
            [282, 89],
            [104, -24],
            [54, -55],
            [23, -89],
            [-18, -118],
            [-127, -149]
        ],
        [
            [23061, 90839],
            [-45, 10],
            [-197, 144],
            [-33, 60],
            [-107, 61],
            [-122, 37],
            [28, 67],
            [67, 54],
            [340, 39],
            [122, -12],
            [87, -54],
            [57, -18],
            [29, -41],
            [-8, -105],
            [-65, -104],
            [-87, -95],
            [-66, -43]
        ],
        [
            [31009, 91249],
            [53, -7],
            [333, 13],
            [69, -10],
            [265, -83],
            [62, -80],
            [76, -25],
            [58, -84],
            [87, -44],
            [-7, -46],
            [68, -65],
            [-96, -34],
            [-189, 13],
            [-254, 29],
            [-147, -8],
            [-253, -61],
            [-113, -9],
            [-135, 60],
            [-36, 63],
            [-40, 138],
            [-134, 26],
            [-64, 61],
            [8, 51],
            [-19, 67],
            [3, 72],
            [27, 20],
            [108, 5],
            [90, -33],
            [180, -29]
        ],
        [
            [28832, 89775],
            [13, -12],
            [130, 33],
            [149, 58],
            [170, 0],
            [9, -41],
            [60, -43],
            [25, 51],
            [36, 192],
            [4, 83],
            [-56, 40],
            [-126, 9],
            [-45, 29],
            [-62, 78],
            [-97, 67],
            [113, 64],
            [43, 63],
            [119, 2],
            [116, -16],
            [-61, 66],
            [67, 38],
            [-69, 17],
            [-95, -13],
            [-57, 21],
            [-92, 118],
            [-2, 79],
            [59, 84],
            [59, 16],
            [311, -87],
            [-6, 22],
            [-253, 92],
            [-89, 24],
            [-22, 34],
            [134, 128],
            [125, 30],
            [61, 37],
            [101, 2],
            [111, 65],
            [99, 31],
            [231, 55],
            [221, 0],
            [105, -19],
            [61, -34],
            [52, -87],
            [27, -92],
            [39, -38],
            [63, -22],
            [67, -47],
            [4, -108],
            [98, -102],
            [-124, -104],
            [-26, -57],
            [48, -17],
            [-67, -93],
            [-37, -27],
            [77, -60],
            [-71, -17],
            [-8, -87],
            [45, 7],
            [128, 122],
            [84, 37],
            [22, 100],
            [82, 25],
            [38, -59],
            [70, 2],
            [32, 30],
            [100, -66],
            [-2, -128],
            [44, 33],
            [14, 91],
            [37, 48],
            [83, -40],
            [97, 1],
            [120, -56],
            [59, 21],
            [-232, 79],
            [-51, 42],
            [-8, 41],
            [40, 51],
            [107, 49],
            [134, 27],
            [208, -9],
            [61, -14],
            [157, -69],
            [149, 0],
            [127, -51],
            [33, -26],
            [45, -91],
            [-4, -24],
            [-105, -104],
            [152, 33],
            [118, -8],
            [78, -27],
            [17, -55],
            [-32, -53],
            [-178, -66],
            [59, -28],
            [-52, -95],
            [34, -93],
            [49, 138],
            [61, 49],
            [81, 5],
            [46, 38],
            [86, -17],
            [-108, -163],
            [108, 89],
            [71, -60],
            [26, -59],
            [64, -13],
            [-37, 75],
            [10, 30],
            [116, 78],
            [99, -40],
            [67, 2],
            [151, -27],
            [128, -55],
            [63, -56],
            [12, -69],
            [-85, -75],
            [-112, 0],
            [-52, -22],
            [-84, -70],
            [-104, -61],
            [99, 1],
            [94, 101],
            [82, 19],
            [115, -40],
            [57, 2],
            [43, 40],
            [78, 29],
            [49, -54],
            [-6, -75],
            [-33, -44],
            [-80, -66],
            [-174, -60],
            [-94, -75],
            [63, -8],
            [37, 49],
            [59, 24],
            [30, -27],
            [-11, -162],
            [103, 207],
            [129, 88],
            [189, 59],
            [78, -33],
            [93, 2],
            [70, -14],
            [85, -43],
            [122, -43],
            [41, -71],
            [-37, -37],
            [-96, -51],
            [-156, -26],
            [-123, -49],
            [-112, -66],
            [82, -14],
            [97, 63],
            [174, 27],
            [60, -35],
            [-88, -93],
            [82, -20],
            [78, 68],
            [57, 13],
            [-4, 41],
            [36, 67],
            [44, 20],
            [63, -20],
            [152, -138],
            [59, -131],
            [-27, -43],
            [-169, 31],
            [-95, -13],
            [-79, -61],
            [-92, 0],
            [-141, -39],
            [16, -31],
            [89, 25],
            [84, 8],
            [140, -57],
            [216, -2],
            [95, -29],
            [87, -47],
            [28, -81],
            [-38, -21],
            [-163, 18],
            [-47, -10],
            [-87, 18],
            [-54, 27],
            [-80, -25],
            [-64, 16],
            [-66, -14],
            [-130, -61],
            [15, -10],
            [178, 52],
            [35, -4],
            [170, -71],
            [0, -58],
            [-41, -84],
            [-136, 34],
            [-124, -19],
            [-152, 35],
            [107, -63],
            [167, -15],
            [55, -29],
            [36, -73],
            [50, -15],
            [68, 15],
            [61, -29],
            [107, -21],
            [79, 6],
            [28, -26],
            [-72, -28],
            [-11, -27],
            [94, -110],
            [61, 68],
            [98, 16],
            [-19, -133],
            [15, -46],
            [74, 61],
            [3, -62],
            [35, -19],
            [50, 36],
            [65, -29],
            [-16, -95],
            [75, 97],
            [99, 58],
            [44, -30],
            [-59, -54],
            [2, -58],
            [59, -2],
            [59, 31],
            [34, -15],
            [115, -106],
            [42, 18],
            [52, -50],
            [-70, -39],
            [22, -83],
            [-92, 4],
            [-16, -55],
            [161, 5],
            [3, 29],
            [72, 34],
            [85, -23],
            [85, -56],
            [-37, -34],
            [-30, -84],
            [-137, -113],
            [228, 71],
            [180, -24],
            [79, 79],
            [48, -16],
            [140, -134],
            [66, -72],
            [-2, -23],
            [-68, -28],
            [-61, 45],
            [-55, 22],
            [-57, -29],
            [135, -69],
            [25, -72],
            [-90, -34],
            [-92, 14],
            [-66, 41],
            [-55, -2],
            [45, -51],
            [-39, -50],
            [90, -44],
            [77, -62],
            [-78, -17],
            [-69, 7],
            [-9, -25],
            [35, -78],
            [-70, -61],
            [-15, -47],
            [-96, -10],
            [-139, 48],
            [-72, -19],
            [98, -32],
            [-9, -41],
            [1, -175],
            [-12, -62],
            [-64, -106],
            [-40, 34],
            [-49, 67],
            [-51, 7],
            [-28, -31],
            [-98, 104],
            [-26, -76],
            [-34, 30],
            [-137, 164],
            [-21, 58],
            [-70, 109],
            [8, 33],
            [59, 65],
            [103, 43],
            [55, 98],
            [6, 53],
            [-108, -117],
            [-93, -38],
            [-73, -12],
            [-88, 5],
            [-9, 50],
            [-64, 26],
            [-45, 41],
            [-83, 41],
            [-72, 101],
            [-23, 53],
            [-164, -20],
            [39, -49],
            [0, -62],
            [-37, -10],
            [-77, 54],
            [-100, 38],
            [56, -111],
            [160, -131],
            [-27, -44],
            [-86, -19],
            [-86, 25],
            [-40, 27],
            [-58, 64],
            [-97, 67],
            [-2, -43],
            [77, -52],
            [-12, -78],
            [44, -62],
            [77, -30],
            [-28, -84],
            [15, -33],
            [104, 44],
            [53, -31],
            [29, -58],
            [58, -24],
            [-65, -47],
            [80, -63],
            [30, -88],
            [34, 3],
            [40, -129],
            [30, 79],
            [127, -82],
            [-24, -43],
            [46, -23],
            [66, 84],
            [52, -18],
            [79, -82],
            [25, 11],
            [49, -53],
            [-74, -59],
            [103, -9],
            [32, -41],
            [-42, -74],
            [-91, 8],
            [49, -48],
            [61, -81],
            [-6, -33],
            [49, -10],
            [103, 10],
            [-3, -37],
            [34, -35],
            [51, -107],
            [-46, -15],
            [19, -121],
            [-5, -111],
            [-56, 3],
            [-59, 156],
            [-31, 53],
            [-31, -21],
            [26, -152],
            [-20, -39],
            [122, -190],
            [-24, -20],
            [-53, 1],
            [-74, 25],
            [36, -129],
            [-41, -29],
            [-27, 36],
            [-94, 86],
            [-52, 35],
            [-38, -6],
            [-36, 45],
            [-75, 59],
            [7, -56],
            [-66, 11],
            [-58, 107],
            [-11, -77],
            [-104, 98],
            [-14, 34],
            [-49, -7],
            [-98, 99],
            [-66, 85],
            [-35, 0],
            [31, -118],
            [-36, 15],
            [-125, 104],
            [-77, 50],
            [-113, 14],
            [-16, -27],
            [74, -105],
            [92, -90],
            [72, -101],
            [69, -32],
            [74, -12],
            [-18, -46],
            [82, -35],
            [79, -58],
            [72, -80],
            [104, -55],
            [112, -167],
            [93, -52],
            [-15, -40],
            [-32, -19],
            [23, -105],
            [-62, -26],
            [-90, 32],
            [-78, 49],
            [-117, 33],
            [-80, 44],
            [-290, 47],
            [-48, 11],
            [-58, 35],
            [-111, 49],
            [-87, 92],
            [-56, 97],
            [-78, 25],
            [-84, -18],
            [-51, 3],
            [-103, 59],
            [-71, 23],
            [-91, 61],
            [-49, 13],
            [-76, 47],
            [-36, 34],
            [-110, 135],
            [85, 0],
            [75, 46],
            [-18, 41],
            [-66, 67],
            [-34, 10],
            [-119, -9],
            [-20, 27],
            [19, 75],
            [-69, -41],
            [-42, 46],
            [-17, 50],
            [-84, 71],
            [-81, 92],
            [-83, 79],
            [51, 76],
            [-107, 24],
            [-32, -19],
            [-56, 5],
            [-12, -63],
            [-46, -12],
            [-10, 92],
            [-88, 14],
            [-30, 20],
            [-37, 86],
            [-88, -32],
            [29, -28],
            [57, -89],
            [-17, -33],
            [-115, -23],
            [-81, 19],
            [-49, 28],
            [-70, -9],
            [-16, -74],
            [-108, -8],
            [-90, -41],
            [-47, -1],
            [-50, -33],
            [-173, 21],
            [-106, 46],
            [-51, 2],
            [-78, 74],
            [-40, 66],
            [-5, 75],
            [29, 104],
            [68, 75],
            [132, 49],
            [26, 33],
            [-30, 60],
            [42, 70],
            [169, -22],
            [91, -25],
            [202, -79],
            [56, -48],
            [45, -71],
            [-27, -61],
            [42, -35],
            [29, 93],
            [-45, 71],
            [-83, 68],
            [20, 32],
            [121, -22],
            [46, 5],
            [57, 54],
            [98, -8],
            [85, 17],
            [47, 48],
            [111, 20],
            [63, -20],
            [35, 33],
            [-57, 125],
            [-89, 61],
            [-75, 76],
            [-49, 70],
            [19, 39],
            [136, 84],
            [108, 83],
            [93, 93],
            [77, 30],
            [26, 86],
            [49, 83],
            [131, 57],
            [45, 67],
            [-41, 49],
            [-69, 177],
            [-46, 85],
            [-55, 74],
            [-50, 91],
            [-81, 89],
            [6, 56],
            [-104, -41],
            [-54, 38],
            [-18, 37],
            [30, 83],
            [-22, 69],
            [-82, 0],
            [47, -68],
            [-94, -21],
            [-47, 21],
            [-70, 72],
            [-10, 46],
            [-71, 18],
            [49, 38],
            [-51, 51],
            [-91, -41],
            [-96, 24],
            [-31, -36],
            [-240, -109],
            [-67, 16],
            [19, 161],
            [54, 24],
            [132, -12],
            [89, 71],
            [6, 30],
            [-43, 59],
            [-80, 38],
            [-112, 31],
            [-35, 42],
            [30, 95],
            [-51, -17],
            [-47, -47],
            [-119, 45],
            [80, 51],
            [-29, 45],
            [-83, 16],
            [-81, -10],
            [-44, 36],
            [-26, 150],
            [-38, 43],
            [-136, -10],
            [-104, 69],
            [-137, 140],
            [-58, -39],
            [-45, -54],
            [16, -36],
            [102, -26],
            [64, -82],
            [10, -73],
            [-35, -39],
            [-128, -46],
            [-96, 0],
            [-169, 56],
            [-289, 53],
            [-142, 11],
            [9, -35],
            [103, -36],
            [84, -74],
            [26, -44],
            [-25, -23],
            [-199, 118],
            [-177, -56],
            [-107, 13],
            [-187, 77],
            [-135, -21],
            [-102, -2],
            [-204, 24],
            [-120, 41],
            [-161, 18],
            [-108, -41],
            [-129, 38],
            [-38, 22],
            [-93, 143],
            [-57, -7],
            [-97, 13],
            [18, -49],
            [-135, 1],
            [-123, -41],
            [-155, 106],
            [-81, 16],
            [-57, 29],
            [-111, 132],
            [-50, 132],
            [2, 39],
            [262, -20],
            [64, -26],
            [143, -22],
            [205, 24],
            [13, 13],
            [-134, 54],
            [-93, 56],
            [-221, 18],
            [-151, 26],
            [-190, 76],
            [-47, 38],
            [-55, 255],
            [29, 56],
            [83, 60],
            [-50, 28],
            [-12, 114],
            [50, 87],
            [106, 132],
            [29, 147],
            [89, 103],
            [66, 33],
            [17, 51],
            [166, 107],
            [139, 71],
            [293, 62],
            [112, 12],
            [141, -3],
            [259, -23],
            [42, -64],
            [-71, -51],
            [-147, -79],
            [-125, -112],
            [-122, -167],
            [-46, -50],
            [-12, -60],
            [23, -57],
            [84, -112],
            [-6, -188],
            [38, -125],
            [56, -71],
            [154, -121],
            [142, -87],
            [17, -25],
            [-118, -71],
            [-167, -36],
            [-72, -37],
            [-127, -47]
        ],
        [
            [24693, 91411],
            [260, -119],
            [311, 48],
            [98, 34],
            [78, 5],
            [110, -25],
            [69, -98],
            [-48, -42],
            [-74, -15],
            [38, -99],
            [-162, -57],
            [-197, -159],
            [21, -37],
            [132, 57],
            [66, 0],
            [123, -55],
            [-15, -40],
            [90, -57],
            [10, -71],
            [118, 43],
            [39, -8],
            [32, -118],
            [-25, -52],
            [-85, -45],
            [63, -61],
            [-54, -88],
            [44, -44],
            [3, -74],
            [-102, -24],
            [-85, -66],
            [-112, -24],
            [-185, 18],
            [-15, -58],
            [10, -65],
            [-66, -52],
            [-77, -26],
            [-100, 38],
            [-56, -1],
            [-73, 105],
            [-102, 112],
            [-182, 138],
            [-83, 82],
            [-121, 32],
            [-69, 60],
            [-89, -22],
            [-70, 21],
            [-77, 95],
            [-132, 61],
            [-79, 69],
            [-18, 36],
            [65, 124],
            [93, 40],
            [87, -11],
            [52, -64],
            [65, -33],
            [59, -77],
            [81, -18],
            [186, 33],
            [28, 114],
            [52, -43],
            [40, 35],
            [-57, 88],
            [-77, 10],
            [29, 65],
            [133, -9],
            [-78, 57],
            [-194, -37],
            [-174, 87],
            [-22, 31],
            [62, 48],
            [107, 15],
            [92, -58],
            [22, 45],
            [-107, 64],
            [12, 64],
            [133, 21],
            [93, -23],
            [-14, 49],
            [70, 31]
        ],
        [
            [25227, 91368],
            [-217, -31],
            [-127, 37],
            [12, 26],
            [105, 22],
            [31, 23],
            [261, 55],
            [112, 2],
            [-18, -57],
            [-159, -77]
        ],
        [
            [26801, 91531],
            [209, -55],
            [84, -50],
            [182, 31],
            [168, -10],
            [142, -32],
            [84, -47],
            [-65, -101],
            [-113, -89],
            [-42, -62],
            [-71, -73],
            [-79, -27],
            [40, -23],
            [-61, -95],
            [-87, -98],
            [-66, -53],
            [-85, -20],
            [-292, 46],
            [-74, 0],
            [-195, -25],
            [136, -49],
            [61, -61],
            [5, -77],
            [-97, -94],
            [-51, -125],
            [-33, -15],
            [-109, 24],
            [-158, -18],
            [-57, 9],
            [8, 85],
            [-26, 179],
            [-92, 156],
            [-20, 89],
            [8, 130],
            [-17, 214],
            [3, 77],
            [76, 33],
            [176, -52],
            [-75, 80],
            [-28, 56],
            [34, 66],
            [172, 50],
            [168, 10],
            [48, -7],
            [115, 33],
            [74, -10]
        ],
        [
            [18601, 91504],
            [82, 50],
            [82, -2],
            [56, -86],
            [86, 83],
            [62, 29],
            [179, 12],
            [139, -19],
            [97, -34],
            [148, -80],
            [236, -156],
            [138, -72],
            [36, -65],
            [-17, -35],
            [-168, -65],
            [-151, -39],
            [-180, -81],
            [-124, -39],
            [-160, -76],
            [-302, -121],
            [-52, -42],
            [-85, -139],
            [-33, -32],
            [-78, -33],
            [-128, -17],
            [-4, -48],
            [-53, -133],
            [-24, -143],
            [-54, -70],
            [-96, -33],
            [-168, -32],
            [-85, 31],
            [-126, -100],
            [-121, -40],
            [-120, -59],
            [-84, 20],
            [-57, 53],
            [-62, 114],
            [-127, 142],
            [-232, 87],
            [-166, 77],
            [-145, -6],
            [1, 98],
            [55, 25],
            [-19, 30],
            [81, 105],
            [122, 91],
            [-13, 32],
            [9, 94],
            [22, 28],
            [107, 35],
            [-1, 44],
            [-77, 39],
            [75, 94],
            [52, 97],
            [96, 61],
            [26, 65],
            [72, 69],
            [-24, 33],
            [-66, 17],
            [-53, 53],
            [-135, 221],
            [379, 49],
            [261, 15],
            [270, 43],
            [134, -6],
            [235, -99],
            [188, -55],
            [118, -12],
            [-54, -67]
        ],
        [[25509, 91735], [-92, -34], [-29, 25], [103, 65], [18, -56]],
        [[26142, 91723], [-145, 26], [36, 48], [46, 0], [72, -55], [-9, -19]],
        [
            [23421, 92019],
            [-158, 14],
            [-78, 48],
            [73, 113],
            [94, 45],
            [83, -3],
            [84, -44],
            [50, -102],
            [-53, -46],
            [-95, -25]
        ],
        [
            [26686, 92015],
            [25, -96],
            [-26, -92],
            [-135, -26],
            [-220, -1],
            [-182, 84],
            [-179, 21],
            [-70, 56],
            [-55, -6],
            [-35, 44],
            [-54, -5],
            [-2, 60],
            [57, 63],
            [62, 16],
            [17, 66],
            [140, 95],
            [192, 52],
            [124, 0],
            [68, -16],
            [160, -95],
            [49, -41],
            [78, -119],
            [-14, -60]
        ],
        [[25904, 92284], [-119, -9], [-80, -64], [-92, 49], [11, 23], [142, 42], [48, 39], [126, -56], [-36, -24]],
        [[26383, 92417], [-70, 11], [-46, 90], [112, 37], [75, -117], [-71, -21]],
        [
            [19036, 92322],
            [-88, -36],
            [-63, 4],
            [-178, 53],
            [23, 26],
            [214, 135],
            [151, 50],
            [119, 65],
            [78, -19],
            [-40, -62],
            [-185, -198],
            [-31, -18]
        ],
        [[31156, 92515], [-19, -31], [-130, -25], [-48, 33], [46, 41], [167, 105], [51, -22], [-65, -68], [-2, -33]],
        [
            [24006, 92565],
            [55, -49],
            [-116, -32],
            [-48, -50],
            [-227, -9],
            [84, 86],
            [-49, 23],
            [-175, -37],
            [-67, 22],
            [57, 58],
            [-136, 6],
            [-51, 34],
            [17, 41],
            [387, 72],
            [158, -16],
            [30, -104],
            [81, -45]
        ],
        [
            [23451, 92882],
            [93, 10],
            [43, -35],
            [164, -50],
            [-9, -24],
            [-121, -43],
            [-246, -1],
            [-42, 21],
            [-55, 135],
            [117, 33],
            [56, -46]
        ],
        [
            [25403, 92817],
            [-2, -91],
            [54, -68],
            [-37, -135],
            [15, -49],
            [-80, -63],
            [140, -37],
            [0, -67],
            [-76, -25],
            [-69, -51],
            [8, -87],
            [46, -39],
            [-30, -41],
            [-99, -47],
            [-138, -13],
            [-181, 4],
            [-82, 15],
            [-64, -33],
            [-187, 13],
            [-38, 33],
            [-32, 85],
            [30, 40],
            [-114, 31],
            [6, 34],
            [134, 30],
            [97, 60],
            [115, 49],
            [-100, 14],
            [-304, -34],
            [-94, -17],
            [-79, 10],
            [-333, -53],
            [-79, 48],
            [168, 100],
            [33, 54],
            [62, 5],
            [106, -29],
            [52, 89],
            [-88, 9],
            [-48, 42],
            [106, 75],
            [-117, 9],
            [-71, 28],
            [86, 86],
            [161, -15],
            [62, -37],
            [25, -55],
            [320, -171],
            [102, 11],
            [-89, 39],
            [-63, 94],
            [-54, 41],
            [97, 11],
            [-41, 38],
            [-147, 20],
            [-74, 45],
            [19, 27],
            [136, 50],
            [99, 12],
            [123, -6],
            [154, -95],
            [87, 6],
            [-42, 83],
            [97, 45],
            [147, -67],
            [132, -31],
            [33, -29]
        ],
        [[24315, 92880], [-88, 27], [107, 21], [62, 38], [105, 10], [109, -10], [-295, -86]],
        [
            [22134, 92589],
            [135, 0],
            [30, -66],
            [-66, -56],
            [170, 38],
            [88, -16],
            [50, -59],
            [86, 21],
            [-52, 67],
            [57, 52],
            [87, 20],
            [152, -28],
            [92, -44],
            [38, -103],
            [-12, -63],
            [-49, -73],
            [-56, -173],
            [-71, -57],
            [-269, -83],
            [-59, -8],
            [-206, 41],
            [-165, -32],
            [-74, 10],
            [-12, 35],
            [-61, 23],
            [-207, -101],
            [-208, -24],
            [-138, -49],
            [-98, -63],
            [-243, -77],
            [-244, -47],
            [-154, -8],
            [-153, 15],
            [-100, 33],
            [-133, 64],
            [-34, 38],
            [76, 53],
            [249, 61],
            [151, 55],
            [199, 20],
            [161, 5],
            [127, 60],
            [69, 56],
            [-45, 18],
            [-90, -38],
            [-242, -32],
            [-105, 43],
            [-110, -58],
            [-234, -22],
            [-41, 25],
            [-13, 55],
            [39, 61],
            [-91, 54],
            [-35, -99],
            [-88, -85],
            [-175, -62],
            [-80, 70],
            [-61, 1],
            [-78, -76],
            [-128, 41],
            [-102, 73],
            [-164, -9],
            [-153, 27],
            [-30, 38],
            [65, 83],
            [72, 29],
            [333, 11],
            [229, 70],
            [66, 49],
            [-282, -56],
            [-121, -12],
            [-185, 9],
            [-43, 25],
            [59, 56],
            [180, 35],
            [170, 18],
            [112, 0],
            [150, 31],
            [-416, -9],
            [-97, 27],
            [32, 49],
            [-19, 32],
            [124, 67],
            [392, -16],
            [-26, 26],
            [-198, 15],
            [-52, 32],
            [78, 79],
            [180, 33],
            [143, 2],
            [105, -28],
            [42, -84],
            [72, -52],
            [202, 28],
            [146, -31],
            [112, -72],
            [145, -74],
            [-59, -59],
            [167, -13],
            [74, -110],
            [69, -36],
            [183, 4],
            [423, -28],
            [43, 20],
            [1, 88],
            [-263, 91],
            [-23, 37],
            [129, 51],
            [-10, 69],
            [-69, 38],
            [-152, 43],
            [-21, 71],
            [125, 59],
            [163, 132],
            [74, 29],
            [82, 6],
            [113, -47],
            [-50, -84],
            [36, -83],
            [98, -60],
            [22, -54],
            [-80, -66],
            [28, -32]
        ],
        [[27864, 92840], [-101, -7], [-74, 47], [-81, 86], [10, 30], [178, 27], [78, -53], [-39, -62], [29, -68]],
        [[20507, 92971], [-46, -18], [-321, 27], [-26, 20], [128, 45], [163, 11], [116, -39], [-14, -46]],
        [
            [26454, 93065],
            [149, 1],
            [185, -89],
            [4, -47],
            [149, -37],
            [130, 7],
            [156, 33],
            [150, 3],
            [175, -55],
            [36, -65],
            [-198, 20],
            [-22, -30],
            [148, -6],
            [485, -75],
            [20, -24],
            [-58, -39],
            [-280, -17],
            [-159, 15],
            [-133, 25],
            [-6, -39],
            [80, -10],
            [95, -37],
            [142, -13],
            [68, -46],
            [161, -63],
            [94, -53],
            [-48, -65],
            [25, -45],
            [112, -62],
            [35, 27],
            [-19, 48],
            [91, 32],
            [114, -74],
            [145, 35],
            [59, -51],
            [87, 75],
            [137, -71],
            [178, -47],
            [103, 19],
            [-51, 34],
            [151, 43],
            [64, -4],
            [119, 41],
            [118, 4],
            [208, 93],
            [214, -38],
            [211, 37],
            [124, 7],
            [156, -20],
            [153, -33],
            [46, -51],
            [210, -8],
            [61, -49],
            [8, -41],
            [135, -10],
            [47, -86],
            [-39, -54],
            [-223, -82],
            [99, -34],
            [94, 17],
            [64, -18],
            [38, -40],
            [-33, -21],
            [-134, -26],
            [-83, -47],
            [-20, -93],
            [-293, -9],
            [-180, -50],
            [-80, 3],
            [-107, 30],
            [-99, -3],
            [-60, 20],
            [-58, 71],
            [5, 69],
            [-94, 38],
            [-25, -28],
            [45, -39],
            [-59, -100],
            [-276, -43],
            [-121, 19],
            [-161, 0],
            [-144, -24],
            [-94, 22],
            [-171, -28],
            [-102, -5],
            [-114, 13],
            [-70, -18],
            [-257, 13],
            [-35, 64],
            [61, 98],
            [-105, 10],
            [-30, -49],
            [-136, 10],
            [7, -53],
            [-112, -46],
            [-88, -4],
            [-160, 35],
            [-59, 1],
            [-71, 47],
            [-107, 22],
            [-1, -48],
            [-116, 0],
            [-112, 52],
            [-28, 28],
            [-65, 144],
            [30, 40],
            [-84, 59],
            [-24, 65],
            [29, 74],
            [81, 100],
            [-36, 105],
            [-89, 78],
            [-126, 127],
            [-65, 78],
            [-66, 3],
            [-111, -48],
            [-330, 11],
            [-81, -20],
            [-85, 4],
            [-54, 55],
            [-121, 30],
            [-61, 39],
            [77, 28],
            [-263, 93],
            [-12, 35],
            [76, 25],
            [-117, 57],
            [17, 32],
            [215, 44],
            [130, 8],
            [158, -26],
            [257, -59]
        ],
        [
            [19893, 93317],
            [-22, -55],
            [-182, -48],
            [-23, -43],
            [133, -74],
            [-18, -34],
            [-99, -19],
            [90, -77],
            [-86, -70],
            [-240, -44],
            [-14, -88],
            [-34, -42],
            [-104, -14],
            [-108, 40],
            [-55, 57],
            [17, 71],
            [57, 117],
            [-31, 12],
            [-130, -39],
            [-51, -105],
            [-109, -34],
            [54, -39],
            [1, -46],
            [-65, -43],
            [-44, -63],
            [-53, -10],
            [-62, 53],
            [-87, 33],
            [3, -69],
            [-26, -32],
            [54, -26],
            [-57, -76],
            [-55, -32],
            [-153, -19],
            [-48, 102],
            [-64, 88],
            [-40, -1],
            [-37, -80],
            [-126, -22],
            [-148, 30],
            [-152, -50],
            [-74, 36],
            [29, 40],
            [-70, 82],
            [126, 96],
            [232, 23],
            [190, 139],
            [158, 57],
            [39, 52],
            [163, 104],
            [229, 129],
            [335, 43],
            [181, -36],
            [83, 24],
            [94, -11],
            [43, 22],
            [-100, 29],
            [60, 54],
            [146, 8],
            [250, -100]
        ],
        [
            [27831, 93263],
            [-122, -30],
            [-236, 65],
            [-47, 32],
            [-1, 123],
            [95, 26],
            [207, -33],
            [139, -85],
            [3, -74],
            [-38, -24]
        ],
        [
            [23286, 93193],
            [-47, -10],
            [-156, 33],
            [-105, 95],
            [-101, 153],
            [-56, 55],
            [147, 6],
            [92, -53],
            [88, -75],
            [16, -49],
            [127, -45],
            [27, -50],
            [-32, -60]
        ],
        [
            [26087, 93556],
            [77, -21],
            [175, 12],
            [202, -9],
            [133, 6],
            [87, -17],
            [53, -45],
            [-65, -17],
            [-56, -86],
            [-97, -13],
            [-177, 13],
            [-487, 5],
            [-86, 62],
            [38, 67],
            [203, 43]
        ],
        [[24170, 93503], [-119, -3], [-117, 44], [4, 61], [249, 7], [158, -45], [39, -43], [-214, -21]],
        [
            [20424, 93535],
            [-141, -18],
            [-99, 26],
            [-115, 82],
            [-15, 29],
            [216, 61],
            [15, -41],
            [158, -56],
            [46, -50],
            [-65, -33]
        ],
        [
            [21465, 93729],
            [247, -13],
            [-35, -68],
            [-302, -56],
            [9, -42],
            [175, -10],
            [11, -77],
            [-25, -56],
            [-149, -44],
            [-168, -10],
            [-224, -47],
            [-130, 11],
            [-84, 45],
            [-160, 48],
            [13, 57],
            [-46, 81],
            [17, 70],
            [281, 58],
            [339, 45],
            [231, 8]
        ],
        [[23766, 93753], [-79, 21], [46, 35], [99, -16], [-66, -40]],
        [
            [21663, 94034],
            [97, -37],
            [43, -50],
            [-8, -87],
            [-99, -19],
            [-96, 11],
            [-123, -16],
            [-104, 9],
            [-127, 42],
            [-82, -55],
            [-101, -2],
            [-114, 46],
            [-322, -46],
            [-37, 28],
            [44, 42],
            [157, 50],
            [132, 27],
            [156, 15],
            [197, 75],
            [205, 27],
            [182, -60]
        ],
        [
            [25865, 93968],
            [73, -15],
            [125, 7],
            [164, -48],
            [44, -48],
            [-136, -67],
            [121, -66],
            [-46, -63],
            [-286, -59],
            [-143, -8],
            [-159, -37],
            [-32, 71],
            [-103, 27],
            [-71, 60],
            [190, 15],
            [-87, 48],
            [-153, 15],
            [-134, 111],
            [-19, 49],
            [79, 23],
            [-71, 75],
            [24, 62],
            [256, -12],
            [246, -53],
            [99, -51],
            [19, -36]
        ],
        [
            [23636, 94405],
            [158, -47],
            [80, -76],
            [-24, -70],
            [265, 67],
            [52, -6],
            [207, -91],
            [-35, -51],
            [71, -23],
            [149, 21],
            [130, -51],
            [125, -81],
            [-74, -81],
            [30, -75],
            [58, -13],
            [133, -91],
            [41, -67],
            [-52, -78],
            [-243, -35],
            [-195, 54],
            [-59, 59],
            [-15, 51],
            [-76, 59],
            [-70, 3],
            [-234, 45],
            [-170, -17],
            [-38, 68],
            [-292, -29],
            [-83, -33],
            [-117, 5],
            [-135, 46],
            [-72, 93],
            [83, 34],
            [297, -34],
            [87, 42],
            [-137, 39],
            [112, 16],
            [14, 43],
            [-151, -3],
            [-45, 28],
            [86, 49],
            [-85, 49],
            [-75, -19],
            [-106, -73],
            [-72, 17],
            [73, 75],
            [-52, 34],
            [-196, -10],
            [-10, 73],
            [56, 89],
            [167, -7],
            [352, 23],
            [87, -21]
        ],
        [
            [25066, 94776],
            [-15, -136],
            [-142, 27],
            [-66, 57],
            [-178, 18],
            [12, 97],
            [99, 28],
            [178, -11],
            [80, -23],
            [32, -57]
        ],
        [
            [27198, 95419],
            [189, -158],
            [182, -91],
            [12, -52],
            [241, -53],
            [165, 18],
            [50, -29],
            [-10, -120],
            [55, -36],
            [149, -38],
            [49, 53],
            [-72, 16],
            [-10, 74],
            [160, 23],
            [139, -32],
            [16, -103],
            [-92, -50],
            [222, -30],
            [70, -83],
            [-52, -129],
            [88, -36],
            [65, 27],
            [354, -65],
            [135, -113],
            [-69, -66],
            [-248, -61],
            [-285, -112],
            [-186, -124],
            [-75, 17],
            [-31, 104],
            [-71, -15],
            [-11, -119],
            [59, -15],
            [16, -50],
            [-93, -22],
            [-91, 58],
            [-50, -10],
            [42, -107],
            [-57, -111],
            [-94, 9],
            [-173, 129],
            [-83, 74],
            [-47, -13],
            [176, -193],
            [-45, -6],
            [-115, 55],
            [-84, 21],
            [-53, -33],
            [44, -47],
            [-89, -20],
            [-245, 22],
            [-151, 27],
            [-241, 85],
            [-15, 54],
            [244, 42],
            [-240, 24],
            [-171, 2],
            [-113, 80],
            [92, 31],
            [-175, 36],
            [-80, 68],
            [268, 81],
            [188, 26],
            [43, 54],
            [209, 19],
            [-190, 68],
            [-104, 6],
            [-343, -89],
            [-2, 53],
            [-144, 3],
            [-215, -56],
            [-195, 72],
            [22, 60],
            [353, 78],
            [-19, 33],
            [-221, -40],
            [-173, 11],
            [-187, 97],
            [-39, 38],
            [-57, 123],
            [306, -39],
            [351, -10],
            [17, 85],
            [-252, -37],
            [-74, 54],
            [-80, -10],
            [-143, 44],
            [11, 34],
            [222, 24],
            [-166, 88],
            [6, 76],
            [129, 19],
            [151, -22],
            [103, -64],
            [297, -6],
            [-206, 45],
            [-59, 62],
            [-224, 48],
            [75, 91],
            [89, 27],
            [143, -10],
            [214, 41],
            [182, 13],
            [-53, 45],
            [-243, 18],
            [42, 60],
            [224, 9],
            [284, -48],
            [163, -81]
        ],
        [
            [34111, 96469],
            [333, -6],
            [93, -25],
            [468, -10],
            [52, -21],
            [-127, -49],
            [-470, -79],
            [57, -17],
            [239, 13],
            [516, 97],
            [132, -24],
            [161, 43],
            [84, -55],
            [115, 25],
            [204, -29],
            [-37, -43],
            [156, -72],
            [-49, -64],
            [238, 39],
            [240, -17],
            [94, -27],
            [37, -90],
            [-279, -132],
            [-437, -110],
            [-303, -62],
            [-201, 5],
            [-84, -42],
            [-157, -22],
            [-191, -7],
            [-89, -73],
            [-548, -107],
            [114, -18],
            [797, 130],
            [295, -1],
            [-16, -30],
            [-201, -86],
            [-256, -77],
            [-128, -59],
            [-323, -101],
            [-264, -101],
            [-238, -142],
            [-103, -31],
            [-126, 17],
            [-38, -92],
            [-258, -26],
            [-114, -23],
            [-45, -41],
            [228, 28],
            [96, -16],
            [-59, -53],
            [-184, -49],
            [75, -35],
            [-85, -48],
            [-178, -34],
            [-146, -3],
            [-312, 74],
            [-215, 29],
            [-159, -25],
            [188, -32],
            [178, -12],
            [75, -63],
            [-3, -51],
            [-70, -32],
            [-123, 4],
            [-167, -27],
            [-121, 3],
            [-142, -21],
            [-159, 6],
            [-91, 23],
            [-70, -33],
            [55, -49],
            [159, -48],
            [157, -20],
            [189, 14],
            [-16, -98],
            [-216, -10],
            [-210, 46],
            [-458, -34],
            [-366, 10],
            [216, -74],
            [326, 42],
            [176, -6],
            [94, -26],
            [48, -39],
            [215, -18],
            [206, -74],
            [-35, -58],
            [-103, -42],
            [-160, -13],
            [-301, -1],
            [273, -65],
            [91, -42],
            [-110, -60],
            [-98, -118],
            [-151, -10],
            [-191, -36],
            [-320, 11],
            [-22, -56],
            [2, -182],
            [-64, -59],
            [-181, -45],
            [-320, -19],
            [-205, 9],
            [-94, 24],
            [-199, 84],
            [-41, -6],
            [116, -74],
            [-76, -30],
            [-167, -16],
            [69, -38],
            [95, 0],
            [129, 31],
            [137, -15],
            [123, -52],
            [108, 24],
            [132, 2],
            [48, -21],
            [37, -124],
            [132, -30],
            [156, 53],
            [89, -70],
            [5, -54],
            [-93, -103],
            [-201, -67],
            [-178, -78],
            [-364, -75],
            [-94, 22],
            [50, 85],
            [-43, 57],
            [-61, 24],
            [-130, -16],
            [-71, 20],
            [-65, 61],
            [-100, 3],
            [38, -95],
            [-357, -14],
            [-153, 7],
            [-104, 124],
            [-16, -178],
            [-268, -29],
            [-166, 25],
            [-190, 80],
            [-82, 14],
            [-37, -78],
            [-208, 39],
            [-44, -34],
            [-187, 15],
            [-90, -4],
            [-126, 28],
            [-237, 20],
            [22, 187],
            [225, 93],
            [115, 61],
            [176, 18],
            [144, 0],
            [151, 36],
            [-70, 60],
            [-102, 22],
            [-108, 81],
            [-97, 126],
            [24, 37],
            [160, 48],
            [148, 12],
            [196, -47],
            [65, -35],
            [136, -132],
            [44, -27],
            [263, -55],
            [236, 16],
            [113, 29],
            [217, 162],
            [86, 113],
            [-24, 15],
            [-224, -190],
            [-108, -50],
            [-120, -5],
            [-98, 22],
            [-116, -35],
            [-132, 33],
            [-1, 114],
            [-79, 91],
            [159, 75],
            [129, 75],
            [-91, 24],
            [-35, 41],
            [-122, -95],
            [-52, -18],
            [-195, -16],
            [48, 59],
            [-112, 6],
            [-150, -39],
            [-132, 3],
            [-66, 24],
            [19, 134],
            [166, 138],
            [45, 62],
            [175, 27],
            [170, 11],
            [142, 33],
            [408, -35],
            [197, -39],
            [87, 41],
            [169, -2],
            [1, 36],
            [-192, 20],
            [-222, 3],
            [-166, 17],
            [-66, 70],
            [85, 11],
            [133, -35],
            [50, 18],
            [-165, 75],
            [-276, 216],
            [-113, 43],
            [-177, 18],
            [-120, 69],
            [-60, 155],
            [36, 75],
            [59, 34],
            [354, -27],
            [340, -5],
            [103, -18],
            [416, -179],
            [161, -104],
            [121, -38],
            [131, -22],
            [173, -5],
            [109, 36],
            [-273, 13],
            [-263, 147],
            [-146, 61],
            [-194, 118],
            [-8, 25],
            [140, 29],
            [480, 39],
            [287, 47],
            [130, 66],
            [384, 76],
            [474, 53],
            [-167, 15],
            [-358, 9],
            [-25, 68],
            [106, 69],
            [232, 86],
            [-135, 5],
            [-235, -100],
            [-143, -19],
            [-126, -131],
            [-163, -66],
            [-269, -61],
            [-421, -52],
            [-159, 9],
            [169, 84],
            [-329, -8],
            [-208, -88],
            [-105, -16],
            [-275, -1],
            [-129, 31],
            [-162, -9],
            [-109, 55],
            [109, 70],
            [310, 111],
            [175, 30],
            [411, 34],
            [18, 25],
            [-415, -28],
            [-354, -35],
            [-140, -47],
            [-338, -157],
            [-118, -7],
            [-161, 26],
            [-212, 57],
            [-106, 61],
            [263, 47],
            [316, -6],
            [281, 26],
            [206, 49],
            [224, 69],
            [-38, 27],
            [-206, -30],
            [-231, -66],
            [-201, -23],
            [-498, -13],
            [-227, -14],
            [-110, 51],
            [10, 27],
            [228, 43],
            [-132, 29],
            [65, 48],
            [248, 63],
            [-110, 22],
            [-409, -78],
            [-77, 35],
            [219, 83],
            [-242, 24],
            [-239, -43],
            [-76, 59],
            [132, 58],
            [225, 50],
            [343, 22],
            [251, 80],
            [156, 20],
            [131, -6],
            [129, -48],
            [183, 29],
            [145, -15],
            [158, -40],
            [103, 51],
            [-392, 79],
            [-11, 18],
            [254, 41],
            [160, 63],
            [117, 25],
            [163, -42],
            [240, -27],
            [179, -103],
            [109, 9],
            [37, 50],
            [294, -71],
            [320, -64],
            [129, 13],
            [-413, 91],
            [-163, 48],
            [-140, 83],
            [237, 51],
            [-136, 47],
            [168, 23],
            [237, -32],
            [-104, 72],
            [152, 30],
            [179, -35],
            [321, -18],
            [-53, 33],
            [-193, 46],
            [-95, 44],
            [78, 24],
            [218, -3],
            [203, -23],
            [322, -4],
            [327, -119],
            [85, -67],
            [179, 32],
            [-414, 174],
            [-67, 49],
            [426, 22],
            [411, -19],
            [352, -135],
            [153, -9],
            [-205, 84],
            [34, 52],
            [160, 46],
            [256, 11],
            [173, -45],
            [170, 43],
            [278, 10],
            [149, -55]
        ],
        [[58394, 76761], [21, -41], [62, -46], [32, -2]],
        [[58500, 76538], [-13, -55], [1, -61], [29, -3]],
        [
            [58786, 76312],
            [-17, -112],
            [10, -64],
            [-49, 8],
            [-24, 32],
            [-33, -12],
            [-15, -65],
            [33, -128],
            [-32, -9],
            [-32, 69],
            [-17, 4],
            [-75, -41],
            [-34, 6],
            [-15, 24],
            [-17, 74],
            [-51, -4],
            [-3, -105],
            [-15, -37],
            [-56, -94],
            [-7, -38],
            [15, -60],
            [-29, -25],
            [-21, 49],
            [-33, 43],
            [12, 45],
            [-54, 19],
            [-57, 76],
            [-4, 87],
            [-23, 24],
            [-43, -58],
            [-46, -48],
            [13, -53],
            [-40, -81],
            [-64, -52],
            [-77, 31],
            [-65, -36],
            [-61, -18],
            [-33, 25]
        ],
        [
            [57727, 75788],
            [-21, 51],
            [-56, 83],
            [14, 61],
            [-19, 78],
            [-55, 12],
            [-46, -4],
            [-60, -54],
            [12, -45],
            [-58, -59],
            [-35, 3],
            [-1, 35],
            [39, 36],
            [9, 56],
            [-20, 27],
            [31, 102],
            [77, 81],
            [14, 107],
            [52, 31],
            [101, 147],
            [15, 31],
            [-31, 40],
            [48, 53],
            [25, 0],
            [21, -32],
            [67, 13],
            [23, 51],
            [37, 26]
        ],
        [
            [57910, 76718],
            [26, -13],
            [70, -4],
            [52, 7],
            [32, 17],
            [67, -9],
            [-4, 55],
            [33, 44],
            [34, -1],
            [34, -37],
            [20, 10],
            [27, -34],
            [93, 8]
        ],
        [[34701, 19018], [-79, 14], [22, 27], [67, -5], [-10, -36]],
        [[34790, 19081], [-84, 29], [4, 23], [61, 40], [27, -73], [-8, -19]],
        [[35042, 19387], [-25, -25], [-26, 22], [35, 38], [16, -35]],
        [
            [34854, 19429],
            [-54, -72],
            [-44, 6],
            [-20, 50],
            [-38, -6],
            [-56, -37],
            [-93, 21],
            [-20, 27],
            [-12, 57],
            [-40, 50],
            [60, 29],
            [72, 0],
            [194, -27],
            [43, -48],
            [8, -50]
        ],
        [
            [34045, 19560],
            [247, -55],
            [77, 33],
            [60, -1],
            [18, -46],
            [-61, -48],
            [4, -28],
            [63, -7],
            [30, -36],
            [-7, -56],
            [47, -45],
            [29, -45],
            [3, -70],
            [-56, 23],
            [-19, 45],
            [-93, 40],
            [-84, -1],
            [-20, 45],
            [13, 60],
            [-37, 4],
            [-44, 40],
            [-45, 10],
            [-19, -75],
            [55, -97],
            [-71, 17],
            [-30, 41],
            [-32, 17],
            [-21, 67],
            [-45, -9],
            [-48, 49],
            [18, 48],
            [12, 100],
            [56, -20]
        ],
        [
            [33647, 19588],
            [20, -42],
            [38, -13],
            [119, 32],
            [42, -87],
            [-38, -56],
            [-43, 3],
            [-16, 44],
            [-35, -14],
            [-71, 25],
            [-16, 40],
            [-65, 54],
            [-58, -23],
            [-6, 53],
            [129, -16]
        ],
        [
            [33524, 20054],
            [68, -45],
            [46, 1],
            [5, -75],
            [-43, -71],
            [-102, 79],
            [-89, 1],
            [-17, -26],
            [-40, -14],
            [-8, 53],
            [-73, 88],
            [20, 61],
            [46, 30],
            [136, -39],
            [51, -43]
        ],
        [
            [33051, 20361],
            [12, -54],
            [61, 12],
            [63, -17],
            [85, -123],
            [-31, -30],
            [-19, -66],
            [-60, -52],
            [-35, -3],
            [-60, -27],
            [-3, 48],
            [30, 48],
            [6, 50],
            [-68, 3],
            [-31, -31],
            [-11, -52],
            [-57, 36],
            [-3, 120],
            [-48, -4],
            [-34, 45],
            [-19, 48],
            [-63, 13],
            [49, 67],
            [74, 9],
            [25, -34],
            [82, -23],
            [-3, 49],
            [43, 1],
            [15, -33]
        ],
        [
            [32599, 20673],
            [99, -24],
            [88, -51],
            [39, -7],
            [63, -42],
            [46, -64],
            [23, -55],
            [-110, 32],
            [-10, 40],
            [-55, 60],
            [-62, 25],
            [-85, -3],
            [-89, 89],
            [-19, 49],
            [15, 35],
            [46, -49],
            [11, -35]
        ],
        [
            [34369, 19596],
            [-133, -31],
            [-124, 28],
            [-74, 82],
            [-94, -58],
            [-34, -2],
            [-44, 38],
            [-66, -32],
            [-132, 53],
            [-94, 11],
            [-66, 42],
            [-120, -4],
            [-30, 54],
            [65, 48],
            [34, -30],
            [78, 57],
            [60, -31],
            [60, 17],
            [21, 46],
            [61, -6],
            [0, -77],
            [39, -10],
            [85, 10],
            [-75, 102],
            [-68, 35],
            [-31, 72],
            [-2, 127],
            [69, 34],
            [-16, 53],
            [51, 56],
            [27, -149],
            [20, -52],
            [-77, -10],
            [29, -73],
            [48, -25],
            [41, -54],
            [1, -39],
            [23, -17],
            [93, 6],
            [39, 35],
            [37, -33],
            [62, -24],
            [52, -84],
            [64, 84],
            [-47, 29],
            [-244, 137],
            [-30, 55],
            [-21, 68],
            [1, 71],
            [62, 50],
            [80, 40],
            [104, 67],
            [-13, 59],
            [-75, 22],
            [-73, -9],
            [-67, -38],
            [-74, 23],
            [-26, 41],
            [-14, 55],
            [5, 67],
            [16, 33],
            [60, 20],
            [21, 27],
            [-77, 106],
            [58, 16],
            [61, -55],
            [18, 0],
            [53, 50],
            [82, 134],
            [26, 3],
            [76, -101],
            [27, -4],
            [90, 55],
            [49, -43]
        ],
        [[32674, 21226], [-60, 18], [-26, 30], [-16, 66], [35, -14], [70, -67], [-3, -33]],
        [
            [32464, 21393],
            [14, -108],
            [41, -23],
            [35, -70],
            [-41, -94],
            [-9, -66],
            [-49, 4],
            [-20, 66],
            [-31, 64],
            [-27, 139],
            [30, 36],
            [29, -8],
            [2, 49],
            [26, 11]
        ],
        [
            [32546, 21590],
            [-1, -46],
            [-18, -20],
            [-34, 16],
            [-38, -37],
            [-60, 20],
            [-30, -71],
            [-48, -17],
            [45, 154],
            [35, -22],
            [49, 22],
            [45, 40],
            [39, 0],
            [16, -39]
        ],
        [[32316, 21923], [-8, -51], [-25, 4], [-21, 62], [16, 96], [84, -9], [-15, -46], [-28, -9], [-3, -47]],
        [[32393, 22137], [-61, -44], [-17, 18], [-44, 0], [38, 185], [139, -55], [12, -49], [-67, -55]],
        [
            [32377, 22951],
            [-3, -44],
            [-45, -86],
            [-76, -90],
            [-41, 20],
            [47, 63],
            [-8, 41],
            [-38, 37],
            [6, 32],
            [154, 63],
            [4, -36]
        ],
        [
            [32571, 22777],
            [3, -81],
            [-17, -183],
            [20, -38],
            [-12, -94],
            [-30, -82],
            [-52, -3],
            [-15, 46],
            [-3, 64],
            [-18, 49],
            [21, 67],
            [2, 50],
            [-48, -9],
            [-9, -41],
            [-1, -81],
            [-23, -56],
            [-72, 2],
            [-47, 44],
            [-30, -12],
            [-6, 52],
            [15, 42],
            [57, -3],
            [9, 74],
            [-50, 76],
            [44, 50],
            [34, -13],
            [40, 12],
            [-2, 48],
            [-36, 20],
            [8, 36],
            [72, 69],
            [-9, 79],
            [26, 48],
            [31, 15],
            [70, -27],
            [12, -33],
            [16, -187]
        ],
        [
            [32252, 22992],
            [-35, -1],
            [-8, 100],
            [41, 143],
            [3, 55],
            [-16, 89],
            [52, 29],
            [16, -31],
            [20, -80],
            [37, -116],
            [-1, -110],
            [-21, -27],
            [-64, -28],
            [-24, -23]
        ],
        [
            [32543, 23087],
            [-110, -19],
            [-27, 51],
            [-12, 80],
            [-50, 139],
            [-11, 65],
            [16, 29],
            [68, 29],
            [25, 46],
            [21, -6],
            [-6, -95],
            [36, -59],
            [20, -96],
            [16, -25],
            [-1, -46],
            [15, -93]
        ],
        [[32375, 23508], [-46, 41], [53, 41], [26, -2], [28, -35], [-61, -45]],
        [
            [32622, 24705],
            [-47, -37],
            [-30, 19],
            [-36, -9],
            [-4, 43],
            [41, 76],
            [20, 56],
            [-3, 78],
            [25, 46],
            [35, 17],
            [7, -58],
            [-9, -105],
            [23, -61],
            [-1, -44],
            [-21, -21]
        ],
        [[32832, 25190], [-19, -6], [-33, 82], [6, 70], [29, 7], [14, -36], [8, -79], [-5, -38]],
        [
            [33031, 25213],
            [-74, -45],
            [-38, 15],
            [-29, 107],
            [40, 62],
            [15, 50],
            [2, 50],
            [16, 9],
            [55, -27],
            [58, -41],
            [24, -51],
            [-41, -91],
            [-28, -38]
        ],
        [
            [32800, 25428],
            [-76, -56],
            [-6, -54],
            [26, -35],
            [27, -103],
            [13, -109],
            [19, -47],
            [-8, -83],
            [-30, -41],
            [-52, -2],
            [-25, 11],
            [3, 72],
            [-33, 28],
            [-22, 48],
            [-26, 83],
            [-21, 25],
            [-25, 66],
            [-36, 56],
            [42, 35],
            [-7, 62],
            [62, 43],
            [28, -17],
            [35, 21],
            [-3, 63],
            [8, 50],
            [27, 26],
            [29, 3],
            [26, -56],
            [35, -22],
            [-10, -67]
        ],
        [[32777, 25744], [-45, -53], [-50, 20], [-7, 37], [54, 2], [34, 18], [14, -24]],
        [[32512, 25866], [-44, -9], [-2, 42], [37, -2], [9, -31]],
        [
            [32788, 26013],
            [-45, -15],
            [-60, 8],
            [-74, 52],
            [-6, 44],
            [26, 59],
            [25, 112],
            [16, 161],
            [-13, 61],
            [12, 147],
            [27, 62],
            [17, 120],
            [-6, 53],
            [94, -46],
            [63, -10],
            [23, -151],
            [4, -62],
            [-28, -20],
            [2, -44],
            [17, -41],
            [-51, -23],
            [-48, -44],
            [36, -66],
            [33, -32],
            [40, -97],
            [-32, -77],
            [-64, -47],
            [3, -74],
            [-11, -30]
        ],
        [[31236, 31421], [-56, -12], [30, 51], [26, -39]],
        [[21829, 35048], [-48, -17], [14, 57], [35, -15], [-1, -25]],
        [
            [34434, 20988],
            [-175, 53],
            [-39, 28],
            [-33, 4],
            [-63, -36],
            [-35, -85],
            [-63, -47],
            [-44, -4],
            [-150, -82],
            [-53, -7],
            [-71, -53],
            [-14, -68],
            [6, -41],
            [-41, -147],
            [-10, -123],
            [11, -68],
            [-14, -117],
            [-27, -25],
            [-67, -33],
            [-45, 24],
            [-77, 21],
            [-55, 45],
            [-93, 50],
            [-63, 90],
            [-11, 67],
            [33, 54],
            [113, 11],
            [27, -29],
            [19, -111],
            [16, 141],
            [105, 70],
            [34, 41],
            [34, 63],
            [7, 42],
            [-71, 45],
            [-158, -132],
            [-71, -35],
            [-46, -38],
            [-56, -68],
            [-22, -66],
            [-6, -49],
            [-55, 22],
            [-83, 73],
            [-17, 26],
            [42, 68],
            [8, 139],
            [50, 61],
            [31, -31],
            [54, 2],
            [103, 92],
            [43, 2],
            [56, -21],
            [64, 13],
            [25, 31],
            [-93, 38],
            [-128, 9],
            [-28, -10],
            [-37, -49],
            [-21, 37],
            [-43, 17],
            [-41, -27],
            [-8, -75],
            [-40, -39],
            [-27, -61],
            [-1, -73],
            [-31, -29],
            [-66, 11],
            [-53, 84],
            [-42, 38],
            [92, 46],
            [33, 26],
            [-1, 46],
            [-43, 16],
            [-63, -50],
            [-38, 13],
            [-63, -15],
            [-31, 28],
            [4, 70],
            [-11, 62],
            [-35, 11],
            [-45, 147],
            [79, -23],
            [63, -41],
            [41, 19],
            [6, 68],
            [47, -42],
            [63, -7],
            [59, 20],
            [59, 46],
            [31, 48],
            [46, -14],
            [53, 53],
            [11, 71],
            [-17, 32],
            [-67, 74],
            [-113, 74],
            [-22, -21],
            [126, -76],
            [64, -68],
            [-6, -35],
            [-101, -34],
            [-80, -73],
            [-60, -44],
            [-42, 16],
            [-41, 103],
            [-31, 34],
            [-68, 6],
            [-69, 58],
            [39, 57],
            [43, -22],
            [11, 160],
            [-14, 36],
            [-56, 40],
            [-65, 0],
            [-149, 74],
            [-74, 154],
            [-13, 59],
            [80, 1],
            [47, 9],
            [11, 25],
            [-39, 82],
            [40, 61],
            [25, -12],
            [62, -59],
            [54, -161],
            [15, -23],
            [90, -68],
            [8, 58],
            [25, 78],
            [40, 38],
            [-43, 49],
            [-43, -135],
            [-27, -25],
            [-68, 121],
            [4, 70],
            [-37, 48],
            [-37, 27],
            [-63, 87],
            [60, 72],
            [31, 51],
            [97, -27],
            [19, 15],
            [-66, 49],
            [-47, 69],
            [11, 100],
            [58, 27],
            [65, -38],
            [0, 56],
            [-63, 52],
            [22, 104],
            [-36, -4],
            [-25, -139],
            [-45, 56],
            [-5, 338],
            [13, 110],
            [51, 57],
            [1, 37],
            [-52, -36],
            [-41, 16],
            [-8, 56],
            [-24, 49],
            [-2, 154],
            [57, -8],
            [46, -18],
            [122, 2],
            [101, -87],
            [44, 12],
            [-36, 39],
            [-33, 63],
            [-33, 189],
            [-10, -4],
            [-30, -114],
            [-29, -35],
            [-89, -22],
            [-38, 14],
            [-8, 63],
            [-72, 40],
            [-14, 32],
            [38, 75],
            [40, -19],
            [25, -37],
            [24, -7],
            [34, 50],
            [-59, 33],
            [-49, 56],
            [25, 57],
            [75, 81],
            [-15, 56],
            [17, 60],
            [-17, 50],
            [-32, 54],
            [-44, 12],
            [-18, -66],
            [-55, 12],
            [-37, 36],
            [-60, 32],
            [-15, 63],
            [-28, 16],
            [-59, -26],
            [-44, -9],
            [-27, -37],
            [37, -12],
            [18, -62],
            [-13, -40],
            [-21, -4],
            [-42, 44],
            [-23, 49],
            [16, 91],
            [126, 135],
            [54, 75],
            [46, 42],
            [-46, 86],
            [2, 72],
            [94, 29],
            [41, -12],
            [52, 2],
            [94, 41],
            [19, 29],
            [4, 40],
            [-13, 83],
            [27, 43],
            [36, 6],
            [29, -22],
            [-17, -68],
            [-24, -148],
            [-31, -63],
            [12, -60],
            [-19, -43],
            [-85, -45],
            [-5, -19],
            [88, 14],
            [37, 38],
            [28, 171],
            [44, 20],
            [13, -27],
            [-5, -118],
            [-31, -171],
            [-39, -69],
            [-2, -39],
            [30, 3],
            [23, 37],
            [34, 113],
            [-2, 47],
            [12, 126],
            [11, 49],
            [0, 68],
            [-50, 41],
            [-8, 42],
            [15, 83],
            [56, -3],
            [53, 57],
            [55, 16],
            [69, -54],
            [11, 19],
            [-38, 32],
            [-50, 58],
            [-67, 9],
            [25, 145],
            [88, 33],
            [105, 103],
            [18, 79],
            [5, 87],
            [-51, 23],
            [-53, 58],
            [-82, 69],
            [13, 151],
            [48, 20],
            [22, 128],
            [-32, 99],
            [8, 73],
            [42, 63],
            [19, 91],
            [37, 4],
            [-3, 74],
            [-24, 55],
            [-1, 78],
            [23, 91],
            [44, -2],
            [-48, 116],
            [4, 24],
            [44, 33],
            [25, -32],
            [42, -73],
            [-14, 101],
            [-12, 126],
            [-39, -17],
            [-35, 9],
            [-27, 48],
            [25, 60],
            [62, 61],
            [-39, 18],
            [-42, 64],
            [-45, 17],
            [-20, -17],
            [-49, -113],
            [-21, -19],
            [-86, -9],
            [-66, 31],
            [15, 57],
            [-7, 37],
            [-31, 31],
            [-14, 40],
            [-6, 70],
            [-28, 113],
            [-6, 80],
            [20, 57],
            [42, 225],
            [13, 114],
            [22, 101],
            [0, 67],
            [58, 60],
            [22, 37],
            [50, 204],
            [7, 111],
            [-78, 334],
            [-13, 64],
            [-3, 80],
            [18, 132],
            [3, 50],
            [-16, 72],
            [-45, 118],
            [-1, 61],
            [19, 62],
            [-18, 77],
            [18, 85],
            [70, -20],
            [32, 9],
            [17, 23],
            [14, 63],
            [17, 204],
            [34, 25],
            [12, 59],
            [29, 82],
            [29, 229],
            [59, 122],
            [-11, 97],
            [37, 78],
            [36, 115],
            [51, 80],
            [12, 98],
            [39, 170],
            [8, 109],
            [12, 74],
            [-3, 68],
            [46, 154],
            [7, 39],
            [51, 93],
            [9, 75],
            [-18, 50],
            [-1, 78],
            [-14, 108],
            [47, 70],
            [43, 173],
            [-3, 68],
            [12, 84],
            [-28, 100],
            [-4, 224],
            [-16, 172],
            [-26, 183],
            [3, 102],
            [-16, 126],
            [-1, 74],
            [12, 166],
            [83, 104],
            [16, 117],
            [10, 158],
            [-3, 115],
            [-9, 52],
            [-41, 85],
            [-10, 151],
            [8, 40],
            [34, 43],
            [24, 59],
            [12, 92],
            [25, 72],
            [10, 175],
            [31, 188],
            [39, 77],
            [5, 47],
            [-1, 110],
            [5, 67],
            [26, 132],
            [3, 61],
            [29, 136],
            [7, 98],
            [12, 51],
            [-4, 58],
            [8, 130],
            [-20, 74],
            [-4, 42],
            [25, 133],
            [44, 95],
            [14, 113],
            [-35, 220],
            [-5, 75],
            [8, 174],
            [12, 113],
            [-3, 90],
            [9, 104],
            [24, 70],
            [6, 50],
            [-37, 47],
            [-24, 63],
            [-1, 63],
            [9, 111],
            [35, 13],
            [19, 36],
            [18, 67],
            [22, 163],
            [9, 203],
            [23, 182],
            [8, 126],
            [13, 82],
            [0, 134],
            [-34, 294],
            [1, 108],
            [15, 168],
            [-1, 237],
            [-3, 56],
            [-12, 51],
            [-4, 71],
            [-20, 122],
            [-18, 245],
            [-1, 130],
            [-8, 110],
            [-17, 29]
        ],
        [
            [33824, 39952],
            [72, 11],
            [39, 24],
            [41, 43],
            [27, 63],
            [11, 57],
            [0, 50],
            [-15, 110],
            [14, 22],
            [37, 8],
            [54, 80]
        ],
        [
            [89787, 61328],
            [25, -61],
            [13, -127],
            [-31, -38],
            [-28, -16],
            [-56, -149],
            [-21, -66],
            [-2, -41],
            [-35, -196],
            [-16, -27],
            [-46, -24],
            [-29, -48],
            [-33, -36],
            [5, -32],
            [-77, -28],
            [-35, -77],
            [-57, -23],
            [-37, 35],
            [-114, 48],
            [-101, 94],
            [-8, 120],
            [-13, 87],
            [5, 200],
            [13, 41],
            [30, 44],
            [35, 35],
            [49, 74],
            [36, 34],
            [30, 48],
            [-30, 4],
            [12, 42],
            [30, 34],
            [32, -8],
            [29, 8],
            [22, 37],
            [21, 8],
            [79, -12],
            [54, 17],
            [27, 33],
            [54, -8],
            [22, 9],
            [53, -44],
            [3, 68],
            [25, 22],
            [40, -68],
            [25, -13]
        ],
        [[89631, 61942], [12, -19], [31, 13], [5, -36], [-11, -28], [-25, 22], [-44, -3], [9, 41], [23, 10]],
        [[90374, 62226], [-15, 9], [-9, 44], [27, -1], [-3, -52]],
        [[90610, 62896], [-40, 30], [12, 26], [28, -56]],
        [[92038, 63840], [-10, -34], [-18, 6], [4, 59], [24, -31]],
        [[92544, 64375], [-23, -26], [-14, 13], [7, 115], [32, -18], [-2, -84]],
        [[92985, 65841], [-37, -13], [1, 41], [22, 38], [14, -66]],
        [[93308, 66888], [-43, 21], [-41, 7], [-14, 28], [-3, 44], [44, -2], [53, -40], [12, -20], [-8, -38]],
        [
            [93174, 67740],
            [-25, -16],
            [-81, 48],
            [-56, 53],
            [-34, 64],
            [34, 21],
            [39, -22],
            [9, -35],
            [26, -32],
            [71, -47],
            [17, -34]
        ],
        [[96553, 75309], [0, 46], [-26, 45], [-45, 37], [-55, 18], [-53, 0], [-49, -23], [-15, -29]],
        [
            [96310, 75403],
            [-35, 21],
            [-18, 30],
            [-61, -68],
            [-23, -67],
            [-41, -56],
            [-67, -36],
            [-45, -5],
            [-35, -62],
            [28, -78],
            [60, -328],
            [-13, -38],
            [-12, -166],
            [3, -111],
            [24, -41],
            [-26, -162],
            [-28, -58],
            [-5, -76],
            [-39, -28],
            [-23, 7],
            [-90, -29],
            [-47, -47],
            [47, -58],
            [-16, -49]
        ],
        [
            [95848, 73898],
            [-51, 53],
            [-35, 63],
            [-2, 82],
            [-49, 46],
            [-18, -6],
            [-39, 20],
            [-36, -124],
            [-19, -168],
            [-60, -50],
            [-31, 28],
            [-34, -12],
            [-30, -57],
            [-7, -52],
            [-83, -101],
            [-54, 2],
            [-100, -17],
            [-37, 8],
            [-81, -21],
            [-3, -49],
            [46, -111],
            [23, -25],
            [10, -52],
            [-28, -72],
            [-27, -24],
            [-30, 33],
            [-30, 7],
            [-71, -12],
            [-53, 23],
            [-29, 1],
            [-75, 27],
            [-53, 117],
            [-32, 22],
            [-49, -31],
            [-44, -47],
            [-34, -158],
            [-25, -20],
            [-49, -103],
            [-33, -33],
            [-48, -97],
            [-81, -21],
            [-25, -49],
            [-16, 0],
            [-55, -66],
            [-31, -9],
            [-89, -67],
            [-9, -33],
            [-34, -3],
            [-54, -78],
            [-72, -77],
            [-29, -43],
            [-7, -56]
        ],
        [
            [93946, 72486],
            [-30, -44],
            [-50, -47],
            [-106, -10],
            [-34, 33],
            [-22, -53],
            [-71, -13],
            [-38, -43],
            [-60, -7],
            [-22, -30],
            [-37, -11],
            [-156, -130],
            [-66, -120],
            [-43, -55],
            [-36, -32],
            [-58, 4],
            [-14, -27],
            [5, -50],
            [-41, -19],
            [-60, -13],
            [-49, -42],
            [-13, 45],
            [-4, 60],
            [48, 22],
            [129, 83],
            [-16, 62],
            [40, 71],
            [8, 30],
            [-84, -15],
            [-73, 6],
            [7, 38],
            [-10, 51],
            [43, 43],
            [35, 10],
            [-14, 64],
            [14, 50],
            [87, 59],
            [21, 54],
            [35, 50],
            [64, 124],
            [26, 102],
            [-29, 34],
            [-12, 48],
            [-87, 86],
            [-7, 73],
            [-33, -71],
            [-40, -2],
            [-19, 20],
            [-112, 13],
            [-28, -34],
            [-50, -88],
            [-47, -53],
            [-90, -199],
            [-34, -15],
            [-160, -121],
            [-80, -47],
            [-62, -84],
            [-40, -107],
            [-11, -85],
            [-57, -104],
            [-40, -31],
            [-49, -3],
            [-39, 9],
            [-101, -61],
            [-47, 71],
            [-33, 18],
            [-54, -20],
            [-25, -32],
            [-51, -157],
            [-20, -90],
            [1, -37],
            [31, -112],
            [34, -62],
            [76, -72],
            [164, -49],
            [38, 17],
            [41, 0],
            [43, -46],
            [27, -78],
            [3, -71],
            [16, -42],
            [-30, -33],
            [-11, -82],
            [-1, -91],
            [49, -73],
            [54, -35],
            [50, -7],
            [96, 17],
            [39, 55],
            [-1, 54],
            [84, 80],
            [48, 71],
            [-16, 32],
            [34, 12],
            [118, 74],
            [92, -60],
            [53, -70],
            [52, -12],
            [77, -66],
            [101, -8],
            [28, 46],
            [35, -40],
            [52, -29],
            [81, 12],
            [20, -13],
            [-29, -47],
            [5, -77],
            [-44, -63],
            [24, -36],
            [-1, -31],
            [-55, -64],
            [-21, 1],
            [-34, 69],
            [-71, 1],
            [-81, -69],
            [-80, -55],
            [-83, -43],
            [-47, -35],
            [-35, 21],
            [-25, -16],
            [27, -38],
            [4, -53],
            [-37, 7],
            [-20, -24],
            [-9, -40],
            [-1, -96],
            [-13, -22],
            [-37, -12],
            [-39, -30],
            [-19, 31],
            [-1, 66],
            [-44, -14],
            [-28, -47],
            [27, -57],
            [32, -18],
            [-20, -28],
            [-51, -41],
            [-23, -67],
            [-35, -54],
            [-45, -31],
            [-60, -128],
            [-30, -32],
            [-24, -104],
            [-42, -57],
            [-15, -91],
            [11, -56],
            [46, 0],
            [23, -19],
            [48, -74],
            [58, -48],
            [60, -27],
            [73, -68],
            [20, -29],
            [18, -58],
            [32, -169],
            [22, -84],
            [2, -43],
            [34, -83],
            [37, -141],
            [42, -123],
            [8, -96],
            [-14, -45],
            [1, -57],
            [42, -52],
            [93, -62],
            [34, -47],
            [1, -93],
            [26, -47],
            [57, -39],
            [49, -84],
            [10, -110],
            [-57, 5],
            [-102, 82],
            [-63, -10],
            [-53, 16],
            [-56, 90],
            [-41, 28],
            [-43, 13],
            [-104, -77],
            [2, -34],
            [48, 26],
            [47, 37],
            [67, -20],
            [22, -91],
            [47, -39],
            [36, -17],
            [46, -51],
            [45, -80],
            [96, -92],
            [38, -87],
            [29, -137],
            [-34, -26],
            [-74, -17],
            [-34, -28],
            [-33, -51],
            [-97, -78],
            [-31, -93],
            [-23, -21],
            [-59, 20],
            [-56, -1],
            [-63, -59],
            [33, -20],
            [44, 31],
            [43, -94],
            [83, 15],
            [79, 79],
            [56, -11],
            [28, -31],
            [76, -138],
            [42, -15],
            [40, -33],
            [43, -13],
            [-55, -51],
            [-70, -109],
            [4, -40],
            [41, 52],
            [36, 1],
            [9, -65],
            [-16, -198],
            [-20, -3],
            [-19, 54],
            [-23, 17],
            [-56, -11],
            [-27, -59],
            [23, -7],
            [44, -60],
            [-7, -53],
            [6, -36],
            [-10, -47],
            [-34, -30],
            [-13, -40],
            [39, -153],
            [2, -42],
            [-31, 18],
            [-48, -53],
            [-25, -4],
            [-17, 69],
            [-37, -31],
            [-43, -141],
            [-20, -19],
            [-45, 4],
            [26, -41],
            [0, -25],
            [-45, -82],
            [-7, -59],
            [-23, -33],
            [12, -55],
            [-27, -91],
            [-48, -91],
            [-33, -32],
            [-43, -118],
            [-13, -59],
            [-3, -61],
            [-37, -47],
            [-26, 13],
            [-21, 105],
            [-32, -39],
            [-38, 32],
            [15, -92],
            [28, -6],
            [18, -35],
            [29, -119],
            [-58, -54],
            [-71, -102],
            [-46, 5],
            [-53, 33],
            [38, -82],
            [47, -11],
            [26, 30],
            [36, -3],
            [10, -47],
            [-30, -123],
            [-4, -60],
            [25, -86],
            [-9, -38],
            [-52, 51],
            [-49, 4],
            [-36, -30],
            [7, -32],
            [23, -27],
            [13, -42],
            [-16, -15],
            [-65, 10],
            [-14, -8],
            [-20, -46],
            [13, -68],
            [-15, -42],
            [-26, -10],
            [-58, -42],
            [26, -50],
            [-19, -70],
            [-30, -23],
            [-46, 12],
            [-36, -16],
            [-31, 30],
            [-33, 0],
            [-23, -37],
            [-2, -43],
            [-51, -5],
            [11, -43],
            [45, -10],
            [10, -74],
            [-47, -78],
            [-20, -52],
            [-30, 1],
            [-23, -42],
            [-12, -57],
            [-15, 11],
            [-35, -9],
            [-10, -27],
            [9, -31],
            [-14, -65],
            [-15, -18],
            [-12, 67],
            [-76, -72],
            [-16, 25],
            [-37, 13],
            [-16, -108],
            [-55, -70],
            [-4, -56],
            [-40, -27],
            [-6, -96],
            [-15, -34],
            [-39, -3],
            [-29, 23],
            [-29, -53],
            [-29, -4],
            [-65, -43],
            [-65, 29],
            [-25, -16],
            [-19, -60],
            [-36, 0],
            [-58, 55],
            [-32, -19],
            [-24, -41],
            [-31, -14],
            [-18, -37],
            [-32, 5],
            [-12, 63],
            [-19, 9],
            [-33, -75],
            [3, -51],
            [-18, -1],
            [-23, 31],
            [-25, 5],
            [-23, -29]
        ],
        [[90829, 62749], [-24, 14], [-42, -13], [-11, -17]],
        [
            [90752, 62733],
            [-26, 11],
            [-32, 42],
            [-23, 71],
            [-28, 38],
            [-13, 33],
            [-11, 88],
            [11, 60],
            [-31, -14],
            [-23, -26],
            [-1, -64],
            [-34, -16],
            [4, -26],
            [27, -42],
            [5, -35],
            [32, -74],
            [0, -106],
            [11, -30],
            [-19, -58],
            [-15, -28],
            [-46, -28],
            [-19, -32],
            [-36, -8],
            [-19, 75],
            [-25, -50],
            [-7, -101],
            [-25, -31],
            [-30, 35],
            [-45, -48],
            [-23, -46],
            [-28, 23],
            [-37, 56],
            [4, -65],
            [-26, -33],
            [-34, 12],
            [-52, 44],
            [-25, 4],
            [-6, -41],
            [-16, -33],
            [-30, 1],
            [-29, -62],
            [-25, -27],
            [-65, -14],
            [-22, -27],
            [-68, -1],
            [-26, 15],
            [-6, -45],
            [-69, -24],
            [-63, -97],
            [-34, 10],
            [-82, -108],
            [-12, -52],
            [8, -48],
            [57, -11],
            [7, -27],
            [-23, -66],
            [61, -86],
            [2, -32],
            [-21, -58],
            [-32, -34],
            [-68, -17],
            [-57, 17],
            [-18, 39],
            [20, 61],
            [-26, 22],
            [-22, 60],
            [4, 50],
            [-44, 115],
            [13, 75],
            [-7, 44],
            [24, 54],
            [6, 61],
            [44, 22],
            [3, 58],
            [-31, 2],
            [-22, 42],
            [-22, -19],
            [-29, 82],
            [-22, 12],
            [7, -87],
            [-61, -47],
            [-61, -16],
            [-21, 9],
            [16, 57],
            [-32, 46],
            [-80, 3],
            [-48, 78],
            [-7, 72],
            [-35, 2],
            [4, -92],
            [10, -38],
            [-25, -35],
            [-19, 40],
            [-18, 8],
            [-24, -76],
            [-31, 4],
            [-53, -32]
        ],
        [
            [88887, 62173],
            [-53, 77],
            [-13, 5],
            [-37, -23],
            [-52, -8],
            [-12, 24],
            [-25, -18],
            [-24, 56],
            [-29, 4],
            [-49, 66],
            [-4, 32],
            [-86, 60],
            [-20, -12],
            [-3, 146],
            [-6, 27],
            [-25, 29],
            [-6, 30],
            [15, 99],
            [36, 36],
            [25, 79],
            [-74, 72],
            [-63, -25],
            [-27, 3],
            [-31, 57],
            [-46, 2],
            [-12, -21],
            [-37, -8],
            [-46, 60],
            [-45, 24],
            [-16, 60],
            [-45, 71],
            [-23, 21],
            [-26, -36],
            [-101, -81],
            [-11, -20],
            [-10, -105],
            [-33, -50],
            [-50, -10],
            [-48, -56],
            [-22, 5],
            [-27, 54],
            [-49, -32],
            [-25, -112],
            [-18, -7],
            [-91, 136],
            [-15, -27],
            [-14, -68],
            [-17, -8],
            [-35, 87],
            [-28, -22],
            [-40, -68],
            [0, -28],
            [-40, -50],
            [-22, 8],
            [-33, 67],
            [-96, 86],
            [-28, -5],
            [-59, -148],
            [-33, -49]
        ],
        [
            [87083, 62659],
            [-32, 34],
            [-25, 0],
            [-32, -29],
            [-25, 57],
            [-27, -16],
            [-16, -75],
            [-30, -41],
            [12, -51],
            [13, -96],
            [41, -91],
            [3, -123],
            [-7, -162],
            [24, -44],
            [-30, -48],
            [-50, 47],
            [-31, -2],
            [-50, -26],
            [-17, 22],
            [-2, 66],
            [-13, 36],
            [6, 64],
            [-18, 26]
        ],
        [
            [86777, 62207],
            [-5, 99],
            [-31, -5],
            [-57, -46],
            [-49, -83],
            [-45, -26],
            [-56, 23],
            [-42, -21],
            [-21, 10],
            [-18, 43],
            [2, 57],
            [-36, 23],
            [-16, 67],
            [7, 93],
            [-10, 22],
            [-100, 34],
            [-63, 12],
            [-26, -5],
            [-34, 14],
            [-7, 37],
            [22, 99],
            [29, 71],
            [1, 107],
            [14, 76],
            [38, 74],
            [-13, 49],
            [-39, 28],
            [-88, 19],
            [-59, 34],
            [7, 65],
            [-8, 74],
            [-19, 44],
            [10, 58],
            [-13, 64],
            [-33, 58],
            [6, 68],
            [41, 70],
            [-22, 15],
            [-55, -26],
            [-26, 25],
            [-89, -2],
            [-60, -26],
            [-56, -44],
            [-46, -49],
            [-38, 7],
            [1, 43],
            [38, 80],
            [5, 54],
            [-12, 85],
            [-32, 35],
            [-10, 27],
            [-1, 78],
            [17, 80],
            [43, 37],
            [-2, 108],
            [32, 121],
            [30, -9],
            [29, 31],
            [27, 69],
            [14, 87],
            [9, 13],
            [38, -14],
            [12, 10],
            [40, 112],
            [50, 21],
            [9, 51],
            [-20, 48],
            [-6, 62],
            [28, 14],
            [7, 28],
            [-4, 60],
            [12, 74],
            [6, 85],
            [3, 113],
            [-7, 145],
            [-13, 81],
            [0, 129],
            [-7, 84],
            [-46, 42],
            [-29, -5],
            [-18, -56],
            [-16, 6],
            [-18, 63],
            [-34, 170],
            [-10, 97],
            [-51, 96],
            [-21, 28],
            [-30, -4],
            [-23, 63],
            [-29, 26],
            [-19, -3],
            [-67, -163]
        ],
        [
            [85599, 65915],
            [-54, 68],
            [-22, 16],
            [-29, -18],
            [-63, 17],
            [-38, 46],
            [-16, 6],
            [-54, -31],
            [-12, -21],
            [-34, 34],
            [36, 99],
            [58, 88],
            [-45, 160],
            [-28, -13],
            [-57, -66],
            [-12, 96],
            [67, 72],
            [-1, 28],
            [-31, -8],
            [-33, 75],
            [-29, 37],
            [-100, -74],
            [-60, -60],
            [0, -31],
            [-30, -54],
            [-43, -3],
            [-87, 56],
            [-71, 15],
            [-11, 42],
            [-34, 34],
            [-48, -54],
            [-54, -40],
            [-56, -94],
            [-29, -9],
            [-1, -29],
            [-34, -58],
            [-74, -63],
            [-93, -20],
            [-34, -14],
            [-14, -21],
            [-27, -106],
            [-26, -41],
            [-47, -56],
            [-56, -45],
            [-18, -48],
            [14, -20],
            [-7, -42],
            [-57, -58],
            [-20, -12],
            [-45, 3],
            [-52, -12],
            [-38, -43],
            [-107, 16]
        ],
        [[82997, 65412], [-39, 63], [-5, 52], [25, 136], [6, 57], [-14, 77], [-56, 47], [-61, -44], [-97, -44], [0, -35]],
        [
            [82756, 65721],
            [-77, 9],
            [-55, -36],
            [-121, 0],
            [-46, 9],
            [-38, 50],
            [-83, 52],
            [-18, 41],
            [-42, -5],
            [-12, -68],
            [-33, -20],
            [-59, 52],
            [-25, 52],
            [-18, -17],
            [-5, -83],
            [-34, -4],
            [-35, 116],
            [-50, 79],
            [-82, -1],
            [-62, 9],
            [-27, 13],
            [-11, 32],
            [22, 122],
            [-28, 10],
            [-66, -31],
            [-43, 23],
            [-20, 36],
            [-57, 52],
            [-17, 28],
            [-56, 60],
            [-39, 172],
            [-52, 34],
            [-81, -52],
            [-27, -2],
            [-39, 68],
            [-32, 75],
            [-61, 96],
            [-44, 3],
            [-49, 37],
            [-114, 144],
            [-82, 68],
            [-19, 28],
            [-36, 118],
            [-58, 20],
            [-66, 14],
            [-69, -28],
            [-50, -136],
            [-24, -29],
            [-21, -2],
            [-31, 71]
        ],
        [
            [80564, 67000],
            [-7, 40],
            [-74, 69],
            [-20, 31],
            [-130, 81],
            [-21, 4],
            [1, 107],
            [-35, 12],
            [-49, 60],
            [-2, 3],
            [-38, 41],
            [-71, -11],
            [-60, 73],
            [-9, 15],
            [-72, 165],
            [-30, 7],
            [-11, -48],
            [-23, 2],
            [-33, -21],
            [-15, 16],
            [4, 63],
            [-9, 20],
            [23, 81],
            [-34, 69],
            [8, 82]
        ],
        [
            [79857, 67961],
            [5, 39],
            [-74, 144],
            [-32, 169],
            [7, 21],
            [89, 22],
            [21, -72],
            [46, -61],
            [46, 17],
            [18, 49],
            [29, 14],
            [-1, 35],
            [5, 77],
            [-9, 60],
            [-1, 76],
            [-29, 43],
            [9, 83],
            [-7, 30],
            [-51, 67],
            [-45, 86],
            [-6, 172],
            [-17, 114],
            [8, 41],
            [55, 57],
            [12, 22],
            [-11, 69],
            [-82, 92],
            [-106, 50],
            [-14, 26],
            [-63, 268],
            [-20, 65],
            [11, 111],
            [-12, 22],
            [-35, -23],
            [-26, 20],
            [-4, 7]
        ],
        [[79573, 69973], [-70, -14], [-39, 2], [-110, 43], [-65, 34], [-34, 27]],
        [
            [79255, 70065],
            [-63, 62],
            [-4, 64],
            [-92, -43],
            [-32, 10],
            [-24, 86],
            [-39, 20],
            [-12, 39],
            [19, 45],
            [2, 119],
            [-13, 78],
            [-28, 71],
            [-54, 51],
            [-29, 10],
            [-46, -12],
            [-24, 98],
            [-90, 41],
            [-51, -19],
            [-61, 46],
            [-46, -7]
        ],
        [
            [78676, 70940],
            [36, 35],
            [34, 51],
            [-7, 37],
            [-62, 84],
            [13, 95],
            [-14, 85],
            [-32, 100],
            [-5, 95],
            [20, 72],
            [-28, 59],
            [-72, 50],
            [-73, 34],
            [-45, 1],
            [-32, -68],
            [-49, 13],
            [-21, 24],
            [-32, 138],
            [30, 49],
            [1, 34],
            [-33, 57],
            [-26, 69],
            [8, 123]
        ],
        [
            [78287, 72177],
            [59, 22],
            [28, 66],
            [-24, 108],
            [48, 135],
            [29, 17],
            [49, 10],
            [52, 26],
            [82, 96],
            [50, 19],
            [-12, 47],
            [20, 36],
            [43, -24],
            [73, 17],
            [86, 82],
            [19, -12],
            [23, -154],
            [6, -13],
            [60, -2],
            [59, 47],
            [29, -6],
            [32, 30],
            [18, -44],
            [50, 55],
            [30, 71],
            [19, 92],
            [57, 134],
            [50, 31],
            [61, -15],
            [31, 2],
            [92, -12],
            [72, 35],
            [44, -3],
            [51, 14],
            [69, 114],
            [5, 51],
            [117, 105],
            [171, 124],
            [18, -1],
            [127, 66],
            [23, 54],
            [22, 11],
            [94, 9],
            [10, 15],
            [-12, 73]
        ],
        [
            [80317, 73705],
            [16, 25],
            [-17, 92],
            [-12, 148],
            [26, 74],
            [90, 63],
            [-49, 35],
            [2, 39],
            [70, 47],
            [41, -14],
            [11, 33],
            [-17, 63],
            [-19, 20],
            [11, 65],
            [-17, 76],
            [-47, 183],
            [-20, 33],
            [-24, 82],
            [3, 70],
            [-9, 120],
            [20, 133],
            [17, 38],
            [-62, 35],
            [-79, -6],
            [-39, 48],
            [58, 68],
            [52, 16],
            [126, 51],
            [67, 2],
            [58, 22],
            [173, 79],
            [28, 22],
            [21, -22],
            [9, -47],
            [24, -25],
            [38, -11],
            [85, 32],
            [66, -53],
            [24, 18],
            [20, 76],
            [1, 46],
            [-13, 38],
            [-79, 43],
            [-4, 42],
            [36, 121],
            [25, 108],
            [13, 85],
            [43, 127],
            [33, 133],
            [63, 228],
            [8, 85],
            [50, 0],
            [136, -80],
            [118, -40],
            [100, 14],
            [101, -13],
            [37, -79],
            [70, 43],
            [68, 71],
            [78, 15],
            [28, 70],
            [25, 37],
            [4, 47],
            [-26, 86],
            [-8, 141],
            [-11, 95],
            [31, 160],
            [38, 101],
            [25, 13],
            [70, 9],
            [65, 17],
            [87, 41],
            [52, 94],
            [13, 92],
            [-10, 43],
            [8, 39],
            [41, 46],
            [50, 10],
            [85, -13]
        ],
        [[82513, 77550], [29, -5], [30, 25], [93, 23]],
        [
            [82665, 77593],
            [14, -110],
            [-36, -47],
            [27, -50],
            [61, -31],
            [6, -34],
            [-24, -40],
            [3, -27],
            [102, -46],
            [32, -38],
            [32, -11],
            [15, -37],
            [3, -55],
            [81, -66],
            [24, -7],
            [40, -48],
            [46, -12],
            [41, 24],
            [46, 3],
            [26, -14],
            [24, -53],
            [43, -46],
            [77, 28],
            [23, -73],
            [65, -39],
            [34, -96],
            [22, -122],
            [68, -157],
            [48, -27],
            [36, -115],
            [14, -123],
            [-37, -144],
            [26, -92],
            [1, -39],
            [-46, -83],
            [-17, -18],
            [-27, -69],
            [-14, -114],
            [59, -147],
            [7, -37],
            [53, 12],
            [81, -55],
            [40, 3],
            [44, -26],
            [138, -5],
            [44, -18],
            [77, -15],
            [48, 1],
            [65, 14],
            [156, -30],
            [69, -21],
            [43, -24],
            [65, -99],
            [28, -27],
            [74, -17],
            [51, -70],
            [40, -26],
            [68, -68],
            [104, -51],
            [93, 10],
            [-8, -96],
            [10, -55],
            [52, -29],
            [20, -56],
            [77, -262],
            [6, -60],
            [16, -39],
            [52, -62],
            [68, -93],
            [26, -116],
            [253, 39],
            [159, -30],
            [379, -67],
            [161, -27],
            [159, 61],
            [342, -70],
            [124, -7],
            [51, -22],
            [17, -19],
            [51, -97],
            [29, -42],
            [57, -33],
            [282, -85],
            [197, -142],
            [243, 71],
            [0, -122],
            [112, -8],
            [38, -27],
            [21, 11],
            [45, 68],
            [36, 18],
            [171, 125],
            [279, 164],
            [99, 18],
            [203, 45],
            [96, 14],
            [34, 12],
            [159, -18],
            [137, 14],
            [65, -1],
            [32, 9],
            [78, 55],
            [111, 59],
            [106, 64],
            [9, 22],
            [178, 294],
            [154, 84],
            [13, 2],
            [69, 94],
            [50, 26],
            [0, 58],
            [-29, 67],
            [-48, 59],
            [-50, 84],
            [-11, 45],
            [-26, 53],
            [27, 81],
            [41, 175],
            [40, 80],
            [45, 53],
            [42, 9],
            [25, -10],
            [92, -3],
            [27, -26],
            [30, -52],
            [34, -19],
            [106, -41],
            [77, -10],
            [89, -26],
            [20, 10],
            [69, 74],
            [48, 26],
            [42, 60],
            [78, 85],
            [21, 38],
            [9, 52],
            [39, 27],
            [29, 4],
            [56, -23],
            [75, 6],
            [85, 17],
            [75, 21],
            [78, 94],
            [54, 34],
            [41, 61],
            [-9, 50],
            [45, 117],
            [49, 63],
            [14, 45],
            [92, 55],
            [37, -15],
            [109, 0],
            [22, 117],
            [44, 9],
            [38, -36],
            [44, 8],
            [30, 46],
            [123, 54],
            [84, -14],
            [44, 0],
            [37, 38],
            [35, -14],
            [64, -53],
            [52, -14],
            [44, 7],
            [72, -12],
            [49, 37],
            [10, 104],
            [-34, 67],
            [-24, 96],
            [-57, 59],
            [-62, 86],
            [-11, 35],
            [-52, 47],
            [-12, 54],
            [-100, 57],
            [-59, 104],
            [-21, 23],
            [-80, 8],
            [-29, 17],
            [-52, -17],
            [-65, -6],
            [-65, -102],
            [-64, -85],
            [-86, 86],
            [-52, 26],
            [-44, 9],
            [-76, -17],
            [-87, 11],
            [-48, -39],
            [-25, -43],
            [-30, -14],
            [-57, 62],
            [-48, 82],
            [-10, 104],
            [80, 65],
            [2, 116],
            [9, 67],
            [41, 63],
            [25, 84],
            [65, 184],
            [135, 364]
        ],
        [
            [91575, 77961],
            [64, -47],
            [110, -63],
            [71, -9],
            [69, -41],
            [54, -13],
            [178, 185],
            [94, 66],
            [69, 9],
            [52, 19],
            [35, 30],
            [20, 49],
            [6, 69],
            [-13, 42],
            [-34, 15],
            [27, 101],
            [51, 79],
            [21, 89],
            [19, 47],
            [53, 89],
            [21, 89],
            [47, 87],
            [31, 99],
            [52, 68],
            [85, 70],
            [53, 70],
            [21, 69],
            [-2, 60],
            [-24, 53],
            [-5, 54],
            [15, 54],
            [-13, 41],
            [-42, 27],
            [-50, 6],
            [-58, -13],
            [-32, 17],
            [-7, 47],
            [15, 39],
            [39, 29],
            [62, 72],
            [87, 113],
            [87, 63],
            [130, 18],
            [211, 75],
            [77, 19],
            [55, -16],
            [70, 7],
            [66, 16],
            [61, 26],
            [48, 6],
            [35, -14],
            [57, 9],
            [41, -20],
            [78, -58],
            [92, -36],
            [54, -63],
            [53, -10],
            [54, -43],
            [21, -2],
            [28, 37],
            [32, 4],
            [46, -21],
            [61, -46],
            [70, -23],
            [24, -84],
            [45, -11],
            [54, -74],
            [-10, -72],
            [43, -35],
            [49, -82],
            [22, -63],
            [3, -64],
            [19, -26],
            [17, -111],
            [44, -81],
            [14, -44],
            [3, -76],
            [30, -34],
            [13, -73],
            [-4, -33],
            [28, -120],
            [29, -64],
            [55, -87],
            [34, -68],
            [12, -88],
            [-13, -53],
            [10, -58],
            [18, -29],
            [60, -50],
            [-24, -76],
            [-3, -111],
            [15, -40],
            [26, -23],
            [23, -49],
            [89, -58],
            [74, -5],
            [89, 19],
            [55, 4],
            [27, -33],
            [8, -43],
            [37, -9],
            [56, -48],
            [117, 15],
            [11, -36],
            [42, -26],
            [38, -44],
            [75, -126],
            [49, -45],
            [49, -14],
            [62, -3],
            [19, -49],
            [-20, -95],
            [33, -67],
            [27, -29],
            [18, -50],
            [-5, -48],
            [-23, -71],
            [6, -61],
            [36, -50],
            [20, -48],
            [6, -46],
            [21, -38],
            [98, 20],
            [45, -3],
            [28, -23],
            [71, -1],
            [112, 21],
            [71, 7],
            [30, -8],
            [27, 30],
            [23, 67],
            [21, 32],
            [53, 18],
            [44, 47],
            [38, 24],
            [100, -5],
            [33, 20],
            [30, 41],
            [53, 37],
            [139, 56],
            [83, -29],
            [32, -38],
            [1, -56],
            [-32, -73],
            [58, -171],
            [-49, -107],
            [-34, -43],
            [-60, -18],
            [-38, -62],
            [11, -98],
            [-20, -33],
            [-31, -117],
            [-5, -81],
            [-48, -119],
            [11, -74],
            [-12, -66],
            [-50, -61],
            [-5, -73],
            [-24, -49],
            [-29, -23],
            [-20, -97],
            [-3, -56],
            [-53, -33],
            [-25, -28],
            [-22, -97],
            [0, -106],
            [-55, -56],
            [-39, 20]
        ],
        [[54607, 53040], [-9, -22]],
        [
            [54727, 55468],
            [-3, -73],
            [10, -38],
            [-22, -97],
            [0, -36],
            [17, -11],
            [13, -38],
            [15, -87],
            [13, -171],
            [16, -159],
            [-33, -34],
            [0, -56],
            [-55, -64],
            [-32, -138],
            [-20, -128],
            [-8, -140],
            [-16, -56],
            [-41, -91],
            [-20, -74],
            [3, -65],
            [-5, -87],
            [13, -104],
            [29, -147],
            [33, -208],
            [11, -39],
            [52, -23],
            [12, -94],
            [-11, -58],
            [-1, -80],
            [-48, -37],
            [-21, 7]
        ],
        [
            [54628, 53042],
            [-47, 40],
            [6, 81],
            [-27, -7],
            [-23, -97],
            [-11, -17],
            [-161, 50],
            [-35, 40],
            [-42, 10],
            [-73, -5],
            [-61, -12],
            [-17, -25],
            [152, 15],
            [24, -18],
            [-192, -32],
            [-74, -19],
            [-22, 5],
            [-16, 31],
            [-80, 4],
            [-26, -33],
            [81, 6],
            [13, -17],
            [-155, -23],
            [-108, -44],
            [-196, -139],
            [-91, -50],
            [-24, -19],
            [-42, -52],
            [-54, -33],
            [-60, -61],
            [-36, -14]
        ],
        [
            [53231, 52607],
            [-9, 20],
            [-6, 242],
            [7, 145],
            [19, 15],
            [7, 72],
            [17, 49],
            [0, 85],
            [9, 41],
            [-16, 162],
            [-19, 0],
            [-37, 37],
            [-30, 6],
            [-20, 32],
            [-28, 144],
            [-29, 29],
            [-69, 3],
            [-43, 33],
            [-33, 62],
            [-27, 3],
            [-20, 23],
            [62, 110],
            [22, 53],
            [11, 152],
            [-44, 247],
            [-15, 23]
        ],
        [
            [52940, 54395],
            [17, 25],
            [62, -26],
            [36, 114],
            [-4, 60],
            [16, 65],
            [20, 52],
            [-2, 37],
            [-62, 42],
            [-12, 19],
            [6, 113],
            [8, 15],
            [50, 7],
            [70, -16],
            [26, -51],
            [18, 19],
            [-3, 85],
            [-9, 45],
            [-20, 43],
            [-52, 37],
            [4, 108],
            [50, 56],
            [-19, 40],
            [-25, 20],
            [7, 127],
            [-41, -10],
            [-33, 55],
            [-3, 215],
            [3, 78],
            [45, 78]
        ],
        [
            [53093, 55847],
            [33, 13],
            [22, 29],
            [20, 59],
            [27, 47],
            [50, 7],
            [42, -101],
            [79, -31],
            [21, -32],
            [22, 17],
            [-8, 42],
            [13, 51],
            [36, 8],
            [44, -4],
            [7, 23],
            [-7, 67],
            [12, 81],
            [27, -39],
            [26, -14],
            [23, 6],
            [-6, 55],
            [51, 30],
            [7, -93],
            [15, -88],
            [-16, -68],
            [14, -26],
            [50, -21],
            [39, 63],
            [20, 46],
            [46, 24],
            [53, -4]
        ],
        [
            [60555, 51447],
            [-2, -37],
            [-30, -54],
            [-3, -48],
            [5, -57],
            [15, -69],
            [0, -40],
            [-24, -26],
            [-26, 46],
            [-72, 87],
            [-43, 20],
            [-57, 3],
            [-24, -7],
            [-42, 45],
            [-32, -12],
            [-61, 5],
            [-8, 38],
            [-35, -3],
            [-57, 69],
            [-29, -25],
            [-61, 4],
            [-158, -2],
            [-148, 2]
        ],
        [[59663, 51386], [-23, 53], [-109, -5], [-62, 5], [-94, 22], [-64, -6], [-66, 0], [-118, 10], [-65, -2], [-6, -73]],
        [[59056, 51390], [-166, 0], [-250, 0], [-34, 25], [-21, 51]],
        [
            [58585, 51466],
            [6, 131],
            [14, 109],
            [6, 101],
            [19, 91],
            [-10, 89],
            [-12, 39],
            [-63, 128],
            [29, 48],
            [-38, -7],
            [-27, 104],
            [22, 40],
            [34, 6],
            [-30, 47],
            [-12, 34],
            [-31, -14],
            [-23, -44],
            [-36, 10],
            [-19, 32],
            [-76, 52],
            [-8, 78],
            [-14, 33],
            [-9, 81],
            [5, 66],
            [-48, 15],
            [-33, -36],
            [-25, 6],
            [-13, 44],
            [7, 83]
        ],
        [
            [58200, 52832],
            [9, 44],
            [67, 203],
            [41, 325],
            [20, 77],
            [19, 51],
            [97, 173],
            [36, 55],
            [52, 63],
            [37, 127],
            [29, 24],
            [83, 108],
            [20, -58],
            [27, -9],
            [58, 8],
            [23, 82],
            [15, 14],
            [41, -41],
            [91, -162],
            [14, -108],
            [23, -37],
            [53, 26],
            [47, 63],
            [23, 55],
            [9, 107],
            [87, 127],
            [-29, 87],
            [26, 72],
            [50, 105],
            [3, 77],
            [41, 120],
            [23, 158],
            [1, 31],
            [52, 175],
            [55, 16],
            [46, 67],
            [23, 79],
            [22, 232],
            [16, 69],
            [28, 34],
            [48, 29],
            [14, 59],
            [9, 176],
            [6, 42],
            [45, 75],
            [37, 242],
            [51, 150],
            [59, 148],
            [51, 59],
            [45, 13],
            [111, 125],
            [6, 55],
            [-6, 77],
            [11, 56],
            [9, 156],
            [-14, 63],
            [-19, 42],
            [-32, 26],
            [-44, 7],
            [-23, 15],
            [-12, 128],
            [-29, 259]
        ],
        [
            [59901, 57473],
            [55, 0],
            [67, -31],
            [17, -24],
            [9, -89],
            [24, -50],
            [43, -42],
            [26, -85],
            [11, -130],
            [28, -90],
            [34, -146],
            [-1, -113],
            [13, -57],
            [-20, -96],
            [-8, -142],
            [12, -147],
            [19, -113],
            [21, -91],
            [24, -71],
            [38, -78],
            [41, -72],
            [38, -45],
            [-36, -26],
            [-68, -4],
            [-39, 15],
            [-110, -22],
            [-74, 7],
            [-68, 17],
            [-41, -3],
            [-32, -43],
            [-50, -117],
            [8, -58],
            [54, -101],
            [47, -113],
            [63, -100],
            [61, -89],
            [39, -37],
            [34, -51],
            [45, -84],
            [42, -131],
            [59, -262],
            [33, -36],
            [1, -68],
            [-22, -79]
        ],
        [
            [64018, 53030],
            [27, -79],
            [53, -68],
            [17, -38],
            [22, -74],
            [16, -26],
            [43, -37],
            [30, -60],
            [35, -41],
            [73, -15],
            [30, 27],
            [63, 74],
            [65, -10],
            [36, -23],
            [30, -32],
            [22, 2],
            [50, 59],
            [26, 63],
            [25, 14],
            [39, -27],
            [31, -59],
            [28, -86],
            [47, -84],
            [54, -109],
            [96, -81],
            [9, -27],
            [7, -75],
            [9, -16],
            [34, 11],
            [18, -11],
            [25, -75]
        ],
        [
            [65078, 52127],
            [21, -45],
            [-24, -71],
            [-15, -66],
            [-8, -68],
            [21, -41],
            [8, -68],
            [-24, -94],
            [-12, -82],
            [-1, -42],
            [32, -31],
            [40, 2],
            [37, -64],
            [30, -10],
            [26, -62]
        ],
        [[65209, 51385], [-26, -48], [-96, -119], [-120, -219], [-28, -95], [28, -32]],
        [
            [64967, 50872],
            [-48, -30],
            [-25, -46],
            [-18, -72],
            [-42, -61],
            [-32, -25],
            [-6, -81],
            [3, -98],
            [-15, -44],
            [-33, -141],
            [-19, -38],
            [-10, -122]
        ],
        [[64722, 50114], [-27, -8], [-31, -25], [-52, -195], [12, -62], [44, 16], [41, 59]],
        [[64709, 49899], [-11, -103], [-5, -110], [-9, -50], [5, -229]],
        [[64689, 49407], [-54, -66], [-16, -6], [-40, -94]],
        [
            [64579, 49241],
            [-7, 24],
            [-39, 21],
            [-12, -24],
            [-14, -106],
            [-24, -95],
            [2, -41],
            [-12, -39],
            [-1, -42],
            [13, -34],
            [-18, -46],
            [0, -42]
        ],
        [[64467, 48817], [20, -131], [28, -22]],
        [
            [64576, 48318],
            [-21, -37],
            [1, -117],
            [-13, -95],
            [-6, -169],
            [4, -64],
            [-11, -62],
            [26, -10],
            [22, 121],
            [11, 9],
            [-16, -187],
            [-24, -83],
            [-3, -71],
            [1, -229],
            [34, -138],
            [45, -137],
            [-12, -25],
            [-2, -76],
            [-43, -65],
            [1, -69],
            [7, -28],
            [30, -57],
            [35, -167],
            [18, -26],
            [-1, -53],
            [10, -49],
            [32, -57],
            [42, -96],
            [26, -38],
            [54, -46],
            [24, -38],
            [18, -48],
            [19, -97],
            [4, -109],
            [22, -113],
            [23, -17],
            [23, -53],
            [38, -66],
            [4, -58]
        ],
        [
            [64998, 45598],
            [-163, -45],
            [-175, -48],
            [-158, -44],
            [-23, -11],
            [12, -59],
            [-6, -61],
            [-38, -106],
            [-55, -101],
            [-66, -85],
            [0, -28],
            [43, -132],
            [20, -94],
            [8, -85],
            [-4, -268],
            [-3, -47],
            [11, -85],
            [-2, -67],
            [-29, -74],
            [-8, -73],
            [-35, -235],
            [-15, -72],
            [39, -183],
            [28, -54],
            [85, -118],
            [67, -127],
            [86, -32],
            [26, -14],
            [24, 25],
            [-4, 66],
            [21, 36],
            [40, 3],
            [32, 23],
            [0, -374],
            [0, -315],
            [-22, -34],
            [-22, 22],
            [-7, 64],
            [-23, 28],
            [-109, -84],
            [-58, 17],
            [-22, 34],
            [-6, 52],
            [-46, 130],
            [-31, 67],
            [-38, 14],
            [-23, 119],
            [-19, 58],
            [-17, 20],
            [-155, 110],
            [-66, 10],
            [-34, 40],
            [-34, 140],
            [-57, 90],
            [-13, 99],
            [-11, 15],
            [-35, -21],
            [-30, -157],
            [-18, -25],
            [-50, -18],
            [-41, 2],
            [-79, 23],
            [-97, 22],
            [-53, 39],
            [-73, 43],
            [-33, -5],
            [-50, 72],
            [-21, 122],
            [12, 94],
            [-23, 13],
            [-19, -17],
            [-95, -31],
            [-64, -30],
            [-47, -48],
            [-43, 12],
            [-13, 26],
            [19, 64],
            [-10, 70],
            [-14, 33],
            [-56, 25],
            [-18, 75],
            [-35, 11]
        ],
        [[59593, 46911], [-20, 16], [-65, -23], [-34, -47], [-52, -24], [-31, 10], [-30, 51], [-32, 76]],
        [
            [59595, 47597],
            [19, 17],
            [26, -57],
            [48, -69],
            [12, -4],
            [42, 45],
            [34, 19],
            [8, 19],
            [9, 130],
            [19, 12],
            [32, -28],
            [19, 0],
            [32, 37],
            [27, 10],
            [56, 53],
            [13, 3],
            [29, -84],
            [-26, -76],
            [11, -53],
            [3, -84],
            [15, -19],
            [30, 6],
            [46, -15],
            [22, 20],
            [41, 78],
            [60, 137],
            [50, 85],
            [39, 35],
            [27, 41],
            [14, 47],
            [23, 31],
            [47, 26],
            [37, 28],
            [36, 94],
            [48, 169],
            [22, 241],
            [-5, 316],
            [-3, 103],
            [8, 57],
            [18, 39],
            [49, 82],
            [33, 67],
            [25, 79],
            [49, 180],
            [31, 84],
            [29, 47],
            [41, 43],
            [53, 36],
            [81, 125],
            [65, 126],
            [-9, 151],
            [15, 126],
            [36, 160],
            [11, 169],
            [-12, 178],
            [5, 145],
            [48, 233],
            [5, 103],
            [0, 164],
            [43, 224],
            [86, 284],
            [40, 211],
            [-3, 98]
        ],
        [[59269, 47391], [-38, 77], [-35, 106], [-1, 61], [-34, 74], [-85, 130], [-9, 39], [-72, 119]],
        [
            [58995, 47997],
            [18, 86],
            [31, 68],
            [66, 67],
            [10, -2],
            [46, -88],
            [51, -8],
            [11, 40],
            [-16, 52],
            [31, 119],
            [-67, 79],
            [-9, 28],
            [22, 80],
            [-37, 71],
            [-31, 10],
            [17, 93],
            [3, 42],
            [-9, 111],
            [10, 30],
            [37, -29],
            [69, 28],
            [35, -38],
            [118, 46],
            [10, 121],
            [-11, 36],
            [-3, 67],
            [49, 56],
            [38, -23],
            [24, -35],
            [37, -136],
            [25, -77],
            [51, -31],
            [61, -20],
            [34, 5],
            [47, 66],
            [36, 78],
            [15, -14],
            [32, -118],
            [0, -51],
            [33, -14],
            [29, 14],
            [34, 62],
            [-11, 77],
            [12, 21],
            [15, 99],
            [41, 62],
            [12, 100],
            [-6, 66],
            [14, 38],
            [2, 62],
            [-13, 246],
            [21, 197],
            [-2, 25],
            [-34, 59],
            [-48, 23],
            [-43, 87],
            [-53, 16],
            [-11, 22],
            [9, 155],
            [-2, 64],
            [20, 91],
            [24, 42],
            [19, 60],
            [44, 8],
            [29, 41],
            [34, 105],
            [-2, 50],
            [-13, 57],
            [-26, 65],
            [-19, 112],
            [-18, 27],
            [-36, 14],
            [-66, 13],
            [-178, -99],
            [-18, 4],
            [9, 66],
            [-19, 94],
            [-7, 63],
            [3, 78],
            [12, 74],
            [24, 95],
            [2, 39]
        ],
        [
            [33546, 56795],
            [-67, -49],
            [-130, -60],
            [-17, -36],
            [-73, -226],
            [-61, -46],
            [-22, -34],
            [-53, -121],
            [-15, -61],
            [-41, -131],
            [-22, -165],
            [-20, -227],
            [-18, -67],
            [-49, -125],
            [-41, -121],
            [6, -33],
            [44, 14],
            [42, 37],
            [15, -11],
            [15, -58],
            [34, 0],
            [17, -15],
            [40, -268],
            [77, -137],
            [18, -165],
            [-27, -67],
            [-10, -197],
            [11, -88],
            [15, -22],
            [58, -25],
            [38, -153],
            [24, -36],
            [35, -23],
            [84, 23],
            [50, -3],
            [74, -23],
            [63, 5],
            [63, 46],
            [48, 3],
            [82, -61],
            [38, -14],
            [53, -6],
            [110, -247],
            [92, -200],
            [25, 7],
            [28, -27],
            [23, 9],
            [32, 38],
            [47, 8],
            [62, -23],
            [82, 0],
            [101, 23],
            [63, 24],
            [25, 27],
            [41, -3],
            [49, -24],
            [26, -34],
            [13, -86],
            [-10, -54],
            [-32, -54],
            [-17, -69],
            [-3, -84],
            [-16, -62],
            [-29, -40],
            [-12, -58],
            [7, -77],
            [-3, -113],
            [-13, -148],
            [0, -88],
            [19, -70],
            [3, -102],
            [16, -62],
            [22, -124],
            [18, -54],
            [32, -43],
            [58, -153],
            [-13, -52],
            [-50, -76],
            [-99, -164],
            [-7, -55],
            [28, 22],
            [53, -36],
            [9, -44],
            [25, -26],
            [54, -96],
            [31, -45],
            [-1, -64],
            [31, -126],
            [-6, -28],
            [13, -33],
            [32, -145],
            [2, -44],
            [30, -136],
            [2, -75]
        ],
        [
            [33964, 47819],
            [-16, 41],
            [-47, 63],
            [-22, 93],
            [-31, 38],
            [-45, -30],
            [-13, 1],
            [-64, 48],
            [98, 275],
            [106, 300],
            [-7, 51],
            [-45, 29],
            [-16, 30],
            [-87, 75],
            [-22, 7],
            [-18, 35],
            [-64, 69],
            [-17, 7],
            [-45, -22],
            [-25, -38],
            [-62, -11],
            [-50, 61],
            [-60, 40],
            [-15, -8],
            [-56, -89],
            [-22, 1],
            [-26, -31],
            [-79, -27],
            [-71, 43],
            [-28, -23],
            [-53, -9],
            [-32, 38],
            [-51, 35],
            [-5, 39],
            [14, 71],
            [-22, 140],
            [-21, 32],
            [-26, -7],
            [-45, 51],
            [-9, 30],
            [9, 57],
            [-8, 49],
            [-17, 27],
            [-27, 85],
            [-22, 19],
            [-39, 10],
            [-20, 40],
            [-39, 54],
            [-60, 32],
            [-27, 67],
            [-26, 150],
            [-14, 35],
            [-47, 83],
            [-43, 40],
            [-14, 54],
            [-44, 7],
            [-60, 77],
            [-27, 5],
            [-18, -36]
        ],
        [
            [32322, 50122],
            [-56, 38],
            [-47, 56],
            [-49, 15],
            [-32, 34],
            [-58, 109],
            [-75, 57],
            [-32, -39],
            [-4, -65],
            [-21, -15],
            [-33, 3],
            [-39, 18],
            [-12, -17],
            [-47, 15],
            [-60, 48],
            [-55, 3],
            [-40, 36],
            [-14, 118],
            [-56, 49],
            [-17, 63],
            [-39, -7],
            [-64, 41],
            [-85, 82],
            [-61, 85],
            [-53, 48],
            [-17, 42],
            [-38, 54]
        ],
        [
            [31218, 50993],
            [-9, 38],
            [-42, 55],
            [21, 72],
            [51, 54],
            [67, -42],
            [8, 84],
            [-24, 74],
            [3, 139],
            [26, 65],
            [36, 34],
            [23, -13],
            [14, 28],
            [55, -13],
            [16, 12],
            [42, 67],
            [17, 54],
            [19, -5],
            [12, 39],
            [33, 51],
            [-8, 90],
            [42, 20],
            [44, 148],
            [18, 4],
            [10, 70],
            [25, 62],
            [52, 183],
            [-28, -28],
            [-30, 17],
            [5, 82],
            [-9, 10],
            [-25, -63],
            [-22, 64],
            [-1, 39],
            [7, 65],
            [-11, 30],
            [28, 54],
            [8, 43],
            [13, 138],
            [-16, 65],
            [-9, 133],
            [3, 77],
            [-14, 112],
            [-41, 67],
            [65, 78],
            [23, 58],
            [-29, 120],
            [-39, 101],
            [-1, 61],
            [23, -6],
            [12, 128],
            [-2, 39],
            [-22, 64],
            [-27, 2],
            [-23, 80],
            [-14, 18],
            [-11, 51],
            [-38, 99],
            [-30, 51]
        ],
        [
            [31514, 54212],
            [23, 119],
            [26, 52],
            [-8, 74],
            [11, 23],
            [45, -93],
            [73, 91],
            [2, 72],
            [19, 40],
            [21, 14],
            [1, 57],
            [-22, 85],
            [-19, 46],
            [-19, 88],
            [-22, 40],
            [32, 89]
        ],
        [
            [31677, 55009],
            [35, -92],
            [40, -52],
            [43, -84],
            [17, -57],
            [26, -32],
            [-19, -32],
            [-3, -33],
            [17, -31],
            [25, 7],
            [14, 40],
            [-9, 172],
            [-15, 86],
            [-31, 61],
            [10, 25],
            [61, 42],
            [128, 164],
            [43, 154],
            [34, 56],
            [37, 36],
            [46, -8],
            [36, 19],
            [11, 49],
            [-9, 67],
            [-14, 40],
            [27, 147],
            [-1, 74],
            [-23, 39],
            [36, 74],
            [19, 111],
            [14, 46],
            [51, 65],
            [10, 32],
            [39, 48],
            [62, 104],
            [24, 30],
            [120, -68],
            [-19, -70],
            [17, -42],
            [19, -13],
            [15, 27],
            [16, 78],
            [25, 85],
            [6, 90],
            [17, 30],
            [26, 11],
            [81, -36],
            [37, -2],
            [112, 13],
            [183, 232],
            [85, 50],
            [53, 49],
            [34, 96],
            [9, 71],
            [25, 28],
            [26, 0],
            [16, 39],
            [63, 62],
            [68, 7],
            [71, -54],
            [34, -96],
            [5, -65],
            [-45, -72],
            [-11, -31]
        ],
        [[69075, 43319], [22, -34], [-60, 14], [-10, 53], [22, -5], [26, -28]],
        [[69288, 43445], [15, -77], [0, -58], [-20, -7], [-26, 47], [-48, 45], [49, 3], [10, 40], [20, 7]],
        [[68976, 43545], [-50, 32], [-24, 52], [9, 178], [13, 32], [29, -19], [-4, -115], [35, -138], [-8, -22]],
        [[48056, 58465], [-24, -22], [-32, 32], [-2, 59], [33, 32], [19, -10], [10, -51], [-4, -40]],
        [[48404, 58621], [-21, 23], [1, 44], [11, 37], [23, -3], [6, -84], [-20, -17]],
        [[48323, 58549], [-19, -51], [-40, 4], [-21, 21], [-25, 65], [9, 92], [17, 16], [51, -74], [28, -73]],
        [[48486, 59235], [52, -9], [17, -30], [-5, -70], [-34, -32], [-20, 4], [-23, 29], [13, 58], [0, 50]],
        [[48124, 59449], [-1, -34], [-46, 21], [-25, -59], [-23, 70], [6, 33], [33, -18], [56, -13]],
        [[48495, 59470], [-29, 23], [-3, 60], [27, 20], [5, -103]],
        [[47878, 59558], [-41, -11], [-16, 41], [42, 28], [15, -58]],
        [[47790, 59630], [-42, -6], [-9, 87], [69, 57], [24, -10], [17, -45], [-11, -26], [-48, -57]],
        [
            [29742, 56268],
            [17, -57],
            [4, -45],
            [39, -149],
            [31, -84],
            [69, -153],
            [30, -28],
            [50, -123],
            [27, -56],
            [52, -30],
            [14, -22]
        ],
        [
            [30075, 55521],
            [-25, -40],
            [-48, 48],
            [-18, -45],
            [-25, -34],
            [0, -217],
            [18, -3],
            [43, -58],
            [1, -29],
            [-44, -52],
            [-11, -37],
            [19, -58],
            [3, -82],
            [-5, -19],
            [-42, -48],
            [-8, -29],
            [23, -33],
            [20, -71],
            [2, -33]
        ],
        [
            [29978, 54681],
            [-21, 62],
            [-29, 59],
            [-26, 37],
            [-2, 84],
            [-10, 47],
            [-70, 72],
            [-25, -6],
            [15, -49],
            [38, -63],
            [2, -56],
            [-77, 22],
            [-19, 19],
            [-40, 75],
            [28, 64],
            [9, 42],
            [-1, 87],
            [-6, 42],
            [-31, 64],
            [-49, 70],
            [-69, 58],
            [-32, 46],
            [-80, 36],
            [-31, 23],
            [-24, 44],
            [5, 79],
            [-22, 62],
            [-96, 120],
            [-53, 45],
            [-12, -49],
            [23, -50],
            [62, -47],
            [23, -63],
            [-35, -68],
            [-18, -17],
            [-17, -48],
            [-62, 127],
            [-96, 51],
            [-17, 32],
            [-36, 97],
            [-16, 89],
            [6, 59],
            [39, 92],
            [12, 40],
            [-1, 61],
            [-15, 26],
            [-59, 59],
            [48, 49],
            [2, 43]
        ],
        [
            [29093, 56349],
            [13, 11],
            [25, 57],
            [26, -10],
            [194, -123],
            [64, 59],
            [21, -3],
            [45, -30],
            [43, -7],
            [29, -44],
            [27, -67],
            [77, -25],
            [33, 4],
            [30, 24],
            [17, 28],
            [5, 45]
        ],
        [
            [30076, 62209],
            [-29, -30],
            [-61, -41],
            [-33, -2],
            [-33, 16],
            [-23, 35],
            [52, 33],
            [-34, 111],
            [1, 24],
            [27, 61],
            [73, -19],
            [13, -11],
            [26, -68],
            [21, -109]
        ],
        [[31586, 62421], [-27, 7], [-44, 40], [-6, 29], [44, -3], [44, -16], [-11, -57]],
        [[31521, 62519], [-41, 21], [2, 46], [35, -19], [4, -48]],
        [[31475, 62607], [-47, 20], [-29, 57], [38, 4], [18, -24], [20, -57]],
        [[31289, 62756], [43, -12], [43, 4], [21, -46], [-33, -6], [-48, 10], [-39, 25], [13, 25]],
        [[31067, 62818], [-53, 26], [-18, 53], [71, -79]],
        [
            [30299, 63096],
            [81, -26],
            [94, 7],
            [29, -38],
            [52, 16],
            [111, 8],
            [30, -48],
            [58, -41],
            [89, -1],
            [36, -36],
            [43, 5],
            [-10, -33],
            [54, -47],
            [40, -92],
            [28, -38],
            [56, -57],
            [29, -11],
            [86, 4],
            [67, -16],
            [168, -143],
            [85, -117],
            [71, -57],
            [28, -13],
            [15, 54],
            [61, -89],
            [48, -38],
            [-12, -26],
            [-57, 9],
            [49, -75],
            [34, 62],
            [81, -106],
            [46, -33],
            [12, -31],
            [60, -6],
            [60, -26],
            [57, -52],
            [54, -11],
            [55, -2],
            [27, -28],
            [12, -37],
            [-21, -54],
            [20, -33],
            [-44, -15],
            [5, -54],
            [25, 11],
            [94, -18],
            [39, 7],
            [102, -36],
            [46, -43],
            [68, -105],
            [40, -30],
            [46, -2],
            [21, -20],
            [9, -33],
            [-5, -35],
            [-31, -50],
            [-118, -12],
            [-66, -31],
            [-47, -41],
            [-35, -15],
            [-19, 32],
            [-35, -37],
            [-81, -1],
            [-65, 38],
            [-122, 17],
            [-110, -19],
            [-82, -9],
            [-67, -26],
            [-66, 0],
            [-78, -18],
            [-77, -3],
            [49, 126],
            [106, 122],
            [33, 60],
            [-1, 47],
            [-25, 38],
            [-12, 46],
            [-74, 26],
            [-39, 0],
            [-81, 13],
            [-43, 1],
            [-37, 26],
            [-61, 93],
            [-29, 26],
            [-26, 44],
            [-14, 136],
            [-12, 65],
            [-19, 57],
            [-28, 43],
            [-29, 14],
            [-113, -37],
            [-27, 6],
            [-196, 100],
            [-99, 72],
            [-25, 35],
            [-53, 105],
            [-5, -33],
            [-143, -6],
            [-37, 25],
            [-32, 95],
            [-11, -70],
            [-41, -21],
            [-26, 44],
            [-116, 9],
            [-48, 51],
            [-33, 54],
            [32, 19],
            [67, 25],
            [23, 38],
            [-19, 55],
            [-49, 25],
            [-258, 6],
            [-38, -53],
            [-46, -45],
            [-41, -71],
            [-46, -46],
            [-27, -45],
            [-33, -20],
            [-35, 12],
            [-27, -16],
            [-66, -5],
            [-19, -44],
            [-21, -83],
            [-65, -25],
            [-64, -60],
            [-16, 78],
            [-56, -18],
            [-48, -39],
            [-12, 37],
            [106, 76],
            [50, 3],
            [14, 21],
            [-17, 101],
            [6, 69],
            [25, 53],
            [49, 81],
            [24, 26],
            [243, 168],
            [25, 9],
            [158, 34],
            [97, 61],
            [77, 20],
            [81, -15]
        ],
        [[34339, 56905], [-17, -8], [-59, 54], [-49, 87], [-1, 46], [25, -21], [20, -62], [57, -41], [24, -55]],
        [[30444, 60969], [26, 8], [47, -9], [-53, -41], [-31, 3], [11, 39]],
        [
            [66055, 69733],
            [-42, 15],
            [-23, -25],
            [-36, -17],
            [-46, 12],
            [-44, 69],
            [-60, 6],
            [-83, -48],
            [-62, 32],
            [-2, 14]
        ],
        [
            [65657, 69791],
            [51, 6],
            [15, 54],
            [4, 63],
            [57, -18],
            [103, -13],
            [46, 11],
            [141, 66],
            [39, 40],
            [68, 47],
            [16, -20],
            [-161, -168],
            [-10, -50],
            [29, -76]
        ],
        [
            [66055, 69733],
            [15, -43],
            [-36, -10],
            [-73, -1],
            [-57, -91],
            [-31, -31],
            [-36, -18],
            [-56, -13],
            [-54, -66],
            [-23, 47],
            [-53, -6],
            [-76, 44],
            [-40, 125],
            [-5, 72],
            [27, -18],
            [51, 59],
            [49, 8]
        ],
        [
            [60131, 78539],
            [53, 15],
            [4, 71],
            [81, -31],
            [6, -42],
            [24, -40],
            [116, -40],
            [67, -39],
            [18, -32],
            [85, 24],
            [43, -45],
            [-20, -41],
            [-45, -43],
            [38, -32],
            [48, -66],
            [33, -70],
            [26, -14],
            [97, 91],
            [-39, 86],
            [35, 1],
            [53, -21],
            [81, -69],
            [94, 24],
            [-3, -58],
            [-37, -20],
            [62, -85],
            [26, -19],
            [47, 35],
            [86, -67],
            [13, 9],
            [66, -29],
            [10, -67],
            [66, -81],
            [7, -57]
        ],
        [
            [61372, 77787],
            [-72, -11],
            [-56, -56],
            [-16, -30],
            [-63, -44],
            [-16, -44],
            [-7, -64],
            [-45, -29],
            [-56, -69],
            [-41, -26],
            [-44, -8],
            [-91, 19],
            [-39, -45],
            [-34, -102]
        ],
        [
            [59824, 77372],
            [-14, 28],
            [-69, 80],
            [-33, -3],
            [-31, 59],
            [-61, 54],
            [-70, 96],
            [-31, 0],
            [-56, 73],
            [-41, 100],
            [-34, 56],
            [33, 63],
            [-12, 57],
            [-56, 48],
            [-58, 126],
            [14, 24],
            [44, -72],
            [54, 94],
            [30, 24],
            [67, 21],
            [62, -8],
            [15, 41],
            [51, 11],
            [17, 37],
            [43, 25],
            [30, -2],
            [17, 42],
            [114, 38],
            [94, 56],
            [52, 21],
            [-35, 57],
            [19, 20],
            [58, -15],
            [36, -53],
            [-3, -33],
            [34, -23],
            [27, 25]
        ],
        [[59947, 80218], [-89, 5], [-1, 65], [-30, 35], [1, 38], [118, -99]],
        [[59946, 80262], [1, -44]],
        [[59042, 80523], [-47, -1], [-37, 28], [23, 37], [46, -17], [15, -47]],
        [
            [59791, 80503],
            [-35, -24],
            [-35, -1],
            [-36, -51],
            [-54, 45],
            [-11, 39],
            [7, 82],
            [19, 53],
            [30, 33],
            [27, 1],
            [21, -47],
            [44, -21],
            [11, -23],
            [-28, -40],
            [40, -46]
        ],
        [
            [58566, 80750],
            [47, -25],
            [40, -59],
            [2, -52],
            [-49, -61],
            [84, 9],
            [22, -44],
            [45, 16],
            [115, -68],
            [87, 35],
            [16, -55],
            [-18, -55],
            [-61, -59],
            [33, -45],
            [58, 8],
            [91, -36],
            [19, 11],
            [74, 83],
            [30, 18],
            [97, 13],
            [143, 167],
            [140, -32],
            [37, -71],
            [92, -79],
            [86, 6],
            [30, -74],
            [13, -93],
            [50, -48],
            [72, -21]
        ],
        [
            [59961, 80139],
            [12, -96],
            [36, -152],
            [-14, -100],
            [-24, -44],
            [-30, -24],
            [-21, -58],
            [39, -54],
            [80, -76],
            [33, -65],
            [-20, -95],
            [47, -84],
            [-1, -55],
            [15, -15],
            [-24, -99],
            [-22, -41],
            [42, -114],
            [-5, -58],
            [56, -33],
            [35, -118],
            [-17, -88],
            [-47, -131]
        ],
        [[58552, 76690], [-56, 45], [-124, 83], [22, -57]],
        [
            [57910, 76718],
            [-26, 45],
            [2, 55],
            [17, 74],
            [-3, 88],
            [10, 52],
            [28, 69],
            [18, 72],
            [23, 126],
            [93, 140],
            [-2, 48],
            [-41, 21],
            [-120, 29],
            [-50, 50],
            [-77, -21],
            [-55, 5],
            [-6, 31],
            [-34, 16],
            [-49, -26],
            [-85, 157],
            [-35, 6]
        ],
        [[57518, 77755], [19, 107], [24, 35], [1, 50], [-71, 41], [-37, 57], [-7, 82]],
        [
            [57410, 78478],
            [16, 86],
            [-47, 45],
            [14, 31],
            [59, 60],
            [-17, 42],
            [36, 104],
            [0, 44],
            [-75, 152],
            [18, 40],
            [49, 26],
            [58, -31],
            [119, 48],
            [19, 39],
            [-27, 31],
            [11, 35],
            [70, 59],
            [18, 98],
            [-21, 35],
            [-67, 12],
            [-18, 36],
            [17, 58],
            [82, 0],
            [32, 141],
            [23, 63],
            [2, 158]
        ],
        [
            [57781, 79890],
            [-44, 52],
            [16, 101],
            [31, 54],
            [24, 15],
            [106, 9],
            [118, -3],
            [48, -83],
            [-18, -42],
            [43, -12],
            [17, 77],
            [73, -15],
            [-10, 63],
            [7, 62],
            [28, 52],
            [86, -22],
            [95, 12],
            [3, 19],
            [-73, 20],
            [-23, 41],
            [1, 145],
            [-39, 30],
            [-42, -10],
            [1, 57],
            [94, 39],
            [1, 39],
            [-85, 142],
            [-3, 62]
        ],
        [[58236, 80794], [72, -4], [135, -50], [85, 27], [38, -17]],
        [[68908, 56593], [-100, -279]],
        [
            [68808, 56314],
            [-43, 6],
            [-39, 38],
            [-30, 1],
            [-78, -42],
            [-43, -7],
            [-65, -29],
            [-49, 22],
            [-10, 242],
            [0, 98],
            [15, 75],
            [56, 105],
            [118, 309]
        ],
        [[68640, 57132], [31, 26], [59, -76], [30, 26], [18, 81], [18, 29], [72, 49]],
        [
            [68868, 57267],
            [4, -27],
            [52, -109],
            [17, -54],
            [18, -99],
            [-10, -55],
            [-33, -68],
            [-69, -78],
            [-77, -50],
            [-49, -100],
            [-37, 6],
            [6, -37],
            [35, 2],
            [42, 30],
            [38, 13],
            [40, 1],
            [37, -12],
            [26, -37]
        ],
        [[36644, 58684], [-29, -13], [-12, 97], [-21, 69], [8, 61], [42, -27], [13, -33], [9, -85], [-10, -69]],
        [[59066, 80787], [55, -34], [62, -13], [8, -71], [-95, -28], [-130, 80], [7, 93], [62, 7], [31, -34]],
        [[59433, 80829], [-59, -3], [-54, -38], [-7, 46], [46, 36], [33, -5], [41, -36]],
        [[58665, 80784], [-32, -8], [-47, 19], [-10, 86], [70, -41], [19, -56]],
        [[58873, 80709], [-35, 56], [73, 112], [19, 5], [-57, -173]],
        [[60217, 80860], [-63, 6], [-62, 39], [9, 75], [16, 33], [113, -85], [-13, -68]],
        [
            [58845, 81188],
            [54, -161],
            [-10, -29],
            [0, -76],
            [-50, -45],
            [-56, -2],
            [-140, 64],
            [-40, 108],
            [0, 88],
            [41, 11],
            [90, 42],
            [68, -29],
            [43, 29]
        ],
        [[58834, 81284], [-25, 1], [6, 116], [35, -64], [-16, -53]],
        [
            [59439, 81285],
            [1, -55],
            [-20, -27],
            [-58, -28],
            [-32, -67],
            [52, -45],
            [9, -56],
            [-28, -27],
            [-72, -27],
            [-12, -208],
            [-58, -24],
            [-38, 79],
            [0, 32],
            [-26, 120],
            [-55, 14],
            [-59, -4],
            [-36, 69],
            [6, 76],
            [-21, 76],
            [-34, 24],
            [-10, 43],
            [106, 17],
            [44, 71],
            [3, 36],
            [48, 7],
            [21, -27],
            [-2, -100],
            [40, -17],
            [35, 110],
            [-21, 40],
            [109, 84],
            [32, 2],
            [79, -32],
            [9, -17],
            [-26, -64],
            [14, -75]
        ],
        [
            [58236, 80794],
            [-10, 79],
            [-20, 49],
            [30, 12],
            [-6, 97],
            [-11, 50],
            [-84, 51],
            [-65, 50],
            [21, 213],
            [-25, 88],
            [13, 261],
            [37, 5],
            [83, -31],
            [37, -36],
            [20, 73],
            [47, 60],
            [55, 33],
            [40, -52],
            [18, 173],
            [-44, 18],
            [-37, -15],
            [-36, -72],
            [-32, -90],
            [-52, -9],
            [-42, -25],
            [-61, 50],
            [4, 54],
            [45, 74],
            [59, 71],
            [59, -1],
            [44, 23],
            [107, -3],
            [79, 48],
            [80, 138],
            [46, 57],
            [91, 20],
            [85, 66],
            [-28, -97],
            [29, -63],
            [-4, -115],
            [-27, -39],
            [-43, -97],
            [-5, -211],
            [64, -56],
            [110, 1],
            [25, -44],
            [-22, -82],
            [-31, -30],
            [-67, -23],
            [-34, 42],
            [-33, -35],
            [-42, -194],
            [-51, 6],
            [-36, -18],
            [37, -46],
            [-38, -30],
            [-95, -119],
            [25, -127],
            [-9, -34],
            [-43, -50],
            [-15, -42],
            [59, -10],
            [29, -110]
        ],
        [
            [33407, 60239],
            [2, 92],
            [8, 37],
            [-8, 40],
            [-34, 41],
            [-39, 102],
            [41, 9],
            [38, 66],
            [3, 69],
            [-23, 73],
            [47, 80],
            [3, 36],
            [-31, 50],
            [12, 76],
            [-15, 149],
            [-7, 16]
        ],
        [
            [33404, 61175],
            [13, 10],
            [21, 63],
            [34, 26],
            [36, -1],
            [64, -25],
            [87, 37],
            [37, -15],
            [61, -63],
            [61, -2],
            [41, -53],
            [54, -22],
            [53, 20],
            [21, -46],
            [4, -65],
            [17, -59],
            [25, -38],
            [128, 16],
            [29, -31],
            [-28, -40],
            [-87, 3],
            [-6, -49],
            [71, -18],
            [71, -32],
            [81, -22],
            [67, -47],
            [94, -130],
            [13, -34],
            [-7, -41],
            [-26, -67],
            [-37, -34],
            [-29, -75],
            [-19, -2],
            [-31, 68],
            [-35, 38],
            [-43, -5],
            [-62, 23],
            [-76, -14],
            [-77, 16],
            [-77, -39],
            [-50, -68],
            [-92, -19],
            [-51, 66],
            [-35, 5],
            [-83, -40],
            [-17, -28],
            [-7, -86],
            [-50, -122],
            [-40, -114],
            [-13, -6],
            [-25, 50],
            [-35, 27],
            [-8, 27],
            [-5, 74],
            [-29, 47]
        ],
        [
            [58207, 70776],
            [7, -57],
            [-48, -41],
            [-23, -72],
            [-43, -48],
            [-7, -28],
            [29, -22],
            [14, -49],
            [-31, -277],
            [0, -39],
            [22, -82],
            [-1, -140],
            [24, -111],
            [-25, -67],
            [-11, -58],
            [-9, -137],
            [-38, -95],
            [-88, -86],
            [-28, -87],
            [-60, -72],
            [-12, -25],
            [-6, -58],
            [2, -80],
            [10, -64],
            [29, -94],
            [42, -176],
            [96, -80],
            [42, -91],
            [29, -128],
            [9, -85],
            [108, -130],
            [103, -115],
            [8, -18],
            [36, -252],
            [63, -439],
            [48, -337]
        ],
        [
            [58498, 67036],
            [-65, -63],
            [25, -68],
            [48, -111],
            [39, -127],
            [23, -111],
            [23, -141],
            [7, -83],
            [-9, -227],
            [13, -288],
            [18, -143],
            [-52, -254],
            [2, -62],
            [26, -169],
            [18, -38],
            [-4, -121],
            [-7, -44],
            [-54, -64],
            [-60, -58],
            [-16, -49],
            [-5, -55],
            [8, -45],
            [170, -409],
            [6, -41],
            [3, -116],
            [28, -146],
            [31, -63],
            [11, -48],
            [43, -58],
            [14, -3],
            [76, 39],
            [130, -65],
            [123, -67],
            [10, -13],
            [71, -222],
            [62, -209]
        ],
        [
            [59254, 63294],
            [-160, -170],
            [-160, -170],
            [-160, -171],
            [-160, -170],
            [-160, -170],
            [-159, -170],
            [-160, -171],
            [-266, -283],
            [-152, -224],
            [-143, -222],
            [-213, -331],
            [-27, -25],
            [-333, -115],
            [-137, -47]
        ],
        [
            [56864, 60855],
            [-255, -87],
            [-45, 14],
            [-42, 50],
            [-4, 27],
            [46, 145],
            [-16, 83],
            [0, 128],
            [-22, 34],
            [-43, 37],
            [-39, 22],
            [-121, 44],
            [-21, 16],
            [-38, 82],
            [-19, 21],
            [-90, 14],
            [-30, 13],
            [-45, 45],
            [-23, 99],
            [-99, 88],
            [-39, 58],
            [2, 92],
            [-8, 67],
            [-247, 292],
            [-202, 239],
            [-101, 119],
            [-203, 239],
            [-101, 119],
            [-202, 239],
            [-101, 120],
            [-202, 238],
            [-202, 239],
            [-187, 220],
            [-94, 107]
        ],
        [[54071, 64118], [-214, 239], [-223, 236], [-174, 185], [-174, 185], [-233, 247], [-174, 185]],
        [[52879, 65395], [0, 207]],
        [
            [52879, 65602],
            [0, 537],
            [7, 55],
            [32, 27],
            [90, 119],
            [83, 85],
            [96, 121],
            [62, 23],
            [77, 102],
            [44, 28],
            [141, -31],
            [36, 51],
            [6, 83],
            [88, 1],
            [65, 11],
            [71, 21],
            [101, 49],
            [48, 57],
            [35, 60],
            [65, 167],
            [59, 48],
            [77, 41],
            [63, 41],
            [104, 120],
            [88, 17],
            [23, 31],
            [1, 37],
            [-15, 25],
            [-50, 48],
            [14, 92],
            [-15, 84],
            [3, 83],
            [39, 21],
            [30, -7],
            [51, 10],
            [130, 72],
            [27, 116],
            [21, 18],
            [128, 31],
            [195, -14],
            [167, -9],
            [15, 10],
            [-11, 92],
            [7, 37],
            [54, 73],
            [-14, 46],
            [-75, 85],
            [-30, 45],
            [-19, 52],
            [-12, 109],
            [-23, 61],
            [-17, 76],
            [15, 138],
            [-22, 84],
            [-4, 78],
            [7, 74],
            [-4, 104],
            [-27, 107],
            [18, 55],
            [-35, 78],
            [16, 81],
            [-104, 122],
            [-27, 74]
        ],
        [
            [54874, 69754],
            [63, -10],
            [32, 5],
            [74, 49],
            [59, 67],
            [45, 34],
            [40, 74],
            [37, 46],
            [52, 50],
            [152, 107],
            [23, 1],
            [50, -24],
            [44, 7],
            [29, 38],
            [32, 91],
            [50, 55],
            [62, 56],
            [86, 53],
            [55, 48],
            [89, 42],
            [221, 27],
            [114, 24],
            [77, -5],
            [78, 77],
            [39, 25],
            [169, 6],
            [80, 56],
            [302, 0],
            [73, -49],
            [62, -73],
            [31, -16],
            [40, 15],
            [93, 70],
            [104, 36],
            [57, 41],
            [25, 60],
            [49, 22],
            [27, -46],
            [109, -47],
            [66, 14],
            [30, 14],
            [-11, 69],
            [71, -19],
            [54, -33],
            [56, -66],
            [37, -14],
            [67, 30],
            [139, 15]
        ],
        [
            [30826, 48523],
            [-6, -21],
            [-38, 9],
            [7, 102],
            [8, 33],
            [44, 47],
            [26, -3],
            [27, -29],
            [-32, -52],
            [-24, -15],
            [-12, -71]
        ],
        [[27649, 49434], [-30, 23], [13, 43], [31, -39], [-14, -27]],
        [[27959, 49673], [-36, -23], [-22, 36], [39, 53], [18, 39], [32, 24], [18, -27], [-30, -55], [-19, -47]],
        [[27676, 49751], [-16, -1], [-48, 54], [4, 53], [19, 36], [62, 18], [26, -34], [-3, -63], [-21, -47], [-23, -16]],
        [[27340, 49924], [-31, -10], [-26, 20], [-11, 29], [-1, 59], [58, 16], [19, -37], [-8, -77]],
        [[27603, 49995], [-15, -17], [-58, 19], [-18, 33], [27, 62], [35, -17], [35, -49], [-6, -31]],
        [
            [27387, 50195],
            [19, -36],
            [11, -102],
            [62, -108],
            [7, -61],
            [-2, -39],
            [30, -43],
            [19, -44],
            [-33, -105],
            [-69, -44],
            [-75, 1],
            [-34, 52],
            [-4, 35],
            [12, 34],
            [38, 52],
            [58, 47],
            [8, 35],
            [-24, 35],
            [-16, 69],
            [-37, 48],
            [-18, 147],
            [-38, -13],
            [-14, 27],
            [27, 34],
            [6, 24],
            [40, 11],
            [27, -56]
        ],
        [[31203, 50880], [-25, 22], [28, 37], [-3, -59]],
        [
            [32322, 50122],
            [-17, -20],
            [-42, -9],
            [-33, 20],
            [-15, -20],
            [43, -50],
            [21, -90],
            [49, -82],
            [-6, -84],
            [11, -137],
            [-53, -5],
            [-46, -318],
            [-22, -42],
            [-139, -293],
            [-182, -240],
            [-210, -138],
            [-154, -95],
            [-24, -37],
            [-76, -169],
            [8, -64],
            [-21, -13],
            [-18, 50],
            [-19, -18],
            [-16, -91],
            [-7, -102],
            [-16, -37],
            [-11, -61],
            [-13, -19],
            [-17, -95],
            [-23, -94],
            [8, -74],
            [-10, -58],
            [-54, -57],
            [-20, -59],
            [2, -49],
            [-17, -8],
            [-18, -54],
            [-13, -12],
            [-79, 35],
            [-39, 91],
            [-14, 53],
            [-4, 73],
            [-38, 47],
            [-49, -12],
            [-106, 101],
            [-18, -9],
            [-29, -59],
            [-28, -26],
            [-29, 19],
            [-3, 20],
            [41, 103],
            [-31, 2],
            [-17, 76],
            [22, 51],
            [42, -15],
            [38, 71],
            [-12, 50],
            [-1, 97],
            [-16, 106],
            [-16, 20]
        ],
        [
            [30766, 48292],
            [51, 35],
            [41, 54],
            [33, 77],
            [30, 175],
            [29, 110],
            [-5, 53],
            [-24, 71],
            [-6, 161],
            [-16, -43],
            [4, -155],
            [-14, -70],
            [-32, -5],
            [7, 114],
            [-14, -21],
            [-23, -77],
            [-37, -57],
            [-11, -42],
            [-52, 45],
            [-72, 128],
            [-48, 26],
            [-28, 45],
            [-10, 44],
            [60, 63],
            [2, 142],
            [-22, 106],
            [10, 139],
            [-6, 54],
            [-25, 115],
            [19, 59],
            [67, 42],
            [21, 28],
            [15, 92],
            [16, 55],
            [30, -22],
            [-34, 105],
            [-4, 38],
            [49, 113],
            [26, 29],
            [32, 60],
            [27, 90],
            [7, 142],
            [-20, 209],
            [16, 27],
            [41, 15],
            [33, 34],
            [17, 32],
            [40, -4],
            [45, 49],
            [73, 25],
            [102, 57],
            [22, 50],
            [-10, 89]
        ],
        [[66115, 67646], [15, -64]],
        [[66130, 67582], [75, -341], [13, -84], [39, -142], [24, -117], [42, -233], [10, -48]],
        [
            [66333, 66617],
            [-17, -25],
            [-35, -90],
            [-36, -286],
            [-53, -224],
            [-6, -140],
            [-9, -50],
            [-55, -140],
            [-54, 36],
            [-88, 122],
            [-51, 116],
            [-55, 74],
            [-52, 100],
            [-14, 71],
            [0, 46],
            [-22, 112],
            [-17, 52],
            [-64, 119],
            [-18, 64],
            [-28, 68],
            [-22, 154],
            [-26, 98],
            [-28, -27],
            [5, -42],
            [-25, -57],
            [-15, -66],
            [11, -54],
            [52, -82],
            [23, -114],
            [-2, -106],
            [8, -36],
            [39, -78],
            [35, -124],
            [38, -68],
            [56, -131],
            [52, -88],
            [38, -42],
            [16, -43],
            [4, -109],
            [-3, -53],
            [46, -148],
            [32, -41],
            [15, -46],
            [13, -76],
            [20, -223],
            [28, -55],
            [87, -293],
            [73, -186],
            [35, -139],
            [53, -169],
            [106, -370],
            [62, -115],
            [25, -64],
            [46, -49],
            [49, -72],
            [-47, 7],
            [-28, -16],
            [-12, -79],
            [6, -188],
            [13, -96],
            [41, -181],
            [46, -89],
            [21, -26],
            [97, -62],
            [57, -131],
            [128, -165],
            [13, -56]
        ],
        [
            [66940, 62446],
            [-303, 0],
            [-203, 0],
            [-203, 0],
            [-202, 0],
            [-203, 0],
            [-202, -1],
            [-203, 0],
            [-159, 0],
            [16, 85],
            [-7, 24],
            [-32, -1],
            [-30, -104],
            [-16, -4],
            [-272, 0],
            [-236, 0],
            [-236, 0],
            [-236, 0],
            [-235, 0],
            [-118, 0],
            [-236, 0],
            [-236, 0],
            [-118, 0]
        ],
        [
            [63270, 62445],
            [0, 501],
            [0, 251],
            [0, 375],
            [0, 376],
            [0, 501],
            [0, 501],
            [0, 500],
            [0, 501],
            [0, 501],
            [-20, 108],
            [-32, 242],
            [-2, 43],
            [-29, 137],
            [5, 66],
            [46, 115],
            [26, 124],
            [4, 54],
            [-30, 159],
            [-7, 153],
            [92, 178]
        ],
        [
            [63323, 67831],
            [23, -68],
            [48, -11],
            [158, 60],
            [174, -61],
            [96, -23],
            [148, -51],
            [90, -93],
            [25, -11],
            [65, 2],
            [42, -55],
            [169, -26],
            [90, -60],
            [51, -48],
            [31, -15],
            [64, 21],
            [96, 80],
            [105, 121],
            [37, 21],
            [53, -4],
            [53, 111],
            [55, 9],
            [108, 52],
            [-12, -25],
            [-99, -59],
            [43, -7],
            [93, 33],
            [15, 72],
            [44, -3],
            [102, -72],
            [25, -1],
            [87, 48],
            [-4, -71],
            [-32, -68],
            [41, -29],
            [32, -11],
            [29, -71],
            [32, 14],
            [37, 77],
            [64, -87],
            [22, -18],
            [77, 27],
            [15, -3],
            [70, 32],
            [20, -47],
            [57, 26],
            [89, 0],
            [73, 28],
            [91, 79]
        ],
        [
            [67950, 58933],
            [12, -30],
            [21, 34],
            [49, -42],
            [-3, -27],
            [-63, 10],
            [-31, -4],
            [-37, 12],
            [30, 36],
            [-39, 63],
            [30, 48],
            [28, -45],
            [3, -55]
        ],
        [[67930, 59148], [10, -54], [-30, 21], [20, 33]],
        [
            [67477, 60220],
            [93, -322],
            [38, -191],
            [33, -198],
            [25, -299],
            [24, -152],
            [38, -75],
            [26, -142],
            [22, -5],
            [16, -39],
            [28, -133],
            [20, -50],
            [10, 43],
            [-9, 65],
            [7, 53],
            [16, 32],
            [55, -76],
            [13, -102],
            [37, -76],
            [31, -23],
            [41, -5],
            [34, -17],
            [27, -29],
            [51, -78],
            [116, -68],
            [94, -210],
            [55, -145],
            [181, -221],
            [31, -106],
            [17, -103],
            [38, 5],
            [65, -113],
            [19, -86],
            [54, -31],
            [9, 50],
            [26, -41],
            [10, -65]
        ],
        [
            [68640, 57132],
            [-75, 170],
            [-56, 62],
            [-58, 168],
            [-43, 72],
            [-81, 104],
            [-75, 132],
            [-56, 138],
            [-37, 71],
            [-15, 19],
            [-76, 45],
            [-94, 114],
            [-49, 16],
            [-51, -10],
            [-43, 32],
            [-69, 21],
            [-81, -37],
            [-22, 5],
            [-20, 58],
            [-19, 25],
            [-81, -81],
            [-95, -32],
            [-22, 2],
            [-17, 23],
            [-48, 100],
            [-67, 49],
            [-37, 64],
            [-97, -392],
            [-19, 4],
            [-48, 121],
            [-30, 45],
            [-38, -27],
            [-10, -40],
            [-23, -34],
            [-66, 24],
            [-41, -4],
            [-48, -29]
        ],
        [
            [66833, 58130],
            [-30, 488],
            [29, 66],
            [14, 63],
            [35, 203],
            [41, 149],
            [31, 168],
            [-8, 184],
            [28, 98],
            [0, 36],
            [10, 108],
            [49, -10],
            [75, 11],
            [13, 26],
            [18, 100],
            [45, 45],
            [39, 50],
            [24, 7],
            [51, 38],
            [22, -7],
            [48, 33],
            [37, 74],
            [15, 59],
            [31, 64],
            [27, 37]
        ],
        [[50038, 65687], [-30, -91], [-37, 34], [56, 80], [11, -23]],
        [
            [50806, 65875],
            [5, -86],
            [-2, -66],
            [-14, -35],
            [-38, -36],
            [-47, 21],
            [-30, 57],
            [0, 60],
            [27, 39],
            [12, 50],
            [71, -10],
            [16, 6]
        ],
        [[50255, 65805], [-27, 9], [-16, 45], [20, 47], [40, -26], [9, -40], [-26, -35]],
        [
            [50518, 66005],
            [-26, -127],
            [-39, -67],
            [-35, -14],
            [-42, 79],
            [-35, 106],
            [20, 21],
            [28, -4],
            [72, 24],
            [61, 81],
            [61, 10],
            [1, -26],
            [-66, -83]
        ],
        [
            [51177, 65888],
            [-41, -64],
            [-8, 41],
            [39, 48],
            [24, 107],
            [38, 117],
            [8, 50],
            [15, 20],
            [30, -2],
            [10, -26],
            [-1, -60],
            [-11, -98],
            [-20, -87],
            [-83, -46]
        ],
        [[50055, 66068], [-52, 148], [23, 48], [40, 1], [16, -33], [-4, -122], [-23, -42]],
        [[51326, 66301], [-21, -36], [-24, 13], [12, 80], [11, 24], [42, 35], [61, 18], [-8, -81], [-23, -26], [-50, -27]],
        [[56006, 71881], [-12, -34], [-47, 12], [0, 53], [29, 59], [66, 23], [19, -46], [-40, -59], [-15, -8]],
        [
            [56530, 72367],
            [30, -19],
            [31, 17],
            [33, -14],
            [4, -36],
            [-52, -123],
            [-15, -50],
            [-53, -48],
            [-94, 61],
            [-7, 56],
            [-34, 26],
            [-42, -44],
            [-32, 35],
            [-8, 40],
            [128, 135],
            [37, 30],
            [78, 35],
            [13, -45],
            [-17, -56]
        ],
        [[56885, 72396], [-6, -7], [-95, 65], [-38, 17], [3, 48], [63, 7], [52, -24], [27, -64], [-6, -42]],
        [
            [55006, 74384],
            [12, -46],
            [39, -24],
            [67, -23],
            [-4, -51],
            [-17, -44],
            [15, -19],
            [45, 13],
            [108, -61],
            [53, -6],
            [54, -78],
            [89, 14],
            [80, -76],
            [75, 17],
            [16, -14],
            [116, -2],
            [7, 61],
            [14, 25],
            [96, -37],
            [61, -36],
            [44, -13],
            [24, -53]
        ],
        [[56086, 73880], [69, -43], [32, -41], [52, 38], [113, -42], [32, 26], [92, 42], [75, -20]],
        [
            [56551, 73840],
            [29, -80],
            [-43, -18],
            [-5, -52],
            [27, -45],
            [3, -77],
            [-75, -99],
            [-214, -167],
            [-51, -82],
            [-20, -18],
            [-159, -51],
            [-111, -55],
            [-54, -20],
            [-98, -133],
            [25, -11],
            [30, -45],
            [-10, -20],
            [-62, -41],
            [-20, 1],
            [-71, -165],
            [-64, -119],
            [-35, -51],
            [-37, -77],
            [-77, -199],
            [-1, -57],
            [38, -198],
            [22, -52],
            [31, -43],
            [58, -37],
            [15, -37],
            [-20, -35],
            [-59, -62],
            [-101, -83],
            [-43, -66],
            [-9, -64],
            [-30, -28],
            [-11, -90],
            [-44, -156],
            [32, -45],
            [-31, -28],
            [-156, -11],
            [-97, -97],
            [-48, -86],
            [-44, -160],
            [-53, -94],
            [-24, -18],
            [-36, 42],
            [-46, 6],
            [-44, -14],
            [-23, -32],
            [-36, -19],
            [-35, 16],
            [-110, 7],
            [-54, -27],
            [-45, 18],
            [-77, 9],
            [-166, -21],
            [-21, -10],
            [-21, -39],
            [-53, -69],
            [-81, -2],
            [-73, -44],
            [-18, -28],
            [-31, -77],
            [-9, -56],
            [-26, 9],
            [-6, -43],
            [-50, -27],
            [-56, 35],
            [-47, 52],
            [-25, 4],
            [-40, 81],
            [-30, 107],
            [0, 39],
            [-36, 23],
            [-9, 51],
            [5, 57],
            [-29, 69],
            [-122, 134],
            [-89, 8],
            [-72, -17]
        ],
        [
            [53273, 70911],
            [-30, 227],
            [19, 79],
            [47, 100],
            [33, 55],
            [50, 22],
            [15, 83],
            [-41, -7],
            [-73, 154],
            [19, 143],
            [48, 63],
            [25, 45],
            [14, 83],
            [-13, 28],
            [-40, 16],
            [-42, 113],
            [-9, 71],
            [-34, 39],
            [-27, 70],
            [25, 11],
            [104, 1],
            [25, 18],
            [38, 124],
            [5, 47],
            [-41, 68],
            [4, 36],
            [63, 75],
            [-11, 38],
            [9, 136],
            [-12, 125],
            [-22, 73],
            [14, 29],
            [33, 26],
            [26, 59],
            [39, 50],
            [50, 40],
            [59, 87],
            [-10, 39],
            [-45, 36],
            [-47, 4],
            [-5, 112],
            [-18, 38],
            [-27, -4],
            [-101, 9],
            [-36, 17],
            [-19, -48],
            [-60, -35],
            [-33, 2],
            [-56, 29],
            [-70, -3],
            [-54, -38],
            [-18, -2],
            [-22, 47],
            [29, 68],
            [-26, 65],
            [-100, -36],
            [-45, -34],
            [-29, -38]
        ],
        [
            [52850, 73566],
            [-31, 4],
            [-3, 88],
            [61, 94],
            [-39, 6],
            [27, 71],
            [-25, 32],
            [0, 95],
            [-55, -30],
            [-14, 42],
            [33, 76],
            [-35, 9],
            [-27, 29],
            [-33, 62],
            [0, 33],
            [18, 77],
            [47, 36],
            [47, 53],
            [64, -10],
            [39, 12],
            [89, 57],
            [-12, 56],
            [10, 22],
            [78, 64],
            [47, 7],
            [47, 32],
            [32, -21],
            [28, 7],
            [33, -24],
            [42, -57],
            [62, -22],
            [50, 17],
            [87, 4],
            [44, -7],
            [77, 13],
            [45, -5],
            [72, 28],
            [56, -35],
            [108, -16],
            [65, -28],
            [179, -48],
            [65, -1],
            [92, 27],
            [39, 20],
            [36, -12],
            [52, 23],
            [25, -4],
            [33, -33],
            [114, -45],
            [31, 38],
            [22, 8],
            [83, -23],
            [83, -47],
            [43, -4],
            [64, 13],
            [61, 35]
        ],
        [
            [62541, 82867],
            [107, -9],
            [101, -68],
            [-51, -27],
            [-114, -97],
            [-8, -17],
            [-72, 3],
            [-39, -11],
            [-32, -31],
            [-13, -61],
            [-23, -47],
            [-48, -20],
            [-3, 36],
            [51, 67],
            [-36, 54],
            [-47, 28],
            [31, 69],
            [-37, 62],
            [43, 7],
            [24, -18],
            [57, 17],
            [19, 40],
            [90, 23]
        ],
        [[62765, 82827], [-26, -6], [-61, 40], [32, 37], [51, -16], [4, -55]],
        [
            [62635, 82981],
            [-48, -3],
            [-33, -62],
            [-37, -11],
            [-40, 97],
            [-77, 19],
            [-33, 25],
            [126, 18],
            [38, 59],
            [36, -4],
            [7, -33],
            [57, -13],
            [30, -88],
            [-26, -4]
        ],
        [[64206, 83348], [43, -61], [-42, -41], [-37, -13], [-43, -126], [-27, -39]],
        [
            [64100, 83068],
            [-45, 14],
            [-70, -7],
            [-58, -23],
            [-42, -39],
            [-2, -44],
            [59, -87],
            [24, -110],
            [59, -83],
            [14, -48],
            [53, -112]
        ],
        [[64092, 82529], [34, -97], [-65, -24], [-44, -73], [-15, -78]],
        [
            [64002, 82257],
            [-51, 6],
            [-89, 39],
            [-113, -43],
            [-72, 39],
            [-83, 103],
            [-12, 29],
            [-61, 17],
            [-140, 95],
            [-34, -24],
            [-37, 38],
            [-243, -108]
        ],
        [
            [63067, 82448],
            [44, 131],
            [20, 139],
            [-60, 15],
            [-31, -51],
            [-37, -13],
            [-107, 53],
            [-24, 80],
            [-40, 39],
            [-16, 47],
            [7, 68],
            [-31, 78],
            [26, 43],
            [-7, 110],
            [89, 44],
            [93, 10],
            [-9, 44],
            [38, 3],
            [63, 53],
            [63, -9],
            [90, 37],
            [175, -1],
            [24, 22],
            [-4, 44],
            [88, -2],
            [206, -45],
            [51, 0],
            [70, -46],
            [38, -12],
            [111, 0],
            [172, -20],
            [37, 39]
        ],
        [
            [68808, 56314],
            [-5, -22],
            [-44, -96],
            [-32, -93],
            [38, -140],
            [18, -93],
            [22, -35],
            [48, -119],
            [35, -26],
            [11, -61],
            [27, -90],
            [55, -128],
            [43, -24],
            [112, -183],
            [12, -13],
            [269, -159],
            [204, -121],
            [228, -138],
            [193, -117],
            [18, -16],
            [309, 0]
        ],
        [
            [70369, 54640],
            [-163, -282],
            [-148, -259],
            [-169, -295],
            [-151, -279],
            [-153, -302],
            [-154, -303],
            [-9, -7],
            [-273, 29],
            [-42, -12],
            [-109, -50],
            [-63, -50],
            [-64, -59],
            [-34, -46],
            [-26, -65],
            [-11, -47],
            [-32, -39],
            [-135, -44],
            [-39, -6],
            [-63, -36],
            [-34, -59],
            [-9, -30]
        ],
        [
            [68488, 52399],
            [-46, 1],
            [-159, -20],
            [-41, 27],
            [-67, 110],
            [-33, 47],
            [-73, -54],
            [-159, -128],
            [-53, -53],
            [-16, -55],
            [-41, -98],
            [-36, -61],
            [-14, -7],
            [-83, 13],
            [-146, 44],
            [-45, 23],
            [-118, 11],
            [-43, 17],
            [-43, 54],
            [-174, 203],
            [-147, 168],
            [-25, 10],
            [-229, 11],
            [-32, 30],
            [-18, 65],
            [-49, 105],
            [-2, 79],
            [14, 115],
            [-3, 68],
            [-14, 37],
            [-86, 42],
            [-44, -31],
            [-19, 27],
            [2, 44]
        ],
        [
            [66446, 53243],
            [-58, 101],
            [-30, 103],
            [-8, 105],
            [-37, 142],
            [-40, 201],
            [-45, 66],
            [-24, 66],
            [-64, 59],
            [-66, 124],
            [-14, 79],
            [-36, 79],
            [-73, 90],
            [-46, 21],
            [-90, 29],
            [-65, 60],
            [-1, 47],
            [17, 49],
            [52, 199],
            [14, 22],
            [40, 6],
            [116, -9],
            [52, 7],
            [43, 77],
            [2, 95],
            [-7, 396]
        ],
        [
            [66078, 55457],
            [13, 149],
            [20, 105],
            [33, 115],
            [7, 71],
            [-12, 154],
            [21, 73],
            [27, 72],
            [44, 52],
            [61, -75],
            [14, 7],
            [36, 59],
            [-2, 54],
            [13, 112],
            [-2, 64],
            [14, 79],
            [23, 184],
            [9, 38],
            [44, 78],
            [61, 192],
            [45, 132],
            [23, 48],
            [46, 34],
            [89, 23],
            [8, 44],
            [8, 161],
            [16, 99],
            [55, 198],
            [17, 120],
            [-1, 82],
            [25, 149]
        ],
        [[62404, 83842], [56, -8], [-13, -48], [14, -58], [-31, 0], [-56, 67], [30, 47]],
        [[62181, 83931], [-47, -28], [-17, 26], [17, 39], [47, -37]],
        [[63229, 86418], [-46, -18], [-37, 11], [-1, 36], [65, 25], [57, -18], [-38, -36]],
        [
            [64500, 88666],
            [-123, -52],
            [43, -35],
            [14, -53],
            [-84, -130],
            [-3, -28],
            [67, -166],
            [203, -71],
            [56, -74],
            [91, -98],
            [49, -37],
            [-12, -78],
            [-114, -125],
            [-149, -197],
            [1, -68],
            [115, -176],
            [64, -143],
            [72, -103],
            [56, -170],
            [3, -59],
            [-117, -31],
            [32, -32],
            [-29, -53],
            [-4, -76],
            [-26, -63],
            [56, -10],
            [0, -54],
            [-58, -39],
            [-6, -39],
            [30, -69],
            [25, -23],
            [90, -22],
            [14, -67],
            [-41, -48],
            [38, -107],
            [117, -72],
            [12, -54],
            [-7, -67],
            [-91, -121],
            [-63, -31],
            [16, -33],
            [112, -103],
            [171, -113],
            [64, -52],
            [48, -78],
            [53, -63],
            [8, -39],
            [-77, -177],
            [-30, -48],
            [-78, -88],
            [-114, -109],
            [-270, -324],
            [-61, -57],
            [-75, -87],
            [-158, -128],
            [-23, -31],
            [-79, -59],
            [-188, -202]
        ],
        [
            [64140, 83934],
            [-104, -39],
            [-68, 41],
            [-51, -8],
            [-39, -30],
            [-71, -9],
            [-57, -23],
            [-102, -4],
            [-52, 38],
            [1, -57],
            [-100, -58],
            [-18, 36],
            [-62, -40],
            [-58, -7],
            [-35, -30],
            [-171, -45],
            [-48, -52],
            [-32, 12],
            [-191, -43],
            [-80, 12],
            [-87, -79],
            [-21, 38],
            [26, 61],
            [-63, 42],
            [-46, 50],
            [-16, -62],
            [-45, -27],
            [-57, 1],
            [2, 96],
            [33, 88],
            [-98, 23],
            [-100, 55],
            [-25, 3],
            [-15, 50],
            [-59, -35],
            [-55, 36],
            [-23, 207],
            [5, 51],
            [31, 62],
            [13, 134],
            [-7, 79],
            [33, 22],
            [-68, 180],
            [-40, 42],
            [31, 130],
            [-10, 67],
            [-48, 39],
            [-20, 117],
            [29, 93],
            [81, 89],
            [5, 47],
            [54, 3],
            [-25, 42],
            [-7, 50],
            [78, 19],
            [30, -16],
            [69, 19],
            [62, 37],
            [-24, 71],
            [48, 30],
            [40, 50],
            [1, 37],
            [70, 20],
            [79, 77],
            [73, 42],
            [75, 77],
            [33, 4],
            [16, 52],
            [84, 78],
            [30, 62],
            [79, 72],
            [87, 159],
            [118, 47],
            [107, -14],
            [-19, 51],
            [45, 33],
            [-10, 49],
            [-26, 25],
            [28, 188],
            [-32, 37],
            [-124, 64],
            [-51, 5],
            [-29, 48],
            [-132, 27]
        ],
        [
            [63015, 86872],
            [-32, 103],
            [-44, 89],
            [-48, 24],
            [-24, 105],
            [8, 56],
            [51, 53],
            [9, 73],
            [29, 58],
            [-15, 37],
            [-81, 106],
            [-17, 65],
            [10, 47],
            [37, 34],
            [-13, 52],
            [-82, 15],
            [22, 79],
            [-12, 59],
            [1, 99],
            [42, 45],
            [-51, 35],
            [-48, 63],
            [-42, 3],
            [-26, 68],
            [-97, 74],
            [-243, 72],
            [-164, 95],
            [-87, 77],
            [-82, 44],
            [-7, 40],
            [-84, 32]
        ],
        [
            [61925, 88674],
            [16, 18],
            [140, 7],
            [-23, 59],
            [66, 48],
            [109, -1],
            [210, -232],
            [34, -76],
            [282, -39],
            [118, 36],
            [45, 51],
            [45, -4],
            [103, -48],
            [114, -33],
            [74, -33],
            [45, 26],
            [26, 70],
            [57, 54],
            [68, 14],
            [53, 57],
            [0, 135],
            [32, 75],
            [49, 160],
            [92, 72],
            [67, 74],
            [66, 10],
            [114, -16],
            [149, 77],
            [92, 11],
            [49, -51],
            [112, -83],
            [120, -50],
            [105, -34],
            [60, -111],
            [-30, -44],
            [-121, -121],
            [-4, -32],
            [41, -54]
        ],
        [
            [110652, 39602],
            [0, -24],
            [-40, -16],
            [-21, 23],
            [-39, -66],
            [-44, -16],
            [-19, 16],
            [29, 35],
            [16, -4],
            [32, 54],
            [39, 20],
            [47, -22]
        ],
        [[110918, 40088], [-29, 40], [16, 48], [17, -68], [-4, -20]],
        [[110757, 40296], [-25, 24], [13, 34], [20, -32], [-8, -26]],
        [
            [110588, 40495],
            [41, -84],
            [55, -72],
            [-5, -55],
            [13, -102],
            [16, -82],
            [-22, -16],
            [-82, -15],
            [-53, -64],
            [-63, -8],
            [-34, 6],
            [-65, 41],
            [-55, 18],
            [-42, 39],
            [-18, 61],
            [0, 59],
            [30, 24],
            [20, 46],
            [-7, 59],
            [67, 95],
            [61, 41],
            [38, -4],
            [77, 46],
            [28, -33]
        ],
        [[111119, 40723], [-32, -1], [11, 49], [21, 51], [0, -99]],
        [[8, 40744], [-8, -21], [0, 31], [0, 46], [0, 22], [43, 54], [12, -43], [-14, -47], [-33, -42]],
        [
            [111119, 41166],
            [-47, -74],
            [-31, -81],
            [-40, -45],
            [-17, -61],
            [2, -62],
            [39, 65],
            [45, 52],
            [28, 10],
            [-13, -82],
            [12, -43],
            [-66, 0],
            [-39, -24],
            [-52, -11],
            [-23, 21],
            [-7, 28],
            [-37, 3],
            [-46, -56],
            [-15, -48],
            [-38, 8],
            [-24, -37],
            [-30, -13],
            [-32, 97],
            [-33, 8],
            [5, 34],
            [22, 58],
            [32, -24],
            [36, 19],
            [19, 51],
            [29, 32],
            [41, 25],
            [82, 32],
            [60, 73],
            [50, 23],
            [41, -4],
            [47, 35],
            [0, -9]
        ],
        [[36725, 21307], [44, -5], [-22, -85], [-26, 2], [-35, 58], [39, 30]],
        [
            [36951, 21487],
            [45, -10],
            [69, 51],
            [40, -32],
            [91, 28],
            [33, 20],
            [37, -38],
            [-53, -92],
            [-23, -19],
            [-62, -101],
            [-64, -90],
            [-65, -13],
            [-35, 4],
            [-33, -86],
            [-48, -30],
            [-55, 3],
            [-39, 23],
            [-46, 50],
            [61, 62],
            [53, -3],
            [79, 63],
            [30, 37],
            [-12, 31],
            [-69, -22],
            [10, 33],
            [69, 33],
            [-18, 32],
            [-62, 53],
            [18, 48],
            [49, -35]
        ],
        [[37005, 21524], [-42, 0], [-8, 64], [32, 4], [31, -19], [-13, -49]],
        [
            [37395, 21594],
            [47, -32],
            [59, 11],
            [39, -36],
            [-43, -29],
            [14, -47],
            [62, -37],
            [-5, 66],
            [25, 29],
            [71, 11],
            [52, -74],
            [-33, -9],
            [-14, -27],
            [52, -30],
            [-14, -41],
            [-97, -31],
            [-57, -55],
            [-107, -40],
            [14, -49],
            [-4, -42],
            [-148, 51],
            [-20, -6],
            [39, -86],
            [-29, -16],
            [-55, 3],
            [-17, -63],
            [-42, 40],
            [-36, 57],
            [0, 32],
            [35, 60],
            [-11, 25],
            [81, 81],
            [15, 24],
            [62, 29],
            [-12, 53],
            [1, 55],
            [64, 74],
            [12, 49]
        ],
        [
            [72782, 38283],
            [-43, -17],
            [-31, 6],
            [-60, 47],
            [-16, 32],
            [-24, 88],
            [24, 86],
            [43, 22],
            [45, -8],
            [20, -15],
            [55, -129],
            [-13, -112]
        ],
        [[69505, 42946], [-19, -5], [-15, 50], [7, 61], [-15, 47], [15, 27], [13, -31], [27, -24], [-13, -125]],
        [
            [38701, 51478],
            [25, 10],
            [16, 40],
            [26, 26],
            [63, 198],
            [8, 98],
            [-10, 81],
            [60, 173],
            [6, 78],
            [-14, 23],
            [-24, 78],
            [-44, 73],
            [-30, 86],
            [3, 47],
            [-17, 57],
            [-16, 136],
            [7, 54],
            [-4, 61],
            [-10, 32],
            [0, 92],
            [6, 55],
            [37, 97],
            [55, 96]
        ],
        [
            [38844, 53169],
            [21, 30],
            [30, 147],
            [21, 52],
            [23, 7],
            [121, -122],
            [57, -11],
            [114, -66],
            [42, -85],
            [96, -140],
            [50, -44],
            [1, -37],
            [21, -8],
            [50, -81],
            [43, -107],
            [12, 61],
            [16, 1],
            [13, -37],
            [27, -158],
            [10, -32],
            [4, -93]
        ],
        [
            [36785, 58263],
            [-23, -12],
            [-51, -3],
            [-8, 34],
            [25, 41],
            [-41, 28],
            [-24, 85],
            [2, 24],
            [27, 15],
            [31, -27],
            [33, -51],
            [-5, -27],
            [20, -41],
            [14, -66]
        ],
        [[36660, 59041], [-25, 3], [-2, 33], [21, 29], [14, -48], [-8, -17]],
        [
            [36549, 59106],
            [-25, -25],
            [-27, 56],
            [-11, 133],
            [14, 30],
            [33, -16],
            [28, -31],
            [-7, -24],
            [3, -100],
            [-8, -23]
        ],
        [[36630, 59231], [-60, -2], [-6, 40], [12, 34], [-8, 41], [18, 41], [20, -22], [15, -58], [57, -60], [-48, -14]],
        [
            [58486, 74048],
            [-8, -82],
            [22, -59],
            [7, -236],
            [-46, -113],
            [-2, -109],
            [-43, -151],
            [-21, -42],
            [-90, 73],
            [-27, 41],
            [25, 62],
            [-53, 34],
            [13, 61],
            [-6, 30],
            [-38, 19],
            [27, 47],
            [-1, 29],
            [-35, 37],
            [-6, 32],
            [33, 37],
            [-15, 33],
            [4, 46],
            [23, 69],
            [31, 32],
            [71, 30],
            [29, 40],
            [46, -22],
            [16, 41],
            [-2, 98],
            [10, 41],
            [30, -20],
            [6, -98]
        ],
        [[55196, 75776], [-11, -49], [-48, 84], [26, 20], [33, -55]],
        [[57347, 77802], [52, -46], [35, 0], [52, 22], [32, -23]],
        [
            [57727, 75788],
            [-25, -32],
            [-42, -30],
            [0, -58],
            [24, -22],
            [40, -95],
            [44, -56],
            [-24, -89],
            [-30, -14],
            [-43, -45],
            [-46, 5],
            [-20, -14],
            [34, -110],
            [20, -21],
            [59, -31],
            [12, -62],
            [-22, -22],
            [-36, -93],
            [15, -46],
            [2, -52],
            [21, -31],
            [56, -43],
            [69, -42],
            [82, 21],
            [12, -45],
            [-8, -28],
            [-52, -94],
            [3, -55]
        ],
        [
            [57872, 74584],
            [-16, -9],
            [-19, -10],
            [-61, -41],
            [-98, -123],
            [-45, -36],
            [-19, -62],
            [-50, -52],
            [-58, -17],
            [-59, -37],
            [-26, 16],
            [-68, -2],
            [-43, 45],
            [-82, 28],
            [-26, 65],
            [-62, 2],
            [-19, 54],
            [-45, -10],
            [-38, -27],
            [-50, 5],
            [-144, 65],
            [-34, 49],
            [-43, -16],
            [-39, -57],
            [-163, -150],
            [-29, -62],
            [-35, -93],
            [-2, -43],
            [15, -137],
            [37, -89]
        ],
        [
            [55006, 74384],
            [50, 17],
            [45, 70],
            [43, 255],
            [31, 300],
            [23, 57],
            [29, 16],
            [-23, 41],
            [-29, -54],
            [17, 276],
            [13, 101],
            [21, 106],
            [78, -85],
            [19, -37],
            [23, -123],
            [16, -2],
            [-29, 164],
            [-45, 86],
            [-90, 82],
            [-12, 48],
            [44, 19],
            [-11, 67],
            [-13, 215],
            [-76, 22],
            [-122, 92],
            [-42, 94],
            [-42, 70],
            [-10, 62],
            [22, 65],
            [-19, 41],
            [-36, 29],
            [28, 56],
            [-76, 8],
            [-46, 19],
            [-8, 39],
            [31, 50],
            [-39, 31],
            [-67, -7],
            [12, 49],
            [-17, 13],
            [-54, -14],
            [-31, 11],
            [-30, 41],
            [-32, -5],
            [-56, 14],
            [-19, 24],
            [-122, 47],
            [-52, 6],
            [-48, -22],
            [-26, 8],
            [-36, 81],
            [-78, 40],
            [16, 25],
            [77, 24],
            [15, 23],
            [-56, 34],
            [-6, 44],
            [39, -9],
            [3, 42],
            [-100, -3],
            [-14, 49],
            [13, 50],
            [59, 44],
            [146, 49],
            [62, -7],
            [44, 9],
            [52, 31],
            [23, 26],
            [74, 15],
            [71, -28],
            [64, -105],
            [31, -36],
            [76, 62],
            [114, -2],
            [23, -35],
            [30, 64],
            [25, -37],
            [120, 6],
            [-40, 92],
            [-5, 221],
            [-33, 62],
            [-56, 157],
            [4, 49],
            [83, -9],
            [69, 23],
            [33, -16],
            [8, -103],
            [29, -60],
            [55, 3],
            [60, -18],
            [76, -3],
            [110, -32],
            [47, 18],
            [89, 74],
            [-46, 26],
            [-6, 27],
            [24, 81],
            [133, 89],
            [95, 27],
            [99, 49],
            [50, 50],
            [33, 65],
            [11, 50],
            [9, 248],
            [29, 81],
            [74, 59],
            [164, 42],
            [25, 17]
        ],
        [[53492, 84441], [-59, 50], [37, 28], [22, -78]],
        [[53341, 84828], [38, -37], [-59, -15], [-38, 16], [-14, 37], [73, -1]],
        [[53513, 84878], [-8, -75], [-56, 1], [35, -59], [-26, -7], [-63, 65], [-49, 107], [66, 17], [101, -49]],
        [[104426, 53980], [-41, -7], [-15, 80], [16, 19], [33, -15], [13, -33], [-6, -44]],
        [[98199, 55478], [-8, 28], [21, 24], [9, -26], [-22, -26]],
        [
            [58995, 47997],
            [-30, 51],
            [-26, 91],
            [-31, 56],
            [-64, 91],
            [-17, 67],
            [-74, 148],
            [-105, 148],
            [-76, 128],
            [1, 25],
            [74, -64],
            [18, 21],
            [-62, 60],
            [-28, 17],
            [-29, -2],
            [-16, 27],
            [-28, 114],
            [-40, 75],
            [-19, 75],
            [44, -38],
            [0, 38],
            [-44, 36],
            [-24, 2],
            [-2, 56],
            [-31, 110],
            [-32, 83],
            [-5, 39],
            [87, -180],
            [27, -1],
            [36, 20],
            [-23, 50],
            [-36, -15],
            [-16, 30],
            [5, 67],
            [-29, -12],
            [-43, 47],
            [-58, 197],
            [-10, 18],
            [-43, 180],
            [17, -14],
            [19, -52],
            [39, 11],
            [15, 30],
            [27, 6],
            [17, 28],
            [49, 124],
            [13, 164],
            [-11, 193],
            [16, 31],
            [17, -80],
            [18, -23],
            [33, -6],
            [50, -36],
            [23, 23],
            [59, 39],
            [-18, 14],
            [-52, -16],
            [-71, 58],
            [-23, 37],
            [-22, 69],
            [-23, 37],
            [1, 33],
            [51, 30],
            [19, -40],
            [19, -10],
            [3, 114],
            [-16, 118],
            [5, 22]
        ],
        [[58520, 50756], [26, 24], [26, 0], [14, -42], [31, -22], [38, 25], [256, -2], [147, -1], [-1, 295], [-1, 357]],
        [[55231, 78445], [-41, -51], [-34, -6], [-64, 45], [0, 19], [62, 39], [52, -22], [25, -24]],
        [[54264, 79912], [35, -32], [-89, -73], [-31, 24], [-25, 47], [-4, 70], [32, 18], [46, -1], [36, -53]],
        [
            [53640, 80340],
            [-57, -16],
            [-76, -1],
            [1, 58],
            [-37, 18],
            [-52, 100],
            [-35, 19],
            [-48, -60],
            [15, -34],
            [-62, -66],
            [-77, 12],
            [-23, 24],
            [-54, 16],
            [-9, 38],
            [-72, 73],
            [-9, 22],
            [32, 33],
            [77, 33],
            [15, 24],
            [-44, 28],
            [4, 29],
            [42, -4],
            [58, 32],
            [31, 61],
            [23, 84],
            [48, 36]
        ],
        [
            [53331, 80899],
            [37, -24],
            [21, 18],
            [26, 56],
            [77, 6],
            [69, 27],
            [107, -13],
            [28, -41],
            [16, -64],
            [36, -63],
            [47, -55],
            [2, -34],
            [-52, -40],
            [91, -12],
            [35, -91],
            [-54, -13],
            [-3, -53],
            [30, -6],
            [-15, -55],
            [-68, -20],
            [-34, -82],
            [-25, -21],
            [-62, 21]
        ],
        [[53984, 81098], [-70, 18], [-19, 76], [23, 51], [49, -24], [17, -51], [0, -70]],
        [[53668, 81366], [22, -131], [-61, -49], [-25, 93], [-49, -35], [15, 68], [41, 13], [57, 41]],
        [[53717, 81302], [-32, 44], [41, 84], [43, 36], [1, -58], [-53, -106]],
        [[53776, 81597], [-123, -31], [12, 113], [-53, 34], [7, 33], [57, 19], [48, -62], [57, -24], [-5, -82]],
        [[53322, 82027], [-41, 9], [-13, 55], [4, 84], [44, -5], [6, -143]],
        [
            [53663, 82244],
            [3, -106],
            [78, -28],
            [54, 3],
            [12, -24],
            [-87, -101],
            [-20, 4],
            [-6, 83],
            [-40, -11],
            [-49, 12],
            [-37, 69],
            [-72, 20],
            [-26, 44],
            [44, 67],
            [74, 23],
            [40, 27],
            [25, -37],
            [7, -45]
        ],
        [[53335, 82344], [35, -32], [-28, -52], [-42, 0], [-60, 38], [5, 20], [90, 26]],
        [
            [53646, 82723],
            [-39, -97],
            [-34, -54],
            [3, -40],
            [-79, -61],
            [-35, -47],
            [-50, -43],
            [-39, 35],
            [68, 67],
            [-60, 39],
            [-8, 100],
            [22, 26],
            [39, -26],
            [50, 8],
            [-20, 49],
            [170, 122],
            [12, -78]
        ],
        [
            [54600, 82808],
            [2, -46],
            [-34, -63],
            [-61, -45],
            [-113, -105],
            [-66, -52],
            [-14, -59],
            [40, -7],
            [5, -29],
            [-58, -62],
            [-18, -55],
            [83, 12],
            [143, 61],
            [99, -20],
            [70, 11],
            [189, -7],
            [52, 12],
            [35, -14],
            [29, -36],
            [28, -66],
            [-18, -41],
            [-57, -90],
            [-21, -87],
            [-53, -133],
            [-52, -74],
            [-51, -95],
            [-56, -44],
            [-84, -18],
            [-52, -37],
            [102, 8],
            [72, -44],
            [-7, -37],
            [-29, -28],
            [-65, -5],
            [-62, -63],
            [-56, -29],
            [96, -43],
            [66, 42],
            [73, 0],
            [140, -69],
            [98, -129],
            [54, -56],
            [14, -41],
            [57, -263],
            [41, -140],
            [42, -67],
            [122, -63],
            [27, -21],
            [93, -125],
            [88, -90],
            [-37, -54],
            [11, -45],
            [56, -110],
            [8, -57],
            [-34, 1],
            [-61, 52],
            [-7, -25],
            [130, -124],
            [44, -74],
            [26, -98],
            [-18, -44],
            [-77, -98],
            [72, -54],
            [31, 9],
            [55, 79],
            [45, 6],
            [108, -10],
            [101, -37],
            [85, -78],
            [18, -43],
            [10, -116],
            [-31, -106],
            [-10, -65],
            [-17, -42],
            [-75, -72],
            [-13, -62],
            [-54, -34],
            [-45, 13],
            [-62, -44],
            [45, -22],
            [-3, -66],
            [-28, -19],
            [-63, -10],
            [28, -74],
            [63, -15],
            [114, 8],
            [48, -6],
            [-5, -101],
            [-10, -15],
            [-99, -60],
            [-26, -68],
            [-58, 5],
            [-27, -28],
            [-47, -17],
            [-72, -44],
            [-29, -7],
            [-126, 29],
            [-77, -3],
            [-103, -24],
            [-26, 4],
            [-81, 40],
            [-47, 7],
            [-72, -61],
            [-107, -18],
            [-51, 5],
            [21, -54],
            [-23, -14],
            [-97, 19],
            [-26, -21],
            [-35, 9],
            [-71, 50],
            [-68, 6],
            [-125, -47],
            [-25, -47],
            [-31, -126],
            [-29, -45],
            [-35, -6],
            [-33, 31],
            [-63, 35],
            [-21, 24],
            [-39, -18],
            [-65, -10],
            [-68, -28],
            [-99, -87],
            [-21, -54],
            [-33, -9],
            [-30, 34],
            [-35, 12],
            [-58, -30],
            [-10, 45],
            [26, 37],
            [71, 27],
            [61, 71],
            [58, 83],
            [115, 142],
            [18, 112],
            [70, 27],
            [34, 90],
            [107, 24],
            [72, -1],
            [72, -18],
            [74, 5],
            [29, 24],
            [49, 87],
            [90, 114],
            [-120, -39],
            [-97, -83],
            [-83, 13],
            [-62, 70],
            [-56, 32],
            [-53, -17],
            [-18, 34],
            [-65, 64],
            [-67, -2],
            [-93, -62],
            [-68, 44],
            [-14, 19],
            [-10, 68],
            [-19, 10],
            [54, 65],
            [65, 25],
            [98, 61],
            [55, 26],
            [72, 72],
            [52, 120],
            [-31, 37],
            [13, 53],
            [-24, 65],
            [5, 53],
            [-79, -10],
            [-70, -46],
            [-17, 43],
            [72, 68],
            [23, 51],
            [68, 64],
            [93, 46],
            [50, -2],
            [99, 27],
            [70, -48],
            [-21, 75],
            [32, 17],
            [1, 89],
            [42, 82],
            [-33, 23],
            [1, 74],
            [39, 30],
            [17, 97],
            [-45, 20],
            [-54, -24],
            [-48, 57],
            [-76, 133],
            [-7, 54],
            [39, 116],
            [61, 75],
            [57, 30],
            [-108, 1],
            [-36, -9],
            [-34, -30],
            [-38, -13],
            [-54, -50],
            [-54, 0],
            [-23, 32],
            [-30, -1],
            [-66, -43],
            [-93, 49],
            [-22, -41],
            [-44, -6],
            [-32, 53],
            [-11, 72],
            [36, 1],
            [28, 90],
            [75, 151],
            [14, 45],
            [-15, 54],
            [-51, 56],
            [6, 98],
            [20, 37],
            [42, 15],
            [-54, 47],
            [-76, -36],
            [-13, -30],
            [-35, -2],
            [7, 76],
            [-18, 13],
            [-40, -52],
            [8, -126],
            [-53, -212],
            [-27, -35],
            [-38, 20],
            [27, 146],
            [33, 93],
            [-15, 12],
            [4, 135],
            [17, 44],
            [6, 65],
            [44, 147],
            [54, 132],
            [-107, -103],
            [-27, -19],
            [-66, 16],
            [-22, 25],
            [-30, 88],
            [48, 9],
            [46, 41],
            [-41, 27],
            [39, 33],
            [45, 79],
            [9, 73],
            [-29, 56],
            [-43, 25],
            [-7, 32],
            [43, 76],
            [-21, 53],
            [42, 119],
            [80, -2],
            [54, 16],
            [-67, 77],
            [17, 108],
            [102, 14],
            [-26, 68],
            [8, 75],
            [43, 38],
            [36, -8],
            [29, -35],
            [69, 32],
            [18, -31],
            [76, 25],
            [101, 11],
            [126, 22],
            [60, 19],
            [63, -9],
            [-17, -66]
        ],
        [[54583, 82963], [-36, -7], [-37, 56], [40, 13], [33, -62]],
        [[54616, 83094], [91, -41], [-31, -36], [-41, 27], [-53, -11], [-56, 37], [12, 81], [47, 3], [33, -21], [-2, -39]],
        [
            [55156, 83935],
            [46, -67],
            [29, -20],
            [-35, -149],
            [-7, -60],
            [-26, -67],
            [-22, 14],
            [25, 113],
            [-15, 42],
            [-49, -9],
            [-4, 67],
            [37, 22],
            [-23, 76],
            [-31, 7],
            [42, 65],
            [33, -34]
        ],
        [[55238, 83922], [-38, 50], [36, 24], [2, -74]],
        [
            [68968, 73101],
            [-25, 47],
            [-48, 5],
            [-17, 60],
            [-28, 25],
            [-47, 64],
            [-26, 14],
            [-10, 40],
            [-33, 12],
            [-35, -15],
            [-32, -66],
            [-78, 26],
            [-89, 5],
            [-31, -35],
            [-97, 47]
        ],
        [
            [68372, 73330],
            [59, 105],
            [18, 62],
            [1, 85],
            [-31, 99],
            [-53, 286],
            [-22, 43],
            [-90, 51],
            [-20, 57],
            [-70, 74],
            [-96, 32],
            [-19, 14],
            [-84, 93],
            [-66, 60]
        ],
        [
            [67899, 74391],
            [33, 74],
            [20, 9],
            [114, -32],
            [40, 12],
            [91, -64],
            [43, -24],
            [85, -23],
            [69, -64],
            [145, -16],
            [71, 21],
            [43, -2],
            [45, -39],
            [60, 8],
            [71, -43],
            [31, -57],
            [79, -52],
            [65, -29],
            [70, -54],
            [4, -25],
            [-18, -48],
            [27, -25],
            [41, -3],
            [114, 76],
            [55, 26],
            [43, -8],
            [39, -66],
            [31, 78],
            [104, -60],
            [41, -66],
            [68, 3],
            [51, -34],
            [-29, -134],
            [1, -17],
            [65, -53],
            [33, -41],
            [80, -25],
            [67, -56]
        ],
        [
            [55538, 56379],
            [24, -53],
            [-7, -72],
            [-23, -98],
            [10, -48],
            [45, -61],
            [39, -72],
            [36, -47],
            [9, -39],
            [-3, -174],
            [-9, -132],
            [-16, -11],
            [-3, -96],
            [9, -36],
            [25, 30],
            [24, -3],
            [24, -46],
            [1, -22],
            [-20, -135],
            [-1, -79],
            [8, -69],
            [-36, -51],
            [14, -59],
            [21, -44],
            [41, -53],
            [21, -69],
            [1, -29],
            [-28, -53],
            [-4, -35],
            [6, -233],
            [-32, -101],
            [3, -62],
            [38, -46],
            [-17, -195],
            [-17, -36],
            [1, -49],
            [21, -61],
            [44, -161],
            [54, -69],
            [23, -5],
            [5, -29],
            [25, -53],
            [31, -16],
            [1, -31]
        ],
        [
            [55926, 53576],
            [-25, -21],
            [-17, -32],
            [-31, -102],
            [-62, -28],
            [-151, -2],
            [-120, -105],
            [-68, -38],
            [-42, -59],
            [-57, -42],
            [-40, -52],
            [-82, -24],
            [-135, -81],
            [-42, -32],
            [-43, -56],
            [-69, -66],
            [-28, 1],
            [-54, 62],
            [-41, 31],
            [-100, 47],
            [-75, 18],
            [-46, 23]
        ],
        [[54607, 53040], [21, 2]],
        [
            [52044, 57097],
            [-9, -14],
            [-26, -100],
            [3, -18],
            [58, -84],
            [29, 5],
            [45, 81],
            [19, 21],
            [22, -2],
            [17, -29],
            [42, -126],
            [20, -15],
            [65, 133],
            [59, 41],
            [140, -94],
            [33, 0],
            [17, 56],
            [53, 47],
            [40, 15],
            [8, 38],
            [-19, 67],
            [9, 20],
            [46, 2],
            [53, -45],
            [14, -31],
            [26, -133],
            [30, -103],
            [-2, -139],
            [35, -31],
            [14, -57],
            [30, -21],
            [49, -51],
            [-5, -46],
            [-29, -38],
            [-45, -112],
            [6, -25],
            [25, 4],
            [28, 28],
            [42, -32],
            [10, -53],
            [-6, -81],
            [18, -147],
            [11, -27],
            [69, -65],
            [10, -51],
            [-5, -38]
        ],
        [
            [52940, 54395],
            [-24, 38],
            [-4, 29],
            [-25, 6],
            [-15, -17],
            [-10, -91],
            [-27, -57],
            [-19, -72],
            [-22, 6],
            [-49, -33],
            [-45, 91],
            [-28, 17],
            [-25, -6],
            [-7, 25],
            [15, 37],
            [13, 73],
            [-8, 86],
            [-13, 40],
            [-2, 57],
            [-13, 105],
            [-7, 11],
            [-3, 95],
            [-29, 31],
            [-16, 40],
            [-23, -11],
            [-10, 45],
            [-91, -59],
            [-10, 43],
            [-16, 7],
            [-42, -19]
        ],
        [
            [52385, 54912],
            [-34, -2],
            [-31, -66],
            [-19, -26],
            [-48, 11],
            [26, 108],
            [39, 73],
            [0, 15],
            [-32, 100],
            [-3, 107],
            [-34, 13],
            [-8, 22],
            [20, 78],
            [-1, 29],
            [-54, 113],
            [-56, 151],
            [-22, 31],
            [-27, 75],
            [-21, 11],
            [-197, -2],
            [-4, -39],
            [-67, -27],
            [-42, 31],
            [-47, -18],
            [-22, -20],
            [-18, -88],
            [-10, -19],
            [-29, -104],
            [-22, -61],
            [-23, -40],
            [-39, -22],
            [-22, -89],
            [-31, -31],
            [-32, 12],
            [-18, -11]
        ],
        [
            [51457, 55227],
            [7, 67],
            [-39, 80],
            [-13, 60],
            [-41, 68],
            [-38, -4],
            [11, 58],
            [0, 76],
            [-13, 42],
            [-37, 20],
            [-42, 45],
            [-21, 44],
            [-7, 53],
            [-38, -8],
            [-80, 67],
            [-56, 168],
            [7, 104],
            [-28, -26],
            [-30, 135],
            [-34, 21],
            [-12, -13],
            [-16, -79],
            [-23, 17],
            [2, 59]
        ],
        [
            [50916, 56281],
            [31, 74],
            [51, 185],
            [29, 58],
            [25, 2],
            [47, 24],
            [57, 58],
            [44, -4],
            [53, 7],
            [68, 40],
            [-2, 152],
            [-24, 25],
            [-41, 69],
            [0, 21],
            [31, 27],
            [27, -1],
            [16, 28],
            [11, 93],
            [-18, 63],
            [1, 46]
        ],
        [
            [51322, 57248],
            [100, -7],
            [99, -16],
            [7, -80],
            [15, -7],
            [25, 31],
            [41, -45],
            [82, -43],
            [23, 2],
            [18, -21],
            [34, -7],
            [76, 39],
            [48, 3],
            [25, -9],
            [72, 22],
            [57, -13]
        ],
        [
            [50385, 57465],
            [-2, 47],
            [-17, 108],
            [23, 47],
            [25, 27],
            [17, -22],
            [18, -73],
            [44, -19],
            [44, 13],
            [27, -6],
            [8, 57],
            [109, 23],
            [-14, 19],
            [-88, -7],
            [-67, -58],
            [-27, 5],
            [-28, 59],
            [-10, 72]
        ],
        [
            [50447, 57757],
            [79, 5],
            [246, -6],
            [26, 79],
            [48, 34],
            [50, 13],
            [53, -15],
            [53, -64],
            [60, -30],
            [51, -63],
            [25, -8],
            [55, 26],
            [52, 5],
            [39, -37],
            [8, -39],
            [-7, -41],
            [-123, -55],
            [-59, 18],
            [-72, 47],
            [-148, 114],
            [-13, -12],
            [-16, -59],
            [-13, -19],
            [-114, -22],
            [-49, -17],
            [-6, -94],
            [-122, 2],
            [-129, -4],
            [-36, -50]
        ],
        [[50586, 56347], [-25, -8], [-13, 39], [52, 46], [5, -44], [-19, -33]],
        [[50651, 56574], [-14, -17], [-23, 23], [18, 68], [15, -5], [4, -69]],
        [[50625, 56806], [-16, -68], [-20, 7], [-15, 58], [51, 3]],
        [
            [50916, 56281],
            [-15, 40],
            [12, 73],
            [-13, -2],
            [-26, -59],
            [-13, -1],
            [2, 69],
            [-31, -2],
            [-24, 36],
            [0, 66],
            [14, 24],
            [-40, 18],
            [15, 50],
            [55, 41],
            [55, 14],
            [-15, 35],
            [-34, 14],
            [-26, -10],
            [-30, -30],
            [-27, 61],
            [10, 66],
            [16, 16],
            [63, 0],
            [7, 31],
            [-76, 9],
            [-24, -14],
            [-42, -55],
            [-52, -31],
            [-38, 13],
            [12, 74],
            [-17, 22],
            [-56, -23],
            [-42, 34],
            [-16, 41],
            [2, 51],
            [20, 35],
            [-18, 20],
            [-38, -21],
            [-85, 84]
        ],
        [[50401, 57070], [59, -4], [32, 11], [54, 42], [30, 8], [94, -11], [82, 29], [117, 106], [261, -2], [192, -1]],
        [
            [58520, 50756],
            [-25, 47],
            [-38, 13],
            [14, 88],
            [19, 77],
            [28, 59],
            [15, 14],
            [26, 124],
            [28, 78],
            [-9, 78],
            [7, 132]
        ],
        [
            [58256, 52277],
            [54, 0],
            [12, -30],
            [-1, -43],
            [-48, -127],
            [-9, -53],
            [-18, -46],
            [-16, -3],
            [-55, 26],
            [-12, 38],
            [9, 66],
            [35, 18],
            [30, 141],
            [19, 13]
        ],
        [
            [62922, 69995],
            [56, 0],
            [18, 32],
            [23, 1],
            [45, -129],
            [41, 1],
            [85, 33],
            [87, -8],
            [31, -35],
            [60, -5],
            [55, -18],
            [78, 23],
            [8, -12],
            [-3, -102],
            [28, -6],
            [18, 26],
            [41, 20],
            [44, 0],
            [40, 30],
            [-17, -125],
            [-24, -14],
            [-104, 3],
            [-67, -10],
            [-125, -27],
            [-126, -13],
            [-17, 9],
            [-11, 77],
            [-75, 40],
            [-145, 34],
            [-34, 13],
            [-76, -6],
            [-24, 34],
            [-4, 67],
            [7, 66],
            [31, -11],
            [13, 50],
            [43, -38]
        ],
        [[63948, 69956], [-19, 25], [-14, 48], [27, 18], [24, -84], [-18, -7]],
        [[62675, 70360], [-35, -8], [-10, 80], [13, 36], [46, -77], [-14, -31]],
        [
            [64154, 70214],
            [-30, -10],
            [-10, 26],
            [13, 62],
            [-12, 57],
            [30, 59],
            [31, 38],
            [79, 45],
            [18, -31],
            [-26, -89],
            [-24, -45],
            [6, -36],
            [-38, -10],
            [-37, -66]
        ],
        [[63727, 70580], [-40, -41], [-19, 20], [47, 43], [12, -22]],
        [[63133, 70680], [-2, -45], [-63, -16], [10, 50], [21, -18], [34, 29]],
        [[63394, 70630], [-38, 47], [11, 17], [35, -40], [-8, -24]],
        [[63878, 70659], [2, 26], [32, 37], [63, 36], [27, -20], [-62, -51], [-36, -4], [-26, -24]],
        [[63900, 70788], [-31, -7], [14, 59], [23, -28], [-6, -24]],
        [[63362, 70849], [-24, -43], [-29, 25], [12, 40], [28, 23], [13, -45]],
        [[63445, 70793], [-28, -21], [-19, 31], [-10, 48], [50, 70], [20, -25], [-2, -63], [-11, -40]],
        [[63102, 71003], [-20, 42], [19, 31], [15, -37], [-14, -36]],
        [[63400, 71045], [-29, -3], [13, 53], [35, -21], [-19, -29]],
        [[63594, 71106], [-10, 21], [27, 38], [39, 2], [-2, -39], [-54, -22]],
        [[63355, 71146], [-31, -31], [-32, 39], [12, 19], [42, -10], [9, -17]],
        [[63077, 71133], [-24, 13], [13, 43], [25, -16], [-14, -40]],
        [[63839, 71264], [67, -23], [-19, -39], [-41, -31], [-39, 34], [-43, 10], [18, 32], [57, 17]],
        [[62007, 71260], [6, -41], [-28, -37], [-35, 44], [-26, 62], [22, 42], [21, -43], [40, -27]],
        [[63274, 71235], [-34, 6], [-52, 71], [-4, 35], [27, 16], [20, -42], [32, -5], [11, -81]],
        [[62829, 71328], [-36, -9], [8, 39], [28, -30]],
        [
            [61922, 71583],
            [4, -65],
            [21, -12],
            [29, -58],
            [-8, -40],
            [-48, 28],
            [-26, -8],
            [-22, 71],
            [-30, -7],
            [17, 65],
            [34, -3],
            [29, 29]
        ],
        [
            [63614, 71490],
            [-30, -31],
            [-38, 60],
            [36, 47],
            [-10, 35],
            [-33, 51],
            [-2, 37],
            [52, 15],
            [30, -31],
            [12, -43],
            [2, -92],
            [-19, -48]
        ],
        [[61945, 71708], [-32, -4], [-8, 34], [24, 87], [26, -11], [-2, -89], [-8, -17]],
        [[63176, 71820], [-34, 13], [-32, 31], [7, 51], [25, -21], [5, -35], [29, -39]],
        [
            [62787, 71903],
            [17, -60],
            [17, -21],
            [50, -27],
            [59, -43],
            [68, -9],
            [35, -93],
            [-8, -23],
            [10, -69],
            [18, -66],
            [25, -33],
            [63, -8],
            [5, -71],
            [-24, -28],
            [-89, 82],
            [-7, 49],
            [-46, 103],
            [-87, 7],
            [-33, 23],
            [-11, 61],
            [-34, 34],
            [-44, 68],
            [-34, 37],
            [-69, 40],
            [-13, 24],
            [49, 48],
            [51, 18],
            [32, -43]
        ],
        [[62899, 71990], [-35, -10], [-22, 63], [57, -53]],
        [
            [63711, 72110],
            [-5, -33],
            [43, -55],
            [14, -35],
            [-34, -76],
            [-24, 1],
            [-71, 29],
            [-16, 31],
            [42, 46],
            [-21, 17],
            [-32, -55],
            [-51, 24],
            [-19, 34],
            [20, 49],
            [36, -2],
            [43, 27],
            [0, 23],
            [56, 5],
            [19, -30]
        ],
        [
            [61757, 72168],
            [-32, -12],
            [-28, 28],
            [-23, 69],
            [-50, 78],
            [18, 40],
            [41, 13],
            [30, -41],
            [-28, -44],
            [18, -27],
            [16, -83],
            [38, -21]
        ],
        [[63411, 72475], [-20, -52], [-5, -46], [-91, 25], [-1, 82], [54, 3], [16, -27], [27, 33], [20, -18]],
        [[63488, 72722], [-35, -15], [-39, 46], [38, 19], [36, -50]],
        [[63206, 72827], [-39, -20], [-40, 38], [0, 22], [33, 59], [29, -4], [21, -46], [-4, -49]],
        [
            [63597, 72889],
            [-9, 24],
            [-48, 42],
            [-111, 24],
            [-52, 31],
            [-24, -6],
            [-45, 35],
            [-30, -16],
            [-66, -61],
            [-35, 7],
            [-38, 37],
            [-24, 6],
            [-29, -19],
            [-46, -71],
            [-47, -34],
            [-42, 13],
            [-57, 0],
            [-6, -40],
            [42, -73],
            [-14, -36],
            [10, -35],
            [51, -5],
            [56, -45],
            [25, -48],
            [-19, -15],
            [-23, 36],
            [-75, 44],
            [-28, 5],
            [-30, -21],
            [-2, -24],
            [76, -96],
            [11, -50],
            [-17, -33],
            [-34, 31],
            [-53, 113],
            [-74, 22],
            [-12, -23],
            [25, -83],
            [64, -64],
            [-15, -19],
            [-71, 36],
            [-21, 56],
            [-5, 71],
            [-128, 102],
            [-14, 51],
            [22, 55],
            [-34, -6],
            [-57, -47],
            [4, -72],
            [-22, -137],
            [7, -46],
            [75, -132],
            [26, -96],
            [18, -36],
            [39, -40],
            [57, -114],
            [12, -63],
            [-34, -39],
            [-30, 15],
            [13, 70],
            [-52, 41],
            [-48, -40],
            [31, -82],
            [8, -45],
            [-11, -47],
            [-39, -25],
            [-64, -7],
            [55, -50],
            [76, -32],
            [36, -42],
            [36, -3],
            [36, -76],
            [62, -20],
            [35, -77],
            [47, -15],
            [40, -28],
            [18, -75],
            [3, -103],
            [8, -77],
            [-1, -60],
            [-26, -18],
            [-29, 56],
            [-92, 130],
            [-24, 13],
            [-26, -24],
            [-69, -18],
            [-49, -45],
            [34, -46],
            [0, -44],
            [16, -54],
            [46, -13],
            [44, -74],
            [0, -13],
            [-73, -35],
            [-28, -25],
            [-19, 17],
            [-1, 43],
            [-49, 43],
            [-27, 8],
            [-24, 30],
            [-15, -24],
            [12, -83],
            [27, -58],
            [44, -153],
            [24, -134],
            [-10, -73],
            [22, -54],
            [-1, -53],
            [-39, 42],
            [-46, 89],
            [-16, 55],
            [-53, -4],
            [-37, -118],
            [0, -67],
            [-35, 37],
            [0, 105],
            [-45, 101],
            [-20, 11],
            [-26, 70],
            [-39, -21],
            [-6, -104],
            [-13, -37],
            [-48, 70],
            [-48, 121],
            [-1, 67],
            [35, 61],
            [-4, 43],
            [-33, 86],
            [-48, 55],
            [-27, 16],
            [-13, 59],
            [-46, 45],
            [2, 36],
            [51, 60],
            [29, 95],
            [45, -18],
            [34, 5],
            [51, 86],
            [40, -4],
            [89, -74],
            [97, -42],
            [48, -37],
            [27, -37],
            [37, -12],
            [-8, 51],
            [19, 13],
            [51, 0],
            [19, 33],
            [-10, 24],
            [-48, 22],
            [-19, -8],
            [-55, 49],
            [-53, 31],
            [-50, 52],
            [-31, -45],
            [-29, -2],
            [-81, 33],
            [-49, -26],
            [-103, -25],
            [-25, 48],
            [-64, -34],
            [-22, 21],
            [-37, 151],
            [-37, 67],
            [-29, 18],
            [0, 67],
            [35, 8],
            [56, -32],
            [24, 21],
            [-10, 60],
            [-60, 4],
            [-45, -16],
            [-64, 78],
            [-32, 60],
            [-51, 40],
            [-34, 122],
            [-59, 91]
        ],
        [
            [62030, 72958],
            [111, 9],
            [25, 23],
            [53, -21],
            [63, 45],
            [46, 87],
            [20, 14],
            [75, 13],
            [79, -20],
            [72, 33],
            [9, 75],
            [50, 13]
        ],
        [[63684, 73441], [27, -11], [53, -53], [14, -111], [-91, -91], [0, -159], [-69, -114], [-21, -13]],
        [[36510, 56879], [-12, 18], [12, 78], [17, 29], [17, -8], [-7, -94], [-27, -23]],
        [[41279, 84071], [-36, -67], [-53, 45], [-73, 21], [122, 72], [59, 20], [-19, -91]],
        [[44129, 86720], [-48, 0], [-11, 91], [54, 15], [29, -33], [-24, -73]],
        [[39813, 88962], [-68, -1], [-32, 101], [-3, 68], [43, 33], [83, -3], [81, -33], [-72, -51], [-32, -114]],
        [
            [39283, 89180],
            [103, -45],
            [109, -31],
            [12, -68],
            [33, -45],
            [-66, -65],
            [-203, -69],
            [-72, -12],
            [-177, -48],
            [-67, 4],
            [-79, 41],
            [-33, 50],
            [83, 5],
            [33, 39],
            [-108, 33],
            [-113, 6],
            [-95, 30],
            [-35, 47],
            [24, 105],
            [55, 35],
            [-52, 109],
            [39, 53],
            [103, 34],
            [112, -12],
            [196, -41],
            [84, -45],
            [114, -110]
        ],
        [[39609, 89688], [-137, 9], [4, 54], [42, 5], [105, -47], [-14, -21]],
        [
            [47709, 89725],
            [10, -61],
            [-20, -18],
            [37, -48],
            [-17, -23],
            [-157, -44],
            [-95, -67],
            [-37, 32],
            [-82, 24],
            [-155, -12],
            [-245, -44],
            [-42, 34],
            [30, 56],
            [69, 55],
            [2, 102],
            [226, -19],
            [109, 7],
            [88, 25],
            [160, 69],
            [119, -68]
        ],
        [[39035, 89792], [-112, 24], [-15, 40], [76, 71], [36, 7], [44, -62], [-29, -80]],
        [[38578, 90767], [-157, -124], [-213, 84], [68, 36], [175, 3], [68, 30], [59, -29]],
        [
            [50003, 92226],
            [36, -113],
            [38, -34],
            [82, 5],
            [32, -64],
            [-60, -25],
            [-237, 10],
            [-98, -5],
            [-68, 39],
            [11, 138],
            [68, 39],
            [58, -34],
            [138, 44]
        ],
        [[49824, 92580], [-36, -14], [-119, 231], [8, 147], [100, -29], [47, -335]],
        [[33438, 93296], [-110, -5], [-145, 38], [18, 35], [107, 11], [203, -41], [-73, -38]],
        [[50018, 93472], [-68, 41], [83, 82], [69, -2], [-15, -85], [-69, -36]],
        [[49696, 93657], [-41, -19], [-52, 137], [-5, 89], [117, 44], [-6, -118], [22, -54], [-35, -79]],
        [
            [50123, 94690],
            [-131, -64],
            [-193, 5],
            [-114, 29],
            [-33, 45],
            [44, 49],
            [139, 39],
            [174, 25],
            [158, -15],
            [21, -49],
            [-65, -64]
        ],
        [[49798, 95817], [-113, -11], [-174, 91], [-5, 49], [92, 25], [155, -97], [45, -57]],
        [[41711, 95949], [-582, 147], [-172, 104], [11, 68], [270, 20], [305, -64], [152, -54], [52, -44], [-36, -177]],
        [
            [46314, 96775],
            [297, -34],
            [157, -39],
            [447, -32],
            [335, -49],
            [-72, -38],
            [-429, -16],
            [-778, -20],
            [-445, -38],
            [-141, -2],
            [-13, -57],
            [160, 5],
            [348, 57],
            [374, 5],
            [316, -22],
            [355, 2],
            [266, 16],
            [314, 36],
            [201, -158],
            [170, 5],
            [159, -31],
            [272, -23],
            [257, -59],
            [53, -49],
            [-146, -74],
            [-148, -43],
            [-199, -34],
            [-230, -21],
            [-1765, -70],
            [-95, -59],
            [24, -56],
            [82, -8],
            [193, 31],
            [333, 29],
            [245, -1],
            [586, -25],
            [173, -66],
            [91, -102],
            [203, 23],
            [75, 48],
            [89, 103],
            [167, 23],
            [378, 8],
            [64, -75],
            [-5, -133],
            [-110, -144],
            [-68, -49],
            [-416, -235],
            [76, -8],
            [276, 77],
            [149, 71],
            [214, 74],
            [228, 141],
            [119, 42],
            [126, 0],
            [22, -71],
            [215, -8],
            [308, -56],
            [71, 19],
            [268, 166],
            [248, 58],
            [406, -11],
            [165, -14],
            [467, -78],
            [237, -93],
            [-32, -32],
            [-217, -64],
            [-71, -43],
            [-305, -108],
            [-231, -14],
            [-90, -22],
            [81, -58],
            [-85, -59],
            [-213, -24],
            [-108, -39],
            [-240, -1],
            [-136, -42],
            [53, -35],
            [201, -47],
            [2, -18],
            [-172, -80],
            [-117, -30],
            [-151, 2],
            [-220, -16],
            [-420, 48],
            [-135, -63],
            [-87, -75],
            [3, -116],
            [48, -26],
            [183, -3],
            [33, -38],
            [-40, -186],
            [81, -13],
            [56, -64],
            [-32, -33],
            [-200, -48],
            [-51, -86],
            [-50, -39],
            [-175, -21],
            [-160, -81],
            [55, -58],
            [-74, -97],
            [-62, -171],
            [-108, -158],
            [5, -46],
            [108, -6],
            [77, 84],
            [83, 36],
            [168, -28],
            [256, -80],
            [59, -54],
            [-70, -28],
            [-197, 66],
            [-160, -40],
            [67, -95],
            [72, -44],
            [130, -20],
            [157, -62],
            [123, 33],
            [98, 1],
            [76, -38],
            [14, -46],
            [-14, -118],
            [-53, -79],
            [-110, 3],
            [-89, 29],
            [-281, 51],
            [-130, -4],
            [-141, -19],
            [-5, -24],
            [-202, -87],
            [-42, 1],
            [-134, 58],
            [-46, 0],
            [-84, -63],
            [96, -44],
            [129, -16],
            [37, -96],
            [58, -60],
            [118, -14],
            [92, 20],
            [100, -36],
            [142, -11],
            [75, -55],
            [-30, -69],
            [139, -134],
            [44, -206],
            [-19, -88],
            [-31, -27],
            [-84, -13],
            [-123, 84],
            [-88, 3],
            [-130, -87],
            [-106, -14],
            [-50, -38],
            [-74, -23],
            [16, -29],
            [141, 54],
            [48, 4],
            [62, -102],
            [-3, -48],
            [-75, -85],
            [54, -10],
            [78, 52],
            [59, 137],
            [63, 25],
            [71, -25],
            [138, -195],
            [77, -44],
            [19, -37],
            [-14, -76],
            [-30, -33],
            [-86, -15],
            [-188, 14],
            [8, -43],
            [-130, -38],
            [-147, -15],
            [-140, 30],
            [-115, 45],
            [38, 63],
            [-44, 18],
            [-107, -49],
            [31, -76],
            [-36, -57],
            [108, -52],
            [212, -4],
            [86, -12],
            [202, -52],
            [9, -16],
            [-53, -182],
            [-39, -17],
            [-213, -3],
            [-69, -14],
            [-196, -91],
            [-50, 0],
            [-198, 43],
            [-76, 29],
            [-163, 81],
            [-122, 123],
            [-91, -76],
            [-69, -14],
            [-71, 28],
            [-138, 90],
            [-23, -11],
            [160, -120],
            [36, -38],
            [-72, -14],
            [-131, -53],
            [-66, -55],
            [-123, -22],
            [-106, 33],
            [-100, -79],
            [-165, 3],
            [-92, -21],
            [66, -39],
            [49, 36],
            [135, -7],
            [99, 29],
            [124, 15],
            [195, 43],
            [40, 48],
            [65, 19],
            [145, 15],
            [213, -14],
            [58, -45],
            [144, -69],
            [76, -12],
            [45, -49],
            [124, -55],
            [128, -38],
            [9, -157],
            [-21, -132],
            [-64, -30],
            [13, -70],
            [-17, -56],
            [-127, 58],
            [-155, 57],
            [-144, 37],
            [-122, 59],
            [-89, 106],
            [-84, 195],
            [-49, 4],
            [-118, -36],
            [-26, -31],
            [-293, -72],
            [-140, -45],
            [82, -24],
            [218, 70],
            [102, 7],
            [115, 44],
            [66, -11],
            [37, -160],
            [-16, -42],
            [-132, -49],
            [4, -40],
            [139, 50],
            [77, -49],
            [478, -211],
            [115, -32],
            [39, -80],
            [126, -14],
            [-16, -31],
            [-151, -105],
            [26, -141],
            [37, 103],
            [104, 42],
            [64, -17],
            [25, -151],
            [-1, -195],
            [16, -29],
            [15, -120],
            [16, -35],
            [-32, -33],
            [-98, -14],
            [-38, 16],
            [-98, -5],
            [-11, 104],
            [-32, 89],
            [-26, -176],
            [-25, -31],
            [-197, 8],
            [-143, 58],
            [-56, 52],
            [-49, 79],
            [-41, 143],
            [-35, 55],
            [-125, 78],
            [-146, 61],
            [-124, 75],
            [-70, 24],
            [-101, 10],
            [-147, -4],
            [-100, 26],
            [-47, -15],
            [18, -39],
            [114, -18],
            [204, -2],
            [72, -9],
            [44, -63],
            [10, -57],
            [-23, -46],
            [-128, -74],
            [-173, -56],
            [-191, 1],
            [-109, 23],
            [-190, 8],
            [4, -32],
            [92, -31],
            [4, -31],
            [-51, -102],
            [-119, -60],
            [-3, -40],
            [162, -42],
            [130, 3],
            [262, 38],
            [73, -44],
            [-21, -22],
            [-153, -42],
            [-79, -36],
            [-72, -51],
            [-21, -54],
            [76, -20],
            [110, 116],
            [85, 23],
            [104, -11],
            [80, 13],
            [193, 60],
            [241, -32],
            [219, -64],
            [115, -23],
            [153, -14],
            [274, 6],
            [-1, -51],
            [-45, -27],
            [-202, -57],
            [23, -44],
            [-166, -35],
            [-80, 2],
            [31, -66],
            [-72, -38],
            [-94, 18],
            [8, -62],
            [-160, -90],
            [-138, -32],
            [29, -53],
            [-55, -41],
            [-84, -26],
            [-48, -87],
            [-136, -60],
            [-62, -44],
            [-146, -27],
            [-320, -90],
            [-85, -8],
            [-347, -100],
            [-54, -6],
            [-137, 13],
            [-56, -22],
            [-45, -41],
            [-38, -3],
            [-124, 32],
            [34, -74],
            [-113, -32],
            [-137, 38],
            [-99, 56],
            [-122, 87],
            [-41, -26],
            [14, -57],
            [-44, -13],
            [65, -84],
            [-3, -40],
            [-34, -38],
            [-198, -124],
            [-74, -41],
            [-59, -103],
            [-52, -49],
            [-3, -54],
            [-177, -296],
            [-52, -57],
            [-48, 3],
            [-64, -109],
            [-172, -103],
            [-69, 7],
            [-77, 46],
            [-29, -12],
            [39, -102],
            [-128, -86],
            [-103, -86],
            [-3, 71],
            [-46, -10],
            [-31, -72],
            [-57, -23],
            [-34, 7],
            [-40, 49],
            [-53, -46],
            [-55, -74],
            [-78, -14],
            [-28, -21],
            [-62, 23],
            [-14, 42],
            [63, 82],
            [3, 68],
            [93, 120],
            [64, 62],
            [-165, 45],
            [-74, 7],
            [20, -42],
            [73, -34],
            [-67, -67],
            [-53, -133],
            [-80, 44],
            [-13, -34],
            [69, -46],
            [4, -71],
            [-133, -49],
            [-140, -7],
            [-269, -31],
            [-71, -18],
            [189, -102],
            [-139, -132],
            [-69, -30],
            [-128, 33],
            [-66, -15],
            [-63, 11],
            [37, -130],
            [96, 26],
            [41, -50],
            [27, -85],
            [48, -43],
            [30, -65],
            [-91, -75],
            [-69, -8],
            [4, -35],
            [-29, -26],
            [-63, 8],
            [-60, 26],
            [-124, 9],
            [170, -99],
            [63, 23],
            [64, -17],
            [-10, -114],
            [31, -112],
            [-68, -56],
            [-1, -51],
            [-85, -11],
            [-2, -57],
            [-30, -35],
            [14, -42],
            [-86, -118],
            [-141, 4],
            [-54, 50],
            [-23, -24],
            [50, -36],
            [91, -44],
            [-84, -131],
            [-46, -24],
            [-113, 16],
            [-98, -6],
            [-35, -20],
            [119, -44],
            [97, -16],
            [-27, -58],
            [14, -38],
            [-39, -136],
            [55, -78],
            [11, -87],
            [-43, -48],
            [-87, -9],
            [-17, -21],
            [81, -20],
            [-30, -81],
            [-70, -263],
            [-22, -166],
            [-101, -136],
            [-94, -2],
            [-77, 32],
            [-100, 10],
            [28, -40],
            [166, -43],
            [43, -63],
            [10, -151],
            [-61, -75],
            [-91, 5],
            [-99, 32],
            [86, -75],
            [-77, -24],
            [-65, 9],
            [16, 52],
            [-98, -15],
            [-22, 65],
            [69, 92],
            [-36, 14],
            [-57, -98],
            [-86, 11],
            [-175, 86],
            [3, 94],
            [51, 6],
            [70, 41],
            [38, 42],
            [30, 74],
            [-101, -88],
            [-92, -34],
            [-65, 41],
            [-106, 34],
            [-34, 20],
            [-30, 89],
            [38, 109],
            [43, 69],
            [9, 48],
            [-39, -3],
            [-11, -44],
            [-176, -75],
            [-90, -81],
            [-77, -3],
            [-31, -16],
            [-74, 33],
            [-102, -7],
            [20, -56],
            [-88, -4],
            [-70, 47],
            [11, 28],
            [93, 50],
            [14, 39],
            [-88, -9],
            [-75, 3],
            [3, 74],
            [-36, 48],
            [-132, 30],
            [-39, 137],
            [-74, 37],
            [29, 53],
            [-22, 14],
            [-35, 100],
            [20, 27],
            [85, 57],
            [9, 38],
            [-59, -5],
            [-46, -50],
            [-85, -6],
            [-13, 85],
            [35, 45],
            [-78, 30],
            [-81, 44],
            [-77, 60],
            [18, 59],
            [-12, 80],
            [69, 102],
            [-5, 40],
            [-76, -82],
            [-51, 64],
            [-74, 60],
            [-83, 115],
            [-54, 100],
            [-87, 114],
            [-21, 65],
            [26, 82],
            [-29, 56],
            [200, 56],
            [127, 57],
            [1, 53],
            [-73, -45],
            [-109, -36],
            [-158, -31],
            [-38, 57],
            [54, 61],
            [40, 83],
            [53, 54],
            [123, -1],
            [-5, 48],
            [110, 27],
            [43, -6],
            [60, -107],
            [45, 10],
            [-24, 43],
            [-9, 66],
            [-55, 42],
            [-67, -7],
            [-41, 49],
            [-41, -60],
            [-64, -46],
            [-71, -20],
            [25, 88],
            [-70, -47],
            [-11, -44],
            [-85, -137],
            [-25, -54],
            [-51, -34],
            [-24, 21],
            [-29, 89],
            [2, 148],
            [-53, 264],
            [-58, 28],
            [-28, 69],
            [111, 63],
            [64, 49],
            [109, 102],
            [-33, 6],
            [-96, -86],
            [-97, -60],
            [-62, 0],
            [-65, 72],
            [-72, -14],
            [-63, 16],
            [-11, 98],
            [39, 115],
            [-42, 1],
            [-35, 53],
            [105, 54],
            [156, 107],
            [141, 81],
            [51, 64],
            [115, 61],
            [80, 61],
            [-44, 7],
            [-130, -87],
            [-185, -140],
            [-79, -51],
            [-76, -64],
            [-72, -35],
            [-118, -21],
            [-23, 8],
            [-11, 66],
            [4, 79],
            [20, 55],
            [47, 76],
            [94, 58],
            [23, 41],
            [135, 14],
            [13, 32],
            [-107, -1],
            [-166, 9],
            [-75, 35],
            [-61, 83],
            [27, 158],
            [177, 93],
            [79, 57],
            [93, 35],
            [88, 1],
            [146, -49],
            [75, -10],
            [67, 12],
            [83, -18],
            [147, -71],
            [20, 28],
            [-164, 75],
            [62, 63],
            [-109, -11],
            [-31, -18],
            [-106, -9],
            [-104, 23],
            [-74, 32],
            [-196, -44],
            [-136, -102],
            [-57, -21],
            [-41, 7],
            [37, 92],
            [12, 68],
            [69, 75],
            [63, 132],
            [34, 6],
            [186, -41],
            [117, -39],
            [142, -11],
            [51, 49],
            [6, 31],
            [64, 71],
            [-1, 52],
            [-76, -15],
            [-55, -67],
            [-174, -29],
            [-56, -1],
            [-99, 24],
            [-25, 27],
            [-186, -7],
            [52, 64],
            [54, 111],
            [45, 28],
            [89, 26],
            [94, -4],
            [161, -85],
            [48, -8],
            [151, 36],
            [58, 47],
            [45, 60],
            [-138, -28],
            [50, 216],
            [91, -6],
            [123, 11],
            [-44, 62],
            [-97, -23],
            [-70, 1],
            [6, 37],
            [51, 76],
            [27, 140],
            [26, 35],
            [114, 40],
            [-46, 77],
            [50, 33],
            [-30, 25],
            [-113, -20],
            [-94, 30],
            [-97, -38],
            [-258, 39],
            [-97, 63],
            [-140, 73],
            [-103, 28],
            [-203, 38],
            [-150, 131],
            [-9, 24],
            [58, 50],
            [54, 17],
            [95, -5],
            [107, -24],
            [130, 1],
            [142, -22],
            [70, -24],
            [192, -102],
            [80, -36],
            [178, -42],
            [82, 19],
            [-78, 31],
            [-120, 75],
            [-5, 56],
            [25, 92],
            [-153, 77],
            [32, 15],
            [160, -26],
            [35, 17],
            [-111, 65],
            [-211, 2],
            [-146, 44],
            [-146, -12],
            [-34, 74],
            [70, 81],
            [44, 24],
            [241, 55],
            [-213, 41],
            [-157, -76],
            [-85, 24],
            [-11, 34],
            [104, 75],
            [-60, 8],
            [-26, 117],
            [-85, 89],
            [-30, -14],
            [86, -88],
            [11, -70],
            [-74, -52],
            [-19, -44],
            [-74, -11],
            [33, -74],
            [-16, -37],
            [-109, -42],
            [-115, -9],
            [-200, 33],
            [-79, 70],
            [-24, 77],
            [37, 43],
            [30, 106],
            [43, 85],
            [136, 120],
            [-7, 38],
            [-131, -108],
            [-80, -12],
            [-25, 24],
            [22, 54],
            [91, 20],
            [-95, 55],
            [45, 28],
            [103, -2],
            [103, 79],
            [19, 61],
            [-3, 68],
            [-40, 52],
            [-64, 27],
            [-66, -45],
            [-117, 41],
            [-8, 59],
            [74, 27],
            [48, 56],
            [-10, 75],
            [-36, 36],
            [-90, -43],
            [-42, 67],
            [-71, 30],
            [42, 112],
            [40, 1],
            [-28, 75],
            [-114, 150],
            [-126, 31],
            [21, 33],
            [-5, 100],
            [123, 38],
            [-168, 81],
            [-120, 124],
            [-192, 81],
            [-136, 134],
            [-108, 59],
            [109, 68],
            [-82, 101],
            [-175, 42],
            [-112, 53],
            [-225, 75],
            [-216, 58],
            [-97, 34],
            [-134, 15],
            [-147, 32],
            [-224, 10],
            [-56, 33],
            [-134, 11],
            [-125, -68],
            [-117, 48],
            [-51, 0],
            [-161, -73],
            [-169, -24],
            [-153, 62],
            [-158, -57],
            [-126, 44],
            [-56, -37],
            [117, -97],
            [-46, -5],
            [-409, 55],
            [-189, 67],
            [-188, 81],
            [-9, 58],
            [165, 70],
            [192, 31],
            [6, 34],
            [-168, -6],
            [-149, 10],
            [-130, 28],
            [-66, 51],
            [59, 90],
            [-230, -101],
            [-109, 34],
            [18, 34],
            [-86, 31],
            [-43, 49],
            [90, 57],
            [372, 30],
            [209, -19],
            [120, 82],
            [141, 21],
            [216, 3],
            [153, -12],
            [169, -46],
            [-19, 62],
            [57, 69],
            [-12, 27],
            [-119, 65],
            [-140, -26],
            [-114, -51],
            [-143, -13],
            [-198, 46],
            [-109, -61],
            [-117, -14],
            [-193, 45],
            [-46, 50],
            [-134, 44],
            [138, 69],
            [-92, 1],
            [-62, -24],
            [-118, -4],
            [-122, 22],
            [-80, 38],
            [-128, 21],
            [-161, 82],
            [-72, 61],
            [73, 47],
            [-41, 47],
            [99, 79],
            [229, 66],
            [230, 9],
            [288, 77],
            [303, 45],
            [-12, 48],
            [202, 52],
            [207, 24],
            [69, 21],
            [278, 11],
            [190, -3],
            [169, 116],
            [93, 139],
            [100, 229],
            [101, 40],
            [-287, 3],
            [-128, -30],
            [-148, 27],
            [-171, 2],
            [-92, 51],
            [-16, 63],
            [61, 74],
            [193, 96],
            [224, 56],
            [180, 84],
            [169, 92],
            [192, 31],
            [139, -24],
            [139, 108],
            [99, 4],
            [381, -45],
            [85, 82],
            [19, 64],
            [-32, 196],
            [112, 60],
            [126, 37],
            [164, 7],
            [191, -28],
            [263, -108],
            [286, -83],
            [198, -88],
            [63, 6],
            [-157, 77],
            [-212, 73],
            [-297, 144],
            [-137, 48],
            [168, 48],
            [308, 42],
            [348, 33],
            [322, 10],
            [19, 21],
            [235, 38],
            [228, -40],
            [97, -64],
            [28, -58],
            [-3, -214],
            [50, 6],
            [120, 102],
            [35, 93],
            [-54, 45],
            [-3, 74],
            [104, 39],
            [315, -135],
            [124, -30],
            [141, -72],
            [317, -2],
            [54, 45],
            [-217, 82],
            [-98, 65],
            [-85, 125],
            [294, 7],
            [363, -38],
            [464, -129],
            [228, -43],
            [410, -149],
            [173, -28],
            [61, 39],
            [-32, 142],
            [27, 87],
            [96, 60],
            [-28, 58],
            [-77, 40],
            [-301, 101],
            [150, 34],
            [746, -24],
            [239, -35],
            [160, 14],
            [-24, 41],
            [-866, 44],
            [-161, 15],
            [-424, -14],
            [-106, 52],
            [96, 62],
            [233, -25],
            [234, 62],
            [141, 10],
            [310, 60],
            [289, -13],
            [135, -47],
            [161, -26],
            [188, 97],
            [103, 32],
            [145, -19],
            [295, -69],
            [201, -98],
            [75, 26],
            [31, 64],
            [-186, 55],
            [-65, 41],
            [173, 39],
            [111, 46],
            [352, -3],
            [25, 32],
            [357, 1],
            [242, 18],
            [256, -23],
            [263, 39],
            [705, -3],
            [231, -16]
        ],
        [[28121, 59041], [30, -15], [60, -55], [21, 47], [-18, 57], [113, -124]],
        [
            [28327, 58951],
            [-141, -205],
            [-90, -122],
            [-52, -39],
            [-8, -18],
            [-16, -97],
            [18, -110],
            [-3, -35],
            [-35, -42],
            [-24, -64]
        ],
        [
            [27976, 58219],
            [-17, 8],
            [-37, -11],
            [-12, -35],
            [10, -59],
            [-39, -33],
            [-24, -59],
            [-38, -17],
            [-54, -79],
            [-18, -39],
            [3, -55]
        ],
        [[27750, 57840], [-118, 92], [-40, 15], [-166, -1], [-71, 36], [-82, 69], [-55, 63], [-128, 177]],
        [
            [27090, 58291],
            [23, 81],
            [-8, 71],
            [13, 103],
            [21, 40],
            [-40, 91],
            [6, 47],
            [139, 417],
            [233, 1],
            [165, 1],
            [-4, 50],
            [13, 127],
            [-17, 27],
            [-32, 16],
            [-18, 24],
            [-8, 67],
            [-16, 43],
            [-32, 44],
            [-49, 45],
            [-42, 61],
            [-35, 75],
            [-29, 49],
            [-28, 31],
            [128, -1],
            [1, 314],
            [249, 0],
            [316, -1]
        ],
        [[100236, 57574], [-28, 30], [0, 65], [43, 54], [14, 54], [32, -30], [-49, -88], [-12, -85]],
        [
            [37906, 53275],
            [-17, -36],
            [-22, -83],
            [12, -49],
            [23, -19],
            [-32, -60],
            [-7, -48],
            [-25, -9],
            [-92, -7],
            [-41, -38],
            [-22, -57],
            [22, -85],
            [-25, -120],
            [-7, -58],
            [-33, -99],
            [7, -95],
            [38, -81],
            [24, -100],
            [56, -89],
            [1, -68],
            [30, -24],
            [38, 13],
            [38, 1],
            [8, -119],
            [14, -31],
            [7, -126],
            [32, -63],
            [24, -73],
            [10, -59],
            [20, -76],
            [28, -66],
            [24, -91],
            [18, -43],
            [44, -18],
            [24, -35]
        ],
        [
            [36811, 53082],
            [-196, 393],
            [-5, 17],
            [27, 62],
            [54, 92],
            [-7, 129],
            [-16, 80],
            [18, 59],
            [64, 21],
            [20, 30],
            [48, -10],
            [41, 49],
            [59, 50],
            [13, 32],
            [8, 73],
            [-20, 17],
            [-41, -12],
            [-18, 7],
            [-16, 31],
            [8, 61],
            [-34, 99],
            [0, 21],
            [33, 63],
            [17, 69],
            [13, 22],
            [41, 9],
            [63, 92],
            [45, 34],
            [21, 76],
            [35, 32],
            [6, 32],
            [-58, 136]
        ],
        [
            [37034, 54948],
            [12, -9],
            [44, -89],
            [25, -19],
            [28, 13],
            [58, -61],
            [86, -100],
            [119, -189],
            [35, -72],
            [23, -34],
            [35, -82],
            [11, -40],
            [-1, -161],
            [-32, -108],
            [-8, -82],
            [12, -39],
            [48, 125],
            [36, 16],
            [39, -28],
            [31, -5],
            [27, -19],
            [59, -105],
            [57, -82],
            [21, -67],
            [61, -33],
            [35, -52],
            [12, -45],
            [7, -119],
            [-12, -178],
            [4, -9]
        ],
        [[90746, 62565], [-37, 0], [2, 39], [37, -2], [-2, -37]],
        [[90829, 62749], [8, -93], [-7, -44], [-73, 45], [-29, -6], [-13, 35], [37, 47]],
        [[78310, 20553], [-37, -26], [-37, 0], [-40, 86], [16, 17], [61, -16], [45, -35], [-8, -26]],
        [
            [29892, 58541],
            [-80, 8],
            [-37, -17],
            [-17, -39],
            [-49, -28],
            [-36, -35],
            [-33, -13],
            [-29, 8],
            [-15, -30],
            [-47, -19],
            [-39, -3],
            [-18, -27],
            [-26, -6],
            [-34, 16],
            [-26, 29],
            [-18, 43],
            [-22, 11],
            [-38, -32],
            [-16, -38],
            [0, -43],
            [-39, -46],
            [-9, -44],
            [4, -57],
            [-60, -67],
            [-32, -64],
            [-32, -45],
            [-31, -26],
            [-16, -28],
            [0, -41],
            [-17, -8],
            [-61, 68],
            [-17, 47],
            [-34, -31],
            [-56, -125],
            [-14, -8],
            [-72, 11],
            [-38, -7],
            [-11, -36],
            [18, -215],
            [-6, -16],
            [-44, -10],
            [-14, -24],
            [-13, -95],
            [-31, -34],
            [-85, -7]
        ],
        [[28602, 57418], [1, 59], [-25, 24], [-26, 82], [3, 43], [-35, 19], [-33, -15], [-33, 22]],
        [
            [28454, 57652],
            [24, 29],
            [-14, 39],
            [21, 163],
            [-27, 43],
            [-58, -6],
            [-28, 45],
            [-22, 15],
            [-38, -25],
            [-54, -51],
            [-10, 2],
            [-9, 69],
            [-47, 21],
            [-56, 61],
            [-7, 21],
            [-41, 50],
            [-17, 43],
            [-95, 48]
        ],
        [
            [28327, 58951],
            [30, -15],
            [79, 99],
            [53, 17],
            [26, 0],
            [40, -67],
            [62, 25],
            [117, -40],
            [47, 17],
            [85, 4],
            [38, -10],
            [54, 57],
            [35, 12],
            [41, 26],
            [-5, 27],
            [52, 1],
            [93, -58],
            [99, 11],
            [58, 40],
            [101, -60],
            [27, -45],
            [12, 39],
            [80, -28],
            [150, -215],
            [-61, 46],
            [-43, -15],
            [5, -51],
            [26, 8],
            [26, -12],
            [39, -58],
            [13, -38],
            [64, 41],
            [56, -31],
            [25, -89],
            [41, -48]
        ],
        [[60699, 74155], [57, -16], [5, -41], [-35, 10], [-27, 47]],
        [[61250, 73911], [25, -70]],
        [[61275, 73841], [-57, 52], [-53, 60], [-104, 91], [-74, 22], [-101, 73], [-11, 32], [138, -72]],
        [[60867, 74227], [-22, -6], [-137, 4], [-40, 12], [-54, 39], [45, 9], [42, -9], [12, -22], [154, -27]],
        [[60741, 74308], [-49, -2], [-63, 28], [8, 39], [47, -3], [72, -18], [-15, -44]],
        [[60248, 74901], [-8, -14], [-77, 98], [-5, 70], [66, -98], [24, -56]],
        [[60137, 75137], [-47, 7], [24, 41], [23, -48]],
        [[60031, 75082], [-21, 6], [-36, 151], [12, 44], [-17, 70], [22, 12], [11, -76], [23, -34], [-5, -56], [11, -117]],
        [[60131, 75259], [-38, -12], [-23, 39], [-31, 6], [-23, 35], [27, 27], [14, 43], [52, -89], [22, -49]],
        [
            [61395, 75791],
            [-21, -53],
            [34, -100],
            [2, -55],
            [31, -17],
            [-15, -71],
            [27, -35],
            [73, -39],
            [18, -53],
            [-56, -3],
            [-44, -17],
            [11, -91],
            [-29, -58]
        ],
        [
            [60987, 74122],
            [-78, 99],
            [-62, 53],
            [-70, 102],
            [-94, 39],
            [-63, 45],
            [-81, -21],
            [-45, 8],
            [-14, 27],
            [0, 49],
            [-37, 44],
            [-51, 42],
            [-48, 54],
            [-97, 147],
            [-20, 47],
            [80, 40],
            [-34, 31],
            [-89, 122],
            [-27, 58],
            [-3, 63],
            [7, 85],
            [-16, 61],
            [-69, 79],
            [-25, 42],
            [-51, 25],
            [-36, -34],
            [-10, -68],
            [-84, -181],
            [-32, 1],
            [-37, 86],
            [-35, 65],
            [-8, 69],
            [-26, 139],
            [19, 20]
        ],
        [
            [59751, 75560],
            [11, -22],
            [81, -27],
            [36, 45],
            [28, -18],
            [88, 2],
            [18, 14],
            [33, 78],
            [61, -77],
            [35, -23],
            [33, 19],
            [49, -28],
            [40, -5],
            [30, 14],
            [-15, 81],
            [20, 27],
            [-24, 40],
            [55, 37],
            [52, 20],
            [14, 39],
            [-1, 80],
            [-21, 34],
            [12, 51],
            [112, 59],
            [21, 36],
            [49, 1],
            [3, 62],
            [26, 29],
            [60, -20]
        ],
        [
            [60657, 76108],
            [72, -46],
            [38, -43],
            [21, -48],
            [65, -63],
            [50, -81],
            [29, -25],
            [62, -21],
            [31, -48],
            [31, -20],
            [48, -12],
            [146, -1],
            [40, 25],
            [31, 53],
            [74, 13]
        ],
        [[33087, 60651], [-5, -39], [-79, 46], [-64, 59], [3, 32], [32, 8], [78, -59], [35, -47]],
        [
            [33407, 60239],
            [-55, 82],
            [-35, 24],
            [-137, -5],
            [-40, -24],
            [-75, -14],
            [-157, 55],
            [-80, -12],
            [-32, -22],
            [-42, -82],
            [-62, 96],
            [-34, 30],
            [-69, 43],
            [-18, 58],
            [28, 98],
            [49, 21],
            [39, -12],
            [74, -37],
            [54, -5],
            [29, -24],
            [209, -38],
            [39, -11],
            [29, 18],
            [24, 46],
            [62, 5],
            [13, 9],
            [8, 56],
            [-36, 38],
            [-57, 84],
            [-50, 99],
            [22, 33],
            [-8, 61],
            [20, 112],
            [-108, 94],
            [-81, 15],
            [-25, 12],
            [-13, 36],
            [11, 47],
            [27, 26],
            [61, 28],
            [74, 13],
            [74, -15],
            [64, -49],
            [65, -38],
            [82, -13],
            [37, -14],
            [17, 12]
        ],
        [[33131, 61353], [8, -28], [-64, 27], [17, 32], [39, -31]],
        [[62391, 77171], [37, 1], [30, -85], [53, -28], [19, -40], [58, -13], [20, -28], [13, -63]],
        [
            [62621, 76915],
            [-62, -82],
            [-35, -22],
            [-22, 7],
            [-62, -25],
            [-55, -87],
            [-35, -37],
            [-1, -61],
            [-39, -51],
            [-26, -93],
            [-38, -53],
            [-3, -44],
            [-49, -97],
            [1, -48],
            [-55, -54],
            [-21, -67],
            [4, -42],
            [-22, -11],
            [-13, -49],
            [-34, -34],
            [-63, 9],
            [-69, -70],
            [-32, 19],
            [-71, -19],
            [-12, -14]
        ],
        [
            [61807, 75890],
            [-24, 19],
            [-71, 10],
            [-27, -8],
            [-72, 13],
            [-25, -8],
            [-43, -59],
            [-57, -36],
            [-37, 17],
            [-22, -31],
            [-34, -16]
        ],
        [[60657, 76108], [-41, 78], [-30, 121], [-59, 4]],
        [
            [60852, 76948],
            [53, -8],
            [98, -101],
            [39, -23],
            [118, -3],
            [179, 13],
            [17, 37],
            [-9, 48],
            [13, 34],
            [38, 28],
            [108, 12],
            [62, 21],
            [30, 57],
            [19, 6],
            [84, -51],
            [135, 91],
            [48, 129],
            [47, 13],
            [69, -2],
            [62, -22],
            [40, 2],
            [79, 24],
            [34, -32],
            [49, -83],
            [14, -5],
            [113, 38]
        ],
        [
            [93509, 44098],
            [-37, 6],
            [-3, 49],
            [9, 28],
            [66, 35],
            [26, 32],
            [37, 68],
            [33, 25],
            [14, -99],
            [-33, -26],
            [-30, -60],
            [-64, -39],
            [-18, -19]
        ],
        [[93180, 44276], [-15, -6], [-33, 16], [43, 75], [41, -5], [-5, -45], [-31, -35]],
        [[93654, 44437], [-28, -20], [0, 41], [21, 52], [20, 17], [11, -30], [-28, -18], [4, -42]],
        [
            [92603, 44954],
            [14, -25],
            [50, -48],
            [22, -79],
            [47, 1],
            [19, -16],
            [39, -74],
            [21, -54],
            [26, -30],
            [15, -45],
            [-9, -39],
            [-32, -55],
            [-42, -16],
            [-38, -33],
            [-14, 17],
            [-43, 12],
            [-34, 24],
            [-29, 43],
            [-37, 87],
            [-37, 27],
            [-65, 81],
            [-40, 7],
            [-34, -6],
            [-85, 36],
            [-33, 74],
            [-6, 30],
            [22, 44],
            [48, 32],
            [34, 9],
            [39, -1],
            [59, 9],
            [56, -15],
            [45, 44],
            [22, -41]
        ],
        [
            [94164, 44877],
            [-22, -29],
            [-11, -56],
            [-37, -53],
            [-42, -86],
            [-32, -44],
            [-54, -87],
            [-78, -19],
            [-63, -62],
            [-35, -27],
            [-34, -2],
            [-32, 20],
            [-9, 53],
            [31, 76],
            [-36, 36],
            [-3, 27],
            [24, 146],
            [13, 50],
            [52, 90],
            [49, 62]
        ],
        [[93845, 44972], [17, -41], [59, -7], [40, 64], [10, 69]],
        [[93971, 45057], [40, 19], [41, 52], [66, 67]],
        [
            [94118, 45195],
            [-2, -50],
            [18, -18],
            [39, 34],
            [15, -22],
            [1, -45],
            [-15, -37],
            [-38, -3],
            [-3, -55],
            [20, -49],
            [11, -73]
        ],
        [[91244, 45291], [-9, -19], [-31, 50], [25, 25], [16, -24], [-1, -32]],
        [[93518, 45416], [-10, -32], [-17, 9], [13, 50], [14, -27]],
        [[92434, 45307], [-24, 3], [4, 50], [-7, 33], [13, 27], [3, 47], [36, -16], [-3, -59], [-28, -46], [6, -39]],
        [[93623, 45523], [-6, -25], [-84, 2], [2, 32], [31, 47], [26, 10], [37, -19], [-6, -47]],
        [
            [91562, 45378],
            [-39, -115],
            [23, -37],
            [-65, -24],
            [-108, 32],
            [-47, 26],
            [-2, 46],
            [50, -12],
            [14, 11],
            [1, 75],
            [-6, 97],
            [49, 79],
            [26, 32],
            [30, 19],
            [76, -44],
            [22, -30],
            [5, -28],
            [-29, -127]
        ],
        [
            [93922, 45537],
            [-18, -35],
            [-13, -60],
            [-37, -29],
            [-15, 60],
            [-27, -3],
            [13, 53],
            [30, 20],
            [13, -26],
            [40, 90],
            [20, -14],
            [-6, -56]
        ],
        [
            [93811, 45569],
            [-44, -16],
            [-26, -69],
            [-22, 1],
            [-23, -81],
            [-20, 20],
            [-24, -31],
            [-25, 29],
            [-31, 3],
            [29, 51],
            [40, 47],
            [24, 50],
            [22, -15],
            [54, 56],
            [37, -27],
            [9, -18]
        ],
        [[98431, 45504], [-15, -8], [-77, 17], [-10, 35], [35, 61], [37, 15], [31, -92], [-1, -28]],
        [[91845, 45516], [-16, 33], [-4, 69], [17, 18], [36, 2], [2, -23], [-35, -99]],
        [[92313, 45587], [-11, 45], [19, 11], [11, -32], [-19, -24]],
        [
            [94011, 45642],
            [8, -34],
            [47, 23],
            [92, -11],
            [23, -14],
            [2, -68],
            [-11, -14],
            [-201, -51],
            [-27, 32],
            [21, 51],
            [-10, 23],
            [12, 39],
            [24, 27],
            [20, -3]
        ],
        [[95014, 45665], [54, -22], [31, 2], [6, -20], [-29, -47], [-63, 36], [1, 51]],
        [
            [93458, 45379],
            [-43, -19],
            [-53, -44],
            [-46, -7],
            [-42, 4],
            [-28, -8],
            [-79, -64],
            [-58, -22],
            [-21, 44],
            [-52, 3],
            [-27, -57],
            [-42, 12],
            [-48, -22],
            [-17, 4],
            [-62, 44],
            [-71, 26],
            [-71, -10],
            [-62, 24],
            [-65, -45],
            [-31, 89],
            [3, 71],
            [18, 84],
            [13, -14],
            [56, 38],
            [41, 49],
            [59, 23],
            [19, -10],
            [39, 14],
            [43, -45],
            [42, -3],
            [38, -21],
            [33, -33],
            [49, -30],
            [30, -41],
            [22, -15],
            [32, 2],
            [42, 38],
            [55, 7],
            [32, 22],
            [31, -23],
            [61, -72],
            [52, 13],
            [25, 74],
            [28, 37],
            [76, 55],
            [21, 46],
            [-49, 20],
            [27, 51],
            [22, -6],
            [18, -26],
            [9, -99],
            [-60, -85],
            [11, -45],
            [-20, -28]
        ],
        [[95952, 45543], [-9, 26], [58, 101], [20, -19], [-13, -49], [-42, -19], [-14, -40]],
        [
            [92057, 45543],
            [29, -20],
            [47, 46],
            [38, -5],
            [18, -24],
            [24, -4],
            [30, 21],
            [25, -3],
            [19, -22],
            [17, -66],
            [-1, -58],
            [28, -60],
            [-16, -35],
            [-23, -11],
            [-31, 27],
            [-49, -19],
            [22, -30],
            [-104, -37],
            [-25, 24],
            [-6, 77],
            [-59, -92],
            [-36, -6],
            [-65, -45],
            [-40, 7],
            [-69, -49],
            [-37, -14],
            [-55, -1],
            [-46, -36],
            [-32, 12],
            [-52, 39],
            [-5, 63],
            [11, 46],
            [-8, 82],
            [16, 74],
            [37, 16],
            [34, 33],
            [31, 43],
            [59, -34],
            [65, 1],
            [17, -19],
            [7, -42],
            [21, -26],
            [29, -72],
            [27, 4],
            [23, -13],
            [42, 43],
            [31, -1],
            [9, 33],
            [-41, 65],
            [-38, 10],
            [-50, 65],
            [-24, 76],
            [5, 31],
            [51, 34],
            [61, -19],
            [10, -15],
            [29, -94]
        ],
        [
            [91194, 45634],
            [31, -30],
            [44, -86],
            [4, -25],
            [-44, -59],
            [-70, -57],
            [-30, -101],
            [-28, -29],
            [-1, 85],
            [-27, 69],
            [-66, 81],
            [-71, 28],
            [-34, 65],
            [-8, 79],
            [45, -5],
            [65, -30],
            [51, 4],
            [48, 61],
            [12, -1],
            [79, -49]
        ],
        [[95636, 45746], [-18, -51], [-21, 3], [-37, 69], [5, 63], [14, 5], [49, -14], [8, -75]],
        [
            [94698, 45906],
            [4, -39],
            [-37, -9],
            [-36, -30],
            [-32, -80],
            [-49, 18],
            [-44, 3],
            [-19, 16],
            [-49, -15],
            [-47, -41],
            [3, 58],
            [11, 36],
            [41, 85],
            [33, -19],
            [40, -5],
            [45, 17],
            [32, 38],
            [45, 20],
            [36, -50],
            [23, -3]
        ],
        [[94889, 45931], [-20, -13], [5, 74], [32, -10], [-17, -51]],
        [
            [98320, 45568],
            [-73, -73],
            [-131, 14],
            [-57, -18],
            [-12, 14],
            [11, 69],
            [45, 184],
            [54, 162],
            [23, 42],
            [66, 72],
            [77, 32],
            [70, -6],
            [59, -110],
            [8, -60],
            [-29, -104],
            [-33, -98],
            [-54, -78],
            [-24, -42]
        ],
        [
            [96095, 45721],
            [-65, 1],
            [3, 42],
            [-12, 32],
            [16, 46],
            [0, 54],
            [18, 38],
            [20, 82],
            [27, 25],
            [41, 97],
            [17, 17],
            [8, 47],
            [25, 13],
            [29, -47],
            [-29, -39],
            [15, -96],
            [-21, -104],
            [-39, -58],
            [-37, -78],
            [-16, -72]
        ],
        [[96298, 46165], [-17, -12], [-14, 32], [12, 35], [19, -55]],
        [[90875, 46204], [-21, -17], [-15, 37], [27, 9], [9, -29]],
        [[95275, 46176], [-14, -14], [-29, 41], [30, 37], [14, -25], [-1, -39]],
        [[92838, 46212], [-41, 1], [-2, 55], [34, -24], [9, -32]],
        [
            [90699, 46219],
            [-58, -3],
            [-34, -46],
            [-23, -14],
            [-133, 4],
            [-85, 40],
            [-12, 37],
            [13, 40],
            [31, 57],
            [61, 11],
            [280, 4],
            [34, -65],
            [-61, -33],
            [-13, -32]
        ],
        [[91172, 46294], [-25, -9], [-23, 19], [6, 51], [54, 12], [34, -34], [-46, -39]],
        [[97129, 46418], [-14, 20], [21, 49], [9, -24], [-16, -45]],
        [[88047, 46479], [-19, -13], [-21, 27], [22, 38], [26, -8], [-8, -44]],
        [[97141, 46529], [-17, -5], [-8, 46], [14, 11], [11, -52]],
        [
            [97086, 46589],
            [-10, -83],
            [-28, -49],
            [-18, -76],
            [-48, -52],
            [-34, 42],
            [-9, 36],
            [14, 166],
            [6, 25],
            [-3, 131],
            [16, 8],
            [47, -78],
            [30, -39],
            [37, -31]
        ],
        [
            [88702, 46831],
            [31, -63],
            [27, -34],
            [32, -19],
            [67, -9],
            [39, -25],
            [40, -11],
            [48, 18],
            [11, -12],
            [57, -103],
            [28, -144],
            [22, -34],
            [32, -10],
            [74, -5],
            [85, -28],
            [33, 4],
            [30, 28],
            [99, -52],
            [36, -7],
            [81, 12],
            [38, -25],
            [32, -5],
            [29, 28],
            [20, 51],
            [28, 132],
            [19, 54],
            [30, 27],
            [43, -6],
            [56, -130],
            [58, -17],
            [61, 28],
            [32, -28],
            [29, -42],
            [78, -18],
            [30, -49],
            [15, -6],
            [54, 6],
            [70, -18],
            [34, -164],
            [45, -47],
            [-3, -71],
            [3, -67],
            [68, -59],
            [72, -33],
            [77, -4],
            [77, 12],
            [100, 39],
            [96, -77],
            [19, -69],
            [0, -61],
            [-18, -144],
            [1, -79],
            [29, -111],
            [35, -45],
            [-4, -48],
            [-62, 36],
            [-32, 51],
            [-37, -7],
            [-67, 33],
            [-77, 50],
            [-135, 107],
            [-37, -1],
            [-36, -14],
            [-37, -27],
            [-68, -27],
            [-101, 31],
            [-73, 17],
            [-186, 10],
            [-53, 25],
            [-88, 12],
            [-69, 21],
            [-69, 29],
            [-176, 144],
            [-57, 35],
            [-176, 69],
            [-27, 6],
            [-64, -6],
            [-41, 21],
            [-35, 0],
            [-53, -22],
            [-36, -50],
            [-72, 8],
            [-93, 32],
            [-69, 50],
            [-46, 52],
            [-81, 39],
            [-65, 14],
            [-136, 17],
            [-55, 26],
            [-13, 32],
            [2, 41],
            [31, 103],
            [-99, 70],
            [-78, 39],
            [-68, 7],
            [-38, -8],
            [-38, 4],
            [-36, 15],
            [-33, -5],
            [6, 59],
            [30, 36],
            [5, -48],
            [30, -17],
            [29, 61],
            [23, 113],
            [16, -16],
            [25, 23],
            [25, 190],
            [21, 55],
            [43, 57],
            [28, -28],
            [57, -11],
            [34, -18],
            [66, -12],
            [47, -33],
            [32, 14],
            [25, 36],
            [11, 58],
            [36, -29],
            [52, -12],
            [13, -17]
        ],
        [[92762, 46669], [-21, 25], [-7, 41], [5, 48], [-2, 122], [10, 56], [22, -108], [-7, -184]],
        [[90352, 46941], [-7, -20], [-29, 2], [-5, 22], [19, 41], [24, -13], [-2, -32]],
        [[96552, 46919], [-19, -54], [-20, 19], [0, 97], [-15, 74], [21, -1], [32, -101], [1, -34]],
        [
            [97151, 46999],
            [2, -98],
            [-13, -37],
            [13, -56],
            [1, -68],
            [-13, -69],
            [-24, -39],
            [-60, 17],
            [-50, 75],
            [-39, 77],
            [0, 24],
            [46, 5],
            [12, 99],
            [-36, 49],
            [7, 35],
            [29, -17],
            [46, 104],
            [5, 49],
            [34, 0],
            [40, -150]
        ],
        [[96589, 46890], [4, 123], [22, 34], [32, 173], [18, -21], [-16, -127], [-46, -89], [-14, -93]],
        [[87157, 47126], [-26, -2], [-46, 68], [19, 40], [54, -43], [10, -22], [-11, -41]],
        [[93719, 47242], [-2, -57], [-22, 23], [3, 46], [21, -12]],
        [[93230, 47149], [-20, -15], [-37, 64], [-16, 52], [21, 63], [-3, 27], [31, 11], [23, -46], [7, -35], [-6, -121]],
        [
            [93416, 47243],
            [-25, -66],
            [-28, 4],
            [-26, 25],
            [-26, -25],
            [-7, 34],
            [14, 101],
            [21, 38],
            [-2, 40],
            [-17, 85],
            [10, 44],
            [48, 33],
            [55, 50],
            [12, -32],
            [6, -144],
            [-45, -114],
            [10, -73]
        ],
        [
            [93581, 47643],
            [7, -119],
            [-26, 23],
            [-20, -13],
            [-21, -120],
            [-5, -98],
            [25, -10],
            [46, -65],
            [-4, -33],
            [-21, -34],
            [-23, -15],
            [-18, 15],
            [-24, -47],
            [2, -23],
            [-32, -85],
            [-24, 20],
            [-27, -16],
            [-19, 67],
            [1, 31],
            [17, 34],
            [8, 54],
            [30, 67],
            [12, 117],
            [14, 94],
            [1, 119],
            [29, 98],
            [28, 27],
            [44, -88]
        ],
        [[93600, 47888], [-30, -67], [-21, 3], [-25, 44], [-8, 66], [17, 27], [58, -9], [10, -24], [-1, -40]],
        [[95242, 48182], [-53, -29], [19, 68], [26, -14], [8, -25]],
        [
            [95154, 48132],
            [-8, -20],
            [-33, -12],
            [-28, 10],
            [-23, -32],
            [-16, 52],
            [27, 43],
            [32, 8],
            [45, 42],
            [20, -2],
            [-16, -89]
        ],
        [[95291, 48203], [-2, -31], [-29, 8], [-8, 52], [39, -29]],
        [[91495, 48249], [-11, -96], [-19, 55], [22, 64], [8, -23]],
        [
            [91458, 48024],
            [-65, -103],
            [-10, 26],
            [5, 106],
            [-18, 65],
            [1, 49],
            [13, 86],
            [17, 66],
            [47, 49],
            [-3, -80],
            [11, -56],
            [-4, -22],
            [11, -127],
            [-5, -59]
        ],
        [
            [94717, 48459],
            [51, -43],
            [20, -62],
            [42, -64],
            [5, -44],
            [-4, -91],
            [-45, -21],
            [-44, -52],
            [-79, -33],
            [-85, 63],
            [-61, 59],
            [-48, 103],
            [-7, 36],
            [-3, 103],
            [19, 37],
            [41, -24],
            [27, 25],
            [76, 21],
            [79, -2],
            [16, -11]
        ],
        [[88551, 48505], [-22, -5], [-20, 30], [15, 35], [35, -20], [-8, -40]],
        [
            [95610, 48583],
            [71, -62],
            [37, -9],
            [62, 8],
            [23, -6],
            [59, -79],
            [17, -54],
            [14, -91],
            [32, -15],
            [26, -85],
            [-17, -160],
            [-69, 61],
            [-96, 94],
            [-77, 59],
            [-21, 46],
            [-33, 36],
            [-67, 5],
            [-36, -6],
            [3, -58],
            [-17, -11],
            [-41, 24],
            [-37, 9],
            [-33, 25],
            [-43, 13],
            [-3, 47],
            [-29, 3],
            [-35, -36],
            [-34, -74],
            [-38, -9],
            [-30, 18],
            [-43, 98],
            [-31, 39],
            [-30, -7],
            [-16, -88],
            [-19, -57],
            [-21, -29],
            [8, 86],
            [-15, 67],
            [72, 160],
            [27, 38],
            [114, 13],
            [68, -8],
            [62, 16],
            [21, -6],
            [18, -55],
            [50, 27],
            [46, 55],
            [36, 0],
            [65, -42]
        ],
        [[86557, 48406], [12, -81], [-36, 56], [-5, 64], [-39, 71], [-8, 93], [21, 20], [64, -122], [3, -64], [-12, -37]],
        [
            [88959, 48510],
            [-12, -81],
            [-35, -47],
            [-24, 3],
            [-11, 51],
            [-26, 24],
            [-11, -41],
            [-64, -27],
            [7, 47],
            [-13, 37],
            [-3, 65],
            [4, 79],
            [14, 38],
            [7, 92],
            [53, 20],
            [12, -16],
            [61, -21],
            [44, -56],
            [23, -74],
            [-26, -93]
        ],
        [[86489, 48653], [-22, -45], [-36, 1], [-8, 28], [2, 67], [-9, 22], [14, 55], [58, -94], [1, -34]],
        [[86377, 48875], [-72, 47], [-22, 54], [11, 76], [15, 5], [20, -26], [15, -64], [33, -92]],
        [[94468, 48814], [-24, 20], [-12, 85], [-11, 23], [-12, 81], [18, 57], [22, -21], [-5, -87], [27, -110], [-3, -48]],
        [
            [94459, 49183],
            [95, -18],
            [-14, -20],
            [-102, -33],
            [-37, 6],
            [-111, -19],
            [-28, 54],
            [41, 24],
            [62, -7],
            [94, 13]
        ],
        [
            [95795, 49238],
            [4, -33],
            [18, -30],
            [-6, -48],
            [4, -45],
            [-25, -6],
            [-28, -37],
            [-35, -9],
            [-12, 20],
            [-64, 23],
            [-46, 67],
            [79, 60],
            [34, 16],
            [29, -1],
            [48, 23]
        ],
        [
            [94133, 49230],
            [39, -20],
            [15, 27],
            [16, -49],
            [19, 6],
            [19, -22],
            [-2, -38],
            [-55, -6],
            [-39, -30],
            [-54, 27],
            [-60, -47],
            [-36, -16],
            [-32, 1],
            [-27, 82],
            [15, 95],
            [32, 24],
            [56, 5],
            [94, -39]
        ],
        [
            [97375, 49294],
            [122, -28],
            [33, 3],
            [70, -11],
            [58, -37],
            [102, -7],
            [30, -11],
            [23, -25],
            [-56, -22],
            [-27, -19],
            [-50, -10],
            [-42, 10],
            [-30, -12],
            [-11, 19],
            [-44, 20],
            [-57, 40],
            [-116, 47],
            [-5, 43]
        ],
        [[89189, 49278], [-35, -23], [-11, 52], [23, 15], [25, -13], [-2, -31]],
        [
            [88292, 49250],
            [36, -110],
            [14, -179],
            [49, -154],
            [140, -61],
            [-23, -25],
            [-21, -48],
            [-20, -106],
            [17, -99],
            [-37, 9],
            [-92, 90],
            [-78, 39],
            [-19, 45],
            [-9, 56],
            [10, 84],
            [-24, 43],
            [-17, 60],
            [-6, 71],
            [-25, 27],
            [-47, 30],
            [-65, -26],
            [-65, 46],
            [2, 39],
            [16, 31],
            [39, 32],
            [18, 26],
            [-1, 87],
            [27, 46],
            [39, 27],
            [36, -114],
            [16, 40],
            [-10, 70],
            [29, 15],
            [29, 1],
            [36, -49],
            [6, -43]
        ],
        [[93710, 49231], [-36, 13], [1, 81], [19, 15], [21, -66], [-5, -43]],
        [
            [95116, 49255],
            [-29, -29],
            [-45, 15],
            [-53, -3],
            [-56, -21],
            [-32, 18],
            [-20, 29],
            [1, 31],
            [19, 75],
            [41, 58],
            [17, 10],
            [30, -15],
            [50, -44],
            [75, -92],
            [2, -32]
        ],
        [
            [93591, 49528],
            [6, -35],
            [-11, -30],
            [13, -57],
            [31, 76],
            [29, 9],
            [29, -27],
            [6, -29],
            [-11, -61],
            [-19, -29],
            [-26, -4],
            [-11, 35],
            [-17, 4],
            [-12, -78],
            [-19, -22],
            [-16, 33],
            [19, 36],
            [-10, 105],
            [-14, -20],
            [-38, -95],
            [-29, -43],
            [-24, 87],
            [6, 83],
            [24, 56],
            [20, -4],
            [57, 18],
            [17, -8]
        ],
        [[89423, 49523], [-61, -57], [-26, 23], [7, 110], [8, 33], [43, 3], [39, -33], [6, -37], [-16, -42]],
        [[97218, 49559], [-32, 1], [-16, 43], [6, 32], [19, 23], [33, -54], [-10, -45]],
        [
            [86168, 49190],
            [-29, -3],
            [-61, 66],
            [-14, 30],
            [-3, 40],
            [-59, 155],
            [-8, 35],
            [23, 127],
            [60, 31],
            [19, -22],
            [7, -57],
            [34, -103],
            [24, -99],
            [-3, -13],
            [42, -104],
            [1, -61],
            [-33, -22]
        ],
        [
            [95995, 49448],
            [-11, -16],
            [-37, 15],
            [-20, 34],
            [-21, 84],
            [-12, 81],
            [69, 39],
            [42, -16],
            [12, -28],
            [-8, -122],
            [-14, -71]
        ],
        [[95965, 49748], [-22, -48], [-133, -34], [25, 51], [47, 12], [55, -2], [28, 21]],
        [
            [97347, 49818],
            [66, -22],
            [24, 1],
            [23, -24],
            [45, 3],
            [54, -84],
            [27, -56],
            [39, -49],
            [29, -16],
            [-22, -44],
            [-60, -24],
            [-33, 26],
            [-27, -5],
            [-24, 33],
            [-4, 51],
            [-24, 114],
            [-32, -33],
            [-37, 53],
            [-29, 10],
            [-15, 66]
        ],
        [[94853, 49746], [-45, 11], [16, 79], [16, -3], [13, -87]],
        [[95879, 49886], [-18, 0], [-32, 24], [47, 38], [21, -29], [-18, -33]],
        [[93175, 49954], [-6, -46], [-38, -3], [8, 49], [36, 0]],
        [
            [99073, 48726],
            [0, -108],
            [0, -567],
            [0, -567],
            [0, -453],
            [0, -388],
            [-9, -60],
            [-22, -88],
            [-3, -72],
            [34, -92],
            [1, -547],
            [0, -453],
            [0, -234]
        ],
        [
            [99074, 45097],
            [-59, 81],
            [-38, 70],
            [-53, 127],
            [-120, 178],
            [-31, 58],
            [-3, 32],
            [-18, 21],
            [-88, -13],
            [-40, -27],
            [-41, -9],
            [-21, 13],
            [-12, 33],
            [-9, 69],
            [-18, -58],
            [-34, -31],
            [-46, -67],
            [-13, 14],
            [-11, 52],
            [16, 57],
            [9, 72],
            [21, 42],
            [26, 140],
            [-12, 32],
            [-34, 32],
            [-17, 55],
            [-42, 68],
            [16, 20],
            [37, 6],
            [30, -12],
            [10, 14],
            [-63, 36],
            [-39, 37],
            [-36, 74],
            [25, 28],
            [56, 16],
            [-43, 71],
            [-8, 59],
            [-55, 96],
            [-25, 61],
            [-22, 125],
            [-22, 95],
            [-5, 62],
            [-25, 17],
            [16, 66],
            [-51, -11],
            [-7, 18],
            [3, 73],
            [-4, 45],
            [-54, 65],
            [-14, -1],
            [-25, 52],
            [-140, 135],
            [-8, 39],
            [-26, -25],
            [-33, 36],
            [-18, -2],
            [-54, 20],
            [-73, 41],
            [-70, 66],
            [-56, 28],
            [-71, 67],
            [-82, 29],
            [-82, 20],
            [-78, -5],
            [-137, 143],
            [-23, 65],
            [9, 83],
            [-50, -28],
            [-48, 39],
            [-38, -20],
            [-20, 33],
            [-17, 50],
            [-54, -12],
            [-21, 55],
            [-56, 79],
            [-14, 55],
            [6, 129],
            [45, 108],
            [-23, 6],
            [-21, -24],
            [-12, -55],
            [-3, -100],
            [-16, -29],
            [-25, 3],
            [7, -59],
            [-10, -55],
            [-29, -65],
            [2, -61],
            [-6, -32],
            [-47, -91],
            [-51, -4],
            [-36, -14],
            [-17, 21],
            [-23, 60],
            [-26, 137],
            [36, 85],
            [-13, 77],
            [-24, 66],
            [-61, 91],
            [-63, 87],
            [-29, 18],
            [-62, 16],
            [-26, 70],
            [30, 16],
            [50, 45],
            [29, -3],
            [78, -24],
            [46, -34],
            [53, 73],
            [42, 95],
            [49, 28],
            [68, -43],
            [61, -18],
            [28, -43],
            [16, 97],
            [47, 33],
            [-2, 48],
            [-33, 6],
            [34, 62],
            [6, 45],
            [-65, -49],
            [-69, -20],
            [-81, 6],
            [-81, -32],
            [-102, 14],
            [-40, 16],
            [-60, -13],
            [-31, 37],
            [-57, 103],
            [-27, 154],
            [-1, 86],
            [-62, 11],
            [-135, 82],
            [-16, -20],
            [-38, -14],
            [-38, 17],
            [16, 78],
            [32, 36],
            [12, 30],
            [20, 89],
            [1, 84],
            [63, 41],
            [106, 44],
            [26, 26],
            [23, 41],
            [25, 26],
            [26, 46],
            [82, 55],
            [71, -2],
            [71, -33],
            [69, -52],
            [59, -69],
            [63, -51],
            [77, -8],
            [39, 5],
            [39, -7],
            [42, -57],
            [-12, -87],
            [13, -56],
            [23, -56],
            [22, -89],
            [-14, -93],
            [-22, -51],
            [-12, -56],
            [12, -138],
            [4, -126],
            [12, -63],
            [51, -174],
            [30, -118],
            [10, 66],
            [-2, 73],
            [25, 40],
            [19, -14],
            [7, -95],
            [16, -127],
            [21, -5],
            [23, 19],
            [3, -111],
            [20, -79],
            [37, -46],
            [66, -20],
            [37, -4],
            [35, 17],
            [44, 89],
            [71, 106],
            [21, 51],
            [27, 94],
            [71, 85],
            [18, 88],
            [27, 84],
            [69, 28],
            [71, 15],
            [71, 51],
            [30, 45],
            [2, 29],
            [-16, 74],
            [79, 86],
            [73, 67],
            [58, 46],
            [33, 0],
            [61, -74],
            [167, -98],
            [50, -70],
            [33, -28],
            [37, -14],
            [137, -122],
            [94, -76],
            [25, -5],
            [88, 4],
            [30, -35],
            [115, -19],
            [30, -34],
            [8, -56],
            [70, -1]
        ],
        [[87807, 49994], [36, -73], [-33, -82], [-22, 17], [-15, -42], [-11, 66], [-22, 43], [14, 43], [19, -10], [34, 38]],
        [
            [94935, 50003],
            [35, -83],
            [-23, -79],
            [16, -44],
            [45, -3],
            [23, -64],
            [-36, -42],
            [-29, 29],
            [-14, 37],
            [-49, -22],
            [-8, 37],
            [9, 54],
            [-27, 24],
            [-25, 55],
            [10, 61],
            [12, 33],
            [26, -42],
            [12, 40],
            [23, 9]
        ],
        [[94837, 49905], [-40, -14], [-5, 59], [7, 76], [19, 12], [20, -35], [8, -40], [-9, -58]],
        [[87579, 49987], [-40, -19], [-45, 14], [6, 33], [21, 39], [19, -2], [35, -25], [4, -40]],
        [
            [95937, 50179],
            [53, -24],
            [12, 4],
            [78, -61],
            [19, -79],
            [-25, -42],
            [-49, 20],
            [-29, -17],
            [-18, 13],
            [-15, 38],
            [-28, 24],
            [-38, 81],
            [-14, -35],
            [16, -21],
            [22, -61],
            [25, -4],
            [17, -26],
            [-1, -40],
            [-45, -15],
            [-15, 29],
            [-4, 53],
            [-42, -39],
            [-17, 55],
            [-48, 3],
            [-32, 29],
            [18, 60],
            [21, 16],
            [21, -14],
            [21, 22],
            [69, 16],
            [28, 15]
        ],
        [
            [85950, 49885],
            [-18, -26],
            [-28, 26],
            [14, 85],
            [17, 39],
            [5, 46],
            [-32, 126],
            [29, -10],
            [21, -83],
            [19, -51],
            [-8, -68],
            [-19, -84]
        ],
        [
            [87901, 50083],
            [20, 20],
            [33, -60],
            [-11, -42],
            [-66, 64],
            [-42, -21],
            [-36, 32],
            [15, 35],
            [14, 80],
            [29, -20],
            [5, -32],
            [19, -15],
            [20, -41]
        ],
        [[95547, 50077], [-56, 67], [-19, 62], [72, -103], [3, -26]],
        [[87440, 50483], [-45, 4], [4, 53], [26, 31], [18, -48], [-3, -40]],
        [[94889, 50539], [-17, 18], [6, 39], [18, -6], [-7, -51]],
        [[87491, 50552], [-33, 63], [13, 51], [34, -82], [-14, -32]],
        [[87734, 50646], [-19, -16], [-24, 51], [40, -9], [3, -26]],
        [
            [87360, 50597],
            [-17, -5],
            [-80, 26],
            [-53, 27],
            [-27, 32],
            [17, 111],
            [13, 23],
            [26, -42],
            [45, -53],
            [69, -56],
            [7, -63]
        ],
        [[87483, 50766], [-19, -24], [-15, 36], [20, 35], [14, -47]],
        [[87403, 50666], [-24, -12], [-62, 83], [-57, 32], [7, 58], [20, 4], [65, -55], [21, -29], [30, -81]],
        [[87668, 50839], [32, -49], [-19, -57], [-32, 13], [-9, 32], [7, 37], [21, 24]],
        [
            [87841, 50859],
            [2, -42],
            [18, -20],
            [1, -80],
            [-24, -72],
            [-22, 11],
            [-23, 58],
            [3, 53],
            [-58, -20],
            [0, 49],
            [34, 44],
            [43, -1],
            [26, 20]
        ],
        [[87175, 50733], [-14, -17], [-17, 27], [-22, 78], [-8, 112], [15, 26], [25, -28], [26, -62], [2, -43], [-7, -93]],
        [
            [85649, 50998],
            [66, -157],
            [28, -21],
            [45, -96],
            [-10, -50],
            [-8, -143],
            [-17, -35],
            [-42, 17],
            [0, 25],
            [-25, 108],
            [-44, 60],
            [-17, 3],
            [-11, 61],
            [-22, 73],
            [-68, 133],
            [51, -1],
            [25, 32],
            [10, 33],
            [39, -42]
        ],
        [[87195, 50995], [2, -72], [-41, 47], [-28, 21], [-35, 7], [-25, 19], [-18, 33], [6, 37], [132, -64], [7, -28]],
        [
            [94108, 50736],
            [-59, -95],
            [-33, -95],
            [-50, -103],
            [-65, -50],
            [-36, -3],
            [-107, -39],
            [-70, -2],
            [-81, 14],
            [-26, 50],
            [-30, 39],
            [-248, -3],
            [-68, -7],
            [-67, -18],
            [-37, 8],
            [-37, 20],
            [-55, 5],
            [-127, -30],
            [-32, 3],
            [-65, 38],
            [-37, 8],
            [-37, -10],
            [-34, -34],
            [-48, -101],
            [-21, -57],
            [-28, -143],
            [-7, -59],
            [6, -132],
            [20, -121],
            [53, -139],
            [48, -35],
            [29, -44],
            [27, -122],
            [19, -62],
            [40, 4],
            [73, -24],
            [36, 37],
            [39, 124],
            [48, 100],
            [27, 46],
            [35, 8],
            [33, -47],
            [35, -11],
            [36, 7],
            [38, 32],
            [25, 45],
            [33, 21],
            [77, 0],
            [40, -7],
            [71, 8],
            [-18, 54],
            [58, 33],
            [47, 16],
            [34, -12],
            [30, -32],
            [17, -72],
            [-17, -126],
            [-24, -12],
            [-23, 13],
            [-23, 53],
            [-32, 20],
            [-45, -16],
            [-29, -37],
            [-47, -116],
            [-46, -96],
            [-53, -84],
            [-55, -54],
            [-92, -55],
            [-24, -41],
            [-19, -54],
            [-45, -24],
            [-55, 41],
            [-14, -63],
            [47, -55],
            [22, -59],
            [47, -32],
            [38, -69],
            [38, -118],
            [13, -63],
            [21, -52],
            [65, -88],
            [4, -80],
            [23, -51],
            [6, -33],
            [-26, -41],
            [-1, -60],
            [-15, -81],
            [-3, -52],
            [23, -41],
            [33, -25],
            [54, -103],
            [-1, -34],
            [25, -55],
            [19, -9],
            [15, 26],
            [24, -31],
            [7, -67],
            [-1, -67],
            [-24, -23],
            [-30, 28],
            [0, -39],
            [-77, -7],
            [-82, -41],
            [-28, -24],
            [-19, -45],
            [6, -96],
            [-11, -22],
            [-37, -9],
            [-52, 17],
            [-49, 32],
            [-23, 44],
            [-9, 56],
            [17, 166],
            [22, 71],
            [2, 35],
            [-25, 43],
            [-38, 18],
            [-32, 36],
            [-123, 202],
            [-7, 20],
            [5, 65],
            [46, 132],
            [5, 88],
            [-6, 144],
            [-19, 45],
            [-70, 16],
            [-34, -14],
            [-96, -113],
            [-25, -44],
            [-2, -58],
            [32, -108],
            [10, -57],
            [14, -200],
            [-17, -81],
            [-6, -130],
            [7, -184],
            [11, -112],
            [-5, -62],
            [-29, -131],
            [-10, -102],
            [35, -138],
            [12, -110],
            [-37, 27],
            [-72, -19],
            [-39, -1],
            [-41, -47],
            [-31, -17],
            [-49, 45],
            [-56, 104],
            [-5, 62],
            [22, 131],
            [27, 113],
            [-1, 75],
            [24, 122],
            [5, 56],
            [4, 217],
            [-40, 148],
            [-5, 56],
            [5, 63],
            [-23, 44],
            [-18, 9],
            [-37, -9],
            [-76, -34],
            [-23, 30],
            [-16, 47],
            [-17, 135],
            [3, 65],
            [11, 62],
            [-23, 91],
            [0, 25],
            [21, 39],
            [33, 30],
            [41, 64],
            [13, 56],
            [1, 69],
            [11, 66],
            [46, 117],
            [8, 58],
            [-12, 93],
            [5, 42],
            [-5, 98],
            [15, 92],
            [46, 187],
            [45, 100],
            [18, 26],
            [23, -46],
            [18, -5],
            [-22, 161],
            [-16, 221],
            [36, 37],
            [9, 34],
            [-18, 111],
            [32, 115],
            [38, 68],
            [7, 70],
            [30, 46],
            [23, 48],
            [12, 61],
            [17, 7],
            [13, -53],
            [47, -39],
            [26, 20],
            [18, 50],
            [29, 51],
            [15, 64],
            [34, 78],
            [52, 21],
            [39, -36],
            [46, -4],
            [26, -23],
            [22, -61],
            [24, -20],
            [86, 11],
            [74, -32],
            [101, -7],
            [68, -44],
            [41, -43],
            [32, -7],
            [21, 41],
            [33, 10],
            [65, -7],
            [175, -51],
            [26, 7],
            [106, 96],
            [43, 91],
            [38, 25],
            [20, 90],
            [58, 42],
            [22, 61],
            [40, 69],
            [38, -8],
            [16, -23],
            [22, -79],
            [-36, -69],
            [-28, -111],
            [-43, -103]
        ],
        [
            [86953, 51340],
            [20, -75],
            [-12, -34],
            [-4, -52],
            [-36, -41],
            [-42, 24],
            [-20, 79],
            [2, 67],
            [13, 26],
            [29, -4],
            [29, 37],
            [21, -27]
        ],
        [
            [94986, 50654],
            [46, -9],
            [11, 25],
            [15, 92],
            [28, 41],
            [32, 24],
            [-1, 88],
            [20, 47],
            [62, 65],
            [36, 23],
            [46, 8],
            [0, -61],
            [9, -54],
            [-5, -145],
            [-10, -21],
            [-48, -50],
            [-66, -57],
            [-13, -40],
            [1, -40],
            [42, -53],
            [66, -49],
            [14, -24],
            [11, -82],
            [38, -31],
            [26, -49],
            [-111, 67],
            [-29, 30],
            [-69, 13],
            [-36, 26],
            [-38, 6],
            [-18, -19],
            [-11, -78],
            [8, -51],
            [-8, -87],
            [28, -166],
            [34, -133],
            [51, -137],
            [53, -90],
            [-46, 13],
            [-13, 46],
            [-58, 45],
            [-49, 158],
            [-46, 69],
            [-15, 32],
            [-2, 218],
            [8, 78],
            [-29, 53],
            [-19, 59],
            [-4, 107],
            [20, 93],
            [-27, 42],
            [-28, 121],
            [-2, 62],
            [36, 120],
            [-1, 59],
            [11, 71],
            [19, 80],
            [31, 68],
            [52, 96],
            [42, 34],
            [-2, -44],
            [-38, -97],
            [-6, -63],
            [18, -24],
            [20, -49],
            [4, -136],
            [-4, -70],
            [-39, -95],
            [-72, -83],
            [-5, -43],
            [30, -49]
        ],
        [[85603, 51338], [-34, 47], [21, 23], [13, -70]],
        [
            [95209, 51325],
            [-49, -9],
            [-11, 26],
            [-13, 120],
            [34, 96],
            [44, 56],
            [40, 15],
            [27, -69],
            [-20, -139],
            [-24, -71],
            [-28, -25]
        ],
        [[94268, 51660], [-14, 53], [26, 9], [-12, -62]],
        [
            [85334, 51497],
            [-38, 7],
            [-15, 32],
            [-83, 92],
            [-26, 2],
            [-40, 32],
            [-23, 62],
            [-5, 33],
            [27, 50],
            [28, -15],
            [32, -60],
            [32, -23],
            [24, -44],
            [73, -82],
            [14, -86]
        ],
        [[89169, 51801], [-15, -29], [-16, 18], [25, 59], [6, -48]],
        [[88204, 51777], [-17, 15], [-4, 97], [44, -48], [-23, -64]],
        [[88366, 51941], [-22, -16], [-4, 43], [22, 6], [4, -33]],
        [[91876, 52010], [-30, 27], [-4, 58], [28, 2], [13, -16], [-7, -71]],
        [[94346, 52097], [-8, -17], [-38, 31], [2, 49], [-19, 75], [27, -7], [36, -131]],
        [[91946, 52515], [12, -73], [-57, -28], [-35, 65], [8, 27]],
        [[91874, 52506], [72, 9]],
        [
            [88993, 52238],
            [-42, -20],
            [-25, 29],
            [44, 59],
            [-47, 23],
            [-14, 20],
            [-13, 53],
            [0, 33],
            [62, 88],
            [58, -119],
            [1, -84],
            [-24, -82]
        ],
        [
            [91850, 52506],
            [-23, -20],
            [-10, -32],
            [29, -49],
            [2, -33],
            [50, -74],
            [15, -60],
            [-19, -25],
            [-26, -4],
            [-38, 52],
            [-18, -57],
            [-86, 6],
            [-1, -26],
            [55, -92],
            [12, -35],
            [-19, -67],
            [9, -28],
            [48, -50],
            [32, -22],
            [8, -84],
            [19, -15],
            [-19, -35],
            [46, -43],
            [6, -44],
            [25, -71],
            [45, -91],
            [10, -34],
            [-7, -57],
            [-26, -31],
            [-24, -55],
            [-28, -19],
            [23, -32],
            [20, -57],
            [47, -92],
            [120, -159],
            [52, -55],
            [66, -124],
            [34, -29],
            [7, -34],
            [-29, -53],
            [-41, -27],
            [-69, -14],
            [-105, 34],
            [-31, 30],
            [-24, 61],
            [-32, 34],
            [20, -76],
            [-17, -73],
            [-55, -57],
            [-59, -217],
            [-10, -58],
            [-18, -244],
            [0, -68],
            [27, -129],
            [4, -121],
            [-100, -86],
            [-29, -47],
            [-44, -99],
            [-27, -20],
            [-20, 3],
            [-38, 37],
            [13, -64],
            [-17, -61],
            [-49, -55],
            [-3, -44],
            [-21, -44],
            [-45, -45],
            [-17, -40],
            [45, 0],
            [9, -77],
            [-9, -72],
            [-34, -49],
            [33, -26],
            [34, -12],
            [11, -51],
            [-11, -118],
            [-48, -37],
            [-1, -72],
            [-12, -109],
            [-13, -32],
            [-36, -37],
            [26, -56],
            [-28, -32],
            [-5, -28],
            [-29, -64],
            [-18, -97],
            [-13, -40],
            [-215, -174],
            [-175, -147],
            [-21, 32],
            [-6, 228],
            [-21, 117],
            [-4, 65],
            [-24, -58],
            [-65, 67],
            [-18, 4],
            [-29, 42],
            [-39, -65],
            [-50, -34],
            [-28, 0],
            [-22, 20],
            [-1, 97],
            [-6, 28],
            [-26, 7],
            [-57, -35],
            [-95, 174],
            [-19, -141],
            [-66, -75],
            [-49, -44],
            [-48, 16],
            [-49, 28],
            [-49, -33],
            [-53, -83],
            [-15, -13],
            [-26, 11],
            [4, 126],
            [-4, 139],
            [-19, 66],
            [-20, 28],
            [-22, -48],
            [-40, 1],
            [-39, 22],
            [-34, -12],
            [-66, -56],
            [-35, -8],
            [-19, 12],
            [-18, 62],
            [-33, -46],
            [-40, 72],
            [-61, -24],
            [-23, -29],
            [-22, 34],
            [-2, 132],
            [-31, 253],
            [-9, 130],
            [-6, 31],
            [-36, 46],
            [1, 67],
            [19, 56],
            [4, 65],
            [-6, 71],
            [-25, 121],
            [-46, 95],
            [-33, 38],
            [-70, 42],
            [-37, -4],
            [-23, 38],
            [4, 42],
            [31, 52],
            [-36, 34],
            [-30, 46],
            [-12, 58],
            [0, 70],
            [23, 143],
            [19, 22],
            [-56, 124],
            [-40, 57],
            [-7, 99],
            [-5, 146],
            [3, 66],
            [13, 124],
            [22, 39],
            [-6, 19],
            [20, 143],
            [28, 62],
            [33, 55],
            [33, 121],
            [77, 59]
        ],
        [
            [89398, 51312],
            [-28, -74],
            [10, -50],
            [20, -16],
            [6, -91],
            [50, -98],
            [40, -56],
            [29, -57],
            [23, -25],
            [62, -109],
            [59, -74],
            [33, 9],
            [100, 77],
            [50, 19],
            [58, -4],
            [60, -27],
            [39, 15],
            [50, -13],
            [12, 7],
            [35, 57],
            [48, 17],
            [28, 108],
            [5, 56],
            [20, 23],
            [70, 44],
            [144, 5],
            [14, -11],
            [6, -63],
            [19, -2],
            [89, -58],
            [48, -10],
            [34, -41],
            [42, 42],
            [44, 69],
            [30, 11],
            [39, -1],
            [81, 26],
            [38, -26],
            [11, 8],
            [35, 122],
            [13, 92],
            [30, 24],
            [10, 48],
            [-14, 40],
            [-9, 62],
            [9, 49],
            [56, 56],
            [65, 96],
            [1, 24],
            [-31, 38],
            [1, 115],
            [10, 30],
            [40, 73],
            [20, -18],
            [44, 23],
            [12, 52],
            [-1, 45],
            [9, 85],
            [15, 47],
            [-7, 105],
            [5, 56],
            [2, 114],
            [34, 142],
            [32, 34],
            [17, 44],
            [18, 9],
            [39, -33],
            [35, 36],
            [57, 0],
            [29, -26],
            [31, 35],
            [23, -18],
            [34, 9],
            [45, -8],
            [79, -2],
            [55, -21],
            [53, -59],
            [38, -13]
        ],
        [
            [94703, 52430],
            [-32, -7],
            [-2, 28],
            [33, 104],
            [-28, 48],
            [0, 40],
            [11, 74],
            [33, -38],
            [17, -105],
            [-22, -62],
            [-10, -82]
        ],
        [
            [85343, 53097],
            [38, -5],
            [70, 30],
            [39, -3],
            [69, -34],
            [80, 16],
            [30, -17],
            [49, -93],
            [62, -89],
            [18, -57],
            [17, -79],
            [70, -124],
            [8, -51],
            [-10, -71],
            [20, -57],
            [69, -53],
            [40, -39],
            [14, -52],
            [23, -42],
            [115, -99],
            [114, -151],
            [65, -71],
            [54, -109],
            [35, -108],
            [33, -82],
            [56, -101],
            [46, -116],
            [45, -67],
            [25, -10],
            [41, -73],
            [18, 34],
            [-18, 50],
            [4, 57],
            [33, 30],
            [34, -21],
            [55, -87],
            [23, -50],
            [33, -142],
            [22, -36],
            [64, -18],
            [31, -22],
            [72, -100],
            [24, -47],
            [19, -55],
            [25, -150],
            [71, -117],
            [30, -17],
            [87, -19],
            [31, -29],
            [26, -47],
            [10, -49],
            [-18, -42],
            [-68, -66],
            [-2, -30],
            [36, 19],
            [33, 30],
            [84, 91],
            [20, 10],
            [43, -18],
            [60, -107],
            [21, -64],
            [14, -71],
            [-25, -37],
            [-36, -27],
            [-50, -69],
            [5, -44],
            [-12, -51],
            [28, -31],
            [4, -27],
            [-24, -37],
            [2, -24],
            [29, -100],
            [58, -73],
            [68, -52],
            [80, -42],
            [50, 9],
            [6, -20],
            [20, -161],
            [10, -132],
            [13, -55],
            [-1, -67],
            [16, -57],
            [69, -67],
            [16, -29],
            [-5, -79],
            [-49, -84],
            [-12, -88],
            [6, -29],
            [27, 14],
            [44, 84],
            [45, 35],
            [81, 0],
            [34, -13],
            [57, -62],
            [98, -221],
            [45, -122],
            [4, -62],
            [-49, -107],
            [-17, -114],
            [2, -65],
            [24, -57],
            [0, -27],
            [-30, -157],
            [17, -218],
            [-2, -134],
            [2, -120],
            [-22, -372],
            [-21, -79],
            [-40, 10],
            [-29, 71],
            [-54, 69],
            [-14, -12],
            [-54, -85],
            [-15, -12],
            [-46, 35],
            [-90, 90],
            [-7, -68],
            [18, -97],
            [3, -43],
            [-26, -6],
            [-71, 119],
            [-39, 85],
            [-55, 85],
            [-72, 171],
            [-19, 26],
            [-113, 121],
            [-23, 28],
            [-59, 94],
            [-68, 70],
            [-118, 178],
            [-51, 102],
            [-57, 164],
            [-18, 42],
            [-96, 124],
            [-52, 74],
            [-22, 43],
            [-84, 245],
            [-58, 78],
            [-54, 135],
            [-29, 113],
            [2, 117],
            [-114, 354],
            [-29, 110],
            [-26, 153],
            [-68, 153],
            [-49, 85],
            [-21, 48],
            [-43, 157],
            [-16, 43],
            [-22, 32],
            [-82, 59],
            [-30, 33],
            [-24, 47],
            [-14, 60],
            [-16, 127],
            [-39, 192],
            [-43, 258],
            [-29, 116],
            [-42, 112],
            [-148, 163],
            [-25, 24],
            [-65, 25],
            [-29, 42],
            [-12, 76],
            [-6, 101],
            [-16, 95],
            [-61, 72],
            [-24, 57],
            [-39, 111],
            [-68, 166],
            [-23, 44],
            [-29, 31],
            [-85, 32],
            [-24, 28],
            [-67, 143],
            [-74, 106],
            [-127, 222],
            [-26, 56],
            [-35, 120],
            [-54, 171],
            [13, 71],
            [-6, 86],
            [52, 36],
            [72, -11],
            [33, -17],
            [32, -36],
            [58, -91],
            [32, -32],
            [111, -36]
        ],
        [[84994, 53422], [-24, -8], [-13, 61], [36, -17], [1, -36]],
        [[54198, 80393], [-63, -70], [-40, 33], [14, 59], [26, 24], [33, 61], [40, 9], [13, -69], [-23, -47]],
        [[84540, 53990], [-19, -46], [-37, 140], [-16, 9], [0, 67], [8, 26], [43, 30], [11, -17], [22, -130], [-12, -79]],
        [[84492, 54283], [-30, -53], [-12, 32], [29, 51], [13, -30]],
        [[84402, 54574], [-24, -1], [-17, 49], [20, 30], [18, -39], [3, -39]],
        [[84431, 54673], [-18, -18], [-7, 82], [12, 30], [13, -94]],
        [[84200, 55275], [-23, 38], [22, 20], [1, -58]],
        [[84112, 56066], [-10, -19], [-31, 15], [2, 58], [-8, 56], [30, 63], [19, 18], [20, -108], [-22, -83]],
        [
            [84180, 56613],
            [-17, 2],
            [-29, 100],
            [-13, 86],
            [23, 43],
            [10, 90],
            [17, 58],
            [29, 6],
            [-3, 43],
            [-19, 30],
            [1, 103],
            [12, 71],
            [-6, 62],
            [21, 55],
            [7, 69],
            [-7, 21],
            [16, 106],
            [-1, 71],
            [21, 71],
            [42, 34],
            [5, -81],
            [-19, -36],
            [18, -47],
            [-21, -91],
            [-17, -15],
            [-20, -67],
            [24, -51],
            [8, -174],
            [-18, -47],
            [-21, -10],
            [5, -116],
            [-4, -26],
            [-37, -105],
            [16, -66],
            [-10, -61],
            [0, -70],
            [-13, -58]
        ],
        [
            [80564, 67000],
            [-31, 4],
            [-27, -29],
            [-42, -70],
            [-42, -53],
            [-45, -94],
            [-27, -88],
            [-19, -83],
            [-6, -128],
            [-32, -52],
            [-24, -129],
            [5, -22],
            [49, -60],
            [59, -62],
            [18, -4],
            [12, 34],
            [22, -9],
            [50, -61],
            [129, -114],
            [44, -89],
            [54, -63],
            [113, -109],
            [42, 26],
            [38, -27],
            [55, -61],
            [50, -47],
            [55, 9],
            [15, -8],
            [17, -86],
            [102, -42],
            [70, -41],
            [49, 53],
            [32, -5],
            [85, -44],
            [22, 32],
            [59, 32],
            [43, -36],
            [118, -72],
            [13, -53],
            [0, -62],
            [10, -29],
            [103, -90],
            [41, -18],
            [12, -45],
            [31, -14],
            [85, 55],
            [25, -6],
            [16, -26],
            [12, -79],
            [36, -22],
            [47, 27],
            [38, -21],
            [73, -21],
            [103, -77],
            [19, 3],
            [78, 64],
            [23, -68],
            [61, -41],
            [39, 35],
            [68, -13],
            [66, 21],
            [45, -31],
            [19, 27],
            [33, 164],
            [-2, 46],
            [-14, 68],
            [-36, 88],
            [-3, 26],
            [12, 154],
            [14, 88],
            [24, 101],
            [1, 53],
            [-12, 15]
        ],
        [
            [85599, 65915],
            [-6, -74],
            [12, -31],
            [-2, -52],
            [-33, -26],
            [-101, -137],
            [-7, -32],
            [8, -82],
            [62, -154],
            [-20, -35],
            [-49, 43],
            [-25, 66],
            [-41, 24],
            [-121, -34],
            [-66, -34],
            [-48, -95],
            [-52, -54],
            [-84, -108],
            [-49, -47],
            [-55, -42],
            [-21, -69],
            [-3, -70],
            [6, -87],
            [19, -84],
            [-36, -72],
            [-7, -79],
            [-40, -97],
            [-24, -43],
            [-36, -34],
            [-14, -27],
            [-21, -93],
            [4, -29],
            [33, -29],
            [10, -50],
            [-38, -157],
            [-57, -142],
            [-33, -107],
            [-38, -194],
            [-13, -54],
            [-84, 38],
            [-53, 34],
            [-58, -18],
            [-43, 56],
            [-15, -29],
            [20, -138],
            [13, -51],
            [-7, -192],
            [-8, -115],
            [-18, -57],
            [-32, 4],
            [-16, -22],
            [3, -50],
            [-25, -106],
            [8, -95],
            [17, -104],
            [-3, -73],
            [-25, -12],
            [-15, -35],
            [-18, -79],
            [-34, 3],
            [-25, 53],
            [-26, 15],
            [-18, -67],
            [-17, -19]
        ],
        [
            [83046, 62500],
            [-7, -87],
            [-24, 0],
            [22, -58],
            [10, -100],
            [-68, 4],
            [-27, -43],
            [-16, 43],
            [-1, 40],
            [15, 152],
            [-24, 34],
            [-29, -131],
            [10, -66],
            [-5, -30],
            [-42, -25],
            [-44, 60],
            [-16, -56],
            [-40, 8],
            [-21, 32],
            [39, 189],
            [-7, 50],
            [-33, -68],
            [-32, -98],
            [-38, -54],
            [-45, -42],
            [-148, -60],
            [-31, -25],
            [-45, -75],
            [-29, -72],
            [-5, -73],
            [16, -78],
            [14, -123],
            [11, -25],
            [-16, -45],
            [-27, -48],
            [-23, -64],
            [-4, -59],
            [-77, -79],
            [-38, -92],
            [-20, -10],
            [-10, -38],
            [-132, -72],
            [-86, -55],
            [-6, 97],
            [-29, 16],
            [-65, -77],
            [-27, -76],
            [20, -11],
            [44, 43],
            [22, -29],
            [-66, -66],
            [-141, -213],
            [-6, -42],
            [-44, -93],
            [-45, -108],
            [-87, -161],
            [-24, -60],
            [-138, -125],
            [-26, -37],
            [-57, -121],
            [-58, -99],
            [-69, -82],
            [-118, -104],
            [-72, -100],
            [-24, -89],
            [24, -85],
            [-10, -66],
            [-21, -59],
            [-36, -41],
            [-118, -87],
            [-111, 20],
            [-35, -16],
            [-15, -41],
            [-33, -168],
            [-31, -45],
            [-16, -69],
            [-35, 14],
            [-12, -9],
            [-14, 56],
            [-42, 16],
            [-81, -57],
            [-28, -46],
            [-59, -216],
            [-15, -139],
            [14, -154],
            [21, -123],
            [4, -55],
            [-3, -72],
            [-18, -77],
            [10, -85],
            [25, -112],
            [6, -47],
            [-3, -94],
            [-24, 60],
            [-29, -59],
            [16, -44],
            [54, -51],
            [16, -42],
            [-35, -374],
            [-26, -133],
            [-50, -121],
            [-38, -137],
            [-27, -167],
            [-5, -64],
            [12, -72],
            [-14, -42],
            [16, -18],
            [15, -79],
            [0, -239],
            [-3, -248],
            [-53, -13],
            [-42, 17],
            [-44, -14],
            [-23, -27],
            [-19, -46],
            [2, -78],
            [-81, -196],
            [-18, -65],
            [-6, -63],
            [31, -67],
            [60, -43],
            [-72, 7],
            [-173, -91],
            [-45, -64],
            [-25, -56],
            [-18, -126],
            [-3, -85],
            [-20, -71],
            [-90, -109],
            [-56, -33],
            [-22, -29],
            [-66, 38],
            [-73, 95],
            [-31, 51],
            [-108, 245],
            [-19, 31],
            [-22, 105],
            [-3, 39],
            [-22, 42],
            [-24, 120],
            [-10, 125],
            [-15, 140],
            [31, -55],
            [9, -67],
            [1, -94],
            [26, -2],
            [-35, 215],
            [-47, 92],
            [2, 64],
            [-32, 112],
            [-54, 213],
            [-24, 152],
            [-37, 170],
            [-24, 60],
            [-38, 130],
            [-31, 61],
            [-34, 82],
            [-36, 55],
            [-78, 283],
            [-23, 156],
            [-31, 130],
            [-27, 239],
            [-3, 90],
            [-20, 101],
            [-33, 110],
            [-10, 95],
            [-22, 106],
            [-4, 49],
            [-32, 86],
            [-18, 33],
            [-41, 108],
            [-43, 96],
            [-20, 130],
            [-26, 50],
            [41, 0],
            [-50, 98],
            [19, 48],
            [-31, -1],
            [-16, 29],
            [-22, 90],
            [-41, 102],
            [-7, 55],
            [-36, 172],
            [-30, 411],
            [-28, 184],
            [2, 53],
            [-33, 158],
            [-17, 107],
            [-16, 149],
            [-8, 118],
            [-14, 59],
            [9, 54],
            [24, 82],
            [9, 53],
            [-11, 73],
            [-22, -77],
            [-20, -22],
            [-10, 58],
            [3, 123],
            [-17, 84],
            [13, 39],
            [-22, 32],
            [-9, 100],
            [-10, 41],
            [13, 138],
            [53, 271],
            [4, 61],
            [-4, 86],
            [-12, 70],
            [-8, 91],
            [-38, 34],
            [-21, 108],
            [19, 36],
            [-22, 15],
            [60, 88],
            [9, 37],
            [-91, 5],
            [15, 101],
            [16, 34],
            [-37, 21],
            [9, 103],
            [23, 22],
            [56, 19],
            [-68, 25],
            [-41, -17],
            [-38, 12],
            [-27, -135],
            [-47, -60],
            [-17, -54],
            [41, -27],
            [27, -63],
            [-1, -73],
            [-55, -171],
            [-19, -38],
            [-137, -103],
            [-54, -57],
            [-115, -73],
            [-45, -13],
            [-49, 14],
            [-72, 56],
            [-111, 142],
            [-28, 47],
            [-89, 182],
            [-63, 96],
            [-49, 90],
            [-60, 85],
            [-56, 114],
            [-12, 53],
            [4, 53],
            [21, 28],
            [25, -11],
            [19, -45],
            [26, -28],
            [84, 68],
            [33, -2],
            [22, 34],
            [28, -7],
            [58, 53],
            [53, 14],
            [46, 136],
            [35, 86],
            [22, 18],
            [-7, 48],
            [-17, -7],
            [-29, -76],
            [-28, 17],
            [-41, -13],
            [-82, -51],
            [-34, -45],
            [-24, -9],
            [-132, 50],
            [-129, 114],
            [-55, 76],
            [-34, 97],
            [-34, 116],
            [11, 32],
            [53, 70],
            [5, 30],
            [-67, -57],
            [-25, -50],
            [-34, -11],
            [-21, 145]
        ],
        [
            [76600, 63483],
            [36, 40],
            [63, 22],
            [73, -2],
            [1, 168],
            [31, -1],
            [23, 16],
            [67, -13],
            [136, 2],
            [48, -56],
            [68, -1],
            [26, 12],
            [24, 53],
            [59, 38],
            [80, 35],
            [10, -78],
            [42, -22],
            [27, 13],
            [26, 45],
            [48, 32],
            [-22, 49],
            [1, 73],
            [22, 38],
            [-52, 210],
            [-24, 79],
            [-30, 70],
            [-16, 51],
            [-1, 136],
            [-24, 22],
            [-20, -12],
            [-56, 1],
            [-18, 11],
            [-51, 114],
            [-7, 90],
            [17, 80],
            [7, 143],
            [-13, 43],
            [-17, 17],
            [-45, 4],
            [-55, 23],
            [-70, 64],
            [-12, 35],
            [21, 177],
            [10, 29],
            [101, 167],
            [47, 123],
            [30, 86],
            [30, 47],
            [50, 51],
            [26, -1],
            [43, -48],
            [6, -57],
            [28, -59],
            [42, -8],
            [96, 65],
            [32, 13],
            [78, 9],
            [101, 51],
            [24, 120],
            [56, 94],
            [16, 42],
            [34, 154],
            [16, 30],
            [173, 155],
            [70, 187],
            [31, 104],
            [47, 214],
            [132, 88],
            [38, 72],
            [-16, 73],
            [6, 46],
            [33, 47],
            [64, 139],
            [38, 69],
            [13, 0],
            [78, 79],
            [-7, 44],
            [-29, 40],
            [24, 156],
            [-26, 138],
            [14, 59],
            [57, 73],
            [102, 78],
            [57, 29],
            [22, 41],
            [2, 36],
            [-31, 52],
            [-76, 50],
            [-61, -2],
            [-40, 34],
            [-5, 49],
            [6, 84],
            [-95, 6],
            [-16, 124],
            [-54, 47],
            [-38, 64],
            [-3, 29],
            [38, 79],
            [10, 69],
            [-6, 21],
            [-39, 49],
            [-9, 49],
            [8, 37],
            [24, 29],
            [42, 26],
            [10, 58],
            [-92, 16],
            [-14, 50],
            [23, 46],
            [-17, 54],
            [-35, 21],
            [1, 54],
            [46, 129],
            [104, 62],
            [201, -66],
            [73, -4],
            [82, -57],
            [47, -19],
            [32, 0],
            [47, 32],
            [56, 61],
            [40, -1],
            [88, 49],
            [42, -11],
            [32, 28],
            [27, 63],
            [67, 52],
            [15, 65]
        ],
        [[79342, 69757], [231, 216]],
        [[88193, 44330], [-9, -39], [-35, 29], [4, 29], [34, 16], [6, -35]],
        [
            [53640, 80340],
            [19, -40],
            [-58, -17],
            [7, -59],
            [16, -23],
            [23, -111],
            [17, -36],
            [2, -154],
            [28, -117],
            [5, -91],
            [-32, -67],
            [-21, -80],
            [-6, -67],
            [-39, -79],
            [-36, -32],
            [42, -55],
            [-73, -32],
            [-68, 12],
            [-92, -39],
            [-42, 3],
            [-96, -26],
            [-42, -66],
            [-64, -25],
            [-25, -39],
            [-60, -29],
            [-44, 43],
            [-26, -8],
            [7, -76],
            [-73, -50],
            [-46, -8],
            [-24, -29],
            [-149, -48],
            [-51, 17],
            [-85, -31],
            [-30, 6],
            [38, 67],
            [41, 48],
            [-99, -24],
            [-34, -20],
            [-19, 25],
            [83, 69],
            [-87, -5],
            [-79, 16],
            [-12, 39],
            [72, 84],
            [62, 33],
            [-3, 32],
            [-91, -6],
            [-44, 5],
            [11, 40],
            [45, 36],
            [46, 3],
            [38, -22],
            [30, 30],
            [-20, 63],
            [99, 87],
            [78, 11],
            [85, 23],
            [84, 33],
            [-63, 42],
            [-58, -67],
            [-67, -10],
            [-52, 21],
            [-55, -4],
            [70, 74],
            [37, 65],
            [-21, 28],
            [50, 84],
            [93, 36],
            [21, 25],
            [-65, 24],
            [-102, -9],
            [-34, 21],
            [-6, 29],
            [-69, -2],
            [9, 42],
            [-91, 10],
            [11, 36],
            [-19, 39],
            [73, 24],
            [-7, 76],
            [49, 30],
            [51, 14],
            [0, 41],
            [-52, 6],
            [-52, -15],
            [18, 78],
            [-24, 40],
            [-13, 62],
            [-35, 16],
            [29, 34],
            [53, -4],
            [33, 18],
            [124, -1],
            [52, -50],
            [45, 44],
            [79, -14],
            [49, -18],
            [6, 40],
            [-17, 24],
            [64, 64],
            [57, 26],
            [30, 74],
            [-100, -17],
            [-95, 40],
            [15, 28],
            [55, 29],
            [50, 59],
            [-11, 42],
            [42, 101],
            [83, 28],
            [63, 2],
            [42, 32],
            [34, -75],
            [-24, -38],
            [15, -34],
            [33, 30],
            [-16, 82],
            [22, 49],
            [49, 9],
            [17, 30],
            [88, -64],
            [-66, -56],
            [-14, -25]
        ],
        [
            [72903, 65192],
            [-29, -67],
            [-43, -56],
            [-33, 16],
            [-54, -25],
            [-40, -38],
            [-37, -19],
            [-35, 5],
            [11, 31],
            [57, 35],
            [71, 57],
            [7, 25],
            [-8, 50],
            [46, -21],
            [52, 41],
            [43, 11],
            [-8, -45]
        ],
        [
            [70644, 71612],
            [10, -163],
            [18, -141],
            [37, -124],
            [28, -38],
            [62, -45],
            [30, -13],
            [79, -9],
            [79, -20],
            [46, -21],
            [26, -37],
            [38, -107],
            [60, -75],
            [122, -114],
            [59, -37],
            [199, -72],
            [132, 4],
            [365, 138],
            [122, 34],
            [18, -27],
            [-18, -35],
            [62, 0],
            [14, 17],
            [1, 58],
            [-32, 218]
        ],
        [
            [72201, 71003],
            [85, -6],
            [34, 11],
            [137, 83],
            [32, 123],
            [16, 31],
            [54, 69],
            [95, 83],
            [61, 27],
            [81, -2],
            [119, -12],
            [21, 12],
            [9, 53],
            [36, 33],
            [103, 0],
            [41, -20],
            [88, 2],
            [21, -21],
            [22, -50],
            [1, -56],
            [27, -23],
            [89, -24],
            [54, -25],
            [69, -43],
            [47, -65],
            [54, -16],
            [35, 28],
            [31, -20],
            [51, 17],
            [37, -18],
            [94, -72],
            [19, -6],
            [13, -37],
            [7, -62],
            [60, -86],
            [119, -77],
            [36, -43],
            [86, -182],
            [240, 3],
            [15, -39],
            [-3, -78],
            [5, -80],
            [11, -55],
            [1, -51],
            [-19, -68],
            [31, -61],
            [-5, -90],
            [8, -48]
        ],
        [
            [74340, 66829],
            [146, -271],
            [6, -60],
            [53, -144],
            [35, -120],
            [83, -136],
            [44, -31],
            [30, -7],
            [69, -36],
            [25, -28],
            [40, -72],
            [47, 10],
            [14, -28],
            [-7, -112],
            [13, -112],
            [9, -169],
            [-14, -79],
            [-1, -59],
            [47, -18],
            [78, 19],
            [27, -25],
            [16, -46],
            [-20, -26],
            [-3, -44],
            [6, -67],
            [-20, -23],
            [-6, -96],
            [-23, -18],
            [-95, 6],
            [-46, -28],
            [-61, -18],
            [-39, -39],
            [-22, -75],
            [-35, 7],
            [-12, -29],
            [-68, -42],
            [-18, -43],
            [-17, -179],
            [-27, -42],
            [-8, -103],
            [-8, -166],
            [-9, -47]
        ],
        [
            [74569, 64233],
            [-16, -4],
            [-38, -52],
            [-93, 46],
            [-138, 55],
            [-23, 73],
            [-24, 13],
            [-34, -70],
            [-116, 41],
            [-39, -13],
            [-25, 22],
            [-62, 1],
            [-50, 44],
            [-70, -30],
            [-56, -6],
            [-77, 77],
            [-82, 21],
            [-67, -7],
            [-34, 6],
            [-56, 28],
            [-27, 28],
            [-43, -21],
            [-20, 40],
            [-122, 37],
            [-40, 137],
            [-2, 68],
            [-29, 118],
            [-10, 172],
            [-12, 67],
            [-16, 59],
            [-52, 103],
            [-27, 21],
            [-114, 40],
            [-74, -32],
            [-54, -58],
            [-90, -34],
            [-41, -82],
            [-29, -33],
            [-40, 8],
            [-43, -34],
            [-80, -94],
            [-42, -28],
            [-36, 2],
            [-38, 44],
            [-84, 60],
            [-55, 20],
            [-76, -13],
            [-36, 10],
            [-62, 70],
            [-16, 51],
            [-35, 34],
            [-111, 77],
            [-90, 101],
            [-16, 38],
            [-11, 57],
            [-39, 68],
            [-88, 56],
            [-49, 60],
            [-59, 13],
            [-54, -1],
            [-46, 36],
            [-74, 123],
            [0, 49],
            [-46, 121],
            [-11, 43],
            [-10, 119],
            [-12, 31],
            [-48, 49],
            [-7, 32],
            [10, 76],
            [-25, 30],
            [-37, 16],
            [-9, 37],
            [7, 71],
            [-6, 45],
            [-33, 71],
            [-48, 73],
            [-48, 108],
            [-19, 27],
            [-30, 155],
            [-28, 6],
            [-132, -101],
            [-38, 57],
            [-116, 98],
            [-16, 38],
            [29, 18],
            [29, -17],
            [17, 20],
            [-7, 34],
            [-29, 20],
            [-39, -1],
            [10, -32],
            [-37, -29],
            [-8, -39],
            [9, -115],
            [-27, -48],
            [-50, -4],
            [-38, -37]
        ],
        [
            [70544, 66887],
            [-34, 42],
            [-12, 40],
            [1, 44],
            [-21, 54],
            [-33, 20],
            [-24, 54],
            [-41, 27],
            [-1, 292],
            [-103, 7],
            [0, 222],
            [47, 220],
            [-74, 163],
            [-24, 36],
            [-44, 152],
            [-26, 28],
            [-51, -4],
            [-170, 204],
            [-60, 54],
            [-24, 11],
            [-57, 4],
            [-10, 72],
            [20, 80],
            [-51, 134],
            [-33, 12],
            [2, 66],
            [-44, -4],
            [-82, 180],
            [-23, 25],
            [41, 102],
            [-1, 73],
            [-28, 73],
            [20, 93],
            [42, -4],
            [8, 21],
            [5, 104],
            [75, 128],
            [65, 55],
            [7, 39],
            [-13, 69],
            [-32, 58],
            [-12, 55],
            [21, 83],
            [69, 40],
            [-29, 43],
            [-70, 8],
            [-51, -8],
            [-16, 9],
            [-25, 51],
            [-49, 44],
            [-38, 4],
            [-37, 190],
            [-11, 23],
            [-29, 7],
            [-25, 65],
            [1, 74],
            [-16, 44],
            [-31, 34],
            [-36, 192]
        ],
        [
            [69377, 70891],
            [-2, 41],
            [11, 41],
            [-25, 37],
            [-43, 44],
            [1, 70],
            [-10, 54],
            [5, 48],
            [-70, 71],
            [-38, 21],
            [17, 72],
            [19, 40],
            [32, 138],
            [-35, 10],
            [-9, 25],
            [3, 77],
            [-13, 80],
            [5, 75],
            [-32, 55],
            [-8, 33],
            [11, 84],
            [-31, 41],
            [-17, 89],
            [31, 15],
            [65, -5],
            [17, 15],
            [20, 136],
            [41, 57],
            [60, -66],
            [11, 0]
        ],
        [[70544, 66887], [-28, -13], [-31, 10], [-66, 47], [-21, 1], [-29, -33]],
        [[70369, 66899], [-70, 52], [-25, 11], [-105, -9], [-57, -44], [-10, -22], [-64, -237], [-42, -106], [-74, -140]],
        [
            [69922, 66404],
            [-54, -18],
            [-265, 38],
            [-241, 35],
            [-8, 5],
            [-183, 232],
            [-203, 259],
            [-180, 229],
            [-242, 327],
            [-151, 139],
            [-239, 220],
            [-102, 94],
            [-34, 25],
            [-105, 32],
            [-273, 72]
        ],
        [[67642, 68093], [46, 66], [-14, 60], [-64, -25], [-18, 93], [23, 11], [-88, 491]],
        [
            [67527, 68789],
            [245, 220],
            [172, 156],
            [175, 159],
            [76, 30],
            [16, 24],
            [64, 189],
            [1, 144],
            [6, 146],
            [9, 77],
            [33, 119],
            [0, 95],
            [-33, 147],
            [5, 111],
            [10, 61],
            [37, 74],
            [115, 46],
            [91, 127],
            [82, 131],
            [3, 27]
        ],
        [
            [68634, 70872],
            [30, 11],
            [56, 67],
            [42, 69],
            [50, -27],
            [49, 24],
            [66, -29],
            [64, -39],
            [99, -12],
            [55, 50],
            [31, -6],
            [29, -56],
            [-2, -84],
            [25, -41],
            [100, 110],
            [49, -18]
        ],
        [
            [50762, 87108],
            [35, -2],
            [82, 32],
            [60, 43],
            [18, -42],
            [-63, -101],
            [68, -36],
            [48, 7],
            [20, -34],
            [-4, -52],
            [-47, -64],
            [25, -14],
            [103, 19],
            [38, -91],
            [42, 8],
            [71, -14],
            [46, -46],
            [53, -26],
            [-16, -49],
            [-43, -25],
            [49, -66],
            [-33, -24],
            [54, -28],
            [3, -42],
            [-64, -30],
            [-23, -85],
            [-31, -43],
            [-57, -39],
            [-49, 6],
            [-52, -50],
            [10, -54],
            [-36, -52],
            [-146, -83],
            [-72, 0],
            [-74, -21],
            [-175, -82],
            [-126, -109],
            [-53, -28],
            [-90, -14],
            [-50, -18],
            [-166, -35],
            [-57, -18],
            [-30, -43],
            [-10, -56],
            [-110, -46],
            [-108, -26],
            [-184, 20],
            [-163, 52],
            [-130, 11],
            [-122, 100],
            [-88, 38],
            [-113, 74],
            [-63, -43],
            [-357, -12],
            [-27, 17],
            [-15, 85],
            [28, 32],
            [43, -48],
            [140, 45],
            [70, 74],
            [57, 108],
            [-94, -47],
            [-16, 77],
            [16, 35],
            [-103, 40],
            [-11, 34],
            [27, 37],
            [-72, 45],
            [-78, -3],
            [-194, 19],
            [-106, -37],
            [-58, -4],
            [-46, 63],
            [51, 34],
            [52, -6],
            [117, 25],
            [64, 4],
            [99, 45],
            [32, -11],
            [116, 11],
            [128, 2],
            [28, 31],
            [7, 46],
            [-80, -35],
            [-112, 19],
            [-22, 38],
            [100, 65],
            [75, 31],
            [19, 27],
            [-50, 25],
            [-94, -7],
            [-24, 31],
            [-79, 18],
            [-52, -11],
            [-28, 18],
            [-67, -25],
            [-149, -37],
            [-92, -34],
            [-100, 44],
            [-71, 7],
            [35, 57],
            [57, 3],
            [55, -29],
            [-12, 76],
            [-29, 38],
            [63, 3],
            [90, -48],
            [45, 9],
            [48, 37],
            [-120, 11],
            [-40, 38],
            [28, 20],
            [67, -3],
            [-74, 65],
            [9, 41],
            [44, 13],
            [20, 40],
            [71, 1],
            [73, -45],
            [13, -58],
            [123, 10],
            [22, -53],
            [34, 2],
            [-2, 90],
            [-111, 46],
            [-44, 34],
            [27, 21],
            [109, 4],
            [-55, 44],
            [-88, -7],
            [-46, 18],
            [71, 47],
            [143, -6],
            [79, -69],
            [63, -28],
            [106, -93],
            [67, -36],
            [-28, -39],
            [60, -44],
            [-50, -135],
            [31, -31],
            [-21, -58],
            [63, -30],
            [20, -65],
            [69, 145],
            [62, 52],
            [88, -48],
            [30, 82],
            [0, 175],
            [46, 38],
            [56, -29],
            [47, -66],
            [87, -84],
            [49, 19],
            [-7, 96],
            [23, 50],
            [58, 13],
            [62, 34],
            [67, 5],
            [99, -114],
            [110, -75],
            [-67, 147],
            [6, 36],
            [120, -8],
            [101, -96],
            [35, 16],
            [97, 113],
            [70, -33],
            [55, -7],
            [81, 36],
            [18, 46],
            [-35, 94],
            [90, 42],
            [81, -4],
            [84, -87],
            [4, -41],
            [49, -32]
        ],
        [[66606, 68433], [-55, -29], [-11, -23], [-7, -137]],
        [
            [66533, 68244],
            [-21, 3],
            [-37, 59],
            [-53, 15],
            [-39, -41],
            [-17, -68],
            [-17, -99],
            [11, -138],
            [-12, -40],
            [31, -2],
            [45, -34],
            [-51, -58],
            [-25, -39],
            [-25, -115],
            [11, -25],
            [60, 8],
            [108, 63]
        ],
        [[66502, 67733], [-16, -139], [12, -54], [-82, -340], [-8, -77], [-2, -136], [-22, -91], [-29, -236]],
        [[66355, 66660], [-22, -43]],
        [[66130, 67582], [32, 47], [0, 39], [54, 91], [-15, 33]],
        [[66201, 67792], [62, 173], [39, 168], [37, 233], [26, 118], [22, 79], [9, 65]],
        [[66396, 68628], [36, 4], [58, -9], [25, 25], [12, 73], [62, 45], [42, 56]],
        [[66631, 68822], [-10, -86], [22, -79], [-12, -27], [14, -77], [-35, -93], [-4, -27]],
        [
            [60367, 71492],
            [-31, -88],
            [-74, -155],
            [-14, -75],
            [-28, -107],
            [6, -69],
            [35, -50],
            [-18, -20],
            [36, -63],
            [1, -46],
            [-47, -68],
            [-11, -59],
            [2, -55],
            [-69, 20],
            [-35, -7],
            [-84, 49],
            [-42, 97],
            [-69, 73],
            [-73, -2],
            [-33, 20],
            [-66, 66],
            [-69, 53],
            [-59, 73],
            [-40, 15],
            [-36, 35],
            [-70, 1],
            [-53, 55],
            [-28, 83],
            [35, 130],
            [36, 31],
            [21, 42],
            [52, -83],
            [45, 28],
            [3, 26],
            [32, 33],
            [59, -5],
            [10, -30],
            [33, -14],
            [58, -57],
            [34, -11],
            [80, 33],
            [74, -13],
            [67, 16],
            [40, 22],
            [31, 37],
            [34, 12],
            [84, -11],
            [50, 43],
            [19, -7],
            [48, 41],
            [24, -39]
        ],
        [[58177, 71964], [-18, -55], [-19, 39], [2, 43], [35, -27]],
        [
            [58533, 72976],
            [15, -36],
            [35, -146],
            [3, -31],
            [-16, -56],
            [-34, -73],
            [5, -61],
            [13, -38],
            [-5, -93],
            [-21, -318],
            [-17, -105],
            [-23, -15],
            [-69, 43],
            [-35, -11],
            [-29, 24],
            [-11, -109],
            [-17, -45],
            [-26, -28],
            [-72, 7],
            [-16, 22],
            [-55, 134],
            [-6, 154],
            [15, 45],
            [1, 89],
            [28, 5],
            [2, 60],
            [-16, 33],
            [-27, 11],
            [0, 67],
            [19, 52],
            [0, 90],
            [-19, 33],
            [-17, 83],
            [-51, 84],
            [-2, 67],
            [7, 55],
            [81, -20],
            [32, 9],
            [77, 56],
            [55, 89],
            [34, 18],
            [37, 64],
            [17, -31],
            [53, -29],
            [26, -54],
            [23, -20],
            [-19, -47],
            [25, -28]
        ],
        [[58768, 74078], [5, -49], [-62, -19], [-24, 3], [-1, 38], [71, 7], [11, 20]],
        [
            [59788, 76120],
            [-6, -32],
            [-87, -82],
            [0, -51],
            [72, -27],
            [-5, -24],
            [-40, -53],
            [7, -36],
            [33, -7],
            [-14, -71],
            [47, -41],
            [34, -45],
            [4, -49],
            [-39, -3]
        ],
        [
            [59794, 75599],
            [20, 23],
            [-48, 80],
            [-22, 0],
            [-28, -34],
            [-80, 34],
            [-55, -75],
            [-39, -15],
            [-44, -37],
            [-81, -46],
            [-44, 17],
            [-25, -25],
            [-15, -114],
            [19, -19],
            [33, -94],
            [40, -40],
            [-18, -68],
            [-25, -27],
            [-32, 19],
            [-10, -61],
            [18, -163],
            [28, -115],
            [28, -50],
            [63, -78],
            [66, -41],
            [120, -131],
            [66, -41],
            [17, -23],
            [40, -101],
            [35, -117],
            [37, -183],
            [26, -90],
            [53, -102],
            [111, -147],
            [100, -107],
            [94, -66],
            [72, -11],
            [173, 14],
            [62, -24],
            [8, -46],
            [-12, -31],
            [-73, -76],
            [-5, -61],
            [35, -43],
            [166, -113],
            [171, -95],
            [53, -48],
            [61, -75],
            [149, -104],
            [25, -50],
            [90, -108],
            [41, -84],
            [7, -65],
            [-43, -158],
            [-39, 18],
            [-43, 47],
            [-66, 191],
            [-120, 20],
            [-68, 47],
            [-13, 48],
            [-57, 15],
            [-31, -31],
            [-38, -73],
            [-42, -105],
            [-43, -155],
            [-3, -63],
            [24, -60],
            [70, -34],
            [54, -54],
            [35, -56],
            [3, -136],
            [16, -78],
            [-24, -44],
            [-45, 12],
            [-61, -28],
            [-43, -50],
            [-17, -48],
            [4, -123],
            [-8, -47],
            [-82, -89],
            [-42, -91],
            [-27, -81],
            [-103, -1],
            [-24, 53],
            [-1, 79],
            [18, 48],
            [37, 23],
            [26, 100],
            [-8, 73],
            [29, 55],
            [69, 26],
            [4, 102],
            [-32, 46],
            [-26, 184],
            [-52, 152],
            [-28, 136],
            [-22, 67],
            [-33, 34],
            [-60, 0],
            [-30, 10],
            [-106, 94],
            [-6, 40],
            [17, 37],
            [-24, 100],
            [-44, 63],
            [-64, -24],
            [-30, 4],
            [0, 53],
            [-47, 47],
            [-64, 8],
            [-16, 24],
            [-58, 145],
            [-39, 59],
            [-20, 10],
            [-36, -12],
            [-59, 26],
            [-36, 6],
            [-48, -25],
            [-74, 91],
            [-68, 34],
            [-131, 192],
            [-40, 71],
            [-83, 79],
            [-52, 114],
            [-43, 43],
            [-97, 52],
            [-5, 44],
            [-71, 113],
            [-42, 37],
            [-29, 73],
            [-60, 18],
            [5, 96],
            [-26, 129],
            [-39, 79],
            [-23, 189],
            [-18, 53],
            [-43, 40],
            [-98, 46],
            [-136, 121],
            [-29, 2],
            [-82, 48],
            [-51, 8],
            [-66, -43],
            [-80, -117],
            [-65, -121],
            [-24, -23],
            [-84, -42],
            [-74, -20]
        ],
        [
            [31712, 60472],
            [37, -20],
            [72, -17],
            [35, -48],
            [29, -26],
            [108, -59],
            [36, -101],
            [7, -32],
            [-28, -19],
            [-69, -7],
            [-45, 34],
            [-56, 26],
            [-28, -70],
            [-29, 3],
            [-11, 26],
            [-27, -31],
            [-14, -73],
            [-48, 67],
            [-32, 12],
            [-64, 2],
            [-30, 10],
            [-35, 79],
            [-25, 16],
            [-34, 80],
            [-68, 15],
            [-14, 39],
            [4, 34],
            [34, 55],
            [38, -2],
            [35, 13],
            [33, 31],
            [130, -31],
            [59, -6]
        ],
        [[54936, 77631], [3, -28], [-70, -2], [5, 50], [62, -20]],
        [
            [67642, 68093],
            [-56, -72],
            [-181, -83],
            [-186, -84],
            [-252, -114],
            [161, -270],
            [155, -283],
            [-96, -85],
            [-11, -19],
            [-44, -168],
            [-7, -9],
            [-220, -72],
            [-16, -20],
            [-71, -187],
            [-125, -164],
            [-17, -6],
            [-328, 91]
        ],
        [[66348, 66548], [9, 73], [-2, 39]],
        [[66502, 67733], [15, 108], [18, 52], [-8, 122], [1, 66], [11, 75], [-6, 88]],
        [
            [66606, 68433],
            [33, -12],
            [19, -26],
            [32, -74],
            [49, -22],
            [47, -60],
            [33, -14],
            [105, -25],
            [154, 153],
            [228, 225],
            [221, 211]
        ],
        [[93799, 63719], [-19, -8], [-45, 12], [22, 34], [6, 37], [51, -29], [-15, -46]],
        [[93924, 63850], [-18, -88], [-30, -5], [-16, 49], [11, 19], [28, -6], [25, 31]],
        [[94280, 63977], [-27, -14], [-28, 8], [21, 40], [34, -34]],
        [
            [95148, 65042],
            [-29, -26],
            [-11, -30],
            [-28, -11],
            [-27, -43],
            [-26, -7],
            [-5, -69],
            [-18, -36],
            [4, -57],
            [-23, -31],
            [-24, -1],
            [1, 58],
            [22, 61],
            [1, 70],
            [20, 8],
            [41, 60],
            [-11, 42],
            [5, 35],
            [43, -28],
            [52, 85],
            [12, 48],
            [24, -39],
            [-7, -51],
            [-16, -38]
        ],
        [[95377, 65637], [-31, 4], [-5, 64], [21, 38], [20, -78], [-5, -28]],
        [
            [95517, 65910],
            [-27, -46],
            [-28, 41],
            [-8, 46],
            [23, 43],
            [57, 21],
            [28, 43],
            [28, 24],
            [6, -48],
            [-21, -12],
            [-62, -87],
            [4, -25]
        ],
        [[95878, 67055], [-35, -12], [-20, 13], [-17, 69], [33, 43], [55, -55], [-16, -58]],
        [[95982, 67130], [-28, 26], [22, 73], [2, 53], [20, 68], [22, -1], [-8, -83], [-20, -62], [-10, -74]],
        [[95803, 68260], [-27, -3], [-16, 24], [39, 36], [29, -6], [-25, -51]],
        [
            [95711, 68151],
            [-24, -19],
            [-13, 27],
            [17, 27],
            [-12, 30],
            [13, 69],
            [-3, 29],
            [49, 11],
            [9, -27],
            [0, -85],
            [-36, -62]
        ],
        [[95274, 68460], [12, -15], [41, 4], [18, -62], [-33, -9], [-12, -28], [-29, 24], [3, 86]],
        [[95401, 68492], [-18, 44], [28, 119], [13, -72], [-23, -91]],
        [[95623, 68999], [-22, -24], [-16, 18], [14, 67], [18, -17], [6, -44]],
        [
            [96048, 68917],
            [42, -17],
            [34, 7],
            [50, 38],
            [35, -28],
            [5, -56],
            [-54, -127],
            [56, -12],
            [55, 1],
            [-15, -76],
            [31, -40],
            [-12, -41],
            [31, -30],
            [-10, -42],
            [-76, -140],
            [-22, -71],
            [-29, -135],
            [-18, -124],
            [-14, -66],
            [4, -58],
            [-5, -60],
            [-37, -149],
            [-61, 21],
            [-22, -3],
            [-11, -33],
            [20, -67],
            [-61, -81],
            [-67, -54],
            [0, 25],
            [23, 54],
            [10, 63],
            [-5, 63],
            [-22, 109],
            [23, 15],
            [-1, 57],
            [-37, 6],
            [-31, -86],
            [-8, -58],
            [11, -60],
            [25, -47],
            [-17, -50],
            [-120, 64],
            [-17, 65],
            [46, 23],
            [8, 84],
            [-16, 53],
            [-25, 41],
            [7, 44],
            [-5, 135],
            [38, 29],
            [44, 90],
            [31, 85],
            [25, 91],
            [-45, 21],
            [23, 43],
            [-7, 54],
            [-33, 67],
            [-18, 79],
            [-45, 47],
            [-34, -41],
            [14, -51],
            [1, -90],
            [47, 1],
            [10, -54],
            [-6, -30],
            [-29, -14],
            [-29, 39],
            [-30, 13],
            [-32, -27],
            [-31, -56],
            [-13, 13],
            [5, 45],
            [-42, 83],
            [-8, 67],
            [5, 36],
            [30, -41],
            [16, -52],
            [22, -23],
            [28, 0],
            [-29, 95],
            [-98, 120],
            [9, 60],
            [16, 11],
            [57, -24],
            [-6, 65],
            [29, 26],
            [47, 21],
            [30, 43],
            [33, -1],
            [27, 21],
            [23, 55],
            [14, 56],
            [72, 52],
            [38, -5],
            [35, -26],
            [32, -111],
            [36, -39]
        ],
        [[96385, 69108], [29, -55], [-46, 15], [17, 40]],
        [[95463, 69207], [-28, 12], [8, 98], [38, -20], [-18, -90]],
        [
            [97031, 69281],
            [42, -23],
            [44, 7],
            [0, -102],
            [18, -65],
            [-6, -44],
            [20, -16],
            [-59, -50],
            [-53, -68],
            [-42, -94],
            [-18, -107],
            [-69, 112],
            [-33, 25],
            [-68, 10],
            [-107, -84],
            [-14, -62],
            [-43, -123],
            [-26, -25],
            [-12, -79],
            [-33, -49],
            [-55, 12],
            [5, 71],
            [-66, 7],
            [-1, 51],
            [-20, 29],
            [15, 37],
            [11, 93],
            [-33, 22],
            [3, 55],
            [-93, -20],
            [78, 66],
            [53, 67],
            [33, 32],
            [43, 168],
            [47, 58],
            [17, -4],
            [19, -51],
            [25, -39],
            [67, 28],
            [38, -3],
            [33, 25],
            [19, 66],
            [-12, 61],
            [32, -4],
            [37, 39],
            [38, 23],
            [39, 5],
            [44, -22],
            [43, -35]
        ],
        [[97029, 69408], [-31, -34], [-21, 54], [44, 9], [8, -29]],
        [[97208, 69299], [-33, -47], [-29, 3], [-19, 48], [27, 41], [24, 58], [39, 40], [-17, -81], [8, -62]],
        [[95496, 69336], [-37, 9], [20, 85], [-1, 47], [38, 44], [9, -20], [-1, -61], [-29, -69], [1, -35]],
        [[96726, 70367], [-14, -20], [-26, 6], [-16, 30], [5, 34], [28, 26], [26, -52], [-3, -24]],
        [
            [98261, 71270],
            [-19, 18],
            [12, 76],
            [-23, 2],
            [1, 47],
            [18, 46],
            [48, 72],
            [15, -18],
            [-18, -102],
            [38, -6],
            [-24, -90],
            [-48, -45]
        ],
        [
            [99152, 73249],
            [12, -10],
            [58, 28],
            [-17, -172],
            [4, -143],
            [15, -127],
            [24, -45],
            [33, -32],
            [46, -102],
            [25, -125],
            [31, -124],
            [5, -130],
            [-5, -101],
            [-21, -118],
            [-3, -60],
            [-49, -62],
            [-26, -14],
            [-11, -61],
            [-23, -57],
            [-12, -148],
            [-13, -52],
            [-65, -12],
            [-45, -25],
            [-46, -105],
            [-10, -54],
            [0, -57],
            [23, -140],
            [10, -129],
            [-10, -197],
            [-11, -63],
            [-54, -86],
            [-51, -192],
            [-2, -65],
            [-15, -86],
            [15, -96],
            [43, -119],
            [35, -68],
            [-72, -35],
            [-56, -84],
            [-14, -65],
            [1, -71],
            [-31, -62],
            [-49, -33],
            [-30, -33],
            [-43, -77],
            [-38, 32],
            [14, 30],
            [-4, 34],
            [7, 90],
            [-8, 36],
            [24, 27],
            [12, 43],
            [44, 65],
            [3, 25],
            [-33, 47],
            [-48, -6],
            [-15, -26],
            [-5, -65],
            [-37, -48],
            [5, -50],
            [24, -37],
            [-21, -58],
            [-12, -4],
            [-22, 57],
            [-28, 31],
            [-69, -12],
            [-27, -37],
            [-14, -64],
            [1, -78],
            [-11, -66],
            [-32, -78],
            [-26, -39],
            [-18, -5],
            [-24, 44],
            [13, 99],
            [0, 55],
            [31, 28],
            [-26, 39],
            [-31, 16],
            [-44, -21],
            [-21, -55],
            [-49, -78],
            [-30, -64],
            [-20, -76],
            [-64, 25],
            [-135, 13],
            [-69, -16],
            [-79, -29],
            [4, 21],
            [65, 46],
            [-4, 38],
            [-75, -3],
            [-30, 27],
            [3, -52],
            [-22, 6],
            [4, 41],
            [-10, 141],
            [-50, -42],
            [-35, -108],
            [-14, -62],
            [26, -50],
            [81, -87],
            [-8, -61],
            [-19, -14],
            [-76, -23],
            [-66, -45],
            [-20, -46],
            [-60, -176],
            [-48, -121],
            [-68, -42],
            [-75, 38],
            [-33, 94],
            [-53, 98],
            [-14, 60],
            [2, 98],
            [-11, 59],
            [51, 52],
            [37, 67],
            [10, 65],
            [-19, 20],
            [-49, 0],
            [-48, -13],
            [-35, 18],
            [-58, 57],
            [-48, 3],
            [-116, -40],
            [-74, -95],
            [-29, -19],
            [-61, -5],
            [-72, -29],
            [-72, -50],
            [-21, -23],
            [-38, 15],
            [-76, -41],
            [-36, -5],
            [-38, 23],
            [-35, 37],
            [-33, -16],
            [-23, -55],
            [-12, -109],
            [-13, -49],
            [-4, -58],
            [-17, 9],
            [-108, 110],
            [-82, -19],
            [-75, -39],
            [-49, 40],
            [-48, -25],
            [-9, 160],
            [36, 72],
            [39, 9],
            [40, -8],
            [29, 11],
            [78, 113],
            [77, 62],
            [64, 96],
            [60, 69],
            [48, 74],
            [63, 84],
            [24, 62],
            [70, 52],
            [72, 27],
            [34, -2],
            [34, -54],
            [74, 29],
            [75, -9],
            [110, 25],
            [74, 49],
            [132, 20],
            [90, 47],
            [28, -14],
            [-10, -73],
            [29, -37],
            [85, -4],
            [24, -8],
            [69, 58],
            [35, 42],
            [24, 47],
            [-22, 60],
            [-5, 64],
            [19, 71],
            [27, 59],
            [63, 77],
            [60, 118],
            [44, 94],
            [16, 117],
            [-9, 138],
            [38, 102],
            [110, 65],
            [38, 13],
            [5, -47],
            [-58, -86],
            [-70, -62],
            [-7, -30],
            [29, -51],
            [7, -37],
            [0, -68],
            [33, -36],
            [37, -11],
            [30, 9],
            [53, 101],
            [123, 63],
            [61, 49],
            [65, 37],
            [70, 97],
            [50, 94],
            [34, 119],
            [20, 39],
            [112, 92],
            [48, 74],
            [23, 144],
            [32, 111],
            [52, 105],
            [16, 52],
            [34, 194],
            [31, 72],
            [11, 59],
            [5, 90],
            [-3, 69],
            [-18, 59],
            [-15, 17],
            [-42, -4],
            [-21, 24],
            [51, 56],
            [20, 64],
            [13, 100],
            [-28, 122],
            [0, 36],
            [32, 75],
            [37, 10],
            [41, 53],
            [19, 89],
            [-8, 86],
            [22, 39],
            [74, -19],
            [16, -169],
            [38, -33],
            [23, 53],
            [18, 7],
            [57, -33],
            [33, 59],
            [11, 64],
            [-6, 57],
            [-13, 21],
            [-40, -28],
            [-83, -30],
            [0, 64],
            [18, 96],
            [24, 44],
            [52, -27],
            [38, -47]
        ],
        [[98612, 73644], [-14, 2], [-1, 64], [39, 20], [-24, -86]],
        [[99172, 75338], [-46, 20], [-3, 29], [36, 14], [24, -45], [-11, -18]],
        [[99104, 75457], [-28, 18], [-4, 56], [27, -8], [5, -66]],
        [
            [99953, 74780],
            [85, -9],
            [118, -85],
            [35, -11],
            [63, 6],
            [22, 23],
            [71, 103],
            [75, 93],
            [2, -58],
            [-33, -85],
            [-36, -116],
            [-8, -58],
            [12, -57],
            [23, -47],
            [39, -154],
            [45, -12],
            [58, 61],
            [16, -26],
            [-32, -29],
            [-36, -65],
            [-49, 1],
            [-68, -49],
            [-30, -32],
            [-69, -21],
            [-54, -26],
            [-36, -2],
            [-66, 23],
            [-32, -6],
            [-70, -51],
            [-64, -75],
            [-56, -83],
            [-47, -100],
            [-30, -111],
            [-6, -76],
            [-24, -47],
            [-38, 13],
            [-63, 53],
            [-123, 78],
            [-130, 119],
            [-73, 60],
            [-137, -18],
            [-130, -114],
            [-85, 119],
            [-71, 2],
            [-30, -40],
            [-21, -85],
            [31, -75],
            [34, -38],
            [64, -9],
            [129, -174],
            [-47, -37],
            [-57, 13],
            [-48, 30],
            [-53, -80],
            [-32, -85],
            [-35, -35],
            [-38, -18],
            [-34, 28],
            [-13, 57],
            [8, 67],
            [19, 59],
            [8, 62],
            [-16, 86],
            [-50, 68],
            [-18, 49],
            [-5, 61],
            [12, 109],
            [10, 37],
            [38, 20],
            [65, 62],
            [64, 88],
            [17, 54],
            [-28, 65],
            [-1, 76],
            [29, 19],
            [30, -14],
            [60, -54],
            [111, -20],
            [49, 11],
            [24, 45],
            [11, 56],
            [-4, 146],
            [15, 59],
            [48, 95],
            [13, 56],
            [5, 136],
            [31, 122],
            [7, 131],
            [-20, 125],
            [-42, 120],
            [3, 56],
            [23, 81],
            [34, 9],
            [50, 51],
            [147, -214],
            [89, -171],
            [56, -83],
            [125, -153],
            [68, -66],
            [44, -31],
            [33, -50],
            [20, -8]
        ],
        [[79342, 69757], [-87, 308]],
        [[71821, 75501], [-40, 35], [33, 25], [7, -60]],
        [[73905, 75352], [-212, 182]],
        [[73693, 75534], [65, 111], [10, 60], [26, -31], [26, 36], [19, -45], [49, -75], [8, -98], [15, -94], [-6, -46]],
        [
            [80317, 73705],
            [-89, 124],
            [-36, 15],
            [-97, 10],
            [-88, 116],
            [-12, 52],
            [-67, 5],
            [-48, 13],
            [-83, 41],
            [-46, 4],
            [-109, -8],
            [-68, 21],
            [-175, 10],
            [-55, 32],
            [-35, 1],
            [-134, -30],
            [-222, 8],
            [-48, -66],
            [-83, 13],
            [-98, 37],
            [-71, 42],
            [-60, 43],
            [-128, 103],
            [-38, -29],
            [-42, 3],
            [-20, -34],
            [-84, -48],
            [-17, -25],
            [-42, -228],
            [22, -103],
            [-25, 6],
            [-40, 47],
            [-28, 13],
            [-104, 19],
            [-31, 43],
            [-65, 22],
            [-83, 45],
            [-35, 1],
            [-106, 35],
            [-26, -2],
            [-68, -29],
            [-28, 9],
            [-51, -28],
            [-72, -110],
            [-7, -43],
            [-33, -66],
            [16, -51]
        ],
        [
            [77458, 73738],
            [-71, -45],
            [-32, -63],
            [-22, -9],
            [-39, 22],
            [-58, -74],
            [-41, -70],
            [-41, -37],
            [-92, -46],
            [-81, -72],
            [-10, -29],
            [-66, -36],
            [-28, -33],
            [-6, -57],
            [-18, -33],
            [-77, -91],
            [-47, -92],
            [-9, -62],
            [14, -59],
            [-32, -29],
            [-63, 27],
            [-41, 36],
            [-35, 49],
            [21, 123],
            [-29, 37],
            [-26, 56],
            [-41, -18],
            [-21, 13],
            [-284, -25],
            [-33, 20],
            [-12, 52],
            [-41, 262],
            [-12, 141],
            [-151, 6],
            [2, 173],
            [11, 88],
            [15, 289],
            [-91, -64],
            [-95, 242],
            [-70, 60],
            [-82, 129],
            [-31, 36],
            [-28, -11],
            [-114, -80],
            [-382, 43],
            [-350, -77],
            [-25, 1],
            [-187, 280],
            [-69, 97],
            [-20, 45],
            [-10, 56],
            [-18, 25],
            [-294, 253]
        ],
        [
            [74096, 75187],
            [3, 197],
            [4, 61],
            [-12, 117],
            [-24, 37],
            [-59, -4],
            [-10, 46],
            [33, 109],
            [28, 35],
            [149, -40],
            [47, 69],
            [50, 44],
            [15, 28],
            [137, 94],
            [14, 44],
            [-1, 54],
            [-101, 25],
            [-28, 19],
            [-20, 60],
            [4, 46],
            [-16, 28],
            [-49, -6],
            [44, -44],
            [-24, -48],
            [-46, 13],
            [-32, -39],
            [-12, 52],
            [-27, 36],
            [-61, -46],
            [-20, -32],
            [4, -62],
            [47, -33],
            [68, 9],
            [47, -47],
            [56, 45],
            [29, -89],
            [-3, -42],
            [-50, -54],
            [-168, 32],
            [-75, -30],
            [-23, 8],
            [8, 52],
            [-11, 67],
            [-25, 16],
            [-54, -2],
            [48, -106],
            [9, -64],
            [-26, -127],
            [-53, -47],
            [-31, -8],
            [-28, 19],
            [-6, 55],
            [29, 81],
            [-23, 15],
            [-57, -25],
            [-29, 10],
            [-46, -27],
            [-35, -44],
            [-40, -171]
        ],
        [
            [73644, 75573],
            [-43, 2],
            [-300, -115],
            [-212, -87],
            [-252, -104],
            [0, -384],
            [0, -512],
            [1, -512],
            [0, -384],
            [0, -256]
        ],
        [
            [72838, 73221],
            [-43, -6],
            [-91, -27],
            [-34, 19],
            [-57, 90],
            [-92, 196],
            [-15, 61],
            [-69, 89],
            [-126, 112],
            [-46, 31],
            [-60, -3],
            [-75, -18],
            [-134, -51],
            [-60, -32],
            [-57, -49],
            [-54, -65],
            [-63, -91]
        ],
        [
            [71762, 73477],
            [-8, 59],
            [-1, 119],
            [48, 183],
            [6, 71],
            [-13, 114],
            [-14, 25],
            [-36, 11],
            [-50, -14],
            [-27, 39],
            [-34, 6],
            [-35, -17],
            [-36, 34],
            [-44, 108],
            [-26, 30],
            [-99, 9],
            [5, 101],
            [-3, 71],
            [-20, 52],
            [-31, 40],
            [-61, 173],
            [-34, 131],
            [-45, 40],
            [-109, 34],
            [-24, 45],
            [14, 98],
            [34, 23],
            [139, 3],
            [58, -55],
            [40, -16],
            [62, 22],
            [16, 34],
            [-37, 9],
            [-28, 51],
            [-50, 57],
            [-15, 61],
            [10, 33],
            [35, 33],
            [29, 46],
            [14, 60],
            [38, 71],
            [38, -8],
            [59, 32],
            [98, -7],
            [117, 9],
            [32, -3],
            [117, -44],
            [52, -7],
            [38, 14],
            [-36, 42],
            [-76, 50],
            [-20, 42],
            [35, 116],
            [48, 105],
            [28, 124],
            [-8, 124],
            [-14, 34],
            [5, 41],
            [28, 67],
            [-31, 105],
            [-47, 55],
            [-74, 1],
            [-60, 19],
            [-44, -54],
            [-47, -30],
            [-32, 0],
            [-23, 34],
            [-20, -4],
            [-62, 22],
            [-29, 47],
            [-111, 44],
            [-35, 7],
            [-79, -38],
            [-104, -89],
            [-51, -1],
            [-35, -47],
            [-94, -90],
            [-74, -35],
            [-128, -29],
            [-43, -75],
            [8, -27]
        ],
        [
            [70756, 76017],
            [-192, 128],
            [-31, 47],
            [2, 47],
            [27, 17],
            [53, -30],
            [54, 8],
            [2, 27],
            [-125, 305],
            [-137, 237],
            [-194, 32],
            [-58, -35],
            [-28, 29],
            [-34, 86],
            [8, 100],
            [-35, 88],
            [-47, 22],
            [-59, 49],
            [-16, 91],
            [29, 129],
            [46, 91],
            [50, 72],
            [1, 57],
            [-51, 58],
            [-15, 35],
            [6, 75],
            [21, 109],
            [31, 87],
            [79, 82],
            [15, 32],
            [0, 89],
            [9, 31],
            [55, 72],
            [30, 6],
            [33, -20],
            [44, -53],
            [116, -195],
            [34, -41],
            [30, -17],
            [101, 56],
            [26, 47],
            [-44, 190],
            [-14, 148],
            [47, -10],
            [159, 140],
            [31, 97],
            [23, 32],
            [100, 27],
            [34, 36],
            [97, 52],
            [83, 120],
            [74, 95],
            [12, 30],
            [114, -46],
            [33, -29],
            [23, -67],
            [81, 5],
            [123, 105],
            [66, 21],
            [34, -16],
            [51, -94],
            [23, -17],
            [77, 7],
            [68, -17],
            [92, 10],
            [61, -46],
            [47, -82],
            [83, -51],
            [26, -25],
            [79, -113],
            [38, -74],
            [16, -110],
            [38, -18],
            [17, 61],
            [-14, 122],
            [-18, 37],
            [29, 37],
            [27, -8],
            [89, -71],
            [55, -70],
            [51, -44],
            [56, -36],
            [45, -10],
            [34, 10],
            [78, 63],
            [29, 73],
            [107, 97],
            [40, -21],
            [71, 36],
            [50, 11],
            [52, -17],
            [41, -50],
            [40, -32],
            [65, 21],
            [34, 67],
            [23, 25],
            [64, -12],
            [44, 7],
            [53, -10],
            [58, -52],
            [82, -130],
            [22, -24],
            [88, -26],
            [87, -15],
            [22, -21],
            [0, -50],
            [71, 28],
            [18, 21],
            [44, 121],
            [49, 20],
            [54, -73],
            [108, -22],
            [94, 18],
            [88, 44],
            [50, 48],
            [24, 72],
            [14, 82],
            [23, 51],
            [-10, 53],
            [-59, 66],
            [-107, 28],
            [-13, 25],
            [-157, 63],
            [-24, 68],
            [-33, 35],
            [-66, 31],
            [0, 48],
            [51, 27],
            [60, 56],
            [75, 14],
            [83, 72],
            [13, 64],
            [-49, 98],
            [-15, 59],
            [9, 38],
            [44, 64],
            [32, 63],
            [109, 13],
            [177, -29],
            [33, 34],
            [-21, 58],
            [-77, 36],
            [-32, 31],
            [-69, 6],
            [-74, 27],
            [-11, 27],
            [21, 61],
            [53, 6],
            [41, 37],
            [-38, 36],
            [-50, -20],
            [-83, 39],
            [41, 74],
            [9, 117],
            [59, 48],
            [82, -31],
            [102, -27],
            [34, 32],
            [142, 5],
            [41, 32],
            [136, 20],
            [36, 36],
            [69, 7],
            [95, 35],
            [39, -5],
            [48, 17],
            [61, 45],
            [80, 20],
            [59, -18],
            [85, 25],
            [50, -31],
            [21, 13],
            [25, 85],
            [74, 60],
            [71, -3],
            [64, 42],
            [12, -19],
            [83, 4],
            [270, 68],
            [49, 22],
            [135, 24],
            [42, 40],
            [75, 9],
            [42, 24],
            [11, 28],
            [-12, 60],
            [99, 25],
            [58, 58],
            [81, 45],
            [160, -18],
            [76, -28],
            [74, -60],
            [62, -21],
            [59, 28],
            [35, 39],
            [78, 13],
            [53, -99],
            [25, -99],
            [60, -196],
            [-10, -131],
            [-31, -58],
            [12, -27],
            [75, -30],
            [106, 11],
            [65, 25],
            [36, -9],
            [31, 57],
            [25, 10],
            [25, -30],
            [37, -83],
            [5, -89],
            [56, 18],
            [-7, 52],
            [18, 25],
            [90, -15],
            [64, -71],
            [80, -10],
            [39, 21],
            [35, 38],
            [29, -14],
            [-10, -63],
            [-87, -66],
            [-29, -58],
            [-6, -61],
            [24, -51],
            [33, -21],
            [53, 60],
            [67, 24],
            [65, -5],
            [43, -19],
            [44, -50],
            [16, 10],
            [15, 79],
            [118, 100],
            [67, 0],
            [101, 80],
            [18, 67],
            [68, 9],
            [69, 35],
            [119, 80],
            [71, 13],
            [81, 57],
            [9, -64],
            [-41, -99],
            [-72, 4],
            [0, -22],
            [48, -95],
            [348, -314],
            [48, -61],
            [190, -352],
            [208, -430],
            [99, -209],
            [76, -185],
            [83, -215],
            [73, 76],
            [62, 19],
            [9, 29],
            [-9, 77],
            [8, 27],
            [48, 22],
            [14, 30],
            [70, 2],
            [28, -51],
            [50, 1],
            [4, -25],
            [-20, -73],
            [15, -39],
            [81, 6],
            [24, -121],
            [52, 0],
            [36, 14],
            [56, 1],
            [51, -31],
            [71, 17],
            [51, -8],
            [37, 25],
            [46, 68],
            [80, 2],
            [43, 51],
            [61, 3],
            [111, -60],
            [70, -62],
            [18, -55],
            [54, -87],
            [25, -130],
            [20, -27],
            [88, -20],
            [71, -62],
            [47, -17],
            [3, -93],
            [65, -128],
            [25, -37],
            [25, 14],
            [173, -41],
            [13, -28],
            [63, 0],
            [35, 49],
            [39, 28],
            [59, 73],
            [37, -11],
            [0, -30],
            [-36, -48],
            [61, -68],
            [44, -92],
            [36, -38],
            [50, -21],
            [28, -73]
        ],
        [[68213, 48978], [-6, 27], [34, 41], [10, -36], [-38, -32]],
        [
            [68488, 52399],
            [-168, -433],
            [-112, -200],
            [-4, -16],
            [0, -331],
            [1, -470],
            [1, -469],
            [1, -470],
            [1, -314],
            [168, -392],
            [3, -68]
        ],
        [
            [68379, 49236],
            [-45, -96],
            [-37, -43],
            [-49, -21],
            [-35, 17],
            [-13, -58],
            [-19, 18],
            [10, -95],
            [-8, -43],
            [-24, -37],
            [-2, -31],
            [-52, -82],
            [-74, -9],
            [-39, -41],
            [-17, -33],
            [-13, -73],
            [4, -111],
            [-20, -86],
            [-4, -43],
            [-39, -56],
            [-29, -103],
            [-11, -23],
            [-13, -117],
            [-27, -115],
            [-29, -89],
            [-45, -182],
            [-35, -82],
            [-28, 9],
            [-20, -46]
        ],
        [
            [67666, 47565],
            [-10, 8],
            [-260, 338],
            [-170, 221],
            [-22, 64],
            [-32, 27],
            [-4, 29],
            [23, 86],
            [1, 33],
            [-13, 112],
            [-229, 231],
            [-132, 132],
            [-197, 199],
            [-263, 266],
            [-132, 133],
            [-155, 156]
        ],
        [
            [66071, 49600],
            [21, 38],
            [12, 53],
            [-29, 86],
            [4, 81],
            [42, 77],
            [49, -10],
            [15, -24],
            [16, 21],
            [-5, 53],
            [36, 22],
            [39, 3],
            [34, 27],
            [-29, 103],
            [-56, -29],
            [-36, -29],
            [-16, -27],
            [-5, -39],
            [-21, -20],
            [-18, 51],
            [-34, 53],
            [0, 47],
            [-27, 9],
            [-14, 49],
            [-3, 105]
        ],
        [
            [66046, 50300],
            [33, 94],
            [10, 69],
            [15, 55],
            [34, 46],
            [6, 25],
            [37, 76],
            [22, 97],
            [51, 80],
            [43, 25],
            [5, 24],
            [-6, 60],
            [56, 146],
            [4, 122],
            [-4, 112],
            [-16, 94],
            [-9, 104],
            [7, 35],
            [-13, 61],
            [-16, 17],
            [-22, 110],
            [-47, 60],
            [-21, 109],
            [-23, 24],
            [-15, 139],
            [13, 108],
            [-15, 47],
            [-38, 24],
            [-32, 44],
            [-58, 227]
        ],
        [[66047, 52534], [124, 223], [154, 273], [121, 213]],
        [
            [78287, 72177],
            [-50, 6],
            [-73, -48],
            [-111, -8],
            [-72, 15],
            [-87, -28],
            [-40, -72],
            [-57, 81],
            [-16, -1],
            [-58, -42],
            [-24, 17],
            [2, 65],
            [-58, 17],
            [-9, 56],
            [-35, 25],
            [-40, -35],
            [-64, -23],
            [-19, -46],
            [-63, -9],
            [-21, 10],
            [-38, 84],
            [-67, 10],
            [-45, -22],
            [-34, 8],
            [-112, 0],
            [-54, 9],
            [-42, -23],
            [-51, -4],
            [-5, 79],
            [-16, 53],
            [24, 115],
            [39, -32],
            [17, 22],
            [-6, 40],
            [19, 42],
            [135, 59],
            [149, -86],
            [20, -55],
            [34, 27],
            [6, 48],
            [29, 26],
            [64, 32],
            [4, 28]
        ],
        [
            [77462, 72617],
            [42, 18],
            [65, 9],
            [66, -43],
            [34, 4],
            [19, -36],
            [48, 46],
            [34, 13],
            [17, 46],
            [37, 55],
            [31, 8],
            [39, -29],
            [15, 34],
            [-12, 32],
            [10, 32],
            [51, -30],
            [35, 18],
            [29, 53],
            [105, 75],
            [6, 24],
            [-44, 18],
            [-114, 13],
            [-36, 54],
            [-43, 35],
            [-55, -10],
            [-7, 82],
            [-35, -5],
            [-53, 17],
            [-7, 65],
            [-20, 57],
            [-58, 50],
            [1, -76],
            [-19, -33],
            [-38, 19],
            [-4, -115],
            [-92, 10],
            [-77, 40],
            [-25, 21],
            [-14, 77],
            [-28, 33],
            [-54, -26],
            [-56, 47],
            [-27, 9],
            [-6, 32],
            [84, 86],
            [55, 84],
            [53, 26],
            [12, 54],
            [59, 33],
            [60, 47],
            [-5, 24],
            [-54, 44],
            [-28, -20]
        ],
        [[77538, 72424], [-8, 49], [15, 38], [-46, 18], [-32, 29], [0, -52], [21, -35], [-10, -45], [60, -2]],
        [[77383, 72387], [-12, 16], [-51, 15], [19, -51], [44, 20]],
        [
            [87792, 55986],
            [-50, 73],
            [-101, 25],
            [-20, 38],
            [-10, -42],
            [-55, -39],
            [-40, 53],
            [3, 36],
            [16, 29],
            [27, 21],
            [13, 73],
            [-21, 94],
            [-38, 49],
            [-20, -35],
            [-17, -60],
            [-18, -30],
            [-62, -5],
            [-14, 89],
            [-5, 77],
            [11, 139],
            [-36, 72],
            [-2, 68],
            [-22, -3]
        ],
        [
            [87331, 56708],
            [-60, 214],
            [-10, 92],
            [15, 96],
            [-38, 80],
            [-41, 55],
            [-2, 89],
            [-9, 104],
            [-31, 99],
            [-10, 53],
            [-3, 141],
            [5, 11],
            [65, 14],
            [-1, 41],
            [24, 32],
            [33, 70],
            [45, 119],
            [11, 45],
            [37, 65],
            [52, 45],
            [124, 49],
            [67, -33],
            [73, 0],
            [54, 19],
            [57, -15],
            [113, 33],
            [59, -35],
            [4, -43],
            [28, -34],
            [34, 66]
        ],
        [
            [88026, 58180],
            [19, -81],
            [32, -51],
            [56, 26],
            [65, -40],
            [28, -60],
            [22, -29],
            [50, -2],
            [18, 71],
            [-8, 44],
            [-29, 76],
            [-8, 44],
            [58, 17],
            [18, 58],
            [40, -12],
            [29, 33],
            [17, 35],
            [19, -40],
            [54, -66],
            [25, -40],
            [36, 7],
            [29, 54],
            [24, -5],
            [57, 98],
            [38, -16],
            [15, 57],
            [17, 22]
        ],
        [
            [88747, 58380],
            [5, -31],
            [-27, -110],
            [-26, -46],
            [-10, -135],
            [61, -264],
            [20, -74],
            [3, -46],
            [-18, -119],
            [-22, -109],
            [2, -54],
            [19, -126],
            [4, -93],
            [-15, -98],
            [-35, -58],
            [-20, 33],
            [-52, -24],
            [-71, -111],
            [-51, -14],
            [-20, -41],
            [-88, -17],
            [-1, -117],
            [-22, -31],
            [-73, 38],
            [-30, 4],
            [-25, -59],
            [-23, -10],
            [-5, -42],
            [6, -40],
            [0, -108],
            [11, -27],
            [86, -130],
            [-12, -50],
            [10, -71],
            [-20, 1],
            [-49, 49],
            [-26, -12],
            [-31, 71],
            [-17, 2],
            [-96, -30],
            [-23, -53],
            [-48, 29],
            [-35, 8],
            [-7, -14],
            [12, -85],
            [-65, -111],
            [-11, -8],
            [-77, -3],
            [-30, -52],
            [-13, -6]
        ],
        [[6994, 51216], [51, -65], [-22, -4], [-53, 31], [-5, 33], [13, 45], [16, -40]],
        [[36258, 59728], [-29, 4], [3, 39], [25, -16], [1, -27]],
        [[36228, 59794], [-65, 55], [14, 35], [25, -27], [26, -63]],
        [
            [94552, 68706],
            [-27, -5],
            [-23, 54],
            [11, 31],
            [42, 52],
            [111, 49],
            [20, 2],
            [43, -21],
            [10, -40],
            [-18, -57],
            [-51, -39],
            [-39, -18],
            [-79, -8]
        ],
        [[94523, 69345], [-19, -8], [-15, 49], [39, 67], [29, -11], [11, -26], [-13, -40], [-32, -31]],
        [[94504, 69546], [-17, -9], [-20, 69], [8, 43], [28, -48], [1, -55]],
        [[95089, 69588], [-4, -55], [-21, -2], [-13, 35], [-22, -18], [-12, 78], [25, 26], [38, -24], [9, -40]],
        [[95297, 69584], [-29, -35], [-39, 47], [-10, 25], [56, 80], [16, 3], [6, -120]],
        [[94612, 71222], [-2, -74], [-28, 11], [-17, 83], [13, 28], [34, -48]],
        [
            [95184, 71716],
            [75, -249],
            [73, -161],
            [61, -117],
            [88, -225],
            [25, -120],
            [3, -74],
            [14, -103],
            [-12, -58],
            [4, -93],
            [-17, -82],
            [4, -151],
            [17, -26],
            [35, 25],
            [-3, -57],
            [-44, -251],
            [-28, -92],
            [-36, -84],
            [-72, -45],
            [-57, -5],
            [-47, 15],
            [-41, -11],
            [-28, -47],
            [8, -81],
            [-52, 22],
            [-56, 13],
            [-18, 49],
            [-51, -31],
            [-49, -6],
            [-23, -36],
            [32, -60],
            [-8, -34],
            [-26, -18],
            [-34, 84],
            [-36, -10],
            [-5, -44],
            [28, -66],
            [-48, -90],
            [-47, 46],
            [27, 64],
            [-4, 53],
            [-67, -83],
            [-41, -94],
            [-22, 7],
            [-22, 34],
            [-44, -60],
            [-8, -48],
            [-24, 18],
            [-8, 80],
            [-46, 53],
            [-21, 47],
            [11, 26],
            [39, -14],
            [24, 24],
            [27, 48],
            [-53, 0],
            [-7, 61],
            [-22, 62],
            [-11, 61],
            [21, 35],
            [31, 133],
            [10, 26],
            [38, 39],
            [-40, 19],
            [1, 23],
            [71, 68],
            [11, 57],
            [-33, 28],
            [14, 52],
            [-47, 84],
            [5, 39],
            [-3, 135],
            [-18, 121],
            [-31, -24],
            [-64, 22],
            [-6, 45],
            [17, 55],
            [42, 49],
            [69, 34],
            [34, -33],
            [30, -6],
            [17, -58],
            [37, 34],
            [0, 29],
            [-28, 10],
            [-37, 121],
            [13, 57],
            [-43, 85],
            [2, 58],
            [-29, 92],
            [22, 36]
        ],
        [
            [94647, 71247],
            [10, 76],
            [27, 34],
            [79, 146],
            [49, 36],
            [112, 0],
            [66, 8],
            [49, -11],
            [42, 5],
            [40, 28],
            [16, 32],
            [36, 107],
            [11, 8]
        ],
        [[62215, 73737], [-53, -15], [-41, -67], [-36, 42], [-25, -2], [-87, -56], [-11, -93], [-15, -28], [-39, 11]],
        [[61753, 73904], [7, 47], [-18, 56], [50, 13], [7, 25], [40, 16]],
        [
            [61839, 74061],
            [38, 16],
            [2, 54],
            [46, 45],
            [11, 36],
            [-11, 55],
            [43, 34],
            [25, -48],
            [66, -45],
            [51, -76],
            [5, -24],
            [51, -45],
            [-4, -45],
            [112, -45],
            [-7, -42],
            [-37, -116],
            [-28, -33],
            [13, -45]
        ],
        [[70460, 66699], [-29, -7], [-30, 104], [23, 90], [22, -13], [37, -86], [-3, -49], [-20, -39]],
        [[70512, 66096], [-238, -6], [-27, 53], [-19, 117], [-28, 85], [-278, 59]],
        [
            [70369, 66899],
            [8, -82],
            [40, -122],
            [-14, -21],
            [-37, 21],
            [-75, -112],
            [37, -28],
            [47, 11],
            [16, -17],
            [41, -210],
            [21, -43],
            [27, -77],
            [32, -123]
        ],
        [
            [87083, 62659],
            [17, -53],
            [36, -59],
            [44, -84],
            [14, -39],
            [29, -30],
            [18, -107],
            [17, -28],
            [46, 41],
            [32, -30],
            [0, -62],
            [-19, -73],
            [-11, -97],
            [10, -35],
            [68, -173],
            [33, -29],
            [78, -34],
            [53, -46],
            [24, 11],
            [24, 52],
            [81, 73],
            [44, -15],
            [47, -52],
            [73, -97],
            [-16, -51],
            [-39, -39],
            [-4, -34],
            [32, -6],
            [38, -22],
            [11, -25],
            [13, -69],
            [35, 6],
            [24, -26],
            [12, -48],
            [0, -36],
            [-35, -64],
            [-4, -38],
            [-18, -45],
            [-48, -76],
            [-13, -5],
            [-88, 42],
            [-71, -6],
            [-5, -16],
            [15, -91],
            [-11, -35],
            [-40, -44],
            [6, -40],
            [59, -41],
            [104, -118],
            [52, -69],
            [32, -32],
            [85, -42],
            [38, -27],
            [9, -35],
            [-10, -24],
            [-8, -69],
            [24, -62],
            [52, -83],
            [39, -20],
            [40, -95],
            [12, -83],
            [20, -54],
            [97, -180],
            [81, -110],
            [48, -120],
            [24, -27],
            [7, -43],
            [6, -126],
            [47, -107],
            [13, -3],
            [29, 41],
            [30, -97],
            [43, -41],
            [46, -80],
            [55, -52],
            [4, -25],
            [-15, -42],
            [-53, -47],
            [0, -51],
            [46, -104],
            [70, -94],
            [27, -76],
            [-6, -36],
            [-24, -75],
            [-23, -43],
            [13, -60],
            [-1, -93]
        ],
        [
            [88026, 58180],
            [49, 39],
            [41, 64],
            [7, 33],
            [8, 141],
            [7, 50],
            [-4, 61],
            [-13, 48],
            [0, 72],
            [7, 58],
            [31, 71],
            [7, 54],
            [-5, 64],
            [-49, 45],
            [-28, 61],
            [11, 54],
            [-24, 28],
            [-56, 31],
            [-31, 38],
            [-7, 43],
            [-23, 57],
            [-41, 70],
            [-21, 101],
            [-2, 132],
            [5, 108],
            [17, 124],
            [-23, 90],
            [-26, 48],
            [-36, 35],
            [-34, 50],
            [-33, 65],
            [-39, 96],
            [-45, 127],
            [-31, 57],
            [-16, -13],
            [-33, 12],
            [-50, 37],
            [-43, 20],
            [-38, 2],
            [-35, -27],
            [3, -53],
            [-35, -32],
            [-18, -47],
            [-12, -61],
            [-19, -23],
            [-28, -6],
            [-56, -47],
            [-18, -41],
            [-20, 29],
            [-13, 53],
            [-29, 11],
            [-33, 34],
            [-37, 57],
            [-40, 35],
            [-48, -72],
            [-22, -20],
            [-31, -7],
            [-10, -45],
            [-17, -35],
            [-85, -95],
            [-76, -123],
            [-19, -11],
            [-46, 35],
            [-15, 23],
            [28, 119],
            [36, 132],
            [9, 61],
            [-2, 80],
            [-27, 67],
            [3, 40],
            [33, 78],
            [37, 200],
            [-2, 63],
            [-17, 68],
            [-8, 65],
            [7, 88],
            [-3, 35],
            [-18, 17],
            [-58, 18],
            [-33, -15],
            [-35, -39],
            [-37, -8],
            [-35, 30],
            [-28, 50],
            [-7, 63],
            [36, 133],
            [9, 52],
            [-8, 50],
            [-27, 35],
            [-18, 55],
            [-17, 26],
            [-31, -26],
            [-13, -37],
            [-16, 24]
        ],
        [
            [86464, 61509],
            [19, 152],
            [20, 79],
            [24, 36],
            [25, 16],
            [48, 1],
            [-13, 54],
            [4, 39],
            [24, 37],
            [28, 107],
            [16, 34],
            [20, 1],
            [33, 29],
            [47, 57],
            [18, 56]
        ],
        [
            [66396, 68628],
            [30, 97],
            [14, 75],
            [26, 62],
            [54, 209],
            [32, 85],
            [11, 121],
            [48, 105],
            [36, 32],
            [18, 30],
            [-1, 45]
        ],
        [
            [66664, 69489],
            [89, 2],
            [10, 26],
            [42, -36],
            [-33, -56],
            [55, -45],
            [25, -118],
            [-39, -92],
            [-32, -25],
            [-22, -65],
            [20, -38],
            [-79, 3],
            [-38, -56],
            [-8, -36],
            [24, -58],
            [-29, -35],
            [-18, -38]
        ],
        [
            [53231, 52607],
            [-36, 9],
            [-104, 79],
            [-81, 45],
            [-269, 259],
            [-75, 104],
            [-86, 155],
            [-192, 312],
            [-44, 50],
            [-55, 24],
            [-59, 55],
            [-19, 87],
            [-48, 51],
            [-89, 73],
            [-66, 122]
        ],
        [
            [52008, 54032],
            [16, 25],
            [24, 80],
            [34, 77],
            [56, 92],
            [64, 78],
            [57, 111],
            [14, 12],
            [24, 174],
            [16, 30],
            [40, 19],
            [23, 85],
            [9, 97]
        ],
        [[63270, 62445], [0, -555], [0, -556], [-4, -4], [-305, 0], [0, -278]],
        [
            [62961, 61052],
            [-148, 132],
            [-147, 132],
            [-148, 132],
            [-148, 131],
            [-148, 132],
            [-148, 132],
            [-148, 132],
            [-148, 132],
            [-148, 132],
            [-147, 132],
            [-148, 132],
            [-148, 132],
            [-148, 132],
            [-296, 263],
            [-250, 223],
            [-196, -158],
            [-114, -92]
        ],
        [[60183, 63003], [-231, -210], [-9, 2], [-186, 277], [-36, 34], [-307, 123], [-160, 65]],
        [
            [58498, 67036],
            [89, 63],
            [27, 25],
            [51, 108],
            [48, 113],
            [12, 46],
            [-4, 93],
            [-39, 240],
            [13, 46],
            [46, 89],
            [52, 17],
            [21, 37],
            [20, 71],
            [50, 51],
            [17, 33],
            [106, 99],
            [104, 87],
            [9, 62],
            [-25, 66],
            [4, 180],
            [12, 120]
        ],
        [
            [59111, 68682],
            [47, -35],
            [48, -14],
            [144, -131],
            [45, -16],
            [101, -16],
            [119, 54],
            [45, 9],
            [78, -50],
            [34, -14],
            [58, -4],
            [124, -62],
            [58, -73],
            [27, -22],
            [205, -66],
            [28, -45],
            [28, -85],
            [2, -105],
            [41, -175],
            [30, -70],
            [34, -58],
            [39, -37],
            [90, -54],
            [101, -20],
            [102, -7],
            [176, -75],
            [148, -86],
            [37, -42],
            [74, -41],
            [148, -202],
            [82, -70],
            [58, -13],
            [52, 12],
            [92, 70],
            [38, 42],
            [93, 174],
            [30, 91],
            [12, 64],
            [-3, 65],
            [-11, 58],
            [-26, 62],
            [-18, 81],
            [-11, 146],
            [15, 101],
            [17, 61],
            [28, 61],
            [77, 119],
            [77, 83],
            [137, 109],
            [79, 1],
            [33, 12],
            [65, 77],
            [26, 3],
            [37, -19],
            [107, 5],
            [47, -21],
            [57, -48],
            [71, -30],
            [104, -68],
            [12, -95],
            [-7, -65],
            [55, -65],
            [158, -31],
            [31, -18],
            [43, -50],
            [28, -15],
            [109, -8],
            [63, 11],
            [60, -17],
            [45, -57],
            [39, -127]
        ],
        [[36763, 57888], [-17, -58], [-34, 36], [-1, 74], [37, 88], [18, -35], [-3, -105]],
        [
            [80247, 55652],
            [61, -1],
            [23, -8],
            [38, -86],
            [103, -154],
            [56, -156],
            [13, -64],
            [25, -21],
            [56, -151],
            [9, -88],
            [33, -18],
            [12, -23],
            [20, -174],
            [71, -188],
            [5, -54],
            [14, -33],
            [21, -90],
            [11, -20],
            [13, -78],
            [1, -150],
            [-5, -66],
            [-29, -160],
            [-17, -57],
            [-23, -48],
            [-79, -103],
            [-23, -21],
            [-104, -64],
            [-76, -61],
            [-70, -17],
            [-71, 34],
            [-53, 80],
            [-27, 118],
            [-19, 122],
            [-27, 137],
            [-21, 421],
            [-26, 268],
            [32, -8],
            [13, 201],
            [28, 156],
            [-4, 116],
            [42, 110],
            [16, 128],
            [-10, 140],
            [34, -22],
            [38, -40],
            [34, 8],
            [-13, 38],
            [-40, 35],
            [-65, 22],
            [-29, 51],
            [9, 39]
        ],
        [
            [64430, 33397],
            [-32, -15],
            [-75, -10],
            [-24, -40],
            [-54, -129],
            [-3, -42],
            [-22, -59],
            [-12, -6],
            [-82, 23],
            [-27, 32],
            [-54, 100],
            [-32, 27],
            [-12, 38],
            [2, 49],
            [-36, 80],
            [-33, 98],
            [-25, 98],
            [14, 36],
            [61, 45],
            [20, 36],
            [31, 85],
            [21, 37],
            [64, 165],
            [70, 37],
            [38, 52],
            [46, 44],
            [74, 48],
            [47, 19],
            [30, -59],
            [41, -50],
            [30, -58],
            [70, -87],
            [38, -30],
            [27, -100],
            [-13, -96],
            [-17, -70],
            [-46, -74],
            [-14, -122],
            [-61, -67],
            [-50, -35]
        ],
        [[62028, 81003], [-17, 4]],
        [[62808, 80256], [-9, 114], [-26, 32], [-62, 45], [-39, 13], [-8, 24], [-60, 27], [-17, -22]],
        [
            [62587, 80489],
            [-27, 76],
            [9, 78],
            [38, 115],
            [-30, 50],
            [-33, 23],
            [-19, 50],
            [-153, 2],
            [-61, 21],
            [-98, 53],
            [-51, 44],
            [-48, -6]
        ],
        [[62114, 80995], [-10, 44], [11, 62], [-21, 91], [-33, 109], [-5, 143]],
        [
            [62056, 81444],
            [83, 66],
            [104, 71],
            [133, 51],
            [155, -18],
            [118, 3],
            [23, -31],
            [47, 24],
            [129, -19],
            [62, -2],
            [95, -36],
            [126, 17],
            [52, 48],
            [63, 9],
            [52, -110],
            [159, -39],
            [24, -14],
            [130, -116],
            [61, -82],
            [37, -26],
            [59, -20]
        ],
        [
            [64002, 82257],
            [49, -11],
            [9, -44],
            [79, -63],
            [13, -38],
            [-7, -45],
            [-30, -63],
            [-2, -42],
            [-22, -74],
            [51, 12],
            [24, -24],
            [3, -47],
            [35, -78],
            [30, -31],
            [30, -159],
            [-16, -65]
        ],
        [
            [62056, 81444],
            [-10, 106],
            [5, 210],
            [12, 104],
            [58, 61],
            [29, 48],
            [33, 170],
            [83, 138],
            [66, 15],
            [90, 39],
            [99, 32],
            [29, -72],
            [120, -114],
            [31, -38],
            [46, -130],
            [112, -66],
            [87, 20],
            [108, 92],
            [32, 43],
            [6, 42],
            [-13, 179],
            [-18, 77],
            [6, 48]
        ],
        [[36110, 60256], [-34, 0]],
        [[36076, 60256], [18, 26], [16, -26]],
        [
            [52879, 65602],
            [-41, 0],
            [13, -110],
            [-9, -55],
            [16, -95],
            [-13, -39],
            [-64, -17],
            [-64, 5],
            [-63, -6],
            [-23, -21],
            [-76, -106],
            [-51, -6],
            [-41, 34],
            [-49, -28],
            [-19, 0],
            [-92, 72],
            [-64, 17],
            [-51, -6],
            [-105, -55],
            [-40, -15],
            [23, -78],
            [-6, -62],
            [-41, -63],
            [-51, -125],
            [-25, -107],
            [-97, -41],
            [-9, -22],
            [-6, -67],
            [-28, -129],
            [-43, -295],
            [-16, -78],
            [-22, -78],
            [-21, -34],
            [-65, -78],
            [-86, -89],
            [-22, -39],
            [-52, -173],
            [-25, -61],
            [-25, -22],
            [-117, -84],
            [-37, -55],
            [-28, -96],
            [-12, -61],
            [-25, -173],
            [-6, -78],
            [-16, -111],
            [-6, -95],
            [0, -78],
            [-9, -78],
            [-28, -67],
            [-40, -61],
            [-59, -123],
            [7, -61],
            [-19, -84],
            [-25, -56],
            [-27, -28],
            [-96, -5],
            [-96, 5],
            [-89, 23],
            [-90, 5],
            [-46, -11],
            [-120, 0],
            [-47, -6],
            [-84, -27]
        ],
        [
            [50311, 62125],
            [23, 267],
            [42, 145],
            [34, 64],
            [52, 33],
            [48, 145],
            [17, 134],
            [32, 62],
            [9, 48],
            [-12, 37],
            [30, 72],
            [36, 110],
            [17, 71],
            [42, 110],
            [-29, 53],
            [37, 61],
            [60, 66],
            [122, 227],
            [47, 39],
            [41, 95],
            [15, 85],
            [4, 194],
            [15, 103],
            [27, 80],
            [32, 145],
            [25, 65],
            [16, 133],
            [17, 50],
            [32, 24],
            [44, 67],
            [67, 40],
            [79, 86],
            [37, 52],
            [25, 77],
            [26, 152],
            [48, 161],
            [25, 123],
            [41, 64],
            [29, 80],
            [48, 36],
            [100, 17],
            [149, 67],
            [134, 101],
            [37, 40],
            [41, 80],
            [67, 105],
            [126, 126],
            [58, 70],
            [88, 176],
            [59, 145],
            [48, 94],
            [34, 83],
            [24, 84],
            [13, 136],
            [-9, 53],
            [-37, 87],
            [-25, 23],
            [-7, 41],
            [14, 72],
            [-1, 124],
            [8, 198],
            [41, 159],
            [101, 210],
            [19, 86],
            [13, 185],
            [126, 194],
            [74, 148],
            [26, 37],
            [65, 68],
            [228, 148],
            [129, 106],
            [75, 77],
            [45, 92],
            [125, 358],
            [122, 505],
            [10, 58],
            [93, 24],
            [70, 57],
            [18, -41],
            [0, -62],
            [26, -73],
            [46, -82],
            [82, -104],
            [65, -42],
            [92, -25],
            [107, 46],
            [60, 1],
            [30, 19],
            [31, -29],
            [61, -9],
            [58, 15],
            [44, 44],
            [28, 50],
            [14, -67],
            [27, -89],
            [33, 5],
            [30, -13],
            [65, 6],
            [63, -11]
        ],
        [
            [64268, 75523],
            [-43, 83],
            [26, 27],
            [-13, 99],
            [-5, 82],
            [6, 93],
            [39, 174],
            [-7, 32],
            [5, 74],
            [-28, 84],
            [-24, 104],
            [-67, 76],
            [-27, 63],
            [-47, 63],
            [-51, 118],
            [-35, 49],
            [-18, 43],
            [-14, 69],
            [-25, 66],
            [-53, 109],
            [-59, 56],
            [-52, 2]
        ],
        [
            [63776, 77089],
            [6, 20],
            [64, 51],
            [17, -8],
            [101, 0],
            [33, 34],
            [21, -10],
            [45, 35],
            [84, -34],
            [21, -29],
            [46, -24],
            [15, -36],
            [63, -10],
            [11, -43],
            [138, -24],
            [28, -69],
            [34, -35],
            [36, 24],
            [32, -52],
            [5, -84],
            [-27, -112],
            [11, -42],
            [54, -44],
            [66, -72],
            [-10, -87],
            [17, -71],
            [46, -45],
            [49, -30],
            [20, -59],
            [-6, -103],
            [64, -65],
            [-17, -25],
            [-74, -15],
            [-26, 49],
            [-42, -22],
            [-49, 30],
            [-47, 8],
            [-31, -49],
            [-1, 70],
            [-17, 12],
            [-58, -38],
            [-10, -19],
            [5, -76],
            [20, -62],
            [-18, -71],
            [-31, -39],
            [-34, -24],
            [-3, -47],
            [-73, -104],
            [7, -52],
            [-13, -36],
            [-50, -5],
            [-30, -27]
        ],
        [[70973, 40756], [-25, -16], [40, 123], [-15, -107]],
        [[70481, 42730], [0, -21], [-40, 9], [-7, 70], [20, 2], [17, 32], [13, -62], [-3, -30]],
        [
            [70850, 43249],
            [31, -114],
            [92, -243],
            [10, -110],
            [32, -172],
            [31, -257],
            [10, -265],
            [9, -121],
            [24, -114],
            [40, -119],
            [13, -132],
            [-24, -135],
            [-35, -128],
            [-26, -57],
            [-35, 34],
            [-23, 54],
            [-29, 128],
            [-10, 64],
            [-46, 5],
            [-29, -66],
            [14, -136],
            [5, -148],
            [23, -46],
            [14, -54],
            [2, -128],
            [-9, -65],
            [-23, -56],
            [10, -63],
            [-40, -43],
            [-30, -78],
            [-28, -116],
            [-4, -59],
            [17, -180],
            [-4, -128],
            [-36, -244],
            [-20, -116],
            [-29, -138],
            [-44, -183],
            [-44, -229],
            [-37, -235],
            [-28, -142],
            [-31, -140],
            [-43, -246],
            [-36, -251],
            [-54, -275],
            [-75, -307],
            [-8, -40],
            [-15, -157],
            [-17, -136],
            [-20, -135],
            [-42, -223],
            [-14, -135],
            [-57, -192],
            [-12, -55],
            [-19, -137],
            [-30, -125],
            [-44, -107],
            [-29, -38],
            [-65, -57],
            [-33, -11],
            [-73, -2],
            [-70, -32],
            [-73, -62],
            [-71, -70],
            [-27, -34],
            [-30, -19],
            [-93, -4],
            [-28, 15],
            [-93, 116],
            [-37, 20],
            [-68, 16],
            [-40, 25],
            [-27, 61],
            [-68, 67],
            [-29, 117],
            [-10, 81],
            [-18, 57],
            [-51, 101],
            [-9, 139],
            [1, 72],
            [-5, 132],
            [6, 62],
            [18, 57],
            [-7, 60],
            [-19, 64],
            [-7, 66],
            [-14, 60],
            [-53, 108],
            [-21, 109],
            [-20, 172],
            [-3, 59],
            [3, 127],
            [8, 65],
            [16, 79],
            [29, 80],
            [20, 162],
            [25, 36],
            [37, 21],
            [30, 42],
            [17, 57],
            [17, 118],
            [47, 117],
            [17, 61],
            [38, 93],
            [33, 130],
            [18, 125],
            [15, 207],
            [-2, 68],
            [-19, 70],
            [-46, 127],
            [3, 118],
            [-4, 69],
            [-39, 132],
            [-21, 120],
            [-10, 198],
            [2, 72],
            [-6, 63],
            [-16, 61],
            [11, 106],
            [137, 384],
            [4, 45],
            [-5, 118],
            [3, 68],
            [15, 40],
            [133, 24],
            [42, 44],
            [38, 62],
            [32, 12],
            [22, -42],
            [44, 29],
            [35, -4],
            [20, 86],
            [12, 14],
            [93, 17],
            [48, 25],
            [10, -5],
            [38, -88],
            [26, -11],
            [13, 16],
            [-31, 46],
            [-3, 56],
            [17, 63],
            [28, 48],
            [61, 74],
            [64, 84],
            [35, -7],
            [12, -100],
            [20, -7],
            [11, 41],
            [-13, 118],
            [58, 115],
            [22, 99],
            [35, 29],
            [10, -58],
            [-21, -99],
            [30, 2],
            [21, 71],
            [38, 103],
            [18, 24],
            [29, -5],
            [-18, 56],
            [-12, 98],
            [57, 168],
            [12, 60],
            [-29, 57],
            [-2, 71],
            [27, 65],
            [18, 10],
            [45, -61],
            [21, -7],
            [26, 44],
            [20, 57],
            [32, 38],
            [35, 24],
            [54, 88],
            [35, 185],
            [3, 54],
            [-8, 66],
            [-33, 140],
            [35, 7],
            [42, 79],
            [53, 132],
            [32, -25],
            [16, -63],
            [36, -62],
            [18, -47]
        ],
        [[27260, 60595], [-41, -1], [70, 57], [-29, -56]],
        [[21324, 60631], [-18, -12], [-28, 34], [23, 46], [23, -68]],
        [[28724, 61502], [-16, -18], [-8, 62], [13, 60], [15, 34], [53, 0], [-57, -138]],
        [[22686, 62231], [-9, -46], [-23, 18], [-10, 76], [32, -12], [10, -36]],
        [[21082, 63782], [-4, -26], [-93, 104], [48, 3], [49, -81]],
        [[21431, 64122], [9, -62], [-36, 43], [-11, 66], [38, -47]],
        [
            [20971, 63867],
            [-32, 58],
            [-4, 45],
            [-37, 33],
            [23, 90],
            [19, 187],
            [8, -35],
            [-20, -188],
            [21, -87],
            [1, -43],
            [21, -60]
        ],
        [[20010, 65832], [-4, -18], [-52, 37], [29, 65], [-4, 68], [23, -8], [15, -87], [-7, -57]],
        [[19062, 66318], [-13, -21], [-35, 116], [27, 10], [20, -48], [1, -57]],
        [[20926, 66354], [-23, -132], [-24, 2], [-49, 42], [-5, 26], [19, 152], [14, 20], [43, 21], [25, -131]],
        [
            [20632, 66380],
            [-33, 25],
            [-72, 117],
            [-26, 59],
            [-2, 89],
            [25, -7],
            [28, -41],
            [12, -39],
            [1, -43],
            [53, -21],
            [14, -139]
        ],
        [
            [25574, 64656],
            [-6, -115],
            [-18, -94],
            [-62, -197],
            [-25, -121],
            [-50, -349],
            [-15, -228],
            [-3, -138],
            [-12, -238],
            [6, -203],
            [-22, -92],
            [-13, -85],
            [5, -64],
            [19, -129],
            [6, -96],
            [55, -166],
            [31, -58],
            [52, -78],
            [-7, -71],
            [-30, -45],
            [3, 61],
            [13, 56],
            [-23, 26],
            [-41, 83],
            [-51, 148],
            [36, -236],
            [13, -38],
            [25, -32],
            [5, -45],
            [44, -164],
            [50, -169],
            [3, -47],
            [20, -57],
            [127, -237],
            [78, -178],
            [27, -169],
            [16, -52],
            [8, -72],
            [52, -81],
            [15, -52],
            [27, -29],
            [23, -87],
            [31, -52],
            [-3, -28],
            [60, -36],
            [20, 16],
            [117, -10],
            [52, -72],
            [67, -32],
            [78, -189],
            [47, -5],
            [63, 16],
            [97, 61],
            [34, 30],
            [65, 40],
            [100, 8],
            [31, -12],
            [75, 26],
            [36, 31],
            [18, 48],
            [83, 36],
            [71, 5],
            [74, 18],
            [28, -44],
            [-10, -61],
            [34, -32],
            [63, -13],
            [20, 5],
            [29, 47],
            [51, 47],
            [-1, 53],
            [-27, 48],
            [7, 53],
            [88, 110],
            [32, 30],
            [67, 111],
            [14, 211],
            [13, 37],
            [44, 64],
            [8, 64],
            [1, 197],
            [-2, 99],
            [8, 87],
            [33, 165],
            [52, 63],
            [112, 85],
            [291, 78],
            [41, 19],
            [50, 50],
            [36, 18],
            [67, -2],
            [36, 27],
            [39, -6],
            [98, -38],
            [64, -35],
            [71, -15],
            [20, 17],
            [-9, 59],
            [27, 22],
            [29, -17],
            [38, -72],
            [27, -23],
            [2, -104],
            [14, -47],
            [-28, -148],
            [-19, -55],
            [-42, -87],
            [-50, -69],
            [-61, -153],
            [-14, -73],
            [0, -57],
            [10, -56],
            [-10, -42],
            [-37, -24],
            [-32, -80],
            [14, -46],
            [68, 16],
            [-3, -45],
            [-15, -33],
            [-26, -15],
            [-29, -36],
            [12, -56],
            [22, 39],
            [15, -19],
            [-28, -134],
            [-19, -138],
            [-25, -80],
            [-8, -117],
            [-29, -99],
            [-8, 3],
            [-24, 93],
            [-30, 47],
            [14, 113],
            [-7, 62],
            [-13, -2],
            [-38, -64],
            [1, -43],
            [-31, -95]
        ],
        [
            [27090, 58291],
            [-91, 164],
            [-86, 167],
            [-67, 96],
            [-44, 76],
            [-115, 169],
            [-60, 77],
            [-56, 92],
            [-50, 51],
            [-50, 34],
            [-41, 44],
            [-17, -33],
            [39, -31],
            [33, -14],
            [51, -46],
            [9, -24],
            [-145, 93],
            [-59, 9],
            [-6, 14],
            [29, 49],
            [-20, 20],
            [-31, -33],
            [-13, 41],
            [-33, 29],
            [-38, -62],
            [23, -54],
            [-57, -18],
            [-102, -113],
            [-95, -48],
            [-136, -109],
            [-60, -5],
            [-32, -18],
            [-92, 42],
            [-116, 102],
            [-176, 32],
            [-118, 133],
            [-118, 55],
            [-75, 128],
            [-45, 6],
            [-29, 20],
            [-107, 47],
            [-105, 30],
            [-103, 112],
            [-68, 36],
            [-58, 45],
            [-129, 76],
            [-47, 42],
            [-45, 65],
            [-74, 68],
            [-31, 56],
            [-35, 20],
            [-50, 106],
            [-26, 45],
            [-46, 28],
            [-68, -8],
            [-102, 46],
            [-47, 12],
            [-99, 70],
            [-130, 77],
            [-80, 171],
            [-66, 109],
            [-41, 47],
            [-71, 55],
            [-40, 45],
            [-61, 34],
            [-103, 87],
            [-33, 75],
            [-19, 66],
            [-56, 81],
            [-60, 150],
            [-16, 56],
            [-11, 85],
            [-31, 88],
            [9, 28],
            [30, 34],
            [51, 8],
            [36, 37],
            [3, 50],
            [-23, 47],
            [-51, 14],
            [11, 37],
            [68, 154],
            [3, 72],
            [-2, 73],
            [7, 62],
            [-68, 71],
            [-30, 111],
            [-38, 95],
            [2, 189],
            [-46, 168],
            [-46, 83],
            [-25, 29],
            [-65, 129],
            [-52, 75],
            [-51, 142],
            [-50, 90],
            [-64, 151],
            [-46, 75],
            [-210, 254],
            [12, 0],
            [62, -62],
            [12, 35],
            [-8, 37],
            [-27, 0],
            [-67, 27],
            [-41, 43],
            [-18, 44],
            [-2, 50],
            [-59, 106],
            [5, 31],
            [34, -7],
            [-4, 43],
            [-87, 56],
            [-28, 39],
            [-71, 66],
            [-17, 23],
            [-11, 63],
            [-75, -32],
            [-12, 40],
            [30, 21],
            [-11, 29],
            [-59, -27],
            [-33, 22],
            [-25, 53],
            [-12, 170],
            [48, 118],
            [21, 34],
            [-23, 128],
            [-64, 98],
            [-84, -4],
            [-23, 37],
            [-19, 64],
            [-16, 109],
            [-103, 46],
            [-62, 89],
            [-26, 72],
            [-17, 113],
            [12, 79],
            [15, 38],
            [-71, 29],
            [-50, -15],
            [-62, 44],
            [-49, 82],
            [-59, 150],
            [-64, 48],
            [-47, 100],
            [-34, 97],
            [-32, 41],
            [-36, 68],
            [-19, 140],
            [-48, 44],
            [-11, 105],
            [-49, 102],
            [-24, 84],
            [-27, 64],
            [-6, 78],
            [-20, 98],
            [-40, 117],
            [-32, 78],
            [-17, 80],
            [8, 80],
            [-7, 78],
            [20, 5],
            [-1, 52],
            [-57, 43],
            [-77, 21],
            [-44, 29],
            [-3, 68],
            [-39, 50],
            [-58, 40],
            [-17, -58],
            [-45, -10],
            [-36, 26],
            [-88, 100],
            [-46, 24],
            [-43, 12],
            [15, -84],
            [-18, -61],
            [-10, -213],
            [37, -110],
            [18, -108],
            [5, -80],
            [16, -64],
            [-5, -150],
            [6, -46],
            [25, -74],
            [45, -70],
            [10, -37],
            [60, -54],
            [36, -69],
            [72, -95],
            [22, -40],
            [65, -148],
            [14, -98],
            [37, 11],
            [18, -75],
            [36, -8],
            [35, -160],
            [18, -21],
            [50, -27],
            [1, -74],
            [23, -47],
            [-4, -64],
            [18, -55],
            [-3, -52],
            [8, -42],
            [56, -94],
            [69, -75],
            [14, -98],
            [28, -89],
            [58, -60],
            [-2, -63],
            [39, -71],
            [7, -90],
            [33, -59],
            [17, 5],
            [-36, 98],
            [6, 68],
            [70, -95],
            [7, -72],
            [24, -41],
            [1, -54],
            [15, -33],
            [4, -47],
            [22, -78],
            [1, -108],
            [12, -79],
            [44, -121],
            [35, -26],
            [7, -59],
            [37, -154],
            [42, -84],
            [21, -70],
            [3, -45],
            [-16, -65],
            [-1, -45],
            [23, -139],
            [35, -71],
            [38, -17],
            [17, -46],
            [22, 52],
            [-9, 62],
            [19, 22],
            [74, -95],
            [13, -36],
            [53, -95],
            [31, -76],
            [10, -79],
            [52, -35],
            [27, -66],
            [2, -42],
            [-13, -106],
            [-12, -31],
            [-41, -45],
            [-31, -54],
            [-60, -53],
            [-25, 4],
            [-25, 62],
            [-29, 188],
            [-20, 39],
            [-14, 59],
            [-22, 49],
            [-83, 73],
            [-42, 78],
            [-40, 52],
            [-43, 76],
            [-119, 124],
            [-49, 64],
            [-32, 63],
            [-37, -8],
            [-14, 71],
            [-69, 95],
            [-15, 53],
            [-3, 60],
            [23, 249],
            [-4, 47],
            [-14, 32],
            [-2, 75],
            [-17, 82],
            [-62, 168],
            [-87, 58],
            [-112, 148],
            [-30, 74],
            [-8, 43],
            [-19, 36],
            [-21, -37],
            [-47, 3],
            [-53, -42],
            [-32, 39],
            [-43, 98],
            [-48, 12],
            [-35, 66],
            [-28, 21],
            [-41, 8],
            [-35, 33],
            [-16, 88],
            [-13, 31],
            [-54, 60],
            [-44, 67],
            [-42, 43],
            [-13, 59],
            [66, -7],
            [78, -25],
            [37, 7],
            [46, 42],
            [0, -54],
            [21, -32],
            [30, 5],
            [-12, 58],
            [5, 49],
            [-33, 9],
            [25, 44],
            [28, 116],
            [14, 114],
            [-30, 100],
            [-51, 69],
            [-109, 203],
            [-102, 162],
            [-53, 24],
            [-45, 58],
            [-78, 83],
            [-34, 42],
            [-23, 100],
            [-18, 14],
            [5, 69],
            [-8, 123],
            [-13, 31],
            [-42, 30],
            [-10, 83],
            [-2, 80],
            [-9, 55],
            [-72, 92],
            [-11, 130],
            [-39, 88],
            [-63, 114],
            [-2, 74],
            [14, 33],
            [1, 52],
            [-70, 82],
            [-21, 112],
            [-46, 81],
            [-20, 106]
        ],
        [
            [19406, 68321],
            [265, 36],
            [265, 35],
            [212, 30],
            [-19, -84],
            [-15, -31],
            [293, -165],
            [292, -165],
            [293, -165],
            [293, -165],
            [327, 1],
            [218, 0],
            [328, 2],
            [0, 250],
            [204, -2],
            [339, -3],
            [33, -51],
            [28, -74],
            [33, -53],
            [39, -29],
            [65, -88],
            [92, -145],
            [74, -97],
            [54, -48],
            [37, -42],
            [19, -34],
            [25, -76],
            [48, -175],
            [0, -80],
            [18, -76],
            [37, -98],
            [32, -58],
            [57, -53],
            [32, -52],
            [38, -35],
            [42, -18],
            [58, -47],
            [75, -76],
            [51, -39],
            [27, -1],
            [24, 24],
            [21, 50],
            [40, 47],
            [18, 127],
            [31, 112],
            [37, 60],
            [43, 10],
            [28, 20],
            [13, 33],
            [23, 3],
            [32, -25],
            [54, -17],
            [73, -7],
            [97, -3],
            [18, -19],
            [24, -61],
            [81, -97],
            [7, -33],
            [81, -122],
            [30, -63],
            [7, -53],
            [26, -85],
            [47, -115],
            [21, -63],
            [-2, -41],
            [13, -56],
            [23, -48],
            [34, -38],
            [34, -70],
            [34, -101],
            [42, -76],
            [49, -53],
            [28, -49],
            [6, -45],
            [-8, -71],
            [22, -95],
            [-1, -74],
            [43, -85],
            [23, -68],
            [18, -110],
            [20, -66],
            [28, -27],
            [44, -9],
            [33, -23],
            [23, -36],
            [29, -21],
            [34, -8],
            [34, -23],
            [32, -40],
            [59, -26],
            [87, -13],
            [66, -32],
            [45, -52],
            [26, -11],
            [23, 39],
            [42, 11]
        ],
        [[62215, 73737], [55, 11], [51, 31], [45, -10], [58, 30], [32, -25]],
        [
            [56864, 60855],
            [1, -245],
            [1, -487],
            [1, -465],
            [-10, -19],
            [-7, -212],
            [-18, -125],
            [-33, -92],
            [-21, -138],
            [-12, -27],
            [-10, -79],
            [-18, -46],
            [-33, -18],
            [-59, -88],
            [-5, -71],
            [-137, 40],
            [-18, -48],
            [-179, -12],
            [-174, -10],
            [-172, -17],
            [-105, -159],
            [-75, -18],
            [-88, 14],
            [-45, 1],
            [-21, -39]
        ],
        [
            [52044, 57097],
            [2, 42],
            [-20, 30],
            [1, 53],
            [17, 175],
            [-49, 127],
            [-10, 67],
            [-17, 45],
            [-38, 13],
            [-23, -43],
            [-14, 27],
            [-5, 44],
            [-49, 105],
            [3, 57],
            [18, 30],
            [8, 49],
            [-19, 55],
            [1, 129],
            [-65, 141],
            [13, 105],
            [-29, 90]
        ],
        [
            [51769, 58438],
            [54, -35],
            [51, 79],
            [21, 60],
            [13, 139],
            [22, 101],
            [26, 48],
            [53, 70],
            [15, -7],
            [88, -148],
            [50, -76],
            [18, -40],
            [16, 0],
            [25, 73],
            [37, 78],
            [88, 9],
            [87, -30],
            [58, -6],
            [153, 47],
            [-1, 65],
            [30, 57],
            [5, -84],
            [49, -17],
            [310, 0],
            [189, 0],
            [252, 0],
            [126, 0],
            [254, 0],
            [47, 439],
            [-83, 159],
            [-35, 551],
            [-26, 416],
            [-18, 277],
            [-35, 554],
            [-26, 416],
            [-35, 555],
            [-27, 416],
            [-26, 416],
            [-35, 554],
            [-35, 543],
            [196, 1],
            [351, 0]
        ],
        [[60056, 70172], [-40, -18], [-26, 28], [-1, 60], [30, -12], [37, -58]],
        [[85865, 55720], [-13, 23], [25, 39], [19, -21], [-31, -41]],
        [[85873, 56288], [26, -96], [-42, 65], [16, 31]],
        [[85877, 56581], [-6, 50], [23, 106], [9, -20], [-13, -111], [-13, -25]],
        [[85980, 56730], [-8, -115], [-29, 16], [-18, 125], [45, 7], [10, -33]],
        [[85968, 56819], [-13, -3], [-6, 90], [48, -58], [-29, -29]],
        [[85851, 56956], [-19, 8], [-12, 38], [28, 16], [3, -62]],
        [[85829, 57089], [-20, -62], [-19, 38], [16, 27], [23, -3]],
        [[85936, 57205], [17, -15], [-3, -54], [-24, -67], [-21, -10], [6, 98], [-9, 56], [3, 37], [26, -17], [5, -28]],
        [[84721, 59072], [-20, -54], [-7, 81], [32, 45], [33, 73], [6, -36], [-16, -68], [-28, -41]],
        [[85677, 59243], [-29, 30], [-3, 86], [22, 25], [18, -42], [-8, -99]],
        [[84478, 60599], [-37, 42], [-25, 60], [40, 12], [39, -13], [-8, -84], [-9, -17]],
        [[84486, 61086], [35, -46], [36, -26], [-13, -54], [-27, -19], [-18, 16], [-8, 50], [-27, 44], [22, 35]],
        [[84268, 61290], [-10, -31], [-20, 73], [15, 26], [15, -68]],
        [
            [86464, 61509],
            [-52, 55],
            [-20, 5],
            [-36, -46],
            [-42, -12],
            [-55, 24],
            [13, -98],
            [-15, -39],
            [-35, -21],
            [-44, 20],
            [-38, -9],
            [-16, -32],
            [-11, -101],
            [-21, -49],
            [-49, -1],
            [-82, -39],
            [-79, -6],
            [-39, 40],
            [-30, -7],
            [-7, -54],
            [-23, -33],
            [-31, -75],
            [-7, -108],
            [3, -75],
            [-28, -75],
            [-2, -36],
            [15, -173],
            [-8, -28],
            [-75, -43],
            [-33, 0],
            [22, -75],
            [23, -36],
            [23, 4],
            [37, -148],
            [6, -57],
            [-12, -56],
            [29, -85],
            [42, -83],
            [101, -215],
            [56, -96],
            [10, -45],
            [2, -91],
            [36, -121],
            [21, -103],
            [8, -13],
            [45, 62],
            [17, -37],
            [-7, -64],
            [-15, -31],
            [-70, -73],
            [-10, -157],
            [-1, -116],
            [3, -87],
            [-9, -30],
            [-26, 4],
            [-80, -86],
            [-5, -31],
            [8, -96],
            [13, -90],
            [101, -253],
            [112, -173],
            [25, -57],
            [37, -129],
            [11, -122],
            [2, -148],
            [-22, -72],
            [21, -79],
            [0, -44],
            [14, -80],
            [57, -107],
            [-3, -41],
            [21, -158],
            [19, -56],
            [28, -172],
            [-13, -53],
            [-29, -41],
            [-37, -124],
            [-52, -159],
            [-51, -103],
            [-74, -118],
            [-9, -27],
            [6, -58],
            [-2, -70],
            [-21, -134]
        ],
        [
            [86025, 55863],
            [-13, -6],
            [-30, -81],
            [-20, 83],
            [8, 95],
            [-18, 180],
            [22, 36],
            [43, 137],
            [2, 82],
            [19, 59],
            [-4, 50],
            [3, 146],
            [16, 41],
            [26, 31],
            [-22, 33],
            [-34, -34],
            [-18, 11],
            [3, 96],
            [13, 26],
            [-8, 95],
            [10, 55],
            [-29, 11],
            [24, 57],
            [-17, 52],
            [13, 55],
            [-1, 68],
            [-8, 104],
            [-13, 77],
            [-6, 98],
            [-27, 73],
            [-20, 106],
            [-55, 139],
            [-2, 113],
            [-12, 25],
            [-15, -185],
            [-12, 36],
            [-4, 103],
            [-8, 50],
            [8, 97],
            [-31, 97],
            [-7, 70],
            [-20, 107],
            [-30, 115],
            [-4, 182],
            [-18, 68],
            [10, 69],
            [-20, 248],
            [-39, 80],
            [18, 131],
            [-7, 158],
            [-75, -8],
            [-14, 83],
            [-20, 40],
            [-17, 83],
            [-10, 94],
            [7, 19],
            [-31, 39],
            [-40, 85],
            [-19, -7],
            [-18, -57],
            [18, -96],
            [-31, -141],
            [-14, -38],
            [-44, -81],
            [-35, -28],
            [-44, 3],
            [-26, 43],
            [-10, 94],
            [-18, 2],
            [15, -77],
            [-1, -35],
            [27, -69],
            [-9, -19],
            [-49, -38],
            [-29, -1],
            [-9, -48],
            [-77, -48],
            [-26, -107],
            [-38, -77],
            [-51, -64],
            [-27, 18],
            [2, 70],
            [17, 58],
            [-10, 27],
            [-48, -116],
            [-30, 8],
            [-42, -12],
            [-16, 90],
            [-3, 60],
            [-26, -65],
            [-42, -37],
            [-3, 89],
            [9, 39],
            [-5, 113],
            [-24, -27],
            [-28, -57],
            [-17, -51],
            [-44, -49],
            [-23, 5],
            [-3, 62],
            [18, 218],
            [25, 68],
            [14, 127],
            [17, 48],
            [6, 101],
            [28, 97],
            [8, 145],
            [-9, 73],
            [-21, 70],
            [-19, 210],
            [-51, 170],
            [-4, 57],
            [-25, 69],
            [23, 5],
            [-48, 60],
            [-6, 25],
            [-22, 160],
            [-18, -20],
            [8, -84],
            [-12, -53],
            [-40, 34],
            [-29, 37],
            [-66, 191],
            [27, 18],
            [46, -75],
            [30, -16],
            [42, 51],
            [11, 62],
            [-11, 23],
            [-38, 29],
            [-21, 42],
            [-9, 49],
            [-40, 44],
            [29, 76],
            [-38, -2],
            [-68, 83],
            [-35, 7],
            [-28, -17],
            [13, -79],
            [-22, -23],
            [-39, 121],
            [29, 60],
            [-25, 2],
            [16, 107],
            [-57, -126],
            [-28, 33],
            [31, 72],
            [-33, 72],
            [-15, 52],
            [-4, -149],
            [-36, 98],
            [-71, 138],
            [-16, 41]
        ],
        [[61484, 74454], [8, -46], [60, -60], [42, -73], [71, -57], [51, -16], [122, -105], [1, -36]],
        [[61535, 73760], [-20, -13], [-60, 7], [36, -66], [38, -28]],
        [[61530, 73526], [-48, 45], [-20, 62], [-71, 105], [-80, 72], [4, 36], [-40, -5]],
        [
            [82665, 77593],
            [37, 1],
            [56, 51],
            [6, 70],
            [17, 39],
            [62, 17],
            [74, 2],
            [62, -21],
            [21, 51],
            [33, -37],
            [53, 33],
            [20, 53],
            [47, -9],
            [24, 27],
            [55, 32],
            [-3, 104],
            [31, 25],
            [72, 20],
            [9, 47],
            [68, 27],
            [90, 54],
            [42, 5],
            [33, 46],
            [24, 10],
            [57, 51],
            [98, 31],
            [79, 59],
            [34, 50],
            [30, 15],
            [120, 4],
            [32, 84],
            [18, 8],
            [41, -56],
            [43, -42],
            [35, 12],
            [12, 38],
            [50, 0],
            [21, -69],
            [29, -29],
            [52, 7],
            [109, -17],
            [193, -16],
            [11, -25],
            [21, -162],
            [65, -74],
            [16, -36],
            [32, 11],
            [65, 0],
            [35, -46],
            [106, -11],
            [42, -17],
            [102, 57],
            [25, -30],
            [40, 22],
            [51, -25],
            [26, -29],
            [59, 9],
            [29, -22],
            [35, 18],
            [84, -16],
            [47, -67],
            [22, -17],
            [47, 6],
            [56, 56],
            [15, 38],
            [40, 19],
            [41, 1],
            [77, 73],
            [46, 125],
            [13, 103],
            [-4, 26],
            [-42, 20],
            [-35, 42],
            [-21, 70],
            [-3, 48],
            [-39, 72],
            [26, 100],
            [11, 103],
            [28, 56],
            [56, 31],
            [6, 41],
            [35, 77],
            [89, 47],
            [50, 87],
            [15, 63],
            [33, 18],
            [24, -37],
            [115, -63],
            [96, -29],
            [63, -64],
            [35, -11],
            [134, -6],
            [20, -7],
            [212, -111],
            [49, -34],
            [59, 8],
            [167, -64],
            [13, -22],
            [-1, -115],
            [13, -31],
            [10, -84],
            [-3, -40],
            [31, -62],
            [-9, -74],
            [15, -23],
            [41, -10],
            [66, -77],
            [55, -30],
            [93, -24],
            [44, -51],
            [101, -34],
            [53, 21],
            [85, -12],
            [31, 8],
            [54, 59],
            [34, 17],
            [158, 43],
            [36, 4],
            [54, 39],
            [36, 8],
            [95, -33],
            [56, -5],
            [64, -41],
            [42, -15],
            [110, 13],
            [42, -9],
            [71, -65],
            [31, -61],
            [60, -54],
            [122, -4],
            [88, -19],
            [10, -13],
            [-3, -131],
            [30, -54],
            [55, -38],
            [60, -72],
            [64, -41],
            [36, 7],
            [156, 0],
            [90, -36],
            [207, -56],
            [38, 26],
            [33, 2],
            [62, -46],
            [61, 16],
            [157, 106],
            [29, -8],
            [94, 31],
            [106, 15],
            [92, 50],
            [37, 10],
            [62, -14],
            [34, 9],
            [77, 52],
            [33, 101],
            [127, 117],
            [94, 52],
            [59, 58],
            [70, 39],
            [27, -11],
            [111, -12],
            [80, -53],
            [84, -106],
            [47, -29],
            [89, -9],
            [129, 73],
            [25, -1],
            [104, -50],
            [40, -54]
        ],
        [[65710, 35211], [-164, -7], [-48, 15], [-26, -3]],
        [[65472, 35216], [-3, 178], [-19, 133], [8, 96], [-3, 51], [-34, 34]],
        [
            [65421, 35708],
            [-9, 102],
            [20, 79],
            [1, 206],
            [-1, 447],
            [-24, 126],
            [-15, 109],
            [-18, 82],
            [-23, 55],
            [-15, 67],
            [-41, 107],
            [-4, 113],
            [-34, 253],
            [-37, 194],
            [-4, 42]
        ],
        [
            [65217, 37690],
            [44, 58],
            [181, 335],
            [109, 202],
            [18, 21],
            [-23, 90],
            [38, 104],
            [0, 132],
            [16, 56],
            [44, 54],
            [61, 166],
            [38, 130],
            [4, 62],
            [-10, 44],
            [-44, 132],
            [-16, 94],
            [16, 83],
            [6, 76],
            [-7, 25],
            [-34, 32],
            [-5, 74],
            [7, 23],
            [40, 36],
            [43, 225],
            [-11, 154],
            [-1, 178],
            [8, 182],
            [-3, 104],
            [-26, 119],
            [-3, 86],
            [19, 60],
            [3, 36],
            [-63, 19],
            [-33, 49],
            [-57, 41],
            [-64, 38],
            [-94, 11],
            [-78, 119],
            [-61, 20],
            [-19, 15],
            [-59, 72],
            [-187, 13],
            [-59, 2],
            [-9, 10],
            [-4, 187]
        ],
        [
            [64942, 41459],
            [-14, 163],
            [-31, 93],
            [-8, 65],
            [2, 43],
            [136, 95],
            [141, 70],
            [126, 65],
            [59, 45],
            [101, 61],
            [67, 36],
            [287, 173]
        ],
        [
            [65808, 42368],
            [13, -17],
            [45, -137],
            [35, -81],
            [41, -75],
            [18, 21],
            [85, 24],
            [24, 1],
            [17, 20],
            [71, 23],
            [13, -9],
            [40, -96],
            [14, -181],
            [2, -122],
            [-5, -87],
            [-33, -101],
            [-23, -127],
            [-35, -69],
            [1, -32],
            [39, -76],
            [8, -32],
            [-2, -66],
            [14, -42],
            [27, -25],
            [26, -63],
            [45, -75],
            [54, -108],
            [25, -33],
            [20, -8],
            [10, -36],
            [-5, -42],
            [-16, -24],
            [7, -35],
            [18, -27],
            [24, -2],
            [27, 19],
            [-2, 161],
            [-16, 94],
            [-20, 44],
            [39, 175],
            [20, 48],
            [75, 20],
            [34, 16],
            [14, 21],
            [11, 56],
            [9, 155],
            [3, 146],
            [-8, 85],
            [11, 129],
            [16, 80],
            [-8, 15],
            [-6, 108],
            [-110, 262],
            [-75, 170],
            [-72, 141],
            [-47, 67]
        ],
        [
            [66320, 42641],
            [-5, 88],
            [-14, 60],
            [3, 64],
            [-12, 100],
            [1, 52],
            [10, 58],
            [-5, 69],
            [-30, 123],
            [6, 32],
            [4, 116],
            [41, 61],
            [23, 98],
            [7, 76],
            [1, 87]
        ],
        [
            [66350, 43725],
            [69, 2],
            [73, -4],
            [26, -12],
            [39, 12],
            [48, 72],
            [39, -1],
            [53, -46],
            [29, -40],
            [4, -34],
            [36, -20],
            [65, -6],
            [48, 18],
            [30, 41],
            [32, 22],
            [33, 3],
            [24, -14],
            [17, -31],
            [32, -22],
            [48, -13],
            [52, 19],
            [57, 53],
            [32, 55],
            [8, 57],
            [20, 47],
            [79, 9],
            [43, -18],
            [55, -57],
            [93, 103],
            [60, 34],
            [56, 1],
            [47, 24],
            [36, 49],
            [38, 32],
            [41, 13],
            [38, 24],
            [53, 51],
            [146, 198]
        ],
        [
            [68049, 44346],
            [17, -57],
            [29, -53],
            [-39, -57],
            [34, -37],
            [-25, -55],
            [-3, -38],
            [12, -38],
            [-16, -63],
            [-22, -48],
            [-6, -37],
            [20, -66],
            [-10, -116],
            [18, -104],
            [12, -89],
            [-9, -64],
            [7, -153],
            [-12, -55],
            [19, -19],
            [10, -61],
            [-8, -106],
            [-33, -44],
            [-3, -44],
            [41, -1],
            [0, -133],
            [-6, -39],
            [10, -45],
            [-12, -50],
            [14, -213],
            [4, -179],
            [35, -27],
            [-1, -42],
            [-22, -55],
            [1, -83],
            [25, 65],
            [29, -26],
            [5, -180],
            [-42, -77],
            [-2, -76],
            [-23, -28],
            [10, -81],
            [-28, -119],
            [-76, -162],
            [-63, -120],
            [-3, -48],
            [-36, -89],
            [-38, -15],
            [-21, -23],
            [16, -79],
            [-25, -18],
            [-43, -62],
            [-118, -119],
            [-19, -28],
            [-30, -73],
            [-61, -38],
            [-66, -5],
            [-12, -15],
            [-78, -52],
            [-73, -40],
            [-29, -44],
            [-65, -40],
            [-101, -99],
            [-82, -94],
            [-95, -142],
            [-12, -75],
            [-44, -100],
            [-67, -117],
            [-39, -98],
            [-3, -42],
            [-24, -14],
            [-19, 41],
            [-9, -79],
            [-34, 11],
            [-45, -39],
            [-39, -45],
            [-62, -95],
            [-88, -184],
            [-129, -178],
            [-30, -4],
            [-40, 62],
            [10, -63],
            [-1, -150],
            [-16, -175],
            [2, -38],
            [18, -50],
            [35, -60],
            [32, -76],
            [42, -217],
            [3, -111],
            [43, -143],
            [2, -62],
            [17, -153],
            [-4, -201],
            [29, -3],
            [3, 125],
            [23, 30],
            [11, -69],
            [4, -72],
            [-16, -156],
            [5, -64],
            [21, -107],
            [-25, -123],
            [-36, -292],
            [-2, -50],
            [28, -30],
            [25, 15],
            [-16, -134],
            [-16, -59],
            [-57, -145],
            [-30, -62],
            [-51, -60],
            [-118, -96],
            [-239, -137],
            [-150, -108],
            [-120, -128],
            [-52, -86],
            [-21, -98],
            [-41, -102],
            [35, -86],
            [45, -61],
            [21, 101],
            [11, 2],
            [-6, -95],
            [-15, -332]
        ],
        [[50506, 61169], [-20, -54], [-12, 56], [25, 77], [16, 10], [-9, -89]],
        [
            [51769, 58438],
            [-40, 45],
            [-15, 48],
            [-26, 35],
            [-36, 24],
            [-34, 59],
            [-27, 31],
            [-2, 54],
            [-21, 63],
            [-19, 29],
            [-27, 3],
            [-19, 52],
            [-20, 8],
            [-16, 46],
            [-12, 86],
            [-15, 66],
            [-20, 48],
            [-45, 48],
            [-39, -10],
            [-23, 25],
            [-34, -13],
            [-20, 30],
            [-13, 61],
            [-34, 60],
            [-66, 90],
            [-73, 42],
            [-78, -6],
            [-43, 5],
            [-57, -5],
            [-3, -23],
            [-27, -12],
            [-53, 0],
            [-42, -14],
            [-32, -28],
            [-46, -12],
            [-58, 4],
            [-65, 30],
            [-22, -9],
            [-19, -44],
            [-18, -80],
            [-25, -58],
            [-12, -60],
            [-7, -100],
            [-10, -44]
        ],
        [
            [50456, 59012],
            [0, 250],
            [16, 94],
            [6, 82],
            [36, 181],
            [43, 148],
            [40, 197],
            [15, 191],
            [-6, 187],
            [-11, 166],
            [-20, 110],
            [-20, 159],
            [-29, 84],
            [-52, 73],
            [-12, 43],
            [44, 27],
            [21, 57],
            [-43, -22],
            [49, 175],
            [16, 119],
            [-3, 78],
            [10, 49],
            [-38, 104],
            [-30, 132],
            [-31, 32],
            [-10, -59],
            [-18, 17],
            [-33, 96],
            [-46, 156],
            [-16, 16],
            [-21, -42],
            [-16, -130]
        ],
        [
            [50297, 61782],
            [-5, 52],
            [31, 240],
            [323, 0],
            [212, 1],
            [213, 0],
            [212, 1],
            [259, 0],
            [-11, 291],
            [-13, 357],
            [-23, 144],
            [15, 73],
            [27, 64],
            [127, 152],
            [76, 26],
            [108, 83],
            [2, 61],
            [0, 523],
            [0, 379],
            [0, 446],
            [219, 0],
            [288, 0],
            [172, 0],
            [173, 0],
            [178, 0],
            [0, 280],
            [-1, 440]
        ],
        [
            [73354, 38759],
            [-39, -16],
            [-43, 6],
            [-6, 54],
            [6, 99],
            [31, 47],
            [9, 49],
            [19, 33],
            [25, 4],
            [25, -60],
            [17, -64],
            [-4, -64],
            [-17, -23],
            [-6, -37],
            [-17, -28]
        ],
        [[66276, 43428], [-18, 6], [6, 51], [23, -12], [-11, -45]],
        [[66252, 43483], [-19, -30], [-12, 27], [16, 26], [15, -23]],
        [[66348, 43742], [2, -17]],
        [[66350, 43725], [-2, 17]],
        [
            [66040, 44796],
            [-12, -30],
            [-3, -50],
            [24, -124],
            [23, -74],
            [30, -55],
            [29, -81],
            [3, -26],
            [-20, -67],
            [12, -282],
            [-1, -86],
            [18, -110],
            [11, -127],
            [-31, -76],
            [-18, -76],
            [-33, -69],
            [-8, -89],
            [13, -81],
            [23, -22],
            [15, -49],
            [-1, -90],
            [21, -49],
            [4, -53],
            [17, -66],
            [4, -120],
            [-7, -123],
            [28, -84],
            [42, -39],
            [18, -38],
            [5, -46],
            [-26, -130],
            [19, -98],
            [40, -60],
            [28, 28],
            [11, 113],
            [27, -31],
            [5, -44],
            [28, -15],
            [25, -63],
            [33, -63],
            [14, 20],
            [-7, 49],
            [-50, 253],
            [-21, 53],
            [-50, 16],
            [-2, 99]
        ],
        [
            [65808, 42368],
            [-17, 40],
            [-48, -45],
            [-22, 77],
            [-17, 37],
            [-31, 31],
            [13, 29],
            [-11, 30],
            [-31, 25],
            [56, 86],
            [26, 111],
            [9, 18],
            [1, 79],
            [9, 103],
            [-16, 53],
            [9, 57],
            [14, 40],
            [69, 41],
            [47, 37],
            [27, 48],
            [2, 41],
            [-47, 12],
            [-27, 109],
            [15, 126],
            [1, 110],
            [-5, 44],
            [-19, 43],
            [2, 65],
            [11, 8],
            [35, 137],
            [-37, 147],
            [26, 45],
            [37, 17],
            [60, 107],
            [1, 21],
            [-34, 90],
            [-7, 87],
            [-67, 110],
            [12, 98],
            [-31, 57],
            [-17, 75],
            [-28, 13],
            [-10, -20],
            [-24, 9],
            [-5, 57],
            [-18, 63]
        ],
        [[65721, 44936], [16, 7], [49, -57], [62, -13], [27, -49], [86, 5], [48, -36], [31, 3]],
        [[89941, 51528], [-24, 12], [-3, 169], [24, -17], [3, -164]],
        [[87729, 51704], [-29, 20], [18, 58], [11, -78]],
        [[91874, 52506], [4, 45], [30, 1], [38, -37]],
        [[86515, 53133], [-30, -6], [4, 91], [13, 12], [28, -32], [-15, -65]],
        [[86379, 53786], [22, -60], [-17, -34], [-13, 9], [-24, -28], [-30, 87], [31, -5], [31, 31]],
        [
            [87074, 53662],
            [54, -22],
            [20, -18],
            [60, -172],
            [79, -121],
            [34, -46],
            [25, -21],
            [36, -65],
            [31, -82],
            [67, -230],
            [12, -100],
            [5, -154],
            [-15, -233],
            [-18, -115],
            [3, -55],
            [25, -84],
            [-8, -79],
            [5, -66],
            [-1, -183],
            [30, -88],
            [85, -108],
            [6, -40],
            [42, -138],
            [77, -300],
            [22, -135],
            [-3, -37],
            [-32, -28],
            [-19, 26],
            [-12, 66],
            [-26, 11],
            [0, -53],
            [-24, -4],
            [-30, 16],
            [-38, -15],
            [-44, -65],
            [-22, -2],
            [-25, 94],
            [-13, 27],
            [-142, 137],
            [-52, 36],
            [-56, 104],
            [-124, 115],
            [-79, 112],
            [-33, 69],
            [-81, 61],
            [-35, 73],
            [-34, 40],
            [18, 70],
            [-17, 135],
            [-57, 122],
            [-28, 85],
            [-53, 85],
            [-42, 106],
            [24, 31],
            [-10, 42],
            [-31, 71],
            [-14, 83],
            [0, 155],
            [-44, 219],
            [-37, 303],
            [6, 106],
            [-9, 115],
            [-25, 110],
            [-32, 79],
            [-12, 66]
        ],
        [
            [86463, 53773],
            [17, 128],
            [27, 6],
            [26, -74],
            [87, -57],
            [27, 18],
            [24, -30],
            [7, -53],
            [18, -48],
            [35, 7],
            [20, -8],
            [10, -117],
            [-3, -43],
            [-26, -61],
            [-3, -42],
            [41, -75],
            [23, 18],
            [21, 67],
            [92, 66],
            [29, -62],
            [44, -10],
            [25, 26],
            [20, 86],
            [36, 65],
            [14, 82]
        ],
        [
            [89398, 51312],
            [28, -95],
            [45, -52],
            [37, -26],
            [80, -13],
            [32, 14],
            [101, -96],
            [33, -15],
            [49, -2],
            [49, -65],
            [-22, 88],
            [6, 42],
            [33, 59],
            [5, 91],
            [25, 90],
            [5, 42],
            [-18, 32],
            [-4, 56],
            [14, 77],
            [34, -40],
            [28, 10],
            [0, 141],
            [21, 60],
            [35, 42],
            [32, 20],
            [121, 34],
            [190, 87],
            [57, 34],
            [38, 41],
            [30, 77],
            [55, 122],
            [39, 100],
            [82, 145],
            [66, 135],
            [19, 99],
            [-1, 70],
            [25, 26]
        ],
        [
            [91099, 52913],
            [73, 18],
            [44, 65],
            [19, 81],
            [-35, 34],
            [-14, 42],
            [-1, 46],
            [43, 86],
            [39, -18],
            [35, 1],
            [25, 43],
            [12, 62],
            [44, 88],
            [15, 67],
            [9, 71],
            [110, 218],
            [14, 34],
            [65, 220],
            [26, -14],
            [5, -70],
            [-13, -75],
            [1, -47],
            [31, 29],
            [33, 77],
            [18, 67],
            [16, 29],
            [38, -28],
            [-2, -48],
            [15, -87],
            [27, -36],
            [36, -23],
            [45, -54],
            [15, -69],
            [1, -44],
            [-25, -42],
            [11, -68],
            [-10, -75],
            [62, 0],
            [24, 18],
            [33, 45],
            [18, -39],
            [17, -67],
            [-56, -42],
            [12, -45],
            [52, 26],
            [33, 37],
            [32, -8],
            [32, -23],
            [33, -44],
            [9, -52],
            [37, -19],
            [75, -72],
            [29, -8],
            [40, 9],
            [13, -10],
            [14, -58],
            [-5, -61],
            [-37, -55],
            [-68, -43],
            [-74, -33],
            [-37, 2],
            [-52, 28],
            [-38, -16],
            [-23, -90],
            [43, -89],
            [73, -93],
            [8, -51],
            [-27, -27],
            [-84, -25],
            [-68, -37],
            [-34, 7],
            [-48, 42],
            [-28, -19],
            [-24, -75]
        ],
        [[91717, 54178], [-19, -30], [-5, 81], [26, 43], [36, 8], [5, -34], [-13, -59], [-30, -9]],
        [[62776, 40345], [129, 45], [147, 44], [142, -20], [61, -15], [50, -50], [51, -89]],
        [
            [61727, 36366],
            [0, -482],
            [0, -496],
            [0, -496],
            [0, -575],
            [-32, 1],
            [-64, -30],
            [-40, -39],
            [-18, -49],
            [-23, -29],
            [-29, -11],
            [-13, -25],
            [3, -39],
            [-11, -30],
            [-26, -20],
            [-42, 6],
            [-58, 32],
            [-73, 8],
            [-90, -17],
            [-64, 8],
            [-39, 34],
            [-41, 19],
            [-44, 5],
            [-78, 39],
            [-16, 75],
            [-15, 35],
            [12, 82],
            [-23, 70],
            [-33, 16],
            [-17, 65],
            [-29, 29],
            [-38, -22],
            [-18, -32],
            [-20, -77],
            [-7, -72],
            [-10, -32],
            [-40, -20],
            [-43, -47],
            [-12, -25]
        ],
        [
            [60636, 34225],
            [-34, 45],
            [-102, 170],
            [-36, 44],
            [-53, 104],
            [-116, 323],
            [-17, 62],
            [-22, 156],
            [-26, 116],
            [-2, 67],
            [12, 37],
            [-21, 98],
            [-39, 60],
            [-12, 200],
            [-26, 130],
            [5, 107],
            [-12, 98],
            [-2, 62],
            [6, 119],
            [-21, 137],
            [-43, 134],
            [-39, 193],
            [-6, 84],
            [4, 227],
            [-7, 93],
            [0, 109],
            [-22, 175],
            [11, 48],
            [18, -22],
            [9, 122],
            [-19, 141],
            [-44, 145],
            [-107, 235],
            [-27, 90],
            [-15, 74],
            [-120, 310],
            [-51, 219],
            [-36, 190],
            [-39, 87],
            [-180, 614],
            [-40, 98],
            [-72, 117],
            [-17, 39],
            [-28, 112],
            [-54, 150],
            [-13, 140],
            [-3, 158],
            [6, 121]
        ],
        [[107274, 37567], [-9, -21], [-28, 24], [6, 43], [27, -22], [4, -24]],
        [[107418, 38232], [40, -8], [-6, -95], [-35, -16], [-40, 34], [1, 33], [-20, 73], [52, 13], [8, -34]],
        [
            [107230, 38382],
            [-17, -4],
            [-22, 40],
            [-43, 20],
            [-32, 77],
            [25, 10],
            [24, 57],
            [-41, 46],
            [45, 26],
            [29, -33],
            [-1, -89],
            [21, -28],
            [21, -63],
            [-9, -59]
        ],
        [[106966, 38640], [12, 138], [12, -81], [-24, -57]],
        [
            [106243, 38892],
            [35, -35],
            [37, 15],
            [47, -55],
            [120, -167],
            [66, -49],
            [36, -66],
            [23, -27],
            [20, -81],
            [42, -55],
            [25, -49],
            [34, -25],
            [15, -29],
            [39, -44],
            [34, -23],
            [75, -85],
            [59, -81],
            [61, -95],
            [78, -77],
            [19, -95],
            [-11, -35],
            [-60, -29],
            [-63, 61],
            [-32, 6],
            [-16, 33],
            [-38, 23],
            [-36, 37],
            [-25, 74],
            [-50, 27],
            [-34, 30],
            [-24, 43],
            [-39, 29],
            [-59, 61],
            [-57, 50],
            [-72, 111],
            [-25, 20],
            [-84, 166],
            [-62, 91],
            [-25, 50],
            [-19, 60],
            [-44, 85],
            [-4, 74],
            [-37, 63],
            [7, 52],
            [44, -59]
        ],
        [
            [60183, 63003],
            [34, -322],
            [26, -277],
            [3, -222],
            [34, -62],
            [97, -255],
            [-21, -45],
            [15, -79],
            [25, -34],
            [80, -152],
            [6, -53],
            [-56, -179],
            [-10, -44],
            [-11, -228],
            [-19, -382],
            [-23, -487],
            [-27, -573],
            [-225, -425],
            [-117, -221],
            [-173, -437],
            [-51, -187],
            [-60, -140],
            [49, -377]
        ],
        [
            [59759, 57822],
            [-55, -1],
            [-32, -17],
            [-40, -55],
            [-45, -21],
            [-54, -48],
            [-67, -68],
            [-45, -74],
            [-15, -56],
            [-44, -11],
            [-62, 9],
            [-40, 56],
            [-91, 59],
            [-87, 32],
            [-140, 10],
            [-149, -23],
            [-90, -34],
            [-79, -75],
            [-96, -181],
            [-128, 6],
            [-76, 20],
            [-64, 28],
            [-90, 85],
            [-112, 129],
            [-43, 17],
            [-51, 9],
            [-133, -129],
            [-26, 3],
            [-31, -14],
            [-36, -48],
            [-37, 4],
            [-41, 56],
            [-55, 143],
            [-74, 133],
            [-27, 31],
            [-36, 3],
            [-213, 116],
            [-41, -20],
            [-37, -44],
            [-43, -8],
            [-86, 9],
            [-49, -15],
            [-75, -47],
            [-55, -82],
            [-29, -24],
            [-19, -225],
            [-15, -67],
            [-28, -89],
            [-93, -137],
            [-4, -261],
            [2, -51],
            [-7, -79],
            [15, -37],
            [-22, -36]
        ],
        [[57813, 52644], [-30, -17], [-20, 5], [27, 73], [31, -22], [-8, -39]],
        [[59759, 57822], [142, -349]],
        [
            [58200, 52832],
            [-12, -17],
            [-26, 12],
            [-12, 38],
            [-16, 6],
            [-33, 46],
            [29, -140],
            [-11, -55],
            [-81, -1],
            [-71, -18],
            [-48, 1],
            [-42, 39],
            [-15, -22],
            [-54, -4],
            [-37, 38],
            [-3, -57],
            [-44, -65],
            [-28, -4],
            [-51, -26],
            [-62, -1],
            [-79, -21],
            [-26, 45],
            [-3, -52],
            [-40, -1],
            [-33, 27],
            [-53, 66],
            [-65, 106],
            [-29, 107],
            [-34, 162],
            [-5, 116],
            [41, 23],
            [15, 53],
            [-50, -40],
            [-47, 46],
            [-6, 49],
            [55, 1],
            [-27, 67],
            [-9, -29],
            [-32, -22],
            [-18, 22],
            [-6, 70],
            [-16, 17],
            [-56, 127],
            [-70, 107],
            [-63, 73],
            [-94, 35],
            [-197, -1],
            [1, 26],
            [81, 71],
            [-11, 8],
            [-66, -37],
            [-23, -4],
            [-29, -71],
            [-194, -16]
        ],
        [
            [29892, 58541],
            [-18, -34],
            [-20, -67],
            [-20, 50],
            [-21, -43],
            [12, -33],
            [23, -9],
            [34, -228],
            [-7, -41],
            [-42, -117],
            [-20, -34],
            [-25, -144],
            [-23, -233],
            [17, -210],
            [-9, -194],
            [10, -102],
            [-27, -9],
            [-9, 35],
            [11, 67],
            [-11, 19],
            [-28, -34],
            [-11, -28],
            [31, -120],
            [-5, -33],
            [-4, -114],
            [-26, 20],
            [-1, -71],
            [-18, -40],
            [38, -20],
            [16, -102],
            [-29, -42],
            [-26, -77],
            [-11, -71],
            [11, -95],
            [36, -110],
            [22, -9]
        ],
        [
            [29093, 56349],
            [-26, 76],
            [-41, 74],
            [-156, 227],
            [-58, 136],
            [-31, 97],
            [-29, 51],
            [-85, 104],
            [-19, 41],
            [-84, 139],
            [-64, 82],
            [-1, 34],
            [26, 44],
            [13, -2],
            [37, -66],
            [27, 32]
        ],
        [[3147, 39541], [-31, -31], [-13, 37], [12, 46], [23, 13], [9, -65]],
        [[34507, 56953], [-25, 15], [-26, 48], [0, 24], [47, -39], [4, -48]],
        [[56594, 78828], [73, 12], [91, -25], [40, 23], [31, -20], [35, 15]],
        [[56778, 79030], [39, -51], [-38, -12], [-41, 37], [40, 26]],
        [[57257, 79343], [-79, 18], [-23, 25], [64, 62], [87, 55], [43, -13], [11, -35], [-28, -41], [-75, -71]],
        [[57068, 79772], [-31, -40], [-14, 51], [45, 52], [0, -63]],
        [
            [56864, 78833],
            [-68, 31],
            [-57, -18],
            [-72, 24],
            [-43, 49],
            [31, 27],
            [60, 4],
            [44, -13],
            [79, -66],
            [30, 27],
            [-49, 27],
            [32, 33],
            [-15, 35],
            [-58, 76],
            [42, 103],
            [39, 36],
            [51, 77],
            [33, 62],
            [25, 75],
            [36, 204],
            [27, 74],
            [37, -19],
            [54, 30],
            [91, 75],
            [27, 66],
            [27, 30],
            [105, 60],
            [59, 17],
            [90, 5],
            [142, 14],
            [47, -63],
            [71, -25]
        ],
        [[57378, 78479], [-61, 13]],
        [
            [57348, 79413],
            [23, 33],
            [-10, 69],
            [-56, 11],
            [-13, 30],
            [14, 94],
            [-73, 12],
            [-7, 94],
            [-40, -8],
            [-62, -58],
            [15, -49],
            [40, -59],
            [-2, -34],
            [-54, -25],
            [1, -96],
            [-9, -60],
            [141, -52],
            [92, 98]
        ],
        [[57129, 83807], [1, -66], [-28, 5], [-17, 41], [-4, 78], [37, -13], [11, -45]],
        [[57090, 84240], [-49, -1], [8, 53], [46, -16], [-5, -36]],
        [[58061, 85496], [-67, 9], [-26, 34], [84, 32], [19, -22], [-10, -53]],
        [[58174, 85680], [-6, 36], [80, 24], [24, -40], [-98, -20]],
        [[59026, 86349], [-123, -13], [-6, 45], [64, 30], [35, -1], [30, -61]],
        [[59421, 86926], [-25, 21], [37, 35], [52, -21], [-64, -35]],
        [[59393, 87005], [-24, 21], [37, 58], [49, -4], [-14, -59], [-48, -16]],
        [
            [59842, 88244],
            [66, -7],
            [-18, -36],
            [-78, -46],
            [-60, -7],
            [-59, -40],
            [-50, -15],
            [-9, 52],
            [31, 41],
            [39, 1],
            [34, 48],
            [104, 9]
        ],
        [
            [60253, 88622],
            [59, -89],
            [-15, -62],
            [-39, -31],
            [-102, -3],
            [-46, 37],
            [-68, -25],
            [-46, 44],
            [56, 60],
            [76, -16],
            [22, 69],
            [51, -11],
            [52, 27]
        ],
        [
            [60424, 88409],
            [46, 50],
            [47, 17],
            [28, 90],
            [55, 19],
            [46, -41],
            [21, -48],
            [-9, -47],
            [-100, -53],
            [-87, -83],
            [-147, -43],
            [-29, 7],
            [-94, -23],
            [-34, 13],
            [-92, -60],
            [-86, -12],
            [-29, 44],
            [102, 80],
            [157, 23],
            [98, 97],
            [23, 106],
            [24, 38],
            [-38, 26],
            [13, 69],
            [79, 71],
            [47, 60],
            [48, 13],
            [21, -48],
            [-38, -58],
            [-56, -49],
            [29, -64],
            [7, -98],
            [-52, -96]
        ],
        [
            [60962, 88986],
            [37, -32],
            [50, 14],
            [68, -33],
            [22, -61],
            [-41, -37],
            [2, -73],
            [-193, -38],
            [-51, -58],
            [-98, 48],
            [40, 15],
            [9, 124],
            [25, 21],
            [86, -10],
            [4, 32],
            [-37, 37],
            [62, 14],
            [15, 37]
        ],
        [[64806, 89098], [-66, -3], [29, 64], [67, -38], [-30, -23]],
        [[61973, 89261], [-42, -18], [-55, 11], [-16, 44], [75, 42], [51, -14], [-13, -65]],
        [
            [61503, 89248],
            [75, -10],
            [29, -43],
            [-80, -84],
            [-62, -5],
            [-100, -96],
            [-7, -34],
            [-158, -24],
            [-44, 13],
            [-15, 38],
            [46, 28],
            [36, 51],
            [51, 0],
            [57, 32],
            [-4, 36],
            [120, 109],
            [-4, 45],
            [58, 7],
            [2, -63]
        ],
        [[61661, 89332], [44, -8], [55, -56], [-95, -14], [-21, 49], [17, 29]],
        [[62849, 89517], [8, -47], [-29, -31], [-120, -70], [-16, 42], [-59, 15], [8, 33], [94, 34], [93, 62], [21, -38]],
        [[62973, 89528], [-59, -23], [-48, 39], [5, 70], [28, 14], [93, -54], [-19, -46]],
        [
            [62795, 89666],
            [-17, -34],
            [-98, -90],
            [-74, -29],
            [-145, -15],
            [-59, 27],
            [-54, 53],
            [110, 0],
            [157, 39],
            [33, -9],
            [74, 58],
            [73, 0]
        ],
        [
            [65088, 89090],
            [17, -73],
            [-20, -63],
            [-76, -3],
            [-119, 56],
            [-30, -95],
            [-42, -40],
            [-187, -52],
            [-55, -112],
            [-76, -42]
        ],
        [
            [61925, 88674],
            [-156, -9],
            [68, -67],
            [-6, -81],
            [-53, -82],
            [-55, -37],
            [84, -36],
            [-84, -67],
            [-30, 3],
            [-253, 73],
            [-87, 4],
            [-121, 35],
            [-66, -19],
            [4, -183],
            [-80, -132],
            [-183, 78],
            [-48, -41],
            [-119, -75],
            [-61, -149],
            [-40, -43],
            [-81, -26],
            [-21, -44],
            [72, -97],
            [23, -54],
            [-9, -56],
            [-52, -44],
            [-109, -115],
            [-101, -121],
            [-41, -35],
            [19, -102],
            [-102, -65],
            [-73, -20],
            [-116, -14],
            [29, -158],
            [-27, -111],
            [-21, -193],
            [-113, -198],
            [-143, -203],
            [132, -66],
            [21, -113],
            [-2, -48],
            [-55, -89],
            [-204, 33],
            [-97, -13],
            [-100, -61],
            [-111, -151],
            [-39, -42],
            [11, -57],
            [-66, -112],
            [68, -162],
            [-34, -46],
            [10, -110],
            [-8, -72],
            [58, -171],
            [-3, -66],
            [-43, -249],
            [103, -82],
            [33, -18],
            [88, -106],
            [-16, -72],
            [-45, -98],
            [-66, -3],
            [-54, -21],
            [7, -62],
            [73, -193],
            [11, -53],
            [-22, -81],
            [-9, -111],
            [-60, -78],
            [-38, -30],
            [-73, -28],
            [-31, -92],
            [-47, -59],
            [36, -168],
            [-26, -152],
            [-22, -51],
            [-53, -10],
            [-25, 71]
        ],
        [
            [59075, 83098],
            [-7, 38],
            [-164, 44],
            [-59, 115],
            [-3, 119],
            [-73, -47],
            [15, -42],
            [-5, -91],
            [-77, -151],
            [-30, 11],
            [-38, -34],
            [-36, -5],
            [-46, 28],
            [-24, -35],
            [-95, -50],
            [27, -28],
            [-49, -38],
            [-19, -35],
            [-77, -59],
            [-125, -150],
            [-65, -43],
            [-45, -44],
            [-40, 1],
            [-50, -37],
            [-126, -33],
            [-84, 15],
            [-58, -13],
            [-32, 26],
            [3, 40],
            [-34, 6],
            [-22, -48],
            [-54, 31],
            [42, 56],
            [-10, 22],
            [-83, 3],
            [-104, 59],
            [-24, 32],
            [-83, 51],
            [-37, 54],
            [-22, 59],
            [12, 139],
            [18, 21],
            [75, -30],
            [75, -49],
            [0, 45],
            [-65, 61],
            [25, 70],
            [-5, 63],
            [76, 77],
            [-56, -13],
            [-53, -34],
            [-87, -35],
            [-30, -48],
            [-32, -21],
            [-59, -2],
            [-13, 35],
            [17, 127],
            [37, 105],
            [52, 39],
            [92, -29],
            [30, 41],
            [38, 6],
            [68, 49],
            [-117, -21],
            [-32, 38],
            [82, 94],
            [36, 56],
            [9, 57],
            [64, 66],
            [52, 31],
            [44, -23],
            [45, 75],
            [-141, -46],
            [-60, -40],
            [-77, -110],
            [-9, -44],
            [-54, -34],
            [-44, -57],
            [-20, -46],
            [-80, -74],
            [-38, -14],
            [3, 93],
            [31, 81],
            [-5, 61],
            [89, -10],
            [51, 46],
            [-74, 0],
            [-41, 29],
            [-32, 57],
            [-14, 77],
            [33, 69],
            [-60, 77],
            [-12, 84],
            [-1, 100],
            [27, 19],
            [60, -14],
            [67, 5],
            [148, 34],
            [95, -20],
            [38, 2],
            [60, 29],
            [52, 3],
            [81, -28],
            [155, 48],
            [-83, 59],
            [0, -57],
            [-103, -11],
            [-88, 25],
            [-35, 21],
            [-15, -50],
            [-34, -11],
            [-93, 18],
            [-135, -11],
            [-60, -25],
            [-39, 3],
            [-67, 45],
            [-26, 35],
            [-6, 102],
            [79, 12],
            [-49, 92],
            [-53, 50],
            [-6, 55],
            [23, 51],
            [41, -8],
            [107, 6],
            [170, -61],
            [140, 11],
            [-22, 25],
            [-82, 0],
            [-203, 52],
            [-64, -5],
            [-33, 12],
            [-19, 38],
            [14, 75],
            [30, 16],
            [36, -21],
            [54, 89],
            [57, 38],
            [59, 21],
            [54, -37],
            [39, 1],
            [115, 31],
            [34, 34],
            [-171, -34],
            [-6, 22],
            [72, 91],
            [121, 15],
            [167, -20],
            [64, -33],
            [14, 72],
            [157, 56],
            [-197, -34],
            [-51, 23],
            [-143, -29],
            [1, 50],
            [70, 94],
            [117, 36],
            [57, 43],
            [89, 7],
            [74, -12],
            [34, -53],
            [123, -64],
            [-139, 156],
            [35, 70],
            [95, 15],
            [4, 63],
            [-64, 10],
            [4, 51],
            [55, 36],
            [82, 25],
            [90, -29],
            [-18, -52],
            [25, -23],
            [51, 62],
            [116, 30],
            [41, -56],
            [77, -51],
            [80, 21],
            [78, -12],
            [52, 7],
            [-27, 54],
            [16, 38],
            [70, 40],
            [51, 12],
            [78, 48],
            [-19, 39],
            [-41, 13],
            [87, 58],
            [-47, 26],
            [-71, -34],
            [-50, -37],
            [41, -43],
            [-34, -41],
            [-184, -111],
            [-88, -33],
            [-40, 5],
            [-49, 99],
            [-61, 4],
            [43, 88],
            [48, 30],
            [45, 92],
            [70, 54],
            [102, 133],
            [83, 42],
            [30, 47],
            [90, 57],
            [22, 42],
            [17, 84],
            [43, 39],
            [207, 113],
            [45, -52],
            [62, 8],
            [71, 64],
            [-115, -12],
            [-9, 27],
            [-62, 21],
            [-4, 46],
            [47, 115],
            [109, 133],
            [19, 53],
            [40, 29],
            [66, 2],
            [-17, 35],
            [-60, 45],
            [187, 46],
            [88, -2],
            [75, 38],
            [18, 40],
            [-192, -46],
            [-72, -3],
            [-16, 111],
            [11, 61],
            [64, 90],
            [43, 8],
            [53, 44],
            [51, -7],
            [-42, 70],
            [71, 32],
            [70, 86],
            [72, 22],
            [41, -9],
            [93, 29],
            [198, 4],
            [6, 25],
            [-189, 12],
            [-106, -7],
            [-10, 24],
            [95, 112],
            [64, 42],
            [121, -17],
            [-42, 62],
            [-55, 15],
            [-80, -4],
            [5, 75],
            [77, 81],
            [70, 3],
            [39, -23],
            [63, 38],
            [-76, 9],
            [-13, 36],
            [105, 54],
            [126, 20],
            [17, -97],
            [43, -14],
            [35, 34],
            [-35, 46],
            [-26, 76],
            [66, 60],
            [71, 10],
            [76, -29],
            [71, 7],
            [147, 45],
            [-45, 19],
            [-69, -13],
            [-190, 4],
            [-22, 37],
            [42, 52],
            [72, 33],
            [76, 5],
            [80, 59],
            [31, 44],
            [17, 68],
            [49, 55],
            [123, 32],
            [-7, 94],
            [66, 84],
            [58, -62],
            [51, -24],
            [66, -4],
            [-73, 67],
            [15, 48],
            [98, 23],
            [15, 55],
            [49, 49],
            [151, 31],
            [3, -107],
            [115, 151],
            [79, 35],
            [19, -44],
            [-34, -185],
            [-72, -100],
            [48, 8],
            [89, 96],
            [79, -4],
            [-56, 54],
            [-5, 122],
            [24, 35],
            [108, 1],
            [59, -14],
            [28, 63],
            [55, 6],
            [49, -42],
            [118, -58],
            [-25, 95],
            [-28, 34],
            [-60, 18],
            [-64, 42],
            [-14, 33],
            [57, 14],
            [74, -16],
            [67, 36],
            [69, 9],
            [143, 36],
            [80, -39],
            [32, -113],
            [65, -61],
            [44, 15],
            [-35, 48],
            [29, 79],
            [87, 85],
            [73, 44],
            [43, 4],
            [77, 99],
            [41, 22],
            [-48, 69],
            [122, 97],
            [118, -40],
            [69, -47],
            [53, 38],
            [102, -33],
            [-152, -168],
            [-40, -127],
            [-47, -59],
            [16, -61],
            [51, 15],
            [64, 56],
            [16, 58],
            [160, 159],
            [75, 88],
            [85, 72],
            [48, 15],
            [22, -48],
            [-18, -63],
            [-36, -40],
            [27, -18],
            [-19, -102],
            [25, -18],
            [100, 50],
            [60, 130],
            [39, 33],
            [76, 14],
            [-89, 46],
            [-10, 20],
            [112, 81],
            [168, -27],
            [77, -38],
            [-3, -59],
            [-34, -40],
            [-99, -45],
            [15, -29],
            [84, 2],
            [-21, -51],
            [33, -75],
            [39, 33],
            [15, 65],
            [38, 79],
            [69, 58],
            [83, -2],
            [91, -70],
            [75, -17],
            [49, -35],
            [83, 34],
            [53, -45],
            [-8, -44],
            [118, -11],
            [102, -68],
            [6, -71],
            [-147, -42],
            [-63, -41],
            [-104, -16],
            [-354, 27],
            [7, -29],
            [246, -65],
            [14, -18],
            [-3, -91],
            [48, -30],
            [112, 11],
            [8, 53],
            [94, -26],
            [119, -7]
        ],
        [[63457, 89848], [111, -21], [58, -61], [-115, -23], [-55, 4], [-83, 41], [84, 60]],
        [[52796, 89679], [-4, 43], [137, 64], [55, 61], [106, 21], [0, -76], [-93, -34], [-103, -22], [-98, -57]],
        [[61492, 91660], [-37, -22], [-93, 74], [119, 18], [11, -70]],
        [
            [62229, 94004],
            [134, -11],
            [51, -94],
            [29, -100],
            [212, 13],
            [143, -57],
            [-92, -34],
            [-11, -54],
            [175, -65],
            [171, 13],
            [205, -79],
            [-239, -55],
            [-89, -89],
            [-142, -66],
            [-86, 3],
            [-92, -61],
            [-116, 22],
            [5, 64],
            [89, 61],
            [-88, 18],
            [-120, -39],
            [-311, -34],
            [-55, 69],
            [102, 31],
            [15, 51],
            [110, 114],
            [-177, 80],
            [-76, 107],
            [-80, 41],
            [-93, 85],
            [42, 21],
            [384, 45]
        ],
        [
            [59032, 94012],
            [113, -75],
            [65, -22],
            [-22, -60],
            [-118, 61],
            [-78, 14],
            [-102, 125],
            [-50, 37],
            [-22, 83],
            [125, -31],
            [89, -132]
        ],
        [[64525, 94180], [-170, -14], [-141, -32], [-46, 13], [162, 61], [133, 5], [62, -33]],
        [
            [60741, 94735],
            [55, 29],
            [189, -41],
            [79, -48],
            [38, -53],
            [-83, -95],
            [54, -54],
            [126, 91],
            [96, -16],
            [77, -104],
            [-18, -70],
            [98, -57],
            [123, 10],
            [81, -16],
            [44, -50],
            [174, 40],
            [96, -39],
            [-83, -43],
            [68, -42],
            [114, -30],
            [92, -62],
            [-90, -36],
            [-410, -30],
            [-119, -80],
            [-101, -89],
            [-30, -76],
            [12, -57],
            [-172, -31],
            [-24, -191],
            [-41, -89],
            [-118, -15],
            [-69, -54],
            [-56, -97],
            [-89, -98],
            [30, -45],
            [-84, -88],
            [26, -85],
            [-112, -44],
            [-73, 16],
            [-69, 52],
            [-214, 103],
            [-130, 111],
            [-234, 83],
            [-112, 117],
            [21, 67],
            [94, 8],
            [98, -30],
            [70, 91],
            [397, 53],
            [255, 8],
            [-56, 63],
            [-244, -35],
            [-147, 12],
            [-303, -57],
            [-158, 2],
            [-93, 46],
            [-34, 97],
            [44, 32],
            [131, -7],
            [231, 44],
            [107, 39],
            [110, 4],
            [-13, 40],
            [153, 30],
            [193, -2],
            [-101, 86],
            [103, 89],
            [-78, -4],
            [-181, -91],
            [-163, -11],
            [-86, 106],
            [-76, -14],
            [-131, 20],
            [-11, -102],
            [64, -43],
            [-163, -80],
            [-297, -19],
            [-149, 82],
            [-126, 117],
            [-91, 27],
            [-58, 41],
            [27, 65],
            [-153, 66],
            [56, 18],
            [154, 0],
            [-48, 94],
            [59, 65],
            [-155, 8],
            [-18, -73],
            [-97, -12],
            [-145, 217],
            [22, 68],
            [-38, 51],
            [55, 36],
            [119, -7],
            [140, 20],
            [123, -46],
            [55, 43],
            [146, -22],
            [109, 31],
            [181, 16],
            [68, -24],
            [-42, -57],
            [-228, -17],
            [-149, -64],
            [204, 10],
            [52, -60],
            [207, -54],
            [-5, 113],
            [171, 119],
            [74, -18],
            [68, -51],
            [187, -246],
            [196, -141],
            [-13, 73],
            [-116, 227],
            [-19, 91],
            [43, 85],
            [45, 28],
            [-2, 68],
            [133, 7],
            [81, -63]
        ],
        [[65599, 94853], [-293, -21], [-29, 15], [587, 75], [53, -25], [-318, -44]],
        [[61344, 94955], [-67, -31], [-111, 24], [39, 39], [139, -32]],
        [
            [62010, 94926],
            [201, -4],
            [45, -46],
            [153, -56],
            [57, 17],
            [23, 174],
            [172, 40],
            [95, -27],
            [-62, -133],
            [177, 11],
            [82, 55],
            [183, -5],
            [286, -35],
            [112, -32],
            [316, -9],
            [89, -56],
            [16, -85],
            [-37, -23],
            [-331, -139],
            [-113, -119],
            [-153, -36],
            [-122, 15],
            [-248, -95],
            [-322, 20],
            [-64, 55],
            [52, 46],
            [-294, -17],
            [-324, 9],
            [-31, 25],
            [-196, 26],
            [-140, 57],
            [46, 24],
            [207, -1],
            [90, 65],
            [-204, 16],
            [-223, -29],
            [-209, 20],
            [-123, 55],
            [-22, 38],
            [186, 60],
            [-158, 13],
            [-132, 47],
            [53, 15],
            [213, 13],
            [178, -5],
            [140, 79],
            [-60, 76],
            [73, 5],
            [157, -40],
            [166, -84]
        ],
        [[106866, 21878], [7, -47], [-110, 21], [9, 25], [48, 47], [9, 78], [38, 4], [-1, -128]],
        [
            [107460, 24052],
            [-32, -39],
            [35, -31],
            [27, 5],
            [-1, -51],
            [-17, -18],
            [-52, -8],
            [-34, -35],
            [-37, 2],
            [-34, -37],
            [-48, -9],
            [6, 33],
            [28, 32],
            [7, 54],
            [27, 18],
            [19, 59],
            [-11, 61],
            [5, 54],
            [53, 3],
            [59, -93]
        ],
        [[107028, 24725], [-5, -42], [-61, 17], [11, 31], [36, 16], [19, -22]],
        [[107100, 24990], [13, -67], [-40, 33], [27, 34]],
        [
            [1180, 25793],
            [-61, -28],
            [-39, -39],
            [19, -53],
            [17, 2],
            [16, -54],
            [-56, -38],
            [-26, 5],
            [-10, 56],
            [33, 59],
            [-34, 45],
            [-54, -8],
            [15, 43],
            [29, -4],
            [31, 26],
            [120, -12]
        ],
        [[109241, 27397], [-42, -33], [10, 72], [47, 45], [-15, -84]],
        [
            [108994, 27165],
            [36, -3],
            [33, 41],
            [69, 61],
            [54, 63],
            [82, 39],
            [-35, -50],
            [21, -51],
            [38, 52],
            [40, 12],
            [28, -19],
            [-50, -128],
            [45, 43],
            [25, -10],
            [-40, -69],
            [-41, -30],
            [-11, -35],
            [8, -42],
            [21, -32],
            [2, -53],
            [35, -46],
            [-20, -62],
            [-75, -128],
            [-27, -28],
            [1, -45],
            [-15, -33],
            [-91, -138],
            [-61, -180],
            [-39, -76],
            [-46, -46],
            [-57, -36],
            [-53, -75],
            [-29, -8],
            [34, -45],
            [-31, -41],
            [33, -23],
            [21, -85],
            [82, -31],
            [13, -67],
            [-15, -43],
            [-45, -10],
            [-32, 12],
            [-21, 32],
            [-84, -11],
            [33, 33],
            [-32, 26],
            [-26, -28],
            [-3, -29],
            [-28, -22],
            [-46, 59],
            [10, -74],
            [-89, -62],
            [-72, -62],
            [-66, -10],
            [-8, -41],
            [-32, -52],
            [-26, -122],
            [-10, -137],
            [-26, -152],
            [-54, -98],
            [-15, -88],
            [-23, -81],
            [-35, -92],
            [27, -61],
            [-4, -43],
            [-110, -39],
            [-26, -29],
            [-46, -94],
            [-83, -97],
            [-71, -121],
            [-107, -38],
            [-75, -6],
            [-102, 36],
            [-60, -25],
            [-33, 13],
            [-26, -10],
            [-17, 33],
            [-2, 55],
            [-41, 48],
            [-34, 5],
            [-73, -8],
            [-49, 97],
            [-59, 21],
            [-38, -48],
            [-83, -4],
            [-83, 13],
            [-30, 15],
            [-2, 131],
            [-72, 0],
            [6, 85],
            [100, 20],
            [-12, 72],
            [22, 54],
            [-42, 3],
            [14, 75],
            [30, 23],
            [10, 34],
            [44, -42],
            [19, 16],
            [5, 49],
            [-30, 24],
            [-2, 55],
            [32, 41],
            [20, 49],
            [90, 107],
            [29, 17],
            [64, 81],
            [22, 53],
            [50, 79],
            [107, 154],
            [28, 29],
            [60, 32],
            [48, -11],
            [80, 72],
            [32, 48],
            [107, 86],
            [45, 18],
            [50, 52],
            [11, 40],
            [49, 43],
            [26, 47],
            [27, 24],
            [35, 63],
            [68, 55],
            [67, 46],
            [71, 116],
            [18, 13],
            [50, 109],
            [20, 19],
            [32, 215],
            [19, 60],
            [20, 99],
            [16, 21],
            [41, 7],
            [49, 50],
            [37, 65],
            [19, 53],
            [26, 135],
            [14, 142],
            [41, 105],
            [60, 76],
            [53, 58],
            [29, -14],
            [-9, -69],
            [19, -59],
            [69, -42],
            [16, -59],
            [9, -129],
            [14, -52]
        ],
        [[109743, 29953], [-30, 3], [-30, 31], [-3, 46], [22, 36], [32, -59], [9, -57]],
        [
            [109042, 30702],
            [52, 4],
            [78, -43],
            [29, -35],
            [18, 23],
            [80, -65],
            [12, -87],
            [19, -5],
            [36, 34],
            [30, -91],
            [39, -96],
            [-11, -47],
            [22, -66],
            [-58, 7],
            [27, -62],
            [21, -68],
            [79, -169],
            [-16, -101],
            [21, -68],
            [-13, -21],
            [-17, -107],
            [25, -6],
            [27, -32],
            [19, 32],
            [29, -33],
            [78, -45],
            [15, -91],
            [12, -29],
            [48, 4],
            [8, 23],
            [-5, 63],
            [-18, 101],
            [-2, 98],
            [-31, 74],
            [23, 45],
            [21, -58],
            [47, -93],
            [28, 6],
            [3, -38],
            [29, -86],
            [14, -137],
            [21, -130],
            [39, -56],
            [-24, -35],
            [22, -25],
            [56, -19],
            [100, -85],
            [48, -32],
            [121, -54],
            [54, -3],
            [36, 19],
            [32, 33],
            [53, 107],
            [87, 84],
            [81, -6],
            [81, -70],
            [-6, -37],
            [-38, -113],
            [-14, -134],
            [-10, -135],
            [-15, -60],
            [-56, -80],
            [-34, -15],
            [-13, -77],
            [-7, -90],
            [17, -68],
            [-28, -46],
            [-27, 64],
            [-82, 21],
            [-35, -5],
            [-86, -58],
            [-30, -45],
            [-24, -56],
            [-6, -69],
            [10, -64],
            [44, -38],
            [-44, -132],
            [-39, -138],
            [-47, -76],
            [-24, -82],
            [-70, -126],
            [-41, -117],
            [-41, -85],
            [-42, -102],
            [-91, -111],
            [-117, -111],
            [-27, 20],
            [-17, 88],
            [-35, 14],
            [-45, -23],
            [-10, 16],
            [0, 70],
            [-36, -26],
            [-38, 20],
            [15, 40],
            [51, 89],
            [52, 117],
            [45, 127],
            [28, 185],
            [-30, 97],
            [-45, 91],
            [-61, 51],
            [-76, 26],
            [-66, 95],
            [-63, 42],
            [-66, 33],
            [-38, 46],
            [-15, 60],
            [6, 60],
            [19, 40],
            [70, 60],
            [74, 34],
            [27, 5],
            [52, 67],
            [9, 32],
            [18, 198],
            [19, 113],
            [29, 71],
            [9, 43],
            [-12, 71],
            [39, 50],
            [-25, 67],
            [-36, 132],
            [12, 61],
            [-19, 7],
            [-37, 127],
            [23, 5],
            [26, -34],
            [18, 22],
            [39, 15],
            [-46, 78],
            [-55, -23],
            [-39, 24],
            [-29, 121],
            [-60, 130],
            [18, 4],
            [48, -65],
            [16, 51],
            [-2, 33],
            [-29, 42],
            [12, 76],
            [-27, 38],
            [-16, -44],
            [-67, 71],
            [-10, -13],
            [43, -80],
            [1, -49],
            [-28, 10],
            [-34, 102],
            [-164, 353],
            [21, 47],
            [32, 39],
            [-13, 33],
            [-27, -39],
            [-24, -56],
            [-81, 165],
            [23, 45],
            [0, 60],
            [-50, 121],
            [-52, 93],
            [-47, 99],
            [51, 12],
            [53, 2],
            [-25, -59],
            [64, -151],
            [3, -26],
            [28, -46]
        ],
        [[73685, 61454], [-25, -4], [0, 71], [45, 88], [30, 103], [20, -92], [-35, -51], [-20, -88], [-15, -27]],
        [
            [72964, 64109],
            [32, -147],
            [46, -137],
            [42, -76],
            [42, -102],
            [65, -95],
            [30, -32],
            [121, -67],
            [66, -24],
            [91, -24],
            [63, -52],
            [21, -3],
            [57, 14],
            [61, -70],
            [17, -67],
            [25, -35],
            [23, -56],
            [14, -58],
            [51, -88],
            [36, -100],
            [36, -74],
            [33, -46],
            [89, -39],
            [4, -49],
            [-11, -112],
            [-37, -92],
            [-9, -57],
            [-42, -95],
            [-45, -158],
            [-20, -35],
            [-73, -82],
            [-54, -98],
            [-63, -170],
            [-48, -170],
            [-19, -54],
            [-38, -11],
            [-43, 21],
            [11, 98],
            [-44, -16],
            [-48, -127],
            [-27, -55],
            [-18, -162],
            [-19, -83],
            [-8, -111],
            [14, -97],
            [1, -100],
            [15, -132],
            [-42, -33],
            [-77, -7],
            [-77, -23],
            [-68, -42],
            [-40, -41],
            [-53, -93],
            [-32, -235],
            [-52, -99],
            [-35, -21],
            [-84, -9],
            [-119, -27],
            [-41, -24],
            [-69, -144],
            [-5, -45],
            [17, -68],
            [-6, -34],
            [-31, -91],
            [-34, -67],
            [-90, -41],
            [-64, 37],
            [-58, 2],
            [-96, -16],
            [-35, -49],
            [-55, -35],
            [-51, -53],
            [-96, -20],
            [-66, -42]
        ],
        [[71945, 59464], [-88, 345], [-22, 18], [-82, 333], [-95, 390], [-55, 223]],
        [[71603, 60773], [256, 154], [266, 160], [159, 96], [245, 147], [59, 321], [79, 433], [67, 365], [-141, 391]],
        [[72870, 64713], [25, 80], [44, 16], [23, 68], [15, -17], [-4, -121], [-13, -170], [-20, -53], [-3, -33]],
        [
            [76600, 63483],
            [-16, -58],
            [-24, 53],
            [-26, -11],
            [-29, 42],
            [-12, -42],
            [-47, -10],
            [-7, 61],
            [-25, -21],
            [-19, 32],
            [-8, 44],
            [-34, 41],
            [-18, 46],
            [-6, 108],
            [-36, 216],
            [-22, 20],
            [-123, 39],
            [-6, 38],
            [8, 101],
            [-3, 65],
            [-40, 84],
            [-11, 59],
            [-32, 51],
            [-33, 15],
            [-32, -7],
            [-27, -54],
            [69, 8],
            [-8, -23],
            [-29, -1],
            [-109, -25],
            [-63, -36],
            [-84, 11],
            [-106, -35],
            [-88, -2],
            [-37, -69],
            [-35, 29],
            [-121, 54],
            [-29, 39],
            [-38, -34],
            [-66, 25],
            [-51, -19],
            [-19, -31],
            [-1, -48],
            [-63, 9],
            [-36, 16],
            [-48, -17],
            [-108, 22],
            [-29, -6],
            [-79, -66],
            [-36, 50],
            [-34, -39],
            [-56, -13],
            [-50, 3],
            [-49, 36]
        ],
        [
            [30372, 54270],
            [-17, -3],
            [-35, 24],
            [-25, 46],
            [-2, 30],
            [14, 47],
            [26, 16],
            [17, -54],
            [-7, -55],
            [25, -25],
            [4, -26]
        ],
        [[31206, 54795], [-20, 29], [1, 61], [32, 7], [6, -56], [-19, -41]],
        [
            [31514, 54212],
            [-83, 175],
            [-64, 199],
            [-13, 90],
            [32, 3],
            [19, 40],
            [-8, 61],
            [52, 73],
            [20, -53],
            [66, -74],
            [-6, 36],
            [-49, 61],
            [-27, 96],
            [-38, -56],
            [-10, 32],
            [-29, 3],
            [-19, -58],
            [-18, 51],
            [-14, 101],
            [-33, 48],
            [-27, 21],
            [-19, 33],
            [-24, 17],
            [-33, 51],
            [-41, 36],
            [-49, 12],
            [-60, -7],
            [-41, -58],
            [-35, -29],
            [-22, -78],
            [-18, -40],
            [20, -24],
            [-115, -137],
            [-23, -20],
            [-52, -14],
            [-28, -42],
            [0, -76],
            [29, -44],
            [32, -82],
            [57, -103],
            [20, -93],
            [-31, -37],
            [-54, -5],
            [-19, -22],
            [-8, -34],
            [-20, -28],
            [-70, -27],
            [-56, -3],
            [-17, 32],
            [-4, 89],
            [-37, 153],
            [-9, 105],
            [-29, -26],
            [-12, -103],
            [-22, -24],
            [-73, 53],
            [-53, 165],
            [-16, 67],
            [-41, 16],
            [-35, 28],
            [-38, 4],
            [-19, -16],
            [-20, 20],
            [-4, 45],
            [-40, -20],
            [-51, 7],
            [-46, 19],
            [-31, -10],
            [-26, -32],
            [3, -82],
            [-7, -16]
        ],
        [
            [30075, 55521],
            [60, -83],
            [-2, -51],
            [11, -71],
            [32, -38],
            [-2, -61],
            [51, -54],
            [92, 12],
            [-16, 50],
            [9, 16],
            [28, -31],
            [51, -107],
            [59, -26],
            [47, 3],
            [43, 15],
            [70, 41],
            [50, 75],
            [40, 34],
            [129, 71],
            [46, 75],
            [38, 19],
            [41, 56],
            [22, 44],
            [23, 23],
            [68, -16],
            [45, -21],
            [30, 2],
            [30, -14],
            [26, -46],
            [73, 4],
            [59, -16],
            [130, -95],
            [78, -94],
            [41, -99],
            [100, -129]
        ],
        [
            [34149, 41533],
            [-26, 20],
            [-28, 57],
            [-26, 16],
            [-19, 44],
            [-45, -25],
            [-33, -50],
            [37, -134],
            [-42, -4],
            [-19, -49],
            [2, -52],
            [47, -52],
            [14, 52],
            [57, -78],
            [56, -35],
            [-1, -45],
            [-10, -40],
            [49, -34],
            [45, -3],
            [14, 15]
        ],
        [[34268, 41126], [-20, -23], [-2, -76], [-15, -37], [19, -27]],
        [
            [33824, 39952],
            [-23, 38],
            [-100, 125],
            [-39, 68],
            [-35, 31],
            [-87, 108],
            [-8, 34],
            [-11, 111],
            [-11, 31],
            [-30, 40],
            [-75, 53],
            [-29, 27],
            [-30, 49],
            [-45, 34],
            [-48, 70],
            [-29, 57],
            [-33, 37],
            [-100, 52],
            [-51, 52],
            [-94, 74],
            [-42, 47],
            [-102, 57],
            [-30, 28],
            [-99, 134],
            [-70, 43],
            [-56, 76],
            [-169, 160],
            [-27, 51],
            [-26, 79],
            [-38, 47],
            [-42, 109],
            [-63, 63],
            [-61, 85],
            [-22, 77],
            [-40, 97],
            [-12, 53],
            [-35, 52],
            [-3, 103],
            [-24, 47],
            [36, 34],
            [23, 160],
            [-12, 81],
            [-63, 145],
            [-23, 70],
            [-16, 90],
            [-26, 53],
            [-37, 112],
            [-23, 100],
            [-50, 72],
            [-21, 63],
            [-28, 26],
            [-1, 76],
            [-20, 145],
            [-27, 73],
            [-100, 136],
            [-10, 148],
            [-22, 104],
            [-111, 321],
            [-28, 96],
            [-27, 155],
            [-25, 88],
            [-28, 157],
            [-41, 120],
            [-26, 103],
            [-28, 129],
            [-3, 68],
            [-50, 119],
            [-27, 108],
            [-47, 91],
            [-46, 69],
            [-19, 49],
            [-66, 232],
            [-9, 69],
            [-44, 128],
            [-44, 92],
            [-28, 74],
            [-36, 66],
            [-216, 205],
            [-76, 85],
            [-26, 41],
            [-12, 64],
            [5, 37],
            [22, 35],
            [31, -27],
            [19, 11],
            [15, 46],
            [0, 69],
            [-19, 89],
            [-69, 172],
            [18, 78],
            [-26, 82],
            [-30, 67],
            [-14, 50],
            [16, 194],
            [16, 49],
            [105, 197],
            [29, 84],
            [45, 51],
            [46, 80],
            [55, 60]
        ],
        [[92676, 53112], [-18, -49], [-55, -10], [-17, -40], [-42, -5], [2, 35], [48, 53], [30, 20], [39, 43], [13, -47]],
        [
            [92957, 53569],
            [17, -41],
            [21, 11],
            [34, -11],
            [6, -35],
            [-36, -39],
            [-24, 41],
            [-42, -28],
            [-19, 17],
            [-28, -15],
            [-16, 31],
            [6, 30],
            [43, 50],
            [38, -11]
        ],
        [[93245, 53765], [-41, -7], [-47, 111], [8, 28], [25, 7], [44, 35], [71, -56], [-26, -87], [-34, -31]],
        [[94385, 54063], [-32, 62], [10, 63], [21, -31], [1, -94]],
        [[93506, 54312], [2, -27], [-43, -25], [-3, 43], [44, 9]],
        [[91698, 54577], [-16, -43], [-18, 49], [7, 87], [26, 10], [1, -103]],
        [[91783, 54761], [-21, -13], [-2, 69], [22, -14], [1, -42]],
        [[94083, 55279], [-9, -33], [-35, 27], [-4, 52], [26, 10], [22, -56]],
        [[93740, 55332], [3, -58], [-28, -17], [-23, 15], [-15, 34], [50, 49], [13, -23]],
        [
            [94453, 55378],
            [25, -33],
            [33, 8],
            [-1, -84],
            [35, -97],
            [5, -59],
            [-18, -57],
            [-37, -65],
            [10, -37],
            [33, -12],
            [26, -31],
            [4, -87],
            [25, -69],
            [-11, -154],
            [4, -53],
            [41, -86],
            [7, -73],
            [-3, -167],
            [-44, -131],
            [-45, -73],
            [-24, 5],
            [-8, -21],
            [15, -66],
            [-6, -140],
            [-9, -97],
            [-25, 101],
            [-9, 135],
            [-12, 62],
            [-17, 56],
            [-8, 50],
            [-18, 46],
            [-24, 121],
            [-42, -39],
            [-15, -88],
            [-30, -50],
            [-44, -123],
            [-6, -59],
            [16, -46],
            [48, -79],
            [26, -134],
            [-1, -137],
            [-19, -61],
            [-47, -115],
            [-34, -36],
            [-18, 18],
            [-17, 99],
            [10, 65],
            [1, 60],
            [-29, 8],
            [-43, -99],
            [-33, 3],
            [-90, 68],
            [-73, 68],
            [-57, 64],
            [-42, 95],
            [-9, 71],
            [0, 75],
            [-19, 110],
            [-1, 73],
            [19, 67],
            [45, 85],
            [5, 72],
            [-43, 101],
            [-31, 49],
            [-63, 43],
            [-30, 42],
            [-35, 8],
            [-19, -13],
            [-5, -80],
            [-26, -144],
            [-66, 68],
            [-25, 96],
            [-33, -86],
            [-45, -10],
            [-8, 16],
            [-8, 92],
            [-24, 29],
            [-30, -6],
            [-37, -51],
            [-15, -62],
            [-40, -123],
            [-44, -188],
            [-24, -50],
            [-42, 30],
            [-18, 60],
            [6, 69],
            [38, 92],
            [21, 165],
            [5, 84],
            [35, 75],
            [29, 46],
            [77, 37],
            [26, 22],
            [41, 0],
            [33, 13],
            [26, 36],
            [7, 99],
            [40, 65],
            [45, 15],
            [14, 16],
            [29, 74],
            [40, -31],
            [36, -15],
            [32, -41],
            [20, -64],
            [9, -136],
            [-24, -78],
            [61, 61],
            [50, 24],
            [21, 39],
            [30, 132],
            [25, 51],
            [14, 4],
            [53, -47],
            [34, 23],
            [9, 70],
            [8, 103],
            [25, 55],
            [23, -9],
            [32, -37],
            [29, -12],
            [21, 88],
            [51, -19],
            [38, 12],
            [11, 71],
            [-7, 75],
            [-30, 219],
            [18, 49],
            [15, 1],
            [38, -58],
            [72, -79],
            [24, -48],
            [16, -59]
        ],
        [[94469, 55626], [-21, 41], [3, 49], [23, 74], [17, -65], [-3, -43], [16, -37], [-35, -19]],
        [[94229, 55747], [-37, 45], [-8, 51], [30, -22], [15, -74]],
        [
            [94017, 55638],
            [-3, -20],
            [-33, -2],
            [-36, -65],
            [-73, -18],
            [-58, 14],
            [-20, 29],
            [-17, 79],
            [29, 57],
            [46, 45],
            [35, 75],
            [50, 14],
            [47, -53],
            [28, -21],
            [-7, -83],
            [12, -51]
        ],
        [[94356, 55709], [-31, 47], [-30, 67], [9, 41], [0, 65], [38, 71], [12, -25], [-12, -81], [18, -97], [-4, -88]],
        [[92573, 56028], [-38, -17], [-9, 53], [28, 50], [48, -39], [-29, -47]],
        [[93417, 56020], [-34, -26], [-7, 37], [6, 65], [42, 73], [20, -47], [-17, -87], [-10, -15]],
        [
            [93566, 55235],
            [-42, -3],
            [-15, 27],
            [-25, 119],
            [-62, 50],
            [-32, 40],
            [-47, 118],
            [-3, 72],
            [22, 77],
            [16, 10],
            [59, 6],
            [44, 54],
            [3, 110],
            [-15, 123],
            [27, 55],
            [16, 53],
            [8, 105],
            [84, 60],
            [79, -40],
            [17, -79],
            [-23, -111],
            [-26, -68],
            [-20, -75],
            [-14, -112],
            [-34, -106],
            [-8, -39],
            [-4, -144],
            [49, -139],
            [4, -47],
            [-28, -84],
            [-30, -32]
        ],
        [
            [93639, 55450],
            [-16, 22],
            [3, 50],
            [24, 173],
            [-6, 43],
            [40, 97],
            [24, 91],
            [37, 95],
            [4, 49],
            [33, 94],
            [30, 130],
            [12, 125],
            [28, 16],
            [-7, -61],
            [5, -101],
            [-8, -88],
            [8, -102],
            [-15, -103],
            [-16, -47],
            [-50, -53],
            [-28, -52],
            [-17, -60],
            [-3, -55],
            [-43, -185],
            [-39, -78]
        ],
        [[93759, 56472], [18, -74], [-24, 1], [-9, 54], [15, 19]],
        [
            [91769, 54887],
            [-28, -41],
            [11, 97],
            [29, 97],
            [21, 29],
            [54, 113],
            [47, 72],
            [43, 79],
            [43, 17],
            [28, 43],
            [71, 142],
            [58, 107],
            [60, 134],
            [37, 54],
            [55, 124],
            [37, 31],
            [25, 38],
            [19, 54],
            [8, 63],
            [-16, 88],
            [14, 72],
            [49, 178],
            [11, 30],
            [18, -45],
            [-8, -92],
            [9, -31],
            [-11, -52],
            [28, -137],
            [21, -87],
            [1, -28],
            [-29, -52],
            [-53, -30],
            [-43, -57],
            [-28, -106],
            [-75, -38],
            [-52, -43],
            [-8, -30],
            [6, -53],
            [-63, -192],
            [-42, -93],
            [-26, -30],
            [-37, -19],
            [-30, -37],
            [-20, -66],
            [-24, -59],
            [-32, -44],
            [-64, -67],
            [-33, -20],
            [-17, -58],
            [-64, -55]
        ],
        [[92556, 56607], [7, -29], [-9, -44], [-38, 21], [40, 52]],
        [
            [94011, 56506],
            [22, -20],
            [24, 8],
            [30, 44],
            [34, -16],
            [30, -90],
            [5, -42],
            [-1, -102],
            [-8, -93],
            [35, -56],
            [18, -56],
            [3, -71],
            [20, -60],
            [-2, -48],
            [-33, 5],
            [-13, -30],
            [-19, 58],
            [-17, 25],
            [12, -187],
            [-30, 35],
            [-36, 22],
            [-10, 18],
            [3, 89],
            [-16, 63],
            [18, 135],
            [-3, 55],
            [-15, 55],
            [-24, 46],
            [-14, 0],
            [-35, -32],
            [-18, 11],
            [-10, 126],
            [-14, 123],
            [-18, 64],
            [7, 28],
            [67, -78],
            [8, -29]
        ],
        [[94022, 56589], [-39, -4], [-17, 26], [-21, 75], [24, 16], [23, -5], [34, -76], [-4, -32]],
        [[94098, 56646], [-23, -8], [-12, 44], [14, 13], [21, -49]],
        [
            [93370, 56657],
            [36, -28],
            [35, 24],
            [34, -7],
            [29, -37],
            [-11, -49],
            [64, 56],
            [17, -3],
            [-1, -52],
            [-11, -87],
            [-32, -95],
            [-24, -32],
            [-42, -38],
            [-10, -93],
            [-30, -13],
            [-46, -60],
            [-100, -39],
            [-28, -26],
            [-37, -66],
            [-17, 20],
            [14, 81],
            [-9, 66],
            [4, 64],
            [18, 60],
            [9, 66],
            [3, 127],
            [13, 177],
            [-11, 45],
            [-54, 37],
            [22, 60],
            [101, -70],
            [34, -39],
            [30, -49]
        ],
        [[92611, 56707], [-23, -19], [-32, 158], [17, 16], [37, -36], [12, -75], [-11, -44]],
        [
            [92630, 56965],
            [29, 0],
            [46, -50],
            [-9, -36],
            [-43, 4],
            [-23, -15],
            [-28, 9],
            [-44, 106],
            [9, 64],
            [56, -65],
            [7, -17]
        ],
        [[93419, 57044], [-16, -13], [-56, 95], [15, 20], [41, 0], [21, -38], [-5, -64]],
        [
            [94216, 57166],
            [22, -45],
            [3, -70],
            [50, -39],
            [17, -33],
            [-10, -31],
            [3, -46],
            [-18, -57],
            [3, -100],
            [10, -33],
            [3, -94],
            [31, -124],
            [6, -49],
            [24, -39],
            [-24, -18],
            [-60, -11],
            [-61, 18],
            [-24, 68],
            [-38, 42],
            [-27, 77],
            [-9, 44],
            [19, 44],
            [5, 71],
            [-34, 6],
            [-28, 67],
            [-36, 70],
            [-46, 32],
            [-26, 41],
            [-18, 51],
            [-19, 89],
            [-9, 92],
            [83, -24],
            [85, 5],
            [96, 21],
            [27, -25]
        ],
        [
            [93746, 57032],
            [60, -66],
            [40, -113],
            [5, -86],
            [-23, 4],
            [-41, 53],
            [-38, 21],
            [3, 28],
            [-38, 49],
            [-25, 60],
            [-35, -2],
            [-39, -88],
            [-42, -38],
            [17, 77],
            [11, 124],
            [7, 37],
            [-10, 105],
            [70, -46],
            [30, -31],
            [5, -21],
            [43, -67]
        ],
        [[93246, 57070], [-25, -139], [-17, 48], [7, 30], [-18, 48], [20, 58], [4, 91], [32, 29], [8, -63], [-11, -102]],
        [[93764, 57125], [-10, -31], [-48, 131], [11, 23], [27, -36], [20, -87]],
        [[93612, 57348], [-35, 12], [-35, 66], [-33, 36], [3, 27], [27, 4], [50, -116], [23, -29]],
        [
            [92817, 57697],
            [15, -5],
            [50, 17],
            [20, -9],
            [13, -31],
            [31, -27],
            [24, 29],
            [26, -33],
            [22, -60],
            [51, -75],
            [5, -24],
            [-15, -39],
            [-3, -101],
            [19, -111],
            [-40, -120],
            [-5, -68],
            [-23, 1],
            [-26, -47],
            [-37, 19],
            [-3, 28],
            [-45, 80],
            [-12, 36],
            [-7, 75],
            [-32, 57],
            [-9, 52],
            [-1, 72],
            [-35, 111],
            [-44, 51],
            [-16, 74],
            [-36, 10],
            [19, 59],
            [21, 3],
            [73, -24]
        ],
        [[93190, 57731], [25, 3], [37, -46], [2, -55], [-36, -89], [-54, 69], [-5, 53], [16, 79], [15, -14]],
        [[92683, 57848], [0, -38], [-52, 56], [5, 42], [28, -21], [19, -39]],
        [
            [93943, 57782],
            [-8, -36],
            [-25, 11],
            [-22, -31],
            [-37, 41],
            [-5, 32],
            [26, 71],
            [0, 106],
            [31, 54],
            [26, -72],
            [34, -43],
            [-4, -107],
            [-16, -26]
        ],
        [[93271, 58014], [-1, -22], [-67, 82], [1, 41], [67, -101]],
        [[93227, 58547], [-20, -62], [16, -74], [-10, -55], [-24, 3], [4, 74], [-32, 91], [6, 42], [41, 5], [19, -24]],
        [
            [92939, 60560],
            [47, -28],
            [105, -105],
            [78, -45],
            [31, -6],
            [28, 24],
            [34, 89],
            [23, 8],
            [24, -55],
            [5, -46],
            [-7, -48],
            [-22, -43],
            [-13, -52],
            [-9, -171],
            [8, -101],
            [19, -79],
            [38, -50],
            [14, -93],
            [35, -30],
            [-16, -75],
            [-13, -93],
            [-62, -216],
            [-3, -47],
            [-25, -93],
            [-49, -15],
            [-58, -45],
            [-32, -35],
            [-27, -45],
            [-11, -59],
            [15, -57],
            [-1, -31],
            [-36, -89],
            [-30, -103],
            [13, -61],
            [34, -121],
            [46, -146],
            [-21, -31],
            [7, -111],
            [47, -205],
            [34, -53],
            [52, -40],
            [41, -10],
            [19, 64],
            [-23, 58],
            [90, 97],
            [42, -3],
            [71, -37],
            [24, -35],
            [25, -60],
            [17, -67],
            [-3, -96],
            [13, -21],
            [40, -2],
            [20, 50],
            [2, 56],
            [-14, 21],
            [19, 48],
            [35, -53],
            [61, -38],
            [29, -7],
            [41, -48],
            [-16, -43],
            [-61, -10],
            [-18, -32],
            [18, -66],
            [29, -54],
            [36, -90],
            [-10, -89],
            [52, -6],
            [35, -38],
            [23, 2],
            [-2, -136],
            [-24, -125],
            [-30, 16],
            [-26, 52],
            [5, 65],
            [17, 62],
            [-9, 13],
            [-57, -24],
            [-33, 8],
            [-70, 68],
            [-28, 6],
            [-6, 31],
            [1, 65],
            [-40, 126],
            [-83, 84],
            [-35, 80],
            [-58, 96],
            [-33, 12],
            [-6, -24],
            [11, -69],
            [1, -59],
            [28, -53],
            [22, -93],
            [2, -79],
            [-23, -33],
            [-26, 36],
            [-6, 58],
            [-28, 72],
            [-62, 87],
            [-41, 78],
            [-91, 83],
            [-42, -12],
            [-44, -41],
            [-15, -29],
            [-1, -44],
            [-32, -35],
            [-43, -4],
            [-34, 21],
            [-27, 44],
            [-23, 2],
            [-28, 69],
            [-35, 9],
            [-28, -54],
            [-6, 106],
            [0, 108],
            [22, 57],
            [72, 113],
            [9, 36],
            [-3, 49],
            [-17, 39],
            [-26, 24],
            [-29, 10],
            [-39, 58],
            [-11, -64],
            [11, -95],
            [2, -63],
            [-10, -23],
            [-36, 7],
            [-14, 22],
            [-9, 64],
            [-25, 43],
            [-10, 60],
            [-35, 4],
            [-17, 29],
            [-12, 70],
            [-3, 77],
            [-32, 176],
            [-12, 227],
            [-10, 38],
            [-28, 57],
            [1, 137],
            [18, 40],
            [31, -49],
            [31, -30],
            [39, -76],
            [55, 10],
            [16, 53],
            [0, 34],
            [-20, 99],
            [-6, 72],
            [5, 130],
            [27, 108],
            [4, 75],
            [-3, 100],
            [4, 94],
            [-16, 54],
            [-4, 58],
            [45, 292],
            [25, 115],
            [4, 78],
            [66, 53],
            [35, -10],
            [54, 16]
        ],
        [[93192, 60716], [-29, -29], [19, 83], [17, 11], [14, -30], [-21, -35]],
        [[93069, 60977], [3, -51], [-18, 1], [-28, 31], [3, 40], [40, -21]],
        [[97104, 54297], [-19, -12], [-8, 43], [3, 49], [12, 38], [32, 39], [-8, -90], [-12, -67]],
        [
            [102951, 43782],
            [51, -29],
            [-1, -47],
            [-45, -10],
            [-11, 20],
            [-43, 20],
            [-7, 36],
            [-38, 41],
            [-9, 54],
            [32, -18],
            [71, -67]
        ],
        [[103180, 43846], [-15, -20], [-51, -12], [-13, 40], [24, 20], [55, -28]],
        [[102136, 44290], [-4, -43], [-25, 12], [-1, 37], [30, -6]],
        [
            [102193, 44594],
            [13, 0],
            [22, 42],
            [31, -7],
            [-20, -132],
            [-17, 20],
            [-67, 37],
            [-2, 52],
            [-17, 17],
            [-11, 51],
            [0, 41],
            [59, -76],
            [9, -45]
        ],
        [
            [102022, 44970],
            [44, -46],
            [37, 6],
            [27, -53],
            [5, -86],
            [-67, 6],
            [-31, 14],
            [-43, 4],
            [22, 49],
            [-23, 56],
            [1, 42],
            [28, 8]
        ],
        [[101966, 44888], [-23, -4], [-50, 77], [8, 57], [22, 30], [35, -32], [15, -74], [-7, -54]],
        [[102671, 45186], [55, -5], [13, -32], [32, -25], [9, -45], [-36, -41], [-45, 32], [-26, 60], [-38, 27], [36, 29]],
        [[99881, 45367], [-40, 9], [-43, 56], [37, -1], [46, -64]],
        [[102201, 45311], [-19, 3], [11, 89], [-24, 25], [13, 41], [22, 18], [7, -83], [-10, -93]],
        [[99880, 45452], [-14, -2], [-54, 38], [-14, 28], [80, -14], [2, -50]],
        [[101250, 46932], [-47, 43], [-29, 68], [1, 59], [19, 18], [65, -68], [6, -21], [-5, -64], [-10, -35]],
        [
            [103698, 46453],
            [-20, -42],
            [-27, -19],
            [-27, -37],
            [-61, 18],
            [-54, 60],
            [-26, 54],
            [-16, 55],
            [8, 64],
            [-10, 58],
            [-59, 55],
            [-22, 57],
            [-49, 76],
            [-22, 125],
            [9, 112],
            [-3, 56],
            [43, -43],
            [39, -10],
            [30, -45],
            [42, -136],
            [44, -61],
            [30, -95],
            [52, -43],
            [57, -89],
            [33, -102],
            [9, -68]
        ],
        [[100987, 47152], [-17, -3], [-35, 73], [3, 28], [36, 37], [23, -34], [5, -73], [-15, -28]],
        [[103294, 47152], [-20, 66], [-7, 90], [-7, 23], [29, 54], [15, -22], [2, -49], [12, -42], [-9, -92], [-15, -28]],
        [[100630, 47546], [-20, -17], [-15, 13], [-1, 72], [29, 36], [18, -56], [-11, -48]],
        [
            [102450, 47785],
            [16, -11],
            [47, 58],
            [24, -40],
            [65, -31],
            [-13, -84],
            [12, -77],
            [-1, -57],
            [-44, -125],
            [-28, -21],
            [-47, -6],
            [-10, -39],
            [4, -42],
            [25, -55],
            [21, -61],
            [-21, -56],
            [-33, -40],
            [-32, -20],
            [-53, 12],
            [-55, -5],
            [-11, -57],
            [-18, -52],
            [-59, -96],
            [-58, -53],
            [-38, -7],
            [-34, -24],
            [-32, -44],
            [-36, -21],
            [-50, -49],
            [-73, -8],
            [-166, 0],
            [-17, 16],
            [-35, 76],
            [-32, 26],
            [-33, -1],
            [-46, -27],
            [-98, 118],
            [-56, 48],
            [-69, 37],
            [-20, 53],
            [2, 69],
            [27, 41],
            [41, -20],
            [31, 12],
            [37, -14],
            [66, 15],
            [76, -49],
            [35, -6],
            [36, 6],
            [48, 31],
            [62, -4],
            [41, 43],
            [15, 171],
            [10, 59],
            [24, 9],
            [15, -29],
            [-28, -65],
            [-3, -68],
            [11, -67],
            [24, -53],
            [35, -6],
            [33, 34],
            [35, 8],
            [33, -34],
            [34, 6],
            [15, 22],
            [52, 26],
            [22, 57],
            [14, 65],
            [21, 51],
            [59, 85],
            [35, 17],
            [40, -4],
            [31, 30],
            [2, 68],
            [-4, 70],
            [-35, 162],
            [-2, 26],
            [15, 55],
            [70, -9],
            [29, -45]
        ],
        [[102683, 48434], [-7, -49], [-32, 70], [30, 29], [9, -50]],
        [[102507, 48538], [-13, -27], [-32, 70], [7, 13], [38, -56]],
        [[102463, 48603], [-8, 44], [22, 8], [3, -40], [-17, -12]],
        [
            [99073, 48726],
            [65, -10],
            [155, -121],
            [62, -60],
            [30, -6],
            [70, -67],
            [104, -68],
            [110, -64],
            [146, -42],
            [41, -20],
            [59, -79],
            [29, -25],
            [28, -45],
            [40, -48],
            [33, -17],
            [78, 7],
            [32, -13],
            [46, -93],
            [34, -20],
            [62, -89],
            [46, -90],
            [37, -17],
            [39, -3],
            [134, -244],
            [6, -38],
            [1, -160],
            [-14, -125],
            [33, -39],
            [109, -41],
            [61, -40],
            [195, -168],
            [26, -15],
            [79, -3],
            [59, -59],
            [50, -114],
            [23, -30],
            [16, -132],
            [-3, -62],
            [-11, -23],
            [-31, -11],
            [-109, -10],
            [-73, 11],
            [-51, -62],
            [2, -53],
            [44, -133],
            [27, -118],
            [21, -48],
            [33, -39],
            [111, -191],
            [30, -34],
            [35, -21],
            [59, -71],
            [24, -131],
            [13, -121],
            [63, -78],
            [23, -136],
            [18, -63],
            [29, -22],
            [35, 1],
            [95, 40],
            [31, -8],
            [15, -22],
            [5, -61],
            [-15, -64],
            [-4, -62],
            [19, -51],
            [65, -50],
            [87, -13],
            [67, -28],
            [3, -42],
            [-69, -38],
            [1, -35],
            [34, -81],
            [29, -27],
            [74, -36],
            [48, -35],
            [54, -10],
            [40, -28],
            [56, 12],
            [-65, -57],
            [-59, 17],
            [-11, -18],
            [24, -48],
            [49, -51],
            [-9, -23],
            [-42, -44],
            [-50, -10],
            [-55, 19],
            [-39, 25],
            [-21, 52],
            [-60, 72],
            [-65, 9],
            [-59, 27],
            [-128, 19],
            [-31, 12],
            [-38, 37],
            [-102, -10],
            [-35, 32],
            [-37, 11],
            [-30, -11],
            [-88, 32],
            [-30, 32],
            [-36, 56],
            [-18, 68],
            [-27, 65],
            [-34, 53],
            [-87, 107],
            [-28, 78],
            [-4, 87],
            [-17, 2],
            [-50, 35],
            [-20, 41],
            [-54, 172],
            [-49, 104],
            [-14, 63],
            [-21, 54],
            [-46, 95],
            [-94, 69],
            [-81, 12],
            [-55, 39],
            [-97, 33],
            [-28, 38],
            [-6, 57],
            [-28, -6],
            [-82, 42],
            [-18, -17],
            [-6, -46],
            [-24, 7],
            [-39, -54],
            [-26, 4],
            [-75, 46],
            [-37, 69],
            [-12, 0],
            [62, -219],
            [-31, 1],
            [15, -42],
            [-34, -6],
            [-35, 18],
            [-35, 6],
            [-3, -25],
            [22, -95],
            [-51, -22],
            [-52, -14],
            [-57, -26],
            [-59, -2],
            [-61, 24],
            [-56, -28],
            [-24, 3],
            [-31, 83],
            [-7, -17],
            [20, -64],
            [26, -32],
            [32, 19],
            [68, -5],
            [67, -55],
            [30, -17],
            [60, -104],
            [26, -79],
            [-8, -88],
            [-43, -42],
            [-45, -32],
            [-68, -61],
            [-65, -70],
            [-35, 14],
            [-31, 37],
            [-63, 37],
            [-78, -16],
            [-110, -7],
            [-67, 34],
            [-34, -10],
            [-24, -26],
            [-26, -4],
            [-48, 58]
        ],
        [
            [102775, 47529],
            [-23, -42],
            [-47, 109],
            [-18, 77],
            [4, 120],
            [-8, 84],
            [-22, 77],
            [-75, 182],
            [-50, 90],
            [-68, 30],
            [-55, 64],
            [-67, 103],
            [-35, 29],
            [-18, 36],
            [-105, 116],
            [-30, 27],
            [-37, 0],
            [-7, 37],
            [0, 78],
            [52, -64],
            [56, -56],
            [16, -45],
            [27, -3],
            [49, -38],
            [67, -72],
            [36, -56],
            [70, -44],
            [45, -88],
            [46, -62],
            [16, -34],
            [196, -292],
            [33, -82],
            [3, -56],
            [-27, -69],
            [-7, -106],
            [-17, -50]
        ],
        [[101994, 48697], [-62, -8], [-22, 9], [-38, 82], [-25, 22], [44, 38], [38, 12], [63, -48], [6, -24], [-4, -83]],
        [
            [100954, 49088],
            [103, -36],
            [-60, -88],
            [-87, -4],
            [-55, 23],
            [-62, -33],
            [-4, 46],
            [23, 13],
            [-4, 47],
            [19, 24],
            [32, -2],
            [30, 17],
            [65, -7]
        ],
        [[101787, 49315], [-29, -13], [-39, 58], [11, 67], [16, -5], [28, -39], [13, -68]],
        [[61611, 80546], [12, -7], [174, -14], [288, -17], [317, -17], [185, -2]],
        [
            [62846, 78906],
            [23, -68],
            [-5, -48],
            [61, -102],
            [23, -75],
            [52, -82],
            [-39, -33],
            [21, -35],
            [15, -59],
            [-2, -48],
            [-36, -68],
            [-81, -18],
            [-138, -170],
            [-70, -97],
            [-102, -163],
            [-17, -37],
            [25, -136],
            [-8, -69],
            [44, -51],
            [-12, -33],
            [-84, 29]
        ],
        [
            [62516, 77543],
            [-20, 4],
            [-140, 72],
            [-16, 50],
            [-24, 25],
            [-77, 38],
            [-89, 9],
            [-84, -6],
            [-41, -56],
            [-45, 6],
            [-57, 36],
            [-78, -4],
            [-62, -38],
            [-32, -76],
            [-44, 23],
            [-35, -17],
            [-9, 101],
            [-34, 13],
            [-69, 112],
            [-59, -48],
            [-31, -62],
            [-56, -2],
            [-9, 57],
            [-33, 7]
        ],
        [[59961, 80139], [70, -32], [20, 20], [2, 64], [-106, 27]],
        [
            [59946, 80262],
            [53, -14],
            [103, 52],
            [176, 68],
            [189, 64],
            [89, 20],
            [58, 82],
            [57, 65],
            [100, 24],
            [38, 30],
            [79, 44],
            [179, 48],
            [148, 12],
            [135, -85],
            [-25, -11],
            [-75, 44],
            [47, -129],
            [25, -46],
            [52, -34],
            [43, -11],
            [133, 20],
            [61, 41]
        ],
        [
            [35148, 60465],
            [18, 14],
            [59, -14],
            [38, -24],
            [39, -11],
            [3, -78],
            [-30, -31],
            [-36, -72],
            [-42, -46],
            [-51, -14],
            [-84, 1],
            [-32, 20],
            [-81, 0],
            [-39, -22],
            [-35, 11],
            [-40, 0],
            [-17, 15],
            [8, 128],
            [-28, 79],
            [28, 39],
            [4, 36],
            [31, 13],
            [76, -17],
            [192, -9],
            [19, -18]
        ],
        [[95848, 73898], [50, -130]],
        [
            [95898, 73768],
            [-16, -16],
            [-55, 15],
            [-68, -66],
            [-18, -48],
            [-34, -28],
            [-43, -83],
            [-16, -51],
            [-37, -52],
            [-22, -66],
            [-1, -56],
            [23, -57],
            [3, -49],
            [-17, -100],
            [9, -107],
            [-10, -42],
            [-114, -73],
            [-29, -36],
            [-42, -95],
            [-51, -35],
            [-31, -39],
            [-44, -23],
            [-28, -67],
            [-31, -37],
            [-64, -53],
            [-61, -2],
            [-43, -20],
            [-31, -56],
            [-92, -64],
            [-12, -48],
            [6, -130],
            [-28, -34],
            [-23, -58],
            [4, -50],
            [57, -36],
            [37, -10],
            [26, -23],
            [58, -103],
            [85, -86],
            [39, -68]
        ],
        [
            [94647, 71247],
            [-82, 54],
            [-51, -28],
            [-27, -47],
            [-20, 70],
            [-34, 2],
            [-53, 63],
            [-23, -13],
            [-35, -82],
            [-41, -48],
            [-26, 10],
            [-17, 54],
            [-64, 21],
            [-35, 28],
            [63, 59],
            [-9, 31],
            [-52, -9],
            [-27, 20],
            [-40, -7],
            [-27, 16],
            [57, 58],
            [2, 60],
            [28, 78],
            [29, 42],
            [75, 61],
            [76, 11],
            [-41, 34],
            [-38, -2],
            [-40, 35],
            [-4, 37],
            [78, 232],
            [-15, 133],
            [-56, 32],
            [-25, 4],
            [-100, 93],
            [-13, -59],
            [-29, -21],
            [-25, 98],
            [-65, 65],
            [5, 54]
        ],
        [[50253, 68508], [42, -30], [39, 15], [48, -38], [25, -9], [-45, -61], [-55, 8], [-48, 33], [-21, 48], [15, 34]],
        [[47834, 70789], [-40, -9], [-12, 29], [35, 16], [17, -36]],
        [
            [47643, 71280],
            [19, -4],
            [99, 8],
            [26, -6],
            [-3, -41],
            [-19, -16],
            [-58, -11],
            [-91, 27],
            [-30, 35],
            [15, 47],
            [42, -39]
        ],
        [[46871, 71621], [-25, -38], [-32, 16], [-37, -2], [-24, 30], [6, 50], [34, 0], [78, -56]],
        [[46719, 71662], [-32, -2], [-30, 43], [45, 22], [22, -29], [-5, -34]],
        [[46985, 71679], [-14, -7], [-112, 62], [-38, 50], [107, -60], [57, -45]],
        [[47202, 71728], [-70, 9], [-26, 59], [39, 20], [41, -7], [27, -27], [-11, -54]],
        [[45949, 72153], [-14, -26], [-31, 19], [6, 57], [38, -9], [1, -41]],
        [
            [53273, 70911],
            [-27, -6],
            [-105, -91],
            [-32, 0],
            [-61, 40],
            [-107, 13],
            [-35, 12],
            [-44, -26],
            [-34, 0],
            [-27, -33],
            [-19, 9],
            [22, 75],
            [35, 147],
            [-1, 91],
            [8, 78],
            [-10, 77],
            [-17, 49],
            [24, 125],
            [-3, 65],
            [-22, 82],
            [66, -13],
            [-40, 53],
            [-36, -4],
            [-56, -31],
            [-36, -4],
            [3, 50],
            [-15, 66],
            [49, 22],
            [36, 60],
            [-8, 55],
            [-28, -38],
            [-13, -51],
            [-69, -25],
            [-36, 18],
            [0, 68],
            [13, 60],
            [6, 85],
            [19, 76],
            [-7, 50],
            [38, 49],
            [32, 65],
            [44, 155],
            [52, 164],
            [-15, 36],
            [35, 238],
            [27, 82],
            [9, 154],
            [-6, 70],
            [-20, 72],
            [-20, 154],
            [-2, 51],
            [-24, 63],
            [3, 38],
            [31, 60]
        ],
        [[66115, 67646], [59, 90], [27, 56]],
        [
            [9469, 40318],
            [45, -26],
            [8, -43],
            [-10, -28],
            [-33, 23],
            [-16, 50],
            [-43, -11],
            [-30, 9],
            [-17, 66],
            [7, 48],
            [32, 20],
            [40, -15],
            [15, -37],
            [2, -56]
        ],
        [[9317, 40398], [-22, -4], [-5, 46], [37, -10], [-10, -32]],
        [[8825, 40770], [-24, 8], [3, 58], [20, -8], [1, -58]],
        [[12648, 44775], [46, -29], [0, -25], [-80, -21], [-10, 33], [44, 42]],
        [[12323, 44925], [-21, 38], [35, 8], [-14, -46]],
        [[12324, 45213], [-45, -11], [-10, 46], [8, 37], [52, -11], [-5, -61]],
        [[71384, 63901], [-54, -23], [-39, 5], [-34, 59], [-16, 61]],
        [
            [71241, 64003],
            [13, 55],
            [-21, 161],
            [-7, 124],
            [2, 25],
            [33, 94],
            [41, 206],
            [33, 55],
            [47, 40],
            [39, -79],
            [48, -60],
            [9, -68],
            [-14, -55],
            [-13, -88],
            [11, -75],
            [25, -135],
            [-4, -102],
            [-17, -41],
            [-33, -125],
            [-49, -34]
        ],
        [
            [64268, 75523],
            [32, -58],
            [41, -30],
            [96, -33],
            [20, 43],
            [21, -11],
            [41, 17],
            [61, 46],
            [55, 9],
            [51, -27],
            [43, -62]
        ],
        [
            [64729, 75417],
            [-22, -156],
            [-24, -76],
            [-157, -48],
            [10, 23],
            [-11, 70],
            [-20, 38],
            [-28, -41],
            [11, -61],
            [-24, -52],
            [-13, -85],
            [14, -33],
            [-47, -73],
            [-17, -44],
            [4, -174],
            [-22, -134]
        ],
        [
            [62568, 74847],
            [-18, 44],
            [-36, 34],
            [-11, 32],
            [18, 59],
            [45, 8],
            [7, 28],
            [-69, 56],
            [-46, -17],
            [-46, -64],
            [-33, -11],
            [-21, 44],
            [-36, 26],
            [-52, 8],
            [-32, 16],
            [-35, 45],
            [-50, 20],
            [7, 24],
            [42, 6],
            [4, 22],
            [-54, 40],
            [41, 73],
            [-18, 39],
            [-64, 27],
            [-88, 70],
            [-51, 66],
            [0, 148],
            [-20, -8],
            [-40, 75],
            [-69, 59],
            [-36, 74]
        ],
        [
            [62621, 76915],
            [55, 33],
            [26, 45],
            [19, -1],
            [64, -53],
            [68, 3],
            [169, -50],
            [95, 23],
            [29, -9],
            [97, -119],
            [56, 16],
            [29, 43],
            [91, 49],
            [216, 45],
            [35, 68],
            [9, 50],
            [97, 31]
        ],
        [[100845, 74571], [-33, -1], [4, 40], [63, 27], [23, -32], [-57, -34]],
        [
            [100689, 74992],
            [45, -41],
            [66, 9],
            [-16, -37],
            [-25, 1],
            [-43, -53],
            [-57, -20],
            [-61, -79],
            [-8, -31],
            [-37, -60],
            [-56, -53],
            [-10, -101],
            [-36, 41],
            [7, 74],
            [63, 72],
            [33, 72],
            [52, 80],
            [53, 127],
            [30, -1]
        ],
        [
            [101427, 75449],
            [-57, -39],
            [-47, -17],
            [-80, -82],
            [-28, -44],
            [-40, -18],
            [-39, 10],
            [-29, -79],
            [-78, -88],
            [-32, -69],
            [-34, -12],
            [-62, -71],
            [24, 90],
            [52, 54],
            [4, 58],
            [28, 50],
            [57, 49],
            [39, 66],
            [31, 17],
            [35, 54],
            [35, 20],
            [-4, 41],
            [29, 43],
            [28, -64],
            [83, 11],
            [89, 113],
            [29, 20],
            [32, -6],
            [-6, -103],
            [-59, -4]
        ],
        [
            [101763, 75630],
            [-46, -28],
            [-29, 1],
            [68, 137],
            [40, 20],
            [51, 82],
            [120, 106],
            [63, -2],
            [-99, -110],
            [-12, -44],
            [-42, -47],
            [-54, -36],
            [-60, -79]
        ],
        [
            [66363, 75681],
            [80, -160],
            [35, -52],
            [57, -24],
            [60, 44],
            [25, 7],
            [55, -17],
            [49, 45],
            [37, 3],
            [88, -36],
            [-38, -90],
            [-18, -93],
            [-51, -22],
            [-54, 3],
            [-57, -14],
            [-59, 54],
            [-33, 9],
            [-30, -11],
            [-36, -67],
            [-62, -46],
            [-21, -52],
            [-62, 12],
            [-53, -10],
            [-76, -47],
            [-58, -102],
            [-64, -64],
            [-51, -21],
            [-47, 7],
            [-31, 19],
            [-63, 67],
            [24, 71],
            [25, 126],
            [-17, 106],
            [-50, 51],
            [-41, -10],
            [-23, 13],
            [-83, 86],
            [-45, 6],
            [-50, -17],
            [-31, 42],
            [98, 106],
            [97, 87],
            [43, 9],
            [57, 40],
            [62, 61],
            [-22, 83]
        ],
        [
            [65929, 75883],
            [18, 28],
            [2, 41],
            [45, -6],
            [68, -57],
            [61, -3],
            [40, -22],
            [30, -54],
            [73, 7],
            [33, -48],
            [2, -56],
            [45, -35],
            [17, 3]
        ],
        [[102477, 76330], [-57, -62], [-31, 37], [46, 9], [93, 135], [38, 17], [-89, -136]],
        [[103119, 77385], [14, 64], [24, -26], [-38, -38]],
        [[103344, 77676], [-30, -25], [-32, 15], [1, 48], [65, 149], [18, -45], [-25, -55], [3, -87]],
        [
            [103687, 78228],
            [-40, -56],
            [-85, -31],
            [-37, -58],
            [-48, 29],
            [-7, 114],
            [33, -3],
            [33, 42],
            [76, 18],
            [29, 46],
            [34, 112],
            [37, 41],
            [29, 8],
            [8, -56],
            [-7, -62],
            [-17, -60],
            [-38, -84]
        ],
        [[103836, 78426], [-24, -10], [-49, 52], [14, 29], [50, 43], [35, -10], [-2, -51], [-24, -53]],
        [[103601, 78518], [-28, -6], [-26, 57], [53, -2], [1, -49]],
        [
            [99625, 80510],
            [66, -141],
            [3, -31],
            [-18, -73],
            [-3, -90],
            [55, -170],
            [39, -107],
            [20, -91],
            [12, -95],
            [-1, -195],
            [-18, -75],
            [-20, -20],
            [-8, -52],
            [-6, -148],
            [11, -78],
            [32, -112],
            [8, -89],
            [42, -63],
            [5, -96],
            [19, -29],
            [63, -413],
            [24, -125],
            [72, -215],
            [47, -193],
            [22, -133],
            [49, -145],
            [79, -101],
            [-20, -31],
            [-26, 44],
            [-78, 98],
            [-49, 77],
            [-49, 38],
            [-73, 20],
            [-108, -12],
            [-45, -15],
            [-40, -36],
            [-24, -52],
            [-17, -105],
            [-99, -374],
            [-24, -97],
            [-9, -105],
            [4, -82],
            [35, -112],
            [23, -47],
            [36, -34],
            [44, -94],
            [26, -124],
            [40, -114],
            [70, -2],
            [12, -22],
            [17, -99],
            [13, -119],
            [-23, -73],
            [-27, -5],
            [-21, 142],
            [-21, 46],
            [-73, 19],
            [-67, 7],
            [-43, 59],
            [-35, -6],
            [-30, -31],
            [-23, -50],
            [-31, -110],
            [-30, -150],
            [-40, -96],
            [-36, 54],
            [-41, 244],
            [12, 136],
            [44, 187],
            [9, 61],
            [-17, 116],
            [-6, 134],
            [34, 123],
            [23, 52],
            [10, 62],
            [-14, 154],
            [-33, 105],
            [-41, 99],
            [-9, 53],
            [47, 183],
            [14, 130],
            [24, 144],
            [3, 361],
            [-3, 53],
            [-22, 113],
            [-2, 64],
            [11, 82],
            [33, 123],
            [0, 125],
            [-36, 116],
            [-26, 51],
            [-88, 120],
            [27, 29],
            [-27, 32],
            [-17, 49],
            [-2, 189],
            [7, 48],
            [37, 110],
            [16, 132],
            [6, 137],
            [-11, 56],
            [-5, 112],
            [44, 65],
            [55, 22],
            [54, -50],
            [64, 23],
            [18, 50],
            [-23, 28],
            [13, 36],
            [40, 12],
            [-12, 35],
            [20, 89],
            [-11, 40],
            [-104, 175],
            [67, -1],
            [20, 13],
            [24, 63],
            [21, -12]
        ],
        [[107427, 80605], [-112, 74], [11, 40], [53, -44], [48, -70]],
        [[97902, 80904], [-38, -97], [-81, 46], [62, 46], [57, 5]],
        [
            [98137, 80899],
            [28, -22],
            [43, 4],
            [-48, -89],
            [-8, -44],
            [-83, -88],
            [-18, -6],
            [-42, 96],
            [-20, 27],
            [-57, -45],
            [-1, 55],
            [50, 70],
            [44, 100],
            [112, -58]
        ],
        [[61611, 80546], [47, 48], [58, 114], [9, 96], [41, 19], [89, -3], [38, 25], [49, 60], [69, 102]],
        [[62028, 81003], [-30, -53], [-82, -112], [91, -41], [33, -4], [60, 18], [14, 184]],
        [
            [106998, 80758],
            [-1, -81],
            [-56, 74],
            [-43, 21],
            [-63, 93],
            [-17, 58],
            [-23, 31],
            [-74, 58],
            [55, 32],
            [107, -22],
            [-14, -39],
            [5, -43],
            [48, -89],
            [54, -55],
            [22, -38]
        ],
        [
            [106068, 82857],
            [-51, -53],
            [-13, 39],
            [46, 35],
            [46, 88],
            [18, 73],
            [-7, 47],
            [136, 46],
            [97, 72],
            [35, -64],
            [10, -78],
            [-15, -48],
            [-104, -26],
            [-98, -53],
            [-100, -78]
        ],
        [[66615, 86525], [8, -101], [-88, 52], [-9, 32], [62, 25], [27, -8]],
        [[77172, 87261], [-54, -7], [-60, 42], [-56, 84], [10, 20], [92, -8], [86, -23], [-18, -108]],
        [
            [62, 88620],
            [101, -15],
            [59, -49],
            [126, -39],
            [37, -53],
            [19, -64],
            [138, -44],
            [45, -23],
            [25, -57],
            [48, 31],
            [-130, 78],
            [10, 13],
            [175, -100],
            [85, -65],
            [155, -71],
            [482, -245],
            [32, -88],
            [3, -41],
            [-44, -50],
            [67, 4],
            [47, 40],
            [48, -49],
            [-25, -81],
            [-3, -62],
            [48, -98],
            [4, -74],
            [-31, -33],
            [-17, -57],
            [78, -11],
            [52, -36],
            [43, -106],
            [49, 58],
            [38, 12],
            [21, -51],
            [7, -76],
            [68, 105],
            [-46, 49],
            [-55, 10],
            [-41, 51],
            [53, 33],
            [17, 49],
            [-25, 92],
            [-111, 89],
            [174, 2],
            [63, 21],
            [57, -22],
            [104, -20],
            [-51, -64],
            [-8, -57],
            [54, 7],
            [-17, 58],
            [25, 17],
            [57, -32],
            [100, -9],
            [6, 56],
            [107, -34],
            [75, 5],
            [72, -24],
            [70, -63],
            [65, -79],
            [134, -82],
            [140, -117],
            [69, -26],
            [17, -40],
            [128, -32],
            [15, -48],
            [-31, -33],
            [-54, 20],
            [-48, -15],
            [-117, -79],
            [-7, -117],
            [-32, -19],
            [-71, 12],
            [-69, 29],
            [-5, -37],
            [25, -44],
            [-50, -26],
            [-77, 17],
            [-136, -21],
            [-15, 26],
            [-101, 22],
            [-47, 49],
            [-37, -32],
            [106, -105],
            [-23, -122],
            [23, -88],
            [-58, -46],
            [-60, -32],
            [-125, -17],
            [61, -48],
            [-38, -48],
            [22, -53],
            [113, -37],
            [29, -39],
            [-3, -33],
            [-104, -1],
            [-16, 48],
            [-49, 5],
            [11, -77],
            [-29, -40],
            [-82, -5],
            [-62, 78],
            [-40, -35],
            [-39, -1],
            [-83, 47],
            [-98, 105],
            [-78, 45],
            [-144, 53],
            [-111, -6],
            [-141, 116],
            [7, 53],
            [-29, 138],
            [-52, 66],
            [-140, 43],
            [-157, 36],
            [-37, -6],
            [-97, -55],
            [-65, -8],
            [-188, -2],
            [-60, 29],
            [0, 113],
            [-54, 31],
            [-62, 78],
            [-19, 54],
            [60, -10],
            [16, 61],
            [33, 42],
            [16, 65],
            [-25, 22],
            [-42, -66],
            [-50, -32],
            [-59, 29],
            [0, 64],
            [-72, -33],
            [4, -69],
            [-90, -20],
            [-51, -61],
            [-2, -65],
            [19, -54],
            [112, -93],
            [4, -68],
            [-52, -72],
            [-57, -111],
            [-91, -67],
            [0, 136],
            [0, 137],
            [0, 136],
            [0, 137],
            [0, 136],
            [0, 137],
            [0, 136],
            [0, 137],
            [0, 136],
            [0, 137],
            [0, 136],
            [0, 137],
            [0, 136],
            [0, 136],
            [0, 137],
            [0, 136],
            [62, -24]
        ],
        [
            [71075, 88757],
            [-107, -74],
            [-25, -44],
            [-66, -64],
            [-137, -45],
            [-159, -25],
            [-70, 40],
            [-38, 77],
            [-12, 54],
            [13, 128],
            [29, 42],
            [67, 51],
            [100, 41],
            [84, 1],
            [290, -142],
            [31, -40]
        ],
        [[76346, 88949], [-25, -49], [-73, 23], [59, 51], [39, -25]],
        [
            [105399, 88598],
            [-2, 53],
            [-100, 64],
            [8, 125],
            [-25, 40],
            [9, 36],
            [65, 39],
            [56, 55],
            [35, -26],
            [-24, -87],
            [-58, -37],
            [13, -147],
            [38, -76],
            [-15, -39]
        ],
        [
            [107786, 88977],
            [-88, -5],
            [-176, 52],
            [-62, 27],
            [-110, 69],
            [23, 36],
            [103, 60],
            [50, 4],
            [313, -74],
            [14, -58],
            [-37, -25],
            [-30, -86]
        ],
        [
            [74218, 89175],
            [-3, -117],
            [-69, -21],
            [-59, 16],
            [-65, -11],
            [-73, 23],
            [-23, 72],
            [-111, 31],
            [-59, -17],
            [-84, 89],
            [-64, 120],
            [99, 93],
            [65, 18],
            [94, -58],
            [101, -92],
            [99, -49],
            [152, -97]
        ],
        [[105168, 89670], [-87, 16], [39, 40], [48, -56]],
        [
            [71889, 89972],
            [93, -114],
            [-48, -72],
            [-66, 31],
            [-30, 53],
            [-59, 38],
            [-92, 20],
            [15, 40],
            [148, 24],
            [39, -20]
        ],
        [
            [110768, 89672],
            [-22, -2],
            [-50, 125],
            [81, 103],
            [106, 52],
            [96, 68],
            [140, 51],
            [0, -304],
            [-109, -53],
            [-153, -10],
            [-89, -30]
        ],
        [[98143, 90052], [-77, -47], [-78, 33], [-60, -15], [-57, 26], [62, 43], [166, 5], [44, -45]],
        [
            [347, 90091],
            [161, -27],
            [117, -77],
            [137, -72],
            [2, -53],
            [-92, -56],
            [-218, -29],
            [-194, -42],
            [-108, -9],
            [-70, 27],
            [-82, 12],
            [0, 304],
            [95, 22],
            [90, -6],
            [89, 16],
            [73, -10]
        ],
        [
            [79522, 90489],
            [-150, -5],
            [-74, 8],
            [-1, 38],
            [76, 41],
            [70, 71],
            [62, 36],
            [53, 0],
            [163, -43],
            [27, -40],
            [-110, -50],
            [-70, -47],
            [-46, -9]
        ],
        [[80099, 90729], [-22, -6], [-170, 22], [-59, 29], [-10, 50], [157, 113], [59, -32], [57, -66], [-12, -110]],
        [[78605, 90813], [-70, 19], [-103, 64], [30, 49], [65, 12], [97, -13], [-24, -77], [5, -54]],
        [[92680, 90934], [-78, -25], [-67, 0], [-47, 44], [38, 18], [97, 0], [57, -37]],
        [
            [72635, 91056],
            [144, -22],
            [108, -7],
            [90, -31],
            [-10, -34],
            [-64, -60],
            [-6, -103],
            [-26, -32],
            [-112, -13],
            [-33, -94],
            [-54, -13],
            [-26, -61],
            [13, -85],
            [37, -52],
            [-68, -159],
            [53, -37],
            [44, -100],
            [64, -101],
            [69, -91],
            [127, -132],
            [136, -101],
            [182, -75],
            [43, -35],
            [-55, -38],
            [-93, -40],
            [-153, 32],
            [-43, 46],
            [-77, -8],
            [93, -68],
            [-39, -17],
            [-90, 53],
            [-107, -24],
            [-34, 43],
            [-139, -14],
            [-196, 7],
            [-83, 36],
            [-188, 39],
            [-105, 33],
            [71, 23],
            [-8, 77],
            [83, 10],
            [9, 70],
            [-147, 80],
            [-28, 33],
            [14, 80],
            [-140, -26],
            [-152, 23],
            [-73, -26],
            [-114, 1],
            [-68, 44],
            [-47, 115],
            [1, 88],
            [43, 76],
            [94, 46],
            [113, -13],
            [65, 68],
            [49, 27],
            [39, 102],
            [36, 37],
            [16, 66],
            [-72, 8],
            [-48, 30],
            [88, 77],
            [134, 55],
            [-15, 97],
            [49, 43],
            [122, 38],
            [104, -9],
            [73, 13],
            [147, 49],
            [98, -17],
            [62, -27]
        ],
        [
            [77374, 90937],
            [-91, -26],
            [-142, 20],
            [31, 78],
            [-7, 75],
            [47, 48],
            [62, 18],
            [182, 21],
            [90, -37],
            [111, -92],
            [11, -61],
            [-84, -6],
            [-210, -38]
        ],
        [[79251, 91133], [-161, 16], [5, 45], [156, -61]],
        [[78865, 91139], [20, 46], [111, 19], [38, -14], [-69, -50], [-100, -1]],
        [
            [99447, 91383],
            [140, -51],
            [218, -131],
            [37, -61],
            [8, -119],
            [-92, -14],
            [-108, 13],
            [-155, 5],
            [-66, 16],
            [-164, 16],
            [-127, 44],
            [-161, 35],
            [-83, -9],
            [-113, -42],
            [-75, -3],
            [-31, 39],
            [215, 32],
            [66, 46],
            [89, 118],
            [62, 50],
            [262, 27],
            [78, -11]
        ],
        [[81348, 91482], [-43, -18], [-156, 49], [76, 13], [112, -16], [11, -28]],
        [[81089, 91492], [-30, -19], [-87, 42], [60, 17], [57, -40]],
        [[97599, 91393], [-45, 9], [-201, 152], [70, 10], [126, -72], [69, -59], [-19, -40]],
        [[99084, 91441], [-155, -45], [-100, 48], [-25, 100], [94, 46], [137, 4], [58, -17], [18, -42], [-27, -94]],
        [[81722, 91698], [-15, -34], [-100, 31], [90, 32], [25, -29]],
        [
            [90558, 91665],
            [-40, -71],
            [-86, -43],
            [-61, -56],
            [-181, 28],
            [-170, 71],
            [-43, 44],
            [137, 20],
            [42, 90],
            [268, -39],
            [134, -44]
        ],
        [[82306, 91989], [107, 6], [39, -29], [-61, -61], [-166, 11], [-18, 49], [99, 24]],
        [[80923, 92233], [15, -38], [-175, -35], [-47, 44], [127, 73], [78, 10], [2, -54]],
        [
            [100870, 92206],
            [82, -4],
            [134, 43],
            [289, -15],
            [13, -79],
            [129, -25],
            [59, 19],
            [315, -24],
            [132, -66],
            [90, 31],
            [-54, -118],
            [-98, -43],
            [-226, -53],
            [-169, 0],
            [-233, 16],
            [-63, 14],
            [-143, 74],
            [-149, 22],
            [-136, 65],
            [-172, 47],
            [34, 109],
            [56, 91],
            [96, -26],
            [14, -78]
        ],
        [[97522, 92227], [-153, -11], [43, 105], [7, 105], [171, -89], [-57, -47], [-11, -63]],
        [
            [98787, 92461],
            [106, -18],
            [33, -59],
            [98, -33],
            [40, 39],
            [-6, 92],
            [33, 69],
            [140, 82],
            [79, -16],
            [222, -114],
            [144, -43],
            [80, -7],
            [154, 28],
            [485, -155],
            [32, -31],
            [-104, -23],
            [-92, -69],
            [49, -54],
            [-147, -93],
            [-120, -32],
            [-262, 40],
            [-108, 84],
            [-28, 39],
            [1, 116],
            [83, 64],
            [-19, 30],
            [-120, 4],
            [-144, -34],
            [20, -113],
            [35, -62],
            [109, -119],
            [97, -39],
            [61, -51],
            [-108, -58],
            [-94, -26],
            [-58, 16],
            [-92, 79],
            [-74, -5],
            [-135, -33],
            [-322, -42],
            [-157, 65],
            [-47, -10],
            [-54, -110],
            [-33, -35],
            [-70, -16],
            [-72, 24],
            [-238, 54],
            [-127, 118],
            [-143, 64],
            [-66, 62],
            [-7, 73],
            [95, -10],
            [-23, 115],
            [16, 109],
            [136, 6],
            [-64, 83],
            [38, 44],
            [109, 22],
            [71, 49],
            [187, 47],
            [91, -51],
            [196, -87],
            [94, -69]
        ],
        [[85356, 92712], [-131, -69], [-246, 33], [146, 45], [113, -13], [118, 4]],
        [[90277, 92903], [57, -62], [-40, -33], [-161, 102], [144, -7]],
        [[101597, 92925], [-232, -7], [99, 55], [169, 0], [-36, -48]],
        [
            [76476, 92689],
            [-197, -72],
            [-261, -69],
            [-333, -81],
            [-290, -67],
            [-186, -28],
            [-492, -134],
            [-139, -61],
            [-80, -2],
            [-65, -52],
            [-151, -93],
            [-56, 0],
            [-72, -47],
            [80, -37],
            [-86, -60],
            [-74, -29],
            [-73, 0],
            [2, -60],
            [-48, -13],
            [-110, 44],
            [-43, -104],
            [-53, -25],
            [-122, 21],
            [40, -117],
            [-69, -90],
            [-208, -64],
            [33, -91],
            [-36, -45],
            [-90, -13],
            [24, -49],
            [-126, -86],
            [-53, -77],
            [-102, -34],
            [-62, -4],
            [-123, 27],
            [-149, 6],
            [-168, 54],
            [-73, -2],
            [-145, -55],
            [-52, 72],
            [22, 34],
            [-112, 87],
            [-24, 38],
            [193, 95],
            [79, 13],
            [117, 127],
            [98, 129],
            [228, 35],
            [-41, 34],
            [-88, 8],
            [-24, 39],
            [102, 94],
            [94, 57],
            [87, 33],
            [-49, 32],
            [-106, -6],
            [-58, 68],
            [70, 38],
            [165, -53],
            [94, 81],
            [-20, 47],
            [85, 31],
            [161, -24],
            [54, 93],
            [96, 47],
            [-11, 40],
            [111, 31],
            [143, 76],
            [278, 50],
            [78, 22],
            [76, 62],
            [239, 13],
            [-6, 64],
            [51, 27],
            [181, 5],
            [211, -34],
            [155, 4],
            [171, 40],
            [289, 39],
            [150, 59],
            [77, 8],
            [205, 64],
            [62, 74],
            [236, 99],
            [218, 47],
            [149, -10],
            [145, -32],
            [119, -80],
            [21, -46],
            [-13, -75],
            [-226, -161],
            [-124, -26]
        ],
        [[85279, 93129], [-133, -29], [-134, 46], [134, 23], [208, 60], [10, -43], [-85, -57]],
        [[83189, 93220], [-115, 21], [43, 41], [104, 6], [-32, -68]],
        [[88715, 93250], [-45, 25], [100, 23], [26, -34], [-81, -14]],
        [[96310, 75403], [-2, -90], [29, -59], [-13, -126], [54, -62], [10, -34], [28, -23], [29, 47], [48, 55], [60, 198]],
        [
            [70756, 76017],
            [-33, -30],
            [-14, -52],
            [-84, -50],
            [-39, -8],
            [2, -110],
            [-31, 26],
            [-31, 0],
            [-71, -87],
            [-31, -23],
            [-101, -41],
            [-40, 12],
            [-54, -47],
            [-11, -81],
            [-24, -19],
            [-7, -71],
            [-52, -151],
            [-33, -66],
            [-34, -16],
            [-14, -52],
            [-63, -71],
            [-15, -85],
            [14, -46],
            [51, -19],
            [33, -24],
            [64, -84],
            [23, -50],
            [17, -61],
            [21, -119],
            [11, -126],
            [30, 156],
            [20, -16],
            [-36, -165],
            [-6, -71],
            [7, -91],
            [-15, -103],
            [53, -73],
            [23, -52],
            [5, -72],
            [30, -38],
            [79, -145],
            [46, -96],
            [48, -127],
            [58, -61]
        ],
        [
            [67899, 74391],
            [-32, 29],
            [-110, 143],
            [-58, 94],
            [-189, 218],
            [-25, 17],
            [-100, 31],
            [-40, 25],
            [-102, 156],
            [-45, -21],
            [-41, 5],
            [-50, 36],
            [-39, 95],
            [-25, 37],
            [-80, 55],
            [-91, 31],
            [-9, 33],
            [78, 37],
            [21, 21],
            [-68, 46],
            [45, 31],
            [34, -24],
            [39, -45],
            [34, -17],
            [16, 21],
            [118, 37],
            [7, 62],
            [-18, 43],
            [18, 50],
            [53, 81],
            [28, 112],
            [25, 26],
            [37, -25],
            [15, 51],
            [67, -8],
            [29, 6],
            [-55, 84],
            [-73, 85],
            [-51, 7],
            [-32, 70],
            [-13, 58],
            [62, -10],
            [81, 46],
            [83, -21],
            [-19, 84],
            [59, 33],
            [53, 19],
            [101, 65],
            [44, 12],
            [7, 34],
            [-30, 91],
            [-53, 2],
            [-30, -54],
            [-80, -18],
            [-28, 53],
            [-29, -35],
            [-83, -47]
        ],
        [
            [67355, 76438],
            [-4, 47],
            [24, 56],
            [-24, 25],
            [17, 49],
            [9, 84],
            [26, 28],
            [43, 7],
            [65, 51],
            [32, 69],
            [24, 10],
            [151, -12],
            [107, 6],
            [12, 67],
            [34, 113],
            [23, 39],
            [-29, 28],
            [7, 41],
            [-17, 101],
            [-59, 27],
            [19, 83],
            [27, 38],
            [34, -8],
            [27, 32],
            [-73, 35],
            [-21, 53],
            [63, 31],
            [56, 76],
            [18, 59],
            [-1, 35],
            [-21, 35],
            [11, 62],
            [-19, 30],
            [-78, -14],
            [-98, 87],
            [-49, 8],
            [-40, 63],
            [-45, -21],
            [-34, 4],
            [-83, 71],
            [-61, 7],
            [-59, 49],
            [-25, -15],
            [-5, -40],
            [-36, -19],
            [-106, 106],
            [-30, 59],
            [-7, 42],
            [-49, 67],
            [-25, 4],
            [-65, -37],
            [-44, -7],
            [-71, -27],
            [-43, -46],
            [-37, 40],
            [-60, 0],
            [-59, 72],
            [-69, 15],
            [-67, -50],
            [-26, 12],
            [-14, 40],
            [-41, 56],
            [-6, 39],
            [15, 65],
            [-18, 40],
            [-23, 105],
            [1, 32],
            [-47, 9],
            [-29, 80],
            [-109, -18],
            [-68, 36],
            [-80, 4],
            [15, 38],
            [-23, 60],
            [-2, 75],
            [-25, 70],
            [80, 21],
            [6, 35],
            [-88, 112],
            [-30, 98],
            [-29, 53],
            [-58, 52],
            [-87, -6],
            [-51, 11],
            [-43, -7],
            [-77, -47],
            [-28, -2],
            [-92, 31],
            [-45, -20],
            [-25, -89],
            [-50, -35],
            [-45, -2],
            [-65, 30]
        ],
        [
            [64092, 82529],
            [49, -14],
            [34, -53],
            [58, -20],
            [21, 31],
            [-22, 72],
            [-72, 72],
            [-84, 1],
            [-3, 73],
            [74, 100],
            [-23, 238],
            [-24, 39]
        ],
        [
            [64206, 83348],
            [16, 39],
            [-16, 95],
            [37, 34],
            [62, -52],
            [28, 23],
            [9, 45],
            [91, -4],
            [61, 12],
            [62, 95],
            [161, -24],
            [140, -46],
            [16, 47],
            [-61, 38],
            [-32, 53],
            [-47, 41],
            [-47, 4],
            [-61, -14],
            [-93, 8],
            [-79, 78],
            [-52, 25],
            [-38, 60],
            [31, 5],
            [9, 66],
            [-43, 37],
            [-103, -59],
            [-117, -20]
        ],
        [
            [65088, 89090],
            [55, -7],
            [125, -45],
            [66, 18],
            [37, 52],
            [75, 11],
            [-14, 66],
            [126, -47],
            [53, -35],
            [116, -30],
            [17, -70],
            [-74, -12],
            [-179, 38],
            [-26, -23],
            [74, -43],
            [14, -42],
            [80, 6],
            [191, -35],
            [62, 0],
            [-13, -89],
            [-26, -65],
            [33, -12],
            [77, 101],
            [168, 1],
            [196, -47],
            [96, 1],
            [35, 25],
            [176, -46],
            [234, -105],
            [344, -174],
            [193, -154],
            [23, -34],
            [123, -17],
            [228, -141],
            [79, -7],
            [65, -24],
            [107, -103],
            [44, -23],
            [136, -43],
            [30, -150],
            [22, -32],
            [0, -67],
            [69, -32],
            [-25, -164],
            [-27, -49],
            [-206, -212],
            [-129, -82],
            [-251, -93],
            [-196, -36],
            [-80, -2],
            [-153, 17],
            [-84, 19],
            [-103, 53],
            [-162, 39],
            [-122, 4],
            [-266, 53],
            [-46, 18],
            [-166, 102],
            [-106, -34],
            [-10, 56],
            [-94, 29],
            [-78, 2],
            [-92, 43],
            [-35, -11],
            [-102, 44],
            [-46, 36],
            [-48, 63],
            [26, 37],
            [-164, 37],
            [-61, -22],
            [92, -61],
            [-11, -49],
            [69, -49],
            [74, -69],
            [78, -14],
            [12, -83],
            [135, -49],
            [-28, -68],
            [169, -53],
            [88, -54],
            [91, -99],
            [29, -49],
            [-3, -53],
            [-50, -144],
            [-64, -64],
            [81, -127],
            [41, -101],
            [9, -104],
            [37, -25],
            [-29, -27],
            [3, -82],
            [52, -67],
            [76, -43],
            [46, -9],
            [66, 18],
            [48, -24],
            [107, -82],
            [67, -104],
            [188, -52],
            [145, -53],
            [59, 44],
            [103, 31],
            [32, 43],
            [-29, 101],
            [-8, 63],
            [-65, 43],
            [-96, -13],
            [-76, 20],
            [-44, 45],
            [-84, 109],
            [-45, 36],
            [-30, 54],
            [2, 51],
            [37, -2],
            [41, 29],
            [30, 103],
            [80, 13],
            [119, -48],
            [149, -128],
            [32, -14],
            [92, 2],
            [40, -37],
            [158, -43],
            [159, -80],
            [58, 4],
            [28, 63],
            [65, 45],
            [119, 4],
            [-50, 122],
            [-43, 37],
            [-106, 159],
            [-15, 55],
            [20, 84],
            [158, 85],
            [113, 119],
            [118, 32],
            [124, 57],
            [94, 76],
            [93, 115],
            [39, 30],
            [75, -21],
            [46, -34],
            [195, -3],
            [98, -53],
            [32, -39],
            [-32, -43],
            [90, -18],
            [81, -74],
            [13, 58],
            [-15, 68],
            [38, 96],
            [83, 147],
            [-16, 69],
            [-11, 117],
            [-34, 53],
            [-67, 38],
            [-68, 12],
            [-22, 36],
            [22, 103],
            [56, 129],
            [58, 182],
            [1, 88],
            [-18, 96],
            [-236, 157],
            [21, 40],
            [178, -73],
            [39, -4],
            [278, 20],
            [137, -17],
            [115, -37],
            [82, -105],
            [162, -179],
            [2, -68],
            [-159, -17],
            [-199, -34],
            [-182, -156],
            [0, -71],
            [61, -37],
            [131, -55],
            [59, -110],
            [72, -75],
            [142, -19],
            [75, 3],
            [249, 58],
            [49, 26],
            [17, 39],
            [18, 128],
            [43, 100],
            [-10, 72],
            [309, 82],
            [-56, 80],
            [80, -11],
            [62, 9],
            [239, 108],
            [94, 62],
            [187, 97],
            [153, 29],
            [87, 42],
            [116, 34],
            [42, -3],
            [48, -41],
            [-31, -47],
            [42, -20],
            [108, 49],
            [-37, 92],
            [-64, 9],
            [105, 69],
            [225, 101],
            [120, 46],
            [119, 4],
            [58, -21],
            [-154, -21],
            [29, -46],
            [-24, -24],
            [-41, -93],
            [49, -55],
            [4, -56],
            [-182, -52],
            [-25, -42],
            [218, -22],
            [41, 17],
            [143, 8],
            [48, -49],
            [44, 10],
            [19, 96],
            [71, 59],
            [82, 49],
            [79, 4],
            [114, 41],
            [72, -14],
            [106, -3],
            [89, -29],
            [67, -7],
            [98, 49],
            [225, 138],
            [231, 64],
            [42, 1],
            [17, -61],
            [80, -88],
            [-80, -68],
            [-4, -96],
            [156, -52],
            [38, 0],
            [53, 39],
            [13, 50],
            [-23, 52],
            [9, 57],
            [82, -4],
            [101, 17],
            [46, 32],
            [92, 111],
            [-24, 89],
            [-60, -20],
            [-101, 193],
            [-51, 75],
            [33, 35],
            [87, 22],
            [78, 71],
            [63, 17],
            [233, -49],
            [266, -11],
            [225, -38],
            [256, -78],
            [124, -55],
            [104, -62],
            [31, -31],
            [92, -38],
            [126, -39],
            [24, -30],
            [83, -23],
            [103, -49],
            [105, -32],
            [76, -10],
            [45, -67],
            [151, -97],
            [29, -37],
            [131, -61],
            [66, -50],
            [41, 19],
            [101, 122],
            [96, 214],
            [-67, 3],
            [-50, -21],
            [-68, 27],
            [-58, 56],
            [-73, 94],
            [-14, 103],
            [-21, 33],
            [-117, 58],
            [-173, 61],
            [-81, -19],
            [9, 102],
            [29, 96],
            [44, -5],
            [53, 57],
            [-29, 63],
            [31, 156],
            [12, 133],
            [-44, 55],
            [-99, -22],
            [-37, 12],
            [-11, 45],
            [56, 91],
            [-25, 43],
            [47, 79],
            [192, 73],
            [129, 76],
            [96, 75],
            [62, 94],
            [42, 89],
            [69, 212],
            [64, 155],
            [109, 159],
            [68, 15],
            [10, -47],
            [75, -9],
            [88, 11],
            [149, -6],
            [261, 13],
            [133, -53],
            [52, 6],
            [107, -22],
            [113, -55],
            [-18, -194],
            [-40, -147],
            [-106, -214],
            [-47, -49],
            [-67, -34],
            [-14, -50],
            [66, -84],
            [155, -87],
            [38, -105],
            [8, -78],
            [-10, -204],
            [-71, -101],
            [19, -58],
            [21, -211],
            [5, -172],
            [-18, -59],
            [-9, -166],
            [15, -63],
            [73, -85],
            [117, -61],
            [110, -74],
            [14, -51],
            [-39, -29],
            [-101, -139],
            [10, -116],
            [-6, -60],
            [-63, -94],
            [-109, -61],
            [-231, -323],
            [-55, -38],
            [-94, 12],
            [58, -112],
            [-4, -43],
            [-61, 2],
            [-124, -77],
            [-66, -16],
            [-106, 46],
            [-31, 46],
            [-125, 89],
            [-42, -17],
            [-161, 8],
            [-64, -23],
            [56, -116],
            [67, -38],
            [90, -15],
            [87, -46],
            [110, -33],
            [249, 13],
            [129, -18],
            [109, -49],
            [46, 4],
            [79, 44],
            [29, 128],
            [285, 137],
            [53, 30],
            [86, 75],
            [29, 50],
            [31, 135],
            [28, 48],
            [185, 157],
            [29, 40],
            [6, 73],
            [-14, 98],
            [-34, 81],
            [-75, 113],
            [28, 132],
            [31, 52],
            [168, 62],
            [143, 22],
            [160, 41],
            [109, 2],
            [45, -45],
            [40, -68],
            [116, -101],
            [39, -70],
            [7, -86],
            [-4, -209],
            [-23, -90],
            [125, -75],
            [30, -31],
            [96, -17],
            [289, 17],
            [-26, 23],
            [-86, 5],
            [-123, 22],
            [-177, 41],
            [-21, 88],
            [5, 54],
            [40, 102],
            [102, 39],
            [-27, 124],
            [-38, 83],
            [-42, 152],
            [-56, 1],
            [-43, 30],
            [-211, 88],
            [-199, 66],
            [-136, 9],
            [-43, -7],
            [-113, -69],
            [-74, -14],
            [-139, 30],
            [-119, -16],
            [-63, 46],
            [36, 123],
            [-18, 48],
            [-84, 113],
            [5, 53],
            [78, 208],
            [33, 54],
            [83, 97],
            [43, 74],
            [-10, 42],
            [-179, 231],
            [-69, 109],
            [-111, 68],
            [-19, 33],
            [180, 223],
            [83, 39],
            [115, 24],
            [152, 67],
            [58, 37],
            [30, 66],
            [2, 88],
            [-27, 111],
            [-69, 107],
            [113, 23],
            [67, -31],
            [73, -121],
            [-4, -69],
            [46, -89],
            [-59, -70],
            [-48, -105],
            [-37, -14],
            [-8, -81],
            [79, -88],
            [-11, -67],
            [-58, -58],
            [16, -50],
            [124, -42],
            [116, -26],
            [195, -10],
            [78, -11],
            [184, -8],
            [147, -101],
            [142, -41],
            [128, 12],
            [-109, 33],
            [-62, 52],
            [-54, 100],
            [-94, 32],
            [-132, -6],
            [-113, 54],
            [-75, 21],
            [-173, 83],
            [-86, 175],
            [120, 54],
            [139, 15],
            [59, -16],
            [151, -91],
            [70, -3],
            [126, 40],
            [14, 25],
            [-67, 78],
            [-72, 12],
            [-89, -24],
            [-26, 20],
            [19, 47],
            [81, 21],
            [72, 56],
            [159, 37],
            [290, -8],
            [164, -88],
            [161, -39],
            [89, -36],
            [29, -66],
            [202, -125],
            [46, -17],
            [130, -5],
            [144, 29],
            [135, -6],
            [77, -45],
            [-98, -138],
            [-131, -71],
            [-52, -18],
            [-26, -146],
            [30, -107],
            [-54, -116],
            [30, -31],
            [59, 82],
            [44, 111],
            [85, 37],
            [44, -34],
            [12, -44],
            [-6, -131],
            [-34, -97],
            [-73, -105],
            [53, -63],
            [70, -7],
            [15, 36],
            [-18, 66],
            [131, 39],
            [50, 40],
            [24, 72],
            [-49, 122],
            [-75, 124],
            [-57, 65],
            [36, 96],
            [94, 177],
            [-11, 50],
            [-60, 80],
            [-44, 27],
            [-171, 28],
            [-101, 81],
            [-41, 93],
            [-121, 49],
            [-157, 18],
            [-57, 18],
            [-84, 55],
            [-53, 124],
            [57, 133],
            [-26, 42],
            [-76, 34],
            [-35, 151],
            [62, 65],
            [-4, 53],
            [380, 50],
            [534, 5],
            [37, 11],
            [232, 20],
            [99, 22],
            [105, -24],
            [114, 9],
            [51, 48],
            [302, 41],
            [93, -4],
            [42, -36],
            [-204, -113],
            [-84, -24],
            [-83, -47],
            [-3, -93],
            [48, 11],
            [-10, 61],
            [66, 44],
            [69, 19],
            [229, 26],
            [77, 78],
            [63, 31],
            [-112, 38],
            [-158, 176],
            [-39, 27],
            [-176, 41],
            [56, 59],
            [66, 15],
            [83, -20],
            [72, -49],
            [102, 21],
            [-163, 89],
            [-181, 59],
            [-100, 9],
            [28, 53],
            [55, -6],
            [44, 49],
            [139, -75],
            [65, 20],
            [172, 124],
            [15, 40],
            [-101, 33],
            [-63, -2],
            [21, 57],
            [51, 12],
            [154, -35],
            [257, 90],
            [71, 44],
            [178, 56],
            [88, -6],
            [182, 74],
            [253, 32],
            [147, 0],
            [113, 42],
            [173, 14],
            [61, 16],
            [292, 42],
            [-115, 59],
            [-22, 37],
            [47, 41],
            [120, -25],
            [140, 39],
            [125, -9],
            [22, 24],
            [142, -21],
            [99, 14],
            [174, -14],
            [48, -18],
            [-28, -40],
            [-103, -65],
            [264, 63],
            [-3, -64],
            [118, 22],
            [100, 49],
            [91, -21],
            [53, 54],
            [306, 92],
            [162, -36],
            [116, -38],
            [81, 14],
            [-64, 59],
            [-251, 134],
            [20, 16],
            [218, -21],
            [111, 10],
            [119, -6],
            [161, 25],
            [67, -26],
            [193, 4],
            [-234, 40],
            [53, 82],
            [-55, 66],
            [21, 94],
            [61, 21],
            [102, 95],
            [338, 173],
            [160, 66],
            [133, 3],
            [140, 54],
            [53, 1],
            [194, -44],
            [46, -32],
            [287, -59],
            [51, -55],
            [-100, -22],
            [-108, -63],
            [-146, -35],
            [-182, -24],
            [-37, -17],
            [345, -5],
            [101, 4],
            [20, -55],
            [193, 26],
            [114, -19],
            [73, 11],
            [104, -24],
            [46, -36],
            [-151, -109],
            [-93, -88],
            [-69, -34],
            [127, -18],
            [102, 25],
            [144, -8],
            [86, 33],
            [39, 83],
            [188, 1],
            [226, 16],
            [189, -20],
            [151, 26],
            [199, -20],
            [207, -67],
            [95, -69],
            [162, -53],
            [20, -92],
            [35, -50],
            [77, -9],
            [70, 77],
            [48, -78],
            [42, -123],
            [94, -20],
            [-77, -146],
            [-71, 47],
            [-81, 12],
            [-154, 76],
            [101, -147],
            [89, 22],
            [34, -43],
            [115, -47],
            [-35, -88],
            [-213, -155],
            [-226, -90],
            [-100, -63],
            [-176, -45],
            [-125, -62],
            [-160, -46],
            [-46, -48],
            [-119, -32],
            [22, -34],
            [-31, -51],
            [-92, -45],
            [-135, -31],
            [-270, -189],
            [-134, -39],
            [-153, -2],
            [-32, -17],
            [-150, -145],
            [-152, -12],
            [-158, -195],
            [-88, -66],
            [98, -2],
            [110, 63],
            [44, 62],
            [83, 44],
            [195, 21],
            [198, -3],
            [78, 35],
            [336, 80],
            [74, 61],
            [95, -19],
            [67, 10],
            [177, 88],
            [106, 33],
            [-16, 51],
            [-103, -30],
            [-91, -10],
            [-105, 8],
            [-27, 43],
            [63, 73],
            [121, 48],
            [246, -43],
            [23, 63],
            [129, -14],
            [-99, -33],
            [53, -79],
            [124, -46],
            [106, -20],
            [200, 21],
            [74, 93],
            [46, -42],
            [72, -106],
            [-80, -105],
            [37, -38],
            [66, -25],
            [-5, -166],
            [21, 3],
            [5, 100],
            [101, 63],
            [-107, 49],
            [-9, 39],
            [107, 16],
            [63, 29],
            [233, 12],
            [161, 54],
            [357, -15],
            [251, -43],
            [353, -5],
            [130, -29],
            [20, -32],
            [-148, -9],
            [-25, -54],
            [17, -68],
            [163, -72],
            [144, -29],
            [100, -48],
            [262, 1],
            [123, -24],
            [110, 19],
            [164, -6],
            [45, -35],
            [71, -10],
            [133, 6],
            [-59, 45],
            [35, 32],
            [169, -41],
            [43, 26],
            [50, 79],
            [49, 28],
            [-73, 86],
            [-25, 103],
            [58, 74],
            [94, -22],
            [69, 48],
            [114, 24],
            [126, -24],
            [253, -107],
            [-6, -41],
            [203, 57],
            [28, -24],
            [-27, -48],
            [91, -47],
            [88, 55],
            [59, 63],
            [219, -37],
            [167, -84],
            [-7, -35],
            [102, -3],
            [93, -40],
            [7, -44],
            [44, -37],
            [-141, -84],
            [129, -12],
            [66, -54],
            [6, -39],
            [-190, -87],
            [-26, -30],
            [175, -6],
            [51, -27],
            [40, -68],
            [0, -83],
            [-39, -41],
            [-108, -7],
            [-142, 92],
            [-86, 36],
            [-121, 69],
            [12, -70],
            [57, -32],
            [102, -90],
            [171, -186],
            [40, 15],
            [52, 75],
            [77, -99],
            [-70, 3],
            [-88, -21],
            [-32, -24],
            [24, -35],
            [66, -5],
            [193, -264],
            [82, -30],
            [79, -66],
            [119, -32],
            [51, 26],
            [20, -74],
            [80, -34],
            [85, 48],
            [40, 41],
            [106, 168],
            [40, 23],
            [-10, 59],
            [69, 163],
            [104, 141],
            [175, -161],
            [91, -64],
            [81, -32],
            [128, -31],
            [185, 4],
            [35, 42],
            [64, 30],
            [104, 16],
            [62, 37],
            [100, 11],
            [161, -33],
            [219, -86],
            [62, -32],
            [103, -84],
            [60, 10],
            [76, 45],
            [-53, 43],
            [62, 101],
            [61, 21],
            [64, -22],
            [45, 40],
            [103, -44],
            [63, -62],
            [131, 25],
            [109, 1],
            [-14, 37],
            [-76, 79],
            [9, 103],
            [-112, 37],
            [86, 26],
            [64, 84],
            [89, 34],
            [-160, 9],
            [-57, -34],
            [-79, 0],
            [-11, 92],
            [142, 93],
            [263, -2],
            [194, 53],
            [-33, 72],
            [-99, 70],
            [48, 27],
            [155, -18],
            [64, -39],
            [168, -38],
            [449, -12],
            [51, -14],
            [192, -17],
            [82, -19],
            [283, -37],
            [70, -25],
            [166, -31],
            [-5, -52],
            [-237, 7],
            [-79, 17],
            [-134, -5],
            [-59, -43],
            [-69, -23],
            [-21, -40],
            [54, -10],
            [176, 47],
            [480, 24],
            [73, -4],
            [-7, -33],
            [-126, -112],
            [-89, -50],
            [-33, 0],
            [70, 107],
            [-56, 3],
            [-105, 35],
            [-14, -77],
            [28, -70],
            [-108, -29],
            [-86, 21],
            [-42, -97],
            [61, -32],
            [190, 28],
            [83, 35],
            [91, 63],
            [163, 153],
            [71, 53],
            [95, 27],
            [299, -16],
            [174, -33],
            [165, -49],
            [82, -41],
            [61, -55],
            [16, -54],
            [-42, -29],
            [-185, -10],
            [-72, -17],
            [-38, -45],
            [177, -28],
            [111, -35],
            [63, -50],
            [166, 5],
            [21, -36],
            [-131, -105],
            [224, 63],
            [55, -4],
            [135, -48],
            [54, -39],
            [103, -108],
            [-102, -23],
            [230, -83],
            [90, 1],
            [204, 24],
            [103, 1],
            [192, 53],
            [190, 33],
            [174, 2],
            [93, 32],
            [243, -1],
            [236, -11],
            [182, -19],
            [205, -58],
            [200, -81],
            [117, -79],
            [57, -80],
            [29, -109],
            [-7, -49],
            [-47, -78],
            [2, -51],
            [-34, -67],
            [32, -48],
            [88, -30],
            [192, -42],
            [53, -27],
            [38, -284],
            [85, -64],
            [10, -43],
            [-66, -140],
            [31, 0],
            [42, 94],
            [62, 46],
            [0, 88],
            [-26, 77],
            [17, 99],
            [126, 93],
            [133, 58],
            [176, 18],
            [79, 18],
            [91, -12],
            [139, 24],
            [66, -9],
            [109, -62],
            [385, -14],
            [68, -21],
            [259, -26],
            [78, 31],
            [171, 103],
            [100, -23],
            [61, -67],
            [48, -171],
            [198, -60],
            [113, -47],
            [32, -89],
            [60, -75],
            [141, 7],
            [145, 15],
            [142, 123],
            [0, 50],
            [-35, 72],
            [-52, 69],
            [-41, 109],
            [-130, 24],
            [106, 128],
            [-5, 140],
            [234, -17],
            [224, -43],
            [181, -17],
            [96, -28],
            [126, -53],
            [50, 69],
            [157, -41],
            [115, 4],
            [143, -14],
            [158, 2],
            [141, 25],
            [110, -25],
            [93, -51],
            [159, -68],
            [145, -19],
            [166, -65],
            [157, -24],
            [126, -36],
            [31, -51],
            [99, -21],
            [184, -137],
            [41, -17],
            [0, -2183],
            [-53, -19],
            [-55, -63],
            [-62, -55],
            [-92, -22],
            [-140, -84],
            [-55, -16],
            [-72, 39],
            [-166, 25],
            [-51, 33],
            [-125, 132],
            [-92, 38],
            [-72, -42],
            [121, -4],
            [57, -77],
            [-48, -42],
            [-73, 35],
            [-124, 4],
            [-114, 59],
            [-86, -66],
            [24, -10],
            [61, 44],
            [59, -34],
            [32, -77],
            [117, -45],
            [35, 5],
            [63, 48],
            [105, 30],
            [24, -20],
            [-17, -92],
            [7, -71],
            [78, -78],
            [82, -46],
            [55, 7],
            [31, 72],
            [46, -58],
            [30, -74],
            [-8, -65],
            [61, -26],
            [25, -166],
            [-89, -34],
            [82, -47],
            [25, -44],
            [40, -24],
            [34, -65],
            [94, -52],
            [22, -62],
            [-45, -39],
            [38, -70],
            [40, -11],
            [18, -98],
            [-28, -42],
            [-93, -80],
            [-17, -83],
            [-340, 127],
            [-110, 20],
            [-97, 2],
            [-17, 32],
            [20, 52],
            [-104, 22],
            [-18, -47],
            [13, -37],
            [47, -37],
            [-141, -30],
            [-82, -53],
            [-33, -36],
            [-221, -91],
            [-53, -31],
            [-54, -14],
            [-23, -38],
            [-122, -53],
            [-25, 5],
            [-62, -70],
            [-116, -16],
            [-98, -64],
            [-61, 20],
            [-72, -89],
            [-80, -83],
            [-85, 35],
            [-15, -19],
            [31, -69],
            [-55, 1],
            [-10, -36],
            [-35, -33],
            [-58, -13],
            [-1, -59],
            [-55, -35],
            [-46, -46],
            [-73, -44],
            [-31, 4],
            [-74, -66],
            [-167, -113],
            [-105, -49],
            [-6, -51],
            [-24, -47],
            [-27, -118],
            [-22, -46],
            [-61, 12],
            [-53, 45],
            [-26, 45],
            [-4, 39],
            [-82, 123],
            [-106, 66],
            [-15, 22],
            [-172, -19],
            [-64, 17],
            [-101, -11],
            [-120, -36],
            [-37, -22],
            [-124, -35],
            [-81, -55],
            [-158, -201],
            [-37, -42],
            [-45, -12],
            [-15, 72],
            [66, 282],
            [-53, -3],
            [-73, -69],
            [-111, -67],
            [-52, -17],
            [-40, -39],
            [-62, -21],
            [-3, -85],
            [-17, -47],
            [-51, -11],
            [-23, 18],
            [-34, 69],
            [-44, 36],
            [-46, -2],
            [-75, -41],
            [-69, 29],
            [-41, 2],
            [-114, -115],
            [-27, -72],
            [-16, -103],
            [1, -121],
            [-58, -96],
            [-45, -9],
            [20, -53],
            [-48, -45],
            [-63, -78],
            [-59, -51],
            [-96, -145],
            [-56, -207],
            [24, -88],
            [49, -50],
            [83, -35],
            [17, 77],
            [61, 23],
            [131, -60],
            [25, -27],
            [-3, -57],
            [-33, -68],
            [-101, -116],
            [-6, -63],
            [17, -123],
            [-4, -118],
            [37, -50],
            [38, 11],
            [65, -30],
            [-4, -69],
            [15, -65],
            [13, -120],
            [-89, -105],
            [-64, 12],
            [-65, 93],
            [26, 55],
            [81, 66],
            [-94, 22],
            [-56, -50],
            [12, -77],
            [-118, -74],
            [-19, -22],
            [-49, -139],
            [-46, -103],
            [-16, -89],
            [2, -77],
            [29, -122],
            [53, -79],
            [26, -62],
            [8, -75],
            [-43, -35],
            [-75, -87],
            [-31, -9],
            [-102, 2],
            [-51, 44],
            [-110, -32],
            [-79, -62],
            [-70, -79],
            [-66, -55],
            [-47, -101],
            [-25, -126],
            [9, -61],
            [26, -68],
            [-18, -95],
            [32, -59],
            [7, -81],
            [-23, -3],
            [-55, 59],
            [-57, 4],
            [-139, -67],
            [-57, -39],
            [-64, -77],
            [-32, 59],
            [-52, 10],
            [-12, -42],
            [39, -20],
            [15, -27],
            [-23, -103],
            [-16, -35],
            [6, -92],
            [-12, -87],
            [-40, -119],
            [-71, -157],
            [-86, -114],
            [-90, -70],
            [-13, -40],
            [-89, -109],
            [-109, -115],
            [-31, -21],
            [-24, 144],
            [-39, 47],
            [-13, 91],
            [-4, 244],
            [-34, 253],
            [-4, 80],
            [-42, 65],
            [-37, 134],
            [-3, 78],
            [-46, 411],
            [-14, 103],
            [-62, 331],
            [-26, 191],
            [-18, 187],
            [-2, 83],
            [27, 248],
            [23, 155],
            [82, 348],
            [26, 48],
            [142, 134],
            [62, 73],
            [77, 175],
            [-9, 83],
            [-49, 74],
            [60, 46],
            [72, -30],
            [72, 12],
            [66, 123],
            [96, -19],
            [72, 22],
            [147, 143],
            [108, 80],
            [54, 53],
            [30, 51],
            [88, 107],
            [79, 181],
            [155, 149],
            [61, 85],
            [95, 44],
            [112, 122],
            [71, 102],
            [94, 69],
            [29, 45],
            [48, 105],
            [81, 65],
            [138, 68],
            [80, 69],
            [117, 10],
            [111, 65],
            [-48, 60],
            [20, 48],
            [84, 72],
            [35, 58],
            [-10, 42],
            [-52, 23],
            [24, 100],
            [42, 39],
            [15, 91],
            [2, 96],
            [41, 138],
            [25, 30],
            [96, 69],
            [162, -33],
            [84, 46],
            [-108, 13],
            [-78, 30],
            [-70, 58],
            [-45, 17],
            [-51, -5],
            [-285, -81],
            [-27, -53],
            [18, -46],
            [-43, -64],
            [-14, -59],
            [4, -58],
            [-35, -88],
            [-2, -56],
            [76, -51],
            [-53, -72],
            [-50, 15],
            [-21, 60],
            [-48, -29],
            [-95, 5],
            [-63, -67],
            [-355, -323],
            [-38, -39],
            [-46, -77],
            [-87, -8],
            [-96, -57],
            [16, 108],
            [48, 108],
            [-60, 13],
            [-56, -23],
            [-37, -36],
            [-29, 8],
            [49, 96],
            [-20, 91],
            [86, 137],
            [48, 142],
            [-3, 57],
            [-39, 4],
            [-142, -80],
            [-52, -22],
            [-80, 109],
            [-67, 4],
            [-78, -40],
            [-86, -22],
            [-66, 8],
            [-81, -40],
            [-84, 23],
            [-101, 3],
            [-31, -29],
            [-88, -40],
            [-60, -62],
            [-65, -47],
            [-16, -116],
            [-88, -65],
            [-89, -89],
            [-62, -122],
            [-43, -53],
            [-89, -74],
            [-141, -97],
            [-121, -157],
            [-42, -117],
            [-46, -28],
            [-7, -98],
            [-37, -72],
            [19, -26],
            [45, -1],
            [70, 33],
            [120, -50],
            [60, -50],
            [-2, -95],
            [-104, -2],
            [-37, -25],
            [-76, 42],
            [-65, -61],
            [-73, -18],
            [-37, 22],
            [-60, 61],
            [-103, -5],
            [-28, -69],
            [-60, -5],
            [-60, -80],
            [-95, 8],
            [-54, 41],
            [-73, -17],
            [-23, -48],
            [-119, -24],
            [-116, 4],
            [-64, 116],
            [119, 45],
            [70, -9],
            [79, 7],
            [84, 36],
            [-48, 37],
            [-50, -4],
            [-45, 22],
            [-96, 112],
            [-98, 33],
            [-58, -7],
            [-36, -53],
            [-42, -4],
            [-58, 32],
            [-26, 36],
            [-251, 100],
            [-68, -5],
            [-41, -18],
            [-69, -55],
            [43, -79],
            [-87, -7],
            [-39, 32],
            [-27, -47],
            [10, -42],
            [45, 15],
            [24, -17],
            [-16, -48],
            [-58, -14],
            [-73, 2],
            [-72, 85],
            [-118, -15],
            [-58, -54],
            [-53, -12],
            [-147, 54],
            [-72, 4],
            [-83, 47],
            [-28, -15],
            [-53, -117],
            [-69, -28],
            [-37, 16],
            [-31, 73],
            [-23, 24],
            [-62, 22],
            [-331, -20],
            [-111, 18],
            [-78, 1],
            [-107, -37],
            [-102, 14],
            [-189, -72],
            [-77, -49],
            [-94, -85],
            [-84, -142],
            [-47, -54],
            [-79, -67],
            [-111, -62],
            [-61, -63],
            [-32, -51],
            [-59, -194],
            [-15, -29],
            [-137, -70],
            [-43, -77],
            [-75, -52],
            [-54, -70],
            [-81, -38],
            [-67, -97],
            [-94, -68],
            [-137, -188],
            [-44, -109],
            [-118, -164],
            [-37, -15],
            [-58, -77],
            [-60, -46],
            [-122, -110],
            [-103, -66],
            [-34, -37],
            [-54, -88],
            [-131, -107],
            [-65, -26],
            [-86, -95],
            [-16, -57],
            [15, -61],
            [183, -82],
            [119, 16],
            [173, 4],
            [7, -94],
            [-15, -55],
            [-13, -163],
            [-14, -72],
            [11, -71],
            [26, -13],
            [25, 32],
            [41, 5],
            [42, -14],
            [32, 113],
            [-50, 58],
            [14, 30],
            [73, 55],
            [89, 1],
            [-47, -71],
            [-54, -31],
            [88, -72],
            [65, -14],
            [-59, -45],
            [-39, -88],
            [-91, -72],
            [33, -22],
            [126, 12],
            [66, 24],
            [93, 68],
            [39, 102],
            [35, 29],
            [23, -7],
            [1, -72],
            [-86, -126],
            [-13, -38],
            [62, 7],
            [19, 18],
            [46, 98],
            [19, 166],
            [-8, 154],
            [126, -57],
            [66, -13],
            [120, 47],
            [146, -126],
            [19, -28],
            [33, -105],
            [105, -121],
            [98, -57],
            [3, -22],
            [62, -67],
            [48, -23],
            [9, -61],
            [-23, -48],
            [-45, -46],
            [-91, 42],
            [-4, -28],
            [66, -80],
            [52, -32],
            [3, -104],
            [-6, -57],
            [-35, -64],
            [12, -38],
            [97, -106],
            [-31, -67],
            [-6, -76],
            [-33, -34],
            [-40, -74],
            [-61, -60],
            [-29, -115],
            [-46, -101],
            [-6, -101],
            [-46, -140],
            [-14, -142],
            [19, -231],
            [27, -27],
            [-50, -96],
            [1, -48],
            [14, -35],
            [2, -92],
            [-27, -148],
            [-20, -62],
            [-17, -93],
            [21, -50],
            [-47, -106],
            [-17, -139],
            [-18, -57],
            [-35, -55],
            [-73, -80],
            [-26, -50],
            [-94, -113],
            [-64, -141],
            [-51, -140],
            [-128, -182],
            [-26, -93],
            [-34, -81],
            [-17, -113],
            [-39, -44],
            [-32, -119],
            [-104, -179],
            [-26, -62],
            [-80, -99],
            [-86, -138],
            [-106, -124],
            [-21, -51],
            [-41, -56],
            [-44, -87],
            [-65, -87],
            [-13, -58],
            [-20, -41],
            [-48, -27],
            [-35, -37],
            [-105, -225],
            [-16, -76],
            [-69, -84],
            [-39, -88],
            [-66, -55],
            [-70, -76],
            [-165, -139],
            [-45, -53],
            [-93, -65],
            [-38, -1],
            [-80, -36],
            [-52, -37],
            [-31, 14],
            [-19, 48],
            [-41, -8],
            [-48, 45],
            [-41, -2],
            [-29, 21],
            [-55, -14],
            [9, 198],
            [-31, 3],
            [-63, -70],
            [-50, -13],
            [10, 42],
            [35, 61],
            [-23, 12],
            [-44, -26],
            [-23, -29],
            [-63, -115],
            [-38, -97],
            [-31, -28],
            [-42, -82],
            [-65, 5],
            [-59, 22],
            [-14, -10],
            [38, -74],
            [-32, -110],
            [-13, -13]
        ],
        [[88801, 93745], [-214, -20], [-129, 40], [285, 12], [58, -32]],
        [
            [87316, 94371],
            [-43, -82],
            [-92, -128],
            [43, -3],
            [113, 102],
            [223, 53],
            [78, -15],
            [51, -61],
            [96, -20],
            [15, -55],
            [214, -34],
            [61, -125],
            [-9, -52],
            [-148, -83],
            [-166, -9],
            [-178, -43],
            [-221, -2],
            [-254, -28],
            [-301, -7],
            [-51, -27],
            [-296, -94],
            [-179, 0],
            [-66, 35],
            [80, 78],
            [146, 90],
            [73, 131],
            [9, 59],
            [103, 65],
            [79, -7],
            [8, 109],
            [91, 125],
            [107, 28],
            [15, 54],
            [72, 11],
            [56, -60],
            [76, -4],
            [-22, 66],
            [69, 33],
            [119, -23],
            [95, -52],
            [-66, -25]
        ],
        [[79095, 94592], [343, -52], [70, -31], [-290, -5], [-4, 29], [-149, 19], [30, 40]],
        [
            [84168, 94611],
            [-164, 0],
            [-317, 123],
            [-17, 43],
            [109, 37],
            [231, -2],
            [130, -27],
            [373, -51],
            [-61, -49],
            [-210, -63],
            [-74, -11]
        ],
        [[71428, 94756], [-295, -11], [-112, 31], [261, 63], [98, -25], [48, -58]],
        [[73983, 94762], [-110, -18], [-127, 34], [8, 33], [185, 42], [79, -20], [34, -49], [-69, -22]],
        [
            [85708, 94875],
            [106, -75],
            [-80, -71],
            [184, -7],
            [75, 94],
            [215, -20],
            [133, -54],
            [104, -79],
            [-87, -83],
            [-31, -170],
            [-44, -26],
            [-114, 16],
            [108, -98],
            [92, -19],
            [35, -75],
            [-151, -71],
            [-318, -26],
            [-110, 19],
            [-154, 3],
            [-192, 60],
            [-38, 28],
            [-143, 17],
            [-170, -8],
            [-82, 54],
            [-122, -27],
            [-149, 43],
            [-104, 101],
            [-30, 53],
            [-142, 27],
            [-150, 4],
            [-62, 21],
            [103, 76],
            [137, 39],
            [126, 71],
            [28, 63],
            [198, 86],
            [90, -37],
            [67, 42],
            [284, -1],
            [217, 27],
            [171, 3]
        ],
        [[71009, 94828], [-153, 48], [101, 39], [134, -32], [-82, -55]],
        [[73178, 94983], [0, -143], [-29, -13], [-242, 3], [-148, 15], [89, 56], [4, 76], [195, -6], [131, 12]],
        [
            [72080, 94890],
            [-206, -6],
            [-158, 22],
            [-40, 28],
            [144, 31],
            [54, 46],
            [102, 6],
            [93, -50],
            [113, -30],
            [-102, -47]
        ],
        [
            [73449, 94856],
            [-175, 9],
            [-34, 30],
            [-64, 167],
            [434, -16],
            [152, -27],
            [88, -41],
            [-265, -13],
            [-44, -66],
            [-92, -43]
        ],
        [[72356, 95051], [-43, -29], [-144, 30], [20, 72], [164, -36], [3, -37]],
        [
            [70203, 95263],
            [141, -23],
            [169, -4],
            [74, -49],
            [-19, -49],
            [-179, 22],
            [-137, 41],
            [-91, -76],
            [-194, -25],
            [-50, -48],
            [-115, -16],
            [-54, 68],
            [-101, -18],
            [-152, 35],
            [-7, 30],
            [517, 57],
            [68, 33],
            [130, 22]
        ],
        [
            [74748, 95252],
            [19, -22],
            [-47, -99],
            [-122, -17],
            [-194, -94],
            [-239, 43],
            [-194, -36],
            [-106, 51],
            [25, 106],
            [63, 58],
            [156, 18],
            [119, -25],
            [344, 50],
            [176, -33]
        ],
        [
            [71079, 95304],
            [161, -7],
            [279, -127],
            [-173, -46],
            [-57, -36],
            [-344, -24],
            [-80, -67],
            [-213, -4],
            [-68, -39],
            [103, -51],
            [-168, -55],
            [-162, -12],
            [-95, 13],
            [106, 56],
            [-164, 10],
            [-140, -26],
            [-107, 65],
            [312, 112],
            [231, 38],
            [68, -34],
            [143, 5],
            [30, 23],
            [-11, 86],
            [29, 61],
            [82, 24],
            [238, 35]
        ],
        [[80261, 95260], [-287, -20], [-37, 20], [74, 62], [182, 9], [192, -27], [-124, -44]],
        [[74431, 95317], [-96, -12], [-238, 31], [163, 57], [269, 9], [34, -29], [-132, -56]],
        [
            [72449, 95409],
            [232, -53],
            [216, 5],
            [471, -132],
            [-36, -21],
            [-236, -51],
            [-154, -17],
            [-186, 2],
            [-53, 37],
            [-131, 27],
            [-138, -7],
            [-186, 42],
            [-7, 32],
            [100, 18],
            [15, 46],
            [93, 72]
        ],
        [
            [73654, 95368],
            [87, -81],
            [-14, -65],
            [-177, -9],
            [-107, 16],
            [-58, 54],
            [-107, 14],
            [-60, 57],
            [138, 8],
            [121, 49],
            [177, -43]
        ],
        [[71225, 95371], [-119, 42], [158, 16], [-39, -58]],
        [
            [75121, 95177],
            [-115, 7],
            [-149, 61],
            [184, 81],
            [303, 18],
            [66, 98],
            [152, 13],
            [114, -30],
            [65, -49],
            [17, -70],
            [-136, -62],
            [-139, -36],
            [-362, -31]
        ],
        [[83823, 95423], [-106, -43], [-385, 28], [29, 56], [434, -17], [28, -24]],
        [
            [85354, 95387],
            [70, -66],
            [204, -65],
            [129, -24],
            [7, -56],
            [-196, -25],
            [-60, -65],
            [69, -97],
            [52, -22],
            [-75, -46],
            [-407, -35],
            [-399, -29],
            [-213, -64],
            [-68, -1],
            [-201, 52],
            [-247, 43],
            [-174, 50],
            [-35, 50],
            [115, 66],
            [210, 31],
            [211, 144],
            [-207, -6],
            [54, 63],
            [92, 53],
            [332, 56],
            [146, 14],
            [138, 41],
            [31, 47],
            [198, 5],
            [224, -114]
        ],
        [[73867, 95515], [-183, 4], [-26, 26], [136, 21], [73, -51]],
        [
            [73403, 95649],
            [64, -35],
            [130, -11],
            [-20, -43],
            [-159, -10],
            [49, -63],
            [-32, -32],
            [-142, -35],
            [-195, 57],
            [-95, -35],
            [-99, 27],
            [-147, -19],
            [-77, 68],
            [213, -4],
            [77, 46],
            [97, 21],
            [115, 65],
            [221, 3]
        ],
        [[75206, 95684], [-236, 0], [-186, 54], [158, 7], [282, -17], [-18, -44]],
        [[73553, 95743], [-119, 4], [70, 59], [347, 15], [30, -53], [-328, -25]],
        [
            [64977, 49586],
            [-12, -36],
            [11, -43],
            [38, -88],
            [25, -17],
            [31, -92],
            [5, -73],
            [-7, -88],
            [4, -65],
            [14, -43],
            [4, -55],
            [-15, -109],
            [-85, -34]
        ],
        [[64467, 48817], [16, 8], [26, 40], [25, 9], [23, 37], [41, 102], [23, 44], [-42, 184]],
        [[64689, 49407], [77, 29], [17, -64], [33, 2], [35, 44], [55, 106], [25, 58], [46, 4]],
        [[50297, 61782], [-15, 28], [29, 315]],
        [
            [68520, 59501],
            [22, 49],
            [34, -53],
            [-1, -62],
            [-29, 42],
            [-34, -10],
            [-20, 17],
            [-30, 52],
            [-8, 38],
            [53, 50],
            [0, -104],
            [13, -19]
        ],
        [[66950, 64334], [-8, 0], [-48, 84], [8, 14], [55, -74], [-7, -24]],
        [
            [70512, 66096],
            [17, -53],
            [8, -52],
            [32, -124],
            [45, -97],
            [18, -88],
            [-11, -43],
            [34, -53],
            [102, -76],
            [-19, -30],
            [71, -144],
            [41, -16],
            [55, -109],
            [83, -71],
            [51, -93],
            [-44, 9],
            [6, -84],
            [49, -68],
            [9, -54],
            [-18, -116],
            [-39, 6],
            [31, -148],
            [18, -50],
            [15, -74],
            [14, -32],
            [53, -79],
            [17, -66],
            [15, -122],
            [34, -69],
            [18, -52],
            [24, -45]
        ],
        [[71384, 63901], [46, -42], [-14, -30], [-19, -76], [80, -31]],
        [
            [71603, 60773],
            [-222, -54],
            [-279, -68],
            [-189, -46],
            [-170, -41],
            [-46, -22],
            [-268, -237],
            [-183, -395],
            [-43, -188],
            [-59, -66],
            [-33, -26],
            [-52, 4],
            [-61, 144],
            [-29, 32],
            [-115, -21],
            [-239, 39],
            [-40, 10],
            [-53, 48],
            [-27, 12],
            [-124, 2],
            [-62, -15],
            [-59, 6],
            [-61, -9],
            [-22, -18],
            [-24, 1],
            [-28, -24],
            [-63, 23],
            [-36, 59],
            [-55, 25],
            [-36, -34],
            [-34, -54],
            [14, -52],
            [-25, -34],
            [-12, -147],
            [9, -53],
            [12, -19],
            [-6, -68],
            [-19, -14],
            [-22, -64],
            [-72, -99]
        ],
        [
            [68770, 59310],
            [-3, 44],
            [-18, 66],
            [-10, 93],
            [-16, 36],
            [-29, 37],
            [-3, 51],
            [-21, 51],
            [-28, 40],
            [-16, 75],
            [-12, 99],
            [-74, 131],
            [-94, 121],
            [-28, 68],
            [-47, 138],
            [-23, 110],
            [-62, 126],
            [-3, 48],
            [-32, 177],
            [-63, 227],
            [-38, 87],
            [-10, 61],
            [-44, 37],
            [-41, 96],
            [-124, 152],
            [-61, 15],
            [-48, 54],
            [-35, 71],
            [-38, 122],
            [-66, 133],
            [-57, 187],
            [18, 68],
            [-1, 48],
            [-18, 81],
            [-31, 122],
            [10, 84],
            [4, 95],
            [19, 106],
            [-10, 111],
            [-19, 59],
            [2, 40],
            [-22, 19],
            [1, 43],
            [-44, 93],
            [-13, 82],
            [-15, 62],
            [-51, 140],
            [-24, 86],
            [-54, 111],
            [-59, 82],
            [-37, 37],
            [-18, 34],
            [-31, 1],
            [-33, 49],
            [-52, 9],
            [-63, 181],
            [-49, 114],
            [26, 78],
            [-15, 106],
            [-21, 79],
            [-70, 195],
            [-49, 61],
            [-19, 85],
            [-8, 76],
            [-48, 36],
            [-84, 274],
            [-48, 95],
            [-19, 64],
            [-55, 106],
            [-28, 105],
            [-56, 97],
            [-48, 168],
            [-76, 168],
            [-31, 29],
            [-77, 12],
            [-33, 12],
            [-30, -37],
            [-3, 47],
            [21, 64],
            [30, 136],
            [6, 119],
            [47, 353]
        ],
        [
            [66940, 62446],
            [4, -127],
            [14, -102],
            [47, -145],
            [40, -78],
            [15, -43],
            [-33, -3],
            [-3, -68],
            [9, -139],
            [17, -98],
            [-12, -90],
            [2, -153],
            [21, -184],
            [-4, -117],
            [35, -273],
            [34, -151],
            [39, -58],
            [40, -12],
            [60, -78],
            [47, -81],
            [39, -90],
            [25, 21],
            [15, -37],
            [75, -82],
            [11, -38]
        ],
        [
            [66078, 55457],
            [-58, 0],
            [-7, 49],
            [9, 93],
            [19, 72],
            [-4, 53],
            [4, 63],
            [-20, 81],
            [-134, 196],
            [-30, 60],
            [-68, 44],
            [10, 63],
            [-31, 413],
            [15, 57],
            [4, 138],
            [18, 108],
            [2, 46],
            [-147, 3],
            [-2, -46],
            [6, -73],
            [-205, -1],
            [81, -162],
            [5, -76],
            [-5, -90],
            [6, -96],
            [22, -74],
            [-7, -31],
            [-145, -221],
            [-24, -102],
            [-19, -54],
            [-43, -90],
            [-133, -235],
            [-21, -16],
            [-101, -8],
            [-27, -8],
            [-82, 132],
            [-146, 166],
            [-96, -86],
            [-26, -32],
            [-1, -80],
            [-40, -85],
            [-71, -28],
            [-75, -61],
            [-50, -84],
            [2, -74],
            [-246, 1],
            [-16, 28],
            [-34, 124],
            [-27, -7],
            [-224, 14],
            [-32, -12],
            [-64, -51],
            [-32, -9],
            [-33, 23],
            [-118, 246],
            [-25, 29],
            [-27, 59],
            [-34, 44],
            [-2, 80],
            [-8, 33],
            [-19, 8],
            [-158, -57],
            [-23, 7],
            [-44, -20],
            [-14, -33],
            [-6, -100],
            [-12, -37],
            [-45, -84],
            [-10, -36],
            [-1, -138],
            [-27, -56],
            [-10, -49],
            [-5, -89],
            [-30, -96],
            [-5, -67],
            [-72, -40],
            [-27, -26],
            [-20, -57]
        ],
        [
            [62616, 56270],
            [24, 151],
            [-5, 86],
            [-23, 32],
            [-20, 4],
            [-44, 59],
            [-26, 86],
            [7, 178],
            [-28, 31],
            [-17, 149],
            [-13, 84],
            [7, 47],
            [-19, 63],
            [-37, 28],
            [-72, -21],
            [-38, 15],
            [-16, 51],
            [5, 41],
            [21, 76],
            [25, 63],
            [52, 56],
            [22, 64],
            [1, 39],
            [-9, 78],
            [-30, 107],
            [0, 38],
            [21, 62],
            [51, 66],
            [53, 55],
            [5, 42],
            [-24, 46],
            [-8, 87],
            [-13, 61],
            [26, 46],
            [51, 31],
            [12, 19],
            [3, 72],
            [26, 82],
            [52, 91],
            [11, 83],
            [-11, 124],
            [24, 52],
            [29, 42],
            [43, -3],
            [66, 10],
            [45, 18],
            [32, -1],
            [74, -23],
            [11, 43],
            [0, 331],
            [0, 497],
            [0, 498],
            [-1, 497],
            [0, 249]
        ],
        [
            [66047, 52534],
            [-126, -228],
            [-25, -31],
            [-50, -1],
            [-53, 12],
            [-48, 59],
            [-50, -46],
            [-31, -14],
            [-62, -13],
            [-62, -24],
            [-43, -55],
            [-12, -45],
            [-18, 1],
            [-48, 44],
            [-17, 56],
            [-28, 52],
            [-52, -56],
            [-46, -12],
            [-79, 59],
            [-22, 0],
            [-69, -85],
            [-28, -80]
        ],
        [[50401, 57070], [-22, 65], [7, 30], [64, 44], [1, 33], [-15, 29], [-23, -52], [-22, -21], [-7, 166], [1, 101]],
        [
            [50447, 57757],
            [-8, 57],
            [-18, 45],
            [-30, 39],
            [-7, 36],
            [31, 73],
            [-39, -18],
            [-1, 50],
            [-26, 64],
            [-29, 109],
            [-32, 44],
            [-28, 88],
            [-28, 34],
            [-49, 12],
            [-8, -40],
            [-28, 58],
            [38, 21],
            [82, 72],
            [94, 208],
            [84, 245],
            [11, 58]
        ],
        [[87651, 50923], [-46, -36], [-52, 33], [17, 55], [34, 13], [44, -31], [3, -34]],
        [
            [44107, 20035],
            [30, -27],
            [24, 19],
            [69, -15],
            [79, -112],
            [38, 32],
            [28, -61],
            [19, -12],
            [31, -96],
            [34, -8],
            [15, -79],
            [36, -30],
            [-44, -39],
            [-45, -18],
            [-51, 48],
            [-19, 48],
            [-60, 102],
            [-70, 25],
            [-47, 71],
            [-37, -1],
            [-47, 39],
            [-105, 64],
            [-41, -6],
            [-18, 50],
            [-69, 27],
            [-10, 19],
            [174, 6],
            [46, -43],
            [40, -3]
        ],
        [[53803, 41261], [-26, 23], [21, 28], [5, -51]],
        [[51126, 45735], [-16, 17], [10, 34], [25, -30], [-19, -21]],
        [[107085, 43677], [-39, -7], [-18, 48], [34, 7], [23, -48]],
        [
            [105124, 43603],
            [-22, -19],
            [-35, 24],
            [-12, 43],
            [-26, 27],
            [-37, 11],
            [-19, 27],
            [-26, 9],
            [-1, 60],
            [24, -12],
            [114, -113],
            [40, -57]
        ],
        [[106839, 44183], [-51, -12], [-20, -40], [-26, 4], [-9, 33], [37, 61], [35, 8], [43, -18], [-9, -36]],
        [
            [105475, 44389],
            [39, -32],
            [23, 5],
            [33, -23],
            [26, 13],
            [15, -29],
            [41, -114],
            [4, -68],
            [-31, 14],
            [-24, -9],
            [-25, 22],
            [-42, 11],
            [-37, 27],
            [-77, 83],
            [1, 42],
            [-13, 21],
            [-3, 52],
            [-28, 16],
            [-32, 3],
            [3, 68],
            [53, -18],
            [74, -84]
        ],
        [[105423, 44814], [2, -80], [-23, 44], [-21, 5], [2, 93], [-3, 81], [43, -143]],
        [
            [104869, 45011],
            [68, -90],
            [29, 8],
            [89, -1],
            [53, -64],
            [31, -29],
            [17, -58],
            [22, -13],
            [13, -29],
            [8, -53],
            [-53, -37],
            [-52, 19],
            [-49, 41],
            [-99, 5],
            [-45, 12],
            [-31, 36],
            [-23, 50],
            [-18, 58],
            [-4, 100],
            [24, 47],
            [20, -2]
        ],
        [[104998, 45165], [26, -6], [48, -74], [-12, -23], [-32, 10], [-4, 22], [-49, 50], [23, 21]],
        [[104695, 45094], [-36, 8], [-11, 19], [29, 46], [31, -21], [-13, -52]],
        [[104219, 45297], [-18, -13], [-40, 29], [38, 15], [20, -31]],
        [[104390, 45262], [-14, 20], [17, 60], [14, -66], [-17, -14]],
        [[104362, 45339], [-31, -44], [-22, 15], [-18, 38], [9, 57], [28, 32], [33, -16], [-12, -39], [13, -43]],
        [[104140, 45323], [-17, 7], [-38, 75], [7, 26], [34, 48], [21, -23], [-25, -98], [18, -35]],
        [[104849, 45437], [-14, -7], [-32, 39], [18, 40], [14, -20], [14, -52]],
        [
            [105177, 45545],
            [77, -166],
            [-14, -48],
            [-3, -56],
            [31, -31],
            [35, -60],
            [16, -95],
            [15, -33],
            [0, -70],
            [34, -97],
            [3, -46],
            [-17, -9],
            [-41, 110],
            [-46, 47],
            [-5, 21],
            [-47, 63],
            [-31, 108],
            [-34, 191],
            [16, 46],
            [-38, 93],
            [49, 32]
        ],
        [
            [104255, 45585],
            [20, -45],
            [22, -102],
            [-20, -37],
            [-26, 27],
            [-29, 14],
            [-21, 30],
            [-9, 98],
            [-17, 6],
            [-47, -9],
            [-15, -32],
            [-22, 10],
            [-1, 57],
            [29, 29],
            [6, 36],
            [29, 62],
            [17, 11],
            [34, -23],
            [4, -88],
            [12, -29],
            [34, -15]
        ],
        [[104073, 45660], [-41, -5], [-25, 57], [0, 43], [20, 39], [24, 7], [26, -48], [5, -41], [-9, -52]],
        [
            [103923, 45763],
            [-23, 32],
            [0, 34],
            [-31, 54],
            [-3, 38],
            [18, 37],
            [25, -22],
            [24, -46],
            [28, -15],
            [-6, -31],
            [-32, -81]
        ],
        [
            [104908, 45423],
            [-41, 33],
            [-31, 57],
            [-90, 62],
            [-81, 88],
            [-45, 35],
            [-35, 63],
            [-16, 11],
            [-29, 50],
            [-27, 33],
            [-10, 60],
            [-33, 59],
            [85, -33],
            [40, -66],
            [34, -37],
            [42, -64],
            [27, -3],
            [28, -37],
            [44, -30],
            [127, -166],
            [-15, -44],
            [26, -71]
        ],
        [[103662, 46224], [-31, -13], [-19, 17], [18, 65], [39, -39], [-7, -30]],
        [
            [104170, 46094],
            [10, -20],
            [-24, -33],
            [-32, 18],
            [-7, 29],
            [-22, -7],
            [-44, 17],
            [-61, 79],
            [-64, 151],
            [-62, 83],
            [-12, 26],
            [7, 59],
            [39, -18],
            [49, -68],
            [82, -72],
            [22, -36],
            [15, -87],
            [57, -93],
            [47, -28]
        ],
        [[51693, 54327], [-25, 22], [-106, 53], [30, 29], [74, 8], [31, -30], [-4, -82]],
        [
            [52008, 54032],
            [-70, 101],
            [-61, 53],
            [-128, 89],
            [-43, 24],
            [16, 89],
            [-24, 67],
            [-18, 20],
            [-40, 8],
            [-56, 79],
            [-24, 161],
            [-20, 31],
            [-39, 7],
            [-16, 68],
            [-22, 52],
            [3, 33],
            [55, -36],
            [28, 57],
            [12, 50],
            [-41, 6],
            [-29, -28],
            [-15, 67],
            [7, 82],
            [16, 30],
            [-36, 50],
            [-6, 35]
        ],
        [
            [28454, 57652],
            [-2, -63],
            [-34, -59],
            [-77, -9],
            [-73, 28],
            [-54, 37],
            [25, -54],
            [-110, 55],
            [-126, 109],
            [-76, 17],
            [-87, 29],
            [-51, 68],
            [-39, 30]
        ],
        [[70665, 56458], [0, -303], [0, -413], [0, -291], [-99, -272], [-106, -290], [-91, -249]],
        [
            [68908, 56593],
            [60, -85],
            [59, -174],
            [68, -140],
            [95, -130],
            [37, -44],
            [33, -23],
            [172, 3],
            [122, 119],
            [110, 86],
            [37, 18],
            [65, -24],
            [70, -7],
            [64, -26],
            [32, 7],
            [127, 100],
            [79, 97],
            [54, 41],
            [21, 1],
            [74, -35],
            [94, 15],
            [130, 84],
            [41, 17],
            [32, 1],
            [70, -38],
            [11, 2]
        ],
        [
            [70665, 56458],
            [38, 7],
            [101, 40],
            [78, 61],
            [145, 43],
            [110, 111],
            [19, 53],
            [33, 68],
            [48, 22],
            [123, -79],
            [20, -6],
            [-11, -97],
            [-26, -85],
            [-16, -94],
            [12, -145],
            [6, -234],
            [-3, -34],
            [-21, -90],
            [38, 25],
            [2, 42],
            [54, -44],
            [5, -50],
            [-54, 25],
            [-54, -25],
            [-32, -28],
            [-10, -46],
            [-8, -183],
            [-12, -120],
            [-3, -157],
            [-43, -104],
            [-14, -74],
            [-65, -147],
            [-33, -126],
            [-11, -61],
            [-57, -173],
            [-77, -132],
            [-28, -169],
            [-28, -106],
            [-31, -96],
            [-68, -171],
            [-35, -119],
            [-44, -206],
            [-14, -131],
            [-123, -378],
            [-128, -302],
            [-80, -255],
            [-143, -294],
            [-196, -381],
            [-255, -452],
            [-70, -92],
            [-279, -279],
            [-182, -233],
            [-92, -159],
            [-97, -139],
            [-78, -131],
            [-233, -445],
            [-47, -81],
            [-29, -76],
            [-20, -29],
            [-56, -127],
            [-74, -131],
            [-28, -99],
            [-13, -30],
            [-35, -126],
            [-31, -83],
            [-31, -65]
        ],
        [[38192, 76297], [-36, -11], [16, 54], [-17, 85], [31, 2], [-9, -66], [15, -64]],
        [[57615, 50248], [-32, -41], [-11, 11], [-16, 90], [17, 63], [32, 33], [19, 3], [19, -44], [0, -46], [-28, -69]],
        [[57851, 51055], [-29, 20], [26, 53], [12, -37], [-9, -36]],
        [
            [37906, 53275],
            [16, 53],
            [2, 52],
            [24, 112],
            [27, 31],
            [155, -31],
            [72, -29],
            [91, -51],
            [9, 55],
            [25, 38],
            [56, 14],
            [83, -19],
            [71, 23],
            [97, -3],
            [148, -44],
            [66, -30],
            [27, -27],
            [5, -48],
            [-3, -63],
            [-10, -59],
            [-23, -80]
        ],
        [[62516, 77543], [-46, -111], [-29, -105], [-47, -65], [-3, -91]],
        [[59751, 75560], [43, 39]],
        [
            [60661, 81567],
            [-39, 12],
            [3, 143],
            [68, 172],
            [30, 14],
            [42, 105],
            [50, 142],
            [8, -76],
            [-52, -124],
            [-14, -81],
            [-19, -20],
            [-77, -287]
        ],
        [
            [61448, 82429],
            [-41, -53],
            [-40, -19],
            [-7, -125],
            [36, -47],
            [-38, -21],
            [-27, -66],
            [-49, -25],
            [-47, -61],
            [-15, -61],
            [-59, -33],
            [43, 91],
            [-24, 28],
            [-32, 77],
            [14, 38],
            [-4, 121],
            [83, 112],
            [40, 41],
            [94, 39],
            [36, 0],
            [37, -36]
        ],
        [
            [63015, 86872],
            [-81, -13],
            [-62, 26],
            [-30, -13],
            [-115, -10],
            [-37, -29],
            [-56, 29],
            [-53, 47],
            [-65, -43],
            [-53, 27],
            [-28, -65],
            [-6, -71],
            [-116, -97],
            [-97, -9],
            [-13, -28],
            [28, -33],
            [-33, -30],
            [21, -67],
            [-46, -63],
            [-71, -75],
            [-18, -38],
            [44, -47],
            [35, -101],
            [39, -45],
            [-17, -47],
            [-65, -44],
            [-73, -68],
            [-79, -173],
            [-95, -52],
            [-77, -62],
            [-90, -29],
            [-59, -82],
            [-68, 25],
            [-46, -18],
            [-36, -72],
            [-62, -61],
            [-132, -33],
            [-45, -158],
            [-66, -26],
            [-109, -10],
            [25, -61],
            [-22, -35],
            [13, -45],
            [-35, -42],
            [-81, -29],
            [-50, 32],
            [-11, -46],
            [17, -51],
            [42, -68],
            [-17, -26],
            [-42, -167],
            [14, -70],
            [-63, -47],
            [-26, -45],
            [10, -65],
            [-8, -43],
            [13, -74],
            [7, -166],
            [24, -78],
            [-9, -62],
            [34, -33],
            [60, 1],
            [33, -60],
            [91, 30],
            [17, -43],
            [74, -84],
            [46, -14],
            [49, -46],
            [-7, -56],
            [77, -41],
            [45, -77],
            [18, -64],
            [-6, -39],
            [-78, -56],
            [-43, -51],
            [-112, -81],
            [-16, 6],
            [-62, -40],
            [52, -24],
            [43, 29],
            [74, 22],
            [33, -45],
            [-63, -20],
            [-12, -62],
            [-27, -39],
            [-58, -26],
            [-83, -60],
            [-115, -54],
            [-34, -43],
            [-75, -39],
            [-39, -32],
            [-105, -2],
            [46, -36],
            [42, -52],
            [-84, -33],
            [37, -122],
            [-22, -30],
            [-1, -136],
            [-31, -2],
            [-12, -56],
            [8, -95],
            [21, -79],
            [-6, -39],
            [-48, -92],
            [16, -110],
            [-55, -200],
            [-61, -117],
            [-48, -155],
            [-52, -54],
            [-62, 34],
            [-93, -20],
            [-85, 12],
            [-83, -6],
            [-21, -15],
            [13, -56],
            [-61, 8],
            [-48, -40],
            [-58, -80],
            [-4, -58],
            [43, -112],
            [-52, -73],
            [-29, -3],
            [-84, 21],
            [-150, -46],
            [-134, 36],
            [17, 39],
            [11, 118],
            [-11, 63],
            [-33, 42],
            [-75, 143],
            [-26, 87],
            [61, -33],
            [30, 16],
            [-45, 99],
            [62, 6],
            [19, 36],
            [-11, 57],
            [-51, 25],
            [-45, 89],
            [-46, 47],
            [-84, 178],
            [-30, 123],
            [-28, -12],
            [-26, 142],
            [-44, 21],
            [-10, 142],
            [-48, 16],
            [-31, 65],
            [-5, 124],
            [-31, 22],
            [-18, 54],
            [-15, 113],
            [-5, 104],
            [-19, 69],
            [15, 50],
            [31, 4],
            [29, -28]
        ],
        [
            [65472, 35216],
            [-37, 12],
            [-8, -80],
            [-7, -118],
            [4, -74],
            [-67, -2],
            [-84, 8],
            [-60, 32],
            [-65, 70],
            [-39, 109],
            [-17, 69],
            [-27, 16],
            [-2, 172],
            [4, 24],
            [71, 176],
            [17, 65],
            [37, 76],
            [40, 49],
            [24, 5],
            [141, -131],
            [24, 14]
        ],
        [[36110, 60256], [-3, -28], [-31, 28]],
        [[72703, 47564], [-18, -1], [-31, 48], [23, 28], [26, -75]],
        [[66664, 69489], [-24, 125], [-3, 116], [17, 91], [-13, 110], [-42, 84], [23, 155], [16, 37]],
        [
            [66638, 70207],
            [23, -3],
            [50, -44],
            [23, 59],
            [45, 37],
            [8, 93],
            [32, 28],
            [49, 7],
            [1, 17],
            [-32, 108],
            [19, 136],
            [19, 56],
            [87, -24],
            [39, -59],
            [114, -6],
            [87, 56],
            [58, 29],
            [88, 59],
            [78, -22],
            [75, -82],
            [24, -12],
            [106, -7],
            [76, 1],
            [102, 32],
            [102, 48],
            [134, 102],
            [79, 50],
            [78, 6],
            [94, -22],
            [78, 11],
            [114, 37],
            [54, 28],
            [33, 46],
            [31, -7],
            [14, -26],
            [14, -67]
        ],
        [[33233, 62365], [35, -31], [-36, -21], [1, 52]],
        [[33440, 62317], [-18, 14], [-34, 0], [8, 34], [42, -10], [2, -38]],
        [[33373, 62359], [-43, 43], [27, 19], [16, -62]],
        [[56060, 53647], [-96, -39], [-38, -32]],
        [[86322, 53817], [-18, 42], [15, 66], [15, -80], [-12, -28]],
        [[85991, 54605], [-19, 97], [23, -28], [-4, -69]],
        [[85935, 54587], [-35, -70], [-10, 83], [12, 118], [41, -29], [-11, -67], [3, -35]],
        [[86448, 55526], [-6, -70], [-28, -22], [-9, 31], [7, 58], [36, 3]],
        [[87230, 56692], [-5, -59], [-17, 24], [22, 35]],
        [[87175, 56866], [-39, -5], [-8, 77], [14, 13], [33, -85]],
        [
            [87331, 56708],
            [-43, 102],
            [-9, 69],
            [-52, 106],
            [-17, -52],
            [-61, 80],
            [-26, 79],
            [-9, -35],
            [-29, 62],
            [-31, 49],
            [-45, 35],
            [-16, 26],
            [-35, 27],
            [-86, -39],
            [-110, 31],
            [-42, -30],
            [-28, 52],
            [11, 58],
            [2, 121],
            [13, 85],
            [-6, 64],
            [11, 72],
            [-17, 17],
            [-78, 33],
            [-16, 26],
            [-21, -30],
            [-92, -16],
            [-35, -25],
            [-33, -49],
            [-8, -61],
            [19, -40],
            [12, -70],
            [-34, -153],
            [-5, -45],
            [13, -187],
            [-5, -103],
            [-19, -69],
            [-28, -61],
            [-12, -105],
            [-23, -49],
            [-30, -111],
            [-21, -138],
            [-14, -64],
            [-8, -117],
            [-63, -179],
            [-15, -101],
            [-22, -38],
            [9, -80],
            [-8, -135],
            [-2, -112],
            [9, -59],
            [30, -119],
            [-10, -83],
            [43, -29],
            [102, 56],
            [34, -14],
            [21, -98],
            [18, -246],
            [9, -46],
            [43, -90],
            [10, 45],
            [20, -47],
            [16, -87],
            [54, -460],
            [28, -120],
            [-32, 30],
            [-9, 102],
            [-10, 43],
            [-30, 6],
            [13, 51],
            [-2, 40],
            [-19, 33],
            [-30, -26],
            [1, -72],
            [13, -55],
            [52, -123],
            [16, -51],
            [20, -15],
            [30, 8],
            [64, -101],
            [69, -74],
            [42, 7],
            [46, 19],
            [30, -5],
            [30, -19],
            [36, -62],
            [57, -156],
            [93, -129]
        ],
        [
            [86463, 53773],
            [-78, 172],
            [-53, 70],
            [8, 128],
            [-17, 25],
            [-20, 3],
            [-15, 35],
            [13, 76],
            [-20, -14],
            [-29, 3],
            [-24, 21],
            [-18, 105],
            [-36, 87],
            [-33, 0],
            [-11, 27],
            [3, 68],
            [-24, 42],
            [-57, 54],
            [-26, 110],
            [-39, 49],
            [-24, -15],
            [-24, -78],
            [-36, 27],
            [-21, 110],
            [-3, 67],
            [4, 125],
            [26, 112],
            [14, 179],
            [22, 113],
            [16, 38],
            [21, 154],
            [43, 197]
        ],
        [
            [76474, 70907],
            [12, 41],
            [5, 135],
            [16, 46],
            [45, 84],
            [24, 64],
            [63, 110],
            [19, 76],
            [-7, 38],
            [-58, 81],
            [-17, 51],
            [-13, 109],
            [31, 123],
            [-13, 40],
            [-45, 17],
            [-59, -5],
            [-28, 14],
            [-3, 56],
            [-16, 23],
            [-66, 26],
            [-16, 25],
            [24, 125],
            [35, 51],
            [55, 36],
            [110, -32],
            [100, -20],
            [20, 5],
            [38, 54],
            [16, 114],
            [30, -1],
            [13, 38],
            [28, 1],
            [-25, 59],
            [5, 21],
            [47, 12],
            [-9, 36],
            [-89, -4],
            [4, 30],
            [92, 22],
            [86, -19],
            [-3, 56],
            [26, 22],
            [-30, 133],
            [33, 38],
            [-1, 50],
            [32, 40],
            [26, -16],
            [40, -49],
            [26, -13],
            [131, 91],
            [48, 40],
            [25, 76],
            [21, -2],
            [67, -103],
            [-6, -34],
            [35, -22],
            [-12, -39],
            [-102, -120],
            [5, -52],
            [42, -20],
            [21, -62],
            [16, -7],
            [94, 21]
        ],
        [
            [72201, 71003],
            [-21, 182],
            [-7, 144],
            [9, 199],
            [-4, 128],
            [14, 195],
            [-5, 47],
            [-45, 86],
            [-6, 59],
            [-27, 4],
            [-44, 50],
            [-43, 19],
            [-41, -13],
            [-24, 17],
            [0, 47],
            [34, 99],
            [48, -40],
            [66, 5],
            [-7, 34],
            [-34, 34],
            [-6, 45],
            [11, 89],
            [-26, 29],
            [-35, -1],
            [-93, 16],
            [-28, -42],
            [-29, 79],
            [-18, 93],
            [-4, 99],
            [36, 160],
            [29, 197],
            [36, -83],
            [27, -36],
            [57, -24],
            [58, 27],
            [30, -7],
            [45, -85],
            [33, -9],
            [100, 40],
            [57, -15],
            [-18, 78],
            [17, 21],
            [53, -22],
            [51, 33],
            [-2, 100],
            [-35, 68],
            [-95, 95],
            [-32, 38],
            [-26, 49],
            [-31, 141],
            [-46, 178],
            [-29, 21],
            [-39, 4],
            [-105, -30],
            [-38, 6],
            [-60, -65],
            [-20, -45],
            [-27, -103],
            [21, -33],
            [-17, -173],
            [-25, 13],
            [-43, 92],
            [-36, 140]
        ],
        [[72838, 73221], [245, -19], [76, -14], [31, 49], [-31, 56], [-17, 226], [39, 49]],
        [
            [73181, 73568],
            [-9, -122],
            [35, 5],
            [53, -90],
            [56, 12],
            [49, 23],
            [41, 36],
            [14, 41],
            [-6, 36],
            [-45, 41],
            [-5, 55],
            [-21, 53],
            [1, 32]
        ],
        [
            [73344, 73690],
            [61, 15],
            [33, 81],
            [7, 47],
            [26, 38],
            [63, -22],
            [29, -27],
            [22, -60],
            [24, 27],
            [-58, 104],
            [-42, 56],
            [33, 34],
            [67, -14],
            [17, 10],
            [18, 54],
            [89, -121],
            [76, -21],
            [23, -23],
            [24, -70],
            [54, -32],
            [126, -2],
            [45, -58],
            [-13, -132],
            [44, -26],
            [27, -41],
            [-26, -23],
            [-10, -52],
            [19, -59],
            [-21, -66],
            [6, -43],
            [113, -99],
            [92, 14],
            [178, -29],
            [18, 32],
            [33, 14],
            [46, -21],
            [48, -42],
            [47, -74],
            [44, -194],
            [29, -79],
            [34, -41],
            [23, -76],
            [21, -165],
            [13, -34],
            [52, -65],
            [264, -268],
            [66, -106],
            [71, -72],
            [65, -58],
            [46, 13],
            [108, -135],
            [49, -35],
            [79, -74],
            [100, -107],
            [66, -61],
            [36, -7],
            [39, 24],
            [35, -14],
            [63, -43],
            [67, -65],
            [57, -22],
            [17, -44],
            [-32, -82],
            [-5, -104],
            [4, -139]
        ],
        [[93845, 44972], [50, 48], [76, 37]],
        [
            [94118, 45195],
            [33, 46],
            [27, 85],
            [19, 33],
            [63, 41],
            [131, 46],
            [114, 2],
            [137, 16],
            [70, 46],
            [37, 34],
            [29, -18],
            [48, -13],
            [25, -29],
            [-56, -89],
            [-61, -73],
            [-77, -38],
            [-30, -28],
            [-26, -44],
            [-32, -25],
            [-67, -22],
            [-67, -71],
            [-33, -4],
            [-134, -81],
            [-61, -71],
            [-43, -61]
        ],
        [[94342, 45642], [-21, -95], [-22, 20], [24, 54], [19, 21]],
        [[1493, 38378], [2, -53], [-55, 59], [34, 22], [19, -28]],
        [[1866, 39788], [-17, -32], [-18, 32], [20, 39], [15, -39]],
        [
            [36727, 55832],
            [-50, -32],
            [-130, -7],
            [-54, 11],
            [-42, -9],
            [76, 69],
            [9, 29],
            [41, 14],
            [11, 150],
            [-11, 56],
            [-42, 34],
            [13, 27],
            [40, 9],
            [29, 18],
            [60, 4],
            [30, 16],
            [49, 4],
            [-35, -95],
            [4, -62],
            [-6, -42],
            [7, -54],
            [15, -35],
            [-10, -34],
            [-4, -71]
        ],
        [[36806, 56414], [-15, 17], [30, 38], [45, 26], [5, -34], [-65, -47]],
        [[58942, 68984], [-31, -20], [-42, 29], [7, 83], [55, 3], [35, -60], [-24, -35]],
        [
            [58207, 70776],
            [76, 34],
            [73, 88],
            [25, 22],
            [169, 81],
            [46, -17],
            [-17, -55],
            [15, -42],
            [20, 26],
            [-6, 40],
            [65, -2],
            [34, -25],
            [-3, -96],
            [45, -94],
            [-12, -47],
            [36, -27],
            [33, 33],
            [16, 49],
            [61, 28],
            [57, 72],
            [31, 8],
            [8, -59],
            [15, -52],
            [-22, -18],
            [-27, -55],
            [-53, -139],
            [-48, -41],
            [-36, -54],
            [-15, -83],
            [9, -79],
            [27, -81],
            [30, -49],
            [29, -15],
            [68, -77],
            [-1, -46],
            [13, -121],
            [24, -53],
            [-51, -115],
            [-27, -83],
            [-55, -115],
            [-48, -75],
            [-103, -110],
            [-42, -75],
            [-5, -87],
            [34, -115],
            [45, -68],
            [46, -37],
            [80, 15],
            [3, -97],
            [54, 11],
            [19, 51],
            [39, -35],
            [20, -108],
            [33, -34],
            [-17, -33],
            [42, -22],
            [19, 8],
            [33, -24]
        ],
        [[63576, 72560], [-71, -17], [-22, 17], [22, 33], [55, 24], [16, -57]],
        [
            [66638, 70207],
            [20, 46],
            [-45, 173],
            [22, 54],
            [95, 141],
            [-3, 83],
            [-40, 57],
            [-45, -35],
            [-32, -38],
            [-43, -30],
            [-11, -40],
            [-27, -31],
            [-45, -13],
            [-67, 34],
            [-72, 50],
            [-41, 41],
            [-33, 10],
            [-31, -18],
            [-93, -100],
            [-86, -147],
            [-21, -26],
            [-80, -63],
            [-53, -21],
            [-25, 5],
            [-106, -28],
            [-52, -4],
            [-42, -33],
            [-80, 36],
            [-49, 46],
            [-29, 47],
            [-47, 101],
            [-33, 48],
            [-76, 43],
            [-131, 105],
            [-124, 27],
            [-95, 9],
            [-19, -38],
            [-7, -151],
            [-16, -42],
            [-7, -78],
            [-30, -38],
            [-48, 36],
            [-46, -32],
            [-91, -46],
            [-31, -6],
            [-105, 57],
            [-38, 37],
            [-25, 40],
            [-8, 69],
            [-16, 39],
            [-8, 57],
            [-22, 13],
            [-22, -24],
            [-55, 15],
            [-73, 58],
            [-55, 4],
            [-34, -70],
            [-25, -22],
            [-31, 13],
            [22, 46],
            [-86, -9],
            [-46, -34],
            [-36, 5],
            [-22, 35],
            [50, 22],
            [94, 13],
            [22, 13],
            [24, 49],
            [43, 42],
            [-28, 19],
            [-143, -13],
            [-99, 7],
            [-26, -24],
            [-4, 57],
            [88, 48],
            [-5, 47],
            [-93, 78],
            [-5, 57],
            [-17, 63],
            [-22, 47],
            [46, 21],
            [9, 87],
            [-7, 54],
            [-23, 5],
            [-66, 42],
            [-20, -5],
            [-22, 47],
            [-38, 33],
            [-31, -27],
            [-77, 52],
            [-14, 19],
            [17, 52],
            [22, -1],
            [4, 41],
            [-17, 67],
            [1, 35],
            [42, 3],
            [23, -41],
            [2, -77],
            [83, -25],
            [73, 24],
            [-59, 36],
            [-22, 43],
            [-23, 85],
            [45, 36],
            [33, 62],
            [-62, 42],
            [12, 86],
            [-53, 98],
            [9, 27],
            [62, 99],
            [-26, 25],
            [-106, -23],
            [-41, -21],
            [-73, -9],
            [-4, 57],
            [17, 49],
            [-2, 120],
            [10, 65],
            [40, 20],
            [50, 96],
            [82, 113],
            [84, -2],
            [34, 31],
            [50, 2],
            [15, -44],
            [44, -32],
            [78, 5],
            [37, 30],
            [-36, 55],
            [44, 18],
            [36, -13],
            [-8, -67],
            [100, 19],
            [106, -15],
            [33, 8],
            [83, -1],
            [15, 20],
            [-83, 61],
            [53, 54],
            [169, 43],
            [91, 29],
            [-135, 27],
            [-32, 21],
            [-45, 51],
            [-21, 39],
            [15, 94],
            [16, 25],
            [54, 4],
            [185, -43],
            [131, 25],
            [143, -62],
            [138, 13],
            [28, 28],
            [34, 90],
            [194, 150],
            [68, 78],
            [73, 43],
            [125, 48],
            [104, 63],
            [30, 7],
            [251, -30],
            [172, -4],
            [79, 59],
            [46, -19],
            [-11, -77],
            [55, -90],
            [80, -53],
            [112, 45],
            [40, -18],
            [40, -143],
            [30, -50],
            [40, -34],
            [32, -7],
            [42, 50],
            [40, 6],
            [67, -49],
            [23, -51],
            [112, -39],
            [103, -19],
            [45, -43],
            [145, -44],
            [55, 7],
            [91, 45],
            [177, 50],
            [118, -69],
            [59, -3],
            [40, -19],
            [42, 10],
            [130, 81],
            [41, 47],
            [43, 12],
            [39, 27],
            [102, 91],
            [29, 52]
        ],
        [
            [64207, 73582],
            [-9, -64],
            [20, -70],
            [45, -97],
            [46, -49],
            [185, -122],
            [34, -10],
            [-18, -94],
            [-13, -30],
            [-54, -19],
            [-150, 54],
            [-38, 6],
            [-76, -51],
            [-55, 13],
            [-76, -22],
            [-22, -75],
            [-53, -85],
            [-87, -69],
            [-63, -36],
            [-94, -132],
            [-42, -77],
            [-40, -27],
            [18, 71],
            [-2, 62],
            [60, 73],
            [84, 55],
            [22, 46],
            [-66, -1],
            [-67, -10],
            [-79, 3],
            [-20, 64]
        ],
        [[92108, 63854], [7, -60], [-42, 12], [35, 48]],
        [
            [92911, 62794],
            [-35, -135],
            [-6, -132],
            [-12, -121],
            [-30, 17],
            [-16, 43],
            [-4, 71],
            [-29, 109],
            [-32, 48],
            [-28, 24],
            [-19, 32],
            [-29, 98],
            [-26, 143],
            [-23, 98],
            [21, 139],
            [-5, 71],
            [2, 70],
            [8, 32],
            [146, 429],
            [83, 186],
            [43, 123],
            [17, 18],
            [84, 52],
            [26, 50],
            [44, 15],
            [29, -52],
            [51, -43],
            [16, -27],
            [8, -46],
            [-34, -83],
            [2, -162],
            [-28, -139],
            [-30, -87],
            [-8, -43],
            [-9, -107],
            [-18, -107],
            [-15, -136],
            [-24, -141],
            [-32, -114],
            [-41, -106],
            [-47, -87]
        ],
        [[67817, 45733], [-17, -7], [-17, 30], [76, 115], [15, 1], [-22, -96], [-19, -6], [-16, -37]],
        [
            [67751, 46738],
            [23, -118],
            [-3, -23],
            [-25, -14],
            [-18, 59],
            [-13, -10],
            [-21, 48],
            [-21, 2],
            [-19, 57],
            [7, 50],
            [-4, 85],
            [23, 43],
            [13, 74],
            [15, -50],
            [3, -78],
            [20, -92],
            [20, -33]
        ],
        [[67864, 47446], [-3, -195], [-18, -78], [-14, -27], [-32, 42], [17, 142], [-9, 104], [33, -10], [26, 22]],
        [[65398, 48919], [8, -12], [44, 24], [-2, -61], [-37, -12], [-5, -39], [-36, 68], [11, 72], [17, -40]],
        [[65737, 49081], [38, 4], [27, -84], [-18, -23], [-84, 54], [-7, 69], [37, 20], [7, -40]],
        [
            [65369, 49622],
            [21, -8],
            [5, -42],
            [-12, -149],
            [-19, -74],
            [-31, -245],
            [3, -192],
            [29, -68],
            [6, -38],
            [-14, -56],
            [23, -30],
            [-10, -72],
            [41, 42],
            [35, 88],
            [31, -12],
            [3, 29],
            [-14, 51],
            [24, 16],
            [21, 46],
            [24, -12],
            [12, -50],
            [26, -28],
            [25, -5],
            [8, -30],
            [29, 38],
            [13, -29],
            [39, -13],
            [1, -74],
            [15, -61],
            [-30, -62],
            [4, -58],
            [35, 61],
            [22, 8],
            [-24, 103],
            [2, 100],
            [16, 35],
            [38, 6],
            [44, -44],
            [64, -23],
            [5, 40],
            [24, 16],
            [26, 41],
            [53, 66],
            [13, 26],
            [-17, 45],
            [-52, -32],
            [-95, 25],
            [-14, 29],
            [21, 27],
            [23, -5],
            [12, 19],
            [34, 1],
            [-23, 45],
            [-47, -4],
            [32, 62],
            [27, -6],
            [32, 34],
            [3, 39],
            [23, 29],
            [-9, 38],
            [7, 36],
            [19, 15],
            [49, -18],
            [-21, 49],
            [7, 46],
            [30, 1],
            [-12, 52],
            [9, 33],
            [38, 81]
        ],
        [
            [67666, 47565],
            [-6, -47],
            [-25, -114],
            [-1, -47],
            [-19, -93],
            [-24, -160],
            [-21, -60],
            [-28, -140],
            [-5, -107],
            [16, -76],
            [6, -70],
            [33, -69],
            [26, -25],
            [50, -103],
            [18, -73],
            [57, -35],
            [23, -81],
            [-8, -56],
            [-27, -46],
            [-25, -75],
            [-20, -99],
            [0, -150],
            [13, 23],
            [31, -37],
            [4, -111],
            [-32, -129],
            [-11, -112],
            [23, -154],
            [34, -79],
            [-11, -45],
            [58, -139],
            [-5, -121],
            [22, -95],
            [10, -81],
            [15, -63],
            [2, -43],
            [-18, -48],
            [43, -12],
            [25, -39],
            [12, -38],
            [31, 2],
            [94, -110],
            [23, -62]
        ],
        [
            [66348, 43742],
            [-5, 47],
            [-26, 62],
            [-24, 6],
            [-26, 92],
            [-28, 78],
            [16, 92],
            [3, 90],
            [-24, 104],
            [-4, 158],
            [-14, 117],
            [-63, 167],
            [-72, 108],
            [-28, 24],
            [-14, -39],
            [1, -52]
        ],
        [
            [65721, 44936],
            [-51, 47],
            [-83, 61],
            [-17, 32],
            [-65, 17],
            [-28, 29],
            [-58, 11],
            [-7, 62],
            [-31, 22],
            [-45, -3],
            [-36, 57],
            [-7, 52],
            [-57, 59],
            [-50, -2]
        ],
        [
            [65186, 45380],
            [-11, 33],
            [-3, 56],
            [-13, 37],
            [-42, 82],
            [-2, 65],
            [-41, 117],
            [-31, 117],
            [-37, 89],
            [-2, 93],
            [-7, 55],
            [-19, 90],
            [15, 28],
            [0, 40],
            [-11, 39],
            [-40, 81],
            [-30, 90],
            [-50, 84],
            [-35, -2],
            [-18, -17],
            [-45, 72],
            [-22, 46],
            [-10, 51],
            [4, 56],
            [14, 53],
            [44, 35],
            [10, 43],
            [-26, 129],
            [-33, 91],
            [-2, 34],
            [15, 83],
            [4, 82],
            [-20, 70],
            [-44, 43],
            [0, 66],
            [12, 186]
        ],
        [[64977, 49586], [50, 9], [21, 24], [32, 3], [289, 0]],
        [[65492, 50008], [28, 11], [15, -26], [-14, -75], [-43, -30], [23, 91], [-32, 22], [-6, 51], [30, -2], [-1, -42]],
        [[65846, 50260], [-33, 27], [1, 48], [29, 12], [22, -14], [-19, -73]],
        [
            [66046, 50300],
            [-35, -16],
            [-36, 13],
            [-10, 56],
            [-22, -4],
            [-18, -44],
            [-30, -2],
            [-13, 29],
            [6, 35],
            [-40, 20],
            [11, 46],
            [-29, 6],
            [-23, -42],
            [-19, -75],
            [-19, -8],
            [-17, -51],
            [-33, -29],
            [-11, 41],
            [-31, -28],
            [-27, -6],
            [-14, 81],
            [-18, -33],
            [-17, -69],
            [-46, -2],
            [-10, -29],
            [-44, -3],
            [-15, -27],
            [-32, -9],
            [-33, -43],
            [-3, -27],
            [19, -41],
            [-2, -37],
            [-39, -89],
            [-15, -49],
            [-30, -123],
            [18, -119]
        ],
        [[64709, 49899], [70, 113], [6, 73], [-33, 28], [-30, 1]],
        [
            [64967, 50872],
            [7, -106],
            [29, -4],
            [38, 83],
            [21, 66],
            [57, 122],
            [60, 43],
            [32, 46],
            [23, 82],
            [17, 34],
            [-4, 203],
            [-13, 17],
            [-25, -73]
        ],
        [[65441, 75943], [-1, -20], [-96, 26], [-19, 32], [116, -38]],
        [
            [67355, 76438],
            [-11, -6],
            [-108, 8],
            [-88, -11],
            [-63, -88],
            [-37, 0],
            [-53, -23],
            [-36, -28],
            [-42, -62],
            [-33, 27],
            [-40, 0],
            [-39, -17],
            [-47, -41],
            [-27, -8],
            [-52, 12],
            [-61, -23],
            [-132, -136],
            [-44, -99],
            [-38, -43],
            [-37, -11],
            [82, 96],
            [4, 51],
            [-19, 39],
            [-51, -97],
            [-67, -43],
            [3, -113],
            [44, -141]
        ],
        [
            [65929, 75883],
            [-51, -21],
            [-51, 38],
            [-19, 27],
            [-81, -29],
            [-44, 5],
            [-99, -27],
            [-45, 26],
            [-91, 73],
            [-63, 12],
            [3, 35],
            [46, 11],
            [5, 36],
            [-91, 23],
            [-49, 47],
            [50, 0],
            [50, -19],
            [78, -7],
            [71, -19],
            [59, 66],
            [-61, -16],
            [-70, 18],
            [-47, 63],
            [-32, -33],
            [-28, -10],
            [-77, 18],
            [-65, -29],
            [-57, 7],
            [-105, -41],
            [-23, -103],
            [-20, -56],
            [-45, -90],
            [-90, -133],
            [-123, -75],
            [-42, 13],
            [-26, -41],
            [0, -46],
            [22, -33],
            [17, -110],
            [-6, -46]
        ],
        [
            [39148, 31964],
            [-41, -49],
            [-6, -68],
            [-26, -40],
            [-21, -3],
            [-39, -67],
            [-7, -32],
            [11, -90],
            [6, -103],
            [11, -36]
        ],
        [
            [39086, 31367],
            [-32, -59],
            [-19, -94],
            [-64, -130],
            [-13, -73],
            [-70, -76],
            [-48, -85],
            [-32, 2],
            [-29, -37],
            [-166, -112],
            [-59, 21],
            [-44, 0],
            [-41, 49],
            [-94, 18],
            [-58, -20],
            [-79, -54],
            [-41, 4],
            [-42, 22],
            [-24, 48],
            [-121, 55],
            [-97, 125],
            [-115, 3],
            [-88, -17],
            [-14, 17],
            [-27, 78],
            [-76, 111],
            [-60, 109],
            [-11, 108],
            [8, 117],
            [18, 139],
            [-3, 43],
            [44, 30],
            [39, 90],
            [4, 41],
            [-15, 76],
            [-10, 107],
            [-12, 53]
        ],
        [
            [7537, 60782],
            [-31, -25],
            [-61, 57],
            [-8, 31],
            [5, 143],
            [-24, 116],
            [-25, 89],
            [19, 46],
            [24, 35],
            [27, 66],
            [-22, 86],
            [6, 51],
            [13, 9],
            [65, -62],
            [130, -95],
            [35, -66],
            [6, -71],
            [24, -9],
            [11, -49],
            [46, -67],
            [-14, -39],
            [-63, -75],
            [-79, -33],
            [-70, -84],
            [-14, -54]
        ],
        [[7146, 61763], [-39, -8], [-4, 38], [-19, 48], [33, 10], [19, -14], [22, -41], [-12, -33]],
        [
            [7258, 61852],
            [8, -9],
            [56, 20],
            [40, -37],
            [49, -71],
            [-36, -63],
            [-63, -26],
            [-39, 11],
            [-13, 102],
            [-20, -6],
            [-22, 18],
            [-23, 44],
            [10, 69],
            [22, 5],
            [31, -57]
        ],
        [[7033, 62010], [92, -21], [54, -8], [-2, -33], [-34, -26], [-50, 23], [-83, 8], [23, 57]],
        [
            [6853, 62145],
            [24, 0],
            [5, -44],
            [21, -39],
            [-50, -22],
            [-32, 40],
            [-25, -14],
            [-39, 2],
            [-9, 32],
            [-31, 63],
            [-11, 53],
            [47, 9],
            [31, 51],
            [18, 5],
            [34, -82],
            [17, -54]
        ],
        [[6118, 62359], [-13, 31], [37, 66], [16, -6], [-9, -54], [-31, -37]],
        [
            [6367, 62410],
            [-27, -31],
            [-46, 18],
            [-12, 24],
            [-31, 21],
            [-13, 29],
            [20, 55],
            [45, 46],
            [70, -2],
            [16, -64],
            [-22, -96]
        ],
        [[30749, 64200], [9, 86], [29, 28], [-38, -114]],
        [[25566, 64767], [-29, 95], [-42, 273], [16, -10], [46, -280], [9, -78]],
        [[30809, 65391], [-24, 54], [-35, 149], [7, 20], [52, -223]],
        [[25615, 65738], [11, 63], [24, 58], [19, -16], [-54, -105]],
        [[27226, 66630], [-11, -8], [-51, 48], [-4, 21], [41, 17], [33, -31], [-8, -47]],
        [[19029, 68485], [-38, 6], [-10, 68], [48, -74]],
        [[19030, 68796], [15, -41], [-46, 3], [-14, 53], [45, -15]],
        [[18506, 69093], [-38, 0], [-26, 53], [56, 7], [27, -29], [-19, -31]],
        [[18556, 69183], [99, -41], [-76, -21], [-24, 15], [1, 47]],
        [[32660, 72776], [0, 51], [27, 24], [7, -40], [-34, -35]],
        [
            [33178, 73034],
            [-2, -40],
            [71, 61],
            [42, 15],
            [15, -20],
            [-73, -67],
            [-67, -39],
            [-64, -26],
            [-133, -69],
            [-22, 5],
            [-110, -36],
            [-45, -4],
            [-17, 36],
            [-59, -42],
            [-6, 32],
            [48, 85],
            [94, 72],
            [62, 13],
            [29, -11],
            [52, 19],
            [150, 19],
            [78, 75],
            [-43, -78]
        ],
        [[33960, 73190], [-24, -9], [-55, 20], [53, 24], [26, -35]],
        [[33796, 73251], [-85, -27], [34, 68], [18, 5], [33, -46]],
        [[34513, 74900], [-70, -22], [1, 39], [34, 52], [19, -10], [16, -59]],
        [
            [28708, 75406],
            [-19, -13],
            [-1, -64],
            [-37, -66],
            [-3, -35],
            [-29, -48],
            [-31, 16],
            [-5, 50],
            [25, 43],
            [18, 60],
            [42, 48],
            [23, 44],
            [17, -35]
        ],
        [[29153, 75608], [-19, 4], [12, 71], [25, -42], [-18, -33]],
        [[29460, 75729], [54, -18], [-18, -30], [-36, 48]],
        [[29785, 75837], [-4, -31], [-66, -8], [-42, 20], [80, 65], [32, -46]],
        [[29591, 76031], [-18, -1], [-26, 71], [41, 24], [-7, -67], [10, -27]],
        [
            [28329, 76504],
            [-5, -28],
            [-62, -83],
            [1, 62],
            [-56, 29],
            [17, 55],
            [51, 65],
            [88, 46],
            [72, 7],
            [27, -41],
            [-71, -10],
            [1, -40],
            [-63, -62]
        ],
        [[17781, 76607], [-36, -20], [7, 73], [29, -53]],
        [[28102, 76903], [-4, -25], [-58, -22], [-13, 17], [16, 45], [172, 115], [-11, -65], [-102, -65]],
        [
            [17726, 77032],
            [21, -43],
            [42, -53],
            [-13, -37],
            [-46, 41],
            [-15, 76],
            [-44, 62],
            [25, 62],
            [30, 5],
            [9, -36],
            [-46, -30],
            [37, -47]
        ],
        [[17590, 77224], [-39, 4], [-10, 44], [18, 15], [31, -63]],
        [[17661, 77320], [-34, -44], [-29, 18], [27, 47], [36, -21]],
        [
            [27910, 76946],
            [-77, -57],
            [-114, -63],
            [-124, -56],
            [-77, -57],
            [-34, -34],
            [-132, -172],
            [-80, -92],
            [-130, -129],
            [-2, -46],
            [26, -21],
            [47, 2],
            [104, 36],
            [44, 24],
            [43, 42],
            [28, -10],
            [56, 48],
            [32, 5],
            [23, -30],
            [-30, -82],
            [-18, -88],
            [47, 23],
            [10, 25],
            [83, -59],
            [97, 39],
            [50, 36],
            [41, 41],
            [51, 26],
            [105, 24],
            [62, 60],
            [63, 30],
            [37, 57],
            [55, 48],
            [6, -36],
            [36, -40],
            [18, -74],
            [-6, -70],
            [80, 64],
            [136, -35],
            [43, -35],
            [39, -79],
            [36, -53],
            [11, -36],
            [58, -6],
            [42, 16],
            [57, -40],
            [36, 11],
            [30, -21],
            [33, 40],
            [92, 73],
            [88, 26],
            [102, -7],
            [54, 9],
            [49, 26],
            [83, 17],
            [5, -24],
            [-12, -131],
            [79, -20],
            [25, 12],
            [53, -30],
            [32, 30],
            [30, 0],
            [30, -70],
            [8, -66],
            [-7, -35],
            [36, -3],
            [21, -50],
            [45, -49],
            [-26, -22],
            [-111, 21],
            [-56, -3],
            [-34, 33],
            [-29, -53],
            [-1, -54],
            [-23, 7],
            [-52, 64],
            [-40, 32],
            [-49, 24],
            [-68, 10],
            [-42, -48],
            [-106, -45],
            [-51, 16],
            [-45, -18],
            [-40, -76],
            [-39, -26],
            [-37, -72],
            [-14, 43],
            [41, 58],
            [-1, 43],
            [-73, -28],
            [-12, -38],
            [-42, -23],
            [-6, 66],
            [-14, 2],
            [-14, -64],
            [-41, -69],
            [-56, -135],
            [-63, -116],
            [-8, -69],
            [-63, -50],
            [-37, -100],
            [-24, -81],
            [19, -37],
            [56, 56],
            [34, 77],
            [22, 31],
            [57, 11],
            [26, -50],
            [-46, -149],
            [-13, -69],
            [-2, -118],
            [-39, -64],
            [-20, -84],
            [8, -103],
            [-23, -69],
            [-16, -87],
            [-17, -54],
            [-7, -57],
            [7, -79],
            [-4, -34],
            [33, -130],
            [-8, -148],
            [5, -185],
            [31, -71],
            [29, -125],
            [27, -78],
            [31, -35],
            [50, -11],
            [55, 18],
            [85, 66],
            [51, 69],
            [35, 95],
            [35, 79],
            [33, 108],
            [21, 130],
            [3, 139],
            [-8, 72],
            [-25, 109],
            [-33, 102],
            [-33, 128],
            [31, 88],
            [-2, 72],
            [-22, 83],
            [32, 54],
            [37, 90],
            [17, 123],
            [-6, 65],
            [7, 29],
            [35, 15],
            [21, 94],
            [32, 28],
            [29, -3],
            [23, 29],
            [29, 64],
            [32, 19],
            [-6, -107],
            [-13, -74],
            [30, -12],
            [20, 14],
            [30, 107],
            [4, 136],
            [47, 44],
            [79, 21],
            [-37, 63],
            [0, 55],
            [34, 57],
            [8, 38],
            [55, 11],
            [102, -66],
            [36, -6],
            [42, -30],
            [19, -44],
            [201, -108],
            [25, -37],
            [0, -29],
            [24, -46],
            [-40, -63],
            [4, -36],
            [33, -51],
            [11, -104],
            [-12, -172],
            [-40, -61],
            [-16, 3],
            [-31, -118],
            [-24, -25],
            [-58, -29],
            [-13, -48],
            [-5, -77],
            [28, -41],
            [34, -21],
            [36, 6],
            [15, 33],
            [32, 19],
            [35, 83],
            [5, 28],
            [40, 36],
            [81, 41],
            [49, -36],
            [38, -83],
            [21, -123],
            [25, -197],
            [17, -111],
            [13, -36]
        ],
        [
            [30050, 73910],
            [4, 58],
            [-17, 20],
            [-31, -18],
            [-3, -42],
            [-23, -39],
            [-17, -80],
            [-55, -50],
            [-26, -113],
            [4, -20],
            [-26, -57],
            [-31, -37],
            [-29, -76],
            [168, -114],
            [25, 23],
            [40, -33],
            [54, -64],
            [43, 12],
            [82, 36],
            [123, 10],
            [26, 21],
            [59, 69],
            [67, 55],
            [111, 69],
            [165, 82],
            [195, 144],
            [59, 51],
            [30, 37],
            [63, 55],
            [46, 69],
            [57, 67],
            [-13, 83],
            [3, 68],
            [-48, 20]
        ],
        [
            [31156, 74314],
            [115, 44],
            [72, 15],
            [87, 4],
            [104, -21],
            [66, -44],
            [29, -6],
            [80, 15],
            [91, -10],
            [87, 47],
            [35, 52],
            [33, 30],
            [57, 16],
            [27, 21],
            [2, 39],
            [-12, 86],
            [11, 42],
            [31, 52],
            [-31, 65],
            [-26, -21],
            [-22, 33],
            [36, 43],
            [125, 120],
            [10, 52]
        ],
        [[34632, 75693], [7, -47], [47, -38], [54, 3]],
        [
            [34840, 75366],
            [14, -100],
            [-8, -58],
            [37, -32],
            [-63, -85],
            [-53, 12],
            [-60, -29],
            [-30, -46],
            [-57, 8],
            [-21, -69],
            [-46, -38],
            [-19, 59],
            [-49, 9],
            [-30, -35],
            [-24, 35],
            [-22, -71],
            [-3, -67],
            [-25, 28],
            [-56, 40],
            [26, 34],
            [-42, 24],
            [-35, -29],
            [1, -48],
            [-33, -98],
            [-1, -41],
            [-49, -62],
            [-37, 8],
            [-42, -54],
            [-77, -29],
            [-19, -26],
            [-53, 27],
            [-30, -11],
            [-36, -38],
            [-28, -53],
            [20, -25],
            [-98, -155],
            [-37, -119],
            [-28, -36],
            [-30, -137],
            [29, -87],
            [23, -29],
            [-53, -36],
            [-30, -67],
            [-36, -56],
            [15, -18],
            [56, -19],
            [24, -20],
            [37, -105],
            [-12, -30],
            [34, -27],
            [10, -76],
            [27, -25],
            [41, -16],
            [49, 23],
            [42, 31],
            [-28, 86],
            [35, -10],
            [11, -86],
            [-2, -73],
            [-34, 0],
            [-107, -28],
            [-24, -25],
            [-54, -27],
            [-3, 99],
            [-10, 2],
            [-85, -93],
            [-66, -17],
            [-5, 69],
            [-39, 68],
            [-29, -72],
            [-6, -100],
            [-24, -42],
            [-76, -27],
            [-50, 6],
            [-103, -28],
            [-33, 12],
            [-33, -21],
            [-114, -5],
            [-24, 11],
            [-30, -39],
            [-49, -22],
            [-124, -86],
            [-83, -106],
            [-30, 4],
            [-23, -46],
            [-63, -83],
            [-11, -44],
            [7, -41],
            [59, -14],
            [16, 12],
            [12, -69],
            [-21, -142],
            [-28, -75],
            [-18, -118],
            [-25, -63],
            [-41, -71],
            [-12, -56],
            [-54, -52],
            [-13, -48],
            [-46, -115],
            [-49, -28],
            [17, 109],
            [-47, 36],
            [-26, -2],
            [-30, 43],
            [-37, 31],
            [-53, 84],
            [-15, -8],
            [49, -109],
            [7, -105],
            [25, -70],
            [39, -82],
            [29, -24],
            [-12, -81],
            [29, -72],
            [-1, -42],
            [-30, -24],
            [-8, -72],
            [-20, -7],
            [-39, -99],
            [-75, -242],
            [2, -40],
            [-34, -24],
            [-35, -51],
            [-13, -71],
            [-25, -81],
            [-19, 62],
            [7, 75],
            [27, 123],
            [29, 77],
            [23, 36],
            [18, 74],
            [-59, 10],
            [17, 64],
            [-41, 46],
            [20, 52],
            [-8, 52],
            [-24, -36],
            [-26, -6],
            [-49, 45],
            [-26, 75],
            [10, 58],
            [63, 12],
            [-75, 110],
            [41, 19],
            [-44, 88],
            [39, -11],
            [-16, 112],
            [26, 69],
            [61, 81],
            [-1, 70],
            [-32, -14],
            [-11, -71],
            [-37, -30],
            [-18, -32],
            [-40, -10],
            [-5, -44],
            [-47, 16],
            [47, -100],
            [-16, -25],
            [-14, -73],
            [-6, -87],
            [11, -117],
            [27, -63],
            [-7, -33],
            [9, -52],
            [23, -71],
            [-80, 49],
            [-54, 19],
            [-31, 71],
            [-7, -54],
            [-30, 56],
            [-27, 27],
            [-25, -25],
            [-23, 6],
            [-3, 49],
            [33, 86],
            [-39, -28],
            [-16, -113],
            [25, -32],
            [37, 17],
            [20, -7],
            [43, -89],
            [81, -35],
            [29, -22],
            [24, -47],
            [36, -27],
            [28, -38],
            [-12, -96],
            [-12, -26],
            [-46, 4],
            [-93, 142],
            [24, -71],
            [30, -31],
            [42, -70],
            [55, -32],
            [11, -43],
            [2, -77],
            [-43, 17],
            [3, -48],
            [-32, -30],
            [29, -19],
            [23, -35],
            [14, -54],
            [-37, -35],
            [-62, 85],
            [-9, 44],
            [-22, -2],
            [-94, 55],
            [25, -51],
            [79, -29],
            [11, -70],
            [40, -48],
            [5, -36],
            [28, -4],
            [48, 35],
            [75, -22],
            [34, -143],
            [41, -238],
            [61, -196],
            [-6, -4],
            [-46, 130],
            [-25, 93],
            [-26, 165],
            [-21, 2],
            [-10, -54],
            [39, -115],
            [-5, -51],
            [-82, 57],
            [0, -74],
            [-24, -17],
            [-48, 10],
            [-30, -59],
            [-25, -7],
            [-37, 34],
            [-14, -66],
            [35, -8],
            [78, 5],
            [47, 22],
            [43, -12],
            [3, -51],
            [-8, -105],
            [26, 18],
            [7, 97],
            [38, 35],
            [25, -33],
            [9, -75],
            [-9, -66],
            [-59, -77],
            [-43, -72],
            [-22, -14],
            [-66, 26],
            [-31, -3],
            [-13, 63],
            [-25, 11],
            [-7, -42],
            [-33, -12],
            [71, -90],
            [-29, -66],
            [-7, -44],
            [-46, -46],
            [10, -28],
            [89, 27],
            [29, -29],
            [-48, -89],
            [-58, -14],
            [-8, -25],
            [-98, -6],
            [-26, 6],
            [-36, -51],
            [-33, 2],
            [-17, -15],
            [10, -37],
            [-42, -42],
            [-72, -93],
            [-54, -118],
            [-27, -90],
            [-122, 4],
            [-53, -25],
            [-81, -83],
            [-24, -37],
            [-68, -141],
            [-17, -90],
            [-25, -61],
            [-45, -51],
            [-51, -24],
            [-9, -51],
            [-58, -68],
            [-40, 13],
            [12, -45],
            [-39, -61],
            [-65, -24],
            [-41, -42],
            [-64, 18],
            [30, -62],
            [-4, -39],
            [-37, -33],
            [-12, 57],
            [-37, -54],
            [22, -46],
            [-20, -41],
            [-28, -16],
            [-23, -94],
            [-58, -37],
            [15, -37],
            [-11, -33],
            [-30, -28],
            [7, -96],
            [-37, -89],
            [-27, -10],
            [29, -50],
            [-24, -51],
            [-24, 15],
            [-3, -62],
            [-21, -119],
            [5, -80],
            [15, -50],
            [22, -207],
            [15, -72],
            [27, -194],
            [44, -188],
            [64, -227],
            [103, -275],
            [13, -39],
            [-31, -92],
            [-33, 79],
            [13, 65],
            [-24, 30],
            [-2, 56],
            [-20, 14],
            [27, -210],
            [31, -112],
            [131, -543],
            [31, -69],
            [11, -50],
            [12, -104],
            [3, -133],
            [-22, -244],
            [-5, -166],
            [-28, -51],
            [-25, -69],
            [-9, -106],
            [-12, -54],
            [-36, -56],
            [-23, 1],
            [-55, -42],
            [-39, 11],
            [-46, -24],
            [-30, 2],
            [-18, 51],
            [22, 50],
            [40, -53],
            [-4, 49],
            [-41, 31],
            [-35, 121],
            [-37, 82],
            [-6, 56],
            [-63, 33],
            [-45, 52],
            [-30, 90],
            [-17, 162],
            [-28, 30],
            [-4, 35],
            [-21, 0],
            [-12, 85],
            [3, 104],
            [-8, 40],
            [-27, -15],
            [0, -54],
            [-33, 18],
            [-47, 105],
            [-55, 190],
            [-30, 55],
            [25, 14],
            [35, 86],
            [28, 52],
            [9, 35],
            [-14, 38],
            [-23, -14],
            [-18, 45],
            [-10, -101],
            [-15, -33],
            [-25, -5],
            [-31, 76],
            [29, 218],
            [27, 139],
            [3, 224],
            [-36, 91],
            [-161, 224],
            [-125, 264],
            [-108, 99],
            [-82, -22],
            [-14, -20],
            [-8, -67],
            [-52, -6],
            [-77, -69],
            [-28, 2],
            [-43, -31],
            [-89, -23],
            [-18, 8],
            [21, 58],
            [-14, 43],
            [-47, 56],
            [-53, 81],
            [23, 92],
            [-43, -23],
            [-4, -44],
            [-31, 27],
            [-99, 66],
            [-86, 37],
            [66, 17],
            [-5, 35],
            [-59, 2],
            [-71, -52],
            [-161, -36],
            [24, 32],
            [42, 19],
            [7, 40],
            [-11, 38],
            [-22, -39],
            [-31, 22],
            [-4, -48],
            [-30, -64],
            [-60, -25],
            [-12, 42],
            [-33, -58],
            [-119, -19],
            [67, 34],
            [-21, 64],
            [-21, 24],
            [1, 62],
            [-8, 37],
            [-26, 30],
            [-32, -175],
            [-66, 4],
            [-106, -11],
            [-39, 29],
            [-26, 5],
            [-99, -46],
            [-30, 7],
            [-37, -68],
            [-45, -32],
            [-113, 57],
            [-28, 46],
            [-56, 16],
            [-33, -57],
            [-25, -76],
            [40, -42],
            [34, -21],
            [56, 17],
            [30, 37],
            [26, -1],
            [23, 27],
            [22, -30],
            [-46, -62],
            [22, -43],
            [47, -8],
            [9, 48],
            [21, 32],
            [25, -27],
            [17, -50],
            [1, -56],
            [-54, -27],
            [-41, -49],
            [-18, -36],
            [14, -45],
            [50, -66],
            [83, -49],
            [20, 2],
            [19, -49],
            [32, -25],
            [-2, -34],
            [-27, -24],
            [-15, -46],
            [-24, 36],
            [-30, -46],
            [-7, 40],
            [-27, 69],
            [-55, 60],
            [-53, 17],
            [-8, 47],
            [-18, 23],
            [-87, 44],
            [5, -32],
            [28, -27],
            [-1, -53],
            [-15, -86],
            [-34, -43],
            [-27, 84],
            [-24, 22],
            [-38, 3],
            [-26, -16],
            [-28, -67],
            [-23, -11],
            [-78, 35],
            [-88, 53],
            [41, 34],
            [-27, 60],
            [-27, 31],
            [-57, 23],
            [-48, 107],
            [-47, 2],
            [-22, 48],
            [-38, -20],
            [-36, -56],
            [15, -60],
            [-54, -20],
            [-127, 23],
            [-37, 21],
            [-50, 44],
            [-68, 36],
            [-161, -5],
            [-40, -25],
            [-18, 47],
            [23, 23],
            [11, 35],
            [-21, 37],
            [-32, -92],
            [17, -70],
            [-65, -11],
            [-200, -140],
            [69, 72],
            [-25, 11],
            [-39, -18],
            [-14, 7],
            [17, 60],
            [-6, 53],
            [-28, 1],
            [-18, -42],
            [-41, 14],
            [10, -95],
            [32, -90],
            [-77, -113],
            [-5, -49],
            [-37, -64],
            [-118, -123],
            [-61, -58],
            [-52, -30],
            [-78, 38],
            [-54, -33],
            [-39, 67],
            [-20, -4],
            [36, -122],
            [32, -18],
            [-44, -50],
            [-35, -15],
            [-30, 45],
            [-10, -112],
            [-26, -35],
            [-24, 18],
            [-58, -25],
            [5, -47],
            [33, 18],
            [-12, -60],
            [-31, -59],
            [-25, -14],
            [-37, 9],
            [-18, -19],
            [44, -93],
            [-28, -140],
            [-18, -50],
            [-27, -8],
            [-48, 45],
            [-4, -60],
            [64, -28],
            [3, -67],
            [-24, -84],
            [27, -153],
            [10, -115],
            [10, -50],
            [58, -183],
            [20, -2],
            [1, -58]
        ],
        [
            [19406, 68321],
            [-3, 64],
            [-32, 9],
            [-9, 79],
            [3, 74],
            [-18, 90],
            [-45, 109],
            [-100, 135],
            [-50, 45],
            [-40, 58],
            [-56, 20],
            [-10, -26],
            [-36, 18],
            [6, 64],
            [-35, 88],
            [-29, 10],
            [-72, -6],
            [-96, 49],
            [-28, 29],
            [-10, 52],
            [-45, 45],
            [-60, 45],
            [-33, -11],
            [-43, 7],
            [-62, 32],
            [-35, 4],
            [-71, -9],
            [-26, 7],
            [-24, 40],
            [-26, 20],
            [6, 129],
            [-12, 77],
            [9, 71],
            [-22, 45],
            [-47, 29],
            [-8, 36],
            [7, 51],
            [-12, 33],
            [-38, 31],
            [-35, 71],
            [-45, 38],
            [-19, 65],
            [-28, 40],
            [-9, 35],
            [-62, 127],
            [-66, 98],
            [-10, 57],
            [-2, 78],
            [39, 89],
            [-5, 66],
            [-23, 49],
            [-87, 29],
            [-71, 121],
            [-5, 92],
            [-28, 95],
            [-4, 128],
            [40, 9],
            [4, -74],
            [44, -51],
            [32, -12],
            [-30, 105],
            [-23, 33],
            [-11, 59],
            [-16, 36],
            [52, 45],
            [40, 5],
            [114, -9],
            [-10, 26],
            [-41, -3],
            [-46, 27],
            [-38, -33],
            [-74, 45],
            [-28, -20],
            [-3, -87],
            [8, -64],
            [-90, 60],
            [-64, 84],
            [-6, 100],
            [-18, 16],
            [-24, 80],
            [-52, 49],
            [-41, 78],
            [-86, 129],
            [-5, 113],
            [-31, 144],
            [13, 82],
            [-2, 57],
            [-15, 88],
            [-16, 47],
            [-69, 131],
            [-67, 87],
            [-15, 134],
            [28, 122],
            [18, 36],
            [28, 109],
            [-2, 104],
            [22, 127],
            [-15, 132],
            [-14, 54],
            [-25, 39],
            [11, 56],
            [-1, 54],
            [-44, 77],
            [-21, 144],
            [5, 113],
            [-41, 127],
            [26, 112],
            [33, 183],
            [18, 38],
            [32, 135],
            [11, 22],
            [6, 203],
            [10, 155],
            [16, 52],
            [-6, 52],
            [6, 72],
            [-4, 72],
            [34, 347],
            [-4, 42],
            [10, 57],
            [-10, 148],
            [5, 166],
            [10, 23],
            [74, 0],
            [47, 23],
            [-52, 43],
            [-64, -18],
            [-19, 18],
            [-35, -12],
            [8, 52],
            [-1, 66],
            [32, -32],
            [17, 126],
            [-56, 48],
            [-13, 65],
            [84, 56],
            [-45, 12],
            [-17, 26],
            [-37, -8],
            [-11, 107],
            [-34, 110],
            [-21, 141],
            [-26, 70],
            [-50, 67],
            [-12, 39],
            [-12, 99],
            [6, 75],
            [15, 50],
            [63, -42],
            [78, -32],
            [62, -41],
            [210, -28],
            [52, 18],
            [31, -39],
            [51, 5],
            [25, 26],
            [12, -69],
            [26, -74],
            [-38, -79],
            [-13, 30],
            [-71, -134],
            [21, 4],
            [70, 79],
            [12, 34],
            [40, 52],
            [20, -48],
            [-33, -43],
            [24, -160],
            [-8, -63],
            [-72, 20],
            [-33, -21],
            [-21, -66],
            [22, -23],
            [32, 8],
            [34, -19],
            [30, 31],
            [19, 61],
            [38, 20],
            [20, 33],
            [-4, 130],
            [-13, 27],
            [5, 94],
            [47, 106],
            [-34, 57],
            [-44, 9],
            [-8, 55],
            [34, 36],
            [-24, 45],
            [-56, 51],
            [53, 22],
            [-5, 92],
            [-15, 60],
            [-28, -7],
            [-21, 49],
            [-21, 78]
        ],
        [[110950, 78825], [-54, 0], [-109, 91], [-55, 28], [-17, 39], [67, -22], [84, -82], [84, -54]],
        [[1232, 79070], [-26, -12], [-34, 25], [3, 28], [57, -41]],
        [[655, 78980], [-15, -18], [-41, 30], [23, 51], [-65, 66], [24, 19], [51, 1], [47, -43], [9, -35], [-33, -71]],
        [[880, 79017], [-25, -13], [-107, 0], [75, 46], [38, 36], [14, 38], [32, -4], [-23, -53], [-4, -50]],
        [
            [1052, 79101],
            [48, -26],
            [0, -37],
            [-103, -69],
            [-21, 25],
            [-38, -40],
            [27, 104],
            [42, 28],
            [12, 81],
            [46, -23],
            [-13, -43]
        ],
        [[111035, 79122], [-55, -6], [-14, 48], [38, 28], [47, -36], [-16, -34]],
        [[1228, 79176], [-37, 1], [-4, 53], [38, -9], [3, -45]],
        [[110321, 79110], [-27, -24], [-24, 35], [41, 40], [43, 24], [13, 51], [33, -4], [-24, -86], [-55, -36]],
        [[1990, 79251], [99, -38], [-71, -15], [-65, 12], [5, 45], [32, -4]],
        [[2326, 79327], [-48, 0], [46, 64], [49, -32], [-47, -32]],
        [
            [1643, 79194],
            [-166, -23],
            [30, 30],
            [139, 49],
            [111, 45],
            [15, 30],
            [-54, 27],
            [82, 57],
            [46, -49],
            [-11, -48],
            [-38, -25],
            [18, -37],
            [-69, -32],
            [-103, -24]
        ],
        [[109181, 79375], [-32, 18], [-66, 8], [78, 55], [37, -5], [-17, -76]],
        [[2860, 79499], [-29, 11], [45, 54], [30, -31], [-46, -34]],
        [[3182, 79647], [-10, -30], [-80, 32], [70, 19], [20, -21]],
        [
            [108900, 79740],
            [53, -19],
            [37, 9],
            [103, -80],
            [-27, -15],
            [-83, -6],
            [-45, -35],
            [-49, 25],
            [-17, 50],
            [-70, 29],
            [57, 39],
            [41, 3]
        ],
        [
            [3715, 79925],
            [-95, -60],
            [-72, -108],
            [-173, -117],
            [-2, 17],
            [50, 48],
            [35, 53],
            [11, 72],
            [38, 45],
            [62, 1],
            [13, 84],
            [33, 51],
            [66, 32],
            [27, 1],
            [56, -41],
            [-18, -55],
            [-31, -23]
        ],
        [
            [4131, 80235],
            [37, -10],
            [38, 64],
            [44, -37],
            [-80, -82],
            [-18, -47],
            [32, -27],
            [-79, -64],
            [-22, -34],
            [-118, -38],
            [-70, -37],
            [-44, -37],
            [-45, -9],
            [-43, 36],
            [30, 26],
            [56, 13],
            [122, 74],
            [13, 61],
            [24, 35],
            [-32, 97],
            [43, 50],
            [76, 22],
            [33, -3],
            [3, -53]
        ],
        [[4370, 80329], [-60, -13], [-20, 38], [4, 30], [60, 21], [59, -48], [-43, -28]],
        [[4457, 80366], [-17, 2], [-12, 63], [32, 18], [26, -58], [-29, -25]],
        [[5464, 80762], [-42, 47], [43, 29], [19, -28], [-20, -48]],
        [
            [5100, 80837],
            [30, -92],
            [7, -45],
            [-70, -61],
            [-151, -3],
            [-50, -27],
            [-34, -50],
            [-36, -31],
            [-40, -13],
            [-72, 9],
            [-24, 70],
            [5, 35],
            [56, 47],
            [54, 105],
            [33, 18],
            [46, -7],
            [40, 31],
            [85, 46],
            [81, 7],
            [40, -39]
        ],
        [[15020, 80892], [33, -98], [-54, -5], [-8, 57], [-50, 52], [5, 62], [20, 34], [34, -27], [20, -75]],
        [[6212, 80919], [-51, -47], [-35, 7], [-6, 37], [41, 39], [44, 16], [7, -52]],
        [
            [14550, 80789],
            [27, 17],
            [48, -18],
            [-9, -76],
            [-18, -40],
            [-31, 13],
            [-63, 82],
            [-35, 64],
            [-39, 114],
            [-52, 20],
            [-3, 52],
            [41, 12],
            [61, -62],
            [32, -58],
            [4, -43],
            [37, -77]
        ],
        [[5962, 81023], [31, -4], [30, -68], [-38, -15], [-67, 9], [-6, 76], [18, 40], [32, -38]],
        [[14413, 81151], [7, -26], [-44, -37], [-12, -30], [-57, -60], [4, 80], [-31, 47], [31, 23], [56, -9], [46, 12]],
        [[7542, 81305], [-53, 5], [36, 47], [17, -52]],
        [
            [15131, 81120],
            [-32, -124],
            [-32, -33],
            [-40, 34],
            [-32, 4],
            [-17, 55],
            [-51, -42],
            [-38, -74],
            [-15, 32],
            [-11, 108],
            [62, 94],
            [7, 137],
            [109, 69],
            [46, -55],
            [48, -104],
            [-4, -101]
        ],
        [
            [14332, 81594],
            [113, -10],
            [30, -48],
            [2, -81],
            [105, -53],
            [49, -55],
            [31, -54],
            [21, -62],
            [44, -72],
            [-2, -28],
            [-67, 48],
            [-25, -72],
            [54, 10],
            [62, -56],
            [18, -46],
            [-15, -42],
            [71, -9],
            [-7, -98],
            [6, -127],
            [-13, -44],
            [-35, -8],
            [-40, 50],
            [-23, 59],
            [-65, 25],
            [-12, 56],
            [-60, -2],
            [-99, 173],
            [45, 20],
            [-38, 61],
            [-2, 60],
            [-65, -3],
            [-22, 46],
            [-57, 1],
            [-39, 52],
            [30, 29],
            [42, -22],
            [39, 27],
            [25, 42],
            [-15, 55],
            [-25, 9],
            [-97, -52],
            [-22, 32],
            [69, 81],
            [-19, 40],
            [8, 68]
        ],
        [[14575, 81543], [-34, 7], [-45, 45], [6, 29], [35, 34], [61, -3], [23, -33], [-12, -57], [-34, -22]],
        [
            [14781, 81466],
            [-6, -92],
            [-48, -8],
            [-41, 28],
            [-9, 43],
            [-65, 12],
            [-12, 67],
            [31, 24],
            [68, 143],
            [19, -6],
            [77, -136],
            [-14, -75]
        ],
        [[7815, 81648], [-15, 37], [66, 55], [22, -15], [-73, -77]],
        [[7961, 81692], [-38, 14], [35, 39], [31, -37], [-28, -16]],
        [[3162, 81759], [87, -23], [-35, -28], [-52, 51]],
        [[14585, 81698], [-56, 0], [-2, 46], [29, 104], [57, -61], [28, -61], [-56, -28]],
        [
            [14202, 81876],
            [20, -38],
            [29, 3],
            [28, -73],
            [-36, -38],
            [-9, -54],
            [0, -108],
            [-20, -92],
            [-36, 3],
            [-38, -31],
            [-17, 71],
            [15, 117],
            [34, 24],
            [-63, 69],
            [4, 20],
            [-33, 60],
            [3, 64],
            [31, 44],
            [40, 8],
            [48, -49]
        ],
        [
            [14394, 81965],
            [53, 0],
            [38, -17],
            [36, -52],
            [-1, -113],
            [-24, -32],
            [-37, -5],
            [4, -46],
            [-21, -36],
            [-121, 0],
            [-14, 29],
            [-12, 108],
            [2, 49],
            [-44, 71],
            [-48, 47],
            [35, 33],
            [49, -3],
            [105, -33]
        ],
        [[8332, 82032], [-46, -17], [-43, -52], [-25, 29], [28, 74], [108, -10], [-22, -24]],
        [[3037, 82065], [-32, -26], [-38, 37], [84, 22], [-14, -33]],
        [
            [13899, 82159],
            [45, -109],
            [63, -244],
            [3, -64],
            [-14, -45],
            [8, -123],
            [-37, -35],
            [-30, 47],
            [-41, 109],
            [4, 43],
            [-16, 35],
            [-43, 37],
            [-1, 55],
            [-52, -2],
            [5, 62],
            [35, 53],
            [-43, 30],
            [-11, 60],
            [-39, 31],
            [-33, -96],
            [-63, -35],
            [14, 51],
            [-17, 72],
            [11, 49],
            [64, 40],
            [28, 71],
            [44, 9],
            [116, -101]
        ],
        [[8260, 82437], [-9, -16], [-77, 67], [53, -5], [33, -46]],
        [
            [8365, 82422],
            [15, -27],
            [48, 32],
            [57, 11],
            [28, -39],
            [-20, -27],
            [23, -49],
            [54, -17],
            [6, -22],
            [-61, -68],
            [-154, 30],
            [40, -30],
            [32, -61],
            [-62, -13],
            [-53, -47],
            [-69, -6],
            [-71, -49],
            [-44, -61],
            [1, -38],
            [-35, -57],
            [-66, -47],
            [-31, 26],
            [86, 94],
            [-64, 34],
            [-20, 46],
            [-80, -1],
            [36, -38],
            [7, -32],
            [-23, -52],
            [-24, 5],
            [-50, 64],
            [-21, 95],
            [-43, 72],
            [10, 61],
            [43, 64],
            [78, 44],
            [78, -5],
            [69, -152],
            [-4, 133],
            [39, 38],
            [-58, 52],
            [-7, 35],
            [42, 34],
            [32, -13],
            [43, -71],
            [52, 41],
            [48, 9],
            [12, 85],
            [67, -20],
            [29, -22],
            [-15, -41]
        ],
        [
            [13664, 82657],
            [45, -55],
            [-8, -86],
            [82, 74],
            [106, -41],
            [23, -55],
            [-13, -76],
            [-41, -13],
            [-39, 13],
            [-6, -47],
            [83, -4],
            [33, -76],
            [-18, -60],
            [-47, 17],
            [-42, 35],
            [-86, 49],
            [-34, -6],
            [-3, -95],
            [-23, -34],
            [-67, 15],
            [-27, 49],
            [-24, 78],
            [-119, 111],
            [-33, 55],
            [17, 69],
            [44, 26],
            [70, 6],
            [15, 25],
            [45, 4],
            [50, 35],
            [17, -13]
        ],
        [[14102, 82648], [-44, -13], [-43, 21], [-16, 39], [39, 11], [64, -58]],
        [
            [13989, 82610],
            [78, -12],
            [57, 3],
            [53, -84],
            [51, -114],
            [-39, 17],
            [-68, 128],
            [-17, -9],
            [12, -83],
            [102, -169],
            [5, -50],
            [-16, -23],
            [15, -63],
            [-54, -21],
            [-50, -85],
            [-54, -50],
            [-48, 19],
            [-9, 58],
            [14, 20],
            [27, 105],
            [0, 35],
            [-53, 87],
            [-29, 199],
            [-21, 84],
            [-27, 65],
            [22, 32],
            [49, -89]
        ],
        [
            [8514, 82721],
            [31, 30],
            [73, -57],
            [30, -37],
            [-39, -47],
            [-49, 51],
            [-21, -25],
            [8, -41],
            [-70, -18],
            [-76, -48],
            [-62, -10],
            [-123, 50],
            [82, 84],
            [43, 33],
            [63, -10],
            [1, 37],
            [-22, 40],
            [51, 19],
            [41, -13],
            [39, -38]
        ],
        [[8493, 82791], [-47, 31], [54, 43], [32, -13], [-39, -61]],
        [[5890, 82842], [-47, -4], [-19, 55], [45, 38], [84, 33], [-63, -122]],
        [[9871, 83672], [-17, -17], [-61, 10], [13, 34], [47, 21], [18, -48]],
        [
            [9959, 83531],
            [-42, 9],
            [18, 41],
            [64, 75],
            [43, 34],
            [107, 148],
            [50, -41],
            [-9, -20],
            [-102, -100],
            [-56, -103],
            [-73, -43]
        ],
        [
            [4279, 83849],
            [29, -27],
            [62, 7],
            [35, -18],
            [12, -51],
            [-7, -86],
            [25, -23],
            [12, -64],
            [-109, -13],
            [-48, -22],
            [-27, -43],
            [-48, 34],
            [-87, 17],
            [-111, 66],
            [-47, 14],
            [-48, 49],
            [-44, 62],
            [57, 15],
            [128, -10],
            [16, 45],
            [95, 48],
            [35, -10],
            [70, 10]
        ],
        [[10373, 83886], [66, -11], [16, -21], [-151, -66], [-26, 75], [44, 40], [51, -17]],
        [[9983, 83887], [-1, -55], [-22, -73], [-43, 5], [24, 128], [42, -5]],
        [
            [2240, 83890],
            [67, -36],
            [43, 4],
            [34, -31],
            [-111, -8],
            [-100, 75],
            [-35, 16],
            [8, 42],
            [38, 22],
            [20, -57],
            [36, -27]
        ],
        [[9899, 84096], [-60, 10], [7, 40], [42, -9], [11, -41]],
        [
            [2635, 85665],
            [132, -30],
            [50, 4],
            [62, 42],
            [75, 17],
            [95, -45],
            [32, -71],
            [122, -34],
            [60, -46],
            [134, 0],
            [86, -21],
            [-14, -54],
            [-28, -23],
            [-79, 7],
            [-79, -7],
            [-60, -63],
            [-36, -57],
            [-32, 76],
            [-65, 45],
            [-62, 13],
            [-26, 49],
            [-78, 53],
            [-99, 36],
            [-66, 1],
            [-105, -60],
            [-71, 7],
            [-49, 41],
            [-4, 87],
            [18, 68],
            [30, 14],
            [57, -49]
        ],
        [[15425, 81343], [-26, -61], [-11, -69], [8, -73], [19, -63], [7, -63], [-42, -90], [-13, -62]],
        [
            [15256, 80719],
            [-85, 21],
            [-40, 142],
            [-21, 54],
            [19, 48],
            [73, 29],
            [-33, 33],
            [-7, 143],
            [-12, 69],
            [-65, 125],
            [-49, 29],
            [-108, -45],
            [-46, -31],
            [-4, -52],
            [-22, -76],
            [-35, -62],
            [-42, 19],
            [-32, 85],
            [67, 116],
            [50, 128],
            [-55, 123],
            [-49, 23],
            [-38, 55],
            [-17, 59],
            [-36, 13],
            [-3, 66],
            [-48, 16],
            [-50, 55],
            [-3, 81],
            [-31, 4],
            [-171, 70],
            [9, 92],
            [-31, 121],
            [-34, 49],
            [29, 29],
            [135, -72],
            [-123, 117],
            [6, 83],
            [-50, -46],
            [-26, 7],
            [-47, 78],
            [-42, 44],
            [-10, 77],
            [-45, 12],
            [-85, 75],
            [-55, 10],
            [-35, 38],
            [-51, 108],
            [-7, 53],
            [-52, 56],
            [-26, 131],
            [-35, 90],
            [-9, 48],
            [-39, -9],
            [26, -56],
            [-31, -3],
            [36, -64],
            [16, -99],
            [39, -134],
            [17, -88],
            [32, -115],
            [-29, -41],
            [-50, 13],
            [-45, 67],
            [-38, 20],
            [-93, -10],
            [-7, 39],
            [11, 63],
            [-57, 118],
            [1, 18],
            [67, 43],
            [-92, -3],
            [-7, -58],
            [-24, -13],
            [-70, 45],
            [-36, 53],
            [-81, 24],
            [-38, -10],
            [-33, -52],
            [56, 5],
            [96, -53],
            [49, -48],
            [-23, -46],
            [80, -9],
            [37, -53],
            [15, -68],
            [-23, -19],
            [-103, -13],
            [-37, -46],
            [-36, 12],
            [-115, 72],
            [-145, 103],
            [-7, 25],
            [-57, 46],
            [-35, 43],
            [-50, 87],
            [-101, 82],
            [-64, 23],
            [-44, 32],
            [-197, 105],
            [-115, 72],
            [-26, 23],
            [57, 36],
            [33, 65],
            [-23, 68],
            [8, 47],
            [33, 13],
            [36, -44],
            [3, -77],
            [44, 56],
            [-69, 90],
            [-36, 9],
            [-102, -104],
            [-113, -58],
            [-63, -9],
            [-131, 21],
            [-174, 86],
            [35, 43],
            [-11, 58],
            [-62, -49],
            [-43, -14],
            [-271, 64],
            [-123, 7],
            [-173, -24],
            [-92, -23],
            [-106, 2],
            [19, 37],
            [-30, 38],
            [-46, 22],
            [-96, 19],
            [-79, 61],
            [23, 111],
            [-49, 2],
            [-81, -88],
            [-42, 5],
            [-56, 29],
            [-103, 21],
            [69, 97],
            [-146, 5],
            [-32, 49],
            [-78, -27],
            [-21, 16],
            [56, 46],
            [-44, 15],
            [-32, 33],
            [17, 128],
            [-90, -68],
            [-33, -15],
            [-39, 13],
            [-46, -13],
            [-20, -29],
            [-84, 30],
            [-19, -39],
            [-73, -11],
            [-35, 44],
            [49, 121],
            [-63, -58],
            [-49, -29],
            [-42, -99],
            [-66, -28],
            [90, -57],
            [-9, -94],
            [76, 20],
            [26, -46],
            [-67, -51],
            [-10, -39],
            [5, -87],
            [-42, -25],
            [-30, -75],
            [-65, -18],
            [-62, -3],
            [-50, 16],
            [-36, 30],
            [-45, -19],
            [-51, 1],
            [-36, -59],
            [-42, 0],
            [-34, -22],
            [4, -59],
            [-72, 15],
            [15, -48],
            [-71, -69],
            [-43, 8],
            [-46, -26],
            [-30, 17],
            [-29, -77],
            [-54, -47],
            [-34, -55],
            [-68, 32],
            [4, -36],
            [-61, 5],
            [-78, -33],
            [-37, 1],
            [-69, 54],
            [35, 67],
            [48, 32],
            [91, 30],
            [65, 67],
            [44, 75],
            [-13, 10],
            [-97, -71],
            [-34, -6],
            [-78, 27],
            [-27, 46],
            [37, 115],
            [87, 119],
            [43, 148],
            [-13, 107],
            [10, 47],
            [114, 55],
            [53, 41],
            [105, 60],
            [28, 0],
            [45, -38],
            [64, -11],
            [43, 15],
            [69, -6],
            [142, -40],
            [10, 31],
            [-98, 16],
            [-41, 17],
            [-116, 71],
            [-27, 27],
            [40, 24],
            [30, 53],
            [122, 107],
            [-81, -16],
            [-40, -32],
            [-37, -67],
            [-51, -15],
            [-112, -4],
            [-43, 23],
            [-103, -57],
            [-63, -63],
            [-41, -25],
            [-96, -34],
            [-43, -39],
            [-16, -43],
            [11, -44],
            [-76, -40],
            [-85, -86],
            [3, -66],
            [-33, -41],
            [-88, -55],
            [-74, 2],
            [70, -65],
            [12, -47],
            [-41, -67],
            [-107, -25],
            [21, -36],
            [-3, -45],
            [-58, -33],
            [-39, -6],
            [-16, 45],
            [-73, -52],
            [13, -18],
            [-63, -79],
            [-85, -62],
            [6, -15],
            [-34, -100],
            [15, -20],
            [146, -46],
            [74, -43],
            [26, -57],
            [-32, -58],
            [-56, -56],
            [-75, -37],
            [-49, -53],
            [-20, -71],
            [-38, -43],
            [-12, -72],
            [-100, -23],
            [-4, -35],
            [-131, -22],
            [-28, -57],
            [-66, -59],
            [-86, -41],
            [-11, -34],
            [-47, -58],
            [-68, -13],
            [-17, -55],
            [-58, 1],
            [-73, -67],
            [25, -49],
            [-24, -76],
            [-36, -22],
            [-11, -31],
            [-47, -2],
            [-111, -100],
            [-77, -9],
            [-31, -28],
            [-27, -70],
            [-90, 6],
            [-49, -30],
            [15, -27],
            [-65, -36],
            [-69, -24],
            [-38, -56],
            [46, -19],
            [35, -58],
            [-77, -69],
            [-6, 52],
            [-26, -7],
            [-24, -62],
            [-26, -31],
            [-198, -81],
            [-29, -18],
            [-13, -64],
            [-32, -28],
            [2, 84],
            [-24, 27],
            [-68, -27],
            [-87, -75],
            [-40, -14],
            [-28, -43],
            [-68, -10],
            [-27, -32],
            [-39, 17],
            [-62, -60],
            [-87, -19],
            [-31, 14],
            [1, 38],
            [33, 51],
            [-27, 40],
            [-43, -20],
            [-26, -35],
            [-18, -77],
            [-103, -141],
            [-28, 3],
            [-52, -52],
            [-38, 15],
            [9, 38],
            [-35, 54],
            [-32, -14],
            [9, -82],
            [-18, -41],
            [-59, -24],
            [-40, 52],
            [-39, 10],
            [-3, -83],
            [-49, -44],
            [-15, 22],
            [13, 40],
            [5, 97],
            [51, 40],
            [47, -6],
            [54, 63],
            [40, 30],
            [44, 56],
            [51, 80],
            [59, 70],
            [69, 58],
            [73, 46],
            [149, 64],
            [22, -39],
            [54, 10],
            [-11, -46],
            [48, -64],
            [32, 0],
            [-4, 46],
            [71, 5],
            [56, -35],
            [12, 36],
            [-53, 39],
            [-18, 40],
            [50, 131],
            [23, 40],
            [160, 138],
            [155, 71],
            [90, 96],
            [29, -25],
            [68, -12],
            [-3, 84],
            [8, 53],
            [23, 41],
            [82, 103],
            [84, 62],
            [47, 57],
            [49, 20],
            [62, -36],
            [-22, 66],
            [-23, 21],
            [-1, 59],
            [20, 84],
            [3, 87],
            [17, 49],
            [35, 18],
            [76, 13],
            [-90, 33],
            [-11, 93],
            [19, 46],
            [72, 77],
            [78, 53],
            [-20, 20],
            [24, 121],
            [-56, -62],
            [-161, -72],
            [-110, -61],
            [-52, -14],
            [-35, 15],
            [-62, 116],
            [24, 84],
            [64, 21],
            [-63, 29],
            [-28, -9],
            [-51, -80],
            [-25, 11],
            [-31, -129],
            [27, -111],
            [-5, -44],
            [-50, -20],
            [-41, 36],
            [-85, 140],
            [-96, 106],
            [-77, -51],
            [-72, 48],
            [-65, 81],
            [-90, -53],
            [-50, -47],
            [-33, 1],
            [-90, -40],
            [-35, -32],
            [-10, -41],
            [-122, -32],
            [-120, 18],
            [89, 40],
            [41, 43],
            [-17, 58],
            [-5, 118],
            [-29, -19],
            [-28, 39],
            [-13, 77],
            [32, 46],
            [27, 83],
            [1, 41],
            [-25, 70],
            [-71, 148],
            [-32, 111],
            [-55, 59],
            [87, 184],
            [-39, -11],
            [-63, -111],
            [-40, -55],
            [30, -95],
            [-21, -76],
            [-50, 2],
            [-45, -40],
            [-105, -43],
            [-143, -24],
            [-70, 3],
            [-72, 50],
            [3, 54],
            [-105, 87],
            [-59, 86],
            [-42, 2],
            [-81, 59],
            [11, 49],
            [-101, 22],
            [104, 111],
            [36, 74],
            [29, 11],
            [134, -54],
            [33, -39],
            [-14, -66],
            [96, 89],
            [32, -12],
            [51, -87],
            [62, 42],
            [33, 52],
            [-72, 67],
            [-29, 51],
            [-76, -58],
            [-138, 3],
            [-96, 34],
            [-96, -6],
            [-34, 25],
            [92, 67],
            [-62, 5],
            [-97, 65],
            [3, -59],
            [-57, -2],
            [-38, 110],
            [-54, 20],
            [-13, 38],
            [34, 49],
            [-51, 33],
            [-59, -3],
            [16, 56],
            [82, 19],
            [-57, 38],
            [-18, 31],
            [144, 37],
            [-29, 32],
            [-12, 47],
            [12, 50],
            [80, 113],
            [78, 95],
            [60, 33],
            [68, -29],
            [-20, 56],
            [16, 23],
            [-16, 99],
            [25, 95],
            [27, 28],
            [93, 18],
            [-46, 41],
            [35, 49],
            [93, 26],
            [51, -8],
            [64, -30],
            [37, -38],
            [80, -44],
            [91, 19],
            [35, 19],
            [44, 51],
            [57, 33],
            [81, 105],
            [24, 42],
            [52, 3],
            [43, -45],
            [145, 8],
            [74, 16],
            [51, 34],
            [84, 96],
            [15, 50],
            [-39, 118],
            [-26, 123],
            [-71, 81],
            [-51, 24],
            [-9, 48],
            [68, -5],
            [81, 35],
            [29, 57],
            [-15, 63],
            [-55, 61],
            [-38, 11],
            [-86, -72],
            [-91, 12],
            [-33, -41],
            [-94, -36],
            [-50, -37],
            [-146, -133],
            [-22, 80],
            [-101, 75],
            [-30, -25],
            [40, -41],
            [37, -7],
            [-28, -54],
            [-106, 70],
            [-70, 22],
            [-182, -3],
            [-184, -68],
            [-74, 2],
            [-95, 27],
            [-215, 39],
            [-56, 24],
            [-48, 57],
            [22, 55],
            [-2, 55],
            [-42, 15],
            [-85, 80],
            [20, 22],
            [71, 11],
            [25, 51],
            [78, 33],
            [-127, 26],
            [-17, -8],
            [-228, 47],
            [-180, 81],
            [-31, 50],
            [157, 56],
            [54, 56],
            [102, 10],
            [101, 98],
            [107, 51],
            [57, 15],
            [64, -27],
            [88, -5],
            [50, 30],
            [-86, 44],
            [19, 41],
            [101, 50],
            [119, 16],
            [121, 65],
            [65, 19],
            [125, 12],
            [75, -15],
            [12, -29],
            [-39, -85],
            [2, -51],
            [-43, -40],
            [105, -73],
            [161, -5],
            [88, 13],
            [93, -27],
            [115, 12],
            [86, -16],
            [37, 6],
            [80, 110],
            [31, 17],
            [79, -35],
            [40, 42],
            [-16, 22],
            [-130, 41],
            [-88, -20],
            [-27, 23],
            [9, 45],
            [-94, 111],
            [-85, 24],
            [-44, 89],
            [76, 29],
            [34, -16],
            [37, -65],
            [36, -10],
            [-11, -65],
            [44, -60],
            [98, -56],
            [79, 21],
            [89, -13],
            [81, -50],
            [41, -6],
            [130, 26],
            [-10, 85],
            [-30, 22],
            [-87, -4],
            [-68, 37],
            [-58, -10],
            [-107, -56],
            [-54, 22],
            [-88, 60],
            [-7, 58],
            [80, 98],
            [-31, 23],
            [-75, 16],
            [-132, -16],
            [-114, 9],
            [-74, -5],
            [-164, 42],
            [-58, 52],
            [-69, 157],
            [-56, 72],
            [-389, 244],
            [-177, 62],
            [-86, 68],
            [-104, 24],
            [1, 22],
            [59, 36],
            [30, 83],
            [31, 125],
            [-8, 49],
            [216, -10],
            [143, 8],
            [229, 30],
            [134, 56],
            [103, 74],
            [115, 122],
            [21, 124],
            [44, 82],
            [186, 188],
            [145, 132],
            [74, -54],
            [199, 39],
            [112, 79],
            [159, 81],
            [48, -13],
            [-45, -53],
            [32, -14],
            [-28, -64],
            [74, -5],
            [12, 96],
            [22, 19],
            [-67, 58],
            [87, 85],
            [113, 51],
            [98, -43],
            [116, -1],
            [42, 23],
            [150, 3],
            [121, 53],
            [127, 85],
            [127, 126],
            [67, 12],
            [30, -28],
            [203, -57],
            [51, -3],
            [21, -35],
            [-70, -70],
            [-105, -37],
            [84, -52],
            [91, 33],
            [127, 114],
            [69, -9],
            [83, -53],
            [-34, -52],
            [57, -26],
            [125, -26],
            [86, 42],
            [129, 8],
            [82, 23],
            [138, -31],
            [91, 2],
            [80, -39],
            [-63, -43],
            [-11, -44],
            [62, -22],
            [30, -32],
            [125, 2],
            [-54, -61],
            [222, -18],
            [30, 18],
            [143, 33],
            [80, -37],
            [78, 0],
            [87, 36],
            [185, -5],
            [131, -42],
            [49, -5],
            [64, -55],
            [71, 22],
            [118, -30],
            [50, -48],
            [198, -26],
            [99, 12],
            [143, -3],
            [69, -17],
            [72, 2],
            [118, -60],
            [75, -24],
            [179, -15],
            [62, 32],
            [109, 8],
            [98, 27],
            [120, -7],
            [43, 15],
            [158, -46],
            [88, -53],
            [39, -38],
            [184, -56],
            [90, -65],
            [125, -2]
        ],
        [
            [73905, 75352],
            [-72, -222],
            [12, -51],
            [21, -38],
            [105, -137],
            [-25, -54],
            [-8, -53],
            [83, 19],
            [34, 29],
            [-10, 46],
            [27, 11],
            [18, 39],
            [-12, 104],
            [18, 142]
        ],
        [[73344, 73690], [-21, 55], [-49, 41], [-36, -18], [-28, -66], [-29, -134]],
        [
            [73644, 75573],
            [-9, -46],
            [-48, -114],
            [-41, -151],
            [-12, -73],
            [19, -80],
            [-13, -126],
            [19, -31],
            [47, 19],
            [34, 48],
            [36, 73],
            [-25, 24],
            [11, 29],
            [39, -5],
            [-10, 40],
            [2, 60],
            [16, 59],
            [-46, -15],
            [43, 100],
            [-19, 41],
            [-5, 45],
            [11, 64]
        ],
        [[36677, 57518], [-32, 28], [3, 44], [27, 38], [18, -35], [-4, -50], [-12, -25]],
        [[36732, 55125], [-20, -11], [-2, 56], [47, 68], [21, -41], [-21, -54], [-25, -18]],
        [[36786, 55276], [-37, -18], [11, 41], [38, 22], [-12, -45]],
        [[35431, 56262], [-17, -12], [-30, 12], [-6, 38], [25, 0], [28, -38]],
        [
            [35852, 56387],
            [9, -72],
            [-31, -63],
            [-42, -2],
            [-33, 41],
            [-18, -9],
            [-44, 11],
            [4, 50],
            [42, 19],
            [31, -44],
            [26, -3],
            [7, 38],
            [35, 55],
            [14, -21]
        ],
        [
            [33546, 56795],
            [-30, -60],
            [-22, -20],
            [-118, -51],
            [-27, -32],
            [3, -87],
            [35, -125],
            [13, -30],
            [46, -68],
            [-27, -11],
            [12, -88],
            [29, -61],
            [1, -39],
            [-22, -119],
            [-40, -71],
            [-28, -83],
            [-22, -33],
            [-48, -163],
            [37, -97],
            [5, -49],
            [32, -70],
            [35, -52],
            [-7, -47],
            [13, -65],
            [16, -34],
            [47, -14],
            [73, 43],
            [66, 124],
            [2, 91],
            [8, 109],
            [-9, 71],
            [-39, 101],
            [-17, 72],
            [-38, 67],
            [-40, 199],
            [-9, 88],
            [26, 32],
            [-3, 71],
            [64, 20],
            [137, 117],
            [85, 29],
            [96, 62],
            [23, 31],
            [19, 51],
            [15, 6],
            [50, -48],
            [25, 17],
            [10, 37],
            [-14, 73],
            [-28, 0],
            [-87, -26],
            [-9, 58],
            [-20, 87],
            [25, 119],
            [62, 44],
            [27, -35],
            [26, -67],
            [7, -88],
            [14, -90],
            [16, -62],
            [25, -47],
            [32, 11],
            [91, 10],
            [55, -32],
            [70, -16],
            [65, -68],
            [67, -83],
            [17, -60],
            [6, -58],
            [16, -39],
            [-16, -39],
            [9, -67],
            [19, -67],
            [29, -42],
            [83, -12],
            [90, 29],
            [138, 26],
            [44, 22],
            [229, 12],
            [44, -32],
            [5, -57],
            [73, -119],
            [61, -17],
            [51, -38],
            [111, -50],
            [86, 15],
            [205, 201],
            [109, -5],
            [32, 30],
            [-41, 31],
            [-91, 12],
            [-27, -21],
            [-16, 52],
            [30, -1],
            [101, 17],
            [116, -12],
            [95, 37],
            [48, 6],
            [27, -7],
            [76, 24],
            [142, -28],
            [112, 23],
            [-13, -33],
            [-37, -20],
            [-60, -7],
            [-45, -48],
            [-97, 9],
            [-46, -31],
            [0, -50],
            [19, -11],
            [23, -37],
            [14, -74],
            [-10, -55],
            [29, 9],
            [0, 56],
            [26, -23],
            [36, -144],
            [24, -75],
            [41, 33],
            [21, 79],
            [32, -16],
            [34, -48],
            [22, -49],
            [1, -27],
            [31, -17],
            [-10, 62],
            [43, 1],
            [11, 44],
            [24, -26],
            [63, -120],
            [23, -20],
            [68, -23],
            [43, -57],
            [25, -52],
            [-15, -54],
            [-40, -27],
            [-25, -67],
            [-22, -140],
            [-38, -136],
            [-115, -1],
            [54, -50],
            [43, -55],
            [34, 44],
            [49, 3],
            [53, 47],
            [19, 8],
            [99, -25],
            [24, 35],
            [20, 10],
            [53, -6],
            [46, -38]
        ],
        [[35569, 60103], [26, -25], [-2, -24], [-62, -3], [1, 39], [37, 13]],
        [[87680, 55975], [6, -28], [-2, -65], [-18, -109], [-20, 119], [-26, 52], [36, 51], [24, -20]],
        [[88596, 61749], [-13, -2], [-24, 45], [13, 24], [28, -17], [-4, -50]],
        [[88773, 62011], [-45, -70], [-17, 1], [23, 98], [39, -29]],
        [
            [88887, 62173],
            [-51, -6],
            [-31, -51],
            [-92, -67],
            [-10, -51],
            [-7, -77],
            [-59, -59],
            [-27, 28],
            [-59, -28],
            [-38, 23],
            [-27, -17],
            [24, -126],
            [-62, -116],
            [7, -75],
            [-17, -57],
            [-38, -47],
            [-71, -119],
            [-32, -3],
            [-24, -26],
            [-53, -197],
            [0, -67],
            [-8, -49],
            [1, -47],
            [-23, -93],
            [-24, -39],
            [-5, -51],
            [82, -258],
            [55, -104],
            [54, -54],
            [53, -93],
            [27, -59],
            [-12, -41],
            [6, -86],
            [79, -196],
            [59, -82],
            [60, -92],
            [18, -88],
            [54, -58],
            [60, -84],
            [-3, -19],
            [57, -68],
            [24, -47],
            [10, -45],
            [60, 5],
            [18, -49],
            [26, -45],
            [12, -40],
            [18, -1],
            [5, -56],
            [34, -65],
            [16, -61],
            [41, -99],
            [29, -57],
            [46, -59],
            [23, -110],
            [13, -100],
            [26, -110],
            [19, -49],
            [1, -91],
            [15, -94],
            [17, -63],
            [5, -65],
            [29, -166],
            [-17, -1],
            [2, -147],
            [11, -78],
            [-5, -96],
            [11, -33],
            [21, -108],
            [15, -39],
            [-1, -132],
            [-27, 18],
            [-36, -59],
            [27, -142],
            [-30, 14],
            [2, -191],
            [13, -45],
            [-17, -11],
            [-14, -76],
            [13, -62],
            [-20, -69],
            [-29, -5],
            [-16, -143],
            [-51, -12],
            [-38, -65],
            [-46, -24],
            [-41, -64],
            [-45, -59],
            [-55, -21],
            [-28, -99],
            [-49, -11],
            [-86, -81],
            [-29, -38],
            [-65, -49],
            [-21, 41],
            [-32, 15],
            [-32, 67],
            [-6, -99],
            [-20, -33],
            [-27, 28],
            [-27, 57],
            [-37, -39],
            [42, -11],
            [11, -38],
            [-6, -45],
            [-35, -4],
            [-13, -32],
            [39, -21],
            [17, -43],
            [-39, -70],
            [0, -50],
            [-19, -23],
            [-46, 44],
            [-81, 113],
            [99, -179],
            [18, -59],
            [3, -41],
            [-28, -46],
            [-32, -2],
            [-54, 67],
            [-86, 159],
            [-29, 22],
            [87, -182],
            [29, -96],
            [-12, -59],
            [-206, -169],
            [-31, -73],
            [-24, -90],
            [-41, -50],
            [-23, -46],
            [-69, -25],
            [-38, 8],
            [39, 83],
            [-24, 31],
            [-1, 214],
            [9, 234],
            [18, 117],
            [26, 30],
            [33, 18],
            [-3, 52],
            [-17, 40],
            [-48, 27],
            [-22, 49],
            [-43, -18],
            [-21, 54],
            [-52, 80]
        ],
        [[108000, 38926], [-11, -31], [-38, 22], [4, 27], [32, 3], [13, -21]],
        [[107875, 39286], [-16, -61], [-28, 14], [-40, 83], [9, 73], [28, 9], [7, -72], [40, -46]],
        [[107827, 39620], [-27, -24], [-80, 63], [0, 91], [9, 36], [39, 7], [18, -92], [29, -40], [12, -41]],
        [[107553, 40400], [30, -79], [-6, -64], [-39, -5], [-45, 15], [8, 42], [-37, -3], [35, 88], [54, 6]],
        [[107553, 40826], [4, -32], [-42, 27], [-44, -9], [-18, 63], [4, 30], [20, 24], [51, -92], [25, -11]],
        [[107507, 41072], [-36, -5], [-49, 17], [-29, 48], [42, 27], [31, 55], [41, -142]],
        [
            [107234, 41206],
            [22, -12],
            [4, -27],
            [67, -82],
            [19, -15],
            [19, -61],
            [-24, -37],
            [-46, 10],
            [-26, -42],
            [-24, 10],
            [-15, 87],
            [-6, 86],
            [-20, 72],
            [-30, -22],
            [-21, 42],
            [15, 109],
            [17, 5],
            [25, -23],
            [24, -100]
        ],
        [[107174, 41414], [-38, 21], [7, 35], [36, -12], [-5, -44]],
        [[107481, 41276], [-11, 25], [-17, 137], [19, 96], [26, -214], [-17, -44]],
        [[107388, 41574], [-21, -25], [-38, 2], [-15, 15], [47, 77], [55, 17], [-28, -86]],
        [[107473, 41634], [-18, 6], [-8, 168], [10, 17], [16, -117], [0, -74]],
        [
            [107028, 41914],
            [20, -184],
            [35, 10],
            [13, 43],
            [6, 68],
            [21, -19],
            [5, -55],
            [19, -35],
            [21, -195],
            [-33, -53],
            [-48, 1],
            [-34, -32],
            [-21, 3],
            [0, 35],
            [-19, 29],
            [-21, 61],
            [6, 108],
            [-38, 202],
            [0, 50],
            [13, 66],
            [12, 3],
            [17, -55],
            [26, -51]
        ],
        [[107287, 42230], [-13, -29], [-43, 17], [2, 47], [30, 31], [28, -23], [-4, -43]],
        [[107257, 42427], [-11, -1], [-19, 67], [28, 44], [20, -37], [-1, -54], [-17, -19]],
        [[603, 42198], [-35, 3], [5, 39], [30, -42]],
        [[2638, 42349], [-85, 0], [-56, 25], [-36, 53], [13, 46], [39, 10], [79, -41], [11, -35], [33, -20], [2, -38]],
        [
            [2366, 42673],
            [35, -52],
            [14, -70],
            [-15, -67],
            [-33, 17],
            [-47, -15],
            [-16, 5],
            [-38, 82],
            [-26, 37],
            [23, 31],
            [49, 22],
            [54, 10]
        ],
        [
            [72154, 57227],
            [19, -7],
            [29, 20],
            [83, 2],
            [100, -62],
            [-30, -39],
            [-44, -20],
            [-44, -48],
            [-126, -23],
            [-38, 13],
            [-30, 46],
            [-57, 60],
            [36, 73],
            [32, 29],
            [32, -5],
            [38, -39]
        ],
        [[68766, 57971], [-28, 20], [21, 34], [7, -54]],
        [
            [71945, 59464],
            [-156, -100],
            [-41, -44],
            [-37, -54],
            [-28, -68],
            [-19, -120],
            [15, -109],
            [-2, -59],
            [-78, -67],
            [-41, -42],
            [-26, -11],
            [-44, -58],
            [-87, -61],
            [-95, -48],
            [-151, -57],
            [-58, -62],
            [-53, -42],
            [-80, -13],
            [-111, -59],
            [-61, -47],
            [-76, -77],
            [-17, -24],
            [-14, -57],
            [-69, -129],
            [-34, -41],
            [-68, -25],
            [-53, -4],
            [-89, 28],
            [-41, -51],
            [-69, -55],
            [-69, -110],
            [-51, -29],
            [-83, -34],
            [-57, -46],
            [-39, -18],
            [-50, -10],
            [-92, 5],
            [-88, -17],
            [-81, -31],
            [-38, -58],
            [-43, -93],
            [-71, -38],
            [-39, -102],
            [-87, -29],
            [-43, 30],
            [-80, -83],
            [-30, -14],
            [-46, -3],
            [-32, -17],
            [-24, 5],
            [-29, 32],
            [-62, 39],
            [-45, -25],
            [-4, 78],
            [-75, 238],
            [15, 208],
            [-15, 122],
            [-44, 85],
            [1, 108],
            [-27, 155],
            [5, 40],
            [-34, 172],
            [7, 42],
            [-25, 109],
            [-61, 55],
            [13, 53],
            [28, -34],
            [3, 59],
            [-25, 158],
            [38, 210],
            [-13, 190]
        ],
        [[67245, 24006], [-14, -10], [-62, 9], [-7, 21], [29, 47], [33, -7], [30, -36], [-9, -24]],
        [
            [65710, 35211],
            [-11, -129],
            [-44, -202],
            [-15, -92],
            [-38, -330],
            [-49, -167],
            [-28, -69],
            [-80, -121],
            [-42, -41],
            [-35, -14],
            [-136, -245],
            [-51, -119],
            [-46, -173],
            [-45, -95],
            [-66, -202],
            [-115, -299],
            [-98, -196],
            [-44, -57],
            [-29, -26],
            [-78, -114],
            [-110, -183],
            [-84, -162],
            [-125, -185],
            [-73, -80],
            [-109, -159],
            [-30, -23],
            [-123, -148],
            [-89, -89],
            [-143, -104],
            [-57, -29],
            [-135, 26],
            [-57, -14],
            [-48, -63],
            [-4, -90],
            [-50, -9],
            [-95, 37],
            [-51, -7],
            [-30, -48],
            [-24, -61],
            [-72, -3],
            [-127, 63],
            [-150, 39],
            [-34, 4],
            [-73, -47],
            [-25, -7],
            [-106, 10],
            [-59, 30],
            [-56, 0],
            [-43, -24],
            [-52, -9],
            [-141, -169],
            [-73, 0],
            [-63, -20],
            [-31, 1],
            [-58, 23],
            [-55, -12],
            [-33, -30],
            [-76, -13],
            [-29, -25],
            [-128, -155],
            [-53, 17],
            [-66, 2],
            [-96, 101],
            [2, 44],
            [-26, 45],
            [-30, -3],
            [-16, 37],
            [-45, 4],
            [-37, -11],
            [-7, 142],
            [-31, 20],
            [-54, -7],
            [-22, -46],
            [0, -100],
            [-34, 88],
            [-6, 64],
            [7, 76],
            [34, 28],
            [-10, 95],
            [-53, 165],
            [-32, 35],
            [-25, 85],
            [-26, 30],
            [-10, 59],
            [-25, 48],
            [-9, 74],
            [14, 43],
            [22, 24],
            [22, -37],
            [27, 14],
            [39, 54],
            [23, 82],
            [1, 131],
            [-6, 82],
            [-30, 212],
            [-15, 49],
            [-70, 152],
            [-80, 203],
            [-102, 320],
            [-49, 192],
            [-74, 388],
            [-65, 220],
            [-79, 205],
            [-11, 14]
        ],
        [[64623, 37806], [92, 27], [74, -21], [89, -60], [83, -21], [78, 17], [63, 4], [49, -9], [38, -21], [28, -32]],
        [[64003, 40367], [-22, -43]],
        [
            [64942, 41459],
            [-206, -1],
            [-75, -29],
            [-61, -44],
            [-74, -70],
            [-42, -48],
            [-12, -27],
            [-5, -59],
            [0, -92],
            [-8, -66],
            [-22, -60]
        ],
        [
            [64437, 40963],
            [-43, 21],
            [-71, -51],
            [-29, 10],
            [-16, -34],
            [-22, -14],
            [-2, -30],
            [-39, -61],
            [-21, -1],
            [-23, 28],
            [-33, -28],
            [12, -46],
            [-35, -15],
            [-9, -77],
            [-25, -3],
            [-55, -127],
            [-26, -89],
            [-2, -51],
            [-52, -77],
            [-20, -46],
            [-3, -42],
            [-23, -62]
        ],
        [
            [63900, 40168],
            [-75, -46],
            [-62, 10],
            [-75, 52],
            [-60, 10],
            [-45, -32],
            [-40, 10],
            [-38, 52],
            [-31, 19],
            [-26, -14],
            [-32, 2],
            [-60, 29]
        ],
        [
            [64998, 45598],
            [-9, -52],
            [-27, -39],
            [1, -64],
            [32, -9],
            [32, 6],
            [41, -42],
            [67, -116],
            [19, 6],
            [15, 28],
            [17, -3],
            [0, 67]
        ],
        [[63900, 40168], [17, 1], [64, 155]],
        [
            [64003, 40367],
            [30, 19],
            [1, 19],
            [37, 46],
            [40, 136],
            [42, 34],
            [36, 59],
            [28, -14],
            [17, 40],
            [-6, 26],
            [21, 60],
            [58, 28],
            [35, -42],
            [17, 59],
            [45, 33],
            [13, -42],
            [20, -19],
            [21, 21],
            [12, 53],
            [20, -7],
            [17, 43],
            [-14, 20],
            [-27, 2],
            [-29, 22]
        ],
        [[90495, 35655], [-8, -24], [-60, 174], [-17, 119], [12, 21], [11, 7], [35, -165], [11, -37], [0, -39], [16, -56]],
        [[91194, 38590], [-18, -43], [-22, 8], [-3, 22], [14, 36], [25, 44], [7, -27], [-3, -40]],
        [[94018, 41593], [-11, -15], [-11, 4], [-1, 22], [-12, 24], [11, 40], [10, -1], [4, -23], [13, -25], [-3, -26]],
        [[94204, 42052], [-20, -35], [-13, 28], [8, 56], [13, 20], [12, -11], [0, -58]],
        [[95378, 41890], [0, -6205]],
        [[95378, 35685], [0, -3175]],
        [
            [95378, 32510],
            [-17, -5],
            [-124, -104],
            [-148, -99],
            [-120, -48],
            [-110, -63],
            [-73, -18],
            [-94, -8],
            [-199, 30],
            [-67, -22],
            [-108, -116],
            [-32, -29],
            [-61, -32],
            [-157, -149],
            [-72, -32],
            [-47, -11],
            [-40, -31],
            [-36, -64],
            [-49, -177],
            [-31, -83],
            [-67, -134],
            [-44, -45],
            [-44, 6],
            [-49, -46],
            [-43, 49],
            [-34, 9],
            [-55, -4],
            [-194, -56],
            [-28, 66],
            [-35, 9],
            [-67, -3],
            [-100, 20],
            [-182, -25],
            [-88, -27],
            [-35, -24],
            [-64, 16],
            [-110, -22],
            [-38, -38],
            [-29, -33],
            [-57, -149],
            [-63, -49],
            [-51, -2],
            [-58, -11],
            [-116, -143],
            [-118, -140],
            [-40, -14],
            [-44, -24],
            [-58, -11],
            [-29, -13],
            [-135, 36],
            [-86, 4],
            [-108, 22],
            [-93, 68],
            [-71, 39],
            [-80, 150],
            [-50, 56],
            [-88, 68],
            [-26, -2],
            [-21, -19],
            [-36, 48],
            [-1, 62],
            [-10, 52],
            [0, 138],
            [6, 161],
            [32, -36],
            [26, -36],
            [55, 2],
            [48, 61],
            [27, 89],
            [25, 100],
            [-4, 106],
            [-16, 187],
            [11, 39],
            [16, 16],
            [6, 93],
            [4, 286],
            [-13, 108],
            [-75, 219],
            [-49, 190],
            [-37, 85],
            [-30, 138],
            [-26, 192],
            [-8, 97],
            [-8, 179],
            [9, 101],
            [-4, 60],
            [-31, 162],
            [-71, 151],
            [-11, 56],
            [0, 59],
            [-17, 68],
            [-57, 139],
            [-58, 119],
            [-10, 58],
            [-10, 241],
            [-22, 110],
            [-99, 278],
            [-116, 240],
            [-31, 99],
            [-14, 33],
            [8, 4],
            [13, -13],
            [14, -24],
            [14, 18],
            [-1, 46],
            [4, 25],
            [11, -14],
            [11, -51],
            [37, -133],
            [11, -68],
            [47, -21],
            [14, 18],
            [18, 35],
            [5, 94],
            [-24, 42],
            [-21, 18],
            [-37, 70],
            [-23, 112],
            [-36, 103],
            [0, 37],
            [17, 27],
            [27, -15],
            [25, -59],
            [29, -55],
            [-5, -97],
            [-5, -27],
            [3, -22],
            [23, -38],
            [14, 25],
            [13, 56],
            [8, -7],
            [19, -129],
            [16, -35],
            [30, -40],
            [27, 31],
            [12, 27],
            [-4, 91],
            [8, 88],
            [-5, 65],
            [-68, 171],
            [-62, 211],
            [-37, 105],
            [-32, 159],
            [-20, 55],
            [-27, 88],
            [-1, 102],
            [3, 67],
            [21, 147],
            [19, 76],
            [63, 176],
            [3, 75],
            [0, 57],
            [9, 88],
            [0, 61],
            [-8, 56],
            [-27, 98],
            [35, 170],
            [50, 219],
            [20, 32],
            [31, 30],
            [6, -45],
            [-15, -152],
            [22, -79],
            [-7, -89],
            [20, 15],
            [30, 17],
            [23, 47],
            [12, 45],
            [57, 178],
            [33, 66],
            [46, 49],
            [94, 58],
            [91, 78],
            [43, 74],
            [54, 65],
            [38, 70],
            [36, 48],
            [184, 177],
            [31, 33],
            [40, 4],
            [49, -6],
            [44, 9],
            [48, -40],
            [35, -5],
            [85, 44],
            [46, 39],
            [79, 86],
            [34, 24],
            [80, 27],
            [91, 36],
            [109, 149],
            [78, -9],
            [70, -15],
            [56, 45],
            [133, 27],
            [73, 38],
            [137, 98],
            [37, 34],
            [56, 71],
            [49, 88],
            [48, 119],
            [30, 106],
            [13, 55],
            [28, 88],
            [19, 69],
            [15, 33],
            [53, 46],
            [79, 131],
            [26, 26],
            [5, 42],
            [-17, 24],
            [-21, 14],
            [-14, 139],
            [-14, 95],
            [-1, 67],
            [5, 64],
            [31, 100],
            [22, 42],
            [31, 50],
            [28, 15],
            [23, 44],
            [38, 43],
            [16, 43],
            [23, 88],
            [21, 67],
            [17, -3],
            [32, -155],
            [21, -82],
            [38, -97],
            [36, -143],
            [30, -65],
            [14, -43],
            [12, -19],
            [3, 27],
            [-3, 32],
            [14, 109],
            [-7, 76],
            [2, 29],
            [8, 13],
            [14, -9],
            [28, -42],
            [14, -16],
            [10, 4],
            [-1, 69],
            [14, 44],
            [-5, 30],
            [-25, -2],
            [-10, 37],
            [-20, 43],
            [-22, 31],
            [-28, 71],
            [-8, 28],
            [10, 13],
            [18, -2],
            [13, 31],
            [7, 41],
            [-12, 66],
            [12, 25],
            [25, -7],
            [40, -106],
            [18, 10],
            [14, 43],
            [26, 12],
            [26, -8],
            [17, -30],
            [36, -31],
            [47, 4],
            [23, -7],
            [51, 5],
            [24, -10],
            [-4, 17],
            [-28, 19],
            [-30, 4],
            [-36, -2],
            [-15, 20],
            [-5, 54],
            [14, 55],
            [23, -7],
            [21, 1],
            [2, 53],
            [8, 46],
            [12, 37],
            [0, 36],
            [-13, -9],
            [-32, -84],
            [-15, 68],
            [-22, 52],
            [4, 73],
            [14, 74],
            [20, 10],
            [17, -11],
            [26, 43],
            [14, 33],
            [-3, 27],
            [4, 21],
            [17, -7],
            [69, -66],
            [14, -35],
            [14, 14],
            [5, 38],
            [-2, 37],
            [-15, -5],
            [-36, 3],
            [-8, 22],
            [3, 17],
            [-16, 45],
            [23, 28],
            [20, 2],
            [14, 19],
            [0, 27],
            [51, -12],
            [35, -34],
            [16, -7],
            [6, 18],
            [3, 40],
            [-43, 39],
            [-2, 39],
            [-18, 45],
            [0, 44],
            [27, 37],
            [5, 36],
            [16, 15],
            [31, 1],
            [21, 30],
            [23, 11],
            [6, 67],
            [0, 47],
            [9, 12],
            [24, -19],
            [-7, -54],
            [0, -52],
            [3, -25],
            [14, 45],
            [25, -14],
            [10, -71],
            [12, -12],
            [17, 55],
            [24, 14],
            [-2, 69],
            [9, 49],
            [3, 37],
            [14, 18],
            [4, 39],
            [-12, 28],
            [-6, 49],
            [20, 11],
            [20, -25],
            [14, -62],
            [9, -28],
            [12, 15],
            [8, 41],
            [25, 24],
            [24, -33],
            [27, -46],
            [34, 40],
            [31, 75],
            [-5, 46],
            [4, 47],
            [39, 25],
            [32, -19],
            [28, -50],
            [60, -38],
            [51, -54],
            [23, -35],
            [44, -56],
            [27, -58],
            [39, -103],
            [90, -127],
            [6, -22],
            [-12, -42],
            [-11, -54],
            [-14, -92],
            [-3, -134],
            [13, 9],
            [13, 49],
            [15, -10],
            [16, -31],
            [1, 30],
            [-9, 17],
            [-17, 62],
            [1, 33],
            [13, 27],
            [20, 31],
            [23, 21],
            [14, 18],
            [2, 23],
            [21, 23],
            [30, 7],
            [19, -3],
            [113, -50]
        ],
        [
            [95378, 41890],
            [17, -8],
            [33, -58],
            [3, -71],
            [13, -25],
            [7, 45],
            [-2, 97],
            [11, 19],
            [35, -15],
            [24, -19],
            [33, -64],
            [7, -31],
            [14, -21],
            [5, 30],
            [-7, 42],
            [-5, 48],
            [8, 42],
            [39, 3],
            [26, 9],
            [-12, 16],
            [-17, 6],
            [-28, 38],
            [-18, 41],
            [29, 40],
            [0, 10],
            [-28, -1],
            [-38, 39],
            [-33, 54],
            [25, 100],
            [49, 98],
            [28, 32],
            [3, 33],
            [13, 61],
            [9, 51],
            [2, 40],
            [13, 42],
            [31, 40],
            [41, 14],
            [20, 16],
            [19, 36],
            [19, 45],
            [-39, 87],
            [4, 49],
            [7, 56],
            [46, 42],
            [25, 109],
            [17, 16],
            [36, -3],
            [14, 9],
            [-2, 87],
            [4, 34],
            [15, 13],
            [20, -11],
            [12, -38],
            [29, -35],
            [9, 19],
            [-5, 38],
            [-3, 49],
            [26, 11],
            [21, 3],
            [2, 40],
            [-4, 32],
            [9, 13],
            [53, 7],
            [14, 33],
            [8, 28],
            [7, -15],
            [9, -64],
            [30, -37],
            [89, -1],
            [50, 26],
            [21, -15],
            [33, -12],
            [36, 30],
            [22, 22],
            [37, -29],
            [12, -31],
            [9, 66],
            [22, 23],
            [22, 14],
            [29, -11],
            [11, 3],
            [-25, 50],
            [1, 44],
            [-1, 67],
            [4, 60],
            [9, 44],
            [-61, 88],
            [-61, 13],
            [-45, -18],
            [-18, 14],
            [-40, 70],
            [-38, 26],
            [-3, 17],
            [46, 51],
            [18, -9],
            [27, -47],
            [15, -17],
            [13, 4],
            [9, 37],
            [11, 19],
            [22, -11],
            [69, -80],
            [39, -77],
            [20, 20],
            [34, 44],
            [32, -9],
            [20, -26],
            [27, -94],
            [22, -47],
            [53, -12],
            [27, -18],
            [27, -31],
            [38, 2],
            [77, -11],
            [72, -60],
            [31, -38],
            [35, -10],
            [20, -15],
            [38, -5],
            [59, 43],
            [26, -39],
            [12, -27],
            [54, -51],
            [58, -15],
            [42, 51],
            [61, 38],
            [42, 59],
            [31, 27],
            [30, 48],
            [12, -3],
            [-25, -44],
            [-2, -25],
            [19, -11],
            [-2, -13],
            [-27, -34],
            [-31, -54],
            [1, -33],
            [12, -18],
            [14, 8],
            [21, 28],
            [25, 14],
            [21, -22],
            [7, -77],
            [16, -51],
            [34, -7],
            [21, 0],
            [21, 72],
            [-11, 61],
            [-13, 13],
            [6, 23],
            [54, 100],
            [30, -3],
            [21, -98],
            [34, -52],
            [36, 4],
            [19, -14],
            [15, -59],
            [-126, -242],
            [-6, -27],
            [17, -44],
            [6, -52],
            [-41, -123],
            [-15, -6],
            [-15, 33],
            [-21, 22],
            [-20, -15],
            [-20, -9],
            [-74, -69],
            [1, -177],
            [19, -105],
            [-11, -70],
            [-22, -121],
            [-24, -46],
            [-19, -29],
            [-64, -166],
            [-20, -40],
            [-21, -57],
            [7, -54],
            [8, -38],
            [24, -43],
            [93, -89],
            [42, -61],
            [73, -74],
            [17, -52],
            [10, -41],
            [52, -48],
            [38, -29],
            [19, 18],
            [18, -6],
            [-1, -37],
            [-4, -20],
            [3, -26],
            [27, -33],
            [43, 1],
            [24, 8],
            [27, -35],
            [25, -23],
            [40, -47],
            [70, -56],
            [55, -37],
            [64, -136],
            [28, -44]
        ],
        [[98156, 40950], [0, -1], [0, -5264]],
        [[98156, 35685], [-2778, 0]],
        [
            [97875, 41384],
            [-13, -26],
            [-17, 27],
            [-3, 28],
            [-13, 8],
            [6, 25],
            [7, 8],
            [7, 32],
            [17, -38],
            [2, -42],
            [7, -22]
        ],
        [[97720, 41467], [-23, 1], [-4, 24], [6, 23], [20, 5], [8, -6], [-7, -47]],
        [[97804, 41472], [-5, 42], [9, 23], [5, -48], [-9, -17]],
        [
            [97758, 42484],
            [14, -23],
            [14, 2],
            [13, 51],
            [14, -20],
            [4, -23],
            [-19, -38],
            [-9, -6],
            [-8, -22],
            [-13, -71],
            [1, -23],
            [12, -24],
            [30, -22],
            [20, 7],
            [-6, -34],
            [-11, -26],
            [-41, 11],
            [-35, -4],
            [-58, 25],
            [-30, 3],
            [-9, 10],
            [18, 20],
            [11, 28],
            [-5, 64],
            [4, 81],
            [34, 40],
            [15, 41],
            [22, 25],
            [14, -3],
            [-1, -25],
            [5, -44]
        ],
        [[97611, 42473], [-7, -7], [-28, 11], [3, 36], [8, 9], [17, 40], [13, -23], [6, -48], [-12, -18]],
        [[97642, 43712], [-49, -42], [27, 56], [56, 50], [7, -12], [-28, -41], [-13, -11]],
        [
            [95828, 43669],
            [25, -13],
            [19, -39],
            [1, -25],
            [-32, -10],
            [-57, 35],
            [-58, -29],
            [-17, 0],
            [-10, 21],
            [9, 59],
            [21, -9],
            [18, 22],
            [-3, 65],
            [-11, 35],
            [30, 66],
            [14, 13],
            [14, 0],
            [11, -47],
            [3, -50],
            [14, -45],
            [9, -49]
        ],
        [
            [95877, 43838],
            [41, -5],
            [50, 42],
            [23, -17],
            [11, 3],
            [36, 40],
            [23, 11],
            [16, 30],
            [16, -32],
            [36, -37],
            [12, -39],
            [20, -30],
            [-22, -40],
            [-3, -44],
            [-23, 3],
            [-28, -72],
            [-106, -120],
            [-94, 103],
            [-41, 69],
            [-28, 96],
            [-5, 79],
            [-11, 50],
            [10, 19],
            [8, -1],
            [28, -54],
            [13, -15],
            [18, -39]
        ],
        [
            [97723, 43836],
            [-23, -33],
            [-1, 25],
            [12, 20],
            [27, 82],
            [19, 29],
            [5, 30],
            [2, 45],
            [15, 7],
            [-12, -102],
            [-44, -103]
        ],
        [
            [96486, 43879],
            [-6, -9],
            [-24, 86],
            [6, 27],
            [-10, 44],
            [17, 5],
            [13, 33],
            [4, -16],
            [1, -61],
            [10, -35],
            [-11, -74]
        ],
        [[98156, 35685], [926, 0], [0, -1673]],
        [[99082, 34012], [7, -2813]],
        [[99089, 31199], [-18, 22], [0, -2268]],
        [
            [99071, 28953],
            [-105, 24],
            [-73, 74],
            [-55, 142],
            [-104, 162],
            [-28, 59],
            [-13, 58],
            [-1, 46],
            [14, 87],
            [19, 86],
            [3, 48],
            [-39, 162],
            [-56, 154],
            [-25, 48],
            [-69, 102],
            [-64, 77],
            [-16, 40],
            [-5, 20],
            [30, -10],
            [15, 32],
            [20, 10],
            [16, -41],
            [18, -8],
            [1, 70],
            [10, 33],
            [-13, 29],
            [-28, 15],
            [-30, -23],
            [-24, -30],
            [-31, -26],
            [-13, -26],
            [-32, -1],
            [-13, -7],
            [-64, -51],
            [-41, -2],
            [-63, 18],
            [21, 71],
            [25, 41],
            [21, 48],
            [34, 168],
            [-7, 146],
            [-16, 60],
            [-53, 120],
            [-24, 74],
            [-30, 77],
            [-15, -45],
            [-9, -47],
            [-29, -68],
            [-14, -151],
            [-56, -232],
            [-39, -3],
            [-33, 10],
            [-58, -27],
            [-39, -32],
            [-35, 0],
            [-20, -10],
            [-26, 8],
            [41, 181],
            [35, -5],
            [38, 7],
            [43, -1],
            [20, 83],
            [12, 93],
            [-8, 60],
            [-3, 62],
            [8, 71],
            [3, 51],
            [48, 168],
            [40, 87],
            [47, 69],
            [-5, 66],
            [-15, 82],
            [-4, 63],
            [22, 20],
            [21, 40],
            [-25, 180],
            [-15, 54],
            [-25, 53],
            [0, -69],
            [3, -67],
            [-35, -87],
            [-44, -62],
            [-29, -58],
            [-27, -132],
            [-36, -111],
            [-33, -41],
            [-30, -9],
            [-30, -17],
            [-47, -45],
            [-46, -37],
            [-34, -49],
            [-29, -25],
            [-96, -222],
            [-43, -75],
            [-9, -30],
            [-19, -25],
            [4, -35],
            [15, -24],
            [14, -99],
            [-9, -21],
            [-15, 11],
            [-39, 55],
            [-25, -20],
            [-20, -22],
            [-51, 101],
            [-22, 24],
            [-27, 40],
            [-29, 35],
            [-12, 4],
            [-21, -7],
            [2, 27],
            [14, 23],
            [13, 5],
            [23, -33],
            [27, -29],
            [15, -2],
            [7, 12],
            [-25, 114],
            [-18, 101],
            [-7, 29],
            [-21, 102],
            [-11, 30],
            [-44, 71],
            [-47, 85],
            [-13, 101],
            [-17, 65],
            [-23, 41],
            [-34, 36],
            [-95, 14],
            [-39, 104],
            [-23, 128],
            [18, 9],
            [22, 1],
            [6, 40],
            [-4, 62],
            [-94, 76],
            [-44, 80],
            [-38, 34],
            [-35, 14],
            [-47, -3],
            [-58, 2],
            [-140, 127],
            [-34, 4],
            [-100, -39],
            [-34, 7],
            [-152, 173],
            [-101, 82],
            [-34, 16],
            [-43, 14],
            [-36, -20],
            [-25, -19],
            [-50, -22],
            [-202, 14],
            [-173, -26],
            [-118, -19],
            [-57, -18]
        ],
        [
            [98031, 30254],
            [73, -13],
            [29, 20],
            [36, -16],
            [24, -54],
            [-17, -27],
            [-17, -4],
            [-55, 22],
            [-50, -17],
            [-16, -22],
            [-9, -50],
            [-44, -26],
            [-21, 30],
            [-53, 21],
            [-19, -31],
            [-38, 8],
            [-34, -13],
            [-49, 8],
            [-51, 54],
            [-15, 26],
            [12, 45],
            [18, 33],
            [140, 48],
            [75, 40],
            [60, -7],
            [17, -9],
            [16, -20],
            [-12, -46]
        ],
        [
            [98156, 40950],
            [21, -34],
            [54, -57],
            [80, -39],
            [37, 6],
            [60, -46],
            [59, -22],
            [31, -64],
            [10, -48],
            [3, -37],
            [29, -90],
            [60, -29],
            [77, -89],
            [63, -40],
            [16, -23],
            [27, -27],
            [54, -1],
            [93, 44],
            [43, 45],
            [56, 72],
            [26, 124],
            [16, 99],
            [78, 206],
            [22, 101],
            [20, 136],
            [17, 84],
            [-6, 92],
            [19, 167],
            [53, 306],
            [-7, 114],
            [-24, 213],
            [11, 74],
            [11, 103],
            [-19, 75],
            [-17, 51],
            [-2, 72],
            [19, 136],
            [17, 72],
            [17, 92],
            [-9, 176],
            [37, 61],
            [15, 31],
            [28, 0],
            [14, -14],
            [3, 36],
            [-11, 32],
            [-5, 38],
            [-8, 20],
            [-18, 6],
            [-14, 21],
            [-22, 21],
            [4, 78],
            [36, 152],
            [20, 58],
            [28, -44],
            [2, 43],
            [-5, 45],
            [27, 148],
            [31, 199],
            [9, 183],
            [49, 34],
            [24, 46],
            [16, 53],
            [27, 0],
            [19, -23],
            [-13, -40],
            [-4, -30],
            [53, -76],
            [17, -59],
            [8, -55],
            [10, -51],
            [5, -70],
            [-1, -112],
            [7, -105],
            [19, -33],
            [17, -22],
            [24, -3],
            [35, -16],
            [-8, -68],
            [-15, -52],
            [-2, -32],
            [4, -43],
            [24, -32],
            [20, -21],
            [11, -56],
            [34, -79],
            [-1, -53],
            [19, -67],
            [16, -133],
            [6, -117],
            [18, -78],
            [-12, -166],
            [12, -67],
            [17, -57],
            [20, -112],
            [15, -102],
            [20, -30],
            [43, -34],
            [45, 38],
            [32, 52],
            [34, 12],
            [47, 27],
            [35, -69],
            [19, -77],
            [83, -101],
            [46, -65],
            [35, -37],
            [34, -48],
            [-4, -48],
            [-8, -38],
            [8, -59],
            [5, -69],
            [-6, -83],
            [24, -126],
            [8, -100],
            [25, -98],
            [-2, -100],
            [-5, -38],
            [-3, -57],
            [20, -70],
            [18, -52],
            [28, -56],
            [36, -86],
            [25, -17],
            [23, -1],
            [-3, -88],
            [46, -173],
            [23, -142],
            [-16, -191],
            [-16, -110],
            [3, -54],
            [59, -133],
            [34, -24],
            [-6, -63],
            [-5, -97],
            [27, -76],
            [30, -57],
            [33, -34],
            [32, -26],
            [42, -27],
            [54, -12],
            [28, -42],
            [14, -34],
            [43, -12],
            [19, 6],
            [24, 14],
            [16, -23],
            [12, -30],
            [24, -83],
            [48, -82],
            [34, -14],
            [20, -41],
            [27, -12],
            [24, -5],
            [33, -32],
            [55, -73],
            [49, -12],
            [23, -20],
            [49, -81],
            [19, -43],
            [20, -64],
            [-25, -6],
            [-23, 14],
            [-14, -63],
            [32, -87],
            [38, -61],
            [46, -64],
            [45, -92],
            [11, -69],
            [12, -28],
            [15, -98],
            [39, -58],
            [1, -104],
            [20, -144],
            [22, -130],
            [16, -40],
            [18, -62],
            [21, 8],
            [15, 20],
            [30, -62],
            [17, -28],
            [10, 17],
            [-20, 119],
            [12, 69],
            [12, 9],
            [18, 2],
            [20, -57],
            [29, -60],
            [52, -53],
            [42, -50],
            [12, 1],
            [-5, 39],
            [2, 57],
            [16, 10],
            [16, -29],
            [28, -88],
            [6, -182],
            [0, -153],
            [18, -157],
            [27, -41],
            [18, -39],
            [31, -52],
            [20, -49],
            [26, -23],
            [81, -105],
            [23, -11],
            [36, -3],
            [43, -47],
            [22, -44],
            [48, -163],
            [23, -58],
            [46, -57],
            [22, -18],
            [32, -39],
            [12, -57],
            [2, -33],
            [19, -60],
            [28, -73],
            [42, -40],
            [38, -88],
            [3, -143],
            [19, -71],
            [14, -31],
            [30, -29],
            [12, -23],
            [-25, -189],
            [24, -379],
            [-14, -118],
            [25, -117],
            [58, -203],
            [13, -72],
            [9, -84],
            [18, -54]
        ],
        [
            [102944, 34488],
            [-41, -50],
            [-58, -13],
            [-23, -52],
            [-84, 15],
            [-29, -18],
            [-45, 35],
            [-12, -16],
            [-23, 34],
            [-25, -45],
            [-37, -25],
            [-24, -27],
            [-16, 0],
            [-61, -55],
            [12, -57],
            [20, -38],
            [-14, -94],
            [-28, -28],
            [-24, 3],
            [-10, -30],
            [-19, 15],
            [-10, 32],
            [-54, -38],
            [-8, -44],
            [-16, -29],
            [-26, -29],
            [-18, 19],
            [-10, 69],
            [-22, 46],
            [-35, 26],
            [-18, 26],
            [-3, 26],
            [-21, 27],
            [-39, 28],
            [-44, 12],
            [-75, -7],
            [-40, 49],
            [-59, 3],
            [-91, -26],
            [-55, -4],
            [-25, 25],
            [-26, -7],
            [-13, -16],
            [-11, -27],
            [-30, -37],
            [-50, -47],
            [-28, -38],
            [-8, -29],
            [-26, -40],
            [-2460, 0]
        ],
        [[102951, 34883], [-26, -153], [-8, 3], [-10, 23], [2, 89], [10, 56], [27, -10], [5, -8]],
        [[102922, 34950], [-7, -8], [-14, 53], [-3, 54], [4, 50], [16, 11], [11, -5], [-12, -91], [5, -64]],
        [
            [102809, 35823],
            [-8, -15],
            [-14, 27],
            [-9, 99],
            [7, 58],
            [16, 52],
            [3, 29],
            [-7, 61],
            [46, 68],
            [12, 36],
            [5, 47],
            [-17, 50],
            [-14, 10],
            [12, 28],
            [23, 20],
            [8, -5],
            [5, -99],
            [19, -35],
            [-3, -47],
            [-64, -251],
            [-18, -95],
            [-2, -38]
        ],
        [
            [102213, 37083],
            [11, -14],
            [18, -7],
            [-4, -37],
            [14, -41],
            [7, -29],
            [-18, -31],
            [-16, 20],
            [-47, 117],
            [8, 39],
            [27, -17]
        ],
        [[102019, 37735], [-17, 8], [7, 22], [1, 32], [10, -10], [8, -44], [-9, -8]],
        [[101837, 37807], [-11, -17], [-7, 41], [2, 42], [11, 14], [5, -80]],
        [[101564, 38867], [-17, -6], [-15, 10], [13, 73], [7, -38], [12, -39]],
        [[101531, 38946], [-15, 3], [13, 42], [11, 14], [-3, -50], [-6, -9]],
        [
            [100710, 40016],
            [7, -53],
            [13, -41],
            [-5, -27],
            [-8, -21],
            [-20, 19],
            [-14, 49],
            [-23, 40],
            [-5, 22],
            [27, -2],
            [19, 17],
            [9, -3]
        ],
        [[98606, 40638], [-12, -9], [-4, 23], [16, 23], [10, 33], [21, -29], [3, -29], [-34, -12]],
        [
            [98621, 40940],
            [-24, -49],
            [-12, 7],
            [-12, -27],
            [-22, -12],
            [-13, 0],
            [-25, -13],
            [-4, 16],
            [5, 49],
            [20, 55],
            [20, 33],
            [51, 16],
            [40, 25],
            [5, -5],
            [29, -62],
            [-42, -8],
            [-16, -25]
        ],
        [[99475, 44212], [-26, -32], [-17, 17], [-3, 36], [1, 15], [21, 27], [24, -63]],
        [[99494, 44498], [-18, -34], [-19, 10], [-7, 20], [7, 28], [25, 5], [12, -29]],
        [[99442, 44519], [-8, -15], [-14, 33], [16, 39], [13, -18], [-7, -39]],
        [[101043, 25984], [-15, -58], [-23, 10], [-24, -10], [-15, 39], [17, 0], [22, 56], [16, 29], [9, -1], [13, -65]],
        [[101067, 26071], [-26, 5], [-9, 48], [10, 37], [14, -22], [11, -68]],
        [[101274, 26367], [-23, -3], [-2, 42], [15, 26], [22, -12], [8, -20], [-21, -16], [1, -17]],
        [
            [100329, 27439],
            [36, -2],
            [20, 14],
            [18, -2],
            [21, -32],
            [24, -17],
            [18, 3],
            [14, -7],
            [14, -22],
            [33, -19],
            [15, -13],
            [27, -35],
            [90, -52],
            [63, -26],
            [80, 12],
            [23, 15],
            [23, 21],
            [19, -20],
            [16, 3],
            [6, 28],
            [19, 23],
            [22, 14],
            [36, -1],
            [35, 6],
            [15, 13],
            [16, 2],
            [21, -16],
            [20, -9],
            [15, 20],
            [24, 50],
            [13, 17],
            [60, -15],
            [18, 0],
            [29, 51],
            [20, 0],
            [56, -42],
            [24, -51],
            [-2, -94],
            [6, -65],
            [2, -65],
            [-7, -65],
            [-1, -50],
            [3, -51],
            [-2, -94],
            [8, -63],
            [-4, -62],
            [12, -40],
            [-3, -27],
            [3, -31],
            [-3, -26],
            [-13, 4],
            [-4, 20],
            [3, 25],
            [-9, 40],
            [-23, 21],
            [18, 24],
            [-8, 29],
            [-15, -24],
            [-12, -51],
            [-19, -37],
            [-13, -50],
            [-6, -47],
            [2, -51],
            [-11, -39],
            [-16, -37],
            [-3, -48],
            [1, -88],
            [13, -81],
            [7, -109],
            [-11, -14],
            [-33, -7],
            [-16, -14],
            [-27, 54],
            [-16, 57],
            [12, 23],
            [27, -14],
            [8, 13],
            [0, 30],
            [-33, 31],
            [-37, 14],
            [-11, -18],
            [4, -53],
            [-4, -13],
            [-26, -20],
            [-14, 78],
            [-34, 57],
            [1, -28],
            [14, -48],
            [-7, -48],
            [-13, -10],
            [-7, -22],
            [-4, -81],
            [-23, -22],
            [-54, 55],
            [-3, -35],
            [28, -31],
            [-22, -53],
            [-16, -74],
            [-25, -61],
            [-12, -4],
            [-42, 10],
            [-46, 52],
            [-42, -6],
            [-70, 3],
            [-44, -19],
            [-10, 57],
            [-9, 21],
            [4, 18],
            [35, 12],
            [36, -1],
            [-5, 22],
            [-10, 8],
            [-16, -5],
            [-46, 19],
            [-32, -9],
            [-21, 27],
            [-38, 94],
            [-22, 43],
            [-38, 40],
            [-67, 213],
            [-10, 50],
            [-12, 125],
            [54, -60],
            [19, -38],
            [10, -48],
            [19, 58],
            [-4, 19],
            [-48, 71],
            [-6, 21],
            [-33, -4],
            [8, 50],
            [-7, 49],
            [-56, 108],
            [-43, 101],
            [-43, 126],
            [-4, 43],
            [-21, 84],
            [-10, 62],
            [-6, 55],
            [20, 111],
            [3, 61],
            [31, -27],
            [69, -37]
        ],
        [[101315, 27591], [-15, -43], [-19, 27], [-3, 12], [23, 11], [14, -7]],
        [[100249, 27596], [-11, -47], [-12, 59], [25, 25], [-2, -37]],
        [
            [101342, 27707],
            [30, -34],
            [16, -36],
            [-22, -30],
            [-15, -6],
            [-11, 35],
            [-32, -13],
            [-35, 3],
            [-25, 27],
            [-3, 13],
            [15, 13],
            [43, 0],
            [39, 28]
        ],
        [
            [101242, 28013],
            [55, -101],
            [28, -15],
            [9, -11],
            [-3, -44],
            [-12, -19],
            [23, -26],
            [-8, -15],
            [-27, -34],
            [-33, -16],
            [-18, 27],
            [-7, 23],
            [-41, 88],
            [5, 24],
            [-9, 37],
            [-20, -3],
            [-14, 22],
            [22, 22],
            [29, 59],
            [21, -18]
        ],
        [
            [99985, 27813],
            [-9, -2],
            [-7, 31],
            [3, 45],
            [-15, 45],
            [9, 44],
            [-2, 48],
            [6, 21],
            [18, 24],
            [3, 41],
            [16, 2],
            [28, -32],
            [9, -82],
            [-4, -50],
            [11, -44],
            [-9, -38],
            [-24, -31],
            [-33, -22]
        ],
        [
            [99089, 31199],
            [21, -12],
            [31, -4],
            [38, -22],
            [47, -39],
            [36, -5],
            [25, 30],
            [29, 14],
            [51, -3],
            [71, -31],
            [30, -28],
            [10, -35],
            [13, -20],
            [14, -6],
            [6, -30],
            [-1, -55],
            [11, -60],
            [25, -66],
            [20, -36],
            [15, -4],
            [14, 23],
            [12, 51],
            [12, 29],
            [10, 6],
            [11, -11],
            [14, -27],
            [34, -20],
            [79, -23],
            [32, -31],
            [11, -52],
            [0, -84],
            [5, -53],
            [8, -23],
            [17, -19],
            [25, -18],
            [14, -25],
            [0, -26],
            [40, -47],
            [79, -66],
            [59, -59],
            [39, -53],
            [28, -51],
            [15, -46],
            [30, -50],
            [44, -53],
            [41, -21],
            [36, 11],
            [15, 18],
            [-7, 25],
            [0, 29],
            [6, 31],
            [14, 21],
            [23, 12],
            [44, 9],
            [64, 7],
            [48, -16],
            [32, -38],
            [38, -26],
            [69, -22],
            [55, -22],
            [34, 2],
            [24, 11],
            [21, 22],
            [36, -6],
            [49, -32],
            [46, -21],
            [47, -4],
            [16, 31],
            [18, 9],
            [35, -8],
            [16, -11],
            [8, 9],
            [7, 27],
            [11, 18],
            [15, 10],
            [14, -3],
            [11, -14],
            [17, 1],
            [25, 16],
            [27, -1],
            [53, -35],
            [13, -15],
            [18, -76],
            [35, -203],
            [16, -44],
            [-11, -59],
            [-9, -26],
            [26, -14],
            [532, -389]
        ],
        [
            [101841, 29272],
            [-3, -16],
            [-38, -11],
            [-31, -38],
            [-44, -63],
            [-26, -23],
            [-56, -17],
            [-110, 7],
            [-210, -23],
            [-41, -15],
            [-78, -43],
            [-76, -68],
            [-73, -91],
            [-166, -248],
            [-130, -27],
            [-25, 0],
            [-19, 7],
            [-23, -15],
            [-1, -31],
            [22, -32],
            [15, -30],
            [28, 41],
            [12, -11],
            [5, -77],
            [1, -49],
            [-9, -26],
            [-17, -18],
            [-19, 12],
            [-2, 26],
            [-24, 63],
            [-30, 55],
            [-27, 17],
            [-16, -18],
            [-26, -19],
            [-21, 70],
            [-23, 60],
            [-31, 7],
            [-26, -1],
            [-22, 26],
            [-43, 42],
            [21, 66],
            [24, 13],
            [-7, 46],
            [-13, 37],
            [-34, 10],
            [-23, -6],
            [-13, -30],
            [-18, -52],
            [-72, -65],
            [-34, 36],
            [-40, 54],
            [19, -5],
            [40, 2],
            [34, 48],
            [14, 30],
            [17, 63],
            [-22, 45],
            [-20, 33],
            [-29, 29],
            [-109, -99],
            [-44, -33],
            [38, -17],
            [22, 5],
            [23, -29],
            [-37, -41],
            [-30, -11],
            [-36, -25],
            [-71, -63],
            [-89, -132],
            [-39, -38],
            [-45, -30],
            [-62, 35],
            [-35, 8],
            [-44, 54],
            [-75, 36],
            [-70, 72],
            [-49, 37],
            [-34, 8],
            [-48, -15],
            [-81, 64],
            [-62, 7],
            [-41, -65],
            [-31, 4],
            [-21, 10],
            [-65, 106],
            [-63, 53],
            [-13, 3]
        ],
        [[100413, 28720], [12, -37], [-26, 20], [-44, -4], [28, 39], [22, -8], [8, -10]],
        [[100466, 28795], [-47, -37], [-17, 17], [5, 40], [40, 3], [19, -23]],
        [
            [101675, 30482],
            [-11, -15],
            [-27, 5],
            [-29, -20],
            [-14, -32],
            [3, -37],
            [-7, -43],
            [-13, -14],
            [6, -122],
            [-17, -48],
            [-31, 15],
            [-16, 37],
            [-2, 43],
            [-13, -3],
            [-18, 23],
            [-5, 40],
            [-2, 79],
            [18, 102],
            [86, 92],
            [26, -17],
            [1, -22],
            [20, -30],
            [45, -33]
        ],
        [[102048, 30560], [7, 24], [22, 15]],
        [[102077, 30599], [5, -8], [-10, -24], [-24, -7]],
        [
            [102944, 34488],
            [19, -53],
            [-2, -163],
            [15, -78],
            [-4, -101],
            [-44, -110],
            [-35, -133],
            [-1, -116],
            [-23, -220],
            [-15, -59],
            [-11, -92],
            [-48, -223],
            [-3, -88],
            [8, -104],
            [-8, -100],
            [-12, -68],
            [-12, -126],
            [-49, -196],
            [-70, -145],
            [-4, -110],
            [-9, -48],
            [-14, -61],
            [-43, -66],
            [-26, -29],
            [-10, -38],
            [-24, 0],
            [-1, -13],
            [16, -12],
            [-7, -20],
            [-65, -35],
            [-43, -45],
            [-45, -110],
            [-19, -57],
            [-24, -56],
            [-14, -26],
            [-6, -28],
            [-10, -69],
            [-23, -12],
            [-20, -21],
            [9, -66],
            [-10, -75],
            [-3, -52],
            [-11, -32],
            [-13, 12],
            [-24, -23],
            [33, -14],
            [-43, -74],
            [-40, -75],
            [-11, -50],
            [-17, -63],
            [-15, -139],
            [-13, -80],
            [9, -57],
            [-17, -7],
            [-18, -19],
            [-5, -20],
            [8, -24]
        ],
        [
            [102048, 30560],
            [-14, -14],
            [-59, -206],
            [-26, -54],
            [-30, -85],
            [-11, -76],
            [-9, -84],
            [-11, -140],
            [-10, -99],
            [-23, -97],
            [-8, -68],
            [-3, -131],
            [11, -99],
            [-7, -53],
            [-1, -51],
            [-6, -31]
        ],
        [[34932, 44696], [62, -49]],
        [
            [34994, 44647],
            [-32, -28],
            [-117, -164],
            [-25, -23],
            [-28, -4],
            [-16, -22],
            [-26, -18],
            [-51, -65],
            [-26, -52],
            [-17, -47],
            [-20, -1],
            [-15, 13],
            [-48, -7],
            [-25, -16],
            [-27, -45],
            [-33, -83],
            [-14, -23],
            [-26, -25],
            [-31, -20],
            [-39, -30],
            [-32, -8],
            [-13, 14],
            [-5, 30],
            [-20, 19],
            [-47, 9],
            [-70, 21],
            [-72, 5],
            [-65, -4],
            [-52, 12],
            [-37, 2],
            [-32, -30],
            [-48, -36],
            [-22, -9],
            [-31, 3],
            [-18, 19],
            [-26, 43],
            [-19, -16],
            [-14, -19],
            [0, 237],
            [1, 225],
            [0, 200],
            [14, 31],
            [8, 35],
            [-10, 47],
            [2, 43],
            [16, 59],
            [-30, -23],
            [-11, -22],
            [-26, -30],
            [-18, -30],
            [-21, -24],
            [-27, -54],
            [-22, -30],
            [-22, -18],
            [-38, -64],
            [-31, -12],
            [-83, -10],
            [-177, 1],
            [2, 89],
            [-27, 39],
            [-1, 48],
            [-17, 73],
            [-18, 26],
            [-27, 10],
            [-43, 23],
            [-65, 23],
            [-61, 2],
            [-61, -2],
            [74, 162],
            [-1, 71],
            [-30, 61],
            [-16, 39],
            [-25, 52],
            [-30, 37],
            [-17, 48],
            [-1, 49],
            [-58, 75],
            [0, 26],
            [-19, 59],
            [0, 26],
            [-11, 41],
            [-12, 29],
            [-28, 47],
            [1, 23],
            [12, 11],
            [5, 26],
            [-1, 26],
            [-15, 16],
            [-17, 8],
            [-22, 47],
            [-27, 39],
            [-6, 16],
            [13, 27],
            [2, 26],
            [-4, 46],
            [23, 3],
            [11, 13],
            [33, 8],
            [9, 15],
            [-1, 25],
            [-11, 51],
            [-12, 31]
        ],
        [[32781, 46213], [350, -265], [707, -314], [175, -167], [919, -771]],
        [
            [34932, 44696],
            [26, 49],
            [15, 0],
            [31, 48],
            [28, 17],
            [31, 60],
            [3, 67],
            [89, -7],
            [33, 9],
            [21, -7],
            [51, -85],
            [27, 18],
            [14, 47],
            [33, 20],
            [25, -17],
            [8, 29],
            [61, 75],
            [7, -5],
            [8, -60],
            [25, -34],
            [16, 19],
            [42, 105],
            [-7, 52],
            [12, 33],
            [33, 42],
            [28, -20],
            [29, -2],
            [37, 42],
            [18, -13],
            [11, 18],
            [51, -5],
            [30, 7],
            [-2, 140],
            [16, -15],
            [24, 17],
            [23, 82],
            [-22, 53],
            [23, 59],
            [51, 28],
            [9, 52],
            [41, 15],
            [1, 47],
            [15, 45],
            [196, -5],
            [24, -5],
            [33, -25],
            [13, -30],
            [13, -59],
            [25, -38],
            [5, -40],
            [26, 8],
            [25, -20],
            [21, -105],
            [41, -22],
            [13, -87],
            [41, -25],
            [25, -35],
            [13, 10],
            [11, 62],
            [24, 10],
            [14, 23],
            [33, -20],
            [0, -25]
        ],
        [
            [36543, 45293],
            [31, -45],
            [7, -37],
            [-13, -48],
            [-9, -72],
            [9, -54],
            [-20, -8],
            [-5, -45],
            [19, -49],
            [-1, -30],
            [22, -97],
            [-13, -38],
            [-14, -12],
            [14, -75],
            [-4, -75],
            [-11, -37],
            [1, -112],
            [29, -97],
            [-9, -139],
            [9, -40],
            [-15, -18],
            [4, -49],
            [-4, -43],
            [15, -25],
            [319, -2],
            [0, -20],
            [18, -35],
            [31, 13],
            [32, -23],
            [33, 3],
            [21, -18],
            [29, -132],
            [-36, -84],
            [-24, -38],
            [0, -79],
            [13, -90],
            [23, -7],
            [17, -75],
            [14, -42],
            [-2, -65],
            [21, -80],
            [-26, -129],
            [-29, -62],
            [-13, -80],
            [-12, -30],
            [-34, -25],
            [-24, -55],
            [-1, -37],
            [-24, -75],
            [-9, -82],
            [-86, -102],
            [-20, -34]
        ],
        [
            [36816, 42563],
            [-59, 57],
            [-50, 40],
            [-16, -5],
            [-88, -16],
            [-30, -8],
            [-20, 9],
            [-66, -1],
            [-26, 31],
            [-22, 36],
            [-46, 92],
            [-7, 45],
            [-18, 15],
            [-27, -6],
            [-28, 7],
            [-53, 38],
            [-50, 39],
            [-24, -2],
            [-21, 24],
            [-38, 60],
            [-18, 23],
            [-8, 31],
            [-8, 45],
            [-15, 10],
            [-20, -8],
            [-21, -24],
            [-30, 16],
            [-37, 42],
            [-37, 48],
            [-32, 23],
            [-31, 4],
            [-46, -33],
            [-38, 14],
            [-60, 12],
            [-51, 24],
            [-18, 63],
            [-10, 42],
            [-31, 27],
            [-24, 32],
            [-29, 48],
            [-14, 16],
            [-26, 14],
            [-24, 17],
            [-3, 31],
            [-11, 50],
            [-17, 49],
            [-7, 4],
            [-15, -17],
            [-7, 9],
            [-1, 22],
            [4, 35],
            [-9, 37],
            [-24, 39],
            [-12, 40],
            [-1, 41],
            [-5, 28],
            [-10, 14],
            [-5, 24],
            [-1, 35],
            [7, 41],
            [14, 48],
            [-3, 74],
            [-21, 99],
            [-11, 71],
            [-3, 44],
            [3, 33],
            [13, 32],
            [26, 77],
            [4, 59],
            [-8, 67],
            [-1, 51],
            [6, 35],
            [-9, 46],
            [-18, 44],
            [-12, 1],
            [-18, -12],
            [-20, -37],
            [-24, -6],
            [-22, 22],
            [-67, -9],
            [-105, -23],
            [-42, -23],
            [-24, -10],
            [-30, -8],
            [-16, -14]
        ],
        [[37359, 50907], [30, -601]],
        [
            [37389, 50306],
            [-279, 3],
            [-78, -3],
            [-32, -52],
            [-12, -70],
            [-15, -27],
            [-11, -60],
            [-18, -47],
            [-2, -40],
            [-22, -87],
            [-1, -33],
            [23, -54],
            [3, -30],
            [-10, -18],
            [-40, -20],
            [-15, -49],
            [-38, -18],
            [-29, 5],
            [-25, 92],
            [-28, 43],
            [-8, 30],
            [-40, 14],
            [-14, 20],
            [-35, -2],
            [-7, -27],
            [-66, -50],
            [-24, -50],
            [-14, -122],
            [6, -42],
            [-4, -68],
            [-14, -74],
            [0, -97],
            [-30, 27],
            [-25, 7],
            [-26, -1],
            [1, 12],
            [-18, 69],
            [-29, 55],
            [-34, 45],
            [-20, 12],
            [-12, 35],
            [-22, 20],
            [-32, 65],
            [-27, 32],
            [9, 42],
            [31, -12],
            [20, 42],
            [-2, 67],
            [-16, 30],
            [-1, 70],
            [-10, 40],
            [-22, 27],
            [-11, 55],
            [-18, 42],
            [-2, 38],
            [16, 42],
            [-12, 45],
            [-2, 40],
            [12, 37],
            [1, 65],
            [12, 32],
            [2, 30],
            [-17, 75],
            [2, 32],
            [27, 40],
            [-21, 87],
            [-1, 55],
            [-30, 169],
            [-3, 30],
            [-30, 45],
            [-21, 59],
            [23, 75],
            [-5, 52],
            [12, 45],
            [-5, 20],
            [-43, 40],
            [-48, 0],
            [-37, 52],
            [-9, 37],
            [-48, -7],
            [-27, 32]
        ],
        [
            [35992, 51421],
            [6, 65],
            [-4, 40],
            [-61, 12],
            [-39, 0],
            [-66, 10],
            [-31, 17],
            [-7, 24],
            [6, 28],
            [6, 54],
            [-9, 72],
            [-32, 113],
            [-24, 112],
            [-3, 78],
            [1, 82],
            [2, 53],
            [-17, 42],
            [-90, 133],
            [-32, 62],
            [-10, 43],
            [-35, 80],
            [9, 24],
            [20, -1],
            [18, -20],
            [16, -45],
            [11, -10],
            [99, 1],
            [20, -8],
            [21, -33],
            [15, -52],
            [16, -25],
            [85, 2],
            [29, 4],
            [17, -14],
            [22, -12],
            [45, 27],
            [13, 1],
            [14, -12],
            [49, -92],
            [28, -39],
            [23, -52],
            [35, 0],
            [28, 44],
            [8, 149],
            [9, 43],
            [14, 12],
            [17, 2],
            [42, 54],
            [20, 10],
            [79, -33],
            [22, 16],
            [81, 39],
            [82, 51],
            [23, 64],
            [35, 17],
            [27, 47],
            [21, -5],
            [33, -2],
            [31, 17],
            [11, 22],
            [19, 62],
            [22, 24],
            [29, 25],
            [19, 30],
            [16, 36],
            [7, 32],
            [0, 25],
            [-9, 49],
            [-12, 46],
            [-12, 15],
            [19, 16],
            [23, -16],
            [36, -2],
            [15, 12],
            [23, -6],
            [29, 33],
            [19, -11],
            [12, 0],
            [20, -53],
            [27, -34],
            [-3, -52],
            [-5, -46],
            [-5, -93],
            [-12, -41],
            [-17, -38],
            [-7, -36],
            [11, -13],
            [46, -5],
            [18, -12],
            [22, -2],
            [40, -53],
            [1, -16],
            [-8, -36],
            [-4, -34],
            [15, -37],
            [22, -77],
            [21, -50],
            [-16, -63],
            [-21, -38],
            [-2, -29],
            [-54, -63],
            [6, -69],
            [1, -63],
            [-13, -37],
            [-23, -109],
            [-8, -55],
            [-7, -125],
            [0, -42],
            [33, -182],
            [12, -20],
            [29, -30],
            [4, -85],
            [-4, -123],
            [5, -15],
            [22, -18],
            [1, -53],
            [40, -26],
            [17, -38],
            [32, -58],
            [12, -11],
            [6, -24],
            [27, -50],
            [40, -18],
            [42, -23]
        ],
        [
            [32781, 46213],
            [-2, 20],
            [14, 98],
            [20, 40],
            [60, 86],
            [54, 58],
            [26, 6],
            [19, 22],
            [13, 33],
            [3, 36],
            [-3, 32],
            [-22, 104],
            [-9, 33],
            [8, 39],
            [15, 53],
            [29, 80],
            [27, 86],
            [7, 78],
            [19, 166],
            [-3, 22],
            [6, 20],
            [17, 16],
            [41, 15],
            [28, 32],
            [43, 60],
            [36, 64],
            [29, 21],
            [54, 60],
            [31, 37],
            [43, 40],
            [99, 19],
            [26, 18],
            [38, 7],
            [25, 20],
            [28, 1],
            [52, 20],
            [18, 31],
            [16, 37],
            [20, 31],
            [24, 8],
            [27, -5],
            [32, 0],
            [39, 10],
            [19, -24],
            [8, -30],
            [24, -30],
            [34, 8],
            [24, -26],
            [15, 3],
            [10, 15],
            [2, 36],
            [5, 20],
            [30, 301],
            [37, 359],
            [19, 195],
            [36, 358],
            [23, 225],
            [13, 111],
            [6, 99],
            [5, 28],
            [-3, 24],
            [-12, 33],
            [0, 52],
            [-22, 30],
            [-7, 16],
            [-12, 67],
            [-9, 19],
            [-3, 23],
            [9, 46],
            [-6, 48],
            [-7, 24],
            [-10, 15],
            [-25, 17],
            [-25, 39],
            [-29, 36],
            [-38, 68],
            [-8, 32],
            [0, 87],
            [5, 313],
            [40, 6],
            [37, 10],
            [41, 32],
            [11, -3],
            [34, 31],
            [17, 8],
            [35, -44],
            [16, 1],
            [7, -14],
            [34, 4],
            [6, 13],
            [-7, 30],
            [3, 23],
            [1, 62],
            [-9, 19],
            [-20, 65],
            [-17, 20],
            [-15, 7],
            [-13, -12],
            [-12, -2],
            [-8, 11],
            [-47, 8],
            [-30, -7],
            [-10, 9],
            [-15, 1],
            [-16, -10],
            [1, 362],
            [15, -2],
            [18, 16],
            [28, 3],
            [21, 17],
            [12, 2],
            [23, -9],
            [23, -18],
            [23, -2],
            [198, 0],
            [135, 0],
            [20, -1],
            [-25, 70],
            [12, 63],
            [8, 16],
            [19, -17],
            [30, -94],
            [13, -20],
            [17, -2],
            [19, 7],
            [18, 16],
            [32, 74],
            [32, 63],
            [34, 40],
            [13, 8],
            [17, -3],
            [15, -17],
            [72, -213],
            [9, -49],
            [1, -120],
            [-2, -106],
            [9, -18],
            [58, 25],
            [138, -224],
            [26, -30],
            [14, -9],
            [34, 7],
            [40, 12],
            [20, 14],
            [22, 29],
            [35, 42],
            [29, 22],
            [11, 3],
            [36, -32],
            [13, -46],
            [-12, -53],
            [2, -33],
            [25, 1],
            [35, 99],
            [30, 36],
            [29, 50],
            [20, 48],
            [24, 28],
            [36, 34],
            [29, 21],
            [26, -2],
            [20, 23],
            [26, 42],
            [18, 34],
            [12, 12],
            [25, -3],
            [31, 4],
            [31, 42],
            [28, 50],
            [14, 84],
            [10, 75],
            [18, 27],
            [12, 8],
            [29, 5],
            [50, 40],
            [35, 40],
            [32, 9],
            [10, 11],
            [12, 38]
        ],
        [
            [37389, 50306],
            [5, -172],
            [-4, -49],
            [3, -100],
            [36, -45],
            [-3, -107],
            [14, -40],
            [23, -40],
            [18, 3],
            [40, -55],
            [15, -104],
            [24, -40],
            [19, -5],
            [29, -60],
            [23, -35],
            [32, -27],
            [25, -42],
            [22, -13],
            [54, -79],
            [27, -20],
            [36, -38],
            [34, -22],
            [20, 10],
            [8, -25],
            [25, -8],
            [25, -22],
            [24, -70],
            [57, -54],
            [25, -10],
            [-2, -70],
            [35, -25],
            [42, 35],
            [5, -50],
            [26, -49],
            [3, -31],
            [-113, -443],
            [-474, -1847],
            [-26, -39],
            [-19, -59],
            [-6, -66],
            [22, -87],
            [48, -107],
            [26, -68],
            [3, -42]
        ],
        [
            [37615, 46089],
            [-20, -42],
            [-7, -39],
            [0, -50],
            [-11, -55],
            [-22, -60],
            [-7, -70],
            [8, -81],
            [-8, -125],
            [-14, -78],
            [-23, -154],
            [-23, -32],
            [-945, -10]
        ],
        [
            [37359, 50907],
            [15, -30],
            [17, -25],
            [23, 3],
            [32, 40],
            [24, -1],
            [29, 3],
            [8, 35],
            [-6, 51],
            [10, 16],
            [24, 8],
            [5, 27],
            [12, 32],
            [52, -22],
            [9, -17],
            [33, 2],
            [13, 30],
            [3, 41],
            [34, 11],
            [24, 18],
            [62, 2],
            [15, 13],
            [14, 26],
            [27, 75],
            [30, 31],
            [13, -3],
            [26, 13],
            [22, 18],
            [8, -5],
            [17, -38],
            [62, -31],
            [22, 6],
            [23, 12],
            [23, 5],
            [16, -9],
            [25, 20],
            [30, -10],
            [49, -22],
            [64, -24],
            [18, 9],
            [10, 16],
            [4, 85],
            [-32, 66],
            [-16, 44],
            [-20, 13],
            [2, 22],
            [13, 23],
            [13, 13],
            [8, 16],
            [8, 59],
            [6, 10],
            [12, 0],
            [13, -15],
            [51, -46],
            [22, 7],
            [84, 12],
            [13, 27],
            [18, 6],
            [30, 26],
            [23, -4],
            [13, 5],
            [20, 25],
            [9, 2],
            [3, -27],
            [28, -55],
            [8, -6],
            [26, 9],
            [16, -17]
        ],
        [
            [38671, 51533],
            [-6, -5],
            [5, -84],
            [-22, -75],
            [11, -27],
            [-12, -40],
            [10, -23],
            [-2, -39],
            [10, -70],
            [48, 5],
            [25, -20],
            [41, 7],
            [50, -57],
            [9, 0],
            [28, -65],
            [1, -19],
            [22, 9],
            [27, -34],
            [9, -30],
            [42, -8],
            [5, 23],
            [25, -8],
            [3, -32],
            [29, 2],
            [5, -69],
            [30, 10],
            [10, -43],
            [-18, -17],
            [15, -117],
            [47, -90],
            [42, -17],
            [5, -18],
            [-8, -102],
            [4, -84],
            [26, -77],
            [11, -63],
            [-3, -44],
            [13, -40],
            [19, -97],
            [26, 5],
            [40, -68],
            [22, -52],
            [-1, -89],
            [8, -30],
            [25, -20],
            [5, -48],
            [-2, -79],
            [36, 2],
            [9, -30],
            [-7, -17],
            [10, -65],
            [37, -42],
            [33, -3],
            [25, -14],
            [21, 19],
            [30, -10]
        ],
        [
            [39544, 49534],
            [-11, -11],
            [-4, -78],
            [-26, -44],
            [-65, 20],
            [-100, -84],
            [-34, -21],
            [109, -5],
            [35, -44],
            [77, 29],
            [93, 108],
            [36, 22],
            [72, 73],
            [29, 48],
            [54, 59],
            [11, 25],
            [30, 27],
            [16, -34],
            [2, -22],
            [-25, -43],
            [6, -27],
            [17, -35],
            [6, -47],
            [2, -36],
            [10, -64],
            [33, -86],
            [1, -28],
            [-5, -37],
            [16, -31],
            [17, -18],
            [56, -93],
            [44, 52],
            [27, 15],
            [17, 21],
            [37, 15],
            [29, -22],
            [57, -31],
            [41, 33],
            [84, 76],
            [-26, -134],
            [-19, -123],
            [-15, -49],
            [-14, -134],
            [-14, -36],
            [-12, -40],
            [19, 14],
            [16, 19],
            [21, 52],
            [15, 89],
            [61, 238],
            [17, 22],
            [51, 27],
            [86, 191],
            [34, -1],
            [22, -44],
            [21, -26],
            [5, 52],
            [30, 22],
            [-32, 25],
            [-5, 24],
            [-3, 39],
            [22, 53],
            [-13, 46],
            [44, 59],
            [-3, 44],
            [15, 37],
            [20, 37],
            [23, 19],
            [4, 32],
            [26, 18],
            [22, -36],
            [24, 42],
            [23, 17],
            [24, -26],
            [13, -8],
            [11, 3],
            [29, 28],
            [27, -44],
            [16, -10],
            [-4, 25],
            [-9, 22],
            [7, 19],
            [12, 12],
            [40, -11],
            [21, -19],
            [23, -37],
            [32, -2],
            [24, 4],
            [16, -21],
            [26, 0],
            [12, -31],
            [39, -45],
            [8, -30],
            [32, -15],
            [29, -18],
            [31, -5],
            [31, 4],
            [2, -38],
            [23, -10],
            [29, 8],
            [12, -24]
        ],
        [
            [41359, 49542],
            [-42, -52],
            [-5, -43],
            [11, -17],
            [-24, -77],
            [6, -50],
            [-6, -57],
            [-13, -25],
            [-22, -5],
            [4, -40],
            [26, -3],
            [1, -67],
            [-20, -119],
            [-31, -62],
            [-11, 7],
            [2, -82],
            [-9, -12],
            [3, -58],
            [-18, -20],
            [-7, -37],
            [-29, -27],
            [-20, -43],
            [29, -59],
            [-24, -38],
            [4, -40],
            [-9, -59],
            [-24, -55],
            [-24, -77],
            [-11, 0],
            [-27, -38],
            [-6, -72],
            [-20, -25],
            [2, -15],
            [-13, -136],
            [-69, -132],
            [-7, 7],
            [-6, -55],
            [-16, -62],
            [-23, -35],
            [-10, -47],
            [-29, -70],
            [-22, -32],
            [-45, 5],
            [-139, -199],
            [-148, -214],
            [3, -10]
        ],
        [
            [40521, 47195],
            [38, -24],
            [27, -5],
            [28, 5],
            [19, -14],
            [13, -35],
            [13, -20],
            [13, -6],
            [12, -18],
            [10, -30],
            [-6, -30],
            [-24, -28],
            [-7, -41],
            [11, -51],
            [-3, -32],
            [-16, -11],
            [-5, -23],
            [8, -34],
            [-7, -25],
            [-22, -16],
            [-7, -37],
            [7, -57],
            [-6, -27],
            [-19, 3],
            [-17, -11],
            [-16, -23],
            [-13, -42],
            [-10, -60],
            [-47, -68],
            [-85, -77],
            [-40, -83],
            [5, -91],
            [-14, -93],
            [-31, -97],
            [2, -78],
            [35, -57],
            [15, -65],
            [-6, -71],
            [-11, -80],
            [-17, -91],
            [-30, -109],
            [-38, -118],
            [-34, -72],
            [-30, -32],
            [-37, -70],
            [-46, -111],
            [-33, -112],
            [-28, -172],
            [-18, -63]
        ],
        [
            [40054, 44693],
            [-328, 30],
            [-1171, 124],
            [-423, 55],
            [-9, 0],
            [-58, 50],
            [-29, -10],
            [-20, 70],
            [-28, 15],
            [-37, 7],
            [-8, 25],
            [-3, 60],
            [-5, 15],
            [-61, 52],
            [-57, 92],
            [-30, 20],
            [-19, 80],
            [-3, 64],
            [-10, 35],
            [13, 115],
            [-43, 102],
            [-36, 199],
            [-16, 40],
            [-10, 49],
            [-25, 68],
            [-23, 39]
        ],
        [
            [39561, 49382],
            [-33, -11],
            [42, 140],
            [38, 64],
            [0, 129],
            [41, 115],
            [38, 46],
            [52, 14],
            [29, -70],
            [-36, -198],
            [-10, -1],
            [-48, -104],
            [-53, -73],
            [-60, -51]
        ],
        [
            [40241, 50053],
            [29, -2],
            [41, 10],
            [27, 26],
            [31, 6],
            [30, -3],
            [102, -29],
            [61, -9],
            [44, -23],
            [16, -14],
            [4, -31],
            [-15, -49],
            [-11, -52],
            [-10, -73],
            [-8, -15],
            [-13, 4],
            [8, -65],
            [-3, -26],
            [-23, -77],
            [-25, -67],
            [-26, -37],
            [-16, -30],
            [4, -28],
            [7, -28],
            [-9, -35],
            [-29, -51],
            [-18, -13],
            [-16, -5],
            [-15, 5],
            [-26, 51],
            [-3, -40],
            [-7, -41],
            [-9, -23],
            [-34, 3],
            [-20, 22],
            [-30, 24],
            [-6, -66],
            [-20, -46],
            [-19, -14],
            [-30, -10],
            [-18, -19],
            [-32, 15],
            [-31, 30],
            [-17, 3],
            [-13, -25],
            [-71, -4],
            [-33, -25],
            [-19, 7],
            [-30, 50],
            [-4, 34],
            [-18, 68],
            [-15, 80],
            [-11, 74],
            [9, 63],
            [19, -2],
            [22, -10],
            [6, 25],
            [-5, 17],
            [-36, -3],
            [-23, 38],
            [-3, 58],
            [4, 120],
            [3, 25],
            [16, 35],
            [5, 30],
            [-4, 33],
            [7, 59],
            [15, 51],
            [57, 64],
            [66, 23],
            [191, -63]
        ],
        [[39925, 50108], [-85, -110], [-28, 36], [-6, 21], [4, 30], [9, 37], [47, 31], [24, 5], [30, -9], [5, -41]],
        [
            [40298, 50118],
            [-82, -17],
            [-37, 28],
            [8, 23],
            [28, 37],
            [34, 27],
            [31, 12],
            [31, -15],
            [9, -31],
            [-3, -32],
            [-19, -32]
        ],
        [
            [40207, 50331],
            [13, -30],
            [-44, -116],
            [-24, -17],
            [-26, -3],
            [-35, 34],
            [-53, -2],
            [-16, 8],
            [-2, 51],
            [22, 54],
            [45, -3],
            [77, 44],
            [43, -20]
        ],
        [
            [39995, 50259],
            [-6, -82],
            [-55, 34],
            [4, 84],
            [26, 24],
            [23, 44],
            [8, 55],
            [0, 74],
            [16, 18],
            [7, -5],
            [3, -111],
            [3, -69],
            [-29, -66]
        ],
        [[40079, 50400], [-33, -19], [-7, 18], [0, 70], [10, 38], [42, 11], [17, 19], [7, -24], [-1, -40], [-35, -73]],
        [
            [39184, 40135],
            [3, -45],
            [-4, -109],
            [7, -35],
            [14, -17],
            [24, 22],
            [39, -25],
            [-1, -39],
            [-18, -40],
            [-14, -58],
            [7, -25],
            [33, -14],
            [45, -8],
            [36, 10],
            [48, -62],
            [22, 2],
            [54, -47],
            [11, -27],
            [46, -25],
            [22, -33],
            [62, -44],
            [30, -5],
            [43, -18],
            [29, -47],
            [53, -18],
            [32, -47],
            [22, -79]
        ],
        [[39829, 39302], [-11, -85], [2, -244]],
        [
            [39820, 38973],
            [-22, -68],
            [-30, -46],
            [-73, -76],
            [-42, -64],
            [-18, -61],
            [-8, -78],
            [-23, -77],
            [-37, -74],
            [-17, -59],
            [3, -43],
            [-5, -39],
            [-19, -52],
            [-6, -26],
            [-11, -13],
            [-18, -10],
            [-7, -24],
            [2, -38],
            [-18, -53],
            [-38, -69],
            [-29, -65],
            [-19, -62],
            [-51, -77],
            [-122, -138],
            [-48, -103]
        ],
        [
            [39164, 37558],
            [-48, -63],
            [-64, -56],
            [-43, -83],
            [-18, -96],
            [-29, -83],
            [-42, -47],
            [-27, -91],
            [-17, -141],
            [-23, -87],
            [-36, -38]
        ],
        [
            [38817, 36773],
            [-40, 42],
            [-21, 39],
            [-28, 28],
            [-29, 22],
            [-60, -43],
            [-33, -35],
            [-18, -12],
            [-65, -24],
            [-53, 14],
            [-15, 22],
            [-9, 48],
            [0, 41],
            [-5, 59],
            [-18, 33],
            [-6, 26],
            [1, 66],
            [5, 26],
            [-3, 31],
            [-8, 23],
            [2, 38],
            [-4, 54],
            [-13, 33],
            [-6, 39],
            [0, 38],
            [-9, 39],
            [-1, 43],
            [8, 38],
            [3, 39],
            [-9, 28],
            [-17, 16],
            [-13, 45],
            [-2, 57],
            [-30, 57],
            [-17, 0],
            [-27, 15],
            [-61, 0],
            [-18, 9],
            [-9, 20],
            [-23, 28],
            [-14, 48],
            [-16, 9],
            [-23, -15],
            [-18, -44],
            [-16, -29],
            [-22, 1],
            [-22, -16],
            [-50, -6],
            [-63, 32],
            [-30, 11],
            [-28, -11],
            [-20, 9],
            [-54, 9],
            [-22, 29],
            [-25, 17],
            [-13, -5],
            [-18, -19],
            [-18, 4],
            [-23, 15],
            [-10, 35],
            [2, 22],
            [15, 53],
            [-5, 33],
            [2, 30],
            [8, 55],
            [-9, 115],
            [22, 77],
            [-6, 30],
            [2, 20],
            [18, 73],
            [-1, 76],
            [-9, 44],
            [-12, 26],
            [5, 17],
            [-8, 37],
            [6, 16],
            [-8, 32],
            [-20, 18],
            [-9, 76],
            [2, 31],
            [-7, 28],
            [-10, 16],
            [-20, 52],
            [-11, 72],
            [20, 7],
            [22, 54],
            [42, 19],
            [8, 23],
            [-84, 131],
            [50, 179],
            [53, 191],
            [5, 15],
            [20, 6],
            [-4, 70],
            [-16, 2],
            [18, 101],
            [46, 253],
            [7, 18],
            [14, 5],
            [4, 13],
            [-18, 18],
            [-10, 34],
            [-52, 216]
        ],
        [
            [37733, 40293],
            [38, -3],
            [9, -43],
            [33, -30],
            [7, -17],
            [32, 14],
            [52, 35],
            [37, 44],
            [31, 78],
            [28, 43],
            [30, 73],
            [14, 39],
            [24, -2],
            [55, 10],
            [17, -10],
            [33, 20],
            [25, 37],
            [45, 17],
            [24, -15],
            [12, -29],
            [47, -25],
            [14, -23],
            [55, -22],
            [23, -62],
            [61, -45],
            [48, -57],
            [33, 2],
            [54, 18],
            [27, 27],
            [10, 25],
            [25, 22],
            [54, 3],
            [31, -38],
            [10, -52],
            [22, 0],
            [26, 20],
            [28, 5],
            [19, 22],
            [14, 43],
            [27, 30],
            [40, 84],
            [24, 30],
            [19, -2],
            [-22, -215],
            [-33, -27],
            [-40, -117],
            [4, -17],
            [33, -8],
            [44, -35],
            [37, 8],
            [35, -10],
            [58, 7],
            [49, -17],
            [29, 7]
        ],
        [
            [38671, 51533],
            [5, -36],
            [11, -18],
            [14, -1],
            [21, -18],
            [11, -27],
            [25, -21],
            [43, -30],
            [20, 0],
            [31, -18],
            [12, 16],
            [44, 46],
            [55, 68],
            [11, -26],
            [52, -26],
            [17, -5],
            [24, 15],
            [30, 34],
            [15, -25],
            [17, -51],
            [16, 4],
            [30, -5],
            [22, -11],
            [14, 1],
            [19, 15],
            [10, 31],
            [53, 54],
            [36, 92],
            [7, 25],
            [2, 41],
            [30, 121],
            [12, 22],
            [7, 38],
            [12, 45],
            [0, 36],
            [9, 36],
            [30, 50],
            [21, 52],
            [14, 49],
            [36, 109],
            [3, 30],
            [14, 19],
            [5, 23],
            [15, 29],
            [16, 23],
            [7, 33],
            [12, 35],
            [35, 38],
            [29, 97],
            [4, 43],
            [26, 1],
            [42, -49],
            [33, -73],
            [44, -236],
            [7, -217],
            [18, -114],
            [52, -237],
            [3, -44],
            [9, -53],
            [16, -57],
            [18, -93],
            [0, -17],
            [-11, -25],
            [17, -2],
            [15, -15],
            [11, -59],
            [12, -39],
            [24, -55],
            [47, -18],
            [36, -6],
            [41, -31],
            [31, -40],
            [23, -133],
            [-8, -84],
            [3, -60],
            [-13, -23],
            [-33, -38],
            [-8, -21],
            [-69, -100],
            [-15, -47],
            [-37, -64],
            [-36, -121],
            [-54, -110],
            [-19, -28],
            [-29, -6],
            [-17, -17],
            [-42, -90],
            [-56, -30],
            [-5, -53],
            [-32, -119],
            [-29, -65],
            [-18, -22],
            [-45, -119],
            [-6, -52],
            [0, -91],
            [-30, -55],
            [-21, -24]
        ],
        [[40034, 51262], [-31, -26], [-17, 10], [-17, 67], [6, 55], [22, 18], [24, -11], [15, -90], [-2, -23]],
        [
            [40054, 44693],
            [-32, -107],
            [-18, -79],
            [-2, -46],
            [-16, -72],
            [-30, -100],
            [-15, -68],
            [-3, -174],
            [-11, -90],
            [-19, -102],
            [-3, -76],
            [14, -51],
            [2, -44],
            [-16, -54],
            [17, -58],
            [3, -39],
            [-7, -37],
            [2, -68],
            [11, -99],
            [1, -83],
            [-10, -67],
            [2, -61],
            [13, -53],
            [15, -32],
            [25, -13]
        ],
        [
            [39977, 43020],
            [-25, -96],
            [-9, -64],
            [-1, -66],
            [-21, -90],
            [-41, -113],
            [-19, -108],
            [2, -105],
            [-4, -56],
            [-13, -7],
            [-10, -52],
            [-11, -146],
            [-43, -209],
            [-23, -77],
            [-17, -16],
            [-13, 1],
            [-57, -23],
            [-36, -54],
            [-24, -67],
            [-9, -79],
            [-11, -49],
            [-13, -18],
            [-5, -19],
            [3, -20],
            [-6, -35],
            [-15, -51],
            [-35, -40],
            [-56, -30],
            [-35, -35],
            [-16, -41],
            [-17, -28],
            [-17, -13],
            [-37, -48],
            [1, -32],
            [-41, -35],
            [-4, -40],
            [20, -38],
            [-20, -82],
            [-34, -72],
            [-47, -61],
            [-25, -54],
            [-3, -47],
            [-14, -55],
            [-25, -64],
            [-13, -53],
            [-3, -59],
            [30, -248],
            [19, -91]
        ],
        [
            [37733, 40293],
            [-8, 35],
            [-3, 55],
            [-13, 34],
            [-23, -11],
            [-26, 10],
            [-66, 84],
            [-44, 45],
            [-15, 27],
            [-7, 85],
            [-13, 95],
            [-6, 117],
            [3, 28],
            [37, 89],
            [0, 45],
            [3, 39],
            [-2, 31],
            [-9, 1],
            [-15, -14],
            [-22, -10],
            [-13, -1],
            [-129, 8],
            [-148, 10],
            [-122, 8],
            [-107, 7],
            [-9, 205],
            [-11, 235],
            [-89, 188],
            [-16, 25],
            [95, 5],
            [-8, 262],
            [-12, 27],
            [-18, 132],
            [-19, 39],
            [-5, 44],
            [4, 29],
            [11, 18],
            [7, 45],
            [-6, 46],
            [-11, 42],
            [-15, 40],
            [-27, 25],
            [-40, 46]
        ],
        [
            [39164, 37558],
            [23, 2],
            [29, 36],
            [79, -17],
            [24, 17],
            [29, -25],
            [24, 8],
            [40, -10],
            [16, 10],
            [14, -22],
            [16, 22],
            [7, 32],
            [24, 13],
            [25, -15],
            [34, -35],
            [40, -5],
            [15, -25],
            [17, 8],
            [29, -20],
            [59, 20],
            [54, -50],
            [55, -30],
            [37, -15],
            [30, -70],
            [18, -2],
            [31, 15],
            [60, -13],
            [19, 18],
            [24, -23],
            [52, 8],
            [47, 15],
            [4, -28],
            [14, -12],
            [1, -27],
            [56, -40],
            [28, -85],
            [7, -85],
            [-12, -54],
            [15, -75],
            [17, -40],
            [-6, -67],
            [-10, -17],
            [60, -122],
            [23, -33],
            [-1, -40],
            [19, -57],
            [15, -12],
            [-4, -45],
            [-22, -62],
            [4, -75],
            [25, -15],
            [39, 3],
            [20, 9],
            [61, 3],
            [15, -17],
            [51, 7],
            [39, -35],
            [-17, -37],
            [-7, -137],
            [17, -15],
            [30, 70],
            [45, -43],
            [11, 13],
            [14, -100],
            [29, -25],
            [5, -30]
        ],
        [
            [40720, 36080],
            [-39, -71],
            [-12, 8],
            [17, 52],
            [-27, 2],
            [-40, 19],
            [-17, -22],
            [10, -51],
            [-15, -22],
            [-28, -3],
            [-24, 6],
            [-27, 38],
            [12, -68],
            [57, -17],
            [24, -16],
            [9, -26],
            [-45, -122],
            [-37, -16],
            [-4, -17],
            [20, 0],
            [12, -34],
            [-3, -28]
        ],
        [
            [40563, 35692],
            [-20, 8],
            [-83, -3],
            [-8, -17],
            [-51, 7],
            [-32, -20],
            [-26, -42],
            [-48, -35],
            [-11, -30],
            [-33, 0],
            [-39, 35],
            [-9, 20],
            [-40, 47],
            [-21, 15],
            [-74, -22],
            [-39, 0],
            [-17, -19],
            [-27, 34],
            [-26, 0],
            [-32, -25],
            [-28, -90],
            [-11, 5],
            [-40, -32],
            [-13, 20],
            [-40, 5],
            [-54, -62],
            [-12, -43],
            [2, -42],
            [13, -60],
            [-14, -25],
            [-43, -27],
            [-25, 55],
            [-114, 0],
            [-41, 10],
            [-59, 74],
            [-80, 10],
            [-27, 18],
            [-30, 0],
            [-10, 12],
            [-44, 22],
            [-30, -14],
            [-25, 7],
            [-40, -10],
            [-48, 60],
            [-23, 12],
            [-32, -27],
            [-18, 0],
            [-47, 17]
        ],
        [
            [38994, 35540],
            [-1, 19],
            [-23, 78],
            [-24, 70],
            [-12, 117],
            [-9, 45],
            [-19, 12],
            [-18, 39],
            [-23, 3],
            [-21, 27],
            [-16, -4],
            [-14, -22],
            [-25, -1],
            [-16, -10],
            [-18, -20],
            [-18, 10],
            [-11, 17],
            [-24, 1],
            [1, 79],
            [43, 119],
            [11, 55],
            [-5, 31],
            [12, 111],
            [31, 189],
            [10, 124],
            [-11, 58],
            [-1, 41],
            [24, 45]
        ],
        [
            [40959, 41238],
            [-171, -2],
            [-100, 2],
            [-22, 5],
            [5, 40],
            [-14, 67],
            [24, 57],
            [-11, 25],
            [18, 112],
            [128, 0],
            [106, -5],
            [3, -20],
            [33, -30],
            [0, -67],
            [-14, -69],
            [-3, -85],
            [18, -30]
        ],
        [
            [39977, 43020],
            [28, 126],
            [30, 71],
            [41, 57],
            [8, -50],
            [-21, -52],
            [2, -47],
            [-24, -75],
            [2, -57],
            [9, -22],
            [58, -50],
            [25, -3],
            [18, -25],
            [70, -59],
            [51, -13],
            [43, -27],
            [7, 65],
            [19, 72],
            [50, 149],
            [37, 45],
            [6, -52],
            [22, -20],
            [31, -50],
            [9, -30],
            [-2, -40],
            [11, -55],
            [2, -62],
            [-5, -79],
            [11, -18],
            [17, 25],
            [10, 90],
            [20, 12],
            [33, -22],
            [35, 5],
            [44, 52],
            [19, -6],
            [-3, -43],
            [31, -8],
            [22, -30],
            [20, 2],
            [25, -27],
            [54, -35],
            [7, 20],
            [-19, 95],
            [24, 19],
            [27, -72],
            [35, -2],
            [46, 27],
            [62, 57],
            [37, 15],
            [44, 0],
            [24, 20],
            [33, 63],
            [16, 17],
            [48, 25],
            [42, 7],
            [20, 20]
        ],
        [
            [41288, 43045],
            [46, -65],
            [4, -34],
            [-23, -28],
            [-10, -74],
            [1, -33],
            [29, -20],
            [-4, -54],
            [-27, -30],
            [-27, -140],
            [3, -119],
            [13, -72],
            [15, -43],
            [14, -59],
            [27, -40],
            [8, -25],
            [28, -30],
            [-12, -65],
            [0, -37],
            [15, -87],
            [-6, -33],
            [-29, -67]
        ],
        [
            [41353, 41890],
            [-16, -30],
            [-35, -7],
            [-33, 15],
            [-5, 35],
            [-22, 42],
            [-40, 32],
            [-21, -44],
            [8, -43],
            [-7, -25],
            [10, -69],
            [-28, -18],
            [-30, 30],
            [-30, 3],
            [-18, -20],
            [-13, -100],
            [13, -7],
            [11, -48],
            [-25, -59],
            [1, -63],
            [20, -27],
            [11, -139],
            [-10, -23],
            [-66, -30],
            [-15, 8],
            [-32, -62],
            [-22, -3]
        ],
        [
            [40959, 41238],
            [-11, -60],
            [4, -44],
            [-8, -43],
            [-25, -60],
            [-7, -47],
            [15, -42],
            [43, -50],
            [33, -144],
            [3, -33],
            [-25, -27],
            [6, -27],
            [-31, -38],
            [-34, -72],
            [-10, -42],
            [-14, 10],
            [-9, -70],
            [22, -40],
            [15, 15],
            [37, -27],
            [6, -68],
            [-18, -42],
            [-8, -45],
            [2, -29],
            [21, -103],
            [-12, -12],
            [-39, -48],
            [-105, -117],
            [-44, -37],
            [-28, 6],
            [-64, 53],
            [-225, 8],
            [-47, -35],
            [-22, -9],
            [-21, -36],
            [-28, -64],
            [-25, -10],
            [-22, 45],
            [-20, 6],
            [-18, -31],
            [-20, -19],
            [-34, -8],
            [-53, -1],
            [-42, -14],
            [-47, -27],
            [-37, -44],
            [-28, -60],
            [-13, -43],
            [3, -37],
            [-13, -37],
            [-14, -14],
            [-20, -4],
            [-22, -23],
            [-24, -44],
            [-16, -40],
            [-8, -37],
            [-4, -46],
            [-13, -3],
            [-12, -26]
        ],
        [
            [40521, 47195],
            [28, 14],
            [17, 23],
            [16, 38],
            [20, 22],
            [25, 7],
            [30, -11],
            [35, -29],
            [33, -12],
            [33, 3],
            [21, -16],
            [10, -36],
            [28, -32],
            [46, -26],
            [29, -29],
            [10, -31],
            [13, -105],
            [15, -180],
            [-3, -194],
            [-20, -209],
            [-20, -129],
            [-22, -49],
            [-18, -29],
            [-16, -10],
            [0, -21],
            [15, -32],
            [17, -12],
            [21, 8],
            [12, -10],
            [4, -29],
            [-2, -52],
            [13, -47],
            [14, 2],
            [20, -72],
            [14, -2],
            [7, -38],
            [40, -69],
            [22, -67],
            [19, -38],
            [10, 3],
            [36, 44],
            [38, 20],
            [53, 10],
            [26, -32],
            [7, -60],
            [-11, -57],
            [-2, -57],
            [-11, -25],
            [13, -42],
            [-48, 0],
            [-42, -23],
            [-14, -27],
            [-13, -55],
            [-13, -90],
            [6, -47],
            [-50, -82],
            [-5, -32],
            [13, -18],
            [31, -2],
            [29, -55],
            [5, -77],
            [24, -57],
            [59, -50],
            [8, -33],
            [-21, -52],
            [-15, -7],
            [-5, -45],
            [49, -62],
            [14, -53],
            [-3, -30],
            [39, -92],
            [19, -10],
            [29, 5],
            [32, -17],
            [16, -35],
            [28, -25]
        ],
        [[41378, 44429], [58, -7]],
        [
            [41436, 44422],
            [-32, -77],
            [-55, -58],
            [-15, -7],
            [-66, -97],
            [20, -70],
            [-4, -17],
            [-37, -30],
            [-29, -117],
            [-20, -33],
            [-13, -44],
            [6, -35],
            [19, -20],
            [19, -47],
            [73, -25],
            [33, -33],
            [-7, -35],
            [-42, -34],
            [-10, -23],
            [8, -42],
            [28, 5],
            [18, -18],
            [7, -34],
            [-42, -40],
            [-11, -28],
            [-23, -25],
            [-4, -19],
            [-3, -120],
            [10, -45],
            [48, -44],
            [0, -55],
            [-24, -63],
            [0, -47]
        ],
        [
            [39820, 38973],
            [126, 156],
            [29, 17],
            [17, -5],
            [22, -33],
            [305, -66],
            [30, -5],
            [6, -17],
            [-9, -31],
            [1, -42],
            [14, -54],
            [12, -28],
            [11, 0],
            [16, 20],
            [23, 40],
            [14, -15],
            [5, -69],
            [8, -40],
            [10, -11],
            [10, 33],
            [9, 77],
            [14, 41],
            [30, 8],
            [108, 3],
            [34, 26],
            [24, 5],
            [21, -18],
            [18, -2],
            [18, 20],
            [26, 1],
            [14, 15],
            [1, 24],
            [13, 17],
            [21, 2],
            [17, -7],
            [12, -18],
            [19, 2],
            [23, 14],
            [18, -4],
            [10, -20],
            [31, -45],
            [26, -31],
            [3, -17],
            [-10, -45],
            [-8, -77],
            [12, -30],
            [31, -28],
            [13, -59],
            [-31, -97],
            [-3, -60],
            [23, -37],
            [7, -85],
            [21, -35],
            [19, -82],
            [-3, -32],
            [34, -3],
            [24, 25],
            [40, -20],
            [10, 13],
            [15, -30],
            [30, -18],
            [5, -37],
            [-21, -82],
            [-14, -5],
            [-7, -50],
            [-12, -23],
            [3, -52],
            [12, -44],
            [-12, -38],
            [17, -45],
            [-19, -40],
            [-11, -64],
            [18, -50],
            [29, -17],
            [1, -18],
            [28, -25],
            [18, -55],
            [-24, -37],
            [32, -37],
            [3, -52],
            [22, -23],
            [41, 20],
            [3, -25],
            [39, 10],
            [34, 30],
            [15, -22],
            [21, 5],
            [15, 30],
            [0, 39],
            [-18, 15],
            [40, 45],
            [28, 2],
            [16, -19],
            [18, 21],
            [19, -19],
            [43, 23],
            [8, 24],
            [58, 53],
            [42, 10],
            [27, 25]
        ],
        [
            [41721, 37689],
            [19, -10],
            [38, -78],
            [4, -22],
            [30, -10],
            [99, 15],
            [15, -60],
            [-24, -27],
            [-9, -40],
            [-26, -20],
            [-34, 3],
            [-36, -15],
            [-43, -33],
            [-22, -30],
            [-3, -82],
            [-17, -37],
            [25, -83]
        ],
        [
            [41737, 37160],
            [-52, -16],
            [-82, -108],
            [-34, -13],
            [-30, -48],
            [-3, -41],
            [-10, -25],
            [-19, -1],
            [-43, 22],
            [-55, 1],
            [-39, -18],
            [-204, -175],
            [-73, -71],
            [-83, -143],
            [-140, -160],
            [-74, -96],
            [-14, -25],
            [-12, -1],
            [-23, -20],
            [9, -17],
            [16, -1],
            [-7, -56],
            [-29, -38],
            [-16, -30]
        ],
        [[41589, 36861], [0, -29], [-13, 15], [-34, -11], [-12, 22], [46, 93], [17, -30], [5, -24], [-9, -36]],
        [
            [41359, 49542],
            [11, -23],
            [59, -35],
            [42, -54],
            [27, 9],
            [30, -14],
            [33, -118],
            [7, -83],
            [15, 11],
            [13, 37],
            [17, 69],
            [33, 22],
            [16, -26],
            [32, -42],
            [29, -46],
            [11, -30],
            [22, -4],
            [-18, -37],
            [18, 4],
            [21, 26],
            [19, -54],
            [13, -58],
            [3, -60],
            [-13, -34],
            [-11, -21],
            [-13, -42],
            [-30, -21],
            [17, -31],
            [12, -29],
            [26, 79],
            [18, 23],
            [26, 12],
            [13, -56],
            [3, -54],
            [-42, -22],
            [0, -42],
            [-13, -24],
            [-8, -28],
            [-7, -58],
            [-9, -47],
            [-25, -212],
            [-1, -35],
            [31, 37],
            [57, 108],
            [18, 115],
            [22, 114],
            [25, 35],
            [15, 0],
            [23, -12],
            [1, -37],
            [-3, -22],
            [-25, -56],
            [-10, -31],
            [10, -31],
            [55, 94],
            [25, 33],
            [21, -7],
            [42, 43],
            [84, 9],
            [7, 49],
            [17, 21],
            [46, -5],
            [90, -44],
            [33, -36],
            [48, -34],
            [25, -40],
            [107, -73],
            [77, -8],
            [38, 34],
            [9, -7]
        ],
        [
            [42643, 48643],
            [-7, -52],
            [17, -47],
            [-9, -55],
            [-24, -42],
            [-25, -68],
            [-32, -17],
            [1, -22],
            [-35, -73],
            [-46, -9],
            [-27, -15],
            [-16, 15],
            [-22, -68],
            [-16, -25],
            [-15, -47],
            [4, -50],
            [-22, -74],
            [-36, -65],
            [-12, -57],
            [-31, -55],
            [11, -85],
            [18, -7],
            [10, -52],
            [-15, -78],
            [-11, -12],
            [5, -40],
            [-7, -25],
            [15, -30],
            [16, -59],
            [6, -90],
            [9, -35],
            [-9, -84],
            [-24, -45],
            [-42, -115],
            [-16, -15],
            [5, -50],
            [-8, -32],
            [11, -159],
            [22, -37],
            [12, -35],
            [35, -38],
            [-6, -102],
            [5, -25],
            [-18, -74],
            [-2, -30],
            [-19, -42],
            [-47, -20],
            [-21, 15],
            [-31, -28],
            [-50, -22],
            [-30, 50],
            [-36, 29],
            [-43, -5],
            [-42, -29],
            [-27, -3],
            [-6, -35],
            [-10, 13],
            [-22, -45],
            [-2, -20],
            [-27, -47],
            [-15, -58],
            [-44, -20],
            [-40, -57],
            [-42, -82],
            [-31, 18],
            [-29, -45],
            [-36, -28],
            [-84, -34],
            [-54, -65],
            [-22, -110],
            [-11, -157],
            [-23, -57],
            [-2, -32],
            [-23, -67],
            [-6, -73],
            [-20, -77],
            [-33, -49],
            [-17, -78],
            [12, -47],
            [2, -60],
            [9, -32],
            [3, -85],
            [21, -25],
            [9, -49],
            [-12, -40],
            [-7, -167],
            [0, -92],
            [-12, -15],
            [0, -32],
            [-17, -55],
            [6, -18],
            [-3, -57]
        ],
        [[41824, 48542], [-30, -55], [10, 64], [-5, 43], [4, 34], [27, 38], [-1, -53], [-5, -71]],
        [[41706, 49446], [-26, -40], [-17, 10], [8, 14], [5, 44], [28, -5], [2, -23]],
        [
            [41721, 37689],
            [32, 24],
            [21, -5],
            [19, 30],
            [20, 8],
            [28, 27],
            [47, 8],
            [23, -5],
            [39, 42],
            [60, 37],
            [25, 23],
            [78, 0],
            [31, 5],
            [37, 29],
            [65, -12],
            [21, -21],
            [242, 195],
            [-1, 40],
            [-26, 5],
            [1, 23],
            [19, 59],
            [2, 45],
            [23, 37],
            [13, 98],
            [26, 89],
            [-14, 22],
            [14, 23],
            [30, -5],
            [11, 12],
            [11, 45],
            [19, 30]
        ],
        [[42637, 38597], [38, -25], [9, -87], [-5, -37], [5, -38], [84, -49], [16, 7], [38, -25], [61, 10], [31, -35]],
        [
            [42914, 38318],
            [-24, -128],
            [7, -51],
            [11, -180],
            [-4, -44],
            [-38, -48],
            [-142, -88],
            [-37, -37],
            [-85, -151],
            [-6, -36],
            [4, -51],
            [14, -29],
            [-15, -32],
            [-16, -57],
            [-25, 4],
            [-142, 0],
            [-76, -18],
            [-40, 3],
            [-18, 14],
            [-20, 22],
            [-6, 29],
            [11, 45],
            [-7, 26],
            [-21, -1],
            [-23, -12],
            [-2, -46],
            [9, -27],
            [4, -34],
            [-9, -29],
            [-45, -4],
            [-50, -27],
            [-63, -11],
            [-50, -20],
            [-24, 25],
            [24, 12],
            [33, -6],
            [35, 21],
            [-8, 24],
            [-50, 31],
            [-56, -19],
            [-31, -37],
            [-68, 3],
            [-83, -28],
            [-14, -29],
            [2, -55],
            [17, -13],
            [15, -25],
            [-15, -24],
            [-15, -10],
            [-35, -10]
        ],
        [[41938, 37278], [-8, -14], [-20, -14], [-30, -12], [-13, 23], [27, 31], [9, 24], [16, -22], [19, -16]],
        [[42643, 48643], [38, -28], [26, -39], [49, -21], [50, -11], [15, 11]],
        [
            [42821, 48555],
            [4, -91],
            [-37, -107],
            [-15, -27],
            [-7, -65],
            [20, -87],
            [9, -65],
            [22, -57],
            [16, -130],
            [15, -44],
            [20, -30],
            [13, -82],
            [-20, -58],
            [-29, -62],
            [-3, -42],
            [6, -62],
            [13, -48],
            [-1, -57],
            [19, -52],
            [3, -33],
            [17, -57],
            [-3, -77],
            [14, -32],
            [23, -30],
            [10, -102],
            [-2, -45],
            [10, -125],
            [0, -59],
            [26, -135],
            [3, -69],
            [8, -65],
            [15, -42],
            [4, -50],
            [29, -28],
            [42, -14],
            [19, -43],
            [-7, -52],
            [-22, -55],
            [-22, -107],
            [15, -72],
            [-1, -37]
        ],
        [
            [43047, 46060],
            [-33, -5],
            [-14, -15],
            [0, -48],
            [22, -69],
            [-12, -70],
            [34, -40],
            [6, -40],
            [-5, -69],
            [-15, -53],
            [-48, -67],
            [-26, -67],
            [-17, 7],
            [-11, -44],
            [-29, 7],
            [-20, -60],
            [-24, -12],
            [-16, -47],
            [-49, -45]
        ],
        [
            [42790, 45323],
            [-9, -40],
            [-21, -45],
            [-10, -40],
            [-17, -20],
            [-17, 5],
            [-39, -10],
            [0, -84],
            [-19, -23],
            [-16, -44],
            [-21, 22],
            [-39, 2],
            [-33, -47],
            [-49, -7],
            [-38, -57],
            [-17, -50],
            [-27, 7],
            [-13, -45],
            [-42, 25],
            [-30, -15],
            [-25, 18],
            [-2, 23],
            [-28, 22],
            [-4, 22],
            [-26, 12],
            [-18, -24],
            [-60, 2],
            [-11, 44],
            [-11, 18],
            [-27, -32],
            [-21, 12],
            [-16, -15],
            [-11, -44],
            [-36, 9],
            [-6, -39],
            [14, -38],
            [18, -102],
            [14, -30],
            [-10, -82],
            [3, -47],
            [-15, -40],
            [-3, -35],
            [-13, -20],
            [-34, -127],
            [-25, -12],
            [-38, -75],
            [-31, -22],
            [-29, 15],
            [-33, 7],
            [-37, -22],
            [-25, -32],
            [-8, -28],
            [-33, -27],
            [-10, -40],
            [-20, -12],
            [-25, 9],
            [-35, -19],
            [-84, 64],
            [-38, 90],
            [-10, 75],
            [-14, 39],
            [-27, 45],
            [-47, 3]
        ],
        [
            [41353, 41890],
            [15, -64],
            [-30, -147],
            [33, 34],
            [13, 33],
            [49, -10],
            [17, 12],
            [18, 45],
            [31, 60],
            [28, -3],
            [44, 48],
            [29, 64],
            [38, 13],
            [68, 67],
            [14, 45],
            [85, 94],
            [62, 43],
            [13, 15],
            [33, 2],
            [16, -17],
            [99, -25],
            [18, -15],
            [-6, -15],
            [-19, -92],
            [-6, -50],
            [5, -20],
            [13, -20],
            [35, -22],
            [67, -30],
            [13, 5],
            [20, 45],
            [48, 35],
            [85, -23],
            [20, -40],
            [79, -107],
            [17, 5],
            [45, -57],
            [53, -40],
            [26, 0],
            [28, -42],
            [45, 5],
            [43, 35],
            [136, -214],
            [8, -125],
            [54, -35],
            [40, 25],
            [26, 35],
            [17, -12],
            [19, 7],
            [21, -32],
            [29, 12],
            [29, -22],
            [12, -22],
            [18, 12],
            [46, -27],
            [28, 2],
            [21, -42],
            [11, 2],
            [40, -57],
            [21, -3],
            [22, -62],
            [-24, -112],
            [-35, -47],
            [-24, -60],
            [-1, -22],
            [-36, -13],
            [-7, -27],
            [-3, -72],
            [13, -50],
            [-17, -25],
            [-54, 5],
            [-16, -35],
            [-15, -112],
            [2, -72],
            [-12, -27],
            [-1, -45],
            [34, -15],
            [6, -77],
            [20, 0],
            [10, -38],
            [30, -52],
            [24, -27],
            [7, -28],
            [-14, -57],
            [7, -32]
        ],
        [
            [43149, 40158],
            [-68, 47],
            [-15, -20],
            [-18, 15],
            [-41, -30],
            [-18, 5],
            [-19, -15],
            [-38, 0],
            [42, -67],
            [2, -25],
            [-22, -7],
            [-23, 27],
            [-32, -40],
            [-13, -2],
            [-25, -67],
            [4, -20],
            [32, -40],
            [6, -28],
            [-8, -102],
            [32, -32],
            [-2, -62],
            [-49, -13],
            [-32, 13],
            [-12, -25],
            [22, -30],
            [18, 10],
            [25, -52],
            [-9, -30],
            [33, -62],
            [6, -83],
            [-10, -99],
            [-27, -10],
            [5, -32],
            [-40, -63],
            [-8, -114],
            [-37, -50],
            [-18, -129],
            [-13, -15],
            [-96, 2],
            [-43, -89],
            [18, -33],
            [0, -60],
            [-16, -49],
            [12, -13],
            [-22, -62],
            [5, -10]
        ],
        [[43149, 40158], [7, -18], [158, -176], [2, -1]],
        [
            [43316, 39963],
            [-23, -175],
            [0, -115],
            [13, -241],
            [-10, -98],
            [-16, -66],
            [-19, -43],
            [-48, -52],
            [-44, -126],
            [-19, -132],
            [-29, -49],
            [-6, -74],
            [-24, -80],
            [-62, -119],
            [-40, -35],
            [-20, -34],
            [-12, -69],
            [-39, -116],
            [-4, -21]
        ],
        [
            [42790, 45323],
            [14, -13],
            [51, 15],
            [17, -5],
            [1, -32],
            [30, -3],
            [7, -19],
            [28, -23],
            [0, -99],
            [11, -33],
            [1, -32],
            [46, -37],
            [4, -70],
            [-17, -45],
            [18, -27],
            [38, 6],
            [47, 36],
            [28, 58],
            [15, 82],
            [18, 24],
            [42, 8],
            [22, 16],
            [18, 21],
            [12, 23],
            [7, 31],
            [1, 40],
            [15, 24],
            [30, 10],
            [15, 24],
            [2, 37],
            [25, 35],
            [49, 34],
            [34, -4],
            [23, -42],
            [49, -41],
            [82, -48],
            [40, -44],
            [11, -9],
            [15, 0],
            [23, 36],
            [12, -2],
            [7, -24],
            [0, -46],
            [16, -24],
            [30, -4],
            [12, -18],
            [-4, -33],
            [8, -57],
            [19, -80]
        ],
        [[43762, 44969], [76, -92]],
        [
            [43838, 44877],
            [-21, -52],
            [15, -22],
            [-11, -45],
            [21, -82],
            [19, -23],
            [0, -20],
            [37, -72],
            [-1, -127],
            [-17, -65],
            [5, -69],
            [12, -45],
            [-10, -27],
            [-48, -43],
            [-12, 0],
            [-31, 25],
            [-24, -5],
            [-17, -60],
            [3, -39],
            [18, -48],
            [20, -27],
            [16, -77],
            [24, -40],
            [-8, -65],
            [12, -25],
            [36, -22],
            [17, -47],
            [43, -18],
            [8, 20],
            [18, -10],
            [50, 23]
        ],
        [
            [44012, 43770],
            [-18, -87],
            [-68, -249],
            [-83, -209],
            [-19, -65],
            [-68, -141],
            [-50, -68],
            [-30, 6],
            [-8, 108],
            [-40, 66],
            [-11, 11],
            [-16, -69],
            [-14, -19],
            [-20, -4],
            [21, -31],
            [7, -35],
            [-22, -70],
            [-1, -64],
            [-38, -70],
            [-22, -51],
            [-11, -64],
            [-7, -60],
            [17, 16],
            [14, -31],
            [-4, -28],
            [-12, -52],
            [2, -130],
            [-4, -29],
            [12, -32],
            [13, 54],
            [7, -15],
            [-36, -348],
            [14, -157],
            [6, -177],
            [16, -173],
            [19, -167],
            [-24, -180],
            [-32, -177],
            [-19, -145],
            [-12, -156],
            [-12, -75],
            [-4, -77],
            [14, -182],
            [5, -34],
            [-38, -81],
            [-42, -40],
            [-23, -39],
            [-50, -146],
            [-5, -41]
        ],
        [[43551, 42669], [-10, -33], [-12, 5], [-14, 43], [13, 26], [22, -1], [1, -40]],
        [[43601, 42878], [-12, -12], [-2, 36], [32, 45], [5, 52], [17, -24], [4, -38], [-44, -59]],
        [
            [42821, 48555],
            [23, 17],
            [99, 9],
            [123, 41],
            [74, -10],
            [84, -27],
            [59, -69],
            [50, -39],
            [31, -39],
            [49, -40],
            [104, -107],
            [37, -62],
            [64, -85],
            [65, -36],
            [36, -88],
            [27, -40],
            [69, -150],
            [78, -105],
            [53, -104],
            [100, -68],
            [22, -62]
        ],
        [
            [44068, 47491],
            [-97, -60],
            [-16, -15],
            [-39, -57],
            [-59, -224],
            [-41, -85],
            [-10, -40],
            [0, -42],
            [-15, -65],
            [-54, -109],
            [-21, -10],
            [-13, 17],
            [-25, -37],
            [-6, -30],
            [-20, -45],
            [-9, -74],
            [25, 7]
        ],
        [
            [43668, 46622],
            [-16, -55],
            [-22, -117],
            [9, -37],
            [-9, -45],
            [-24, -30],
            [-1, -62],
            [14, -15],
            [2, -72],
            [24, -35],
            [16, -7],
            [4, -33],
            [-15, -74],
            [-15, -18],
            [-1, -42],
            [-20, -47]
        ],
        [
            [43614, 45933],
            [-37, -25],
            [-13, -23],
            [-32, -79],
            [-10, 15],
            [-23, -20],
            [-11, 57],
            [-42, 40],
            [-19, 32],
            [-14, 42],
            [-56, 40],
            [-37, 58],
            [-60, 14],
            [-33, -7],
            [-34, -25],
            [-33, -7],
            [-28, 15],
            [-85, 0]
        ],
        [
            [43838, 44877],
            [11, -14],
            [159, -134],
            [70, -60],
            [55, -40],
            [19, -31],
            [6, -39],
            [18, -39],
            [32, -39],
            [24, -19],
            [16, 2],
            [12, -22],
            [9, -44],
            [12, -22],
            [18, 0],
            [12, -12],
            [9, -33]
        ],
        [
            [44320, 44331],
            [-69, -55],
            [-41, -45],
            [-52, -83],
            [-48, -131],
            [-10, -17],
            [-17, 10],
            [0, -67],
            [-41, -105],
            [-13, -15],
            [0, 29],
            [11, 47],
            [-12, 8],
            [-24, -79],
            [8, -58]
        ],
        [
            [43762, 44969],
            [40, 90],
            [38, 25],
            [47, 92],
            [3, 45],
            [18, 20],
            [21, -65],
            [16, -3],
            [33, 20],
            [15, -32],
            [25, -22],
            [65, -110],
            [56, -37],
            [18, -28],
            [11, 38],
            [22, 15],
            [79, -18],
            [43, 47],
            [29, 5],
            [24, 33],
            [9, 30],
            [36, 40],
            [1, 27],
            [32, 40],
            [13, -5],
            [28, 17],
            [25, 3],
            [25, -28],
            [34, 30],
            [43, 18],
            [25, -28],
            [27, -2],
            [46, -15]
        ],
        [
            [44709, 45211],
            [-1, -9],
            [-57, -168],
            [-79, -173],
            [-52, -90],
            [-20, -9],
            [-19, 18],
            [14, -48],
            [-12, -42],
            [-52, -127],
            [-52, -83],
            [-54, -145],
            [-5, -4]
        ],
        [
            [44068, 47491],
            [17, -49],
            [68, -14],
            [29, -16],
            [35, -47],
            [48, -26],
            [63, 7],
            [70, -5],
            [56, 22],
            [133, -42],
            [21, -20],
            [27, -48],
            [49, -176],
            [28, -195],
            [15, -150],
            [33, -116],
            [5, -61]
        ],
        [
            [44765, 46555],
            [-23, -18],
            [-65, 15],
            [-15, -12],
            [-50, 37],
            [-62, 20],
            [-16, -10],
            [-64, -12],
            [-100, 30],
            [-13, 59],
            [-27, 3],
            [-35, -42],
            [-7, -58],
            [22, -79],
            [-27, -8],
            [1, -54],
            [8, -28],
            [-22, -80],
            [-26, -2],
            [-16, -25],
            [-18, 25],
            [8, 60],
            [-15, 32],
            [-47, 10],
            [-14, 22],
            [-16, -24],
            [-35, -18],
            [-19, -22],
            [-17, 47],
            [-20, 22],
            [-55, 10],
            [2, 73],
            [24, 19],
            [11, 70],
            [67, 155],
            [0, 34],
            [-26, 15],
            [-49, -40],
            [-17, 8],
            [-51, -25],
            [-36, -27],
            [-11, -65],
            [-15, -27],
            [-50, -50],
            [-16, -8],
            [-24, -42],
            [-33, 20],
            [-13, -10],
            [-47, 50],
            [-28, 17]
        ],
        [
            [43614, 45933],
            [17, -33],
            [17, -7],
            [1, -28],
            [19, -15],
            [24, 18],
            [9, -8],
            [20, 28],
            [15, -46],
            [1, -26],
            [14, -13],
            [10, 23],
            [17, 2],
            [6, 20],
            [19, -27],
            [10, 34],
            [25, -7],
            [24, 47],
            [32, 28],
            [26, 49],
            [49, 40],
            [35, 72],
            [17, -2],
            [11, 30],
            [29, 15],
            [32, -43],
            [41, -29],
            [0, -60],
            [-57, -38],
            [-4, -39],
            [14, -65],
            [-18, -30],
            [-36, -102],
            [40, 22],
            [20, -9],
            [7, -105],
            [20, -37],
            [30, -30],
            [40, 32],
            [16, 3],
            [48, 77],
            [-10, 40],
            [28, 49],
            [37, 8],
            [8, 47],
            [26, 8],
            [22, -8],
            [16, 25],
            [15, -25],
            [14, 25],
            [15, -25],
            [33, 5],
            [11, -12],
            [14, 59],
            [15, -7],
            [38, 20],
            [10, -3],
            [39, 33],
            [17, 112],
            [39, -3],
            [32, 43],
            [63, -15],
            [26, -58],
            [38, -20]
        ],
        [[44800, 45972], [1, -48], [-6, -32], [-1, -31], [13, -69], [0, -56], [-17, -67], [-23, -176], [-58, -282]],
        [[44765, 46555], [13, -157], [15, -69], [2, -53], [13, -12], [8, -147], [-3, -59], [-13, -86]],
        [
            [40563, 35692],
            [-11, -108],
            [-18, -26],
            [-11, 0],
            [-10, -24],
            [14, -44],
            [16, -33],
            [-2, -62],
            [-6, -52],
            [-1, -51],
            [20, -97],
            [6, -101],
            [8, -36],
            [5, -41],
            [-13, -38],
            [7, -60],
            [-22, -103],
            [12, -150],
            [-5, -139],
            [-8, -74],
            [-14, -57],
            [-32, -74],
            [-1, -74],
            [-69, -69],
            [-77, -96],
            [-70, -114],
            [-66, -139]
        ],
        [
            [40215, 33830],
            [-32, 30],
            [-16, 30],
            [-26, 12],
            [-39, -27],
            [14, -42],
            [-6, -20],
            [-36, 40],
            [2, 49],
            [29, 58],
            [19, -5],
            [19, 84],
            [-2, 88],
            [33, 54],
            [15, 40],
            [30, 15],
            [-3, 37],
            [-40, 37],
            [-31, 9],
            [-40, 2],
            [-22, -5],
            [-5, -11],
            [-24, 3],
            [-66, 26],
            [-40, 20],
            [-49, 83],
            [-71, 155],
            [-47, 84],
            [-22, 15],
            [-30, 36],
            [-37, 58],
            [-25, 27],
            [-13, -3],
            [-16, 12],
            [-19, 27],
            [-18, 6],
            [-16, -13],
            [-37, 1],
            [-12, 21],
            [-22, 54],
            [-23, 35],
            [-25, 17],
            [-28, -6],
            [-11, 9],
            [-25, 0],
            [-21, 23],
            [-30, 3],
            [-38, -16],
            [-33, 8],
            [-26, 31],
            [-23, 7],
            [-16, -1],
            [-24, 23],
            [-23, -10],
            [-9, 8],
            [-16, -5],
            [-13, -13],
            [-11, 5],
            [-13, 37],
            [-13, 10],
            [-16, -1],
            [-18, -12],
            [-10, -17],
            [-2, -21],
            [-13, -15],
            [-24, -7],
            [-13, 6],
            [-4, 17],
            [-14, 7],
            [-26, -4],
            [-16, 4],
            [-25, -2]
        ],
        [[38912, 35037], [30, 22], [24, 80], [13, 53], [-3, 43], [-8, 32], [11, 170], [2, 51], [13, 35], [0, 17]],
        [[40594, 34699], [-22, -25], [4, 132], [12, 44], [12, 33], [16, 21], [11, -29], [-10, -64], [-27, -79], [4, -33]],
        [[40563, 35460], [-6, -7], [-19, 70], [39, 66], [13, -27], [-10, -52], [-17, -50]],
        [
            [40215, 33830],
            [-10, -21],
            [-89, -244],
            [-82, -349],
            [-99, -263],
            [-40, -95],
            [-53, -106],
            [-71, -124],
            [-95, -123],
            [-105, -111],
            [-37, -50],
            [-37, -69],
            [-9, 29],
            [8, 47],
            [-5, 36],
            [-2, 46],
            [22, 9],
            [31, -30],
            [28, 40],
            [38, 12],
            [72, 121],
            [54, 45],
            [30, 77],
            [5, 41],
            [-1, 82],
            [17, 21],
            [39, -7],
            [8, 23],
            [-4, 26],
            [8, 57],
            [53, 50],
            [25, 61],
            [-9, 155],
            [10, 7],
            [22, -24],
            [10, 10],
            [11, 68],
            [-6, 35],
            [-25, 10],
            [-88, -77],
            [-29, 3],
            [-5, 61],
            [-43, 27],
            [-16, 50],
            [-5, 34],
            [-15, 14],
            [1, -59],
            [4, -57],
            [38, -67],
            [-9, -27],
            [-18, -31],
            [-13, -69],
            [1, -89],
            [-10, 27],
            [-13, 16],
            [-6, -96],
            [-25, -37],
            [-8, -36],
            [7, -42],
            [-14, -29],
            [-65, -78],
            [-64, -53],
            [-15, -25],
            [-6, -59],
            [-10, -61],
            [-29, -53],
            [-23, -106],
            [1, -46],
            [7, -68],
            [13, -44],
            [-20, -29],
            [-26, -58],
            [-21, -64],
            [-51, -243],
            [-44, -147],
            [-35, -71],
            [-48, -76],
            [-139, -190],
            [-29, 18],
            [-17, 19],
            [-6, 30],
            [2, 42],
            [7, -6],
            [17, 15],
            [5, 33],
            [-4, 68],
            [5, 64],
            [8, 43],
            [18, 35],
            [38, 22],
            [17, 55],
            [13, 62],
            [19, 21],
            [17, 5],
            [12, -13],
            [25, -49],
            [14, -4],
            [13, 6],
            [11, 17],
            [48, 133],
            [5, 29],
            [2, 48],
            [-19, 59],
            [-11, 26],
            [0, 61],
            [-3, 19],
            [-14, -8],
            [-11, -25],
            [-9, -71],
            [-21, -23],
            [-25, -20],
            [-22, -73],
            [-19, -12],
            [-24, -29],
            [-19, 26],
            [-41, 25],
            [-39, 43],
            [-34, 56],
            [-16, 58],
            [-34, 135],
            [-13, 9],
            [-22, 26],
            [-14, 23],
            [-20, 14],
            [-35, 15],
            [-37, 25],
            [-47, 62],
            [-33, 68],
            [-16, 45],
            [-18, 32],
            [-95, 52],
            [-43, 63],
            [-17, -20],
            [-26, 19],
            [-25, 31],
            [-28, 73],
            [-6, 26],
            [-26, 46],
            [-33, 49],
            [-14, 14],
            [-8, -4],
            [-11, -37],
            [-13, -12],
            [-31, -50],
            [-21, -19],
            [-40, -5],
            [-4, 49],
            [6, 86],
            [-15, 33],
            [-40, 83],
            [-71, 101],
            [-97, 146],
            [-35, 44],
            [-32, 4],
            [-29, -5],
            [-28, -20],
            [-20, -67],
            [-9, -10],
            [-52, 1],
            [-52, 11],
            [-17, 41],
            [14, 27],
            [49, 59],
            [27, 53],
            [5, 46],
            [23, 41],
            [42, 37],
            [47, 68],
            [51, 98],
            [31, 73],
            [11, 47],
            [20, 36],
            [29, 26],
            [26, 53],
            [22, 81],
            [30, 64],
            [38, 48],
            [21, 39],
            [4, 31],
            [11, 21],
            [17, 8],
            [8, 17],
            [-1, 24],
            [15, 26],
            [16, -4],
            [23, -15],
            [14, 3],
            [5, 21],
            [-6, 23],
            [-17, 26],
            [6, 29],
            [44, 47],
            [33, 17],
            [20, 29],
            [20, 45],
            [32, 32],
            [44, 18],
            [11, 17],
            [-1, 23],
            [9, 15],
            [26, 12],
            [14, 21],
            [2, 32],
            [8, 29],
            [15, 28],
            [16, 10],
            [17, -7],
            [17, 10],
            [16, 28],
            [18, 12],
            [22, -1],
            [49, 18],
            [20, 24],
            [17, 51],
            [15, 20],
            [14, -12],
            [22, 18],
            [33, 46]
        ],
        [[21607, 77498], [-231, 0], [-132, 0], [-263, 0], [-132, 0], [-263, 0], [-233, 0]],
        [
            [20353, 77498],
            [1, 25],
            [-23, 32],
            [-18, 41],
            [-51, 24],
            [-38, 68],
            [-34, 49],
            [4, 68],
            [-43, 14],
            [-7, 20],
            [16, 22],
            [13, 48],
            [2, 37],
            [-15, 77],
            [11, 29],
            [-5, 42],
            [-15, 38],
            [-23, 128],
            [-63, 104],
            [-17, 17],
            [-24, 5],
            [-24, -18],
            [-19, 23],
            [-14, 27],
            [4, 17],
            [-15, 31],
            [-12, -1],
            [-15, 16],
            [-62, 56],
            [15, 30],
            [-10, 29],
            [-54, 61],
            [-45, 17],
            [-18, 16],
            [-11, 49],
            [-31, 27],
            [-13, 17],
            [-23, 14],
            [-9, 14],
            [-9, 56],
            [-21, 28],
            [-10, 25],
            [-28, 40],
            [-21, 20],
            [-20, 60],
            [-13, 18],
            [-26, -1],
            [-15, -20],
            [-7, -21],
            [-25, -1],
            [-8, 13],
            [-31, 83],
            [-12, 23],
            [-52, 67],
            [-23, 61],
            [-20, -7],
            [-62, -1],
            [-51, 37],
            [-22, 36],
            [27, 44],
            [1, 18],
            [-47, 26],
            [-36, 31],
            [-18, -41],
            [-41, -16],
            [-16, 14],
            [6, 41],
            [-20, 44],
            [-19, 35],
            [10, 28],
            [-12, 38],
            [-17, 23],
            [-5, 29],
            [-23, 29],
            [-32, 4],
            [-19, 43],
            [-3, 30],
            [-27, 22],
            [-3, 31],
            [-9, 18],
            [-34, 32],
            [-24, 14],
            [-7, -18],
            [-2, -36],
            [-74, 39],
            [-15, 18],
            [-28, 62],
            [-59, 11],
            [-17, -5],
            [-24, 20],
            [-29, 51],
            [-23, 14],
            [2, 55],
            [44, 0],
            [3, 11],
            [-24, 36],
            [-23, 5],
            [-10, 35],
            [-17, 15],
            [-8, 26],
            [0, 215],
            [0, 214],
            [0, 215],
            [0, 214],
            [0, 215],
            [0, 214],
            [0, 215],
            [0, 215],
            [0, 214],
            [0, 215],
            [0, 214],
            [0, 215],
            [0, 214],
            [0, 215],
            [0, 215],
            [0, 214]
        ],
        [
            [18520, 83636],
            [193, 0],
            [193, 0],
            [193, 0],
            [192, 0],
            [193, 0],
            [193, 0],
            [193, 0],
            [193, 0],
            [193, 0],
            [193, 0],
            [193, 0],
            [193, 0],
            [193, 0],
            [193, 0],
            [193, 0],
            [192, 0]
        ],
        [
            [21606, 83636],
            [0, -192],
            [0, -191],
            [0, -192],
            [0, -192],
            [0, -192],
            [0, -192],
            [1, -191],
            [0, -192],
            [0, -192],
            [0, -192],
            [0, -192],
            [0, -191],
            [0, -192],
            [0, -192],
            [0, -192],
            [0, -192],
            [0, -191],
            [0, -192],
            [0, -192],
            [0, -192],
            [0, -191],
            [0, -192],
            [0, -192],
            [0, -192],
            [0, -192],
            [0, -191],
            [0, -192],
            [0, -192],
            [0, -192],
            [0, -192],
            [0, -191],
            [0, -193]
        ],
        [[20353, 77498], [-162, 0], [-263, 0], [-188, 0]],
        [[19740, 77498], [-207, 0], [-99, 0]],
        [[19434, 77498], [-164, 0], [-263, 0], [-263, 0], [-132, 0], [-263, 0], [-132, 0], [-263, 0], [-132, 0], [-163, 0]],
        [
            [17659, 77498],
            [-12, 20],
            [-30, 26],
            [-24, -8],
            [-14, -38],
            [-12, 0],
            [-9, 36],
            [11, 41],
            [-22, -5],
            [-14, 15],
            [2, 40],
            [-12, 22],
            [14, 10],
            [36, 8],
            [37, 1],
            [11, 16],
            [-32, 0],
            [-49, 14],
            [-32, -2],
            [9, 55],
            [8, 82],
            [10, 30],
            [1, 20],
            [-42, -57],
            [-4, -66],
            [-19, -9],
            [-12, 5],
            [-29, -30],
            [-101, 47],
            [-28, 29],
            [-25, 38],
            [-7, 33],
            [18, 42],
            [22, -11],
            [23, -45],
            [10, -28],
            [24, 4],
            [39, 36],
            [-47, 0],
            [-17, 15],
            [-17, 29],
            [-9, 33],
            [0, 103],
            [6, 20],
            [19, 15],
            [12, 25],
            [-13, 31],
            [-17, 17],
            [-20, 5],
            [25, -45],
            [0, -17],
            [-29, -44],
            [-4, -13],
            [0, -43],
            [-27, -22],
            [-26, -34],
            [-43, -11],
            [-40, 3],
            [-22, 17],
            [-68, 83],
            [-24, 35],
            [-1, 29],
            [-46, 104],
            [0, 22],
            [-16, 32],
            [-18, 5],
            [-4, 30],
            [37, 66],
            [23, 56],
            [1, 45],
            [-5, 60],
            [-18, -8],
            [-5, -26],
            [6, -26],
            [-4, -29],
            [-13, -41],
            [-23, -44],
            [-46, -21],
            [-83, 12],
            [-15, 21],
            [-4, 64],
            [-14, -42],
            [-8, -49],
            [-27, -12],
            [-23, 24],
            [-21, 1],
            [-38, -13],
            [-40, 6],
            [-44, 14],
            [-52, 4],
            [-14, 11],
            [1, 21],
            [9, 11],
            [55, 10],
            [53, 22],
            [52, 11],
            [-2, 12],
            [-23, 3],
            [-120, -25],
            [-45, 8],
            [-1, 25],
            [14, 24],
            [23, 22],
            [-6, 24],
            [-22, -5],
            [-10, 14],
            [11, 52],
            [-10, 54],
            [-14, -51],
            [-21, -28],
            [-102, -12],
            [-16, -15],
            [-14, 0],
            [-64, 28],
            [-28, 16],
            [-26, 24],
            [-46, 55],
            [-36, 36],
            [-2, 65],
            [7, 42],
            [18, 47],
            [66, 100],
            [22, 19],
            [21, 7],
            [96, 9],
            [72, 12],
            [-92, 14],
            [-94, -5],
            [-32, -16],
            [-42, -65],
            [-21, -47],
            [-21, 7],
            [-11, 29],
            [-22, 34],
            [-9, 39],
            [-6, 57],
            [2, 25],
            [10, 32],
            [32, 64],
            [-41, -2],
            [5, 54],
            [15, 58],
            [37, 35],
            [39, 25],
            [34, 32],
            [60, 22],
            [21, -45],
            [52, -13],
            [15, -20],
            [18, -37],
            [23, -35],
            [23, -7],
            [-44, 63],
            [-2, 22],
            [-12, 24],
            [-58, 35],
            [-10, 13],
            [-15, 58],
            [6, 22],
            [60, 67],
            [13, 35],
            [-17, 19],
            [-9, -41],
            [-149, -180],
            [-13, -9],
            [-47, -14],
            [-24, -16],
            [-13, -21],
            [-21, -56],
            [-29, -112],
            [-33, -90],
            [-28, 117],
            [-51, 89],
            [99, 89],
            [3, 14],
            [-10, 47],
            [12, 35],
            [25, 31],
            [-30, -8],
            [-45, -69],
            [-27, -25],
            [-1, 41],
            [24, 104],
            [27, 131],
            [1, 28],
            [-80, -46],
            [-27, 29],
            [-22, 147],
            [-40, 57],
            [-67, 47],
            [-65, 22],
            [-15, 42],
            [-13, 51],
            [18, 60],
            [28, 28],
            [27, 13],
            [25, -6],
            [1, -22],
            [-17, -59],
            [22, -5],
            [90, -72],
            [20, -6],
            [37, 28],
            [21, -1],
            [49, -23],
            [16, -27],
            [47, -52],
            [-7, 30],
            [-51, 65],
            [-28, 21],
            [-50, 4],
            [-31, -11],
            [-41, 20],
            [-23, 27],
            [-23, 59],
            [-4, 48],
            [15, 35],
            [56, 27],
            [-36, 34],
            [-17, 0],
            [-57, -50],
            [-22, 7],
            [-30, -36],
            [-46, -76],
            [-8, -36],
            [-2, -54],
            [-6, -34],
            [-8, -14],
            [-55, -26],
            [-31, -53],
            [-38, 45],
            [-42, 45],
            [-28, 77],
            [-50, 13],
            [-58, 44],
            [-22, 39],
            [31, 80],
            [46, 61],
            [7, 72],
            [6, 15],
            [78, 18],
            [51, 36],
            [-53, 4],
            [-31, -6],
            [-58, -25],
            [-63, 50],
            [-33, 45],
            [-11, 39],
            [12, 32],
            [7, 79],
            [19, 45],
            [28, 16],
            [24, 52],
            [10, 36],
            [49, 108],
            [18, 46],
            [34, 65],
            [68, 102],
            [-44, -14],
            [-34, 53],
            [-1, -65],
            [-7, -54],
            [-12, -39],
            [-33, -77],
            [-20, -30],
            [-13, 28],
            [10, 48],
            [19, 39],
            [4, 53],
            [-18, 63],
            [-11, 50],
            [-4, 39],
            [2, 67],
            [18, 76]
        ],
        [
            [15425, 81343],
            [4, 35],
            [-3, 35],
            [-23, 53],
            [-36, -15],
            [-61, 22],
            [-20, 61],
            [-53, 18],
            [-29, 43],
            [-105, 36],
            [-78, 54],
            [-74, 54],
            [-77, -5],
            [-3, 53],
            [-16, 32],
            [6, 28],
            [-73, 36],
            [22, 95],
            [-94, 29],
            [32, 66],
            [-21, 44],
            [-77, 124],
            [-113, 211],
            [-26, 40],
            [-37, 72],
            [-48, 81],
            [-45, 63],
            [6, 41],
            [-44, 52],
            [-85, 112],
            [-123, 81],
            [-24, 27],
            [-30, 62],
            [-15, 42],
            [-55, 39],
            [-17, 25],
            [-39, 28],
            [-44, 22],
            [-39, 85],
            [11, 61],
            [-5, 16],
            [-65, 64],
            [-66, 55],
            [-142, -73],
            [-119, -32],
            [23, -40],
            [-10, -29],
            [-21, -14],
            [-37, 2],
            [0, -100],
            [-34, -71],
            [-73, -1],
            [-143, -91],
            [-50, -47],
            [-25, 7],
            [11, 42],
            [-34, 131],
            [-183, 176],
            [-137, 132],
            [-23, 68],
            [-104, 52],
            [-4, 4]
        ],
        [
            [12638, 83636],
            [296, 0],
            [294, 0],
            [294, 0],
            [294, 0],
            [294, 0],
            [293, 0],
            [294, 0],
            [294, 0],
            [294, 0],
            [293, 0],
            [294, 0],
            [294, 0],
            [294, 0],
            [293, 0],
            [294, 0],
            [294, 0]
        ],
        [[17341, 83636], [147, 0], [295, 0], [295, 0], [294, 0], [148, 0]],
        [[17459, 77365], [-12, -14], [-13, 12], [-20, 98], [9, -2], [26, -31], [-6, -12], [20, -29], [-4, -22]],
        [[17479, 77439], [-4, -6], [-48, 39], [-32, 52], [-14, 31], [64, -78], [32, -26], [2, -12]],
        [[16639, 77700], [9, -51], [-38, 8], [-13, 10], [-1, 24], [7, 23], [36, -14]],
        [[17238, 77798], [-65, 32], [-29, 26], [-19, 29], [-35, 27], [3, 22], [23, -5], [39, -21], [35, -34], [48, -76]],
        [
            [16470, 77840],
            [-32, 4],
            [-21, 16],
            [-39, 43],
            [0, 18],
            [13, 18],
            [-9, 30],
            [31, 20],
            [27, -16],
            [27, -55],
            [7, -39],
            [-4, -39]
        ],
        [[16983, 78076], [-7, -5], [-7, 64], [12, 34], [15, -17], [6, -19], [3, -34], [-22, -23]],
        [
            [16920, 78114],
            [-4, -30],
            [-20, 48],
            [-30, 101],
            [4, 24],
            [14, 34],
            [12, 2],
            [20, -16],
            [17, -28],
            [15, -40],
            [6, -26],
            [-12, -32],
            [-22, -37]
        ],
        [
            [16298, 78417],
            [153, -70],
            [154, -34],
            [112, -41],
            [70, -12],
            [25, -9],
            [16, -15],
            [19, -34],
            [33, -83],
            [25, -52],
            [51, -92],
            [41, -65],
            [9, -26],
            [-8, -23],
            [31, -63],
            [58, -57],
            [45, -27],
            [96, -44],
            [58, -43],
            [19, -30],
            [25, -28],
            [11, -20],
            [21, -74],
            [38, -71],
            [40, -135],
            [8, 11],
            [4, 41],
            [14, 13],
            [8, -16],
            [7, -35],
            [25, -85],
            [-15, -27],
            [-35, 12],
            [-28, -46],
            [-18, -6],
            [-99, 29],
            [-61, 28],
            [-81, 44],
            [-97, 46],
            [-55, 31],
            [-46, 32],
            [-32, 28],
            [-4, 34],
            [62, 75],
            [26, 40],
            [10, 31],
            [5, 32],
            [-12, -1],
            [-9, -34],
            [-18, -36],
            [-74, -13],
            [-60, 4],
            [-31, -32],
            [-25, 7],
            [-36, 42],
            [-52, 35],
            [5, 9],
            [34, 18],
            [18, 26],
            [-26, 8],
            [-21, 33],
            [-12, 9],
            [-36, -16],
            [-10, 23],
            [14, 51],
            [-25, -7],
            [-25, 30],
            [-21, -3],
            [-23, 15],
            [-19, -34],
            [-35, 38],
            [-8, 1],
            [-17, -29],
            [-15, 11],
            [-5, 69],
            [7, 26],
            [30, 16],
            [88, 18],
            [7, 12],
            [-65, -6],
            [-18, 9],
            [-18, 24],
            [-19, -1],
            [-21, 25],
            [-28, 63],
            [-19, 16],
            [-32, 10],
            [-17, 12],
            [-23, -35],
            [-22, -6],
            [-20, 5],
            [-16, 17],
            [-13, 46],
            [9, 32],
            [-4, 27],
            [-18, 22],
            [-12, -38],
            [-19, -10],
            [-15, 18],
            [-21, 44],
            [-64, 0],
            [-30, -24],
            [-28, 4],
            [-3, 12],
            [14, 35],
            [-7, 57],
            [-30, 7],
            [-5, 11],
            [18, 55],
            [23, 14],
            [58, 5],
            [20, -8],
            [27, -21],
            [-11, 38],
            [-1, 23],
            [19, 26],
            [-18, 7],
            [-70, 6],
            [7, -40],
            [-42, -20],
            [-30, -4],
            [-29, 4],
            [-24, 12],
            [-41, 49],
            [-25, 49],
            [1, 27],
            [14, 28],
            [18, 18],
            [43, 17],
            [57, 2],
            [63, -23],
            [159, -100]
        ],
        [[16074, 78882], [-18, -10], [-19, 10], [-15, 20], [-17, 65], [8, 22], [28, 23], [14, -19], [21, -49], [-2, -62]],
        [[15115, 79153], [-15, 11], [-7, 19], [-5, 48], [6, 28], [27, -31], [-6, -75]],
        [[15937, 79398], [-24, -7], [10, 48], [-7, 48], [-1, 76], [23, 48], [36, 1], [0, -24], [-23, -157], [-14, -33]],
        [
            [15761, 79459],
            [-9, -25],
            [-42, 61],
            [-15, 17],
            [-30, 66],
            [-6, 28],
            [7, 21],
            [18, -11],
            [60, -72],
            [16, -34],
            [1, -51]
        ],
        [[15645, 79728], [-17, 3], [-13, 15], [-28, 58], [-4, 28], [20, -2], [33, -68], [9, -34]],
        [
            [14892, 79841],
            [31, -51],
            [9, -46],
            [-3, -55],
            [-50, -21],
            [-26, 17],
            [-28, -20],
            [20, -7],
            [29, -27],
            [26, -34],
            [36, -7],
            [48, -24],
            [-36, -44],
            [-6, -25],
            [46, -69],
            [4, -18],
            [14, -3],
            [34, 5],
            [4, -20],
            [-20, -40],
            [21, -15],
            [36, 0],
            [8, -40],
            [-33, -36],
            [-62, 47],
            [-27, 46],
            [-16, 44],
            [-19, 24],
            [-57, 55],
            [-88, 118],
            [-22, 17],
            [-23, 46],
            [-6, 38],
            [35, 13],
            [0, 23],
            [-100, 41],
            [-11, 8],
            [-6, 32],
            [55, -5],
            [96, 24],
            [44, 29],
            [12, 0],
            [31, -20]
        ],
        [
            [15880, 79699],
            [14, -178],
            [-1, -57],
            [-21, -37],
            [-14, -63],
            [-17, -28],
            [-16, 38],
            [-2, 62],
            [-9, 73],
            [6, 92],
            [-26, -48],
            [-21, -2],
            [-38, 45],
            [-19, 37],
            [-3, 39],
            [-25, 41],
            [-1, 29],
            [21, 41],
            [8, 27],
            [7, 57],
            [9, 22],
            [19, -4],
            [71, -53],
            [33, -37],
            [25, -96]
        ],
        [[15690, 79798], [-34, -4], [-14, 18], [3, 39], [19, 41], [18, 4], [5, -19], [3, -79]],
        [
            [15480, 79826],
            [-27, 5],
            [-67, 94],
            [-47, 35],
            [-33, 46],
            [-33, 30],
            [21, 48],
            [17, -6],
            [62, -39],
            [77, -63],
            [59, -107],
            [-4, -15],
            [-25, -28]
        ],
        [
            [15360, 80267],
            [-31, -52],
            [-14, -12],
            [-27, 10],
            [-21, 31],
            [-27, 13],
            [-12, -52],
            [-12, 25],
            [2, 33],
            [16, 22],
            [47, 46],
            [30, 7],
            [30, -28],
            [19, -43]
        ],
        [
            [14614, 80361],
            [28, -33],
            [68, 21],
            [25, -16],
            [30, -68],
            [3, -45],
            [-18, -33],
            [-108, -71],
            [9, -20],
            [22, 1],
            [85, 17],
            [5, 13],
            [6, 55],
            [12, 30],
            [1, 22],
            [-8, 54],
            [0, 21],
            [60, 4],
            [38, 20],
            [38, 37],
            [8, -1],
            [-5, -66],
            [-5, -21],
            [-37, -80],
            [-21, -71],
            [-10, -71],
            [-2, -116],
            [-9, -39],
            [-17, -25],
            [-103, -42],
            [-54, 3],
            [-47, 38],
            [-23, 27],
            [17, 32],
            [45, -5],
            [26, -12],
            [10, 7],
            [-74, 60],
            [-54, 28],
            [-16, 30],
            [-5, 37],
            [-43, 83],
            [-8, 33],
            [-6, 47],
            [0, 47],
            [10, 77],
            [23, 8],
            [30, -9],
            [74, -8]
        ],
        [[15147, 80557], [-10, 11], [2, 24], [14, 50], [40, -7], [8, -11], [-16, -31], [-38, -36]],
        [[15367, 80862], [3, -44], [-45, -74], [-57, -36], [-12, 11]],
        [[15256, 80719], [25, 36], [56, 62], [30, 45]],
        [[15367, 80862], [-1, 19], [14, 43], [42, 90], [-7, 63], [-19, 63], [-8, 73], [11, 69], [26, 61]],
        [[15425, 81343], [-20, -57], [-10, -53], [4, -61], [23, -92], [7, -47], [-1, -27], [-61, -144]],
        [
            [28104, 81880],
            [-159, -176],
            [-159, -178],
            [-108, -126],
            [-108, -125],
            [-108, -125],
            [-108, -126],
            [-94, -116],
            [-94, -117],
            [-95, -116],
            [-94, -117],
            [-157, -204],
            [-158, -205],
            [-118, -129],
            [-118, -129],
            [-119, -129],
            [-118, -129],
            [0, -240],
            [-1, -241],
            [0, -240],
            [0, -241],
            [0, -240],
            [-1, -241],
            [0, -240],
            [1, -242]
        ],
        [[26188, 77708], [-2, -210], [-204, 0], [-263, 0], [-170, 0]],
        [[25549, 77498], [-225, 0], [-263, 0], [-132, 0], [-263, 0], [-263, 0], [-132, 0]],
        [
            [24271, 77498],
            [-11, 239],
            [-13, 237],
            [-12, 238],
            [-12, 238],
            [-12, 238],
            [-13, 238],
            [-12, 237],
            [-12, 238],
            [-13, 238],
            [-12, 238],
            [-12, 238],
            [-12, 237],
            [-13, 238],
            [-12, 238],
            [-12, 238],
            [-13, 237],
            [0, 146],
            [0, 292],
            [0, 146],
            [0, 291],
            [0, 292],
            [0, 146],
            [0, 291],
            [0, 292],
            [0, 291],
            [0, 146]
        ],
        [[24075, 83636], [278, 0], [278, 0], [278, 0], [138, 0], [278, 0], [139, 0], [278, 0], [278, 0], [287, 0]],
        [
            [26307, 83636],
            [-4, -27],
            [2, -265],
            [-3, -117],
            [-10, -65],
            [-16, -35],
            [8, -21],
            [22, -17],
            [19, -65],
            [12, -19],
            [29, 0],
            [13, -12],
            [37, -57],
            [40, -16],
            [2, -32],
            [-16, -179],
            [19, 22],
            [20, 139],
            [26, 61],
            [21, 13],
            [85, 7],
            [91, -16],
            [34, -2],
            [30, 9],
            [31, -17],
            [7, -17],
            [9, -73],
            [8, -42],
            [54, -147],
            [26, -83],
            [31, -130],
            [12, -37],
            [65, -172],
            [13, -47],
            [5, -36],
            [-2, -25],
            [-12, -39],
            [-22, -52],
            [-20, -40],
            [-38, -49],
            [26, 3],
            [44, 36],
            [17, 8],
            [47, 5],
            [17, -20],
            [71, 30],
            [280, 99],
            [66, 9],
            [94, -18],
            [76, -42],
            [84, -54],
            [87, -40],
            [139, -36],
            [40, -18],
            [81, -18]
        ],
        [[34952, 75094], [-41, -29], [16, 75], [13, 23], [18, -7], [-6, -62]],
        [[35648, 76881], [-8, -40], [-27, -35], [-19, 1], [7, 22], [-1, 39], [31, 2], [17, 11]],
        [[35658, 76922], [-36, -29], [16, 43], [18, 12], [2, -26]],
        [[35795, 75837], [-6, -20], [-33, -7], [-35, -64], [-13, -8]],
        [
            [35708, 75738],
            [-28, -5],
            [-24, -12],
            [-17, 34],
            [-29, 45],
            [-3, -19],
            [15, -55],
            [-57, -98],
            [-37, -7],
            [-49, -46],
            [-70, -39],
            [-81, -76],
            [-105, -64],
            [-22, 0],
            [-47, 52],
            [13, 24],
            [-7, 9],
            [-29, -22],
            [24, -44],
            [-12, -16],
            [-33, -22],
            [-31, -31],
            [-27, -21],
            [-22, 27],
            [-61, -34],
            [-51, -9],
            [-11, 17],
            [-3, 27],
            [-18, 7],
            [-33, -8],
            [-13, 14]
        ],
        [
            [34840, 75366],
            [-38, 18],
            [-20, -26],
            [-16, 11],
            [-27, 41],
            [-6, 16],
            [14, 57],
            [-20, 53],
            [1, 15],
            [20, 17],
            [3, 19],
            [-11, 24]
        ],
        [[34740, 75611], [-9, 42], [-16, -23], [-21, -3], [-33, 31], [-29, 35]],
        [
            [34632, 75693],
            [8, 35],
            [-2, 31],
            [4, 30],
            [-5, 14],
            [-4, 304],
            [-3, 326],
            [-90, 107],
            [-42, 40],
            [-24, 5],
            [-14, -6],
            [-6, -16],
            [-32, -17],
            [-58, -18],
            [-49, -28],
            [-34, 5],
            [-20, 14],
            [-16, 32]
        ],
        [
            [34245, 76551],
            [131, 71],
            [41, 33],
            [21, 27],
            [15, 33],
            [1, 190],
            [81, 0],
            [0, 39],
            [155, 0],
            [10, -33],
            [66, -47],
            [18, 18],
            [37, 4],
            [40, 13],
            [33, -10],
            [8, 35],
            [26, 19],
            [42, 14]
        ],
        [
            [34970, 76957],
            [23, -6],
            [62, 31],
            [22, -4],
            [46, -40],
            [111, -43],
            [29, -29],
            [28, -91],
            [18, -14],
            [38, 9],
            [43, 45],
            [36, 24],
            [70, 20],
            [-14, -30],
            [53, 3],
            [53, -41],
            [-20, -28],
            [-26, -58],
            [-19, -112],
            [-53, -76],
            [-72, -74],
            [18, -17],
            [21, -11],
            [46, 22],
            [31, -2],
            [34, -14],
            [-10, -57],
            [-13, -39],
            [8, -37],
            [20, -69],
            [28, -15],
            [11, -89],
            [15, -48],
            [-2, -39],
            [28, -25],
            [5, -40],
            [102, -11],
            [20, -15],
            [71, -15],
            [26, -33],
            [-69, -48],
            [7, -4]
        ],
        [[38822, 76633], [-16, -19], [-13, 18], [28, 56], [4, 25], [15, 13], [6, -19], [-24, -74]],
        [[38721, 77830], [-72, -51], [-10, 10], [-14, 34], [23, 9], [17, -16], [36, 33], [18, 5], [2, -24]],
        [[38863, 77917], [23, -36], [12, -10], [-80, -39], [-15, 2], [0, 37], [9, 32], [18, -17], [19, 35], [14, -4]],
        [[38418, 78461], [-29, 1], [7, 33], [24, 11], [17, -14], [-19, -31]],
        [
            [38441, 78916],
            [-22, -55],
            [-16, -27],
            [-46, -17],
            [-65, -8],
            [-27, -9],
            [-4, -37],
            [13, -35],
            [12, -4],
            [27, 9],
            [18, -9],
            [10, -33],
            [-5, -55],
            [-22, -70],
            [-28, -39],
            [-36, -32],
            [-13, -26],
            [-5, -46],
            [-18, -37],
            [-58, -94],
            [-22, -20],
            [-9, -61],
            [-17, -36],
            [-48, -82],
            [-17, -52],
            [-1, -47],
            [-30, -65],
            [13, -31],
            [-4, -54],
            [20, 21],
            [45, 76],
            [34, 46],
            [22, 16],
            [16, 20],
            [17, 44],
            [23, 43],
            [21, 14],
            [18, -29],
            [-2, -27],
            [-11, -32],
            [73, 34],
            [16, -3],
            [34, -29],
            [28, 3],
            [44, 17],
            [9, -8],
            [-8, -26],
            [-17, -24],
            [-42, -36],
            [-99, -69],
            [-4, -26],
            [23, 11],
            [34, -4],
            [-7, -50],
            [-61, -72],
            [15, 3],
            [69, 32],
            [43, -45],
            [58, 16],
            [35, 15],
            [7, -29],
            [-1, -31],
            [20, 6],
            [4, 11],
            [-1, 57],
            [16, -4],
            [7, -14],
            [2, -41],
            [-18, -79],
            [-26, -55],
            [3, -50],
            [25, 24],
            [3, 44],
            [21, 24],
            [34, 30],
            [12, 4],
            [13, -20],
            [23, 27],
            [20, 16],
            [19, 5],
            [20, 19],
            [43, 57],
            [24, 20],
            [10, 2],
            [-4, -34],
            [6, -71],
            [4, -7],
            [29, 48],
            [123, 15],
            [29, -9],
            [33, -23],
            [42, -35],
            [16, -33],
            [2, -40],
            [-4, -28],
            [-30, -36],
            [-27, -23],
            [-15, -24],
            [-12, -37],
            [-17, -21],
            [-80, -56],
            [19, -2],
            [46, 12],
            [30, 3],
            [-10, -24],
            [-23, -16],
            [-2, -18],
            [25, -13],
            [31, 6],
            [27, -8],
            [-3, -14],
            [-21, -44],
            [-6, -28],
            [-28, -23],
            [-56, -37],
            [83, 17],
            [18, 26],
            [29, 9],
            [29, -17],
            [43, 45],
            [16, 6],
            [26, -5],
            [17, 8],
            [29, 30],
            [22, 15],
            [9, -14],
            [2, -35],
            [-12, -51],
            [-24, -43],
            [-27, -21],
            [-24, 2],
            [-10, -7],
            [-22, -34],
            [-39, -35],
            [-24, -14],
            [15, -18],
            [6, -37],
            [-8, -11],
            [-42, -12],
            [-28, -32],
            [44, 9],
            [-2, -32],
            [-11, -26],
            [-52, -68],
            [8, -40],
            [22, -44],
            [29, -1],
            [21, 8],
            [31, 46],
            [68, 141],
            [61, 40],
            [51, 44],
            [11, -9],
            [4, -21],
            [-26, -36],
            [-13, -30],
            [-35, -91],
            [-13, -43],
            [-7, -46],
            [2, -78],
            [15, -32],
            [20, 15],
            [34, 39],
            [22, 37],
            [18, 61],
            [10, 23],
            [22, -13],
            [3, -30],
            [10, -39],
            [5, -41],
            [-9, -68],
            [-71, -180],
            [8, -32],
            [0, -40],
            [-23, -87],
            [-33, -77],
            [-30, -19],
            [-15, 8],
            [-24, 31],
            [-28, -3],
            [-47, -44],
            [-17, 4],
            [-8, 23],
            [7, 116],
            [4, 38],
            [-10, 30],
            [10, 49],
            [1, 19],
            [-18, 3],
            [-18, -25],
            [-25, -45],
            [-26, -41],
            [-46, -55],
            [-21, -11],
            [-17, 10],
            [-13, 23],
            [6, 49],
            [19, 66],
            [38, 98],
            [31, 70],
            [6, 30],
            [-16, 38],
            [-12, 75],
            [-15, 63],
            [-18, 27],
            [-45, 30],
            [-8, -7],
            [-5, -42],
            [-52, -120],
            [-9, -52],
            [-17, -33],
            [-23, -16],
            [6, 28],
            [25, 62],
            [-4, 6],
            [-31, -50],
            [-23, -27],
            [-29, -7],
            [-18, 1],
            [-17, -7],
            [-72, -118],
            [-3, -39],
            [-12, -32],
            [-36, -58],
            [-18, -21],
            [-27, -3],
            [-24, 10],
            [-16, -2],
            [-37, -18],
            [-42, -8],
            [-29, 11],
            [-21, 23],
            [-2, 25],
            [11, 24],
            [25, 31],
            [21, 11],
            [50, 16],
            [36, 23],
            [41, 54],
            [52, 106],
            [67, 38],
            [32, 30],
            [23, 39],
            [-46, -11],
            [-28, 7],
            [-12, 14],
            [-38, -5],
            [-52, 7],
            [-8, -11],
            [-6, -51],
            [-7, -27],
            [-20, -15],
            [-24, -6],
            [-61, 19],
            [-27, 18],
            [-68, -17],
            [-1, 13],
            [67, 38],
            [7, 109],
            [-4, 18],
            [-19, -15],
            [-31, -16],
            [-40, 6],
            [-22, -58],
            [-32, -9],
            [-42, -21],
            [-81, -14],
            [-16, -15],
            [-55, 5],
            [-160, 32],
            [-58, -3],
            [-69, 19],
            [-13, 8],
            [-97, -3],
            [-29, 4],
            [-1, 31],
            [-28, -27],
            [-25, -17],
            [-32, -15],
            [-102, -25],
            [-54, -6],
            [-31, 18],
            [-13, 18],
            [-19, 57],
            [-13, 72],
            [7, 38],
            [21, 34],
            [96, 91],
            [78, 93],
            [32, 48],
            [32, 17],
            [51, 40],
            [-48, 0],
            [-35, 11],
            [-36, 4],
            [-68, -10],
            [-69, 0],
            [0, 20],
            [32, 39],
            [68, 66],
            [-20, -54],
            [20, -25],
            [39, -4],
            [9, 13],
            [14, 71],
            [30, 83],
            [16, 59],
            [27, 45],
            [14, 7],
            [13, -8],
            [41, -11],
            [42, -42],
            [-16, 50],
            [16, 58],
            [21, 27],
            [-36, 0],
            [-29, 16],
            [-9, 26],
            [2, 46],
            [10, 27],
            [23, 36],
            [28, 24],
            [17, -6],
            [32, -33],
            [18, 20],
            [-30, 51],
            [-10, 38],
            [1, 18],
            [66, 181],
            [32, 97],
            [44, 147],
            [32, 67],
            [10, 12],
            [46, 6],
            [-26, 19],
            [-10, 27],
            [17, 26],
            [34, 24],
            [24, 39],
            [15, 46],
            [-9, 39],
            [18, 10],
            [53, 65],
            [17, 73],
            [21, 32],
            [50, 37],
            [96, 50],
            [56, 44],
            [39, -2],
            [11, -31],
            [54, -21],
            [9, 22],
            [-12, 27],
            [10, 11],
            [45, 10],
            [21, -19],
            [-2, -15]
        ],
        [[38471, 79113], [-18, 6], [7, 22], [16, 24], [22, 7], [-6, -36], [-21, -23]],
        [[36733, 81427], [3, -13], [-47, 9], [-17, 9], [1, 23], [9, 16], [22, 13], [37, -24], [-8, -33]],
        [[36501, 82272], [26, -17], [7, -60], [-48, 3], [-56, 41], [-11, 30], [23, 3], [27, 14], [32, -14]],
        [
            [37935, 78865],
            [-1, 311],
            [-251, -1],
            [-251, 0],
            [-125, 0],
            [-251, 0],
            [-126, 0],
            [-251, 0],
            [-125, 0],
            [-251, 0],
            [-126, 0],
            [-251, 0],
            [-46, 6],
            [-9, 22],
            [25, -1],
            [13, 6],
            [-6, 44],
            [-26, 89],
            [-36, 26],
            [-16, 20],
            [-5, 27],
            [-34, 16],
            [14, 38],
            [36, 35],
            [27, 13],
            [89, 21],
            [31, 11],
            [4, 11],
            [-43, 48],
            [-5, 28],
            [5, 64],
            [-17, 53],
            [-21, 37],
            [-39, 2],
            [-37, -22],
            [-17, -95],
            [-10, -9],
            [-41, -14],
            [-12, -22],
            [-3, -105],
            [1, -40],
            [25, -98],
            [-8, -107],
            [-9, -22],
            [-31, -27],
            [-19, -94],
            [-4, -49],
            [14, -41],
            [-1, -22],
            [-66, -67],
            [-29, -5],
            [-30, 67],
            [1, 24],
            [17, 15],
            [4, 19],
            [-43, 45],
            [-52, 84],
            [-32, 32],
            [-31, 23],
            [-40, 17],
            [-41, 10],
            [-23, -4],
            [-24, -57],
            [-24, -11],
            [-19, 11],
            [-28, 6],
            [-14, -29],
            [-17, 1],
            [-30, 15],
            [-17, 16],
            [-19, 56],
            [-16, 11],
            [-41, 40],
            [-5, -4],
            [-15, -78],
            [-19, 16],
            [-10, 26],
            [-7, 62],
            [21, 43],
            [-10, 135],
            [19, 45],
            [7, 55],
            [13, 32],
            [-28, 53],
            [-24, 15],
            [-16, -34],
            [-29, -15],
            [-5, -12],
            [-13, -90],
            [-5, -12],
            [-39, -22],
            [-12, 6],
            [-30, 0],
            [-24, 13],
            [-12, 19],
            [0, 43],
            [4, 49],
            [8, 34],
            [18, 51],
            [2, 61],
            [8, 82],
            [-13, 31],
            [-29, 18],
            [-28, 70],
            [-90, 33],
            [-6, 19],
            [6, 53],
            [-4, 37],
            [-19, 23],
            [-70, 109],
            [-1, 15],
            [25, 45],
            [52, 53],
            [-1, 25],
            [-21, 62],
            [-11, 63],
            [5, 26],
            [20, 11],
            [69, -30],
            [9, 0],
            [15, 38],
            [27, 17],
            [1, 20],
            [-18, 26],
            [-27, 70],
            [-25, 52],
            [-20, 66],
            [9, 20],
            [33, -5],
            [42, -70],
            [92, -88],
            [44, -18],
            [23, 28],
            [-2, 27],
            [-17, 57],
            [6, 27],
            [-17, 74],
            [7, 46],
            [-22, 45],
            [19, 14],
            [36, -35],
            [117, -138],
            [48, -37],
            [62, -19],
            [26, -57],
            [38, -34],
            [171, -14],
            [94, 8],
            [147, -4],
            [133, -51],
            [49, -13],
            [16, 2],
            [13, 16],
            [27, 74],
            [24, 79],
            [3, 38],
            [-21, 56],
            [12, 45],
            [25, 24],
            [83, 54],
            [15, 18],
            [-12, 36],
            [-1, 61],
            [-46, 16],
            [-34, 30],
            [-34, 61],
            [-55, 87],
            [1, 34],
            [43, 39],
            [-6, 18],
            [-79, 21],
            [-16, 14],
            [-36, 6],
            [4, 26],
            [28, 38],
            [-4, 9],
            [-53, 26],
            [-11, 13],
            [-5, 53],
            [26, 20],
            [30, 5],
            [9, 20],
            [-9, 29],
            [-49, 91],
            [4, 27],
            [22, 27],
            [24, 43],
            [15, 14],
            [8, 75],
            [26, 59],
            [11, 55],
            [-13, 50],
            [18, 43],
            [-6, 66],
            [5, 38],
            [40, 49],
            [-1, 32],
            [-30, -17],
            [-39, 9],
            [-25, 40],
            [-20, 11],
            [-18, -10],
            [-27, 50],
            [-29, 79],
            [-49, 45],
            [-5, 13],
            [9, 27],
            [85, 106],
            [23, 22],
            [54, 34],
            [2, 25],
            [-13, 28],
            [-48, -6],
            [-14, 31],
            [4, 23],
            [34, 24],
            [126, 26],
            [15, 22],
            [-27, 33],
            [-42, 18],
            [-81, -28],
            [-51, -23],
            [-25, 8],
            [-18, 45],
            [-100, 26],
            [-59, 10],
            [-12, 11],
            [5, 39],
            [19, 16],
            [117, -28],
            [21, 12],
            [-3, 13],
            [-44, 41],
            [-13, 61],
            [0, 72],
            [5, 24],
            [24, 32],
            [14, 11],
            [-2, 22],
            [-18, 7],
            [-84, -34],
            [-18, 12],
            [-13, 29],
            [8, 154],
            [9, 27],
            [30, 23],
            [-6, 21],
            [-46, 24],
            [-15, 35],
            [31, 8],
            [40, 26],
            [2, 28],
            [-45, 20],
            [-17, 23],
            [9, 17],
            [62, 21]
        ],
        [
            [35615, 83806],
            [36, -21],
            [19, -22],
            [6, -32],
            [-34, -43],
            [-57, -32],
            [-6, -22],
            [53, 26],
            [47, 12],
            [38, -1],
            [32, -51],
            [4, -70],
            [6, -30],
            [29, 17],
            [24, -39],
            [2, -31],
            [13, -29],
            [55, -74],
            [-31, -36],
            [-37, -22],
            [8, -16],
            [51, -17],
            [9, -40],
            [35, 35],
            [30, -5],
            [39, -77],
            [-29, -44],
            [-43, -20],
            [-34, -9],
            [-47, 1],
            [-10, -21],
            [46, 0],
            [69, 11],
            [53, 18],
            [22, 1],
            [32, -13],
            [-25, -13],
            [27, -59],
            [-20, -34],
            [29, -5],
            [42, 11],
            [13, -13],
            [25, -50],
            [17, -52],
            [-71, -70],
            [-36, -15],
            [-53, -37],
            [-14, -30],
            [-31, -39],
            [19, 1],
            [55, 61],
            [27, 15],
            [20, -4],
            [21, -25],
            [74, 36],
            [31, 7],
            [40, 2],
            [4, -12],
            [-25, -87],
            [-42, -66],
            [-78, -41],
            [-27, -24],
            [-34, -38],
            [13, -7],
            [74, 50],
            [50, 20],
            [71, 16],
            [31, -2],
            [56, -101],
            [32, -10],
            [26, 5],
            [49, -29],
            [18, -28],
            [-4, -20],
            [-17, -12],
            [-8, -19],
            [20, -56],
            [-12, -32],
            [-36, -28],
            [-25, -14],
            [-27, -4],
            [-26, -25],
            [-36, -13],
            [47, -12],
            [33, 8],
            [33, -1],
            [52, -18],
            [21, -22],
            [-27, -59],
            [-12, -15],
            [36, -28],
            [20, -6],
            [25, 5],
            [27, -7],
            [91, -96],
            [-4, -50],
            [-14, -38],
            [6, -43],
            [0, -53],
            [-49, -15],
            [-164, 25],
            [-94, 38],
            [-4, 11],
            [26, 26],
            [-23, 1],
            [-39, -19],
            [31, -40],
            [86, -35],
            [39, -42],
            [42, -4],
            [36, -33],
            [-7, -8],
            [-43, -3],
            [-34, -29],
            [22, -17],
            [76, -14],
            [55, -4],
            [28, -17],
            [-23, -18],
            [-64, -22],
            [-2, -32],
            [48, -13],
            [42, 8],
            [17, -3],
            [13, -78],
            [7, -17],
            [-46, -13],
            [0, -15],
            [31, -12],
            [50, -11],
            [17, -14],
            [13, -35],
            [29, -3],
            [32, 29],
            [19, 25],
            [27, -9],
            [2, -31],
            [33, -34],
            [12, -6],
            [9, -49],
            [27, 44],
            [41, -12],
            [-7, -42],
            [-13, -33],
            [17, -21],
            [13, -31],
            [36, -42],
            [-9, -21],
            [-43, -43],
            [-27, -93],
            [-22, -39],
            [-11, -35],
            [66, 71],
            [40, 23],
            [87, 13],
            [21, 20],
            [32, 8],
            [20, -22],
            [2, -41],
            [25, -13],
            [28, 14],
            [24, -12],
            [-15, -26],
            [-79, -104],
            [-2, -31],
            [99, 94],
            [32, 54],
            [20, 26],
            [54, -9],
            [27, -19],
            [13, -53],
            [22, -57],
            [32, -64],
            [87, -30],
            [31, -5],
            [54, 21],
            [9, 30],
            [42, 9],
            [30, -4],
            [10, -57],
            [63, -55],
            [30, -13],
            [45, -6],
            [24, -28],
            [0, -11],
            [-25, -29],
            [-24, -43],
            [-42, -30],
            [-59, -2],
            [-81, -19],
            [-3, -17],
            [-18, -18],
            [-66, -33],
            [-38, -70],
            [-23, -29],
            [-27, -6],
            [-38, 3],
            [-24, -7],
            [-18, -12],
            [-19, -26],
            [-50, -19],
            [-91, -53],
            [-48, -2],
            [-30, 6],
            [-23, -4],
            [-15, -15],
            [-44, -26],
            [-20, -34],
            [-6, -37],
            [-14, -21],
            [-37, 8],
            [-40, 24],
            [8, -26],
            [64, -43],
            [19, -24],
            [-18, -21],
            [-41, -32],
            [-5, -18],
            [17, -9],
            [-7, -15],
            [-22, -15],
            [5, -13],
            [56, 22],
            [50, 48],
            [32, 49],
            [16, 14],
            [65, 18],
            [38, 21],
            [54, 38],
            [59, 56],
            [65, 74],
            [83, 57],
            [100, 41],
            [74, 21],
            [47, 1],
            [-40, 20],
            [-35, 2],
            [-43, -9],
            [-13, 22],
            [15, 26],
            [37, 15],
            [178, -20],
            [61, -16],
            [67, -133],
            [16, -43],
            [4, -31],
            [-7, -20],
            [-27, -23],
            [-75, -46],
            [-12, -18],
            [33, -9],
            [10, -13],
            [17, -51],
            [34, 33],
            [65, 80],
            [53, 38],
            [44, 10],
            [72, 4],
            [6, -26],
            [28, -52],
            [26, -14],
            [49, -7],
            [45, -65],
            [17, -45],
            [16, -26],
            [1, -32],
            [18, -41],
            [-3, -43],
            [-26, -75],
            [19, -68],
            [-9, -31],
            [-4, -49],
            [21, -52],
            [-14, -11],
            [-98, -27],
            [-39, 0],
            [-10, -17],
            [30, -4],
            [54, 1],
            [66, -17],
            [29, -19],
            [12, -25],
            [-3, -21],
            [-19, -15],
            [-70, 3],
            [53, -33],
            [44, -38],
            [5, -29],
            [-7, -29],
            [-99, -117],
            [-82, -73],
            [-82, -65],
            [-132, -124],
            [-38, -8]
        ],
        [
            [35795, 75837],
            [49, -30],
            [53, -57],
            [41, 11],
            [18, -1],
            [47, -36],
            [20, -33],
            [24, 3],
            [33, 14],
            [61, -3],
            [65, -20],
            [-5, -31],
            [-10, -21],
            [51, 7],
            [31, -21],
            [19, 23],
            [63, 37],
            [81, 77],
            [10, -10],
            [14, -76],
            [31, -33],
            [37, -7],
            [51, 25],
            [20, -22],
            [24, -41],
            [22, -55],
            [-1, -19],
            [-29, -17],
            [-26, -25],
            [109, -10],
            [23, -31],
            [-21, -33],
            [-20, 13],
            [-37, -12],
            [-32, -28],
            [-34, -16],
            [-22, -1],
            [-24, -13],
            [-22, -20],
            [-23, -6],
            [-72, -50],
            [-73, -33],
            [-77, -51],
            [-79, -33],
            [-81, -39],
            [-38, -2],
            [-47, -38],
            [-23, 5],
            [-23, -7],
            [-27, 9],
            [-5, -25],
            [5, -38],
            [-21, -35],
            [-46, 3],
            [-40, 34],
            [-10, 32],
            [-24, 23],
            [-14, -32],
            [0, -24],
            [-17, -32],
            [-21, 55],
            [-36, -20],
            [-16, -59],
            [8, -16],
            [11, -45],
            [-18, -24],
            [-14, 7],
            [-28, -66],
            [-34, -24],
            [-34, -68],
            [-42, -51],
            [-11, -34],
            [-69, -79],
            [-46, 0],
            [-29, -33],
            [-5, -66],
            [-26, 7],
            [-7, -21],
            [-9, -3],
            [-26, 19],
            [-30, -11],
            [-23, 15],
            [-30, 97],
            [-16, 34],
            [-29, 11],
            [-18, -40],
            [-27, 39],
            [-21, 149],
            [0, 36],
            [29, 124],
            [71, 112],
            [-22, 4],
            [-64, -78],
            [18, 39],
            [21, 31],
            [32, 30],
            [43, 18],
            [30, 2],
            [50, 46],
            [-21, -3],
            [-43, -17],
            [22, 35],
            [232, 201],
            [47, 33],
            [93, 43],
            [13, 27],
            [24, 2],
            [-9, -39],
            [-2, -29],
            [4, -27],
            [36, -13],
            [31, -51],
            [-14, 69],
            [27, 39],
            [107, 52],
            [89, 6],
            [28, 24],
            [-76, 17],
            [-90, -9],
            [-56, 18],
            [-77, -12],
            [-81, 11],
            [-25, -15],
            [-20, -32],
            [-52, 28],
            [27, 56],
            [82, 84],
            [50, 72],
            [15, 16],
            [11, 29]
        ],
        [[37105, 74681], [-41, -20], [-36, 1], [-25, 26], [56, -7], [22, 4], [43, 31], [-19, -35]],
        [[35103, 74877], [-12, 0], [19, 49], [13, 7], [-20, -56]],
        [[36743, 75545], [-16, 3], [-20, 23], [16, 23], [35, -6], [-15, -43]],
        [
            [36699, 75799],
            [10, -5],
            [42, 27],
            [22, -1],
            [-1, -19],
            [-36, -21],
            [-17, -16],
            [21, -15],
            [0, -10],
            [-25, -24],
            [-12, -26],
            [10, -25],
            [39, 25],
            [39, -6],
            [21, 8],
            [12, 12],
            [70, 97],
            [3, 12],
            [-75, -20],
            [-9, 13],
            [50, 59],
            [-4, 30],
            [25, 49],
            [39, 45],
            [25, 15],
            [16, -23],
            [6, -42],
            [41, 6],
            [41, -8],
            [29, -18],
            [5, -26],
            [-10, -28],
            [-16, -24],
            [33, -30],
            [-5, -13],
            [-53, -34],
            [-31, -35],
            [-28, -42],
            [-56, -49],
            [-88, -36],
            [-28, 0],
            [-33, 11],
            [-33, -2],
            [-33, -13],
            [-32, 1],
            [-30, -6],
            [-38, 53],
            [-13, 26],
            [-14, 126],
            [5, 66],
            [22, 61],
            [33, 41],
            [19, 33],
            [79, 194],
            [16, 44],
            [19, 38],
            [34, 37],
            [44, 63],
            [14, 12],
            [26, 6],
            [25, -3],
            [-7, -23],
            [1, -22],
            [29, -86],
            [0, -18],
            [-16, -69],
            [-30, -111],
            [-8, -61],
            [4, -19],
            [-25, -55],
            [-52, -44],
            [-27, -10],
            [-25, -17],
            [-59, -55]
        ],
        [
            [17341, 83636],
            [-19, 22],
            [-35, 0],
            [-6, 11],
            [5, 37],
            [-33, 55],
            [-31, 71],
            [-6, 56],
            [-8, 11],
            [-47, 12],
            [-21, 41],
            [-40, 53],
            [-3, 21],
            [32, 49],
            [0, 19],
            [-24, 73],
            [-10, 4],
            [-59, 0],
            [-16, -20],
            [-7, -36],
            [-83, -9],
            [-53, -29],
            [-17, 0],
            [-102, 27],
            [-48, 28],
            [-21, -4],
            [-22, -42],
            [-30, 12],
            [-5, 19],
            [-33, -4],
            [-10, -35],
            [-29, -7],
            [-53, 11],
            [-44, -21],
            [-32, 7],
            [-20, -6],
            [-18, 17],
            [-9, 50],
            [3, 36],
            [-11, 57],
            [-34, 0],
            [-11, 10],
            [20, 32],
            [2, 61],
            [-16, 74],
            [-29, 53],
            [-41, 27],
            [-52, -1],
            [-44, 12],
            [-32, 31],
            [-29, 17],
            [-57, 52],
            [-8, 38],
            [-23, 34],
            [-35, 14],
            [-16, 34],
            [-34, 36],
            [-10, 23],
            [-50, 47],
            [-36, -3],
            [-30, -24],
            [-20, 2],
            [-12, 22],
            [-41, 11],
            [-38, -3],
            [-23, 5],
            [-18, 17],
            [11, 30],
            [-19, 42],
            [17, 44],
            [-17, 21],
            [2, 17],
            [27, 16],
            [-3, 24],
            [-74, 37],
            [-12, 10],
            [-11, 42],
            [-30, 22],
            [-11, 36],
            [-19, 30],
            [1, 56],
            [30, 59],
            [-4, 17],
            [-32, 1],
            [-29, 12],
            [-24, 54],
            [-47, 41],
            [-23, 8],
            [10, 24],
            [47, 32],
            [13, 16],
            [19, 45],
            [-13, 39],
            [-27, 33],
            [-27, 12],
            [-15, 33],
            [-41, -10],
            [-17, 24],
            [47, 23],
            [2, 26],
            [-44, 8],
            [-25, 15],
            [-46, 39],
            [-46, 17],
            [-30, 24],
            [-27, 31],
            [-29, 51],
            [8, 15],
            [-5, 29],
            [-25, 30],
            [-3, 29],
            [-26, 42],
            [-49, 26],
            [-29, 6],
            [-28, -23],
            [-42, -20],
            [-55, 0],
            [-8, 25],
            [23, 50],
            [-12, 17],
            [-43, 18],
            [-49, 59],
            [-83, 44],
            [-25, 8],
            [-47, 2],
            [-15, 25],
            [30, 33],
            [2, 41],
            [45, 45],
            [-9, 20],
            [-41, 11],
            [-8, 42],
            [-12, 8],
            [-53, -6],
            [-3, 29],
            [51, 31],
            [17, 33],
            [60, 58],
            [24, 52],
            [23, 34],
            [-1, 16],
            [-30, 50],
            [-80, 78],
            [5, 16],
            [61, 39],
            [-10, 21],
            [-34, -2],
            [-41, 22],
            [-30, -17],
            [-34, -39],
            [-25, -8],
            [-20, 11],
            [16, 38],
            [-7, 15],
            [-32, -1],
            [-58, -12],
            [-56, -28],
            [-55, 4],
            [-27, 74],
            [34, 45],
            [-5, 61],
            [-21, 8],
            [-43, 3],
            [-3, 11],
            [19, 64],
            [26, 7],
            [6, 63],
            [-40, 48],
            [-13, 46],
            [4, 47],
            [-40, 47],
            [-33, 23],
            [-8, 34],
            [-373, 0],
            [-266, 0],
            [-21, 18],
            [-9, 29],
            [2, 52],
            [21, 25],
            [14, 43],
            [-23, 66],
            [3, 51],
            [-12, 35],
            [-18, 22],
            [-41, 28],
            [-14, 45],
            [0, 324],
            [0, 316]
        ],
        [
            [13444, 88595],
            [99, -7],
            [79, -28],
            [156, -76],
            [41, -1],
            [-55, 75],
            [-71, 36],
            [-74, 13],
            [-19, 32],
            [20, 15],
            [88, 4],
            [-80, 41],
            [-19, 17],
            [67, 111],
            [24, -11],
            [36, 26],
            [63, -17],
            [12, 9],
            [8, 57],
            [27, 23],
            [89, 11],
            [111, -10],
            [12, 5],
            [-12, 53],
            [13, 52],
            [13, 9],
            [52, -7],
            [51, -62],
            [54, -17],
            [7, -11],
            [-21, -44],
            [-67, -83],
            [-3, -15],
            [70, 27],
            [78, 37],
            [67, 21],
            [57, 3],
            [40, 13],
            [41, 41],
            [35, 68],
            [23, 11],
            [97, -4],
            [35, 17],
            [-48, 14],
            [25, 22],
            [48, 8],
            [31, -25],
            [21, -1],
            [71, 27],
            [109, 72],
            [43, 19],
            [38, 4],
            [32, -13],
            [24, 3],
            [45, 62],
            [20, 19],
            [81, 42],
            [51, 9],
            [69, -25],
            [31, -7],
            [71, 3],
            [67, 56],
            [16, 1],
            [43, -49],
            [0, -18],
            [-34, -42],
            [-250, -121],
            [-78, -53],
            [-38, -19],
            [-39, -11],
            [-77, -9],
            [-81, -20],
            [-121, -17],
            [-39, -18],
            [-43, -64],
            [-62, -53],
            [-47, -19],
            [-63, -7],
            [-40, -31],
            [-47, -58],
            [-37, -40],
            [-43, -35],
            [-47, -45],
            [-12, -23],
            [22, -42],
            [46, -16],
            [2, 20],
            [-39, 24],
            [4, 16],
            [185, -19],
            [40, 19],
            [10, 23],
            [-50, 4],
            [-10, 14],
            [-10, 50],
            [16, 38],
            [54, 34],
            [57, 15],
            [45, 19],
            [24, 18],
            [67, 32],
            [26, 25],
            [16, 29],
            [-2, 24],
            [70, 17],
            [68, -15],
            [12, -11],
            [44, 22],
            [45, -14],
            [9, -37],
            [1, -61],
            [21, 17],
            [78, 110],
            [95, 97],
            [73, 36],
            [168, 60],
            [95, 16],
            [48, 14],
            [70, 46],
            [-17, -49],
            [-62, -24],
            [1, -46],
            [25, -27],
            [26, 6],
            [82, 54],
            [98, 84],
            [34, 83],
            [56, 29],
            [102, 34],
            [25, 21],
            [-89, 19],
            [-22, 20],
            [17, 19],
            [-56, 31],
            [1, 34],
            [12, 24],
            [42, 28],
            [74, -31],
            [116, -83],
            [46, -41],
            [27, -31],
            [66, -99],
            [29, -58],
            [23, -59],
            [22, -42],
            [23, -26],
            [112, -103],
            [57, -44],
            [48, -27],
            [56, -21],
            [62, -16],
            [43, -2],
            [66, 44],
            [2, 29],
            [-29, 48],
            [-30, 34],
            [4, 20],
            [39, 39],
            [5, 54],
            [38, -6],
            [34, 42],
            [62, 54],
            [-47, 8],
            [-10, 20],
            [64, 22],
            [12, 20],
            [47, 20],
            [34, -23],
            [1, -27],
            [-9, -80],
            [20, -84],
            [17, -19],
            [70, -25],
            [-5, -20],
            [-80, -89],
            [-25, -38],
            [17, -26],
            [27, -8],
            [70, -3],
            [19, 8],
            [136, 2],
            [46, 24],
            [30, 43],
            [46, 25],
            [21, 50],
            [11, 59],
            [26, 40],
            [21, 5],
            [53, -6],
            [25, 5],
            [98, -5],
            [98, 5],
            [101, -11],
            [65, -12],
            [60, -19],
            [116, -45],
            [86, -52]
        ],
        [
            [18309, 88970],
            [1, -184],
            [0, -344],
            [1, -344],
            [236, -131],
            [237, -131],
            [236, -130],
            [158, -88],
            [158, -87],
            [236, -130],
            [158, -88],
            [157, -87],
            [158, -87],
            [237, -131],
            [157, -87],
            [158, -87],
            [237, -131],
            [141, 0],
            [283, -2],
            [142, 0],
            [178, -166],
            [178, -166],
            [93, -50],
            [74, -19],
            [270, -38],
            [269, -39],
            [134, -19],
            [269, -38],
            [135, -19],
            [269, -39],
            [269, -38],
            [134, -19],
            [270, -39],
            [134, -19],
            [4, -82],
            [-6, -129],
            [0, -134],
            [0, -269],
            [0, -268],
            [1, -268],
            [0, -268],
            [0, -268],
            [0, -269],
            [0, -268],
            [0, -134]
        ],
        [
            [24075, 83636],
            [-308, 0],
            [-155, 0],
            [-308, 0],
            [-155, 0],
            [-308, 0],
            [-309, 0],
            [-154, 0],
            [-309, 0],
            [-154, 0],
            [-309, 0]
        ],
        [
            [21606, 90874],
            [0, -149],
            [0, -302],
            [0, -303],
            [0, -303],
            [0, -302],
            [0, -303],
            [-289, 0],
            [-289, 0],
            [-193, 0],
            [0, -50],
            [-46, -43],
            [-70, -1],
            [-2, 94],
            [-168, 0],
            [-326, 0],
            [-326, 0],
            [-163, 0],
            [-305, 0],
            [-6, -63],
            [117, -108],
            [14, -25],
            [-64, 0]
        ],
        [
            [19490, 89016],
            [-42, 39],
            [-34, 47],
            [-14, 47],
            [-14, 92],
            [18, 26],
            [180, 42],
            [316, 46],
            [289, 30],
            [131, -2],
            [78, -15],
            [77, -6],
            [140, -4],
            [177, -21],
            [36, 2],
            [79, 14],
            [24, 12],
            [125, -2],
            [47, 20],
            [-29, 24],
            [-120, 53],
            [-318, 95],
            [-78, 20],
            [-111, 21],
            [-65, 3],
            [-82, -12],
            [-30, 1],
            [-81, -19],
            [-77, -11],
            [-145, -12],
            [-210, -8],
            [-29, 3],
            [-75, 18],
            [-205, -11],
            [-183, 14],
            [-209, 145],
            [-35, 44],
            [33, 37],
            [104, 56],
            [37, 13],
            [154, 30],
            [154, 36],
            [121, 34],
            [60, 12],
            [57, 1],
            [47, 12],
            [-47, 23],
            [20, 25],
            [76, 9],
            [81, -10],
            [40, 3],
            [1, 22],
            [-77, 19],
            [-368, -57],
            [-172, -5],
            [-119, -24],
            [-66, 0],
            [-78, 25],
            [-12, 17],
            [24, 33],
            [84, 20],
            [42, 54],
            [-45, 1],
            [-150, -11],
            [-65, 5],
            [-88, 21],
            [-37, 43],
            [1, 83],
            [13, 40],
            [109, 102],
            [68, 21],
            [48, 32],
            [-10, 27],
            [-44, 32],
            [-28, 33],
            [7, 25],
            [26, 34],
            [74, 55],
            [180, 111],
            [91, 46],
            [88, 25],
            [123, 54],
            [315, 88],
            [282, 89],
            [104, -24],
            [42, -34],
            [21, -50],
            [14, -60],
            [-1, -63],
            [-17, -55],
            [-53, -68],
            [-67, -63],
            [12, -25],
            [36, 6],
            [52, 18],
            [67, 16],
            [82, 12],
            [35, -12],
            [24, 24],
            [3, 71],
            [13, 23],
            [48, 48],
            [26, 17],
            [42, 8],
            [99, -5],
            [92, -27],
            [125, -27],
            [183, -69],
            [58, -29],
            [6, -25],
            [-33, -54],
            [-79, -76],
            [-63, -27],
            [-25, -17],
            [42, -12],
            [26, -19],
            [41, 28],
            [30, 32],
            [42, 26],
            [13, -51],
            [40, 1],
            [55, 37],
            [55, 57],
            [83, 37],
            [23, 18],
            [72, 16],
            [3, 54],
            [-26, 19],
            [-84, 39],
            [-42, 46],
            [8, 36],
            [47, -6],
            [128, -3],
            [29, -6]
        ],
        [
            [18601, 91504],
            [82, 50],
            [82, -2],
            [17, -17],
            [6, -78],
            [33, 9],
            [86, 83],
            [62, 29],
            [107, 12],
            [72, 0],
            [79, -8],
            [60, -11],
            [97, -34],
            [77, -39],
            [71, -41],
            [236, -156],
            [99, -46],
            [39, -26],
            [31, -43],
            [5, -22],
            [-17, -35],
            [-24, -13],
            [-144, -52],
            [-76, -16],
            [-75, -23],
            [-180, -81],
            [-124, -39],
            [-160, -76],
            [-302, -121],
            [-52, -42],
            [-85, -139],
            [-33, -32],
            [-78, -33],
            [-100, -8],
            [-28, -9],
            [-4, -48],
            [-36, -80],
            [-17, -53],
            [-24, -143],
            [-24, -41],
            [-30, -29],
            [-96, -33],
            [-71, -18],
            [-97, -14],
            [-46, 32],
            [-39, -1],
            [-126, -100],
            [-121, -40],
            [-53, -37],
            [-67, -22],
            [-49, 3],
            [-35, 17],
            [-57, 53],
            [-62, 114],
            [-27, 39],
            [-22, 19],
            [-78, 84],
            [-232, 87],
            [-113, 50],
            [-53, 27],
            [-145, -6],
            [-24, 9],
            [17, 26],
            [8, 63],
            [55, 25],
            [-19, 30],
            [41, 40],
            [40, 65],
            [67, 55],
            [55, 36],
            [-13, 32],
            [9, 94],
            [22, 28],
            [107, 35],
            [-1, 44],
            [-46, 10],
            [-31, 29],
            [10, 28],
            [65, 66],
            [52, 97],
            [96, 61],
            [26, 65],
            [72, 69],
            [-24, 33],
            [-66, 17],
            [-53, 53],
            [-97, 165],
            [-38, 56],
            [379, 49],
            [261, 15],
            [270, 43],
            [76, 2],
            [58, -8],
            [57, -22],
            [77, -39],
            [101, -38],
            [188, -55],
            [118, -12],
            [-47, -44],
            [-7, -23]
        ],
        [[18188, 92415], [-51, 3], [6, 15], [60, 39], [-5, 31], [51, 2], [-6, -35], [-18, -31], [-37, -24]],
        [
            [19036, 92322],
            [-88, -36],
            [-63, 4],
            [-83, 27],
            [-68, 8],
            [-27, 18],
            [23, 26],
            [97, 59],
            [117, 76],
            [76, 29],
            [75, 21],
            [119, 65],
            [74, -7],
            [4, -12],
            [-40, -62],
            [-81, -90],
            [-104, -108],
            [-31, -18]
        ],
        [[21605, 92824], [1, -131]],
        [[21606, 92693], [-61, 25], [-36, 45], [14, 26], [82, 35]],
        [[21606, 92300], [0, -384]],
        [
            [21606, 91916],
            [-119, -21],
            [-73, -34],
            [-39, -36],
            [-59, -27],
            [-107, -30],
            [-136, -47],
            [-244, -47],
            [-154, -8],
            [-153, 15],
            [-100, 33],
            [-104, 47],
            [-29, 17],
            [-34, 38],
            [20, 24],
            [56, 29],
            [83, 26],
            [166, 35],
            [151, 55],
            [53, 11],
            [146, 9],
            [73, -6],
            [88, 11],
            [51, 20],
            [76, 40],
            [55, 38],
            [14, 18],
            [-45, 18],
            [-90, -38],
            [-46, -13],
            [-49, -1],
            [-68, -13],
            [-79, -5],
            [-68, 37],
            [-37, 6],
            [-33, -14],
            [-30, -27],
            [-47, -17],
            [-119, -8],
            [-115, -14],
            [-41, 25],
            [-13, 55],
            [10, 27],
            [29, 34],
            [79, 42],
            [-26, 9],
            [-90, -21],
            [-32, 31],
            [-22, -7],
            [-35, -99],
            [-81, 23],
            [-23, -13],
            [45, -48],
            [1, -17],
            [-30, -30],
            [-125, -49],
            [-50, -13],
            [-33, 18],
            [-47, 52],
            [-61, 1],
            [-30, -27],
            [-11, -26],
            [-37, -23],
            [-128, 41],
            [-102, 73],
            [-113, -11],
            [-51, 2],
            [-153, 27],
            [-30, 38],
            [7, 23],
            [58, 60],
            [72, 29],
            [82, 4],
            [209, 1],
            [42, 6],
            [229, 70],
            [59, 33],
            [7, 16],
            [-282, -56],
            [-121, -12],
            [-185, 9],
            [-43, 25],
            [59, 56],
            [53, 14],
            [127, 21],
            [170, 18],
            [112, 0],
            [94, 14],
            [56, 17],
            [-189, -1],
            [-227, -8],
            [-97, 27],
            [-4, 16],
            [36, 33],
            [-19, 32],
            [48, 39],
            [76, 28],
            [46, 4],
            [90, -10],
            [256, -10],
            [18, 16],
            [-44, 10],
            [-198, 15],
            [-41, 7],
            [-11, 25],
            [17, 38],
            [61, 41],
            [180, 33],
            [71, 5],
            [72, -3],
            [105, -28],
            [24, -31],
            [18, -53],
            [42, -40],
            [30, -12],
            [142, 23],
            [60, 5],
            [59, -7],
            [87, -24],
            [112, -72],
            [145, -74],
            [-1, -16],
            [-55, -25],
            [-3, -18],
            [55, -5],
            [52, 4],
            [49, -6],
            [30, -33],
            [25, -48],
            [30, -35],
            [69, -36],
            [101, 6],
            [223, -11]
        ],
        [
            [20507, 92971],
            [-46, -18],
            [-321, 27],
            [-26, 20],
            [58, 31],
            [70, 14],
            [163, 11],
            [57, -13],
            [59, -26],
            [9, -24],
            [-23, -22]
        ],
        [
            [19893, 93317],
            [23, -22],
            [-45, -32],
            [-182, -49],
            [-36, -23],
            [13, -20],
            [66, -40],
            [67, -34],
            [14, -17],
            [-32, -17],
            [-60, 6],
            [-45, -10],
            [6, -15],
            [67, -50],
            [23, -27],
            [-13, -27],
            [-73, -43],
            [-76, -19],
            [-164, -25],
            [-14, -88],
            [-34, -42],
            [-59, -14],
            [-45, 0],
            [-108, 40],
            [-47, 34],
            [-8, 23],
            [17, 71],
            [49, 89],
            [8, 28],
            [-31, 12],
            [-130, -39],
            [-33, -41],
            [-18, -64],
            [-33, -13],
            [-49, 1],
            [-27, -22],
            [54, -39],
            [1, -46],
            [-65, -43],
            [-44, -63],
            [-53, -10],
            [-62, 53],
            [-37, 55],
            [-29, 4],
            [-21, -26],
            [3, -69],
            [-26, -32],
            [54, -26],
            [-18, -38],
            [-39, -39],
            [-55, -31],
            [-77, -4],
            [-76, -15],
            [-48, 102],
            [-23, 15],
            [-41, 73],
            [-40, -1],
            [-37, -80],
            [-60, -20],
            [-66, -2],
            [-82, 22],
            [-66, 8],
            [-46, -9],
            [-106, -41],
            [-41, 3],
            [-33, 33],
            [29, 40],
            [-24, 48],
            [-86, -18],
            [40, 52],
            [78, 70],
            [48, 26],
            [232, 23],
            [16, 6],
            [110, 95],
            [64, 38],
            [158, 57],
            [39, 52],
            [49, 25],
            [114, 79],
            [104, 58],
            [52, 35],
            [73, 36],
            [83, 16],
            [252, 27],
            [181, -36],
            [43, -2],
            [40, 26],
            [94, -11],
            [43, 22],
            [-100, 29],
            [-3, 19],
            [63, 35],
            [100, 11],
            [46, -3],
            [47, -15],
            [62, -31],
            [141, -54]
        ],
        [
            [20424, 93535],
            [-85, -19],
            [-56, 1],
            [-99, 26],
            [-115, 82],
            [-15, 29],
            [74, 14],
            [56, 26],
            [86, 21],
            [15, -41],
            [60, -15],
            [58, -34],
            [40, -7],
            [46, -50],
            [-65, -33]
        ],
        [[21605, 93722], [0, -90]],
        [
            [21605, 93632],
            [-60, -13],
            [-170, -27],
            [-36, -13],
            [45, -29],
            [132, 3],
            [43, -13],
            [11, -27],
            [0, -50],
            [-25, -56],
            [-53, -19],
            [-96, -25],
            [-65, -11],
            [-103, 1],
            [-224, -47],
            [-69, 0],
            [-61, 11],
            [-84, 45],
            [-87, 17],
            [-73, 31],
            [-14, 28],
            [27, 29],
            [-46, 81],
            [0, 46],
            [26, 29],
            [118, 16],
            [154, 37],
            [339, 45],
            [103, -4],
            [45, 9],
            [83, 3],
            [140, -7]
        ],
        [[21605, 94055], [0, -204]],
        [
            [21605, 93851],
            [-128, -15],
            [-104, 9],
            [-127, 42],
            [-82, -55],
            [-26, -7],
            [-75, 5],
            [-114, 46],
            [-132, -14],
            [-136, -27],
            [-54, -5],
            [-37, 28],
            [44, 42],
            [157, 50],
            [132, 27],
            [156, 15],
            [58, 16],
            [37, 23],
            [102, 36],
            [140, 27],
            [65, 0],
            [124, -39]
        ],
        [
            [18309, 88970],
            [121, -82],
            [47, -22],
            [88, -21],
            [304, -48],
            [38, -13],
            [80, -50],
            [55, -29],
            [66, -27],
            [82, -24],
            [160, -37],
            [55, -15],
            [33, 5],
            [147, -21],
            [66, -3],
            [35, -15],
            [48, 5],
            [-57, 57],
            [26, 10],
            [71, -10],
            [17, 17],
            [77, -9],
            [59, -17],
            [62, -28],
            [76, -23],
            [115, -58],
            [64, -48],
            [60, -60],
            [34, -42],
            [5, -23],
            [40, -20],
            [-18, -52],
            [-23, -22],
            [-55, -11],
            [-151, 13],
            [-27, -42],
            [-85, -35],
            [-18, -27],
            [6, -37],
            [-11, -11],
            [-70, -42],
            [-2, -11],
            [45, -17],
            [48, -30],
            [38, -7],
            [47, 4],
            [60, -10],
            [72, -25],
            [50, -11],
            [67, -2],
            [49, -11],
            [65, -4],
            [144, 1],
            [43, -9],
            [61, -3],
            [137, 2],
            [61, 26],
            [42, 0],
            [120, 15],
            [42, -1],
            [39, 11],
            [49, 22],
            [30, 4],
            [33, -19],
            [30, 1],
            [57, 24],
            [134, 68],
            [48, -1],
            [35, 22],
            [18, -9],
            [33, -49],
            [33, -13],
            [44, -63],
            [18, -11],
            [125, -2],
            [44, -10],
            [27, -41],
            [14, -80],
            [18, -31],
            [23, -1],
            [31, 81],
            [38, 5],
            [31, -60],
            [45, -45],
            [110, -82],
            [25, -52],
            [-6, -20],
            [-49, -32],
            [-41, -10],
            [-73, 7],
            [73, -68],
            [36, -45],
            [31, -24],
            [14, -20],
            [61, -55],
            [17, -26],
            [69, -81],
            [33, -32],
            [30, -5],
            [-89, 108],
            [-45, 68],
            [-9, 41],
            [-2, 82],
            [7, 13],
            [30, 10],
            [39, -37],
            [30, 7],
            [63, -37],
            [13, 0],
            [-59, 96],
            [20, 27],
            [-61, 54],
            [-27, 41],
            [-23, 62],
            [-2, 71],
            [-32, 42],
            [-35, 29],
            [-27, 34],
            [-6, 18],
            [5, 48],
            [60, 49],
            [11, 29],
            [-19, 30],
            [9, 11],
            [77, 15],
            [49, 1],
            [70, 27],
            [40, -2],
            [49, 13],
            [39, 43],
            [13, 6],
            [75, -9],
            [-1, 49],
            [7, 17],
            [41, 36],
            [43, 3],
            [29, 10],
            [56, 38],
            [24, 29],
            [9, 36],
            [-7, 11],
            [-49, 14],
            [-94, -33],
            [-68, -34],
            [-27, -31],
            [-7, -40],
            [-13, -18],
            [-53, 17],
            [-51, -7],
            [-62, -39],
            [-47, -5],
            [-62, 15],
            [-37, 5],
            [-37, -26],
            [19, -46],
            [-17, -16],
            [-91, -6],
            [-23, 3],
            [-49, -10],
            [-33, 15],
            [-98, 56],
            [-10, 11],
            [24, 45],
            [91, 122],
            [10, 8],
            [169, 21],
            [102, 22],
            [187, 67],
            [36, 6],
            [120, 45],
            [49, 11],
            [46, -8],
            [67, -23],
            [35, -20],
            [25, -26],
            [20, -35],
            [26, -79],
            [8, -66],
            [16, -25],
            [57, -47],
            [46, -23],
            [33, 8],
            [8, -29],
            [44, 0],
            [41, -21],
            [-8, -36],
            [11, -15],
            [43, -33],
            [42, -12],
            [49, -6],
            [90, 6],
            [75, 16],
            [57, 25],
            [46, -28],
            [93, -69],
            [56, -49],
            [46, -23],
            [94, -28],
            [21, -14],
            [34, -2],
            [47, 12],
            [54, -5],
            [60, -20],
            [41, -9],
            [142, 39],
            [21, 1],
            [53, 19],
            [74, 5],
            [49, 18],
            [75, -1],
            [136, -13],
            [93, -17],
            [55, -22],
            [45, -12],
            [70, 1],
            [34, 11],
            [35, 19],
            [76, 10],
            [11, 16],
            [-59, 48],
            [-30, 30],
            [-5, 42],
            [28, 18],
            [28, -15],
            [38, -32],
            [109, -122],
            [41, -33],
            [100, -45],
            [47, -7],
            [55, 27],
            [37, 34],
            [5, 38],
            [-21, 33],
            [-40, 26],
            [-65, 33],
            [-59, 10],
            [-54, -14],
            [-61, -28],
            [-25, 11],
            [-76, 79],
            [-19, 30],
            [37, 8],
            [-78, 111],
            [-5, 18],
            [56, 10],
            [77, -36],
            [39, 16],
            [92, 23],
            [-36, 35],
            [-9, 34],
            [34, 12],
            [59, -28],
            [28, -4],
            [42, 12],
            [45, -24],
            [40, -42],
            [49, -69],
            [108, -2],
            [61, 33],
            [-15, -38],
            [-76, -101],
            [41, -7],
            [30, 20],
            [17, 37],
            [112, 48],
            [33, 7],
            [-20, -51],
            [-42, -182],
            [-9, -63],
            [-9, -22],
            [-44, -70],
            [1, -24],
            [57, -75],
            [5, -48],
            [8, -10],
            [40, 0],
            [41, 15],
            [49, 10],
            [8, -10],
            [-27, -58],
            [48, 9],
            [30, -1],
            [35, -30],
            [4, -22],
            [-5, -57],
            [-12, -13],
            [-31, -10],
            [-65, -3],
            [-29, 6],
            [-48, 23],
            [-24, -14],
            [-37, 2],
            [-41, 41],
            [-22, -19],
            [19, -26],
            [146, -139],
            [22, -28],
            [13, 20],
            [-75, 80],
            [-9, 30],
            [22, 16],
            [108, -20],
            [41, 4],
            [28, 14],
            [14, 18],
            [10, 96],
            [20, 61],
            [-12, 55],
            [-29, 87],
            [-23, 52],
            [-52, 52],
            [-5, 19],
            [58, 158],
            [24, 19],
            [46, 2],
            [34, 14],
            [81, -24],
            [36, 17],
            [80, 66],
            [32, 21],
            [39, 39],
            [49, 57],
            [52, 41],
            [86, 39],
            [62, 42],
            [-60, 8],
            [-10, 30],
            [5, 54],
            [-7, 58],
            [-26, 46],
            [-40, 7],
            [-13, -52],
            [-16, -38],
            [-23, -20],
            [-47, -14],
            [-81, -10],
            [-33, 18],
            [-4, 16],
            [11, 60],
            [27, 26],
            [74, 51],
            [47, 41],
            [-53, 16],
            [-9, 50],
            [9, 41],
            [31, 15],
            [168, 34],
            [-58, -68],
            [-6, -16],
            [22, -14],
            [56, 39],
            [42, 44],
            [-33, 4],
            [1, 55],
            [-36, 21],
            [-44, -12],
            [-38, -22],
            [-31, -6],
            [-78, 4],
            [-46, 35],
            [-67, 74],
            [-24, 0],
            [-34, -40],
            [-145, 50],
            [-61, 28],
            [-30, 21],
            [-37, 13],
            [-79, 13],
            [-48, 39],
            [-46, 67],
            [-69, 74],
            [-18, 47],
            [1, 66],
            [99, 119],
            [55, 14],
            [44, 73],
            [-87, -33],
            [-22, 2],
            [-31, 21],
            [-59, 72],
            [0, 45],
            [25, 101],
            [-17, 32],
            [32, 27],
            [-8, 36],
            [13, 18],
            [82, 69],
            [24, 10],
            [42, -12],
            [62, -36],
            [49, 5],
            [49, 86],
            [-12, 8],
            [-71, -1],
            [-48, 12],
            [-13, 26],
            [11, 14],
            [68, 49],
            [32, 51],
            [96, 71],
            [97, 33],
            [47, 11],
            [55, -2],
            [21, -36],
            [3, -37],
            [53, -47],
            [42, -3],
            [27, 7],
            [85, -3],
            [19, -13],
            [-11, -38],
            [6, -20],
            [58, -39],
            [52, -27],
            [47, -33],
            [69, -70],
            [26, -41],
            [18, -78],
            [2, -30],
            [-7, -85],
            [-24, -36],
            [62, -30],
            [43, -44],
            [79, -38],
            [22, -24],
            [31, -64],
            [51, -58],
            [-7, -39],
            [28, -19],
            [50, 32],
            [32, -24],
            [19, -37],
            [28, -30],
            [-16, -17],
            [-75, -9],
            [-42, 6],
            [-66, 30],
            [-25, 24],
            [-51, -50],
            [-18, -26],
            [21, -11],
            [98, 0],
            [47, -25],
            [-29, -31],
            [-66, -51],
            [-144, -99],
            [-43, -26],
            [27, -9],
            [49, 4],
            [46, 14],
            [56, -6],
            [32, -39],
            [92, -40],
            [58, 8],
            [59, 39],
            [45, 19],
            [57, -3],
            [10, -13],
            [-80, -46],
            [43, 3],
            [104, -16],
            [51, -4],
            [37, 4],
            [34, -6],
            [43, -27],
            [-58, -6],
            [-24, -10],
            [-35, -45],
            [-8, -31],
            [-22, -13],
            [-34, 5],
            [-17, 23],
            [-55, -18],
            [152, -100],
            [48, -89],
            [37, -46],
            [-22, -25],
            [9, -73],
            [-4, -43],
            [-15, -76],
            [14, -24],
            [32, -21],
            [33, -36],
            [21, -35],
            [23, 2],
            [18, 38],
            [34, 33],
            [39, 69],
            [-2, 58],
            [32, 61],
            [19, 110],
            [17, 46],
            [35, 39],
            [62, 79],
            [47, 24],
            [44, -2],
            [32, -25],
            [43, -48],
            [54, -43],
            [100, -58],
            [28, -22],
            [56, -57],
            [24, -57],
            [16, -81],
            [32, -90],
            [-6, -58],
            [-20, -29],
            [-30, -3],
            [-48, 13],
            [-19, 39],
            [-43, -26],
            [-4, -16],
            [12, -53],
            [-1, -98],
            [3, -22],
            [37, -102],
            [61, -79],
            [154, -150],
            [25, -79],
            [30, -23],
            [17, 6],
            [56, 47],
            [49, 49],
            [35, 26],
            [40, 11],
            [22, 16],
            [23, 36],
            [19, 110],
            [32, 62],
            [119, 123],
            [10, 15],
            [51, 143],
            [17, 65],
            [3, 39],
            [-7, 36],
            [4, 28],
            [28, 39],
            [24, 16],
            [14, 23],
            [29, 3],
            [46, -19],
            [126, 18],
            [0, 10],
            [-74, 30],
            [7, 35],
            [24, 23],
            [28, 8],
            [17, 62],
            [-9, 10],
            [-69, 41],
            [-40, -2],
            [-44, 39],
            [-14, 68],
            [7, 55],
            [-9, 20],
            [7, 33],
            [-27, 58],
            [17, 70],
            [-19, 38],
            [63, -5],
            [39, -17],
            [49, -1],
            [57, 17],
            [59, 8],
            [100, -3],
            [24, -5],
            [100, -50],
            [78, -25],
            [35, 2],
            [173, -10],
            [76, 5],
            [39, -2],
            [76, -28],
            [-5, -22],
            [-33, -39],
            [-80, -21],
            [35, -20],
            [102, -27],
            [32, -63],
            [-12, -18],
            [30, -9],
            [61, 16],
            [68, -10],
            [98, -34],
            [28, -33],
            [-2, -10],
            [-87, -66],
            [-45, -25],
            [-60, -27],
            [-2, -14],
            [84, -3],
            [65, -7],
            [29, -9],
            [36, -39],
            [2, -49],
            [-7, -19],
            [-76, -57],
            [-35, -18],
            [-59, -20],
            [-26, -16],
            [-28, 2],
            [-31, 20],
            [-32, 4],
            [-58, -16],
            [-31, 1],
            [-17, -18],
            [50, -60],
            [0, -30],
            [52, -78],
            [22, -3],
            [23, 22],
            [20, -3],
            [-24, -68],
            [-3, -35],
            [12, -34],
            [26, -37],
            [83, -78],
            [67, -47],
            [24, -24],
            [37, -54],
            [7, -21],
            [-9, -57],
            [-27, -94],
            [-25, -67],
            [-50, -37],
            [-28, -9],
            [-47, 1],
            [-16, -8],
            [-25, -30],
            [-33, -53],
            [-26, -34],
            [-55, -31],
            [-55, -49],
            [-27, -19],
            [-95, -20],
            [-77, -66],
            [-31, -22],
            [-33, -12],
            [-36, -1],
            [-21, 10],
            [-19, 54],
            [-27, 28],
            [-56, 81],
            [-24, 27],
            [-16, 6],
            [-48, -2],
            [-36, 26],
            [-12, 23],
            [28, 9],
            [-60, 49],
            [-22, 25],
            [-48, 25],
            [-47, 7],
            [-60, -41],
            [-23, -27],
            [29, -20],
            [50, 38],
            [37, -4],
            [31, -17],
            [15, -25],
            [83, -81],
            [30, -17],
            [40, -87],
            [40, -59],
            [42, -72],
            [9, -29],
            [-33, -15],
            [-120, 45],
            [-32, -19],
            [-25, -44],
            [-46, 16],
            [-87, 35],
            [-58, 30],
            [-29, 25],
            [-36, 39],
            [-41, 55],
            [-50, 17],
            [-58, -20],
            [-84, -7],
            [-176, 6],
            [-32, -11],
            [15, -30],
            [-18, -23],
            [19, -31],
            [31, -22],
            [87, -29],
            [58, -24],
            [35, -22],
            [13, -38],
            [-26, -54],
            [-203, -196],
            [-78, -79],
            [-39, -49],
            [-35, -32],
            [-30, -16],
            [-50, -9],
            [-70, -2],
            [-90, 8],
            [-46, 25],
            [-85, 68],
            [-85, 53],
            [-23, 38],
            [-62, 13],
            [-44, 20],
            [-102, 68],
            [-54, 27],
            [-48, 15],
            [-60, -1],
            [30, -34],
            [-83, 5],
            [-62, 25],
            [-61, -3],
            [-44, 5],
            [-52, 13],
            [-57, 7],
            [-91, -1],
            [-38, -9],
            [44, -30],
            [75, -36],
            [-10, 31],
            [28, 19],
            [120, -19],
            [135, -41],
            [34, -3],
            [38, -15],
            [42, -24],
            [58, -49],
            [111, -113],
            [35, -28],
            [47, -26],
            [240, -39],
            [83, 1],
            [166, -11],
            [87, -20],
            [25, -15],
            [8, -50],
            [-8, -25],
            [-48, -76],
            [-30, -57],
            [-186, -237],
            [-35, -87],
            [-34, -34],
            [-84, -52],
            [-84, -45],
            [-51, -10],
            [-46, 11],
            [-29, 13],
            [-46, 40],
            [31, -70],
            [-33, 2],
            [-58, 31],
            [-30, -14],
            [-36, 9],
            [-45, 38],
            [-15, 45],
            [-71, -22],
            [-12, -7],
            [39, -26],
            [29, -57],
            [-19, -20],
            [-68, 22],
            [-8, -2],
            [33, -57],
            [15, -40],
            [-44, -64],
            [-28, -27],
            [-38, -10],
            [-51, 23],
            [-19, -2],
            [-12, -21],
            [-22, -15],
            [-33, -9],
            [-41, 4],
            [-50, 17],
            [-133, 60],
            [-42, 9],
            [-78, 8],
            [-1, 31],
            [-33, 1],
            [-18, -16],
            [-31, -5],
            [-44, 6],
            [-65, 24],
            [-130, 60],
            [-142, 51],
            [-82, 66],
            [31, -60],
            [-3, -20],
            [-18, -35],
            [32, -42],
            [44, -16],
            [45, 2],
            [-34, 33],
            [1, 27],
            [262, -104],
            [59, -15],
            [56, -24],
            [-15, -20],
            [-79, -48],
            [53, -4],
            [66, 43],
            [37, 20],
            [35, 12],
            [48, -21],
            [61, -54],
            [49, -31],
            [70, -17],
            [41, -19],
            [69, -51],
            [11, -26],
            [7, -108],
            [-12, -52],
            [-15, -26],
            [-29, -14],
            [-42, -3],
            [-33, -11],
            [-73, -57],
            [-30, -8],
            [-130, 17],
            [-51, 16],
            [-24, -1],
            [-26, -18],
            [-51, -6],
            [-8, -10],
            [13, -37],
            [31, -28],
            [29, -10],
            [60, -12],
            [6, -29],
            [-22, -29],
            [-23, 2],
            [-39, 23],
            [-19, 1],
            [-40, -17],
            [-30, 5],
            [-17, -11],
            [-13, -42],
            [-54, -51],
            [1, -16],
            [20, -12],
            [23, -28],
            [25, -43],
            [-10, -13],
            [-48, 45],
            [-41, 26],
            [-89, 34],
            [-8, -9],
            [60, -36],
            [22, -23],
            [3, -16],
            [-50, -37],
            [16, -32],
            [-18, -18],
            [-29, -15],
            [-56, -2],
            [-5, -8],
            [28, -30],
            [-30, -18],
            [-65, 7],
            [17, -39],
            [30, -33],
            [36, -18],
            [-12, -23],
            [-21, -18],
            [-89, -58],
            [-63, -68],
            [-9, -21],
            [16, -55],
            [-16, -20],
            [-37, 5],
            [4, -59],
            [-6, -41],
            [-26, -63],
            [-48, -86],
            [-37, -78],
            [-25, -70],
            [-19, -35],
            [-33, -3],
            [-26, -22],
            [28, -25],
            [7, -20],
            [-7, -65],
            [-22, -108],
            [-9, -59]
        ],
        [
            [21606, 90874],
            [121, -59],
            [43, -38],
            [35, -18],
            [73, -28],
            [47, -40],
            [-8, -32],
            [61, -16],
            [30, -38],
            [41, -102],
            [30, -99],
            [59, -133],
            [21, -83],
            [20, -26],
            [38, -15],
            [30, -22],
            [43, -5],
            [30, 48],
            [105, 58],
            [-9, 37],
            [22, 5],
            [-73, 72],
            [-47, 70],
            [-31, 85],
            [-9, 78],
            [-33, 44],
            [-1, 37],
            [-19, 36],
            [-75, 253],
            [11, 43],
            [69, 13],
            [-2, 15],
            [-32, 39],
            [19, 25],
            [95, -11],
            [69, -22],
            [118, -54],
            [51, 47],
            [37, -6],
            [107, -39],
            [124, -69],
            [83, -34],
            [58, -46],
            [65, -78],
            [1, -44],
            [27, -42],
            [28, -122],
            [109, -243],
            [35, -62],
            [76, -94],
            [41, -69],
            [12, -79],
            [-11, -54],
            [-32, -50],
            [-25, -80],
            [17, -22],
            [107, -77],
            [66, -92],
            [31, -16],
            [83, -57],
            [89, -33],
            [59, -34],
            [32, 17],
            [-25, 43],
            [10, 20],
            [92, -74],
            [50, -29],
            [68, -31],
            [117, -72],
            [16, -6],
            [63, 7],
            [33, -21],
            [3, -43],
            [17, -21],
            [100, 9],
            [28, -1],
            [32, -21],
            [22, -45],
            [20, -90],
            [1, -32],
            [-10, -54],
            [-33, -26],
            [-53, 7],
            [-38, 17],
            [-19, 21],
            [-18, 48],
            [-15, -1],
            [-18, -43],
            [-25, -32],
            [-27, 3],
            [-39, 19],
            [-73, 48],
            [-26, 12],
            [-52, -18],
            [-54, -31],
            [-22, -22],
            [19, -54],
            [-9, -27],
            [-18, -12],
            [-38, -2],
            [-54, 9],
            [-43, 17],
            [-93, 51],
            [-32, -23],
            [14, -18],
            [38, -24],
            [47, -40],
            [25, -7],
            [9, -29],
            [-2, -36],
            [-23, -74],
            [7, -13],
            [64, 72],
            [33, 20],
            [71, 32],
            [31, 23],
            [91, 7],
            [33, -13],
            [21, -32],
            [-24, -26],
            [-3, -45],
            [22, -25],
            [29, 6],
            [24, -16],
            [10, -48],
            [-21, -60],
            [-38, -20],
            [-117, -36],
            [-40, -19],
            [-77, -14],
            [-48, -23],
            [-83, 3],
            [-94, -11],
            [-109, 22],
            [-76, 10],
            [-88, 35],
            [-34, -9],
            [-34, -23],
            [-165, 27],
            [-19, 20],
            [45, 54],
            [1, 16],
            [-75, 7],
            [-84, 22],
            [-84, 11],
            [-62, -3],
            [-41, 8],
            [-62, 35],
            [-6, 87],
            [-19, 18],
            [-36, 17],
            [-37, -2],
            [-31, -18],
            [-30, -34],
            [-55, -93],
            [-27, -15],
            [-72, -68],
            [-26, -16],
            [-131, -27],
            [-155, -11],
            [-58, -21],
            [-55, -39],
            [-66, -37],
            [-163, -47],
            [-150, -26],
            [-157, -11],
            [-117, -17],
            [-34, 8],
            [-53, -3],
            [-56, -26],
            [-64, -5],
            [-243, -9],
            [-111, -17],
            [-62, -5],
            [-81, 10],
            [-32, 23],
            [-33, 35],
            [-67, 94],
            [-19, 40],
            [8, 67],
            [-5, 39],
            [-27, 92],
            [-117, 32],
            [-77, 10],
            [-116, 2],
            [-142, -5],
            [-142, 10],
            [-75, 12],
            [-74, 19],
            [-127, 48],
            [-30, 49],
            [-76, 77]
        ],
        [
            [21605, 92824],
            [43, 24],
            [111, 94],
            [52, 38],
            [74, 29],
            [82, 6],
            [113, -47],
            [-14, -32],
            [-31, -28],
            [-5, -24],
            [21, -28],
            [15, -55],
            [51, -26],
            [47, -34],
            [22, -54],
            [-80, -66],
            [-2, -27],
            [68, -7],
            [46, 6],
            [51, -4],
            [40, -35],
            [-10, -31],
            [-66, -56],
            [16, -21],
            [67, 42],
            [87, 17],
            [88, -16],
            [26, -19],
            [24, -40],
            [86, 21],
            [-39, 35],
            [-13, 32],
            [18, 25],
            [39, 27],
            [46, 16],
            [41, 4],
            [151, -28],
            [60, -24],
            [33, -20],
            [38, -103],
            [-12, -63],
            [-49, -73],
            [-7, -50],
            [-49, -123],
            [-34, -34],
            [-37, -23],
            [-153, -41],
            [-116, -42],
            [-59, -8],
            [-95, 14],
            [-111, 27],
            [-62, -7],
            [-63, -20],
            [-40, -5],
            [-74, 10],
            [-48, 18],
            [36, 17],
            [-61, 23],
            [-53, -30],
            [-154, -71],
            [-154, -18]
        ],
        [
            [21606, 92300],
            [282, -19],
            [43, 20],
            [15, 46],
            [-14, 42],
            [-263, 91],
            [-23, 37],
            [129, 52],
            [12, 28],
            [-22, 40],
            [-69, 38],
            [-61, 6],
            [-29, 12]
        ],
        [[21605, 93722], [107, -6], [12, -13], [-47, -55], [-72, -16]],
        [[21605, 94055], [58, -21], [54, -32], [43, -5], [43, -50], [8, -47], [-16, -40], [-29, -12], [-70, -7], [-91, 10]],
        [[31056, 79148], [-42, 1], [-23, 14], [-15, 17], [96, 50], [20, -15], [-18, -44], [-18, -23]],
        [
            [30641, 79592],
            [-22, -8],
            [-64, 15],
            [-27, 11],
            [-79, 40],
            [-150, 59],
            [-51, 29],
            [-11, 22],
            [27, 46],
            [32, 30],
            [158, 21],
            [62, -10],
            [72, -94],
            [42, -63],
            [17, -51],
            [-6, -47]
        ],
        [[30885, 79902], [0, -17], [-31, 13], [-10, 26], [7, 12], [23, -7], [11, -27]],
        [
            [31229, 81486],
            [-27, -7],
            [2, 19],
            [15, 37],
            [18, 84],
            [23, 31],
            [17, 0],
            [4, -68],
            [-5, -32],
            [-27, -48],
            [-20, -16]
        ],
        [
            [30873, 81521],
            [-34, 3],
            [10, 41],
            [16, 17],
            [40, 17],
            [20, 16],
            [19, 0],
            [21, 15],
            [15, -9],
            [-17, -34],
            [-90, -66]
        ],
        [
            [31195, 81554],
            [-25, -57],
            [-21, -54],
            [-28, -102],
            [-16, -4],
            [-14, 25],
            [40, 119],
            [0, 25],
            [-12, 17],
            [-12, -20],
            [-58, -134],
            [-27, -34],
            [-34, 1],
            [-49, -39],
            [83, 160],
            [-21, 16],
            [-67, -101],
            [-38, -39],
            [-26, 12],
            [-4, 22],
            [65, 102],
            [60, 72],
            [25, 46],
            [15, 75],
            [11, -7],
            [-14, -75],
            [-24, -68],
            [30, 11],
            [20, 36],
            [16, 56],
            [11, 48],
            [10, 77],
            [19, -29],
            [27, -16],
            [14, -37],
            [35, -18],
            [7, -42],
            [11, -14],
            [-9, -30]
        ],
        [[31015, 81771], [-18, -6], [8, 49], [21, -10], [-11, -33]],
        [[30907, 81837], [-23, 1], [-1, 28], [15, 22], [22, -13], [-13, -38]],
        [[30954, 82250], [-18, 0], [-11, 25], [13, 22], [13, 3], [3, -50]],
        [[34212, 83100], [-18, -40], [-25, 5], [-3, 55], [-6, 26], [8, 13], [33, 0], [1, -29], [10, -30]],
        [[30778, 83426], [-4, 28], [36, 5], [-32, -33]],
        [[30847, 83508], [-32, -4], [14, 33], [25, 26], [26, 4], [18, -13], [-16, -25], [-35, -21]],
        [[35679, 83840], [-10, -38], [-36, 14], [-56, 29], [-22, 19], [-8, 51], [59, 7], [73, -82]],
        [
            [34498, 83770],
            [-28, -5],
            [-12, 12],
            [-1, 34],
            [9, 26],
            [32, 53],
            [29, 59],
            [16, 14],
            [34, -9],
            [20, -18],
            [29, -50],
            [-8, -32],
            [-24, -29],
            [-27, -20],
            [-69, -35]
        ],
        [[31320, 84042], [-43, -7], [18, 31], [65, 20], [49, 6], [-11, -19], [-29, -16], [-49, -15]],
        [
            [35548, 84397],
            [-15, -5],
            [-23, 30],
            [-42, 24],
            [-93, 61],
            [-12, 48],
            [31, 11],
            [62, 9],
            [54, 0],
            [51, -13],
            [37, -38],
            [-8, -68],
            [-28, -33],
            [-14, -26]
        ],
        [[26840, 84664], [-12, -2], [-29, 29], [-6, 14], [37, 9], [26, -25], [-16, -25]],
        [
            [35487, 84683],
            [22, -4],
            [11, -27],
            [18, -14],
            [6, -20],
            [-25, -17],
            [-74, 37],
            [-20, 37],
            [6, 36],
            [27, 7],
            [17, -9],
            [12, -26]
        ],
        [
            [31007, 84980],
            [24, -15],
            [40, -51],
            [16, -25],
            [4, -35],
            [-16, -89],
            [-15, -32],
            [-28, -41],
            [-24, -48],
            [-22, -55],
            [-31, -54],
            [-32, -10],
            [-25, 19],
            [-33, 41],
            [-27, 24],
            [-35, 17],
            [-18, 23],
            [-4, 23],
            [0, 109],
            [13, 55],
            [17, 33],
            [49, 73],
            [29, 28],
            [18, 6],
            [48, -5],
            [52, 9]
        ],
        [
            [35551, 85062],
            [59, -6],
            [36, 2],
            [15, -9],
            [15, -27],
            [-19, -38],
            [-21, -15],
            [-34, -5],
            [-75, 21],
            [-17, 21],
            [8, 15],
            [27, 5],
            [6, 36]
        ],
        [[32718, 85095], [-16, -4], [-62, 6], [-76, 27], [-39, 24], [19, 11], [53, -20], [88, -9], [28, -10], [5, -25]],
        [
            [33849, 85057],
            [-63, 2],
            [-45, 11],
            [-24, 13],
            [-22, 29],
            [-5, 31],
            [-41, 47],
            [-47, 16],
            [-26, 32],
            [27, 2],
            [92, -21],
            [50, -18],
            [71, -41],
            [24, -38],
            [23, -28],
            [7, -21],
            [-21, -16]
        ],
        [
            [30249, 85283],
            [16, -39],
            [-5, -32],
            [-19, -54],
            [-27, -44],
            [-85, -74],
            [-55, -65],
            [-138, -107],
            [-36, -4],
            [-38, 17],
            [-38, 2],
            [-99, -43],
            [-10, 54],
            [-9, 26],
            [-44, 55],
            [1, 41],
            [49, 52],
            [112, 187],
            [27, 9],
            [55, -20],
            [45, -6],
            [80, 39],
            [76, -4],
            [70, 23],
            [57, -4],
            [15, -9]
        ],
        [
            [31522, 85571],
            [26, -24],
            [27, 1],
            [51, -80],
            [2, -30],
            [-19, -25],
            [-61, -33],
            [-47, -8],
            [-25, 14],
            [-71, 56],
            [-66, 66],
            [-21, 36],
            [9, 16],
            [28, 10],
            [56, 11],
            [93, -6],
            [18, -4]
        ],
        [[31892, 85528], [-33, -6], [-43, 13], [-41, 24], [-95, 77], [71, 52], [114, -60], [35, -39], [-8, -61]],
        [[31594, 85861], [-22, -26], [-66, 10], [-12, 17], [11, 12], [68, 12], [29, 1], [-8, -26]],
        [
            [29348, 86569],
            [24, -3],
            [22, 28],
            [49, 79],
            [34, 6],
            [72, -51],
            [27, -28],
            [15, -40],
            [15, -15],
            [57, -21],
            [54, -6],
            [72, -21],
            [26, -16],
            [57, -76],
            [71, -35],
            [100, -69],
            [25, -10],
            [97, -23],
            [35, -17],
            [34, -26],
            [37, -47],
            [44, -75],
            [34, -119],
            [3, -23],
            [-17, -29],
            [-56, -49],
            [5, -8],
            [53, 3],
            [117, 30],
            [72, -22],
            [30, -2],
            [26, 38],
            [29, -6],
            [68, -66],
            [9, -35],
            [98, -60],
            [-13, -22],
            [-62, -49],
            [-64, -43],
            [-75, -65],
            [-29, -10],
            [-41, 12],
            [-59, 30],
            [-183, 71],
            [-56, 15],
            [-72, 8],
            [-10, 17],
            [-17, 106],
            [-32, 19],
            [-111, 22],
            [-32, 13],
            [5, 58],
            [-15, 17],
            [-37, 0],
            [-36, -8],
            [-59, -25],
            [-28, -23],
            [-10, -25],
            [-14, -78],
            [-20, -33],
            [-91, -86],
            [-37, -26],
            [-51, -15],
            [-25, -32],
            [-37, -77],
            [-39, -45],
            [-50, -35],
            [-51, -28],
            [-85, -32],
            [-48, -11],
            [-32, 11],
            [-22, 73],
            [-45, 216],
            [-28, 27],
            [-154, -28],
            [-84, 3],
            [-84, -48],
            [-64, -2],
            [-38, 13],
            [-4, 43],
            [49, 88],
            [45, 52],
            [143, 72],
            [35, 23],
            [18, 24],
            [-7, 56],
            [-25, 78],
            [-6, 105],
            [9, 54],
            [36, 131],
            [12, 63],
            [23, 227],
            [12, 65],
            [18, 59],
            [17, 36],
            [46, 71],
            [35, 29],
            [45, 20],
            [18, -11],
            [17, -30],
            [62, -28],
            [34, -57],
            [8, -39],
            [-8, -18],
            [-30, -25],
            [-4, -20],
            [57, -41],
            [42, -98]
        ],
        [
            [29423, 86744],
            [-33, -3],
            [-26, 45],
            [-20, 22],
            [-43, 26],
            [-20, 47],
            [-12, 85],
            [8, 24],
            [36, 5],
            [29, -9],
            [21, -38],
            [35, -46],
            [20, -36],
            [28, -76],
            [-8, -30],
            [-15, -16]
        ],
        [
            [29716, 86868],
            [40, -22],
            [39, -13],
            [64, -6],
            [9, -15],
            [-30, -37],
            [-15, 0],
            [-79, 34],
            [-4, -19],
            [-43, 6],
            [-3, 23],
            [30, 26],
            [-35, 17],
            [-60, -20],
            [-34, 12],
            [-7, 80],
            [-40, 42],
            [-31, 12],
            [-24, 29],
            [-2, 23],
            [15, 14],
            [88, -30],
            [53, -28],
            [50, -34],
            [27, -26],
            [-4, -33],
            [-16, -16],
            [12, -19]
        ],
        [[29902, 87139], [60, -15], [-25, -27], [-15, -5], [-48, 43], [28, 4]],
        [[22195, 87541], [89, -3], [-9, -43], [-19, -28], [-21, 7], [-30, 35], [-10, 32]],
        [[36212, 87570], [-38, -15], [-6, 24], [61, 58], [48, 7], [23, -6], [-27, -25], [-61, -43]],
        [
            [22255, 87763],
            [-16, -47],
            [-16, 27],
            [-46, 35],
            [0, 53],
            [10, 24],
            [-3, 34],
            [25, 20],
            [18, -24],
            [0, -60],
            [26, -26],
            [2, -36]
        ],
        [[21864, 88086], [34, -6], [26, 5], [26, -46], [-10, -11], [-55, 26], [-20, 15], [-1, 17]],
        [
            [32835, 87976],
            [-150, -1],
            [-82, 4],
            [-62, 22],
            [-32, 42],
            [-21, 45],
            [12, 45],
            [101, 15],
            [83, -18],
            [71, -22],
            [92, -3],
            [28, -9],
            [18, -17],
            [10, -51],
            [-2, -47],
            [-66, -5]
        ],
        [[21815, 88091], [-11, -2], [-43, 33], [9, 29], [40, -29], [5, -31]],
        [
            [28831, 87949],
            [-34, 8],
            [-48, 33],
            [-15, 32],
            [4, 40],
            [15, 40],
            [-28, 32],
            [-7, 18],
            [23, 50],
            [57, 64],
            [40, -10],
            [37, -34],
            [9, -24],
            [1, -61],
            [11, -81],
            [-20, -62],
            [-45, -45]
        ],
        [
            [32201, 88276],
            [161, -49],
            [16, -18],
            [12, -34],
            [0, -37],
            [-20, -61],
            [13, -120],
            [-1, -65],
            [-12, -54],
            [-23, -43],
            [-61, -52],
            [-117, -46],
            [-83, -12],
            [-88, -3],
            [-111, -12],
            [-51, 3],
            [-45, 14],
            [-22, 30],
            [-25, 49],
            [-21, 56],
            [-25, 110],
            [24, 81],
            [32, 54],
            [55, 80],
            [64, 78],
            [44, 27],
            [72, 22],
            [59, -6],
            [58, 13],
            [36, 3],
            [59, -8]
        ],
        [[31180, 88204], [-25, -7], [-34, 30], [7, 56], [62, 10], [26, -24], [12, -23], [-48, -42]],
        [
            [23292, 88322],
            [-49, 7],
            [-47, 20],
            [-35, 21],
            [-27, 38],
            [44, 12],
            [64, -2],
            [31, -9],
            [40, -32],
            [4, -41],
            [-25, -14]
        ],
        [
            [32446, 88290],
            [-24, -3],
            [-35, 34],
            [-73, 40],
            [-28, 28],
            [9, 62],
            [26, 29],
            [27, 4],
            [39, -6],
            [28, -21],
            [57, -106],
            [-14, -51],
            [-12, -10]
        ],
        [
            [24123, 88423],
            [-129, 43],
            [-2, 25],
            [61, 37],
            [19, 28],
            [57, -14],
            [21, -14],
            [12, -28],
            [-4, -40],
            [-19, -9],
            [-16, -28]
        ],
        [
            [24626, 88546],
            [-10, -18],
            [-36, -26],
            [-24, 11],
            [-11, 21],
            [-42, -1],
            [-3, 46],
            [8, 42],
            [-4, 27],
            [15, 21],
            [46, 0],
            [26, -17],
            [13, -22],
            [34, -30],
            [-12, -54]
        ],
        [[24695, 88661], [-7, -33], [-39, 9], [-31, 39], [2, 18], [26, 32], [36, -24], [13, -41]],
        [[27628, 88777], [-26, -7], [-34, 44], [-26, 3], [9, 36], [44, 6], [18, -24], [17, -44], [-2, -14]],
        [
            [31110, 88567],
            [-46, 7],
            [-14, 37],
            [50, 70],
            [30, 21],
            [76, 27],
            [30, 56],
            [43, 15],
            [-8, 35],
            [29, 25],
            [42, 11],
            [39, -2],
            [19, -14],
            [13, -32],
            [-18, -23],
            [-47, -35],
            [-29, -30],
            [-19, -37],
            [-34, -37],
            [-23, -35],
            [-22, -19],
            [-62, -19],
            [-49, -21]
        ],
        [[27718, 88887], [7, -34], [-28, -47], [-30, -6], [-31, 37], [-8, 23], [52, 33], [38, -6]],
        [
            [31794, 88734],
            [-39, -7],
            [-29, 4],
            [-33, 31],
            [-18, 44],
            [9, 59],
            [10, 21],
            [40, 13],
            [60, -16],
            [77, -4],
            [19, -13],
            [-1, -30],
            [-38, -34],
            [-31, -51],
            [-26, -17]
        ],
        [
            [24331, 88875],
            [-29, -4],
            [-7, 29],
            [22, 12],
            [-4, 16],
            [-39, 27],
            [14, 20],
            [21, -2],
            [45, -18],
            [30, -44],
            [-26, -10],
            [-27, -26]
        ],
        [
            [26078, 88973],
            [41, -37],
            [-6, -48],
            [-30, -39],
            [-25, -8],
            [-47, 6],
            [19, 31],
            [1, 20],
            [-12, 56],
            [-35, 1],
            [2, -52],
            [-25, -53],
            [-29, 22],
            [-3, 44],
            [18, 54],
            [19, 22],
            [52, 10],
            [60, -29]
        ],
        [[34597, 88955], [-8, -3], [-81, 25], [-6, 21], [72, 34], [49, -2], [23, -24], [-28, -22], [-21, -29]],
        [
            [31475, 89052],
            [18, -42],
            [-22, -17],
            [-82, -32],
            [-50, -27],
            [-26, -6],
            [-34, 6],
            [-41, -13],
            [2, 24],
            [65, 65],
            [55, 6],
            [41, 21],
            [2, 16],
            [36, 13],
            [36, -14]
        ],
        [
            [31042, 89093],
            [20, -42],
            [-11, -15],
            [-47, -31],
            [-101, -12],
            [-51, 14],
            [28, -61],
            [-28, -6],
            [-35, 12],
            [-26, 32],
            [-26, -3],
            [-37, 35],
            [-102, 15],
            [0, 19],
            [39, 22],
            [58, -7],
            [12, 33],
            [65, 3],
            [28, -36],
            [47, 1],
            [79, 31],
            [38, 9],
            [50, -13]
        ],
        [
            [25483, 89012],
            [28, -1],
            [35, 18],
            [43, -32],
            [33, -35],
            [36, -24],
            [55, -22],
            [122, -70],
            [36, -48],
            [38, -74],
            [34, -57],
            [30, -39],
            [32, -31],
            [51, -35],
            [65, 31],
            [33, -36],
            [-29, -27],
            [-32, -17],
            [-68, -7],
            [-36, -27],
            [-29, -33],
            [-40, -11],
            [-75, -56],
            [-41, -20],
            [-61, -6],
            [-126, 43],
            [-79, -6],
            [-65, 9],
            [-71, 46],
            [-56, 26],
            [-108, 37],
            [-27, 58],
            [-67, -25],
            [-51, 3],
            [-39, 20],
            [-23, 52],
            [-47, -8],
            [-10, -31],
            [-51, 0],
            [-57, 31],
            [-38, 65],
            [15, 36],
            [18, 18],
            [114, 10],
            [54, 10],
            [58, 29],
            [83, 64],
            [-4, 23],
            [-28, 48],
            [20, 21],
            [-17, 25],
            [23, 20],
            [26, -8],
            [52, -45],
            [18, 15],
            [-39, 65],
            [-4, 35],
            [11, 35],
            [21, 24],
            [37, 20],
            [59, 14],
            [30, 2],
            [31, -11],
            [27, -22],
            [59, -36],
            [8, -21],
            [-23, -10],
            [6, -22]
        ],
        [
            [28733, 89274],
            [92, -4],
            [26, -32],
            [-9, -29],
            [-54, -11],
            [-37, 5],
            [-40, 14],
            [-19, -6],
            [-45, 11],
            [-41, 34],
            [0, 12],
            [67, 25],
            [60, -19]
        ],
        [[24598, 89488], [-71, 16], [-25, 12], [-18, 56], [13, 13], [62, -12], [49, -30], [-14, -9], [4, -46]],
        [
            [25686, 90849],
            [-50, -6],
            [-46, 39],
            [-1, 37],
            [9, 38],
            [16, 15],
            [48, 17],
            [36, -35],
            [45, -29],
            [-22, -63],
            [-35, -13]
        ],
        [
            [23061, 90839],
            [-45, 10],
            [-43, 29],
            [-70, 58],
            [-84, 57],
            [-13, 35],
            [-20, 25],
            [-107, 61],
            [-69, 25],
            [-53, 12],
            [-9, 18],
            [37, 49],
            [67, 54],
            [77, 13],
            [263, 26],
            [60, 1],
            [62, -13],
            [87, -54],
            [57, -18],
            [29, -41],
            [1, -42],
            [-9, -63],
            [-65, -104],
            [-55, -44],
            [-10, -28],
            [-22, -23],
            [-66, -43]
        ],
        [
            [31009, 91249],
            [53, -7],
            [333, 13],
            [69, -10],
            [210, -62],
            [55, -21],
            [26, -27],
            [36, -53],
            [76, -25],
            [31, -31],
            [27, -53],
            [87, -44],
            [-7, -46],
            [17, -22],
            [51, -43],
            [-29, -22],
            [-67, -12],
            [-189, 13],
            [-254, 29],
            [-147, -8],
            [-74, -13],
            [-179, -48],
            [-58, -8],
            [-55, -1],
            [-99, 39],
            [-36, 21],
            [-36, 63],
            [-19, 57],
            [-21, 81],
            [-34, 12],
            [-100, 14],
            [-34, 19],
            [-30, 42],
            [8, 51],
            [19, 6],
            [-28, 29],
            [-10, 32],
            [3, 72],
            [27, 20],
            [44, 6],
            [64, -1],
            [90, -33],
            [72, -3],
            [108, -26]
        ],
        [
            [28832, 89775],
            [13, -12],
            [70, 15],
            [60, 18],
            [94, 43],
            [55, 15],
            [170, 0],
            [29, -9],
            [-20, -32],
            [24, -26],
            [36, -17],
            [14, 15],
            [11, 36],
            [25, 148],
            [11, 44],
            [4, 83],
            [-12, 25],
            [-44, 15],
            [-59, -3],
            [-67, 12],
            [-45, 29],
            [-62, 78],
            [-67, 50],
            [-30, 17],
            [15, 20],
            [61, 22],
            [37, 22],
            [43, 63],
            [26, 10],
            [93, -8],
            [127, -49],
            [79, -43],
            [1, 23],
            [-91, 53],
            [-41, 39],
            [-20, 27],
            [9, 12],
            [52, 12],
            [6, 14],
            [-69, 17],
            [-36, 0],
            [-59, -13],
            [-57, 21],
            [-49, 50],
            [-43, 68],
            [-2, 79],
            [22, 46],
            [37, 38],
            [59, 16],
            [84, -19],
            [227, -68],
            [-6, 22],
            [-253, 92],
            [-89, 24],
            [-22, 34],
            [134, 128],
            [125, 30],
            [61, 37],
            [101, 2],
            [97, -17],
            [-43, 44],
            [3, 12],
            [54, 26],
            [99, 31],
            [120, 25],
            [55, 22],
            [56, 8],
            [141, 4],
            [80, -4],
            [105, -19],
            [61, -34],
            [20, -21],
            [32, -66],
            [27, -92],
            [39, -38],
            [63, -22],
            [43, -23],
            [24, -25],
            [7, -31],
            [-12, -38],
            [9, -38],
            [49, -63],
            [48, -25],
            [1, -14],
            [-124, -104],
            [-100, -74],
            [-71, -64],
            [-4, -19],
            [149, 100],
            [46, -3],
            [2, -14],
            [-30, -49],
            [-37, -44],
            [-37, -27],
            [7, -11],
            [70, -49],
            [-47, -4],
            [-24, -13],
            [-8, -87],
            [45, 7],
            [30, 33],
            [98, 89],
            [63, 34],
            [21, 3],
            [71, -21],
            [-64, 69],
            [-5, 18],
            [20, 34],
            [65, 29],
            [17, -4],
            [38, -59],
            [22, -10],
            [48, 12],
            [32, 30],
            [40, -19],
            [60, -47],
            [-5, -47],
            [3, -81],
            [71, -62],
            [50, -28],
            [-2, 30],
            [-28, 21],
            [-47, 72],
            [14, 91],
            [37, 48],
            [36, -12],
            [47, -28],
            [97, 1],
            [120, -56],
            [65, -2],
            [-6, 23],
            [-49, 11],
            [-72, 31],
            [-111, 37],
            [-51, 42],
            [-8, 41],
            [17, 35],
            [23, 16],
            [107, 49],
            [77, 20],
            [57, 7],
            [97, 0],
            [111, -9],
            [61, -14],
            [69, -35],
            [88, -34],
            [68, -5],
            [42, 8],
            [39, -3],
            [127, -51],
            [33, -26],
            [36, -62],
            [5, -53],
            [-105, -104],
            [-46, -18],
            [-30, -40],
            [13, -10],
            [52, 37],
            [87, 43],
            [76, 21],
            [118, -8],
            [78, -27],
            [18, -33],
            [-1, -22],
            [-32, -53],
            [-94, -32],
            [-84, -34],
            [-97, -9],
            [5, -10],
            [71, -13],
            [80, 4],
            [-2, -15],
            [-37, -43],
            [-13, -37],
            [9, -55],
            [-28, -51],
            [-32, -47],
            [12, -7],
            [73, 67],
            [20, 74],
            [29, 64],
            [35, 35],
            [26, 14],
            [81, 5],
            [46, 38],
            [55, 12],
            [33, -14],
            [-2, -15],
            [-48, -67],
            [-102, -109],
            [42, 13],
            [108, 89],
            [28, -34],
            [43, -26],
            [26, -59],
            [67, -50],
            [-3, 37],
            [-37, 75],
            [10, 30],
            [28, 15],
            [88, 63],
            [62, -21],
            [37, -19],
            [67, 2],
            [77, -10],
            [74, -17],
            [73, -25],
            [55, -30],
            [63, -56],
            [22, -47],
            [-10, -22],
            [-85, -75],
            [-31, -10],
            [-81, 10],
            [-52, -22],
            [-84, -70],
            [-47, -31],
            [-57, -30],
            [99, 1],
            [28, 21],
            [22, 40],
            [44, 40],
            [82, 19],
            [115, -40],
            [57, 2],
            [43, 40],
            [49, 27],
            [29, 2],
            [37, -28],
            [12, -26],
            [-6, -75],
            [-33, -44],
            [-80, -66],
            [-53, -25],
            [-58, -13],
            [-63, -22],
            [-45, -44],
            [-49, -31],
            [36, -21],
            [27, 13],
            [37, 49],
            [27, 22],
            [32, 2],
            [30, -27],
            [-1, -42],
            [-46, -166],
            [36, 46],
            [82, 173],
            [21, 34],
            [39, 35],
            [90, 53],
            [69, 27],
            [120, 32],
            [47, -5],
            [31, -28],
            [42, -4],
            [51, 6],
            [70, -14],
            [31, -20],
            [54, -23],
            [122, -43],
            [30, -25],
            [13, -23],
            [-2, -23],
            [-37, -37],
            [-49, -18],
            [-47, -33],
            [-88, -20],
            [-68, -6],
            [-42, -14],
            [-81, -35],
            [-112, -66],
            [1, -16],
            [45, -8],
            [36, 10],
            [50, 46],
            [47, 17],
            [73, 14],
            [101, 13],
            [43, -2],
            [17, -33],
            [-88, -93],
            [34, -14],
            [48, -6],
            [27, 15],
            [24, 34],
            [27, 19],
            [57, 13],
            [29, 23],
            [-33, 18],
            [11, 37],
            [25, 30],
            [44, 20],
            [63, -20],
            [43, -34],
            [109, -104],
            [52, -96],
            [7, -35],
            [-6, -23],
            [-21, -20],
            [-24, 0],
            [-145, 31],
            [-66, -4],
            [-29, -9],
            [-41, -30],
            [-13, -20],
            [-25, -11],
            [-92, 0],
            [-52, -12],
            [-89, -27],
            [-32, -15],
            [-7, -20],
            [55, 4],
            [89, 25],
            [84, 8],
            [140, -57],
            [47, -9],
            [56, 11],
            [113, -4],
            [38, -7],
            [57, -22],
            [87, -47],
            [16, -13],
            [13, -30],
            [-1, -38],
            [-38, -21],
            [-125, 10],
            [-38, 8],
            [-47, -10],
            [-38, 3],
            [-49, 15],
            [-54, 27],
            [-80, -25],
            [-64, 16],
            [-66, -14],
            [-130, -61],
            [15, -10],
            [178, 52],
            [35, -4],
            [56, -18],
            [89, -38],
            [25, -15],
            [0, -58],
            [-13, -40],
            [-28, -44],
            [-40, 6],
            [-96, 28],
            [-67, -1],
            [-57, -18],
            [-152, 35],
            [-31, -9],
            [138, -54],
            [102, -6],
            [65, -9],
            [55, -29],
            [2, -36],
            [34, -37],
            [50, -15],
            [34, 13],
            [34, 2],
            [61, -29],
            [107, -21],
            [79, 6],
            [34, -8],
            [-6, -18],
            [-72, -28],
            [-11, -27],
            [41, -35],
            [21, -27],
            [-1, -20],
            [-22, -45],
            [2, -20],
            [53, 37],
            [8, -5],
            [12, -48],
            [18, 42],
            [-8, 57],
            [31, 22],
            [98, 16],
            [-17, -88],
            [-2, -45],
            [-43, -76],
            [-36, -25],
            [27, -15],
            [31, 11],
            [36, 59],
            [74, 61],
            [13, -21],
            [-10, -41],
            [35, -19],
            [50, 36],
            [41, -3],
            [24, -26],
            [-19, -76],
            [3, -19],
            [43, -50],
            [-12, 88],
            [8, 26],
            [36, 33],
            [72, 49],
            [27, 9],
            [44, -30],
            [-37, -28],
            [-22, -26],
            [-14, -38],
            [16, -20],
            [59, -2],
            [59, 31],
            [34, -15],
            [41, -41],
            [74, -65],
            [42, 18],
            [52, -50],
            [-70, -39],
            [22, -83],
            [-92, 4],
            [-51, -7],
            [-34, 8],
            [-3, -23],
            [66, -8],
            [6, -25],
            [90, 6],
            [71, -1],
            [3, 29],
            [46, 16],
            [26, 18],
            [22, -11],
            [63, -12],
            [85, -56],
            [-37, -34],
            [-30, -84],
            [-15, -17],
            [-122, -96],
            [20, 0],
            [52, 23],
            [100, 34],
            [56, 14],
            [60, -9],
            [18, 12],
            [33, -14],
            [69, -13],
            [79, 79],
            [48, -16],
            [45, -49],
            [95, -85],
            [50, -50],
            [16, -22],
            [-2, -23],
            [-45, -23],
            [-23, -5],
            [-61, 45],
            [-55, 22],
            [-34, -2],
            [-34, -18],
            [11, -9],
            [135, -69],
            [23, -50],
            [2, -22],
            [-90, -34],
            [-29, -2],
            [-63, 16],
            [-36, 30],
            [-30, 11],
            [-55, -2],
            [45, -51],
            [-4, -15],
            [-24, -10],
            [-11, -25],
            [90, -44],
            [67, -44],
            [10, -18],
            [-45, -14],
            [-33, -3],
            [-69, 7],
            [-38, 9],
            [-10, -10],
            [54, -39],
            [19, -43],
            [1, -20],
            [-32, -16],
            [-38, -45],
            [-15, -47],
            [-35, -4],
            [-14, 8],
            [-47, -14],
            [-61, 20],
            [-23, 21],
            [-69, 78],
            [17, -44],
            [-3, -27],
            [-72, -19],
            [44, -21],
            [54, -11],
            [-9, -41],
            [1, -175],
            [-12, -62],
            [-26, -54],
            [-38, -52],
            [-40, 34],
            [-16, 35],
            [-33, 32],
            [-51, 7],
            [-28, -31],
            [-60, 59],
            [11, 85],
            [-9, 22],
            [-40, -62],
            [-26, -76],
            [-34, 30],
            [-56, 72],
            [-41, 42],
            [-40, 50],
            [-21, 58],
            [-33, 61],
            [-37, 48],
            [8, 33],
            [59, 65],
            [47, 28],
            [56, 15],
            [25, 35],
            [30, 63],
            [52, 74],
            [-46, -21],
            [-33, -31],
            [-39, -52],
            [-36, -34],
            [-93, -38],
            [-73, -12],
            [-88, 5],
            [-20, 13],
            [11, 37],
            [30, 47],
            [-56, -24],
            [-38, 3],
            [-45, 41],
            [-65, 27],
            [-18, 14],
            [-72, 101],
            [-23, 53],
            [-24, 22],
            [-38, 18],
            [6, -45],
            [-34, -12],
            [-35, 4],
            [-36, 21],
            [-3, -28],
            [39, -49],
            [0, -62],
            [-37, -10],
            [-18, 8],
            [-59, 46],
            [-95, 50],
            [-5, -12],
            [56, -111],
            [48, -46],
            [77, -54],
            [35, -31],
            [-27, -44],
            [-39, -19],
            [-47, 0],
            [-86, 24],
            [-40, 28],
            [-58, 64],
            [-97, 67],
            [-21, 0],
            [-68, -28],
            [55, -6],
            [32, -9],
            [77, -52],
            [6, -22],
            [-19, -25],
            [1, -31],
            [22, -38],
            [22, -24],
            [77, -30],
            [-28, -84],
            [-2, -23],
            [17, -10],
            [59, 34],
            [45, 10],
            [53, -31],
            [16, -21],
            [13, -37],
            [58, -24],
            [-6, -11],
            [-59, -36],
            [46, -29],
            [34, -34],
            [21, -39],
            [9, -49],
            [34, 3],
            [19, -40],
            [21, -89],
            [17, -26],
            [3, 90],
            [10, 15],
            [36, -16],
            [53, -35],
            [38, -31],
            [4, -14],
            [-28, -29],
            [26, -30],
            [20, 7],
            [13, 31],
            [24, 31],
            [29, 22],
            [52, -18],
            [44, -46],
            [7, -16],
            [28, -20],
            [25, 11],
            [49, -53],
            [-23, -24],
            [-51, -35],
            [7, -9],
            [96, 0],
            [26, -14],
            [6, -27],
            [-42, -74],
            [-40, 6],
            [-51, 2],
            [-23, -13],
            [72, -35],
            [48, -57],
            [13, -24],
            [-6, -33],
            [49, -10],
            [31, 9],
            [72, 1],
            [-3, -37],
            [-25, -31],
            [40, 7],
            [19, -11],
            [24, -60],
            [27, -47],
            [-46, -15],
            [3, -60],
            [16, -61],
            [0, -58],
            [-5, -53],
            [-22, -11],
            [-24, 1],
            [-10, 13],
            [-59, 156],
            [-31, 53],
            [-63, 67],
            [18, -42],
            [14, -46],
            [18, -92],
            [8, -60],
            [-4, -23],
            [-16, -16],
            [6, -16],
            [48, -61],
            [23, -36],
            [16, -38],
            [29, -39],
            [-24, -20],
            [-36, -4],
            [-17, 5],
            [-65, 36],
            [-9, -11],
            [36, -129],
            [-1, -31],
            [-18, -11],
            [-22, 13],
            [-27, 36],
            [-40, 41],
            [-54, 45],
            [-52, 35],
            [-20, -11],
            [-18, 5],
            [-36, 45],
            [-75, 59],
            [7, -56],
            [-29, -6],
            [-37, 17],
            [-26, 39],
            [-32, 68],
            [-18, 9],
            [9, -64],
            [-2, -22],
            [-19, -6],
            [-15, 23],
            [-8, 29],
            [-18, 21],
            [-44, 31],
            [-14, 34],
            [-49, -7],
            [-26, 20],
            [-72, 79],
            [-66, 85],
            [-42, 45],
            [7, -45],
            [25, -81],
            [6, -37],
            [-36, 15],
            [-125, 104],
            [-77, 50],
            [-43, 8],
            [-70, 6],
            [-16, -27],
            [38, -60],
            [36, -45],
            [36, -31],
            [56, -59],
            [51, -77],
            [21, -24],
            [69, -32],
            [37, -9],
            [37, -3],
            [4, -11],
            [-22, -35],
            [82, -35],
            [32, -19],
            [30, -31],
            [17, -8],
            [72, -80],
            [18, -12],
            [64, -26],
            [22, -17],
            [57, -77],
            [31, -62],
            [24, -28],
            [93, -52],
            [-15, -40],
            [-32, -19],
            [5, -27],
            [18, -49],
            [0, -29],
            [-62, -26],
            [-20, 1],
            [-70, 31],
            [-78, 49],
            [-117, 33],
            [-43, 18],
            [-37, 26],
            [-289, 47],
            [-49, 11],
            [-30, 14],
            [-28, 21],
            [-111, 49],
            [-13, 10],
            [-74, 82],
            [-56, 97],
            [-18, 13],
            [-60, 12],
            [-50, -8],
            [-34, -10],
            [-51, 3],
            [-33, 16],
            [-70, 43],
            [-71, 23],
            [-62, 38],
            [-32, 13],
            [3, 10],
            [46, 56],
            [-14, 0],
            [-81, -43],
            [-29, 13],
            [-47, 34],
            [-36, 34],
            [-74, 93],
            [-42, 34],
            [6, 8],
            [48, 3],
            [37, -3],
            [26, 8],
            [49, 38],
            [23, 38],
            [-41, 3],
            [-35, 43],
            [-31, 24],
            [-34, 10],
            [-119, -9],
            [-21, 11],
            [1, 16],
            [40, 74],
            [-21, 1],
            [-69, -41],
            [-15, 3],
            [-27, 43],
            [-17, 50],
            [-84, 71],
            [-81, 92],
            [-62, 54],
            [-24, 11],
            [3, 14],
            [51, 76],
            [2, 13],
            [-43, -5],
            [-66, 16],
            [-32, -19],
            [-56, 5],
            [-12, -62],
            [-24, -25],
            [-22, 12],
            [-10, 92],
            [-23, 11],
            [-65, 3],
            [-30, 20],
            [-25, 65],
            [-12, 21],
            [-27, 1],
            [-29, -16],
            [-31, -3],
            [-1, -14],
            [29, -28],
            [29, -38],
            [28, -51],
            [-17, -33],
            [-62, -18],
            [-53, -5],
            [-46, 7],
            [-35, 12],
            [-49, 28],
            [-70, -9],
            [-16, -74],
            [-15, -4],
            [-67, 2],
            [-26, -6],
            [-90, -41],
            [-47, -1],
            [-50, -33],
            [-41, -3],
            [-52, 19],
            [-44, 8],
            [-36, -3],
            [-37, 11],
            [-38, 24],
            [-31, 11],
            [-51, 2],
            [-60, 53],
            [-18, 21],
            [-40, 66],
            [-7, 26],
            [2, 49],
            [14, 31],
            [15, 73],
            [31, 47],
            [37, 28],
            [132, 49],
            [27, 20],
            [-1, 13],
            [-30, 60],
            [10, 25],
            [32, 45],
            [23, 5],
            [48, -17],
            [42, -8],
            [56, -2],
            [91, -25],
            [128, -46],
            [74, -33],
            [56, -48],
            [39, -47],
            [6, -24],
            [-27, -61],
            [42, -35],
            [12, 54],
            [16, 17],
            [1, 22],
            [-27, 51],
            [-18, 20],
            [-83, 68],
            [-8, 22],
            [28, 10],
            [121, -22],
            [46, 5],
            [18, 26],
            [39, 28],
            [41, 4],
            [57, -12],
            [53, 3],
            [32, 14],
            [47, 48],
            [31, 11],
            [80, 9],
            [63, -20],
            [38, 1],
            [-3, 32],
            [-26, 62],
            [-31, 63],
            [-25, 21],
            [-64, 40],
            [-75, 76],
            [-38, 47],
            [-11, 23],
            [19, 39],
            [136, 84],
            [108, 83],
            [47, 42],
            [23, 30],
            [48, 35],
            [52, 16],
            [15, 21],
            [11, 65],
            [49, 83],
            [38, 22],
            [56, 15],
            [37, 20],
            [45, 67],
            [-5, 17],
            [-36, 32],
            [-69, 177],
            [-46, 85],
            [-55, 74],
            [-50, 91],
            [-81, 89],
            [6, 56],
            [-84, -39],
            [-20, -2],
            [-32, 17],
            [-22, 21],
            [-18, 37],
            [30, 83],
            [-5, 45],
            [-17, 24],
            [-68, 8],
            [-14, -8],
            [47, -68],
            [-7, -17],
            [-60, -7],
            [-27, 3],
            [-47, 21],
            [-70, 72],
            [-14, 26],
            [4, 20],
            [-39, 3],
            [-32, 15],
            [49, 38],
            [-20, 25],
            [-33, 3],
            [2, 23],
            [62, 35],
            [-42, 11],
            [-31, -23],
            [-46, -46],
            [-34, -18],
            [-46, 22],
            [-50, 2],
            [-31, -36],
            [-67, -26],
            [-121, -63],
            [-52, -20],
            [-57, 4],
            [-10, 12],
            [14, 70],
            [-4, 71],
            [9, 20],
            [54, 24],
            [91, -15],
            [41, 3],
            [59, 40],
            [30, 31],
            [6, 30],
            [-43, 59],
            [-80, 38],
            [-112, 31],
            [-35, 42],
            [2, 41],
            [16, 16],
            [72, 19],
            [-60, 19],
            [-27, -2],
            [-24, -15],
            [-30, -37],
            [-17, -10],
            [-54, 21],
            [-32, 4],
            [-33, 20],
            [80, 51],
            [3, 17],
            [-32, 28],
            [-83, 16],
            [-81, -10],
            [-30, 5],
            [-14, 31],
            [-26, 150],
            [-17, 38],
            [-21, 5],
            [-97, -16],
            [-39, 6],
            [-64, 48],
            [-40, 21],
            [-47, 52],
            [-39, 35],
            [-25, 40],
            [-26, 13],
            [-29, -16],
            [-58, -52],
            [-18, -45],
            [18, -16],
            [102, -26],
            [25, -18],
            [39, -64],
            [11, -42],
            [-1, -31],
            [-35, -39],
            [-63, -29],
            [-65, -17],
            [-65, -4],
            [-31, 4],
            [-169, 56],
            [-69, 8],
            [-88, 23],
            [-47, 3],
            [-85, 19],
            [-142, 11],
            [-29, -9],
            [38, -26],
            [34, -13],
            [28, 0],
            [41, -23],
            [84, -74],
            [26, -44],
            [-25, -23],
            [-199, 118],
            [-121, -41],
            [-56, -15],
            [-48, -3],
            [-59, 16],
            [-187, 77],
            [-18, 3],
            [-117, -24],
            [-102, -2],
            [-204, 24],
            [-75, 16],
            [-45, 25],
            [-44, 0],
            [-117, 18],
            [-108, -41],
            [-129, 38],
            [-38, 22],
            [-50, 80],
            [-5, 35],
            [21, 52],
            [-59, -24],
            [-57, -7],
            [-97, 13],
            [-10, -19],
            [28, -30],
            [-54, -8],
            [-81, 9],
            [-52, -9],
            [-37, -29],
            [-34, -3],
            [-86, 65],
            [-69, 41],
            [-81, 16],
            [-57, 29],
            [-111, 132],
            [-15, 28],
            [-35, 104],
            [-26, 36],
            [28, 3],
            [105, -12],
            [101, 0],
            [56, -8],
            [64, -26],
            [83, -18],
            [60, -4],
            [96, 7],
            [109, 17],
            [12, 13],
            [-70, 23],
            [-63, 31],
            [-58, 39],
            [-35, 17],
            [-58, 10],
            [-163, 8],
            [-151, 26],
            [-105, 36],
            [-85, 40],
            [-47, 38],
            [-13, 52],
            [-14, 88],
            [-28, 115],
            [29, 56],
            [83, 60],
            [-50, 28],
            [-15, 59],
            [3, 55],
            [50, 87],
            [51, 68],
            [55, 64],
            [9, 21],
            [5, 56],
            [15, 70],
            [46, 64],
            [43, 39],
            [66, 33],
            [17, 51],
            [166, 107],
            [75, 43],
            [64, 28],
            [76, 20],
            [217, 42],
            [112, 12],
            [141, -3],
            [259, -23],
            [31, -17],
            [19, -32],
            [-8, -15],
            [-71, -51],
            [-89, -42],
            [-58, -37],
            [-99, -83],
            [-26, -29],
            [-122, -167],
            [-46, -50],
            [-12, -60],
            [23, -57],
            [66, -76],
            [18, -36],
            [-8, -110],
            [2, -78],
            [14, -54],
            [24, -71],
            [56, -71],
            [89, -73],
            [65, -48],
            [65, -35],
            [77, -52],
            [17, -25],
            [-35, -28],
            [-83, -43],
            [-109, -18],
            [-58, -18],
            [-72, -37],
            [-91, -29],
            [-36, -18]
        ],
        [
            [24693, 91411],
            [260, -119],
            [37, 10],
            [78, 6],
            [82, 18],
            [114, 14],
            [98, 34],
            [78, 5],
            [110, -25],
            [35, -29],
            [31, -47],
            [3, -22],
            [-48, -42],
            [-74, -15],
            [-29, -21],
            [-33, 5],
            [3, -36],
            [36, 9],
            [37, -4],
            [37, -33],
            [-13, -19],
            [-65, -27],
            [-97, -30],
            [-117, -95],
            [-61, -39],
            [-19, -25],
            [4, -33],
            [17, -4],
            [58, 33],
            [74, 24],
            [66, 0],
            [77, -24],
            [46, -31],
            [5, -22],
            [-20, -18],
            [43, -16],
            [47, -41],
            [4, -26],
            [-27, -41],
            [33, -4],
            [57, 28],
            [61, 15],
            [39, -8],
            [30, -82],
            [2, -36],
            [-25, -52],
            [-36, -29],
            [-49, -16],
            [39, -23],
            [24, -38],
            [-8, -32],
            [-46, -56],
            [44, -44],
            [3, -74],
            [-102, -24],
            [-53, -45],
            [-32, -21],
            [-74, -22],
            [-38, -2],
            [-185, 18],
            [-31, 30],
            [-6, 64],
            [-27, -4],
            [-21, -28],
            [12, -32],
            [58, -88],
            [11, -37],
            [-1, -28],
            [-66, -52],
            [-38, -17],
            [-39, -9],
            [-38, 7],
            [-62, 31],
            [-56, -1],
            [-33, 31],
            [-40, 74],
            [-55, 53],
            [-47, 59],
            [-120, 86],
            [-62, 52],
            [-83, 82],
            [-35, 19],
            [-86, 13],
            [-33, 39],
            [-36, 21],
            [-34, -2],
            [-55, -20],
            [-70, 21],
            [-34, 53],
            [-23, 12],
            [-20, 30],
            [-132, 61],
            [-79, 69],
            [-18, 36],
            [27, 71],
            [38, 53],
            [52, 33],
            [41, 7],
            [87, -11],
            [27, -22],
            [25, -42],
            [65, -33],
            [33, -35],
            [26, -42],
            [24, -13],
            [57, -5],
            [60, 7],
            [126, 26],
            [13, 19],
            [15, 95],
            [52, -43],
            [31, 4],
            [9, 31],
            [-27, 52],
            [-30, 36],
            [-51, 0],
            [-26, 10],
            [-1, 33],
            [30, 32],
            [65, 0],
            [49, -24],
            [19, 15],
            [-78, 57],
            [-33, 10],
            [-41, -24],
            [-79, -21],
            [-41, -2],
            [-174, 87],
            [-22, 31],
            [19, 27],
            [43, 21],
            [64, 13],
            [43, 2],
            [37, -16],
            [55, -42],
            [48, -26],
            [-4, 34],
            [-22, 37],
            [-54, 21],
            [-53, 43],
            [-10, 42],
            [22, 22],
            [133, 21],
            [93, -23],
            [59, -4],
            [24, 29],
            [-74, -1],
            [-23, 25],
            [27, 22],
            [43, 9]
        ],
        [
            [25227, 91368],
            [-89, -12],
            [-41, 5],
            [-39, -21],
            [-48, -3],
            [-127, 37],
            [12, 26],
            [105, 22],
            [31, 23],
            [99, 16],
            [162, 39],
            [80, 5],
            [32, -3],
            [7, -31],
            [-58, -47],
            [-88, -44],
            [-38, -12]
        ],
        [
            [26801, 91531],
            [121, -26],
            [88, -29],
            [56, -39],
            [28, -11],
            [107, 23],
            [75, 8],
            [168, -10],
            [142, -32],
            [84, -47],
            [-8, -24],
            [-57, -77],
            [-61, -59],
            [-52, -30],
            [-42, -62],
            [-71, -73],
            [-79, -27],
            [40, -23],
            [-11, -28],
            [-50, -67],
            [-87, -98],
            [-66, -53],
            [-36, -15],
            [-49, -5],
            [-292, 46],
            [-74, 0],
            [-195, -25],
            [18, -11],
            [72, -18],
            [46, -20],
            [61, -61],
            [12, -33],
            [-7, -44],
            [-97, -94],
            [-31, -68],
            [-20, -57],
            [-33, -15],
            [-109, 24],
            [-36, -1],
            [-122, -17],
            [-57, 9],
            [8, 85],
            [-8, 92],
            [-18, 87],
            [-92, 156],
            [-20, 89],
            [8, 130],
            [-5, 86],
            [-12, 128],
            [3, 77],
            [20, 18],
            [56, 15],
            [121, -39],
            [55, -13],
            [-75, 80],
            [-23, 42],
            [-6, 29],
            [10, 29],
            [46, 32],
            [75, 24],
            [76, 16],
            [168, 10],
            [48, -7],
            [72, 27],
            [43, 6],
            [74, -10]
        ],
        [[25509, 91735], [-92, -34], [-29, 25], [72, 51], [31, 14], [38, -28], [-20, -28]],
        [[26142, 91723], [-42, 1], [-103, 25], [-23, 17], [59, 31], [46, 0], [49, -29], [23, -26], [-9, -19]],
        [
            [23421, 92019],
            [-58, -3],
            [-100, 17],
            [-78, 48],
            [26, 36],
            [47, 77],
            [54, 35],
            [40, 10],
            [83, -3],
            [49, -18],
            [35, -26],
            [18, -52],
            [24, -23],
            [8, -27],
            [-21, -27],
            [-32, -19],
            [-95, -25]
        ],
        [
            [26686, 92015],
            [20, -43],
            [5, -53],
            [-9, -47],
            [-17, -45],
            [-25, -17],
            [-110, -9],
            [-69, 1],
            [-101, -5],
            [-50, 3],
            [-81, 32],
            [-101, 52],
            [-51, 2],
            [-128, 19],
            [-70, 56],
            [-27, 11],
            [-28, -17],
            [-35, 44],
            [-54, -5],
            [-11, 37],
            [9, 23],
            [57, 63],
            [62, 16],
            [19, 34],
            [-2, 32],
            [53, 48],
            [87, 47],
            [192, 52],
            [53, 4],
            [71, -4],
            [68, -16],
            [53, -28],
            [107, -67],
            [49, -41],
            [49, -67],
            [29, -52],
            [-14, -60]
        ],
        [
            [25904, 92284],
            [-49, -20],
            [-34, 17],
            [-36, -6],
            [-80, -64],
            [-42, -6],
            [-35, 24],
            [-15, 31],
            [11, 23],
            [40, 16],
            [102, 26],
            [30, 12],
            [18, 27],
            [69, -23],
            [57, -33],
            [-36, -24]
        ],
        [
            [26383, 92417],
            [-70, 11],
            [-19, 29],
            [-27, 61],
            [112, 37],
            [21, -14],
            [17, -49],
            [37, -54],
            [-11, -12],
            [-60, -9]
        ],
        [
            [31156, 92515],
            [-19, -31],
            [-72, -21],
            [-58, -4],
            [-29, 10],
            [-19, 23],
            [46, 41],
            [52, 30],
            [63, 45],
            [52, 30],
            [51, -22],
            [-31, -45],
            [-34, -23],
            [-2, -33]
        ],
        [
            [24006, 92565],
            [64, -34],
            [-9, -15],
            [-83, -18],
            [-33, -14],
            [-48, -50],
            [-112, -9],
            [-115, 0],
            [22, 33],
            [62, 53],
            [-49, 23],
            [-175, -37],
            [-67, 22],
            [57, 58],
            [-136, 6],
            [-51, 34],
            [17, 41],
            [105, 23],
            [136, 20],
            [146, 29],
            [114, -2],
            [45, -14],
            [29, -104],
            [19, -5],
            [62, -40]
        ],
        [
            [23451, 92882],
            [93, 10],
            [43, -35],
            [164, -50],
            [-9, -24],
            [-71, -33],
            [-50, -10],
            [-246, -1],
            [-42, 21],
            [-53, 98],
            [-2, 37],
            [26, 13],
            [91, 20],
            [66, -5],
            [7, -24],
            [-17, -17]
        ],
        [
            [25403, 92817],
            [3, -25],
            [-14, -33],
            [9, -33],
            [54, -68],
            [0, -40],
            [-25, -32],
            [-12, -63],
            [15, -49],
            [-28, -27],
            [-61, -24],
            [9, -12],
            [130, -30],
            [10, -7],
            [0, -67],
            [22, -74],
            [-98, 49],
            [-69, -51],
            [8, -87],
            [46, -39],
            [9, -35],
            [-39, -6],
            [-90, 33],
            [32, -36],
            [11, -28],
            [-52, -16],
            [-54, 0],
            [-84, -13],
            [-82, 5],
            [-99, -1],
            [-53, 19],
            [-29, -4],
            [-64, -33],
            [-98, 11],
            [-89, 2],
            [-38, 33],
            [-39, 68],
            [7, 17],
            [95, 9],
            [-65, 31],
            [-78, 17],
            [-36, 14],
            [6, 34],
            [134, 30],
            [97, 60],
            [60, 24],
            [4, 12],
            [51, 13],
            [118, 7],
            [5, 16],
            [-223, -9],
            [-304, -34],
            [-94, -17],
            [-79, 10],
            [-333, -53],
            [-49, 17],
            [-30, 31],
            [21, 22],
            [98, 42],
            [49, 36],
            [-6, 19],
            [39, 35],
            [62, 5],
            [106, -29],
            [55, -28],
            [51, 1],
            [-49, 35],
            [-28, 40],
            [23, 41],
            [-88, 9],
            [-33, 19],
            [-15, 23],
            [31, 37],
            [75, 38],
            [-8, 10],
            [-109, -1],
            [-71, 28],
            [10, 26],
            [76, 60],
            [56, 7],
            [105, -22],
            [62, -37],
            [25, -55],
            [48, -22],
            [272, -149],
            [48, -9],
            [54, 20],
            [-89, 39],
            [-42, 49],
            [35, 12],
            [65, -3],
            [-8, 19],
            [-56, 16],
            [-57, 1],
            [-72, 25],
            [18, 16],
            [97, 11],
            [20, 12],
            [-61, 26],
            [-147, 20],
            [-52, 23],
            [-22, 22],
            [19, 27],
            [79, 34],
            [57, 16],
            [99, 12],
            [123, -6],
            [105, -58],
            [49, -37],
            [87, 6],
            [-42, 83],
            [97, 45],
            [57, -15],
            [90, -52],
            [83, -23],
            [49, -8],
            [33, -29]
        ],
        [
            [24315, 92880],
            [-80, -3],
            [-40, 17],
            [32, 13],
            [107, 21],
            [62, 38],
            [105, 10],
            [109, -10],
            [-147, -47],
            [-148, -39]
        ],
        [
            [27864, 92840],
            [-14, -8],
            [-87, 1],
            [-74, 47],
            [-81, 86],
            [10, 30],
            [35, 12],
            [85, 15],
            [58, 0],
            [53, -30],
            [25, -23],
            [-4, -22],
            [-35, -40],
            [5, -39],
            [24, -29]
        ],
        [
            [26454, 93065],
            [58, -4],
            [91, 5],
            [63, -22],
            [122, -67],
            [4, -47],
            [-36, -53],
            [-34, -26],
            [2, -30],
            [131, 82],
            [86, -10],
            [130, 7],
            [156, 33],
            [75, 6],
            [75, -3],
            [56, -10],
            [119, -45],
            [41, -22],
            [19, -26],
            [-24, -17],
            [-75, 10],
            [-123, 10],
            [-56, -1],
            [9, -24],
            [25, -5],
            [148, -6],
            [485, -75],
            [20, -24],
            [-58, -39],
            [-280, -17],
            [-159, 15],
            [-133, 25],
            [-46, -6],
            [40, -33],
            [80, -10],
            [67, -20],
            [28, -17],
            [142, -13],
            [68, -46],
            [37, -2],
            [37, -23],
            [30, -40],
            [57, 2],
            [72, -35],
            [22, -18],
            [-16, -35],
            [-32, -30],
            [-82, -34],
            [-6, -11],
            [95, 4],
            [18, -4],
            [112, -62],
            [35, 27],
            [-19, 48],
            [25, 33],
            [66, -1],
            [114, -74],
            [145, 35],
            [59, -51],
            [54, 60],
            [33, 15],
            [137, -71],
            [83, -16],
            [95, -31],
            [88, -7],
            [15, 27],
            [-51, 33],
            [30, 15],
            [121, 28],
            [64, -4],
            [119, 41],
            [118, 4],
            [147, 61],
            [35, 10],
            [26, 22],
            [58, -4],
            [156, -34],
            [45, 3],
            [166, 34],
            [62, 9],
            [62, -2],
            [156, -20],
            [117, -21],
            [36, -12],
            [-13, -28],
            [59, -23],
            [147, -1],
            [63, -7],
            [51, -27],
            [10, -22],
            [-50, -28],
            [58, -13],
            [111, -4],
            [24, -6],
            [47, -86],
            [0, -20],
            [-39, -34],
            [-106, -45],
            [-117, -37],
            [30, -28],
            [69, -6],
            [94, 17],
            [64, -18],
            [38, -40],
            [-33, -21],
            [-134, -26],
            [-80, 34],
            [-35, -10],
            [51, -45],
            [-19, -26],
            [-3, -51],
            [-17, -42],
            [-293, -9],
            [-118, -35],
            [-62, -15],
            [-80, 3],
            [-107, 30],
            [-99, -3],
            [-60, 20],
            [-39, 36],
            [-19, 35],
            [5, 69],
            [-37, 6],
            [-57, 32],
            [-42, 4],
            [17, -32],
            [38, -18],
            [7, -21],
            [-16, -53],
            [-43, -47],
            [-28, -11],
            [-76, -1],
            [-116, -27],
            [-56, -4],
            [-74, 6],
            [-47, 13],
            [-59, 34],
            [-24, -42],
            [-39, -5],
            [-39, 13],
            [-31, 32],
            [-32, -36],
            [-81, -20],
            [-46, 0],
            [-48, 22],
            [-71, -14],
            [-97, 23],
            [-3, -37],
            [-32, -6],
            [-70, 1],
            [-114, 13],
            [-70, -18],
            [-128, 10],
            [-128, 3],
            [-41, 26],
            [5, 38],
            [61, 98],
            [-60, 26],
            [-45, -16],
            [-30, -49],
            [-33, -2],
            [-17, 44],
            [-36, -24],
            [-50, -8],
            [7, -53],
            [-20, -16],
            [-92, -30],
            [-88, -4],
            [-53, 7],
            [-107, 28],
            [-59, 1],
            [-71, 47],
            [-57, 10],
            [28, 48],
            [-78, -36],
            [-10, -14],
            [9, -34],
            [-64, 10],
            [-52, -10],
            [-48, 27],
            [-64, 25],
            [-28, 28],
            [-43, 86],
            [-22, 58],
            [35, 27],
            [-5, 13],
            [-84, 59],
            [-24, 65],
            [5, 34],
            [24, 40],
            [68, 74],
            [13, 26],
            [-36, 105],
            [-37, 38],
            [-52, 40],
            [-126, 127],
            [-65, 78],
            [-66, 3],
            [-78, -27],
            [-33, -21],
            [-57, -2],
            [-164, 7],
            [-63, 8],
            [-46, -2],
            [-81, -20],
            [-85, 4],
            [-54, 55],
            [-121, 30],
            [-61, 39],
            [8, 15],
            [69, 13],
            [-56, 18],
            [-207, 75],
            [-63, 13],
            [-16, 15],
            [6, 27],
            [61, -20],
            [71, 4],
            [5, 21],
            [-70, 24],
            [-47, 33],
            [17, 33],
            [117, 18],
            [98, 25],
            [65, 9],
            [65, -1],
            [158, -26],
            [158, -33],
            [99, -26]
        ],
        [
            [27831, 93263],
            [-80, -31],
            [-42, 1],
            [-236, 65],
            [-47, 32],
            [-9, 22],
            [-2, 73],
            [10, 28],
            [40, 20],
            [55, 6],
            [129, -14],
            [78, -19],
            [102, -58],
            [37, -27],
            [8, -58],
            [-43, -40]
        ],
        [
            [23286, 93193],
            [-47, -10],
            [-156, 33],
            [-50, 40],
            [-55, 55],
            [-43, 60],
            [-16, 36],
            [-31, 21],
            [-11, 36],
            [-56, 55],
            [62, 16],
            [85, -10],
            [92, -53],
            [88, -75],
            [16, -49],
            [57, -3],
            [70, -42],
            [27, -50],
            [-12, -48],
            [-20, -12]
        ],
        [
            [26087, 93556],
            [77, -21],
            [85, 11],
            [90, 1],
            [202, -9],
            [133, 6],
            [87, -17],
            [53, -45],
            [-65, -17],
            [-56, -86],
            [-97, -13],
            [-177, 13],
            [-487, 5],
            [-86, 62],
            [8, 43],
            [30, 24],
            [141, 37],
            [62, 6]
        ],
        [
            [24170, 93503],
            [-42, -6],
            [-77, 3],
            [-92, 20],
            [-25, 24],
            [4, 61],
            [163, 11],
            [86, -4],
            [98, -22],
            [60, -23],
            [39, -43],
            [-122, -3],
            [-92, -18]
        ],
        [[23766, 93753], [-35, -11], [-42, 7], [-2, 25], [46, 35], [68, 14], [31, -30], [-66, -40]],
        [
            [25865, 93968],
            [73, -15],
            [125, 7],
            [164, -48],
            [36, -22],
            [8, -26],
            [-117, -46],
            [-19, -21],
            [70, -26],
            [51, -40],
            [1, -17],
            [-47, -46],
            [-35, -14],
            [-78, -3],
            [-68, -21],
            [-105, -21],
            [-143, -8],
            [-111, -34],
            [-48, -3],
            [-23, 29],
            [14, 28],
            [-23, 14],
            [-103, 27],
            [-60, 38],
            [-11, 22],
            [133, 7],
            [57, 8],
            [5, 23],
            [-92, 25],
            [-153, 15],
            [-7, 18],
            [-64, 36],
            [-6, 33],
            [-57, 24],
            [-19, 49],
            [79, 23],
            [-71, 75],
            [-13, 45],
            [37, 17],
            [190, -4],
            [66, -8],
            [138, -35],
            [108, -18],
            [99, -51],
            [19, -36]
        ],
        [
            [23636, 94405],
            [72, -11],
            [86, -36],
            [80, -76],
            [5, -22],
            [-29, -48],
            [95, -20],
            [9, 43],
            [161, 44],
            [52, -6],
            [125, -54],
            [48, -5],
            [34, -32],
            [-35, -51],
            [6, -12],
            [65, -11],
            [149, 21],
            [130, -51],
            [71, -61],
            [54, -20],
            [-22, -50],
            [-52, -31],
            [23, -25],
            [7, -50],
            [58, -13],
            [133, -91],
            [24, -25],
            [17, -42],
            [-19, -17],
            [-33, -61],
            [-152, -18],
            [-91, -17],
            [-99, 22],
            [-96, 32],
            [-59, 59],
            [-15, 51],
            [-40, 23],
            [-36, 36],
            [-70, 3],
            [-164, 36],
            [-70, 9],
            [-70, -3],
            [-100, -14],
            [-35, 14],
            [-19, 31],
            [16, 23],
            [-292, -29],
            [-83, -33],
            [-117, 5],
            [-58, 14],
            [-77, 32],
            [-69, 65],
            [-3, 28],
            [27, 19],
            [56, 15],
            [158, -22],
            [139, -12],
            [60, 12],
            [27, 30],
            [-32, 16],
            [-134, 7],
            [29, 16],
            [112, 16],
            [59, 24],
            [-45, 19],
            [-151, -3],
            [-55, 9],
            [10, 19],
            [86, 49],
            [-4, 9],
            [-81, 40],
            [-75, -19],
            [-106, -73],
            [-49, -10],
            [-23, 27],
            [73, 75],
            [-4, 20],
            [-48, 14],
            [-126, -10],
            [-70, 0],
            [-10, 15],
            [0, 58],
            [17, 44],
            [39, 45],
            [167, -7],
            [272, 20],
            [80, 3],
            [87, -21]
        ],
        [
            [25066, 94776],
            [7, -72],
            [-22, -64],
            [-32, -7],
            [-110, 34],
            [-10, 31],
            [-56, 26],
            [-150, -2],
            [-28, 20],
            [-9, 62],
            [21, 35],
            [99, 28],
            [95, -10],
            [83, -1],
            [80, -23],
            [32, -57]
        ],
        [
            [27198, 95419],
            [40, -47],
            [149, -111],
            [67, -40],
            [115, -51],
            [12, -52],
            [132, -25],
            [109, -28],
            [58, 18],
            [107, 0],
            [50, -29],
            [-12, -40],
            [18, -26],
            [-16, -54],
            [55, -36],
            [50, -18],
            [99, -20],
            [105, -3],
            [-56, 56],
            [-72, 16],
            [-16, 52],
            [6, 22],
            [68, 23],
            [92, 0],
            [139, -32],
            [9, -13],
            [7, -90],
            [-76, -29],
            [-16, -21],
            [183, -28],
            [39, -2],
            [70, -83],
            [-52, -129],
            [-46, -46],
            [16, -5],
            [118, 15],
            [65, 27],
            [96, -7],
            [49, -16],
            [71, -67],
            [45, 49],
            [48, 21],
            [45, -45],
            [135, -113],
            [7, -24],
            [-76, -42],
            [-248, -61],
            [-111, -34],
            [-83, -35],
            [-73, -1],
            [-18, -42],
            [-143, -101],
            [-43, -23],
            [-75, 17],
            [-19, 25],
            [-12, 79],
            [45, 80],
            [-19, 1],
            [-70, -37],
            [-27, -59],
            [8, -68],
            [-19, -51],
            [59, -15],
            [17, -18],
            [-1, -32],
            [-17, -24],
            [-33, -9],
            [-43, 11],
            [-91, 58],
            [-50, -10],
            [37, -68],
            [5, -39],
            [-57, -111],
            [-55, -4],
            [-39, 13],
            [-116, 90],
            [-57, 39],
            [-83, 74],
            [-47, -13],
            [23, -30],
            [76, -70],
            [77, -93],
            [-45, -6],
            [-68, 25],
            [-47, 30],
            [-84, 21],
            [-50, 1],
            [-60, -13],
            [57, -21],
            [44, -47],
            [-19, -12],
            [-70, -8],
            [-94, 5],
            [-151, 17],
            [-151, 27],
            [-140, 42],
            [-101, 43],
            [-52, 39],
            [37, 15],
            [133, 19],
            [133, 12],
            [-22, 11],
            [-240, 24],
            [-80, 5],
            [-91, -3],
            [-37, 19],
            [-76, 61],
            [22, 14],
            [109, -4],
            [-39, 21],
            [-175, 36],
            [-65, 32],
            [-15, 36],
            [65, 24],
            [203, 57],
            [140, 10],
            [48, 16],
            [43, 54],
            [209, 19],
            [162, 25],
            [-279, 7],
            [-73, 36],
            [-104, 6],
            [-64, -11],
            [-109, -34],
            [-52, -8],
            [-118, -36],
            [-55, 14],
            [53, 39],
            [-53, 9],
            [-91, -6],
            [-136, -31],
            [-79, -25],
            [-66, 36],
            [-105, 20],
            [-24, 16],
            [22, 60],
            [31, 13],
            [80, 10],
            [242, 55],
            [36, 39],
            [-55, -6],
            [-121, -27],
            [-100, -13],
            [-137, 3],
            [-80, 25],
            [-143, 80],
            [-39, 38],
            [-16, 60],
            [-41, 63],
            [306, -39],
            [120, -7],
            [231, -3],
            [19, 52],
            [99, 30],
            [-101, 3],
            [-186, -37],
            [-66, 0],
            [-74, 54],
            [-80, -10],
            [-96, 18],
            [-47, 26],
            [11, 34],
            [99, 17],
            [82, -10],
            [41, 17],
            [-89, 41],
            [-77, 47],
            [6, 76],
            [63, 17],
            [66, 2],
            [64, -19],
            [87, -3],
            [61, -22],
            [42, -42],
            [125, -7],
            [172, 1],
            [-84, 28],
            [-122, 17],
            [-59, 62],
            [-126, 32],
            [-98, 16],
            [1, 14],
            [74, 77],
            [89, 27],
            [143, -10],
            [93, 14],
            [121, 27],
            [148, -11],
            [34, 24],
            [-15, 28],
            [-38, 17],
            [-150, 2],
            [-93, 16],
            [-12, 41],
            [54, 19],
            [140, 1],
            [84, 8],
            [92, -10],
            [192, -38],
            [62, -20],
            [66, -32],
            [35, -29]
        ],
        [
            [34111, 96469],
            [252, -10],
            [81, 4],
            [93, -25],
            [149, 2],
            [68, -6],
            [251, -6],
            [52, -21],
            [-127, -49],
            [-470, -79],
            [57, -17],
            [239, 13],
            [124, 26],
            [119, 15],
            [152, 36],
            [121, 20],
            [132, -24],
            [57, 50],
            [104, -7],
            [84, -55],
            [115, 25],
            [152, -6],
            [52, -23],
            [-46, -23],
            [9, -20],
            [64, -23],
            [92, -49],
            [0, -18],
            [-49, -46],
            [238, 39],
            [240, -17],
            [94, -27],
            [57, -56],
            [-20, -34],
            [-106, -53],
            [-109, -41],
            [-64, -38],
            [-99, -20],
            [-338, -90],
            [-165, -29],
            [-138, -33],
            [-201, 5],
            [-54, -16],
            [-30, -26],
            [-157, -22],
            [-191, -7],
            [-89, -73],
            [-548, -107],
            [-10, -18],
            [55, -7],
            [69, 7],
            [797, 130],
            [153, 9],
            [142, -10],
            [-16, -30],
            [-201, -86],
            [-256, -77],
            [-128, -59],
            [-323, -101],
            [-264, -101],
            [-102, -51],
            [-136, -91],
            [-46, -22],
            [-57, -9],
            [-66, 3],
            [-60, 14],
            [-80, 34],
            [-82, 26],
            [140, -127],
            [-16, -25],
            [-258, -26],
            [-114, -23],
            [-141, -3],
            [-42, -19],
            [36, -11],
            [102, -8],
            [228, 28],
            [96, -16],
            [2, -12],
            [-61, -41],
            [-184, -49],
            [77, -19],
            [-2, -16],
            [-85, -48],
            [-178, -34],
            [-78, -8],
            [-68, 5],
            [-312, 74],
            [-110, 10],
            [-105, 19],
            [-77, -3],
            [-82, -22],
            [36, -11],
            [152, -21],
            [126, -4],
            [52, -8],
            [75, -63],
            [-3, -51],
            [-38, -27],
            [-32, -5],
            [-123, 4],
            [-100, -20],
            [-67, -7],
            [-121, 3],
            [-142, -21],
            [-76, -4],
            [-83, 10],
            [-91, 23],
            [-95, 12],
            [-161, 10],
            [186, -55],
            [55, -49],
            [52, -8],
            [107, -40],
            [157, -20],
            [113, 18],
            [76, -4],
            [-16, -98],
            [-33, -10],
            [-183, 0],
            [-87, 15],
            [-39, 14],
            [-84, 17],
            [-76, -10],
            [-68, 2],
            [-47, -9],
            [-74, 0],
            [-193, -17],
            [-103, 0],
            [-75, 11],
            [-88, 3],
            [-100, -4],
            [111, -33],
            [57, -29],
            [48, -12],
            [115, 20],
            [211, 22],
            [93, 4],
            [83, -10],
            [94, -26],
            [48, -39],
            [122, -5],
            [93, -13],
            [206, -74],
            [-32, -37],
            [-3, -21],
            [-103, -42],
            [-160, -13],
            [-175, 4],
            [-126, -5],
            [273, -65],
            [77, -27],
            [14, -15],
            [-110, -60],
            [-98, -118],
            [-65, -12],
            [-86, 2],
            [-109, -30],
            [-82, -6],
            [-148, 11],
            [-172, 0],
            [-22, -56],
            [1, -55],
            [10, -74],
            [-9, -53],
            [-28, -34],
            [-36, -25],
            [-65, -25],
            [-116, -20],
            [-82, -1],
            [-238, -18],
            [-116, 1],
            [-89, 8],
            [-94, 24],
            [-155, 69],
            [-44, 15],
            [-41, -6],
            [46, -38],
            [70, -36],
            [-7, -12],
            [-69, -18],
            [-167, -16],
            [69, -38],
            [26, -6],
            [69, 6],
            [79, 24],
            [50, 7],
            [98, -6],
            [39, -9],
            [123, -52],
            [17, -2],
            [91, 26],
            [132, 2],
            [48, -21],
            [18, -41],
            [3, -33],
            [-14, -26],
            [30, -24],
            [74, -24],
            [58, -6],
            [41, 14],
            [63, 33],
            [52, 6],
            [38, -24],
            [51, -46],
            [5, -54],
            [-42, -62],
            [-51, -41],
            [-201, -67],
            [-108, -54],
            [-70, -24],
            [-136, -33],
            [-72, -6],
            [-156, -36],
            [-84, 4],
            [-10, 18],
            [50, 85],
            [0, 23],
            [-43, 34],
            [-61, 24],
            [-130, -16],
            [-71, 20],
            [-65, 61],
            [-25, 7],
            [-75, -4],
            [46, -68],
            [-8, -27],
            [-357, -14],
            [-153, 7],
            [-31, 24],
            [-73, 100],
            [-16, -178],
            [-268, -29],
            [-62, 5],
            [-104, 20],
            [-134, 48],
            [-56, 32],
            [-49, 52],
            [-33, -38],
            [-37, -78],
            [-91, 20],
            [-117, 19],
            [-41, 77],
            [-3, -111],
            [-187, 15],
            [-90, -4],
            [-27, 97],
            [-4, 108],
            [-36, -68],
            [15, -58],
            [6, -71],
            [-80, 20],
            [-175, 10],
            [-62, 10],
            [8, 93],
            [14, 94],
            [225, 93],
            [66, 43],
            [49, 18],
            [77, 11],
            [99, 7],
            [67, -5],
            [77, 5],
            [92, 17],
            [65, 4],
            [-6, 15],
            [-70, 60],
            [-51, 19],
            [-51, 3],
            [-49, 26],
            [-59, 55],
            [-97, 126],
            [24, 37],
            [80, 28],
            [80, 20],
            [81, 11],
            [67, 1],
            [81, -16],
            [115, -31],
            [65, -35],
            [82, -73],
            [54, -59],
            [44, -27],
            [197, -48],
            [66, -7],
            [236, 16],
            [78, 13],
            [35, 16],
            [40, 40],
            [70, 39],
            [107, 83],
            [60, 65],
            [26, 48],
            [-24, 15],
            [-185, -161],
            [-39, -29],
            [-108, -50],
            [-46, -8],
            [-74, 3],
            [-98, 22],
            [-116, -35],
            [-70, 9],
            [-62, 24],
            [-1, 114],
            [-79, 91],
            [87, 47],
            [72, 28],
            [129, 75],
            [70, 6],
            [-50, 25],
            [-111, -7],
            [39, 161],
            [-74, -120],
            [-122, -95],
            [-52, -18],
            [-195, -16],
            [48, 59],
            [-2, 55],
            [-110, -49],
            [-83, -26],
            [-67, -13],
            [-132, 3],
            [-66, 24],
            [19, 60],
            [0, 74],
            [101, 79],
            [65, 59],
            [45, 62],
            [175, 27],
            [170, 11],
            [142, 33],
            [70, 5],
            [67, -15],
            [271, -25],
            [197, -39],
            [87, 41],
            [169, -2],
            [89, 14],
            [115, 48],
            [-77, 6],
            [-64, -21],
            [-62, -11],
            [-64, 2],
            [-128, 18],
            [-222, 3],
            [-113, 8],
            [-53, 9],
            [-55, 29],
            [-23, 24],
            [12, 17],
            [85, 11],
            [133, -35],
            [77, -3],
            [-27, 21],
            [-98, 40],
            [-67, 35],
            [-101, 84],
            [-96, 66],
            [-79, 66],
            [-55, 29],
            [-58, 14],
            [-177, 18],
            [-36, 12],
            [-84, 57],
            [-23, 96],
            [-37, 59],
            [36, 75],
            [59, 34],
            [354, -27],
            [149, 4],
            [191, -9],
            [103, -18],
            [117, -46],
            [105, -52],
            [101, -34],
            [93, -47],
            [101, -70],
            [60, -34],
            [121, -38],
            [131, -22],
            [114, -7],
            [59, 2],
            [109, 36],
            [-50, 5],
            [-132, -2],
            [-91, 10],
            [-108, 53],
            [-155, 94],
            [-146, 61],
            [-107, 60],
            [-87, 58],
            [-8, 25],
            [140, 29],
            [480, 39],
            [287, 47],
            [116, 54],
            [14, 12],
            [384, 76],
            [271, 28],
            [104, 5],
            [99, 20],
            [-167, 15],
            [-189, -1],
            [-169, 10],
            [-51, 17],
            [26, 51],
            [106, 69],
            [232, 86],
            [156, 36],
            [45, 24],
            [-336, -55],
            [-117, -40],
            [-118, -60],
            [-61, -18],
            [-82, -1],
            [-63, -45],
            [-23, -42],
            [-40, -44],
            [-163, -66],
            [-269, -61],
            [-91, -15],
            [-78, -3],
            [-252, -34],
            [-75, -1],
            [-84, 10],
            [36, 30],
            [133, 54],
            [35, 25],
            [-85, -6],
            [-87, -15],
            [-192, -12],
            [-75, -22],
            [-133, -66],
            [-105, -16],
            [-225, -3],
            [-50, 2],
            [-129, 31],
            [-115, -11],
            [-47, 2],
            [-87, 22],
            [-22, 33],
            [109, 70],
            [189, 75],
            [121, 36],
            [175, 30],
            [411, 34],
            [18, 25],
            [-415, -28],
            [-354, -35],
            [-57, -13],
            [-83, -34],
            [-261, -125],
            [-77, -32],
            [-118, -7],
            [-90, 11],
            [-71, 15],
            [-121, 37],
            [-91, 20],
            [-69, 27],
            [-37, 34],
            [30, 15],
            [233, 32],
            [316, -6],
            [142, 7],
            [139, 19],
            [206, 49],
            [224, 69],
            [44, 22],
            [-142, 0],
            [-146, -25],
            [-231, -66],
            [-201, -23],
            [-498, -13],
            [-158, -18],
            [-69, 4],
            [-52, 18],
            [-58, 33],
            [10, 27],
            [119, 30],
            [109, 13],
            [-132, 29],
            [-12, 15],
            [77, 33],
            [165, 48],
            [83, 15],
            [153, 10],
            [157, -5],
            [6, 9],
            [-155, 18],
            [-117, 3],
            [-154, -13],
            [-409, -78],
            [-94, 16],
            [17, 19],
            [219, 83],
            [7, 13],
            [-157, -2],
            [-92, 13],
            [-64, -8],
            [-83, -27],
            [-92, -8],
            [-87, 32],
            [11, 27],
            [132, 58],
            [225, 50],
            [101, 9],
            [164, 0],
            [78, 13],
            [156, 56],
            [95, 24],
            [156, 20],
            [131, -6],
            [72, -18],
            [57, -30],
            [68, -4],
            [51, 23],
            [64, 10],
            [145, -15],
            [87, -27],
            [71, -13],
            [75, 16],
            [110, 1],
            [-82, 34],
            [-392, 79],
            [-11, 18],
            [133, 16],
            [121, 25],
            [160, 63],
            [117, 25],
            [47, -7],
            [116, -35],
            [168, -13],
            [72, -14],
            [128, -78],
            [51, -25],
            [116, -36],
            [95, 9],
            [-102, 36],
            [-16, 40],
            [53, 10],
            [81, -16],
            [213, -55],
            [320, -64],
            [122, -15],
            [144, -52],
            [18, 26],
            [-155, 54],
            [-413, 91],
            [-163, 48],
            [-139, 65],
            [-1, 18],
            [132, 38],
            [105, 13],
            [-136, 47],
            [2, 15],
            [102, 11],
            [64, -3],
            [120, -27],
            [117, -5],
            [-104, 72],
            [-9, 16],
            [52, 19],
            [109, -5],
            [179, -35],
            [321, -18],
            [75, 11],
            [-128, 22],
            [-193, 46],
            [-95, 44],
            [78, 24],
            [218, -3],
            [203, -23],
            [171, 8],
            [151, -12],
            [327, -119],
            [85, -67],
            [42, -9],
            [137, 41],
            [-24, 20],
            [-137, 45],
            [-99, 51],
            [-154, 58],
            [-67, 49],
            [426, 22],
            [411, -19],
            [66, -13],
            [153, -77],
            [133, -45],
            [153, -9],
            [-141, 50],
            [-64, 34],
            [34, 52],
            [160, 46],
            [256, 11],
            [178, -70],
            [-5, 25],
            [104, 35],
            [66, 8],
            [278, 10],
            [58, -13],
            [91, -42]
        ],
        [
            [28104, 81880],
            [38, -21],
            [45, -50],
            [72, -64],
            [54, -41],
            [61, -38],
            [61, -70],
            [98, -159],
            [24, -20],
            [60, -26],
            [114, -33],
            [167, -79],
            [74, -31],
            [47, -12],
            [48, -22],
            [47, -31],
            [36, -34],
            [25, -37],
            [22, -24],
            [39, -27],
            [20, -19],
            [2, -29],
            [-47, -112],
            [46, 72],
            [26, 23],
            [21, 11],
            [44, -1],
            [66, -14],
            [58, 0],
            [50, 13],
            [42, 6],
            [35, -1],
            [60, 13],
            [75, -28],
            [31, -1],
            [109, -27],
            [71, 10],
            [12, -5],
            [24, -35],
            [21, -2],
            [35, 5],
            [34, -9],
            [57, -46],
            [26, -38],
            [25, -80],
            [2, -23],
            [-46, -184],
            [-15, -72],
            [-2, -62],
            [9, -35],
            [41, -60],
            [7, -16],
            [24, -89],
            [6, -38],
            [-2, -43],
            [-13, -72],
            [3, -55],
            [11, -82],
            [-4, -56],
            [-31, -58],
            [-10, -53],
            [0, -19],
            [10, -39],
            [17, -22],
            [30, -25],
            [27, -37],
            [49, -89],
            [37, -49],
            [44, -73],
            [8, -36],
            [-27, -41],
            [-36, -23],
            [-12, -20],
            [52, 12],
            [30, -1],
            [26, -18],
            [21, -35],
            [35, -29],
            [48, -25],
            [49, -41],
            [82, -97],
            [14, -22],
            [22, -51],
            [28, -79],
            [15, -52],
            [2, -24],
            [-17, -25],
            [-54, -44],
            [-55, -78],
            [17, 4],
            [36, 33],
            [62, 65],
            [34, 12],
            [31, -7],
            [50, -19],
            [45, -27],
            [38, -34],
            [57, -92],
            [41, -50]
        ],
        [
            [31015, 78572],
            [0, -233],
            [0, -270],
            [0, -270],
            [1, -135],
            [0, -269],
            [0, -135],
            [0, -270],
            [1, -296],
            [-15, -38],
            [4, -42],
            [21, -49],
            [12, -51],
            [2, -52],
            [21, -63],
            [62, -108],
            [47, -123],
            [34, -67],
            [38, -52],
            [99, -48],
            [240, -67],
            [96, -70],
            [24, -48],
            [8, -26],
            [10, -14],
            [41, -40],
            [22, -14],
            [28, -4],
            [8, 42],
            [7, 8],
            [21, -6],
            [21, -45],
            [27, -87],
            [35, -56],
            [43, -25],
            [45, -7],
            [45, 11],
            [38, -11],
            [30, -36],
            [85, 17],
            [142, 70],
            [94, 37],
            [45, 5],
            [43, -11],
            [56, -36],
            [-25, -139],
            [42, -58]
        ],
        [[32613, 75391], [-113, -117]],
        [[32500, 75274], [-46, 0], [-43, -19], [-57, -39], [-68, -71], [-123, -157]],
        [
            [32163, 74988],
            [-10, -1],
            [-34, -44],
            [-36, -24],
            [-87, -40],
            [-21, -18],
            [-25, -11],
            [-31, -3],
            [-30, -11],
            [-31, -20],
            [-63, -60],
            [-15, -2],
            [-7, 11],
            [16, 35],
            [-3, 24],
            [-12, 5],
            [-27, -14],
            [-17, -3],
            [-15, 8],
            [-23, -6],
            [-69, -31],
            [-11, -22],
            [43, 26],
            [35, 13],
            [0, -28],
            [11, -3],
            [8, 23],
            [48, 19],
            [10, -14],
            [-11, -38],
            [5, -19],
            [19, 1],
            [22, 10],
            [24, 19],
            [1, -18],
            [-42, -45],
            [-6, -20],
            [41, 8],
            [-7, -20],
            [-37, -26],
            [-30, -9],
            [-18, 5],
            [-3, 13],
            [9, 27],
            [-31, -14],
            [-11, 27],
            [-29, -9],
            [-26, 4],
            [-16, 16],
            [2, 19],
            [-11, 8],
            [-30, 3],
            [-14, -20],
            [-32, 1],
            [-15, -9],
            [-37, -8],
            [-58, -8],
            [-46, -12],
            [-34, -16],
            [-25, -6],
            [-17, 4],
            [-27, -5],
            [-38, -15],
            [-60, -11],
            [-23, -12],
            [-32, -30],
            [-42, -51],
            [-29, -24],
            [-16, 1],
            [-38, -39],
            [-27, -70],
            [-36, -74],
            [14, -37],
            [62, -24],
            [39, -1],
            [20, -6],
            [38, 25],
            [47, 22]
        ],
        [[31156, 74314], [-1, -98]],
        [
            [31155, 74216],
            [8, -47],
            [28, -39],
            [4, -25],
            [-38, -25],
            [-20, -3],
            [-16, 9],
            [-27, 4],
            [-38, 0],
            [-64, -15],
            [-47, 3],
            [-55, -20],
            [-54, -11],
            [-38, -16],
            [-44, -51],
            [-10, -4],
            [-17, -35],
            [26, -3],
            [19, -10],
            [62, -10],
            [3, -14],
            [-93, 17],
            [-24, -2],
            [-44, 12],
            [-65, 27],
            [-65, 11],
            [-66, -5],
            [-47, -14],
            [-28, -21],
            [-73, -81],
            [-24, -43],
            [-10, -41],
            [-14, -12],
            [-49, -9],
            [-35, -20],
            [-47, -36],
            [-31, -30],
            [-15, -26],
            [-9, -29],
            [-7, -41],
            [-17, 38],
            [-11, 14],
            [-27, 6],
            [-44, -21],
            [-32, 5],
            [-53, 36],
            [-3, 27],
            [4, 53],
            [9, 34],
            [32, 28],
            [32, 5],
            [86, -11],
            [23, 4],
            [16, 9],
            [11, 16],
            [4, 24],
            [-1, 34],
            [-11, 13],
            [-49, 17],
            [-10, 18]
        ],
        [[30050, 73910], [31, 37], [17, 64], [22, 155]],
        [
            [30120, 74166],
            [33, 15],
            [40, 23],
            [29, 27],
            [17, 29],
            [18, 21],
            [19, 13],
            [40, 45],
            [13, 36],
            [9, 46],
            [2, 47],
            [-3, 47],
            [-1, 189],
            [-4, 44],
            [7, 39],
            [19, 35],
            [12, 33],
            [4, 33],
            [9, 27],
            [15, 22],
            [27, 21],
            [9, 13],
            [15, 46],
            [17, 30],
            [6, 26],
            [0, 82],
            [-7, 23],
            [-13, 21],
            [-5, 23],
            [1, 37],
            [-19, 6],
            [-11, 15],
            [-14, 37],
            [-28, 47],
            [-29, 21],
            [-5, 27],
            [32, 6],
            [92, -7],
            [-5, -52],
            [15, -42],
            [2, -29],
            [20, -15],
            [4, -15],
            [17, -13],
            [-3, -19],
            [19, -2],
            [19, 30],
            [14, -5],
            [-12, -29],
            [-10, -36],
            [-28, -33],
            [6, -10],
            [27, 21],
            [18, 3],
            [14, -6],
            [8, -20],
            [-10, -72],
            [42, 38],
            [37, 15],
            [6, -4],
            [17, -46],
            [41, -34],
            [73, -38],
            [43, -11],
            [15, 16],
            [9, 30],
            [3, 45],
            [-7, 32],
            [-18, 19],
            [-9, 35],
            [34, 27],
            [21, 4],
            [-2, -22],
            [14, -7],
            [20, -23],
            [34, -4],
            [1, 33],
            [-18, -1],
            [-18, 65],
            [-22, 12],
            [-10, 25],
            [-12, 11],
            [-15, 28],
            [-20, 21],
            [19, 15],
            [3, 22],
            [-11, 16],
            [-18, -2],
            [-1, 32],
            [19, 24],
            [3, 23],
            [-16, 28],
            [-29, -4],
            [3, -23],
            [-29, 9],
            [-25, 21],
            [-10, 33],
            [-2, 65],
            [-37, 9],
            [-3, 18],
            [-23, 33],
            [-14, 37],
            [-5, 23],
            [-13, 15],
            [-5, 24],
            [-32, 51],
            [-46, 1],
            [-40, -6],
            [-20, 7],
            [0, 32],
            [-23, -21],
            [-21, 0],
            [-45, 11],
            [-16, 0],
            [-29, -15],
            [0, 16],
            [-14, 25],
            [31, 19],
            [-23, 25],
            [-23, -23],
            [-23, -11],
            [-2, 26],
            [-14, 5],
            [-61, 8],
            [-56, 3],
            [-38, 16],
            [-10, 17],
            [-97, -9],
            [-17, 17],
            [-54, -10],
            [-40, -4],
            [-134, 31],
            [-35, 13],
            [-28, 16],
            [-56, 7],
            [-12, 17],
            [-47, 6],
            [-18, 10],
            [-4, 38],
            [6, 43],
            [-24, 31],
            [-22, -3],
            [-33, -14],
            [-28, -5],
            [-21, -22],
            [-21, 33],
            [0, 19],
            [32, 54],
            [8, 28],
            [-15, 11],
            [-16, -26],
            [-6, 18],
            [2, 43],
            [21, 23],
            [24, -2],
            [12, 20],
            [-20, 28],
            [-34, 9],
            [-25, -13],
            [-10, 15],
            [-29, 18],
            [-6, 30],
            [18, 47],
            [-2, 12],
            [9, 28],
            [22, 42],
            [7, 30],
            [-7, 16],
            [-16, 12],
            [-14, 31],
            [-17, 19],
            [-28, 19],
            [-23, 25],
            [-19, 31],
            [-5, 24],
            [8, 19],
            [2, 25],
            [18, 42],
            [2, 35],
            [15, 23],
            [4, 30],
            [-34, 5],
            [-65, 0],
            [-52, -5],
            [-39, -9],
            [-45, 4],
            [-50, 16],
            [-42, 33],
            [-34, 50],
            [-25, 51],
            [-17, 52],
            [-6, 45],
            [-11, 21],
            [-13, 70],
            [-8, 28],
            [-10, 12],
            [-25, 62],
            [-19, 19],
            [-38, -7],
            [-19, 24],
            [-15, 7],
            [-19, -4],
            [-21, -16],
            [-21, 0],
            [-37, 9],
            [-23, -5],
            [-43, -2],
            [-57, 33],
            [-34, 2],
            [-16, 18],
            [-59, 28],
            [-63, 21],
            [-18, 22],
            [-32, 0],
            [-23, -11],
            [-19, -3],
            [12, -59],
            [24, -26],
            [11, -25],
            [0, -24],
            [-9, -28],
            [-29, -48],
            [-28, -7],
            [-14, -12],
            [-23, -1],
            [-10, -17],
            [-2, -23],
            [-17, -25],
            [-14, 27],
            [5, 20],
            [54, 71],
            [18, 30],
            [1, 37],
            [-7, 25],
            [-13, 14],
            [-19, 1],
            [-14, -8],
            [-10, -26],
            [-9, -82],
            [-19, -23],
            [-3, -29],
            [-22, -39],
            [-9, -51],
            [-47, -26],
            [4, 24],
            [18, 70],
            [16, 37],
            [-3, 6],
            [-96, -48],
            [-36, -26],
            [-8, -38],
            [2, -40],
            [-9, -17],
            [-20, -68],
            [-9, -21],
            [-29, -12],
            [-34, -48],
            [-9, -6]
        ],
        [
            [27910, 76946],
            [-61, 7],
            [-39, -11],
            [-28, 11],
            [-15, 35],
            [-16, 22],
            [-70, -10],
            [-89, 7],
            [-42, -4],
            [-16, 15],
            [-14, 38],
            [-23, 5],
            [-39, -8],
            [-55, -50],
            [-51, -26],
            [-41, 0],
            [-40, 26],
            [-65, 52],
            [-45, 58],
            [-52, 20],
            [-39, -5],
            [-15, -29],
            [-21, 0],
            [-26, 88],
            [-26, 17],
            [-46, 37],
            [-32, 20],
            [-49, 25],
            [-17, 4],
            [-64, 5],
            [-37, -7],
            [-26, -30],
            [-31, -14],
            [-45, -6],
            [-29, 13],
            [-15, 32],
            [-63, 29],
            [-111, 25],
            [-64, 22],
            [-26, 36],
            [-2, 31],
            [-28, 78],
            [-12, 65],
            [-5, 77],
            [1, 26],
            [-26, 25],
            [-67, 11]
        ],
        [[30052, 73458], [-14, -6], [3, 39], [10, 5], [1, -38]],
        [[31889, 74791], [-31, -4], [8, 23], [37, 15], [1, -10], [-15, -24]],
        [[31988, 74801], [-17, -19], [-20, 4], [1, 28], [16, 27], [63, 15], [-3, -12], [-29, -14], [-11, -29]],
        [[30813, 75165], [-13, 8], [-7, 23], [20, 1], [0, -32]],
        [[30314, 75532], [-12, 17], [29, 19], [2, -17], [-19, -19]],
        [
            [29996, 75816],
            [-4, -22],
            [21, -44],
            [23, 3],
            [25, -9],
            [17, -22],
            [10, 23],
            [-18, 26],
            [16, 24],
            [20, -2],
            [19, 20],
            [22, 6],
            [13, -20],
            [16, 0],
            [10, -12],
            [9, -29],
            [10, -1],
            [11, 27],
            [16, 20],
            [21, 13],
            [15, 1],
            [13, -23],
            [0, -16],
            [17, -13],
            [4, -13],
            [-3, -42],
            [13, -26],
            [10, 45],
            [20, 40],
            [11, -12],
            [-11, -32],
            [4, -7],
            [29, -6],
            [-29, -75],
            [-21, -37],
            [-23, -24],
            [-16, -7],
            [-10, 13],
            [-20, 7],
            [17, 18],
            [18, 4],
            [32, 42],
            [-19, 3],
            [-64, -70],
            [-55, 35],
            [-15, 18],
            [-21, 13],
            [-26, 8],
            [-31, 16],
            [-36, 25],
            [-34, 14],
            [-62, 8],
            [-8, 13],
            [-61, 23],
            [-19, 15],
            [2, 17],
            [12, 20],
            [16, -17],
            [27, 11],
            [22, -7],
            [19, 18],
            [18, 7],
            [8, -8]
        ],
        [[29838, 75763], [-17, -7], [-21, 9], [-8, 12], [13, 32], [14, 14], [15, 2], [15, -9], [8, -16], [-19, -37]],
        [
            [29691, 75922],
            [-21, -10],
            [-10, -28],
            [-22, 6],
            [-18, 38],
            [-12, 33],
            [-6, 29],
            [11, 12],
            [28, -4],
            [24, -10],
            [22, -17],
            [8, -22],
            [-4, -27]
        ],
        [[29117, 76796], [-59, -8], [-26, 8], [4, 18], [32, 22], [19, 1], [38, -14], [11, -22], [-19, -5]],
        [[28514, 77367], [-21, -4], [-17, 8], [-3, 33], [16, 10], [24, -34], [1, -13]],
        [
            [28388, 77345],
            [-14, 13],
            [-4, 37],
            [10, 16],
            [18, 12],
            [25, 4],
            [32, -3],
            [15, -10],
            [-6, -26],
            [-10, -15],
            [-39, -6],
            [-17, -8],
            [-10, -14]
        ],
        [[31014, 78598], [-35, 47], [-24, 38], [-8, 38], [15, 90], [15, 37], [17, 22], [20, 51]],
        [[31014, 78921], [0, -323]],
        [
            [35863, 76091],
            [9, -8],
            [14, 14],
            [17, 46],
            [46, -12],
            [24, -21],
            [27, 3],
            [25, -27],
            [49, -21],
            [51, 3],
            [78, 13],
            [9, 5],
            [80, 10],
            [80, 5],
            [27, -12],
            [16, -25],
            [-46, -36],
            [-45, -43],
            [-64, -42],
            [-8, -21],
            [4, -38],
            [-1, -39],
            [20, -16],
            [-17, -12],
            [-65, -6],
            [-19, 4],
            [-23, 15],
            [-8, 37],
            [-28, -5],
            [-8, 5],
            [39, 31],
            [-18, 40],
            [-19, -3],
            [-13, 19],
            [0, 40],
            [-18, -24],
            [-24, -9],
            [-24, -20],
            [37, -7],
            [-19, -15],
            [-20, -4],
            [-90, 31],
            [-22, 12],
            [-28, 33],
            [-21, 43],
            [13, 17],
            [-32, 6],
            [-49, -2],
            [-28, 12],
            [1, 76],
            [-9, 21],
            [-31, 18],
            [-47, 5],
            [-4, 28],
            [15, 43],
            [23, 37],
            [17, 37],
            [21, 30],
            [50, 59],
            [-1, -44],
            [5, -38],
            [-33, -77],
            [57, -76],
            [12, -37],
            [-13, -36],
            [22, -8],
            [7, -14]
        ],
        [
            [34245, 76551],
            [-3, 25],
            [4, 49],
            [-59, 20],
            [-120, -213],
            [-116, -207],
            [-19, -150],
            [-34, -55],
            [-22, -51],
            [-17, -108],
            [-1, -43],
            [6, -22],
            [-2, -19],
            [-35, -58],
            [-4, -36],
            [-14, -17],
            [-40, -35],
            [-33, -52],
            [-1, -29],
            [5, -39],
            [-6, -11],
            [-28, -2],
            [-12, -22],
            [1, -31],
            [-9, -22],
            [-10, -5],
            [-19, 40],
            [-13, 2],
            [-26, -24]
        ],
        [[33618, 75436], [-15, -18], [-21, -1], [-39, 17], [-28, -50], [-30, -108]],
        [[33485, 75276], [-129, 0], [-128, 0], [-129, -1], [-181, 0]],
        [[32918, 75275], [-204, -1], [-214, 0]],
        [
            [32500, 75274],
            [44, 21],
            [91, 82],
            [68, 29],
            [88, 86],
            [64, 17],
            [12, 19],
            [16, 96],
            [30, 70],
            [36, 59],
            [29, 82],
            [52, 52],
            [79, 44],
            [74, 95],
            [40, 29],
            [39, 21],
            [16, 39],
            [24, 22],
            [64, 45],
            [71, 12],
            [72, 37],
            [55, 20],
            [33, 35],
            [49, 19],
            [147, 100],
            [40, 47],
            [53, 97],
            [46, 49],
            [16, 52],
            [66, 85],
            [68, 111],
            [34, 80],
            [51, 45],
            [99, 127],
            [53, 51],
            [21, 5],
            [60, 46],
            [37, 47],
            [60, 47],
            [108, 58],
            [101, 70],
            [137, 60],
            [160, 91],
            [130, 48],
            [91, 7],
            [111, 23],
            [39, -3],
            [173, -39],
            [83, -48],
            [94, -102],
            [14, -27],
            [3, -38],
            [-50, 18],
            [-45, 2],
            [31, -21],
            [52, -63],
            [-2, -79],
            [-30, -70],
            [-87, -35],
            [-23, -28],
            [-18, -46],
            [-18, -18],
            [-42, -20],
            [-24, -30],
            [-69, -48],
            [-31, -5],
            [-36, 11],
            [-86, 45],
            [-53, 43],
            [-48, -48],
            [-51, 8],
            [-23, -11],
            [-39, 12],
            [-79, -54]
        ],
        [
            [37935, 78865],
            [-62, 19],
            [-50, -5],
            [-95, -24],
            [-26, -15],
            [-52, -43],
            [-76, -15],
            [-54, 6],
            [-21, -6],
            [-32, -33],
            [-7, -36],
            [-129, -163],
            [-34, -55],
            [-65, -59],
            [-73, -102],
            [-62, -41],
            [-22, -57],
            [-60, -34],
            [-111, -9],
            [-52, -10],
            [-61, 16],
            [-47, -25],
            [-69, -7],
            [-33, 5],
            [-135, -54],
            [-34, 52],
            [-26, 20],
            [-76, 3],
            [-60, 21],
            [-56, 4],
            [-53, 10],
            [-36, 0],
            [-37, -6],
            [-57, 2],
            [-32, -29],
            [-107, 9],
            [-46, 26],
            [-37, 5],
            [-50, -6],
            [-48, -19],
            [-104, 22],
            [-111, -19],
            [-96, 13],
            [-28, 12],
            [-152, -34],
            [-60, 20],
            [-52, -52],
            [-36, 11],
            [-39, -8],
            [-13, 10],
            [-26, -7],
            [-17, -28],
            [-22, -4],
            [-37, -50],
            [-62, -40],
            [-90, -218],
            [-9, -84],
            [-34, -58],
            [-55, -9],
            [-156, -42],
            [-70, -33],
            [19, -26],
            [-23, -20],
            [-37, -8],
            [-40, -25],
            [-25, -27],
            [-13, -38],
            [-80, -61],
            [-94, -143],
            [-44, -104],
            [-54, -76],
            [-38, -28],
            [-27, -5],
            [-28, 9],
            [-46, 36],
            [-34, 4],
            [-84, 49],
            [-196, 50],
            [29, -19],
            [26, -31],
            [52, -7],
            [52, 0],
            [110, -62],
            [54, -21],
            [33, -18],
            [27, -42],
            [-20, -81],
            [-20, -67],
            [-27, -51],
            [-95, -133],
            [-45, -44],
            [-80, -158],
            [-82, -74],
            [-44, -46],
            [-47, -72],
            [-110, -54],
            [-41, -14],
            [-38, 7],
            [-46, -44],
            [-54, -27],
            [-17, -41],
            [-130, -110],
            [-50, -14],
            [-43, -30],
            [-13, -50],
            [-38, -30],
            [-42, -92],
            [-60, -91],
            [-73, -15],
            [-26, -31],
            [-31, -51],
            [-43, -34],
            [-86, 16],
            [21, -21],
            [76, -34],
            [8, -49],
            [-38, -11],
            [-75, -62]
        ],
        [[31015, 78572], [43, -47], [-23, 46], [-21, 27]],
        [
            [31014, 78921],
            [7, 14],
            [50, 33],
            [12, -3],
            [10, -40],
            [35, -14],
            [19, -14],
            [16, -21],
            [17, -43],
            [15, -71],
            [12, 7],
            [12, 62],
            [9, 26],
            [30, 38],
            [-14, 38],
            [-62, 93],
            [-1, 23],
            [16, 14],
            [12, 26],
            [6, 38],
            [13, 27],
            [39, 39],
            [34, 60],
            [17, 41],
            [14, 21],
            [-11, 33],
            [-1, 49],
            [-8, 52],
            [-14, 24],
            [-38, 52],
            [-6, 15],
            [-7, 59],
            [4, 29],
            [10, 24],
            [-6, 24],
            [-35, 43],
            [-14, 38],
            [-15, 90],
            [-13, 114],
            [-16, 84],
            [-18, 54],
            [-4, 33],
            [10, 14],
            [13, 43],
            [11, 10],
            [-22, 53],
            [0, 11],
            [24, 28],
            [-22, 28],
            [-54, 26],
            [20, 10],
            [12, 23],
            [-48, 33],
            [-42, 67],
            [-14, 32],
            [-14, 54],
            [-24, 62],
            [-10, 15],
            [-25, 14],
            [15, 24],
            [233, 103],
            [20, 14],
            [114, 58],
            [53, 32],
            [54, 46],
            [73, 47],
            [36, 31],
            [23, 30],
            [116, 117],
            [49, 61],
            [29, 51],
            [41, 62],
            [55, 72],
            [34, 62],
            [15, 51],
            [17, 89],
            [6, 79],
            [3, 115],
            [-2, 103],
            [-15, 162],
            [-9, 51],
            [-16, 60],
            [-41, 122],
            [-7, 33],
            [-25, 55],
            [-82, 146],
            [-103, 98],
            [-19, 25],
            [-41, 29],
            [-62, 33],
            [-39, 27],
            [-105, 101],
            [-34, 12],
            [-16, 45],
            [10, 82],
            [16, 40],
            [57, 74],
            [32, 60],
            [23, 33],
            [25, 25],
            [44, 33],
            [26, 42],
            [-6, 17],
            [-20, 18],
            [-5, 18],
            [34, 46],
            [5, 13],
            [-4, 43],
            [6, 10],
            [42, 2],
            [60, -62],
            [-4, 23],
            [-23, 42],
            [3, 17],
            [44, 45],
            [1, 21],
            [-12, 28],
            [-2, 23],
            [26, 54],
            [-7, 11],
            [-73, 11],
            [-7, 22],
            [37, 25],
            [-61, 121],
            [-10, 36],
            [26, 44],
            [29, 20],
            [-4, 11],
            [-61, 9],
            [-24, 34],
            [40, 84],
            [18, 20],
            [-83, -22],
            [-39, 18],
            [-38, -5],
            [-18, 5],
            [6, 19],
            [70, 84],
            [32, 45],
            [20, 41],
            [12, 41],
            [-7, 90],
            [4, 25],
            [69, 66],
            [-57, 39],
            [-36, 38],
            [-41, 38],
            [-23, 39],
            [-17, 51],
            [-19, 102],
            [-3, 57],
            [5, 41],
            [20, 41],
            [52, 39],
            [91, 59],
            [71, 23],
            [52, -13],
            [101, -13],
            [81, -34],
            [247, -83],
            [43, -37],
            [-41, -32],
            [6, -7],
            [93, 59],
            [45, 15],
            [71, -23],
            [28, -4],
            [35, -19],
            [85, -64],
            [-18, 38],
            [14, 15],
            [67, 34],
            [69, 28],
            [49, 27],
            [52, 36],
            [35, 19],
            [42, -8],
            [62, -48],
            [40, -24],
            [32, -26],
            [45, -45],
            [52, -40],
            [45, 3],
            [20, -10],
            [12, -48],
            [-11, -40],
            [-32, -64],
            [13, -1],
            [48, 38],
            [21, 9],
            [44, -20],
            [42, -31],
            [45, -58],
            [12, -27],
            [-13, -21],
            [-51, -22],
            [10, -9],
            [60, 14],
            [18, 14],
            [13, 22],
            [17, 7],
            [70, -40],
            [11, -14],
            [-16, -23],
            [-31, -13],
            [-26, -34],
            [-4, -15],
            [18, -10],
            [46, -5],
            [-27, -22],
            [-3, -20],
            [59, -69],
            [40, -30],
            [23, -6],
            [53, -1],
            [44, -12],
            [96, -39],
            [56, -7],
            [49, 12],
            [32, 2],
            [28, -15],
            [14, -33],
            [-1, -34],
            [16, -23],
            [31, -13],
            [26, 2],
            [34, 26],
            [28, 4],
            [26, 76],
            [21, 5],
            [26, -27],
            [23, -71],
            [-11, -39],
            [-44, -39],
            [-20, -30],
            [-25, -68],
            [-9, -45],
            [-2, -55],
            [15, -57],
            [23, -37],
            [3, -41],
            [-15, -39],
            [-38, -26],
            [-52, -7],
            [-168, -1],
            [-45, 6],
            [11, -23],
            [47, -8],
            [43, 1],
            [161, -15],
            [22, -15],
            [32, -54],
            [16, -82],
            [-7, -29],
            [-17, -32],
            [-11, -43],
            [-6, -53],
            [9, -29],
            [87, -2],
            [18, -19],
            [-2, -15],
            [-31, -54],
            [-3, -15],
            [14, -37],
            [-19, -48],
            [-8, -44],
            [-9, -29],
            [-24, -22],
            [-21, 1],
            [-24, 60],
            [-23, -6],
            [-12, -40],
            [-35, -22],
            [-55, -16],
            [1, -16],
            [38, -8],
            [48, -27],
            [27, -4],
            [43, 21],
            [83, 69],
            [34, 18],
            [30, 7],
            [34, 1],
            [38, -5],
            [75, 9],
            [42, -22],
            [45, -46],
            [11, -22],
            [17, -83],
            [22, -21],
            [8, -40],
            [-2, -48],
            [-25, -96],
            [-13, -36],
            [-34, -48],
            [-40, -22],
            [-71, -21],
            [-36, -17],
            [-28, -24],
            [-2, -13],
            [80, 41],
            [89, 20],
            [44, 44],
            [19, 48],
            [35, 126],
            [20, 39],
            [28, 7],
            [12, -13],
            [29, -74],
            [-7, -35],
            [-47, -71],
            [17, 7],
            [47, 67],
            [15, 52],
            [22, 11],
            [14, -79],
            [3, -76],
            [20, 19],
            [14, 40],
            [58, 49],
            [68, 39],
            [44, 35],
            [37, 16],
            [55, 16],
            [35, 32],
            [29, 83],
            [11, 19],
            [36, 33],
            [20, 2],
            [18, -12],
            [22, -25],
            [38, -68],
            [5, -22],
            [3, -75],
            [27, 58],
            [1, 42],
            [-29, 69],
            [-9, 30],
            [2, 18],
            [24, 10],
            [34, 4],
            [-20, 38],
            [25, 35],
            [42, -3],
            [3, 34],
            [46, -11],
            [6, 13],
            [40, 1],
            [4, 12],
            [-35, 18],
            [-34, 11],
            [-18, 23],
            [-11, 34],
            [29, 0],
            [19, 59],
            [10, 17],
            [33, -11],
            [-26, 66],
            [5, 12],
            [38, 5],
            [24, -8],
            [61, -48],
            [2, 18],
            [-31, 29],
            [-29, 18],
            [-25, 9],
            [-19, 16],
            [-21, 43],
            [-2, 41],
            [15, 48],
            [23, 18],
            [45, 0],
            [49, -31],
            [8, 10],
            [-41, 33],
            [-4, 43],
            [21, 48],
            [10, 38],
            [44, 106],
            [35, 44],
            [34, 3],
            [28, -17]
        ],
        [[32812, 75598], [-37, -11], [-13, 5], [41, 54], [47, 13], [-38, -61]],
        [[32852, 75533], [-24, -11], [-40, 11], [-45, -15], [21, 41], [51, 26], [51, 78], [14, 2], [-28, -132]],
        [[33636, 76316], [-28, -4], [7, 19], [38, 35], [29, 19], [16, -1], [-27, -42], [-35, -26]],
        [
            [36449, 76546],
            [11, -11],
            [33, -3],
            [-19, -21],
            [-36, -2],
            [-18, 9],
            [26, 106],
            [30, 25],
            [61, 69],
            [25, 21],
            [23, 9],
            [24, -5],
            [-25, -42],
            [-33, -2],
            [-31, -34],
            [-21, -38],
            [-25, -21],
            [-17, -27],
            [-8, -33]
        ],
        [
            [36484, 77555],
            [-129, -9],
            [-103, 35],
            [-76, 16],
            [-75, 31],
            [-162, 97],
            [-19, 34],
            [-15, 41],
            [-31, 38],
            [-33, 31],
            [-172, 95],
            [-14, 33],
            [35, 21],
            [40, 11],
            [34, -2],
            [115, -37],
            [145, -32],
            [62, -25],
            [71, -37],
            [70, -46],
            [154, -121],
            [28, -9],
            [70, -60],
            [25, -44],
            [12, -36],
            [-15, -19],
            [-17, -6]
        ],
        [[24271, 77498], [-263, 0], [-263, 0], [-132, 0], [-165, 0]],
        [[23448, 77498], [-230, 0], [-263, 0], [-263, 0], [-132, 0], [-263, 0], [-132, 0], [-263, 0], [-131, 0], [-164, 0]],
        [
            [12638, 83636],
            [-40, 46],
            [33, 109],
            [0, 36],
            [-185, -8],
            [-91, -81],
            [-148, 65],
            [-23, -46],
            [-147, 46],
            [0, 326],
            [0, 326],
            [0, 325],
            [0, 326],
            [0, 163],
            [0, 326],
            [0, 326],
            [0, 326],
            [0, 326],
            [0, 163],
            [0, 325],
            [0, 163],
            [0, 326],
            [0, 326],
            [0, 326],
            [0, 163],
            [0, 326],
            [0, 326]
        ],
        [
            [12037, 89017],
            [44, -9],
            [141, -18],
            [132, 10],
            [245, -59],
            [152, -111],
            [123, -54],
            [50, -38],
            [80, -33],
            [188, -71],
            [59, -8],
            [109, -34],
            [84, 3]
        ],
        [[12642, 88975], [-26, -21], [-51, 33], [47, 29], [64, -18], [17, -16], [-51, -7]],
        [
            [15256, 80719],
            [-13, 12],
            [-72, 9],
            [-26, 80],
            [-14, 62],
            [-21, 54],
            [0, 12],
            [19, 36],
            [73, 29],
            [0, 12],
            [-27, 8],
            [-6, 13],
            [-7, 58],
            [0, 85],
            [-12, 69],
            [-18, 42],
            [-47, 83],
            [-4, 21],
            [33, 50],
            [-78, -42],
            [-108, -45],
            [-46, -31],
            [-12, -23],
            [8, -29],
            [-11, -27],
            [-11, -49],
            [-23, -51],
            [-12, -11],
            [-42, 19],
            [-11, 17],
            [-21, 68],
            [5, 18],
            [36, 48],
            [26, 50],
            [50, 128],
            [33, 1],
            [57, 25],
            [-90, 13],
            [-26, 24],
            [-29, 60],
            [-34, 11],
            [-15, 12],
            [-38, 55],
            [-17, 59],
            [-36, 13],
            [-3, 66],
            [-48, 16],
            [-19, 15],
            [-31, 40],
            [-11, 37],
            [8, 44],
            [-31, 4],
            [-171, 70],
            [9, 92],
            [-31, 121],
            [-34, 49],
            [14, 29],
            [15, 0],
            [66, -35],
            [61, -43],
            [8, 6],
            [-98, 90],
            [-25, 27],
            [-6, 49],
            [7, 9],
            [93, -8],
            [5, 7],
            [-93, 26],
            [-19, 0],
            [-31, -46],
            [-26, 7],
            [-24, 46],
            [-23, 32],
            [-42, 44],
            [-8, 31],
            [-2, 46],
            [6, 44],
            [34, 99],
            [-32, -29],
            [-29, -76],
            [-24, -26],
            [-15, 6],
            [-23, 31],
            [-47, 38],
            [-55, 10],
            [-35, 38],
            [-51, 108],
            [-7, 53],
            [-7, 13],
            [-28, 18],
            [-17, 25],
            [-26, 131],
            [-35, 90],
            [-9, 48],
            [-39, -9],
            [26, -56],
            [-31, -3],
            [36, -64],
            [16, -99],
            [24, -74],
            [15, -60],
            [17, -88],
            [32, -115],
            [-13, -34],
            [-16, -7],
            [-50, 13],
            [-45, 67],
            [-38, 20],
            [-93, -10],
            [-7, 39],
            [11, 63],
            [-9, 26],
            [-48, 92],
            [1, 18],
            [67, 43],
            [-33, 3],
            [-26, -16],
            [-10, 10],
            [-16, 60],
            [-15, 27],
            [-3, -57],
            [11, -30],
            [0, -41],
            [-7, -17],
            [-24, -13],
            [-23, 12],
            [-25, 23],
            [-22, 10],
            [-19, 34],
            [-17, 19],
            [-81, 24],
            [-49, 28],
            [11, -38],
            [-33, -52],
            [56, 5],
            [43, -18],
            [53, -35],
            [11, -26],
            [38, -22],
            [1, -12],
            [-24, -34],
            [50, 4],
            [30, -13],
            [37, -53],
            [13, -30],
            [2, -38],
            [-23, -19],
            [-103, -13],
            [-37, -46],
            [-36, 12],
            [-51, 37],
            [-64, 35],
            [-145, 103],
            [-7, 25],
            [-30, 19],
            [-27, 27],
            [-35, 43],
            [-22, 35],
            [-8, 24],
            [-20, 28],
            [-66, 59],
            [-35, 23],
            [-64, 23],
            [14, 20],
            [-58, 12],
            [-56, 28],
            [-141, 77],
            [-73, 49],
            [-42, 23],
            [-26, 23],
            [10, 12],
            [47, 24],
            [31, 49],
            [2, 16],
            [-16, 35],
            [-7, 33],
            [8, 47],
            [22, 17],
            [11, -4],
            [36, -44],
            [5, -16],
            [-2, -61],
            [19, 2],
            [12, 43],
            [13, 11],
            [40, -6],
            [19, 3],
            [-79, 33],
            [-49, 60],
            [-36, 9],
            [-29, -24],
            [-73, -80],
            [-21, -14],
            [-92, -44],
            [-63, -9],
            [-71, 7],
            [-60, 14],
            [-151, 70],
            [-23, 16],
            [35, 43],
            [1, 14],
            [-12, 44],
            [-24, 19],
            [-1, -42],
            [-37, -26],
            [-43, -14],
            [-134, 35],
            [-137, 29],
            [-123, 7],
            [-173, -24],
            [-92, -23],
            [-54, -3],
            [-52, 5],
            [-4, 16],
            [23, 22],
            [-30, 37],
            [-46, 22],
            [-61, 8],
            [-35, 11],
            [-30, 27],
            [-34, 12],
            [-15, 22],
            [12, 70],
            [11, 41],
            [31, 72],
            [-43, -34],
            [-37, -36],
            [-34, -47],
            [-47, -41],
            [-42, 5],
            [-56, 29],
            [-48, 15],
            [-55, 6],
            [27, 26],
            [37, 54],
            [5, 17],
            [-146, 5],
            [-11, 41],
            [-21, 8],
            [-30, -6],
            [-48, -21],
            [-21, 16],
            [56, 46],
            [-44, 15],
            [-32, 33],
            [0, 53],
            [12, 34],
            [97, 33],
            [-31, 13],
            [-61, -5],
            [-41, -28],
            [-49, -40],
            [-33, -15],
            [-39, 13],
            [-46, -13],
            [-20, -29],
            [-22, -5],
            [-13, 18],
            [-49, 17],
            [-19, -39],
            [-47, -14],
            [-26, 3],
            [-35, 44],
            [10, 28],
            [68, 111],
            [-29, -18],
            [-44, -45],
            [-19, -13],
            [-68, 0],
            [-37, -25],
            [56, -4],
            [-26, -51],
            [-16, -48],
            [-15, -12],
            [-50, -2],
            [-1, -14],
            [49, -38],
            [41, -19],
            [3, -14],
            [-8, -37],
            [-17, -22],
            [-53, -2],
            [-12, -28],
            [33, 8],
            [45, 1],
            [33, 9],
            [21, 15],
            [22, -4],
            [20, -25],
            [6, -21],
            [-25, -32],
            [-42, -19],
            [-10, -39],
            [-1, -31],
            [6, -56],
            [-42, -25],
            [-30, -75],
            [-23, 0],
            [-42, -18],
            [-62, -3],
            [-50, 16],
            [-36, 30],
            [-45, -19],
            [-12, 8],
            [-27, 51],
            [-6, -3],
            [-6, -55],
            [-36, -59],
            [-15, -70],
            [-10, 8],
            [-17, 62],
            [-9, 14],
            [-25, -36],
            [4, -59],
            [-6, -7],
            [-50, 25],
            [-16, -3],
            [17, -36],
            [-2, -12],
            [-71, -69],
            [-43, 8],
            [-46, -26],
            [-30, 17],
            [-12, -17],
            [0, -31],
            [-17, -29],
            [-54, -47],
            [-34, -55],
            [-31, 19],
            [-37, 13],
            [4, -36],
            [-36, -3],
            [-25, 8],
            [-34, -9],
            [-44, -24],
            [-37, 1],
            [-69, 54],
            [10, 32],
            [25, 35],
            [48, 32],
            [56, 11],
            [35, 19],
            [42, 38],
            [23, 29],
            [44, 75],
            [-13, 10],
            [-97, -71],
            [-34, -6],
            [-78, 27],
            [-16, 12],
            [-11, 34],
            [21, 78],
            [16, 37],
            [37, 58],
            [50, 61],
            [17, 41],
            [26, 107],
            [-2, 48],
            [-11, 59],
            [-1, 36],
            [11, 11],
            [114, 55],
            [53, 41],
            [105, 60],
            [28, 0],
            [45, -38],
            [28, -12],
            [36, 1],
            [43, 15],
            [69, -6],
            [142, -40],
            [32, 3],
            [-22, 28],
            [-98, 16],
            [-41, 17],
            [-116, 71],
            [-27, 27],
            [11, 13],
            [29, 11],
            [30, 53],
            [28, 31],
            [44, 30],
            [82, 44],
            [-32, 2],
            [-59, -8],
            [-22, -8],
            [-40, -32],
            [-37, -67],
            [-10, -8],
            [-41, -7],
            [-112, -4],
            [-19, 22],
            [-24, 1],
            [-103, -57],
            [-37, -30],
            [-26, -33],
            [-41, -25],
            [-55, -15],
            [-41, -19],
            [-43, -39],
            [-16, -43],
            [11, -44],
            [-36, -11],
            [-40, -29],
            [-85, -86],
            [-11, -42],
            [14, -24],
            [-33, -41],
            [-53, -40],
            [-35, -15],
            [-45, 5],
            [-38, 26],
            [-34, -2],
            [43, -27],
            [43, -36],
            [27, -29],
            [11, -23],
            [1, -24],
            [-10, -24],
            [-31, -43],
            [-30, -12],
            [-77, -13],
            [-32, -18],
            [53, -18],
            [4, -9],
            [-7, -36],
            [-14, -12],
            [-44, -21],
            [-39, -6],
            [1, 32],
            [-17, 13],
            [-21, -11],
            [-52, -41],
            [13, -18],
            [-63, -79],
            [-85, -62],
            [6, -15],
            [-22, -53],
            [-12, -47],
            [15, -20],
            [71, -24],
            [35, -5],
            [40, -17],
            [74, -43],
            [24, -29],
            [2, -28],
            [-32, -58],
            [-56, -56],
            [-25, -15],
            [-50, -22],
            [-49, -53],
            [-13, -28],
            [2, -25],
            [-9, -18],
            [-63, -34],
            [25, -9],
            [-8, -30],
            [-4, -42],
            [-11, -7],
            [-39, 0],
            [-50, -16],
            [-4, -35],
            [-131, -22],
            [-28, -57],
            [-15, -18],
            [-51, -41],
            [-31, -17],
            [-36, -10],
            [-19, -14],
            [-11, -34],
            [-31, -26],
            [-16, -32],
            [-11, -6],
            [-57, -7],
            [-12, -11],
            [-5, -44],
            [-31, 9],
            [-27, -8],
            [-60, -50],
            [-13, -17],
            [25, -49],
            [-1, -20],
            [-23, -56],
            [-36, -22],
            [-11, -31],
            [-26, 4],
            [-21, -6],
            [-13, -21],
            [-31, -15],
            [-20, -16],
            [-24, -29],
            [-23, -19],
            [-20, -8],
            [-57, -1],
            [-31, -28],
            [-12, -48],
            [-15, -22],
            [-30, -1],
            [-30, 11],
            [-30, -4],
            [-49, -30],
            [-16, -22],
            [31, -5],
            [-1, -19],
            [-27, 1],
            [-37, -18],
            [-50, -14],
            [-19, -10],
            [-38, -56],
            [46, -19],
            [22, -26],
            [13, -32],
            [-49, -48],
            [-13, -20],
            [-15, -1],
            [-6, 52],
            [-15, 10],
            [-11, -17],
            [-24, -62],
            [-26, -31],
            [-198, -81],
            [-29, -18],
            [-13, -64],
            [-13, -23],
            [-19, -5],
            [2, 84],
            [-4, 16],
            [-20, 11],
            [-21, -6],
            [-20, -18],
            [-27, -3],
            [-26, -18],
            [-61, -57],
            [-40, -14],
            [-28, -43],
            [-28, -13],
            [-22, 10],
            [-18, -7],
            [-27, -32],
            [-39, 17],
            [-17, -11],
            [-22, -30],
            [-23, -19],
            [-24, -10],
            [-63, -9],
            [-31, 14],
            [1, 38],
            [11, 27],
            [22, 24],
            [36, 12],
            [-32, 19],
            [-31, 9],
            [-43, -20],
            [-26, -35],
            [-12, -61],
            [-6, -16],
            [-74, -108],
            [-29, -33],
            [-28, 3],
            [-34, -40],
            [-18, -12],
            [-16, 1],
            [-22, 14],
            [14, 16],
            [-5, 22],
            [-35, 54],
            [-28, 2],
            [-4, -16],
            [9, -82],
            [-1, -18],
            [-17, -23],
            [-45, -26],
            [-14, 2],
            [-40, 52],
            [-39, 10],
            [-2, -17],
            [8, -34],
            [-9, -32],
            [-28, -30],
            [-21, -14],
            [-14, 1],
            [-1, 21],
            [13, 40],
            [3, 34],
            [-6, 27],
            [8, 36],
            [51, 40],
            [21, 6],
            [26, -12],
            [28, 19],
            [4, 20],
            [22, 24],
            [40, 30],
            [44, 56],
            [51, 80],
            [59, 70],
            [69, 58],
            [73, 46],
            [149, 64],
            [-2, -24],
            [24, -15],
            [54, 10],
            [22, 14],
            [-1, -30],
            [-33, -16],
            [1, -14],
            [48, -64],
            [14, -10],
            [18, 10],
            [-4, 46],
            [16, 9],
            [33, 2],
            [22, -6],
            [28, -26],
            [28, -9],
            [17, 2],
            [7, 16],
            [-12, 18],
            [-53, 39],
            [-15, 17],
            [-3, 23],
            [7, 29],
            [43, 102],
            [23, 40],
            [47, 46],
            [32, 23],
            [81, 69],
            [155, 71],
            [38, 46],
            [52, 50],
            [22, 12],
            [7, -37],
            [35, -11],
            [33, -1],
            [3, 19],
            [-6, 65],
            [8, 53],
            [23, 41],
            [34, 48],
            [48, 55],
            [29, 25],
            [28, 13],
            [28, 24],
            [46, 57],
            [49, 20],
            [28, -28],
            [34, -8],
            [23, 13],
            [-34, 19],
            [-11, 34],
            [-23, 21],
            [-5, 23],
            [4, 36],
            [20, 84],
            [3, 87],
            [17, 49],
            [35, 18],
            [76, 13],
            [-44, 22],
            [-46, 11],
            [-12, 54],
            [1, 39],
            [19, 46],
            [72, 77],
            [78, 53],
            [-20, 20],
            [36, 107],
            [35, 95],
            [-47, -81],
            [-56, -62],
            [-161, -72],
            [-110, -61],
            [-52, -14],
            [-35, 15],
            [-27, 58],
            [-35, 58],
            [9, 50],
            [15, 34],
            [35, 5],
            [38, -16],
            [34, -2],
            [-43, 34],
            [-63, 29],
            [-28, -9],
            [-22, -48],
            [-29, -32],
            [-25, 11],
            [-5, -26],
            [-19, -61],
            [-7, -42],
            [27, -111],
            [-5, -44],
            [-50, -20],
            [-41, 36],
            [-85, 140],
            [-29, 40],
            [-67, 66],
            [-22, -9],
            [-28, -33],
            [-27, -9],
            [-72, 48],
            [-33, 37],
            [-32, 44],
            [-48, -24],
            [-42, -29],
            [-50, -47],
            [-33, 1],
            [-90, -40],
            [-10, -1],
            [-25, -31],
            [-10, -41],
            [-122, -32],
            [-120, 18],
            [42, 22],
            [47, 18],
            [41, 43],
            [-17, 58],
            [-3, 66],
            [45, 52],
            [-47, 0],
            [-29, -19],
            [-28, 39],
            [-13, 77],
            [32, 46],
            [14, 35],
            [13, 48],
            [1, 41],
            [-25, 70],
            [-71, 148],
            [-32, 111],
            [-55, 59],
            [41, 96],
            [46, 88],
            [59, 39],
            [-37, 6],
            [-22, -5],
            [-39, -51],
            [-63, -111],
            [-40, -55],
            [-26, -16],
            [42, -21],
            [14, -58],
            [-10, -49],
            [-11, -27],
            [-50, 2],
            [-45, -40],
            [-105, -43],
            [-143, -24],
            [-70, 3],
            [-72, 50],
            [3, 54],
            [-105, 87],
            [-59, 86],
            [-42, 2],
            [-37, 23],
            [-44, 35],
            [11, 50],
            [-27, 14],
            [-34, -2],
            [-40, 10],
            [104, 111],
            [36, 74],
            [29, 11],
            [38, -12],
            [52, -29],
            [44, -13],
            [33, -39],
            [-18, -44],
            [4, -22],
            [55, 47],
            [41, 42],
            [32, -12],
            [23, -43],
            [28, -44],
            [62, 42],
            [33, 52],
            [-28, 23],
            [-34, 13],
            [-88, 18],
            [22, 14],
            [56, -1],
            [21, 14],
            [-50, 37],
            [-76, -58],
            [-138, 3],
            [-96, 34],
            [-96, -6],
            [-34, 25],
            [54, 43],
            [38, 24],
            [-20, 16],
            [-42, -11],
            [-19, 20],
            [-63, 37],
            [31, 40],
            [-28, -2],
            [-18, -30],
            [3, -59],
            [-30, -6],
            [-27, 4],
            [-19, 35],
            [-19, 75],
            [-54, 20],
            [-13, 38],
            [34, 49],
            [-15, 25],
            [-36, 8],
            [-41, -24],
            [-18, 21],
            [-5, 59],
            [21, -3],
            [82, 19],
            [8, 9],
            [-65, 29],
            [-18, 31],
            [27, 17],
            [49, 2],
            [68, 18],
            [-29, 32],
            [-12, 47],
            [12, 50],
            [80, 113],
            [78, 95],
            [24, 21],
            [36, 12],
            [33, -9],
            [35, -20],
            [-20, 56],
            [48, 15],
            [29, 44],
            [-29, -6],
            [-32, -30],
            [-8, 30],
            [-8, 69],
            [14, 66],
            [11, 29],
            [27, 28],
            [76, 11],
            [17, 7],
            [-46, 41],
            [35, 49],
            [93, 26],
            [51, -8],
            [64, -30],
            [37, -38],
            [-10, -38],
            [45, 27],
            [25, -12],
            [20, -21],
            [21, 0],
            [70, 19],
            [35, 19],
            [44, 51],
            [57, 33],
            [81, 105],
            [24, 42],
            [27, 7],
            [25, -4],
            [18, -35],
            [25, -10],
            [145, 8],
            [74, 16],
            [51, 34],
            [53, 58],
            [31, 38],
            [15, 50],
            [-39, 118],
            [-26, 123],
            [-71, 81],
            [-51, 24],
            [-33, -3],
            [24, 51],
            [68, -5],
            [45, 10],
            [36, 25],
            [29, 57],
            [-6, 41],
            [-9, 22],
            [-55, 61],
            [-38, 11],
            [-86, -72],
            [-52, -1],
            [-39, 13],
            [-33, -41],
            [-94, -36],
            [-50, -37],
            [-93, -90],
            [-24, -41],
            [-29, -2],
            [-22, 80],
            [-101, 75],
            [-30, -25],
            [17, -24],
            [23, -17],
            [37, -7],
            [-28, -54],
            [-38, 29],
            [-68, 41],
            [-70, 22],
            [-182, -3],
            [-120, -42],
            [-22, 12],
            [-20, -10],
            [-22, -28],
            [-24, -4],
            [-50, 6],
            [-95, 27],
            [-215, 39],
            [-56, 24],
            [-48, 57],
            [1, 38],
            [21, 17],
            [-2, 55],
            [-42, 15],
            [-85, 80],
            [-31, 34],
            [51, -12],
            [71, 11],
            [25, 51],
            [53, 15],
            [49, -7],
            [-24, 25],
            [-127, 26],
            [-17, -8],
            [-228, 47],
            [-180, 81],
            [-31, 50],
            [24, 34],
            [24, 16],
            [5, -37],
            [104, 43],
            [54, 56],
            [102, 10],
            [55, 46],
            [46, 52],
            [64, 27],
            [43, 24],
            [57, 15],
            [64, -27],
            [88, -5],
            [29, 10],
            [21, 20],
            [-86, 44],
            [19, 41],
            [101, 50],
            [78, 17],
            [41, -1],
            [121, 65],
            [65, 19],
            [125, 12],
            [102, 4],
            [27, -24],
            [-54, 5],
            [-7, -12],
            [19, -17],
            [-6, -21],
            [-33, -64],
            [2, -51],
            [-43, -40],
            [105, -73],
            [161, -5],
            [88, 13],
            [51, -22],
            [42, -5],
            [115, 12],
            [86, -16],
            [37, 6],
            [80, 110],
            [31, 17],
            [34, -19],
            [45, -16],
            [28, 11],
            [12, 31],
            [-16, 22],
            [-130, 41],
            [-88, -20],
            [-27, 23],
            [9, 45],
            [-94, 111],
            [-39, 23],
            [-46, 1],
            [-24, 39],
            [-20, 50],
            [40, 20],
            [36, 9],
            [34, -16],
            [37, -65],
            [36, -10],
            [-11, -65],
            [44, -60],
            [98, -56],
            [79, 21],
            [56, -1],
            [33, -12],
            [81, -50],
            [41, -6],
            [130, 26],
            [1, 49],
            [-11, 36],
            [-30, 22],
            [-87, -4],
            [-68, 37],
            [-58, -10],
            [-107, -56],
            [-54, 22],
            [-34, 30],
            [-54, 30],
            [-7, 58],
            [46, 66],
            [34, 32],
            [-31, 23],
            [-75, 16],
            [-132, -16],
            [-5, 46],
            [-54, -47],
            [-55, 10],
            [-74, -5],
            [-164, 42],
            [-58, 52],
            [-25, 42],
            [-44, 115],
            [-56, 72],
            [-389, 244],
            [-177, 62],
            [-86, 68],
            [-53, 17],
            [-51, 7],
            [-65, 22],
            [42, 7],
            [24, -7],
            [38, 17],
            [21, 19],
            [30, 83],
            [31, 125],
            [-8, 49],
            [216, -10],
            [143, 8],
            [48, 11],
            [181, 19],
            [47, 14],
            [87, 42],
            [103, 74],
            [88, 98],
            [27, 24],
            [10, 37],
            [11, 87],
            [44, 82],
            [186, 188],
            [86, 74],
            [59, 58],
            [37, -41],
            [-18, -5],
            [-55, -47],
            [71, 18],
            [39, 21],
            [199, 39],
            [107, 65],
            [5, 14],
            [159, 81],
            [48, -13],
            [-45, -53],
            [32, -14],
            [-28, -64],
            [74, -5],
            [-1, 36],
            [13, 60],
            [41, -11],
            [92, 27],
            [-111, 3],
            [-67, 58],
            [-37, 0],
            [124, 85],
            [113, 51],
            [25, -1],
            [15, -25],
            [-48, -28],
            [27, -18],
            [55, 13],
            [24, 16],
            [116, -1],
            [42, 23],
            [150, 3],
            [28, 8],
            [93, 45],
            [87, 55],
            [40, 30],
            [68, 76],
            [59, 50],
            [97, 49],
            [-30, -37],
            [30, -28],
            [203, -57],
            [51, -3],
            [21, -35],
            [-17, -33],
            [-53, -37],
            [-105, -37],
            [32, -15],
            [21, -33],
            [31, -4],
            [51, 12],
            [40, 21],
            [82, 67],
            [26, 38],
            [19, 9],
            [69, -9],
            [39, -19],
            [44, -34],
            [-34, -52],
            [57, -26],
            [64, -5],
            [61, -21],
            [86, 42],
            [66, 9],
            [63, -1],
            [82, 23],
            [138, -31],
            [36, 8],
            [55, -6],
            [59, -19],
            [21, -20],
            [-63, -43],
            [-11, -44],
            [22, -19],
            [40, -3],
            [5, -26],
            [25, -6],
            [125, 2],
            [-16, -28],
            [-38, -33],
            [222, -18],
            [30, 18],
            [46, 7],
            [97, 26],
            [37, -11],
            [43, -26],
            [40, -6],
            [38, 6],
            [87, 36],
            [101, 2],
            [41, -12],
            [43, 5],
            [131, -42],
            [49, -5],
            [64, -55],
            [34, -1],
            [37, 23],
            [33, -1],
            [32, -22],
            [53, -7],
            [24, -35],
            [26, -13],
            [198, -26],
            [99, 12],
            [143, -3],
            [69, -17],
            [72, 2],
            [118, -60],
            [63, -10],
            [12, -14],
            [179, -15],
            [62, 32],
            [109, 8],
            [98, 27],
            [56, 0],
            [64, -7],
            [43, 15],
            [158, -46],
            [88, -53],
            [39, -38],
            [184, -56],
            [53, -31],
            [37, -34],
            [36, 6],
            [89, -7]
        ],
        [[1146, 79059], [-19, -33], [-15, 15], [-5, 45], [11, 11], [30, -32], [-2, -6]],
        [[1232, 79070], [-26, -12], [-34, 25], [3, 28], [38, -23], [19, -18]],
        [
            [655, 78980],
            [-15, -18],
            [-41, 30],
            [-6, 11],
            [24, 14],
            [5, 26],
            [-19, 21],
            [-33, 26],
            [-13, 19],
            [24, 19],
            [51, 1],
            [27, -32],
            [20, -11],
            [48, -8],
            [-39, -27],
            [-17, -51],
            [-16, -20]
        ],
        [
            [880, 79017],
            [-25, -13],
            [-47, 6],
            [-60, -6],
            [-24, -9],
            [-4, 24],
            [103, 31],
            [24, 16],
            [14, 20],
            [14, 38],
            [17, 11],
            [15, -15],
            [-23, -53],
            [-4, -50]
        ],
        [
            [1052, 79101],
            [1, -19],
            [36, 2],
            [11, -9],
            [0, -37],
            [-23, -5],
            [-14, -19],
            [-66, -45],
            [-21, 25],
            [-38, -40],
            [27, 104],
            [31, 16],
            [11, 12],
            [-2, 30],
            [14, 51],
            [31, -2],
            [15, -21],
            [-13, -43]
        ],
        [[1228, 79176], [-7, -16], [-30, 17], [-13, 29], [9, 24], [24, 1], [14, -10], [17, -30], [-14, -15]],
        [
            [1990, 79251],
            [60, -23],
            [76, 3],
            [28, -12],
            [-49, -9],
            [-16, 3],
            [-42, -13],
            [-29, -2],
            [-65, 12],
            [-50, -8],
            [-29, 13],
            [-19, 18],
            [16, 15],
            [45, -15],
            [4, 8],
            [38, 14],
            [32, -4]
        ],
        [[2326, 79327], [-23, -9], [-25, 9], [12, 29], [34, 35], [27, -8], [22, -24], [-47, -32]],
        [
            [1643, 79194],
            [-166, -23],
            [-25, 16],
            [55, 14],
            [62, 26],
            [77, 23],
            [60, 28],
            [51, 17],
            [15, 30],
            [-45, 15],
            [-9, 12],
            [21, 14],
            [18, 20],
            [43, 23],
            [38, -29],
            [8, -20],
            [-11, -48],
            [-33, -13],
            [-5, -12],
            [18, -37],
            [-69, -32],
            [-103, -24]
        ],
        [[2860, 79499], [-19, -18], [-10, 29], [45, 54], [23, -7], [7, -24], [-20, -27], [-26, -7]],
        [[3182, 79647], [-10, -30], [-47, 12], [-32, -5], [-1, 25], [50, 18], [20, 1], [20, -21]],
        [
            [3715, 79925],
            [-95, -60],
            [-30, -43],
            [-24, -42],
            [-18, -23],
            [-28, -16],
            [-32, -29],
            [-13, -4],
            [-100, -68],
            [-2, 17],
            [30, 25],
            [20, 23],
            [35, 53],
            [6, 57],
            [6, 15],
            [37, 45],
            [20, 6],
            [42, -5],
            [23, 26],
            [-11, 10],
            [1, 48],
            [12, 28],
            [21, 23],
            [29, 19],
            [37, 13],
            [27, 1],
            [49, -28],
            [7, -13],
            [-18, -55],
            [-31, -23]
        ],
        [[4257, 80136], [-13, 25], [19, 30], [27, 6], [-33, -61]],
        [
            [4131, 80235],
            [14, -27],
            [23, 17],
            [17, 23],
            [21, 41],
            [12, -15],
            [32, -22],
            [-27, -32],
            [-53, -50],
            [-17, -32],
            [-1, -15],
            [51, 11],
            [23, -13],
            [-14, -13],
            [-28, -12],
            [-24, -24],
            [-55, -40],
            [-22, -34],
            [-24, -13],
            [-34, -3],
            [-60, -22],
            [-36, -21],
            [-9, -11],
            [-25, -5],
            [-44, -37],
            [-45, -9],
            [-34, 23],
            [-9, 13],
            [30, 26],
            [22, 9],
            [34, 4],
            [33, 24],
            [68, 32],
            [21, 18],
            [13, 61],
            [16, 10],
            [8, 25],
            [37, -1],
            [18, -27],
            [10, 21],
            [19, 15],
            [-11, 11],
            [-34, 14],
            [-43, 6],
            [-24, 25],
            [-4, 33],
            [25, 39],
            [18, 11],
            [40, 9],
            [36, 13],
            [33, -3],
            [3, -53]
        ],
        [[4370, 80329], [-60, -13], [-20, 38], [4, 30], [38, 24], [22, -3], [59, -48], [-11, -22], [-32, -6]],
        [[4457, 80366], [-17, 2], [-2, 24], [-10, 39], [32, 18], [19, -35], [7, -23], [-29, -25]],
        [[5385, 80514], [-27, -12], [-28, 12], [-25, 24], [-2, 28], [54, -18], [28, -34]],
        [[5464, 80762], [-29, 15], [-13, 32], [43, 29], [19, -28], [-20, -48]],
        [
            [5100, 80837],
            [30, -92],
            [13, -18],
            [47, -20],
            [16, -14],
            [16, -30],
            [-85, 37],
            [-54, -54],
            [-16, -7],
            [-151, -3],
            [-30, -10],
            [-20, -17],
            [-34, -50],
            [-36, -31],
            [-40, -13],
            [-47, 2],
            [-25, 7],
            [-13, 23],
            [-11, 47],
            [5, 35],
            [42, 31],
            [14, 16],
            [54, 105],
            [33, 18],
            [46, -7],
            [40, 31],
            [85, 46],
            [19, 6],
            [62, 1],
            [17, -7],
            [23, -32]
        ],
        [[6370, 80832], [-18, 3], [-12, 32], [21, 3], [9, -38]],
        [[6323, 80932], [-2, -44], [-12, 5], [-18, -13], [-9, 9], [3, 28], [12, 1], [1, 31], [16, 25], [9, -42]],
        [
            [15020, 80892],
            [31, -73],
            [2, -25],
            [-30, -9],
            [-24, 4],
            [-15, 20],
            [7, 37],
            [-15, 21],
            [-18, 8],
            [-16, -13],
            [-1, 36],
            [12, 26],
            [-7, 36],
            [4, 35],
            [16, -1],
            [34, -27],
            [20, -75]
        ],
        [
            [6212, 80919],
            [-18, -12],
            [-6, -15],
            [-27, -20],
            [-40, -57],
            [5, 64],
            [-6, 37],
            [22, 6],
            [19, 33],
            [18, 3],
            [19, 39],
            [15, -2],
            [-8, -24],
            [18, -22],
            [-11, -30]
        ],
        [
            [14550, 80789],
            [15, -2],
            [12, 19],
            [23, -4],
            [25, -14],
            [-9, -76],
            [-18, -41],
            [-31, 14],
            [-26, 30],
            [-37, 52],
            [-35, 64],
            [-25, 64],
            [-14, 50],
            [-52, 20],
            [-11, 28],
            [8, 24],
            [41, 12],
            [61, -62],
            [10, -27],
            [22, -31],
            [4, -43],
            [11, -17],
            [26, -60]
        ],
        [[6072, 81036], [-5, -44], [-42, 28], [-4, 24], [40, 3], [11, -11]],
        [
            [5962, 81023],
            [31, -4],
            [30, -68],
            [-38, -15],
            [-28, 11],
            [-29, -18],
            [-10, 16],
            [-6, 76],
            [18, 40],
            [20, 12],
            [18, -25],
            [-6, -25]
        ],
        [
            [14413, 81151],
            [7, -26],
            [-44, -37],
            [-12, -30],
            [-26, -34],
            [-31, -26],
            [4, 80],
            [-31, 47],
            [31, 23],
            [56, -9],
            [34, 20],
            [12, -8]
        ],
        [[7542, 81305], [-12, -17], [-37, 7], [-4, 15], [36, 47], [15, 4], [2, -56]],
        [
            [15131, 81120],
            [-11, -61],
            [-21, -63],
            [-32, -33],
            [-23, 7],
            [-17, 27],
            [-32, 4],
            [-10, 23],
            [9, 29],
            [-16, 3],
            [-15, -18],
            [-36, -24],
            [-26, -45],
            [-12, -29],
            [-15, 32],
            [-9, 76],
            [-2, 32],
            [27, 48],
            [35, 46],
            [7, 137],
            [109, 69],
            [11, -3],
            [35, -52],
            [38, -72],
            [10, -32],
            [0, -57],
            [-4, -44]
        ],
        [
            [14332, 81594],
            [59, -12],
            [54, 2],
            [30, -48],
            [9, -44],
            [-7, -37],
            [105, -53],
            [49, -55],
            [31, -54],
            [21, -62],
            [44, -72],
            [23, -22],
            [-25, -6],
            [-67, 48],
            [-22, -51],
            [-3, -21],
            [54, 10],
            [45, -47],
            [17, -9],
            [17, -33],
            [1, -13],
            [-15, -42],
            [13, -4],
            [49, 7],
            [9, -12],
            [-7, -98],
            [7, -35],
            [-6, -57],
            [5, -35],
            [-13, -44],
            [-35, -8],
            [-17, 13],
            [-23, 37],
            [-23, 59],
            [-9, 8],
            [-56, 17],
            [-13, 24],
            [1, 32],
            [-23, 52],
            [-12, -9],
            [6, -31],
            [-6, -25],
            [-25, 11],
            [-40, 78],
            [-45, 62],
            [-18, 15],
            [4, 18],
            [45, 20],
            [-38, 61],
            [1, 17],
            [14, 30],
            [-17, 13],
            [-48, -9],
            [-17, 6],
            [-22, 46],
            [-57, 1],
            [-39, 52],
            [30, 29],
            [14, -3],
            [28, -19],
            [11, 1],
            [28, 26],
            [4, 23],
            [21, 19],
            [-15, 55],
            [-25, 9],
            [-52, -20],
            [-45, -32],
            [-18, 13],
            [-4, 19],
            [48, 52],
            [21, 29],
            [-19, 40],
            [-2, 56],
            [10, 12]
        ],
        [
            [14575, 81543],
            [-34, 7],
            [-45, 45],
            [6, 29],
            [35, 34],
            [61, -3],
            [19, -7],
            [4, -26],
            [-7, -14],
            [2, -28],
            [-7, -15],
            [-34, -22]
        ],
        [
            [14781, 81466],
            [-6, -92],
            [-24, 5],
            [-24, -13],
            [-25, 6],
            [-16, 22],
            [5, 27],
            [-14, 16],
            [-47, 5],
            [-18, 7],
            [-10, 29],
            [-2, 38],
            [7, 14],
            [24, 10],
            [18, 46],
            [11, 6],
            [39, 91],
            [19, -6],
            [34, -56],
            [43, -80],
            [-14, -75]
        ],
        [[7815, 81648], [-22, -13], [-8, 15], [15, 35], [33, 33], [33, 22], [22, -15], [-21, -29], [-52, -48]],
        [[7961, 81692], [-15, -1], [-23, 15], [3, 17], [32, 22], [33, -4], [-2, -33], [-28, -16]],
        [[3162, 81759], [41, -11], [22, 7], [20, -5], [4, -14], [-35, -28], [-14, 1], [-41, 35], [3, 15]],
        [
            [14585, 81698],
            [-3, -8],
            [-39, 1],
            [-14, 7],
            [-6, 23],
            [4, 23],
            [20, 49],
            [9, 55],
            [57, -61],
            [18, -27],
            [10, -34],
            [-56, -28]
        ],
        [
            [14202, 81876],
            [20, -38],
            [29, 3],
            [16, -29],
            [12, -44],
            [-9, -28],
            [-13, 6],
            [-14, -16],
            [-9, -54],
            [5, -54],
            [-5, -54],
            [-16, -55],
            [-4, -37],
            [-14, -14],
            [-22, 17],
            [-17, -31],
            [-21, 0],
            [-17, 71],
            [15, 117],
            [34, 24],
            [-20, 31],
            [-43, 38],
            [4, 20],
            [-33, 60],
            [3, 64],
            [31, 44],
            [40, 8],
            [29, -19],
            [19, -30]
        ],
        [
            [14394, 81965],
            [21, -18],
            [11, 19],
            [21, -1],
            [38, -17],
            [23, -24],
            [13, -28],
            [-2, -54],
            [2, -39],
            [-6, -37],
            [-19, -15],
            [-30, 35],
            [-34, 63],
            [-20, -5],
            [21, -34],
            [4, -21],
            [15, -24],
            [11, -44],
            [-5, -40],
            [-16, -17],
            [-53, 5],
            [-31, -12],
            [-37, 7],
            [-14, 29],
            [-3, 45],
            [-9, 63],
            [2, 49],
            [-24, 44],
            [-20, 27],
            [-29, 23],
            [-19, 24],
            [5, 19],
            [30, 14],
            [49, -3],
            [105, -33]
        ],
        [[8332, 82032], [-46, -17], [-25, -36], [-18, -16], [-25, 29], [7, 44], [21, 30], [108, -10], [0, -21], [-22, -3]],
        [[3037, 82065], [-32, -26], [-29, 10], [-9, 27], [84, 22], [-14, -33]],
        [
            [13899, 82159],
            [45, -109],
            [17, -57],
            [46, -187],
            [3, -64],
            [-14, -45],
            [8, -49],
            [0, -74],
            [-7, -42],
            [-30, 7],
            [-30, 47],
            [-32, 74],
            [-9, 35],
            [4, 43],
            [28, 41],
            [-44, -6],
            [-43, 37],
            [4, 43],
            [-5, 12],
            [-38, -14],
            [-14, 12],
            [-3, 41],
            [8, 21],
            [35, 53],
            [-43, 30],
            [-11, 60],
            [-25, 34],
            [-14, -3],
            [-33, -96],
            [-16, -21],
            [-47, -14],
            [14, 51],
            [-17, 72],
            [0, 28],
            [11, 21],
            [33, 8],
            [31, 32],
            [3, 20],
            [25, 51],
            [12, 10],
            [32, -1],
            [67, -57],
            [20, -8],
            [29, -36]
        ],
        [[8260, 82437], [-9, -16], [-61, 49], [-16, 18], [11, 16], [42, -21], [33, -46]],
        [
            [8365, 82422],
            [15, -27],
            [48, 32],
            [24, 9],
            [33, 2],
            [25, -15],
            [3, -24],
            [-20, -27],
            [1, -17],
            [22, -32],
            [54, -17],
            [6, -22],
            [-37, -52],
            [-24, -16],
            [-67, 10],
            [-62, 17],
            [-25, 3],
            [-14, -27],
            [54, -3],
            [20, -24],
            [12, -37],
            [-34, -13],
            [-28, 0],
            [-34, -22],
            [-19, -25],
            [-69, -6],
            [-52, -33],
            [-19, -16],
            [-6, -20],
            [-20, -14],
            [-44, -14],
            [26, -13],
            [1, -38],
            [-35, -57],
            [-66, -47],
            [-17, 2],
            [-14, 24],
            [86, 94],
            [-27, 8],
            [-37, 26],
            [-26, -17],
            [1, 23],
            [17, 26],
            [-12, 14],
            [-55, 6],
            [-25, -7],
            [-17, -19],
            [34, 1],
            [19, -20],
            [7, -32],
            [-23, -52],
            [-24, 5],
            [-50, 64],
            [-21, 95],
            [-43, 72],
            [-2, 17],
            [12, 44],
            [43, 64],
            [46, 17],
            [32, 27],
            [51, 7],
            [27, -12],
            [11, -24],
            [-4, -17],
            [19, -15],
            [20, -50],
            [23, -46],
            [15, 5],
            [-12, 43],
            [-7, 85],
            [-6, 22],
            [12, 6],
            [34, -3],
            [-1, 13],
            [-36, 28],
            [-22, 24],
            [-7, 35],
            [19, 24],
            [23, 10],
            [32, -13],
            [29, -54],
            [14, -17],
            [22, 9],
            [9, 18],
            [21, 14],
            [32, -7],
            [16, 16],
            [0, 24],
            [10, 27],
            [-18, 26],
            [20, 8],
            [67, -20],
            [29, -22],
            [-15, -41]
        ],
        [
            [13664, 82657],
            [45, -55],
            [-9, -50],
            [-24, -10],
            [25, -26],
            [12, 9],
            [47, 52],
            [23, 13],
            [57, -16],
            [49, -25],
            [15, -20],
            [8, -35],
            [-13, -76],
            [-41, -13],
            [-39, 13],
            [-34, -27],
            [28, -20],
            [83, -4],
            [26, -43],
            [7, -33],
            [-18, -60],
            [-47, 17],
            [-42, 35],
            [-86, 49],
            [-34, -6],
            [-4, -30],
            [1, -65],
            [-23, -34],
            [-67, 15],
            [-27, 49],
            [-24, 78],
            [-94, 92],
            [-25, 19],
            [-33, 55],
            [17, 69],
            [44, 26],
            [15, 42],
            [23, -34],
            [32, -33],
            [0, 31],
            [15, 25],
            [45, 4],
            [21, 23],
            [29, 12],
            [17, -13]
        ],
        [[14102, 82648], [-2, -14], [-42, 1], [-43, 21], [-21, 27], [5, 12], [39, 11], [37, -26], [27, -32]],
        [
            [13989, 82610],
            [78, -12],
            [57, 3],
            [53, -84],
            [32, -67],
            [19, -47],
            [25, -90],
            [-31, 24],
            [-33, 83],
            [-23, 33],
            [-22, 57],
            [-1, 17],
            [-22, 21],
            [-17, -8],
            [2, -40],
            [10, -44],
            [57, -96],
            [38, -55],
            [7, -18],
            [5, -50],
            [-16, -23],
            [20, -46],
            [-5, -17],
            [-54, -21],
            [-50, -85],
            [-54, -50],
            [-25, -9],
            [-23, 28],
            [-9, 58],
            [14, 20],
            [27, 105],
            [0, 35],
            [-33, 47],
            [-20, 40],
            [-11, 54],
            [-18, 145],
            [-9, 46],
            [-12, 38],
            [-15, 31],
            [-19, 71],
            [29, -5],
            [32, -53],
            [17, -36]
        ],
        [
            [8514, 82721],
            [11, -4],
            [20, 34],
            [36, -28],
            [23, 6],
            [14, -35],
            [32, -1],
            [-2, -36],
            [-27, -37],
            [-12, -10],
            [-24, 13],
            [-25, 38],
            [-21, -25],
            [8, -41],
            [-44, -3],
            [-26, -15],
            [-19, 34],
            [-26, -55],
            [-31, -27],
            [-45, -12],
            [-17, 2],
            [-99, 36],
            [-24, 14],
            [82, 84],
            [43, 33],
            [63, -10],
            [1, 37],
            [-23, 28],
            [1, 11],
            [51, 20],
            [41, -13],
            [39, -38]
        ],
        [[8493, 82791], [-10, -4], [-37, 35], [10, 14], [44, 29], [21, 1], [11, -14], [-11, -30], [-28, -31]],
        [[5890, 82842], [-23, -9], [-24, 5], [-19, 55], [15, 2], [30, 36], [67, 29], [17, 4], [-63, -122]],
        [[10937, 83534], [8, 34], [30, 40], [28, 25], [36, 11], [-4, -18], [-48, -35], [-50, -57]],
        [[9871, 83672], [-17, -17], [-61, 10], [13, 34], [47, 21], [51, -33], [-33, -15]],
        [
            [9959, 83531],
            [-34, -8],
            [-8, 17],
            [18, 41],
            [64, 75],
            [43, 34],
            [40, 49],
            [41, 70],
            [7, 26],
            [19, 3],
            [31, -17],
            [19, -24],
            [-9, -20],
            [-102, -100],
            [-18, -46],
            [-22, -18],
            [-16, -39],
            [-32, -13],
            [-41, -30]
        ],
        [
            [4279, 83849],
            [29, -27],
            [62, 7],
            [35, -18],
            [10, -19],
            [2, -32],
            [-8, -28],
            [1, -58],
            [25, -23],
            [12, -64],
            [-54, -11],
            [-55, -2],
            [-48, -22],
            [-9, -17],
            [7, -25],
            [-25, -1],
            [-22, 23],
            [-26, 11],
            [-87, 17],
            [-111, 66],
            [-47, 14],
            [-48, 49],
            [-44, 62],
            [57, 15],
            [128, -10],
            [16, 45],
            [17, 11],
            [40, 12],
            [38, 25],
            [35, -10],
            [55, 18],
            [15, -8]
        ],
        [[10767, 83823], [-10, -13], [-42, 13], [49, 36], [8, -7], [-5, -29]],
        [
            [10373, 83886],
            [7, -15],
            [59, 4],
            [16, -21],
            [-23, -13],
            [-67, -24],
            [-54, -32],
            [-7, 3],
            [-26, 75],
            [30, 33],
            [14, 7],
            [51, -17]
        ],
        [[9983, 83887], [-10, -29], [9, -26], [-22, -73], [-17, -24], [-26, 29], [-6, 38], [11, 13], [19, 77], [42, -5]],
        [[8636, 83837], [19, 79], [22, -17], [-30, -55], [-11, -7]],
        [
            [2240, 83891],
            [67, -37],
            [43, 4],
            [34, -31],
            [14, -25],
            [-51, 18],
            [-74, -1],
            [-100, 75],
            [-35, 16],
            [8, 42],
            [38, 22],
            [20, -57],
            [36, -26]
        ],
        [[9899, 84096], [-39, -4], [-21, 14], [7, 40], [20, 5], [22, -14], [11, -41]],
        [
            [2635, 85665],
            [5, -14],
            [32, 3],
            [45, -6],
            [50, -13],
            [50, 4],
            [62, 42],
            [75, 17],
            [40, -10],
            [55, -35],
            [32, -71],
            [74, -24],
            [48, -10],
            [21, -32],
            [39, -14],
            [41, 6],
            [23, -5],
            [70, -1],
            [86, -21],
            [-14, -54],
            [-28, -23],
            [-79, 7],
            [-79, -7],
            [-33, -28],
            [-27, -35],
            [-4, -35],
            [-32, -22],
            [-14, 19],
            [-18, 57],
            [-26, 26],
            [-39, 19],
            [-62, 13],
            [-16, 20],
            [-10, 29],
            [-46, 36],
            [-32, 17],
            [-99, 36],
            [-33, 5],
            [-33, -4],
            [-35, -17],
            [-70, -43],
            [-36, -4],
            [-35, 11],
            [-49, 41],
            [-9, 29],
            [5, 58],
            [18, 68],
            [30, 14],
            [57, -49]
        ],
        [[28375, 67049], [-27, -12], [-40, 1], [8, 12], [47, 11], [12, -12]],
        [
            [28555, 67119],
            [-8, -5],
            [-33, -58],
            [-119, -19],
            [7, 13],
            [25, 3],
            [35, 18],
            [-7, 31],
            [-14, 33],
            [-12, 4],
            [-9, 20],
            [1, 62],
            [-8, 37],
            [-19, 37],
            [-7, -7],
            [-14, -64],
            [-12, -84],
            [-6, -27],
            [-35, -2],
            [-31, 5],
            [-15, -1]
        ],
        [
            [28274, 67115],
            [-8, 219],
            [-6, 210],
            [-7, 209],
            [-6, 209],
            [15, 206],
            [23, 309],
            [22, 309],
            [23, 309],
            [15, 206],
            [15, 206],
            [11, 152],
            [-27, 37]
        ],
        [[28344, 69696], [-6, 14], [198, -3], [198, -4], [99, -1], [199, -4], [99, -1]],
        [
            [29131, 69697],
            [24, -214],
            [25, -214],
            [40, -356],
            [41, -356],
            [8, -33],
            [6, -52],
            [43, -155],
            [13, -65],
            [-4, -27],
            [6, -23],
            [14, -19],
            [-2, -22],
            [-20, -25],
            [-13, -30],
            [-9, -54],
            [-18, -95],
            [0, -58],
            [17, -79],
            [4, -35],
            [-12, -154],
            [8, -100],
            [19, -64]
        ],
        [
            [29321, 67467],
            [-100, -1],
            [-199, 0],
            [-200, 0],
            [-200, 0],
            [-100, 0],
            [-4, -40],
            [2, -38],
            [11, -36],
            [45, -69],
            [4, -17],
            [-8, -53],
            [1, -38],
            [-5, -20],
            [-10, -17],
            [-3, -19]
        ],
        [
            [27871, 70255],
            [5, -33],
            [-5, -20],
            [-18, -10],
            [0, -34],
            [-5, -13],
            [-36, -30],
            [-15, -40],
            [5, -49],
            [-12, -49],
            [-31, -50],
            [-13, -56],
            [5, -61],
            [-15, -50],
            [-35, -38],
            [-12, -25]
        ],
        [
            [27689, 69697],
            [4, -31],
            [-12, -26],
            [-30, -27],
            [-16, -25],
            [-2, -26],
            [-20, -17],
            [-7, -38],
            [-7, -88],
            [-15, -50],
            [-26, -12],
            [-14, -20],
            [-1, -27],
            [-15, -31],
            [-29, -35],
            [-9, -34],
            [9, -32],
            [-10, -23],
            [-31, -15],
            [-9, -16],
            [10, -40],
            [-4, -42],
            [-15, -33],
            [-26, -29],
            [-7, -22],
            [11, -16],
            [0, -17],
            [-13, -19],
            [7, -34],
            [11, -12],
            [5, -35],
            [-9, -44],
            [2, -36],
            [17, -43],
            [-14, -98],
            [1, -14]
        ],
        [[27425, 68590], [-116, -1], [-222, 0], [-222, -1], [-166, 0], [-167, 0]],
        [[26532, 68588], [-2, 302], [-15, 13], [-29, 6], [-32, 0], [-12, -13], [-14, 1], [-16, 18], [-16, 28]],
        [[26396, 68943], [4, 303], [3, 181], [3, 243], [4, 242], [-14, 155], [-21, 233], [-21, 233]],
        [
            [26354, 70533],
            [172, 0],
            [172, 0],
            [172, 0],
            [172, 0],
            [172, 0],
            [86, 0],
            [172, 0],
            [86, 0],
            [172, 0],
            [13, -44],
            [14, -28],
            [-1, -42],
            [-22, -45],
            [-21, -21],
            [-27, -44],
            [-24, -59],
            [209, 5]
        ],
        [
            [21901, 70812],
            [0, -198],
            [0, -198],
            [0, -197],
            [0, -198],
            [0, -198],
            [0, -197],
            [0, -198],
            [0, -198],
            [0, -197],
            [0, -198],
            [0, -198],
            [0, -197],
            [0, -198],
            [0, -198],
            [-1, -197],
            [0, -198]
        ],
        [
            [21900, 67649],
            [-179, -1],
            [-109, 0],
            [-218, -1],
            [-109, 0],
            [-147, 82],
            [-146, 83],
            [-146, 82],
            [-147, 83],
            [-146, 82],
            [-146, 83],
            [-147, 82],
            [-146, 83],
            [15, 31],
            [19, 84]
        ],
        [
            [20148, 68422],
            [1, 5],
            [43, 6],
            [20, 21],
            [12, 39],
            [3, 39],
            [-7, 40],
            [-18, 29],
            [-30, 20],
            [-18, 55],
            [-4, 89],
            [5, 49],
            [16, 7],
            [15, 22],
            [14, 37],
            [11, 40],
            [7, 43],
            [1, 55],
            [-4, 67],
            [28, 82],
            [27, 51],
            [51, 62],
            [12, 18],
            [0, 17],
            [-10, 22],
            [-46, 43],
            [-20, 31],
            [-2, 28],
            [-6, 28],
            [-49, 115],
            [-17, 62],
            [0, 47]
        ],
        [
            [20183, 69691],
            [6, 202],
            [-17, 68],
            [-5, 39],
            [6, 48],
            [-2, 29],
            [-8, 26],
            [-3, 105],
            [-17, 53],
            [8, 40],
            [14, 21],
            [24, 14],
            [27, 5],
            [30, -5],
            [23, -17],
            [16, -32],
            [15, -16],
            [15, 0],
            [20, 25],
            [18, 55],
            [6, 4],
            [0, 240],
            [0, 219]
        ],
        [[20359, 70814], [193, -1], [193, 0], [192, 0], [193, 0], [96, 0], [193, -1], [193, 0], [96, 0], [193, 0]],
        [
            [20148, 68422],
            [-35, -6],
            [-177, -24],
            [-88, -11],
            [-177, -24],
            [-88, -12],
            [-177, -24],
            [-3, 64],
            [-14, 22],
            [-18, -13],
            [-9, 79],
            [5, 37],
            [-2, 37],
            [-18, 90],
            [-45, 109],
            [-100, 135],
            [-50, 45],
            [-40, 58],
            [-25, 16],
            [-31, 4],
            [-10, -26],
            [-36, 18],
            [6, 64],
            [-35, 88],
            [-29, 10],
            [-72, -6],
            [-96, 49],
            [-28, 29],
            [-10, 52],
            [-45, 45],
            [-60, 45],
            [-33, -11],
            [-43, 7],
            [-62, 32],
            [-36, 4],
            [-70, -9],
            [-26, 7],
            [-24, 40],
            [-26, 20],
            [5, 50],
            [-3, 44],
            [4, 35],
            [-12, 77],
            [9, 71],
            [-8, 25],
            [-14, 20],
            [-47, 29],
            [-8, 36],
            [7, 51],
            [-12, 33],
            [-38, 31],
            [-35, 71],
            [-45, 38],
            [-19, 65],
            [-28, 40],
            [-9, 35],
            [-62, 127],
            [-66, 98],
            [-10, 57],
            [-2, 78],
            [25, 47],
            [14, 42],
            [-5, 66],
            [-23, 49],
            [-87, 29],
            [-71, 121],
            [-5, 92],
            [-28, 95],
            [0, 61],
            [-4, 67],
            [21, 14],
            [19, -5],
            [-2, -27],
            [6, -47],
            [23, -36],
            [21, -15],
            [19, -35],
            [30, -13],
            [-17, 36],
            [-10, 47],
            [-20, 58],
            [-23, 33],
            [-11, 59],
            [-16, 36],
            [22, 26],
            [30, 19],
            [40, 5],
            [114, -9],
            [24, 15],
            [-34, 11],
            [-41, -3],
            [-16, 6],
            [-18, 19],
            [-12, 2],
            [-38, -33],
            [-17, 4],
            [-40, 36],
            [-17, 5],
            [-28, -20],
            [-3, -87],
            [8, -64],
            [-16, -7],
            [-20, 27],
            [-30, 15],
            [-24, 25],
            [-35, 44],
            [-18, 17],
            [-22, -20],
            [11, 43],
            [-3, 73],
            [31, -58],
            [-10, 40],
            [-24, 45],
            [-18, 16],
            [-24, 80],
            [-52, 49],
            [-41, 78],
            [-86, 129],
            [-5, 113],
            [-31, 144],
            [13, 82],
            [-2, 57],
            [-15, 88],
            [-16, 47],
            [-69, 131],
            [-67, 87],
            [-10, 67],
            [-5, 67],
            [15, 59],
            [13, 63],
            [19, -8],
            [4, 28],
            [-4, 16],
            [27, 109],
            [-2, 103],
            [22, 128],
            [-1, 42],
            [-14, 90],
            [-14, 54],
            [-25, 39],
            [11, 56],
            [-1, 54],
            [-5, 9]
        ],
        [[17215, 73600], [247, -1], [162, 0], [163, 0], [163, 0], [163, 0], [162, 0], [245, 0]],
        [
            [18520, 73599],
            [0, -313],
            [0, -209],
            [0, -209],
            [0, -210],
            [0, -209],
            [0, -209],
            [0, -313],
            [144, -183],
            [145, -182],
            [145, -182],
            [144, -183],
            [170, -230],
            [170, -231],
            [113, -153],
            [157, -221],
            [156, -221],
            [157, -221],
            [162, -229]
        ],
        [[19029, 68485], [-18, -5], [-20, 11], [-17, 54], [-19, 42], [10, 12], [16, -40], [38, -62], [10, -12]],
        [[18693, 68702], [-32, 4], [-10, 30], [30, -2], [12, -32]],
        [[19030, 68796], [15, -41], [-22, 5], [-24, -2], [-14, 53], [-21, 11], [2, 25], [50, -35], [14, -16]],
        [[18506, 69093], [-21, -7], [-17, 7], [-26, 53], [56, 7], [27, -29], [-19, -31]],
        [[18425, 69152], [-16, -1], [-25, 6], [22, 22], [19, -27]],
        [[18556, 69183], [63, -29], [34, 14], [2, -26], [-76, -21], [-24, 15], [-10, 40], [11, 7]],
        [[24068, 72485], [1, -314], [0, -209], [1, -209], [0, -209], [1, -209], [0, -210], [1, -313]],
        [[24072, 70812], [-153, 0], [-152, 0]],
        [[23767, 70812], [-117, 0], [-233, 0], [-233, 0], [-234, 0], [-233, 0], [-233, 0], [-117, 0], [-233, 0], [-233, 0]],
        [[21901, 70812], [0, 279], [0, 278], [0, 279], [0, 279], [0, 279], [0, 139], [0, 279], [0, 279], [0, 139]],
        [[21901, 73042], [97, 0], [194, 0], [97, 0], [193, 0], [194, 0], [194, 0], [97, 0], [194, 0], [194, 0], [97, 0]],
        [[23452, 73042], [154, 0], [154, 0], [231, 0], [77, 0], [0, -348], [0, -209]],
        [[33397, 73606], [2, -275], [-3, -57], [-8, -13], [-4, -32]],
        [
            [33384, 73229],
            [-27, 3],
            [-44, -9],
            [-59, -19],
            [-33, 12],
            [-33, -21],
            [-114, -5],
            [-24, 11],
            [-30, -39],
            [-49, -22],
            [-124, -86],
            [-15, -17]
        ],
        [[32832, 73037], [-28, 63], [74, 64], [-19, 43], [7, 158], [13, 265]],
        [[32879, 73630], [207, -12], [163, -3], [148, -3], [0, -6]],
        [[31783, 71865], [-7, 14], [-21, 16]],
        [[31755, 71895], [24, 38], [35, -69], [-28, -45], [-3, 46]],
        [
            [32280, 72381],
            [-14, -19],
            [-11, -36],
            [-27, -42],
            [7, -49],
            [-2, -43],
            [16, -41],
            [33, -68],
            [7, -105],
            [25, -70],
            [39, -82],
            [29, -24],
            [2, -30],
            [-14, -51],
            [5, -18],
            [12, -11],
            [12, -43],
            [-1, -26]
        ],
        [[32398, 71623], [-207, 0], [-9, 265], [-6, 176], [-9, 265]],
        [[32167, 72329], [24, 45], [23, 20], [38, 3], [28, -16]],
        [
            [29321, 67467],
            [37, -135],
            [1, -22],
            [127, -13],
            [99, -11],
            [196, -21],
            [99, -10],
            [197, -21],
            [98, -10],
            [0, -19],
            [8, -29],
            [6, -48],
            [10, -10],
            [15, -3],
            [16, 19],
            [10, 41],
            [2, 45],
            [-6, 52],
            [1, 44],
            [8, 26],
            [24, 23],
            [17, -7],
            [64, -37],
            [52, -5]
        ],
        [
            [30402, 67316],
            [15, -50],
            [22, -207],
            [15, -72],
            [27, -194],
            [44, -188],
            [64, -227],
            [103, -275],
            [13, -39],
            [-14, -33],
            [-4, -35],
            [-1, -51],
            [4, -51],
            [12, -62],
            [23, -94],
            [-13, 19],
            [-34, 135],
            [-4, 80],
            [5, 113],
            [-8, -3],
            [-6, -37],
            [-4, -43],
            [-9, -17],
            [-11, 66],
            [0, 30],
            [13, 35],
            [-4, 12],
            [-20, 18],
            [-4, 28],
            [2, 28],
            [-11, 14],
            [-9, 0],
            [6, -68],
            [9, -42],
            [12, -100],
            [20, -61],
            [11, -51],
            [131, -543],
            [31, -69],
            [11, -50],
            [12, -104],
            [3, -133],
            [-22, -244],
            [-5, -166],
            [-10, 25],
            [-18, -76],
            [-25, -69],
            [-9, -106],
            [-12, -54],
            [-36, -56],
            [-23, 1],
            [-55, -42],
            [-39, 11],
            [-46, -24],
            [-30, 2],
            [-18, 51],
            [10, 45],
            [12, 5],
            [40, -53],
            [8, 23],
            [-12, 26],
            [-24, 15],
            [-17, 16],
            [-35, 121],
            [-37, 82],
            [-6, 56],
            [-63, 33],
            [-45, 52],
            [-30, 90],
            [-17, 162],
            [-28, 30],
            [19, 60],
            [21, 50],
            [-16, -12],
            [-12, -19],
            [-16, -44],
            [-11, -7],
            [-10, 7],
            [-12, 85],
            [3, 104],
            [17, 39],
            [-25, 1],
            [-27, -15],
            [4, -35],
            [-4, -19],
            [-19, 5],
            [-14, 13],
            [-20, 36],
            [-27, 69],
            [-55, 190],
            [-11, 27],
            [-19, 28],
            [25, 14],
            [35, 86],
            [28, 51],
            [9, 36],
            [-1, 16],
            [-13, 22],
            [-16, -20],
            [-7, 6],
            [-18, 45],
            [-17, 13],
            [-12, -10],
            [12, -37],
            [12, -14],
            [-5, -53],
            [-15, -33],
            [-17, 8],
            [-8, -13],
            [-20, 38],
            [-11, 38],
            [29, 218],
            [27, 139],
            [3, 158],
            [2, 24],
            [-2, 42],
            [-36, 91],
            [-161, 224],
            [-125, 264],
            [-108, 99],
            [-82, -22],
            [-14, -20],
            [-6, -26],
            [5, -29],
            [-7, -12],
            [-22, 1],
            [-30, -7],
            [-77, -69],
            [-28, 2],
            [-43, -31],
            [-48, -8],
            [-41, -15],
            [-18, 8],
            [-12, 41],
            [10, 9],
            [14, -25],
            [9, 33],
            [-14, 43],
            [-47, 56],
            [-53, 81],
            [17, -2],
            [4, 17],
            [-17, 23],
            [19, 54],
            [-23, -4],
            [-20, -19],
            [-4, -44],
            [-11, 3],
            [-20, 24],
            [-99, 66],
            [-86, 37],
            [66, 17],
            [36, -13],
            [-13, 32],
            [-28, 16],
            [-36, -6],
            [-23, 8],
            [-23, -16],
            [-26, -24],
            [-22, -12],
            [-89, -17],
            [-72, -19],
            [24, 32],
            [42, 19],
            [6, 40],
            [-10, 38],
            [-11, -9],
            [-11, -30],
            [-15, 22],
            [-16, 0],
            [-4, -48],
            [-21, -32],
            [-9, -32],
            [-60, -25],
            [-8, 9],
            [18, 30],
            [-14, 8]
        ],
        [[30383, 63897], [-4, 17], [5, 33], [10, -26], [-1, -16], [-10, -8]],
        [[30454, 63926], [-9, -12], [-17, 57], [30, -26], [-4, -19]],
        [[30544, 63962], [-13, 10], [48, 14], [-18, -17], [-17, -7]],
        [[30749, 64200], [-62, -105], [7, 26], [24, 56], [8, 27], [16, 16], [15, 31], [1, 35], [29, 28], [-38, -114]],
        [[30238, 64931], [-11, -15], [-23, 11], [-12, 19], [-5, 38], [26, -49], [25, -4]],
        [[30223, 64986], [-16, 22], [-10, 61], [15, -20], [11, -63]],
        [[30809, 65391], [5, -41], [-29, 95], [-35, 149], [-18, 116], [12, -31], [13, -65], [52, -223]],
        [[29352, 66709], [9, 20], [20, 22], [23, 8], [-52, -50]],
        [[29131, 69697], [200, -4], [201, -4]],
        [[29532, 69689], [186, 4], [187, 4]],
        [
            [29905, 69697],
            [-17, -38],
            [-45, -71],
            [-12, -55],
            [58, -60],
            [35, -50],
            [24, -19],
            [24, -6],
            [15, -16],
            [9, -39],
            [71, -195],
            [73, -100],
            [30, -49],
            [15, -48],
            [62, -78],
            [22, -43],
            [1, -32],
            [7, -22],
            [14, -14],
            [13, -28],
            [13, -44],
            [25, -38],
            [37, -33],
            [28, -74],
            [17, -116],
            [17, -67],
            [27, -28],
            [37, -99],
            [12, -58],
            [-1, -52],
            [19, -40],
            [62, -45]
        ],
        [
            [30597, 68040],
            [-16, -47],
            [-37, -30],
            [-21, -7],
            [15, -37],
            [-11, -33],
            [-19, -5],
            [-11, -23],
            [10, -32],
            [-2, -20],
            [-22, -20],
            [-5, -20],
            [26, -4],
            [-14, -33],
            [-12, -20],
            [-11, -36],
            [-27, -10],
            [1, -12],
            [15, -10],
            [13, -28],
            [-24, -51],
            [-24, 15],
            [-5, -40],
            [2, -22],
            [-15, -97],
            [-6, -22],
            [5, -80]
        ],
        [[30428, 67450], [-13, -136], [-6, 48], [-1, 47], [11, 28], [9, 13]],
        [
            [7537, 60782],
            [-14, -27],
            [-17, 2],
            [-61, 57],
            [-8, 31],
            [5, 143],
            [-24, 116],
            [-25, 89],
            [19, 46],
            [24, 35],
            [27, 66],
            [-22, 86],
            [6, 51],
            [13, 9],
            [65, -62],
            [130, -95],
            [35, -66],
            [6, -71],
            [24, -9],
            [11, -49],
            [35, -42],
            [11, -25],
            [-14, -39],
            [-63, -75],
            [-79, -33],
            [-70, -84],
            [-14, -54]
        ],
        [[7146, 61763], [-19, -15], [-20, 7], [-4, 38], [-19, 48], [33, 10], [19, -14], [22, -41], [-12, -33]],
        [
            [7258, 61852],
            [8, -9],
            [33, 14],
            [23, 6],
            [40, -37],
            [14, -25],
            [26, -27],
            [9, -19],
            [-7, -24],
            [-29, -39],
            [-40, -9],
            [-23, -17],
            [-30, 4],
            [-9, 7],
            [-4, 49],
            [-9, 53],
            [-20, -6],
            [-22, 18],
            [-23, 44],
            [-2, 27],
            [12, 42],
            [22, 5],
            [17, -23],
            [14, -34]
        ],
        [
            [7033, 62010],
            [66, -15],
            [15, 6],
            [11, -12],
            [54, -8],
            [9, -4],
            [-11, -29],
            [-34, -26],
            [-50, 23],
            [-83, 8],
            [3, 22],
            [8, 16],
            [1, 27],
            [11, -8]
        ],
        [
            [6853, 62145],
            [24, 0],
            [4, -44],
            [22, -39],
            [-17, -16],
            [-33, -6],
            [-16, 12],
            [-16, 28],
            [-18, -8],
            [-6, 29],
            [-12, -6],
            [11, -29],
            [-30, -2],
            [-9, 4],
            [-9, 32],
            [-31, 63],
            [0, 24],
            [-11, 29],
            [47, 9],
            [31, 51],
            [18, 5],
            [34, -82],
            [0, -23],
            [7, -23],
            [10, -8]
        ],
        [
            [6118, 62359],
            [-7, -25],
            [-10, 4],
            [-3, 22],
            [7, 30],
            [18, 26],
            [19, 40],
            [16, -6],
            [-8, -26],
            [-1, -28],
            [-23, -16],
            [-8, -21]
        ],
        [
            [6367, 62410],
            [-27, -31],
            [-16, 13],
            [-30, 5],
            [-12, 24],
            [-31, 21],
            [-13, 29],
            [20, 55],
            [45, 46],
            [70, -2],
            [15, -36],
            [1, -28],
            [-9, -30],
            [-4, -43],
            [-9, -23]
        ],
        [
            [27579, 73885],
            [19, -38],
            [32, -34],
            [19, -32],
            [4, -30],
            [20, -32],
            [35, -34],
            [20, -30],
            [6, -26],
            [-1, -40],
            [-8, -55],
            [-12, -39],
            [-18, -24],
            [-14, -34],
            [-9, -43],
            [-27, -40],
            [-46, -37],
            [-52, -25],
            [-57, -13],
            [-34, -32],
            [-10, -49],
            [5, -42],
            [20, -33],
            [11, -35],
            [3, -38],
            [-14, -62],
            [-31, -86],
            [-35, -56],
            [-39, -25],
            [-17, -38],
            [5, -49],
            [-4, -29],
            [-15, -9]
        ],
        [
            [27335, 72696],
            [-27, 29],
            [-5, 21],
            [-22, 21],
            [-4, 13],
            [-16, 12],
            [-16, 40],
            [-233, -2],
            [-156, -2],
            [-234, -2],
            [-155, -2],
            [-156, -1],
            [-156, -2],
            [-155, -1]
        ],
        [
            [26000, 72820],
            [-19, 41],
            [-10, 38],
            [7, 19],
            [1, 62],
            [-4, 106],
            [-7, 60],
            [-11, 14],
            [-2, 18],
            [9, 24],
            [-3, 16],
            [-13, 8],
            [-5, 20],
            [5, 33],
            [-3, 20],
            [-12, 7],
            [-2, 26],
            [-21, 14],
            [-6, 36],
            [3, 69],
            [-6, 49],
            [-14, 28],
            [-7, 27],
            [0, 25],
            [-14, 39],
            [-29, 54],
            [-19, 71],
            [-9, 88],
            [-20, 49],
            [-10, 3]
        ],
        [
            [25779, 73884],
            [-8, 46],
            [-10, 36],
            [-25, 40],
            [2, 34],
            [16, 38],
            [15, 61],
            [4, 42],
            [12, 31],
            [-2, 40],
            [-7, 19],
            [-20, 15],
            [-4, 29],
            [8, 14],
            [1, 36],
            [-13, 34],
            [-5, 35],
            [45, 2]
        ],
        [
            [25788, 74436],
            [201, 0],
            [100, 0],
            [201, 0],
            [100, 0],
            [201, 0],
            [201, 0],
            [200, 1],
            [101, 0],
            [200, 0],
            [102, 0]
        ],
        [
            [27395, 74437],
            [3, -35],
            [6, -25],
            [12, -20],
            [19, -16],
            [3, -29],
            [-12, -44],
            [-5, -54],
            [4, -65],
            [10, -58],
            [15, -52],
            [33, -38],
            [53, -24],
            [31, -38],
            [12, -54]
        ],
        [
            [19740, 77498],
            [-1, -275],
            [0, -276],
            [34, -56],
            [24, -34],
            [16, -37],
            [24, -39],
            [13, -56],
            [-6, -30],
            [12, -30],
            [-10, -34],
            [34, -29],
            [33, -41],
            [42, -28],
            [69, -99],
            [29, -52],
            [30, -38],
            [15, -43],
            [31, -38],
            [10, -24],
            [24, 9],
            [14, -18],
            [9, -32],
            [26, -7],
            [52, 11],
            [6, -17],
            [-5, -49],
            [-13, -28],
            [2, -26],
            [-10, -61],
            [-9, -41],
            [-1, -39],
            [-12, -23],
            [7, -27],
            [-5, -42],
            [19, -30],
            [6, -50],
            [-2, -10],
            [-27, -19],
            [-13, -32],
            [12, -54],
            [-12, -29],
            [1, -32],
            [25, -14],
            [31, -30],
            [16, -5],
            [27, 30],
            [29, 21],
            [34, 44],
            [4, 19],
            [16, -6],
            [21, -27],
            [22, -18],
            [1, -34],
            [10, -21],
            [3, -34],
            [11, -35],
            [7, -41],
            [28, -54],
            [15, -38],
            [17, -17],
            [10, -21],
            [10, -43],
            [-9, -36],
            [11, -31],
            [29, -37],
            [32, 1],
            [15, -6],
            [29, -47],
            [9, -28],
            [3, -33],
            [15, -37],
            [2, -33],
            [27, -34],
            [18, -12],
            [11, 5],
            [9, 31],
            [22, 20],
            [21, -1],
            [79, -16],
            [9, 7],
            [13, 30],
            [28, 15],
            [48, -7],
            [56, 4],
            [30, -9],
            [42, 11],
            [50, -8],
            [7, 11],
            [-5, 33],
            [13, 49],
            [11, 12],
            [24, 7],
            [22, -32],
            [21, -54],
            [25, -37],
            [20, -15]
        ],
        [[21282, 74992], [0, -261], [0, -174], [0, -261], [0, -261], [0, -174], [0, -261]],
        [[21282, 73600], [-115, 0], [-173, 0], [-174, 0], [-230, 0], [-231, 0]],
        [[20359, 73600], [-230, 0], [-115, 0], [-229, 0], [-115, 0], [-229, -1]],
        [
            [19441, 73599],
            [-1, 374],
            [0, 249],
            [0, 249],
            [-1, 139],
            [20, 84],
            [4, 41],
            [-5, 23],
            [3, 23],
            [12, 21],
            [0, 24],
            [-13, 25],
            [-23, 17],
            [-34, 8],
            [-18, 30],
            [-1, 52],
            [25, 79],
            [53, 107],
            [28, 75],
            [5, 45],
            [32, 102],
            [58, 161],
            [22, 102],
            [-13, 45],
            [-30, 43],
            [-46, 42],
            [-32, 47],
            [-8, 25]
        ],
        [
            [19478, 75831],
            [-11, 30],
            [-5, 38],
            [8, 22],
            [-7, 38],
            [-20, 54],
            [-9, 38],
            [4, 18],
            [-1, 357],
            [-1, 358],
            [-1, 268],
            [0, 179],
            [-1, 267]
        ],
        [[27579, 73885], [142, -1], [139, -2], [139, -1], [139, -1], [139, -2], [178, -2]],
        [[28455, 73876], [0, -87], [5, -72], [9, -32], [22, -39], [14, -47], [15, -78], [14, -52], [11, -22]],
        [
            [28545, 73447],
            [-1, -316],
            [-1, -334],
            [-1, -334],
            [-1, -328],
            [-14, -17],
            [-10, -29],
            [3, -32],
            [-4, -23],
            [-10, -13],
            [5, -35],
            [19, -56],
            [12, -54],
            [4, -54],
            [-4, -39],
            [-16, -35],
            [-17, -77],
            [-13, -30],
            [-17, -10],
            [-15, -28],
            [-14, -47],
            [-14, -23],
            [-15, 2],
            [-18, -27],
            [1, -20],
            [9, -20],
            [-3, -19],
            [-15, -17],
            [5, -13],
            [-11, -17],
            [-6, -26],
            [1, -42],
            [-5, -22],
            [-11, -13],
            [16, -48]
        ],
        [
            [28384, 71251],
            [-10, -10],
            [-17, -40],
            [-3, -44],
            [10, -48],
            [-26, -39],
            [-61, -29],
            [-33, -27],
            [-3, -22],
            [4, -35],
            [12, -46],
            [2, -33],
            [-8, -17],
            [-43, 12],
            [-80, 42],
            [-54, -2],
            [-27, -45],
            [-10, -34],
            [4, -27]
        ],
        [
            [28041, 70807],
            [-22, 34],
            [-15, 15],
            [-8, -38],
            [-16, 13],
            [-19, 37],
            [-23, 62],
            [-5, 49],
            [13, 36],
            [0, 38],
            [-13, 40],
            [-6, 39],
            [0, 39],
            [-31, 57],
            [-62, 76],
            [-45, 47],
            [-29, 18],
            [-34, 38],
            [-39, 59],
            [-20, 45],
            [-3, 31],
            [18, 82],
            [51, 180],
            [8, 29],
            [-8, 15],
            [-21, 21],
            [-42, 19],
            [-38, 9],
            [-30, -21],
            [-27, 43],
            [-23, 109],
            [-56, 114],
            [-90, 121],
            [-52, 81],
            [-14, 43],
            [-13, 65],
            [-11, 86],
            [1, 72],
            [18, 86]
        ],
        [[28545, 73447], [14, -18], [16, -9], [3, -12], [18, -8], [32, -3], [29, 5], [26, 13], [65, 51]],
        [[28748, 73466], [170, 0], [94, -1], [187, 0], [187, 0], [0, -32]],
        [[29386, 73433], [-2, -363], [-2, -363], [-1, -181], [-2, -363], [-1, -185]],
        [
            [29378, 71978],
            [-12, -29],
            [8, -25],
            [-6, -46],
            [15, -8],
            [5, -17],
            [-3, -27],
            [-31, -28],
            [-83, -44],
            [-24, 20],
            [-19, 6],
            [-30, -4],
            [-12, -26],
            [6, -49],
            [-11, -37],
            [-27, -25],
            [-19, -34],
            [-11, -43],
            [-19, -25],
            [-25, -9],
            [-21, -39],
            [-15, -69],
            [-18, -43],
            [-18, -17],
            [-26, 4],
            [-32, 25],
            [-18, 26],
            [-5, 26],
            [-18, 28],
            [-7, -20],
            [-20, -2],
            [-9, -11],
            [3, -19],
            [-16, -22],
            [-6, -18],
            [-1, -28],
            [-8, -26],
            [-16, -24],
            [-22, 8],
            [-30, 39],
            [-31, 10],
            [-31, -22],
            [-23, -28],
            [-15, -37],
            [-15, -9],
            [-21, 28],
            [-50, 38],
            [-26, 8],
            [-19, -9],
            [-25, 14],
            [-1, -33],
            [-4, -21],
            [-15, -2],
            [-5, 22],
            [-11, 8],
            [-17, -8],
            [-17, 3],
            [-15, 14],
            [-10, -8],
            [-2, -47],
            [-19, -16],
            [-21, 0]
        ],
        [
            [24068, 72485],
            [130, 0],
            [129, 0],
            [194, 0],
            [129, 0],
            [130, 0],
            [129, 0],
            [194, 0],
            [130, 0],
            [129, 0],
            [130, 0],
            [194, 0],
            [129, 0],
            [129, 0],
            [185, 0]
        ],
        [
            [26129, 72485],
            [72, -72],
            [18, -1],
            [22, 11],
            [17, -16],
            [11, -45],
            [-1, -22],
            [-15, -1],
            [-18, -27],
            [-22, -52],
            [6, -50],
            [32, -46],
            [22, -46],
            [11, -47],
            [21, -36],
            [48, -39],
            [-1, -22],
            [1, -218],
            [0, -290],
            [0, -146],
            [1, -290],
            [0, -218]
        ],
        [
            [26354, 70812],
            [-214, 0],
            [-142, 0],
            [-143, 0],
            [-143, 0],
            [-142, 0],
            [-143, 0],
            [-143, 0],
            [-142, 0],
            [-143, 0],
            [-143, 0],
            [-142, 0],
            [-143, 0],
            [-143, 0],
            [-142, 0],
            [-214, 0]
        ],
        [
            [29378, 71978],
            [17, 18],
            [19, 2],
            [14, -19],
            [20, -5],
            [27, 10],
            [24, -7],
            [22, -23],
            [21, -42],
            [20, -61],
            [35, -37],
            [51, -13],
            [37, -24],
            [23, -35],
            [19, -11],
            [23, 19],
            [24, 9],
            [24, -11],
            [32, -29],
            [48, 6],
            [62, 42],
            [37, -2],
            [11, -46],
            [27, -48],
            [45, -52]
        ],
        [
            [30060, 71619],
            [7, -16],
            [4, -82],
            [-13, -51],
            [0, -18],
            [9, -28],
            [33, -64],
            [3, -25],
            [13, -25],
            [11, -37],
            [36, -79],
            [54, -65],
            [43, -17]
        ],
        [
            [30260, 71112],
            [-117, -135],
            [-53, -49],
            [-51, -40],
            [-16, -50],
            [-31, -38],
            [-19, -41],
            [-46, -34],
            [-33, -46],
            [-82, -46],
            [-46, -15],
            [-32, -27]
        ],
        [
            [29734, 70591],
            [-19, -10],
            [-214, 11],
            [-215, 11],
            [-214, 11],
            [-214, 10],
            [-206, -5],
            [-205, -6],
            [-9, 17],
            [-71, 10],
            [13, -57],
            [-1, -51],
            [-208, 0],
            [-222, 1]
        ],
        [[27949, 70533], [17, 48], [20, 16], [23, -12], [17, 17], [14, 51], [8, 53], [3, 56], [-10, 45]],
        [[27938, 70534], [-22, -1]],
        [[27916, 70533], [3, 29], [9, 1], [10, -29]],
        [
            [27425, 68590],
            [2, -27],
            [14, -17],
            [1, -29],
            [-13, -43],
            [0, -29],
            [14, -17],
            [-1, -17],
            [-15, -19],
            [-2, -20],
            [10, -22],
            [5, -25],
            [-1, -28],
            [14, -37],
            [21, -24],
            [14, -28],
            [2, -30],
            [-3, -21],
            [-43, -76],
            [-1, -32],
            [-20, -42],
            [-40, -48],
            [-27, -62],
            [-13, -74],
            [-14, -48],
            [-14, -20],
            [-7, -39],
            [0, -58],
            [-9, -32],
            [-19, -6],
            [-4, -33],
            [11, -60],
            [-5, -25],
            [-12, -20],
            [-2, -15],
            [74, 0],
            [149, 0],
            [222, -1],
            [148, 0],
            [-9, -64],
            [-21, -86],
            [-1, -23],
            [5, -44],
            [8, -24],
            [18, -23],
            [16, -36],
            [14, -63],
            [3, -30],
            [12, -40],
            [22, -17]
        ],
        [
            [27928, 67016],
            [-21, -15],
            [-113, 57],
            [-28, 46],
            [-25, 10],
            [-31, 6],
            [-33, -57],
            [-25, -77],
            [40, -41],
            [34, -21],
            [56, 17],
            [30, 37],
            [26, -1],
            [12, 8],
            [11, 19],
            [21, -15],
            [1, -15],
            [-15, -22],
            [-19, -18],
            [-12, -22],
            [22, -43],
            [34, -14],
            [13, 6],
            [9, 48],
            [21, 32],
            [29, -7],
            [-4, -20],
            [17, -50],
            [-2, -45],
            [3, -11],
            [-31, -20],
            [-23, -7],
            [-19, -26],
            [10, -15],
            [-19, -13],
            [-13, 5],
            [-18, -36],
            [14, -45],
            [29, -29],
            [21, -37],
            [83, -49],
            [20, 2],
            [19, -49],
            [32, -25],
            [-2, -34],
            [-27, -24],
            [-15, -46],
            [-24, 36],
            [-30, -46],
            [-14, -10],
            [7, 50],
            [-11, 19],
            [-16, 50],
            [-25, 31],
            [-17, 10],
            [-13, 19],
            [-16, 8],
            [-14, -2],
            [-23, 11],
            [-2, 27],
            [-6, 20],
            [-18, 23],
            [-87, 44],
            [5, -32],
            [28, -27],
            [-1, -53],
            [-6, -22],
            [-9, -64],
            [-10, -25],
            [-24, -18],
            [-10, 15],
            [-17, 69],
            [-24, 22],
            [-38, 3],
            [-26, -16],
            [-28, -67],
            [-23, -11],
            [-78, 35],
            [-88, 53],
            [2, 18],
            [14, 5],
            [27, -7],
            [-2, 18],
            [-27, 60],
            [-5, 27],
            [3, 32],
            [-9, 0],
            [-16, -28],
            [-57, 23],
            [-15, 28],
            [-33, 79],
            [-47, 2],
            [-22, 48],
            [-38, -20],
            [-19, -22],
            [-17, -34],
            [23, -46],
            [-8, -14],
            [-54, -20],
            [-127, 23],
            [-37, 21],
            [-50, 44],
            [-68, 36],
            [-34, 6],
            [-32, -7],
            [-95, -4],
            [-22, -10],
            [-18, -15],
            [-12, 17],
            [-6, 30],
            [11, 5],
            [12, 18],
            [11, 35],
            [1, 22],
            [-7, 14]
        ],
        [
            [26609, 66896],
            [20, 55],
            [5, 20],
            [-3, 95],
            [-9, 34],
            [1, 20],
            [10, 52],
            [-2, 48],
            [17, 57],
            [13, 30],
            [14, 61],
            [3, 39],
            [6, 30],
            [-4, 32],
            [10, 23],
            [-6, 32],
            [-2, 42],
            [-13, 17],
            [-21, 63],
            [1, 27],
            [-22, 59],
            [-1, 20],
            [-21, 31],
            [-5, 20],
            [-1, 81],
            [-6, 24],
            [-19, 47],
            [-42, 68],
            [0, 353],
            [0, 212]
        ],
        [[27226, 66630], [-11, -8], [-51, 48], [-4, 21], [26, 19], [15, -2], [33, -31], [2, -26], [-10, -21]],
        [[28142, 66801], [-9, -18], [9, 85], [4, 3], [-4, -70]],
        [[28019, 66955], [1, -26], [-15, 13], [-22, 1], [20, 27], [20, 9], [-4, -24]],
        [[32879, 73630], [-9, 14], [40, 187], [39, 188]],
        [[32949, 74019], [243, -13]],
        [[33192, 74006], [131, -5], [220, -10], [27, 15], [31, 44], [20, 9], [31, 26], [16, 6], [36, -3]],
        [
            [33704, 74088],
            [-7, -29],
            [15, -58],
            [14, -29],
            [34, 2],
            [4, -27],
            [-15, -4],
            [-28, -26],
            [-25, -10],
            [-30, -67],
            [-36, -56],
            [15, -18],
            [56, -19],
            [24, -20],
            [37, -105],
            [-12, -30],
            [34, -27],
            [10, -76],
            [27, -25],
            [41, -16],
            [49, 23],
            [42, 31],
            [-2, 26],
            [-26, 60],
            [-6, 28],
            [-19, 18],
            [-8, -15],
            [-12, 20],
            [10, 16],
            [29, -12],
            [41, -65],
            [11, -86],
            [2, -54],
            [-4, -19],
            [-34, 0],
            [-107, -28],
            [-24, -25],
            [-54, -27],
            [1, 42],
            [-4, 57],
            [-10, 2],
            [-85, -93],
            [-32, -5],
            [-28, -28],
            [-6, 16],
            [-5, 69],
            [17, 58],
            [-9, -1],
            [-17, -20]
        ],
        [[33572, 73436], [-10, 24], [-23, 26], [1, 53], [-13, 6], [-2, 64], [-128, -3]],
        [[33960, 73190], [-24, -9], [-55, 20], [45, 18], [8, 6], [6, 38], [17, -55], [3, -18]],
        [[33796, 73251], [-85, -27], [-14, 18], [21, 8], [27, 42], [18, 5], [28, -24], [5, -22]],
        [[31755, 71895], [-21, 14], [-35, 47], [-55, 33], [-8, 17], [9, 44], [-17, 25], [-42, 24], [-18, 21]],
        [
            [31568, 72120],
            [-6, 30],
            [-16, 34],
            [6, 15],
            [-6, 16],
            [-17, 17],
            [-9, 35],
            [-23, -1],
            [-22, 12],
            [-21, 26],
            [-26, 5],
            [-45, -26],
            [-25, -6],
            [-11, -15],
            [-5, -25],
            [-11, -13],
            [-25, 0],
            [-31, 9],
            [-20, 16],
            [-2, 20],
            [-15, -1],
            [-6, -24],
            [-48, -65],
            [-32, 13],
            [-68, -92],
            [-20, -14],
            [-40, -42],
            [4, 285]
        ],
        [[31028, 72329], [142, 0], [143, 0], [213, 0], [214, 0], [214, 0], [213, 0]],
        [
            [32398, 71623],
            [-4, -41],
            [-12, 24],
            [-14, -23],
            [-2, -48],
            [-6, -24],
            [-20, -7],
            [-20, -63],
            [-19, -36],
            [-7, -22]
        ],
        [[32294, 71383], [-76, -15], [-12, -25]],
        [
            [32206, 71343],
            [-23, 11],
            [-36, -1],
            [7, 34],
            [10, 30],
            [-18, 30],
            [-23, 16],
            [14, 25],
            [6, 27],
            [-8, 52],
            [-24, -36],
            [-6, 23],
            [-20, -29],
            [-49, 45],
            [-17, 42],
            [-9, 33],
            [10, 58],
            [20, 11],
            [26, -10],
            [17, 11],
            [-36, 48],
            [-12, 29],
            [-20, 8],
            [-9, -28],
            [-10, -7],
            [12, 60],
            [17, 3],
            [24, 16],
            [-7, 35],
            [-15, 16],
            [-28, -20],
            [6, 57],
            [20, 0],
            [19, -11],
            [15, 51],
            [1, 23],
            [-26, -33],
            [-6, 71],
            [26, 69],
            [24, 30],
            [30, -1],
            [12, 18],
            [-20, 7],
            [15, 27],
            [13, 5],
            [12, 23],
            [-30, -3],
            [4, 45],
            [-32, -14],
            [-7, -19],
            [1, -31],
            [-5, -21],
            [-14, -17],
            [-23, -13],
            [-18, -32],
            [-17, 46],
            [-9, -45],
            [-14, -11],
            [1, -29],
            [-6, -15],
            [-46, 25],
            [-1, -9],
            [26, -53],
            [19, -18],
            [2, -29],
            [-16, -25],
            [-23, 21],
            [17, -68],
            [-8, -26],
            [-1, -62],
            [-5, -25],
            [11, -117],
            [27, -63],
            [6, -28],
            [-13, -5],
            [-42, 42],
            [-23, 57],
            [-6, 0],
            [8, -47],
            [72, -104],
            [23, -71],
            [-2, -30],
            [-19, 22],
            [-16, 27],
            [-43, 30],
            [-54, 19],
            [-31, 71],
            [0, -29],
            [-7, -25],
            [-30, 56],
            [-4, 29],
            [-23, -2],
            [-25, -25],
            [-23, 6],
            [-3, 49],
            [6, 25],
            [27, 61],
            [25, 31],
            [11, 40],
            [-4, 63]
        ],
        [[32340, 71391], [-8, -1]],
        [[32332, 71390], [8, 19], [27, 94], [1, -33], [-28, -79]],
        [
            [34840, 75366],
            [-1, -17],
            [8, -28],
            [7, -55],
            [-10, -25],
            [2, -33],
            [29, -10],
            [8, -22],
            [-63, -85],
            [-53, 12],
            [-29, -23],
            [-31, -6],
            [-13, -38],
            [-17, -8],
            [-22, 2],
            [-20, 11],
            [-15, -5],
            [-21, -69],
            [-17, 6],
            [-7, -24],
            [-22, -20],
            [-19, 59],
            [-25, 14],
            [-24, -5],
            [-30, -35],
            [-24, 35],
            [-22, -71],
            [3, -42],
            [-6, -25],
            [-12, 6],
            [-13, 22],
            [-34, 18],
            [-27, -1],
            [5, 23],
            [26, 34],
            [-26, 7],
            [9, 31],
            [-11, 22],
            [-14, -36],
            [-35, -29],
            [1, -48],
            [-33, -98],
            [-1, -41],
            [-22, -34],
            [-27, -28],
            [-37, 8],
            [-28, -25],
            [-14, -29],
            [-12, -4],
            [-11, 48],
            [-10, -54],
            [-11, -3],
            [-9, 63],
            [-14, -22],
            [-10, -57],
            [-22, 8],
            [3, -34],
            [-5, -19],
            [-20, 27],
            [-31, -18],
            [3, 38],
            [-30, -12],
            [-36, -38],
            [-28, -53],
            [20, -25],
            [-48, -82],
            [-50, -73],
            [-37, -119],
            [-15, -14],
            [-13, -22]
        ],
        [[33727, 74196], [-25, 52], [-5, 42], [-28, 50], [-11, 34], [-4, 38], [2, 41], [-12, 309], [-12, 309], [-14, 365]],
        [[34632, 75693], [-19, -9], [26, -38], [47, -38], [35, -8], [19, 11]],
        [[34378, 74824], [-12, -11], [-12, 3], [-1, 28], [15, 5], [10, -25]],
        [
            [34513, 74900],
            [-18, -11],
            [-20, 5],
            [-2, -40],
            [-30, 24],
            [1, 39],
            [19, 37],
            [15, 15],
            [19, -10],
            [14, -42],
            [2, -17]
        ],
        [
            [30050, 73910],
            [5, 21],
            [-1, 37],
            [-17, 20],
            [-31, -18],
            [-5, -15],
            [2, -27],
            [-14, -12],
            [-9, -27],
            [-4, -43],
            [-13, -37],
            [-28, -16],
            [-27, -34],
            [-11, -33],
            [-11, -45],
            [-4, -35],
            [4, -20],
            [-24, -35],
            [-2, -22],
            [-17, -13],
            [-14, -24],
            [-29, -75]
        ],
        [[29800, 73457], [-3, -3], [-205, -11], [-206, -10]],
        [
            [28748, 73466],
            [20, 15],
            [33, 36],
            [18, 33],
            [18, 42],
            [17, 53],
            [35, 79],
            [17, 48],
            [16, 60],
            [12, 63],
            [9, 67],
            [3, 68],
            [0, 71],
            [-8, 72],
            [-25, 109],
            [-33, 102],
            [-33, 128],
            [1, 11],
            [30, 77],
            [-2, 72],
            [-7, 31],
            [-15, 42],
            [0, 10],
            [32, 54],
            [20, 40],
            [17, 50],
            [11, 57],
            [6, 66],
            [-1, 43],
            [-5, 22],
            [7, 29],
            [35, 15],
            [11, 26],
            [3, 46],
            [7, 22],
            [22, 9],
            [10, 19],
            [13, 6],
            [16, -9],
            [23, 29],
            [29, 64],
            [23, 36],
            [9, -17],
            [0, -44],
            [-10, -53],
            [4, -10],
            [-12, -49],
            [-1, -25],
            [17, -12],
            [14, 49],
            [-3, 15],
            [14, 37],
            [7, -15],
            [-2, -26],
            [-17, -60],
            [20, 14],
            [30, 107],
            [2, 26],
            [-4, 65],
            [6, 45],
            [17, 21],
            [30, 23],
            [30, 13],
            [29, 1],
            [20, 7],
            [8, 20],
            [-20, 6],
            [-15, 15],
            [-10, 22],
            [-3, 26],
            [3, 29],
            [12, 29],
            [22, 28],
            [8, 38],
            [26, -4],
            [19, 4],
            [10, 11],
            [25, -12],
            [40, -34],
            [37, -20],
            [36, -6],
            [26, -12],
            [16, -18],
            [19, -44],
            [17, -13],
            [27, -3],
            [21, -10],
            [15, -17],
            [85, -43],
            [36, -22],
            [25, -37],
            [0, -29],
            [24, -46],
            [8, -55],
            [-26, 15],
            [-15, -4],
            [-7, -19],
            [4, -36],
            [33, -51],
            [9, -47],
            [2, -57],
            [-8, -70],
            [-4, -102],
            [-11, -25],
            [-29, -36],
            [-16, 3],
            [-11, -31],
            [-9, -56],
            [-11, -31],
            [-13, -5],
            [-11, -20],
            [-40, -11],
            [-18, -18],
            [-13, -48],
            [0, -23],
            [-6, -29],
            [1, -25],
            [7, -21],
            [21, -20],
            [34, -21],
            [21, -3],
            [15, 9],
            [15, 33],
            [14, 14],
            [18, 5],
            [35, 83],
            [5, 28],
            [22, 24],
            [18, 12],
            [43, 17],
            [23, 20],
            [15, 4],
            [21, -11],
            [28, -25],
            [22, -36],
            [16, -47],
            [21, -123],
            [25, -197],
            [17, -111],
            [13, -36]
        ],
        [[29022, 75329], [-19, 0], [-7, 25], [19, 2], [7, -27]],
        [[29153, 75608], [-19, 4], [1, 26], [11, 45], [11, 21], [11, -14], [3, -49], [-5, -21], [-13, -12]],
        [[29460, 75729], [39, -7], [15, -11], [-3, -23], [-15, -7], [-15, 11], [-23, 28], [2, 9]],
        [
            [29785, 75837],
            [-4, -31],
            [-22, -9],
            [-44, 1],
            [-29, 7],
            [-13, 13],
            [28, 18],
            [29, 25],
            [-1, 28],
            [24, -6],
            [24, -40],
            [8, -6]
        ],
        [[29594, 75967], [-19, 18], [5, 25], [15, -22], [-1, -21]],
        [[29591, 76031], [-18, -1], [-14, 47], [-12, 24], [18, 27], [23, -3], [1, -15], [-8, -26], [0, -26], [10, -27]],
        [
            [28519, 75332],
            [-15, 8],
            [-20, 44],
            [-1, 23],
            [18, 57],
            [-10, 21],
            [-22, -10],
            [-30, 2],
            [-3, 25],
            [18, 52],
            [0, 32],
            [6, 18],
            [-4, 50],
            [-9, 18],
            [-26, 24],
            [-60, 31],
            [6, 35],
            [-2, 15],
            [-15, 22],
            [-62, 26],
            [-43, 12],
            [-42, 0],
            [-30, 10],
            [-34, 3],
            [-87, 63],
            [-193, 67],
            [-116, 40],
            [-34, 94],
            [-27, 15],
            [-7, 12],
            [-16, -5],
            [-5, 24]
        ],
        [
            [27654, 76160],
            [20, 5],
            [58, 29],
            [50, 36],
            [41, 41],
            [51, 26],
            [61, 9],
            [44, 15],
            [26, 20],
            [36, 40],
            [20, 11],
            [25, 4],
            [18, 15],
            [13, 27],
            [24, 30],
            [35, 35],
            [20, 13],
            [6, -36],
            [9, -14],
            [18, -11],
            [9, -15],
            [3, -33],
            [12, -13],
            [3, -28],
            [-6, -70],
            [8, -20],
            [16, 22],
            [5, 19],
            [51, 43],
            [27, -9],
            [78, -15],
            [31, -11],
            [43, -35],
            [39, -79],
            [18, -32],
            [18, -21],
            [11, -36],
            [58, -6],
            [26, 5],
            [16, 11],
            [18, -7],
            [19, -26],
            [20, -7],
            [18, 11],
            [18, 0],
            [30, -21],
            [33, 40],
            [39, 35],
            [53, 38],
            [31, 17],
            [8, -4],
            [49, 13],
            [44, 1],
            [58, -8],
            [54, 9],
            [49, 26],
            [44, 14],
            [39, 3],
            [14, -7],
            [-9, -17],
            [-5, -30],
            [-1, -42],
            [-9, -38],
            [3, -21],
            [38, -6],
            [19, -14],
            [22, 0],
            [25, 12],
            [20, -5],
            [13, -21],
            [20, -4],
            [32, 30],
            [20, 8],
            [10, -8],
            [30, -70],
            [8, -46],
            [0, -20],
            [-14, -24],
            [7, -11],
            [36, -3],
            [23, -23],
            [-2, -27],
            [9, -15],
            [36, -34],
            [-10, -19],
            [-16, -3],
            [-111, 21],
            [-33, 4],
            [-23, -7],
            [-9, 20],
            [-25, 13],
            [-14, -11],
            [-15, -42],
            [-1, -54],
            [-23, 7],
            [-52, 64],
            [-40, 32],
            [-49, 24],
            [-39, 11],
            [-29, -1],
            [-23, -16],
            [-19, -32],
            [-28, -18],
            [-39, -5],
            [-39, -22],
            [-25, 13],
            [-26, 3],
            [-26, -5],
            [-19, -13],
            [-21, -39],
            [-4, -20],
            [-15, -17],
            [-39, -26],
            [-23, -40],
            [-14, -32],
            [-13, 18],
            [-1, 25],
            [13, 31],
            [28, 27],
            [-1, 43],
            [-44, -19],
            [-15, 6],
            [-14, -15],
            [-12, -38],
            [-14, -24],
            [-17, -12],
            [-11, 13],
            [-6, 37],
            [0, 29],
            [-14, 2],
            [-14, -64],
            [-9, -21],
            [-13, -9],
            [-19, -39],
            [-26, -68],
            [-30, -67],
            [-34, -64],
            [-29, -52],
            [-1, -27]
        ],
        [
            [28329, 76504],
            [-5, -28],
            [-37, -48],
            [-14, -30],
            [-11, -5],
            [-10, 37],
            [11, 25],
            [-43, 12],
            [-13, 17],
            [2, 24],
            [15, 31],
            [51, 65],
            [23, 18],
            [65, 28],
            [36, 7],
            [36, 0],
            [26, -9],
            [16, -19],
            [-15, -13],
            [-71, -10],
            [14, -21],
            [-13, -19],
            [-63, -62]
        ],
        [
            [28102, 76903],
            [-4, -25],
            [-35, -17],
            [-23, -5],
            [-13, 17],
            [9, 17],
            [-7, 15],
            [14, 13],
            [121, 84],
            [51, 31],
            [32, 5],
            [-29, -32],
            [-14, -38],
            [-88, -59],
            [-14, -6]
        ],
        [
            [27910, 76946],
            [-17, -5],
            [-27, -26],
            [-33, -26],
            [-53, -33],
            [-61, -30],
            [-124, -56],
            [-77, -57],
            [-34, -34],
            [-132, -172],
            [-80, -92],
            [-130, -129],
            [-12, -16],
            [-1, -15]
        ],
        [
            [27129, 76255],
            [-5, 0],
            [-31, -51],
            [-21, -6],
            [0, -322],
            [-23, -26],
            [-18, -5],
            [-83, -66],
            [-13, -19],
            [-15, -45],
            [-28, -49],
            [-6, -27],
            [1, -36],
            [42, -28],
            [15, -28],
            [8, -34],
            [-1, -29],
            [-21, -57],
            [-4, -23],
            [2, -70],
            [-10, -22],
            [9, -77],
            [-7, -62],
            [-4, -18],
            [9, -36],
            [39, -45],
            [33, -25],
            [29, -8],
            [23, -19],
            [17, -30],
            [22, -20],
            [29, -9],
            [28, -26],
            [44, -62],
            [23, -52],
            [38, -38],
            [62, -40],
            [41, -36],
            [19, -30],
            [13, -78],
            [10, -164]
        ],
        [
            [25788, 74436],
            [0, 376],
            [0, 250],
            [0, 376],
            [-24, 41],
            [-51, 34],
            [-13, 20],
            [-33, 71],
            [-2, 17],
            [12, 18],
            [46, 54],
            [15, 25],
            [18, 80]
        ],
        [
            [25756, 75798],
            [-4, 42],
            [3, 67],
            [-18, 105],
            [-35, 81],
            [-8, 66],
            [-9, 32],
            [-3, 83],
            [8, 68],
            [-15, 31],
            [-2, 25],
            [-7, 197],
            [-5, 28],
            [2, 92],
            [-27, 97],
            [-13, 32],
            [-6, 59],
            [-22, 66],
            [-15, 72],
            [2, 63],
            [-5, 48],
            [2, 36],
            [-4, 56],
            [4, 31],
            [1, 49],
            [-31, 174]
        ],
        [[26354, 70533], [0, 279]],
        [[26129, 72485], [-27, 53], [-9, 56], [-17, 38], [-27, 17], [-17, 37], [-7, 58], [-17, 58], [-8, 18]],
        [[27949, 70533], [-11, 1]],
        [
            [27916, 70533],
            [6, -41],
            [-5, -30],
            [-15, -12],
            [-2, -17],
            [8, -19],
            [-3, -16],
            [-18, -6],
            [-7, -15],
            [13, -30],
            [-3, -35],
            [-17, -41],
            [-2, -16]
        ],
        [[28274, 67115], [-91, -9], [-39, 29], [-26, 5], [-46, -26], [-53, -20], [-30, 7], [-37, -68], [-24, -17]],
        [[27689, 69697], [161, -1], [164, 0], [164, 0], [166, 0]],
        [[28225, 67029], [-4, -7], [-44, 23], [-3, 11], [46, -20], [5, -7]],
        [[23448, 77498], [1, -212], [1, -212], [1, -319], [1, -319], [2, -319], [1, -319]],
        [[23455, 75798], [1, -130], [0, -259], [1, -137], [-10, 1]],
        [
            [23447, 75273],
            [-135, 0],
            [-136, 0],
            [-135, 0],
            [-135, -1],
            [-136, 0],
            [-135, 0],
            [-203, 0],
            [-135, 0],
            [-203, 0],
            [-203, 0],
            [-135, 0],
            [-136, 0],
            [-203, 0],
            [-135, 0],
            [0, -280]
        ],
        [
            [29532, 69689],
            [11, 119],
            [8, 27],
            [9, 6],
            [32, 1],
            [21, 14],
            [18, 71],
            [40, 56],
            [19, 14],
            [27, 11],
            [66, 14],
            [70, 54],
            [50, 52],
            [40, 14],
            [13, 19],
            [19, 66],
            [23, -3],
            [18, 30],
            [17, 16],
            [27, 10],
            [11, -42],
            [17, 5],
            [47, 66],
            [23, 19],
            [35, 11],
            [25, -26],
            [15, 9],
            [44, 103],
            [31, 25],
            [23, 2],
            [0, 28],
            [8, 42],
            [1, 29],
            [14, 43]
        ],
        [
            [30354, 70594],
            [6, -8],
            [111, -2],
            [224, -3],
            [223, -3],
            [112, -2],
            [223, -3],
            [112, -2],
            [223, -3],
            [223, -3],
            [112, -1],
            [188, -3]
        ],
        [
            [32111, 70561],
            [-8, -43],
            [5, -25],
            [16, -26],
            [18, -64],
            [15, -86],
            [-20, 35],
            [-21, 18],
            [-32, 14],
            [-29, 25],
            [3, -35],
            [-3, -39],
            [-37, 25],
            [13, -42],
            [-29, 13],
            [-19, -3],
            [-13, -36],
            [-17, -23],
            [-25, -7],
            [-37, 34],
            [-11, 40],
            [-7, -8],
            [6, -56],
            [-2, -42],
            [35, -8],
            [34, 7],
            [44, -2],
            [30, 8],
            [17, 14],
            [43, -12],
            [3, -51],
            [-5, -51],
            [-3, -54],
            [12, 0],
            [14, 18],
            [7, 97],
            [38, 35],
            [13, -2],
            [12, -31],
            [9, -75],
            [-9, -66],
            [-59, -77],
            [-43, -72],
            [-22, -14],
            [-31, 8],
            [-35, 18],
            [-18, 3],
            [-13, -6],
            [-8, 22],
            [-5, 41],
            [-14, 13],
            [-11, -2],
            [-7, -42],
            [-33, -12],
            [-45, 17],
            [-47, 36],
            [20, -38],
            [117, -72],
            [26, -33],
            [-17, -31],
            [-12, -35],
            [-7, -44],
            [-46, -46],
            [-26, 8],
            [-64, 83],
            [29, -72],
            [24, -30],
            [47, -17],
            [89, 27],
            [29, -29],
            [-24, -52],
            [-23, -37],
            [-32, -4],
            [-27, -10],
            [-8, -25],
            [-98, -6],
            [-26, 6],
            [-36, -51],
            [-14, -7],
            [-19, 9],
            [-8, 42],
            [-9, 20],
            [0, -77],
            [10, -37],
            [-42, -42],
            [-41, -52],
            [-15, -14],
            [-16, -27],
            [-34, -75],
            [-9, -55],
            [-14, -34],
            [3, 46],
            [-9, 54],
            [-5, -98],
            [-13, -46],
            [-122, 4],
            [-48, -23]
        ],
        [
            [31310, 69070],
            [-128, 195],
            [-125, 191],
            [-84, 127],
            [-87, 4],
            [-174, 9],
            [-88, 5],
            [-2, 74],
            [-44, 85],
            [-34, -27],
            [-1, 36],
            [-12, 14],
            [-196, 13],
            [-196, 13],
            [-11, 5],
            [-22, -19],
            [-58, -27],
            [-29, -25],
            [-10, 1],
            [-98, -47],
            [-6, 0]
        ],
        [[31946, 69497], [20, 63], [56, 89], [-76, -152]],
        [
            [32242, 69830],
            [-42, -15],
            [-3, 5],
            [47, 31],
            [15, 112],
            [2, 52],
            [-7, 91],
            [8, -10],
            [7, -85],
            [-3, -65],
            [-14, -94],
            [-10, -22]
        ],
        [[32213, 70173], [-4, -11], [-21, 62], [21, -20], [4, -31]],
        [[32135, 70561], [10, 0]],
        [[32145, 70561], [31, -179], [61, -196], [-6, -4], [-46, 130], [-25, 93], [-25, 156]],
        [
            [25756, 75798],
            [-144, 0],
            [-144, 0],
            [-143, 0],
            [-144, 0],
            [-144, 0],
            [-144, 0],
            [-144, 0],
            [-215, 0],
            [-144, 0],
            [-216, 0],
            [-144, 0],
            [-144, 0],
            [-143, 0],
            [-144, 0],
            [-144, 0]
        ],
        [[23452, 73042], [-1, 139], [0, 279], [-1, 279], [0, 279], [0, 140]],
        [
            [23450, 74158],
            [213, -1],
            [214, 0],
            [214, 0],
            [213, 0],
            [214, 0],
            [214, 0],
            [213, 0],
            [229, 0],
            [92, -83],
            [55, -26],
            [26, 25],
            [57, 14],
            [86, 3],
            [55, -11],
            [23, -26],
            [45, -30],
            [66, -33],
            [40, -35],
            [13, -39],
            [24, -24],
            [23, -8]
        ],
        [[33727, 74196], [-14, -72], [-9, -36]],
        [
            [33192, 74006],
            [-6, 20],
            [-17, 36],
            [-3, 32],
            [9, 44],
            [14, 40],
            [11, 104],
            [10, 60],
            [7, 110],
            [27, 103],
            [23, 43],
            [15, 52],
            [18, 45],
            [3, 27],
            [13, 57],
            [10, 103],
            [9, 16],
            [42, 14],
            [57, 53],
            [22, 36],
            [13, 52],
            [-15, 67],
            [-1, 25],
            [34, 76],
            [-7, 44],
            [5, 11]
        ],
        [[32677, 72306], [-36, -84], [-1, 16], [45, 105], [-8, -37]],
        [
            [32387, 72475],
            [51, 53],
            [54, 42],
            [-75, 140],
            [-18, 8],
            [-19, 69],
            [-29, 29],
            [-1, 53],
            [6, 47],
            [19, 15],
            [11, 30],
            [1, 16],
            [-15, 49],
            [0, 15],
            [28, 29],
            [37, 58],
            [22, 63],
            [19, 32],
            [25, 18]
        ],
        [[32503, 73241], [152, -128], [91, -76]],
        [
            [32746, 73037],
            [-5, -43],
            [-30, -88],
            [-29, -39],
            [-11, -8],
            [-23, -36],
            [-11, -44],
            [7, -41],
            [59, -14],
            [16, 12],
            [8, -29],
            [4, -40],
            [-4, -43],
            [-10, -44],
            [-7, -55],
            [-12, -45],
            [-16, -30],
            [-18, -118],
            [-25, -63],
            [-23, -44],
            [-23, 7],
            [5, -34],
            [-6, -18],
            [-6, -38],
            [-14, -25],
            [-13, 3],
            [-27, -30],
            [0, -26],
            [-13, -22],
            [-46, -115],
            [-40, -33],
            [-9, 5],
            [10, 54],
            [7, 55],
            [-24, 23],
            [-23, 13],
            [-26, -2],
            [-30, 43],
            [-37, 31],
            [-53, 84],
            [0, 62],
            [16, 62],
            [15, 43],
            [22, 22],
            [61, 23],
            [25, 63]
        ],
        [[23767, 70812], [0, -279]],
        [
            [23767, 70533],
            [-13, 0],
            [-1, -314],
            [0, -156],
            [-1, -314],
            [-1, -313],
            [-1, -314],
            [-1, -313],
            [-1, -314],
            [-1, -313],
            [0, -157],
            [-139, 0],
            [-139, 0],
            [-138, 0],
            [-139, 0],
            [-139, -1],
            [-139, 0],
            [-139, 0],
            [-140, 0],
            [31, -101],
            [38, -29]
        ],
        [[22704, 67894], [-3, 1], [-135, 2], [-136, 1], [-136, 1], [-136, 1], [0, -250], [-109, -1], [-149, 0]],
        [[18520, 73599], [230, 0], [230, 0], [230, 0], [231, 0]],
        [
            [20359, 73600],
            [0, -174],
            [0, -262],
            [0, -261],
            [0, -261],
            [0, -174],
            [0, -348],
            [0, -175],
            [0, -261],
            [0, -261],
            [0, -261],
            [0, -348]
        ],
        [
            [32918, 75275],
            [3, -37],
            [-7, -44],
            [5, -47],
            [-7, -100],
            [19, -76],
            [-4, -52],
            [1, -55],
            [-19, -45],
            [-8, -31],
            [-5, -52],
            [13, -91],
            [2, -63],
            [-12, -75],
            [7, -28],
            [13, 24],
            [14, -3],
            [18, -35],
            [-3, -160],
            [-3, -224],
            [-4, -28],
            [8, -34]
        ],
        [
            [32832, 73037],
            [-45, -63],
            [-23, -26],
            [-18, -9],
            [-12, 13],
            [13, 41],
            [11, 79],
            [-3, 65],
            [-27, 44],
            [16, -64],
            [2, -80]
        ],
        [
            [32503, 73241],
            [-18, 37],
            [-55, 28],
            [-27, 44],
            [-9, 31],
            [-5, 58],
            [4, 29],
            [-13, 19],
            [-8, 30],
            [-36, 22],
            [-11, 30],
            [-24, 29],
            [-127, 0],
            [-128, 1],
            [-213, 0],
            [-255, 0],
            [-170, 0],
            [-171, 0],
            [-170, 1],
            [-127, 0],
            [0, 153]
        ],
        [
            [30940, 73753],
            [77, 64],
            [30, 37],
            [31, 30],
            [32, 25],
            [26, 31],
            [20, 38],
            [21, 29],
            [23, 18],
            [13, 20],
            [-3, 48],
            [-10, 35],
            [-2, 27],
            [8, 20],
            [-3, 21],
            [-48, 20]
        ],
        [
            [31156, 74314],
            [115, 44],
            [72, 15],
            [87, 4],
            [104, -21],
            [40, -19],
            [26, -25],
            [29, -6],
            [33, 11],
            [47, 4],
            [59, -4],
            [32, -6],
            [28, 21],
            [59, 26],
            [12, 25],
            [23, 27],
            [33, 30],
            [30, 15],
            [27, 1],
            [18, 8],
            [9, 13],
            [2, 39],
            [-5, 14],
            [-2, 49],
            [-5, 23],
            [-17, 28],
            [1, 11],
            [27, 3],
            [31, 52],
            [-1, 20],
            [-23, -5],
            [6, 29],
            [-13, 21],
            [-26, -21],
            [-22, 33],
            [36, 43],
            [125, 120],
            [17, 34],
            [-7, 18]
        ],
        [[32660, 72776], [-14, -3], [14, 54], [27, 24], [10, -5], [-3, -35], [-18, -25], [-16, -10]],
        [
            [33178, 73034],
            [-22, -36],
            [20, -4],
            [17, 11],
            [16, 21],
            [38, 29],
            [42, 15],
            [15, -20],
            [30, 16],
            [32, 9],
            [-135, -92],
            [-27, -11],
            [-40, -28],
            [-37, -19],
            [-27, -7],
            [-133, -69],
            [-22, 5],
            [-110, -36],
            [-45, -4],
            [-41, -12],
            [31, 29],
            [-7, 19],
            [-16, -3],
            [-17, -29],
            [-26, -10],
            [-6, 32],
            [21, 48],
            [27, 37],
            [37, 24],
            [19, 20],
            [17, 6],
            [21, 22],
            [27, 0],
            [35, 13],
            [29, -11],
            [29, 3],
            [23, 16],
            [24, 5],
            [63, 3],
            [63, 11],
            [25, 20],
            [53, 55],
            [30, 15],
            [-47, -64],
            [-26, -29]
        ],
        [[31197, 74169], [-10, -19], [-16, 8], [0, 27], [8, 7], [22, -6], [-4, -17]],
        [
            [29800, 73457],
            [4, -11],
            [28, -6],
            [19, -12],
            [15, -17],
            [53, -35],
            [16, -21],
            [17, -11],
            [16, -2],
            [25, 23],
            [9, -14],
            [31, -19],
            [-84, -25],
            [4, -20],
            [21, 2],
            [21, 12],
            [46, -6],
            [10, 7],
            [36, -34],
            [28, -1],
            [15, 13],
            [32, 16],
            [50, 20],
            [47, 9],
            [46, -4],
            [30, 5],
            [26, 21],
            [59, 69],
            [67, 55],
            [111, 69],
            [108, 53]
        ],
        [[30706, 73593], [0, -339], [0, -233], [0, -176]],
        [
            [30706, 72845],
            [-36, -25],
            [-7, -22],
            [11, -29],
            [6, -37],
            [1, -45],
            [-21, -100],
            [-42, -154],
            [-21, -96],
            [0, -40],
            [-28, -52],
            [-54, -64],
            [-38, -39],
            [-22, -13],
            [-18, 1],
            [-15, 15],
            [-16, -10],
            [-19, -37],
            [-16, -19],
            [-16, -1],
            [-14, -24],
            [-11, -46],
            [-10, -26],
            [-10, -8],
            [-1, -23],
            [9, -40],
            [-21, -21],
            [-12, -23],
            [-7, 4],
            [-4, 29],
            [-9, 20],
            [-16, 13],
            [-22, -27],
            [-28, -66],
            [-13, -43],
            [5, -29],
            [2, -44],
            [-6, -17],
            [-16, -7],
            [-12, -23],
            [-8, -41],
            [-21, -25],
            [-35, -11],
            [-35, 19]
        ],
        [
            [26396, 68943],
            [-70, 28],
            [-17, 18],
            [-32, 20],
            [-29, 42],
            [-57, 52],
            [-28, 11],
            [-12, -25],
            [-30, -21],
            [-16, 0],
            [-30, 7],
            [-10, 22],
            [-12, 11],
            [-9, -8],
            [-43, -22],
            [-7, -15],
            [-24, -1],
            [-24, 11],
            [-61, -34],
            [-21, -26],
            [-22, -10],
            [-11, -26],
            [-30, 36],
            [-24, 10],
            [-32, 32],
            [-1, 27],
            [-16, 4],
            [-14, -23],
            [-17, -6],
            [-31, 16],
            [-13, 29],
            [-14, 11],
            [-13, -9],
            [-8, -31],
            [-19, -14],
            [1, -16],
            [-11, -44],
            [-7, -8],
            [-16, 12],
            [-9, 29],
            [5, 34],
            [-9, 15],
            [-16, -16],
            [-13, 1],
            [-17, -17],
            [-21, 0],
            [-16, 26],
            [-27, 17],
            [-16, 40],
            [-12, 1],
            [-41, -51],
            [-15, -13],
            [-24, 2],
            [-8, 10],
            [-1, 42],
            [-8, 12],
            [-29, 26],
            [-6, 24],
            [-3, 34],
            [-36, -5],
            [-43, 3],
            [-20, -29],
            [-23, 0],
            [-35, 40],
            [-38, -8],
            [-21, 5],
            [-53, 30],
            [-41, 3],
            [-26, 12],
            [-4, 46],
            [-22, 50],
            [-27, 27],
            [-8, -5],
            [-6, -31],
            [-41, 7],
            [-29, -9],
            [-17, 15],
            [-56, 72],
            [-23, 18],
            [-18, 6],
            [0, 333],
            [0, 267],
            [0, 267],
            [-1, 200],
            [-115, 0],
            [-174, 0],
            [-115, 0],
            [-232, 0],
            [-173, 0],
            [-116, 0]
        ],
        [
            [17215, 73600],
            [-39, 68],
            [-17, 101],
            [-4, 43],
            [5, 113],
            [-12, 48],
            [-29, 79],
            [12, 70],
            [14, 42],
            [33, 183],
            [8, 15],
            [14, 0],
            [24, 31],
            [-11, 7],
            [-17, -15],
            [15, 73],
            [17, 62],
            [11, 22],
            [6, 203],
            [10, 155],
            [16, 52],
            [-6, 52],
            [6, 72],
            [-4, 72],
            [34, 347],
            [-4, 42],
            [10, 57],
            [-10, 148],
            [4, 166],
            [-13, 44],
            [9, 3],
            [15, -24],
            [74, 0],
            [47, 23],
            [17, -8],
            [20, -30],
            [25, -6],
            [31, 5]
        ],
        [
            [17526, 75915],
            [31, 14],
            [24, -10],
            [31, -26],
            [30, -76],
            [30, -127],
            [6, -42],
            [24, -26],
            [27, -2],
            [111, -19],
            [36, 7],
            [63, 48],
            [68, 16],
            [80, -3],
            [49, -14],
            [18, -24],
            [43, -3],
            [102, 28],
            [112, 20],
            [61, 21],
            [68, 42],
            [156, 54],
            [78, 6],
            [39, 20],
            [9, 11],
            [170, 0],
            [163, 0],
            [164, 1],
            [159, 0]
        ],
        [[31028, 72329], [-201, 0], [-121, 0], [0, 194], [0, 322]],
        [[30706, 73593], [57, 29], [80, 59], [97, 72]],
        [[32387, 72475], [-31, -50], [-45, -16], [-31, -28]],
        [
            [33572, 73436],
            [-11, -15],
            [-13, 22],
            [-6, 24],
            [-18, 18],
            [8, -52],
            [-19, -38],
            [-6, -100],
            [-24, -42],
            [-76, -27],
            [-23, 3]
        ],
        [[33570, 73316], [-15, -15], [-18, 2], [9, 21], [3, 30], [9, 33], [15, 19], [-3, -90]],
        [
            [31310, 69070],
            [-5, -2],
            [-81, -83],
            [-24, -37],
            [-68, -141],
            [-17, -90],
            [-14, 38],
            [4, 52],
            [-17, -50],
            [16, -73],
            [-14, -28],
            [-45, -51],
            [-51, -24],
            [-9, -51],
            [-37, -47],
            [-21, -21],
            [-40, 13],
            [12, -45],
            [-14, -35],
            [-25, -26],
            [-31, -17],
            [-18, 2],
            [-16, -9],
            [-11, -22],
            [-30, -20],
            [-30, 11],
            [-34, 7],
            [-19, -12],
            [32, -21],
            [17, -29],
            [-4, -39],
            [-8, -16],
            [-20, -20],
            [-9, 3],
            [-12, 57],
            [-10, -8],
            [-10, -25],
            [-28, 62],
            [1, -47],
            [10, -36],
            [20, -29],
            [2, -17],
            [-20, -41],
            [-28, -16],
            [-10, -25],
            [3, -22]
        ],
        [[23450, 74158], [-1, 139], [0, 279], [-1, 278], [-1, 279], [0, 140]],
        [[29734, 70591], [220, -2], [193, -1], [117, -1], [14, 12], [76, -5]],
        [
            [26609, 66896],
            [-15, 1],
            [-32, -92],
            [18, -51],
            [-1, -19],
            [-65, -11],
            [-146, -103],
            [-57, -56],
            [3, 19],
            [69, 72],
            [-25, 11],
            [-39, -18],
            [-14, 7],
            [17, 60],
            [-6, 53],
            [-28, 1],
            [-18, -42],
            [-12, 2],
            [-16, 18],
            [-13, -6],
            [10, -95],
            [17, -40],
            [15, -50],
            [-40, -62],
            [-37, -51],
            [-5, -49],
            [-37, -64],
            [-118, -123],
            [-24, -18],
            [-37, -40],
            [-52, -30],
            [-49, -47],
            [15, 33],
            [37, 39],
            [-32, -5],
            [-49, 18],
            [-31, 1],
            [0, -14],
            [-23, -20],
            [-24, 30],
            [-15, 37],
            [-20, -4],
            [36, -122],
            [32, -18],
            [-21, -28],
            [-23, -22],
            [-35, -15],
            [-30, 45],
            [-6, -56],
            [-4, -56],
            [-26, -35],
            [-9, 15],
            [-15, 3],
            [-15, -15],
            [-25, -3],
            [-18, -7],
            [4, -47],
            [34, 18],
            [-12, -60],
            [-31, -59],
            [-25, -14],
            [-37, 9],
            [-18, -19],
            [44, -93],
            [-28, -140],
            [-18, -50],
            [-27, -8],
            [-48, 45],
            [-27, 35],
            [23, -95],
            [64, -28],
            [3, -67],
            [-12, -36],
            [-12, -48],
            [9, -33],
            [10, -82],
            [8, -38],
            [10, -115],
            [10, -50],
            [58, -183],
            [20, -2],
            [3, -19],
            [-2, -39],
            [-42, -11],
            [-17, -17],
            [-6, -22],
            [-26, 11],
            [-45, 52],
            [-66, 32],
            [-87, 13],
            [-59, 26],
            [-32, 40],
            [-34, 23],
            [-34, 8],
            [-29, 21],
            [-23, 36],
            [-33, 23],
            [-44, 9],
            [-28, 27],
            [-20, 66],
            [-18, 110],
            [-23, 68],
            [-43, 85],
            [-5, 25],
            [6, 49],
            [-5, 36],
            [-13, 29],
            [-4, 30],
            [8, 32],
            [0, 39],
            [-6, 45],
            [-28, 49],
            [-49, 53],
            [-42, 76],
            [-34, 101],
            [-34, 70],
            [-34, 38],
            [-23, 48],
            [-13, 56],
            [-3, 32],
            [5, 9],
            [-21, 63],
            [-47, 115],
            [-26, 85],
            [-7, 53],
            [-30, 63],
            [-52, 74],
            [-29, 48],
            [-7, 33],
            [-81, 97],
            [-24, 61],
            [-18, 19],
            [-22, -2],
            [-18, 20],
            [-13, -13],
            [-44, -2],
            [-73, 7],
            [-54, 17],
            [-32, 25],
            [-23, -3],
            [-13, -33],
            [-28, -20],
            [-43, -10],
            [-37, -60],
            [-31, -112],
            [-13, -72],
            [4, -31],
            [-9, -24],
            [-20, -14],
            [-20, -33],
            [-21, -50],
            [-24, -24],
            [-27, 1],
            [-51, 39],
            [-75, 76],
            [-58, 47],
            [-42, 18],
            [-38, 35],
            [-32, 52],
            [-30, 35],
            [-27, 18],
            [-32, 58],
            [-37, 98],
            [-18, 76],
            [0, 80],
            [-48, 175],
            [-25, 76],
            [-19, 34],
            [-37, 42],
            [-54, 48],
            [-74, 97],
            [-92, 145],
            [-65, 88],
            [-39, 29],
            [-33, 53],
            [-28, 74],
            [-30, 50]
        ],
        [[25566, 64767], [-4, -26], [-25, 121], [-42, 273], [-2, 156], [7, 54], [11, -220], [46, -280], [9, -78]],
        [[25510, 65403], [-7, 16], [25, 108], [51, 143], [21, 24], [-58, -157], [-32, -134]],
        [[25615, 65738], [11, 63], [24, 58], [13, 8], [6, -24], [-26, -41], [-28, -64]],
        [[25692, 65878], [3, 28], [22, 15], [50, 58], [33, 2], [-40, -34], [-68, -69]],
        [[26224, 66432], [-15, -5], [67, 85], [14, 29], [18, -1], [-30, -48], [-54, -60]],
        [[21282, 73600], [0, -349], [0, -209], [155, 0], [155, 0], [154, 0], [155, 0]],
        [
            [31783, 71865],
            [-5, -64],
            [-14, -31],
            [-22, -24],
            [-30, -43],
            [-7, -39],
            [-9, -74],
            [12, -25],
            [13, -7],
            [37, 17],
            [20, -7],
            [43, -89],
            [81, -35],
            [29, -22],
            [24, -47],
            [36, -27],
            [28, -39],
            [1, -25],
            [-9, -30],
            [-4, -40],
            [-12, -26],
            [-29, -3],
            [-17, 7],
            [-93, 142],
            [-11, 13],
            [-34, 75],
            [-40, 40],
            [-13, -1],
            [57, -74],
            [24, -51],
            [41, -73],
            [30, -31],
            [21, -48],
            [21, -22],
            [55, -32],
            [-19, -23],
            [30, -20],
            [5, -36],
            [-3, -41],
            [-43, 17],
            [-1, -31],
            [4, -17],
            [-19, -15],
            [-26, 20],
            [-68, 109],
            [6, -32],
            [39, -70],
            [36, -42],
            [29, -19],
            [23, -35],
            [8, -22],
            [6, -32],
            [-17, -22],
            [-20, -13],
            [-62, 85],
            [-9, 44],
            [-22, -2],
            [-94, 55],
            [-75, 7],
            [17, -19],
            [60, -14],
            [23, -25],
            [50, -23],
            [29, -6],
            [11, -70],
            [40, -48],
            [5, -36],
            [28, -4],
            [48, 35],
            [31, -12],
            [44, -10],
            [10, -29],
            [8, -53],
            [16, -61],
            [10, -59]
        ],
        [[32135, 70561], [-24, 0]],
        [
            [30260, 71112],
            [-2, -37],
            [10, -23],
            [8, -35],
            [26, -39],
            [24, -16],
            [28, -27],
            [29, -7],
            [25, 27],
            [20, 14],
            [22, 28],
            [38, -39],
            [15, 0],
            [37, 17],
            [35, 5],
            [22, 21],
            [0, 33],
            [16, 13],
            [16, -12],
            [15, 0],
            [66, 38],
            [13, -20],
            [29, 22],
            [17, 20],
            [7, 32],
            [15, 30],
            [-13, 32],
            [12, 41],
            [18, 41],
            [67, 124],
            [21, 75],
            [28, 48],
            [9, 38],
            [21, 38],
            [15, 78],
            [9, 16],
            [13, 3],
            [22, -25],
            [6, -23],
            [34, -21],
            [28, -2],
            [20, 15],
            [11, 27],
            [16, 52],
            [15, 30],
            [19, 65],
            [16, 17],
            [38, -1],
            [19, 23],
            [15, 27],
            [20, 8],
            [34, 43],
            [45, 90],
            [10, 57],
            [12, 41],
            [4, 42],
            [9, 22],
            [150, -171],
            [34, 113]
        ],
        [[32340, 71391], [-33, -84], [-14, -9], [39, 92]],
        [
            [32294, 71383],
            [-68, -220],
            [2, -40],
            [-34, -24],
            [-21, -24],
            [-14, -27],
            [-13, -71],
            [-25, -81],
            [-15, 34],
            [-4, 28],
            [7, 75],
            [27, 124],
            [29, 76],
            [23, 36],
            [18, 74]
        ],
        [
            [17526, 75915],
            [-24, 10],
            [-33, 28],
            [-19, 28],
            [-57, -2],
            [-12, 18],
            [-64, -18],
            [-19, 18],
            [-35, -12],
            [8, 52],
            [-1, 66],
            [10, 17],
            [22, -49],
            [10, 56],
            [7, 70],
            [-21, 28],
            [-35, 20],
            [-13, 65],
            [84, 56],
            [-45, 12],
            [-17, 26],
            [-21, 3],
            [-16, -11],
            [-2, 39],
            [-9, 68],
            [-34, 110],
            [-21, 141],
            [-26, 70],
            [-50, 67],
            [-12, 39],
            [-12, 99],
            [6, 75],
            [-9, 53],
            [24, -3],
            [63, -42],
            [78, -32],
            [24, -24],
            [38, -17],
            [210, -28],
            [14, 3],
            [27, 17],
            [11, -2],
            [31, -39],
            [16, -5],
            [35, 10],
            [25, 26],
            [3, -34],
            [9, -35],
            [19, -45],
            [7, -29],
            [-38, -79],
            [-13, 30],
            [-71, -134],
            [-25, -64],
            [-1, -46],
            [32, 3],
            [34, 26],
            [-45, -4],
            [6, 44],
            [20, 45],
            [22, 27],
            [30, 28],
            [18, 24],
            [12, 34],
            [40, 52],
            [-1, 34],
            [18, 2],
            [7, -58],
            [-4, -26],
            [-29, -32],
            [-4, -11],
            [5, -43],
            [-19, -2],
            [28, -46],
            [8, -37],
            [2, -32],
            [-8, -63],
            [-22, -6],
            [-18, 19],
            [-18, -54],
            [-5, 4],
            [-9, 57],
            [-5, 5],
            [-28, -26],
            [-12, -26],
            [-9, -40],
            [-13, -19],
            [35, -4],
            [32, 8],
            [34, -19],
            [23, 18],
            [7, 13],
            [19, 61],
            [10, 10],
            [28, 10],
            [20, 33],
            [1, 13],
            [-7, 75],
            [2, 42],
            [-13, 27],
            [8, 36],
            [-6, 37],
            [3, 21],
            [20, 43],
            [3, 19],
            [24, 44],
            [-6, 17],
            [-28, 40],
            [-11, -13],
            [-33, 22],
            [-11, 39],
            [3, 16],
            [16, 17],
            [20, 6],
            [-2, 13],
            [-24, 45],
            [-29, 31],
            [-17, 2],
            [-10, 18],
            [13, 18],
            [26, -5],
            [14, 9],
            [-5, 28],
            [0, 64],
            [-10, 52],
            [-5, 8],
            [-28, -7],
            [-21, 49],
            [-21, 78]
        ],
        [[17781, 76607], [-2, -12], [-34, -8], [1, 35], [6, 38], [29, -53]],
        [[17749, 76719], [-19, 2], [-5, 38], [8, 21], [13, -12], [3, -49]],
        [
            [17726, 77032],
            [15, -73],
            [6, 30],
            [42, -53],
            [0, -26],
            [-13, -11],
            [-25, 35],
            [-21, 6],
            [-14, 35],
            [-1, 41],
            [-5, 13],
            [-21, 13],
            [-18, 36],
            [25, 62],
            [12, 19],
            [18, -14],
            [11, -21],
            [-2, -15],
            [-46, -30],
            [29, -23],
            [8, -24]
        ],
        [[17649, 77185], [-21, 2], [-13, 28], [6, 30], [13, 5], [2, -26], [15, -27], [-2, -12]],
        [[17590, 77224], [-25, -7], [-14, 11], [-10, 44], [18, 15], [27, -42], [4, -21]],
        [[17661, 77320], [4, -12], [-21, -14], [-14, 19], [-3, -37], [-29, 18], [3, 29], [24, 18], [36, -21]],
        [
            [27129, 76255],
            [11, -15],
            [26, -21],
            [47, 2],
            [104, 36],
            [44, 24],
            [43, 42],
            [28, -10],
            [56, 48],
            [32, 5],
            [23, -30],
            [-6, -22],
            [-16, -33],
            [-8, -27],
            [0, -23],
            [-7, -24],
            [-17, -32],
            [6, -9],
            [47, 23],
            [10, 25],
            [62, -50],
            [21, -9],
            [19, 5]
        ],
        [
            [28519, 75332],
            [-7, -42],
            [-17, -22],
            [-46, -28],
            [-8, -35],
            [-29, -65],
            [-14, -40],
            [-10, -41],
            [3, -26],
            [16, -11],
            [12, 4],
            [9, 19],
            [35, 33],
            [14, 22],
            [20, 55],
            [22, 31],
            [15, 1],
            [24, 15],
            [18, -5],
            [23, -36],
            [3, -14],
            [-17, -64],
            [-15, -34],
            [-14, -51],
            [-13, -69],
            [-3, -51],
            [8, -35],
            [-7, -32],
            [-22, -27],
            [-17, -37],
            [-12, -46],
            [-8, -38],
            [0, -55],
            [8, -48],
            [-23, -69],
            [-8, -34],
            [-8, -53],
            [-17, -54],
            [-7, -57],
            [7, -79],
            [-4, -34],
            [15, -49],
            [2, -32],
            [16, -49],
            [2, -31],
            [-7, -40],
            [-3, -103]
        ],
        [
            [28708, 75406],
            [-19, -13],
            [2, -25],
            [-3, -39],
            [-17, -19],
            [-20, -47],
            [-3, -35],
            [-29, -48],
            [-11, -5],
            [-20, 21],
            [-5, 22],
            [0, 28],
            [25, 43],
            [12, 28],
            [6, 32],
            [11, 20],
            [17, 9],
            [14, 19],
            [11, 31],
            [12, 13],
            [19, -16],
            [-2, -19]
        ],
        [[28748, 75468], [-26, -3], [-6, 12], [12, 26], [22, -11], [-2, -24]],
        [[27560, 76266], [-12, 17], [41, 32], [9, -9], [-27, -23], [-11, -17]],
        [[27611, 76342], [-10, -3], [-22, 13], [23, 11], [9, -21]]
    ],
    transform: {
        scale: [0.003239769976331682, 0.0017934844634610613],
        translate: [-180, -89.99892578125]
    },
    objects: {
        countries: {
            type: 'GeometryCollection',
            geometries: [
                {
                    arcs: [[0]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ABW',
                        iso_a2: 'AW',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Aruba',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'AW'
                    }
                },
                {
                    arcs: [[1, 2, 3, 4, 5, 6]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'AFG',
                        iso_a2: 'AF',
                        sub_region: 'Southern Asia',
                        continent: 'Asia',
                        name: 'Afghanistan',
                        region_un: 'Asia',
                        region_wb: 'South Asia',
                        postal: 'AF'
                    }
                },
                {
                    arcs: [[[7, 8, 9, 10]], [[11, 12, 13]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'AGO',
                        iso_a2: 'AO',
                        sub_region: 'Middle Africa',
                        continent: 'Africa',
                        name: 'Angola',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'AO'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'AIA',
                        iso_a2: 'AI',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Anguilla',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'AI'
                    }
                },
                {
                    arcs: [[14, 15, 16, 17, 18, 19, 20]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ALB',
                        iso_a2: 'AL',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Albania',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'AL'
                    }
                },
                {
                    arcs: [[21]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ALA',
                        iso_a2: 'AX',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Åland',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'AI'
                    }
                },
                {
                    arcs: [[22, 23]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'AND',
                        iso_a2: 'AD',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Andorra',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'AND'
                    }
                },
                {
                    arcs: [[[24]], [[25]], [[26, 27, 28, 29, 30]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'ARE',
                        iso_a2: 'AE',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'United Arab Emirates',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'AE'
                    }
                },
                {
                    arcs: [[[31]], [[32, 33]], [[34]], [[35, 36, 37, 38, 39, 40]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'ARG',
                        iso_a2: 'AR',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Argentina',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'AR'
                    }
                },
                {
                    arcs: [[41, 42, 43, 44, 45]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ARM',
                        iso_a2: 'AM',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Armenia',
                        region_un: 'Asia',
                        region_wb: 'Europe & Central Asia',
                        postal: 'ARM'
                    }
                },
                {
                    arcs: [[46]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ASM',
                        iso_a2: 'AS',
                        sub_region: 'Polynesia',
                        continent: 'Oceania',
                        name: 'American Samoa',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'AS'
                    }
                },
                {
                    arcs: [
                        [[47]],
                        [[48]],
                        [[49]],
                        [[50]],
                        [[51]],
                        [[52]],
                        [[53]],
                        [[54]],
                        [[55]],
                        [[56]],
                        [[57]],
                        [[58]],
                        [[59]],
                        [[60]],
                        [[61]],
                        [[62]],
                        [[63]],
                        [[64]],
                        [[65]],
                        [[66]],
                        [[67]],
                        [[68]],
                        [[69]],
                        [[70]],
                        [[71]],
                        [[72]],
                        [[73]],
                        [[74]],
                        [[75]],
                        [[76]],
                        [[77]],
                        [[78]],
                        [[79]],
                        [[80]],
                        [[81]],
                        [[82]],
                        [[83]],
                        [[84]],
                        [[85]],
                        [[86]],
                        [[87]],
                        [[88]],
                        [[89]],
                        [[90]],
                        [[91]],
                        [[92]],
                        [[93]],
                        [[94]],
                        [[95]],
                        [[96]],
                        [[97]],
                        [[98]],
                        [[99]],
                        [[100]],
                        [[101]],
                        [[102]],
                        [[103]],
                        [[104]],
                        [[105]],
                        [[106]],
                        [[107]],
                        [[108]],
                        [[109]],
                        [[110]],
                        [[111]],
                        [[112]],
                        [[113]],
                        [[114]],
                        [[115]],
                        [[116]],
                        [[117]],
                        [[118]],
                        [[119]],
                        [[120]],
                        [[121]],
                        [[122]],
                        [[123]],
                        [[124]],
                        [[125]],
                        [[126]],
                        [[127]],
                        [[128]],
                        [[129]],
                        [[130]],
                        [[131]],
                        [[132]],
                        [[133]],
                        [[134]],
                        [[135]],
                        [[136]],
                        [[137]],
                        [[138]],
                        [[139]],
                        [[140]],
                        [[141]],
                        [[142]],
                        [[143]],
                        [[144]],
                        [[145]],
                        [[146]],
                        [[147]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'ATA',
                        iso_a2: 'AQ',
                        sub_region: 'Antarctica',
                        continent: 'Antarctica',
                        name: 'Antarctica',
                        region_un: 'Antarctica',
                        region_wb: 'Antarctica',
                        postal: 'AQ'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: '-99',
                        iso_a2: '-99',
                        sub_region: 'Australia and New Zealand',
                        continent: 'Oceania',
                        name: 'Ashmore and Cartier Is.',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'AU'
                    }
                },
                {
                    arcs: [[[148]], [[149]], [[150]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'ATF',
                        iso_a2: 'TF',
                        sub_region: 'Seven seas (open ocean)',
                        continent: 'Seven seas (open ocean)',
                        name: 'Fr. S. Antarctic Lands',
                        region_un: 'Seven seas (open ocean)',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'TF'
                    }
                },
                {
                    arcs: [[[151]], [[152]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'ATG',
                        iso_a2: 'AG',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Antigua and Barb.',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'AG'
                    }
                },
                {
                    arcs: [
                        [[153]],
                        [[154]],
                        [[155]],
                        [[156]],
                        [[157]],
                        [[158]],
                        [[159]],
                        [[160]],
                        [[161]],
                        [[162]],
                        [[163]],
                        [[164]],
                        [[165]],
                        [[166]],
                        [[167]],
                        [[168]],
                        [[169]],
                        [[170]],
                        [[171]],
                        [[172]],
                        [[173]],
                        [[174]],
                        [[175]],
                        [[176]],
                        [[177]],
                        [[178]],
                        [[179]],
                        [[180]],
                        [[181]],
                        [[182]],
                        [[183]],
                        [[184]],
                        [[185]],
                        [[186]],
                        [[187]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'AUS',
                        iso_a2: 'AU',
                        sub_region: 'Australia and New Zealand',
                        continent: 'Oceania',
                        name: 'Australia',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'AU'
                    }
                },
                {
                    arcs: [[188, 189, 190, 191, 192, 193, 194, 195, 196, 197]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'AUT',
                        iso_a2: 'AT',
                        sub_region: 'Western Europe',
                        continent: 'Europe',
                        name: 'Austria',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'A'
                    }
                },
                {
                    arcs: [[[198, 199, -43]], [[200, 201, -46, 202, 203]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'AZE',
                        iso_a2: 'AZ',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Azerbaijan',
                        region_un: 'Asia',
                        region_wb: 'Europe & Central Asia',
                        postal: 'AZ'
                    }
                },
                {
                    arcs: [[204, 205, 206, 207]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'BDI',
                        iso_a2: 'BI',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Burundi',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'BI'
                    }
                },
                {
                    arcs: [[208, 209, 210, 211, 212, 213, 214, 215]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'BEL',
                        iso_a2: 'BE',
                        sub_region: 'Western Europe',
                        continent: 'Europe',
                        name: 'Belgium',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'B'
                    }
                },
                {
                    arcs: [[216, 217, 218, 219, 220]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'BEN',
                        iso_a2: 'BJ',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Benin',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'BJ'
                    }
                },
                {
                    arcs: [[221, -220, 222, 223, 224, 225]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'BFA',
                        iso_a2: 'BF',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Burkina Faso',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'BF'
                    }
                },
                {
                    arcs: [[[226]], [[227]], [[228]], [[229]], [[230, 231, 232]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'BGD',
                        iso_a2: 'BD',
                        sub_region: 'Southern Asia',
                        continent: 'Asia',
                        name: 'Bangladesh',
                        region_un: 'Asia',
                        region_wb: 'South Asia',
                        postal: 'BD'
                    }
                },
                {
                    arcs: [[233, 234, 235, 236, 237, 238]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'BGR',
                        iso_a2: 'BG',
                        sub_region: 'Eastern Europe',
                        continent: 'Europe',
                        name: 'Bulgaria',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'BG'
                    }
                },
                {
                    arcs: [[239]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'BHR',
                        iso_a2: 'BH',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Bahrain',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'BH'
                    }
                },
                {
                    arcs: [
                        [[240]],
                        [[241]],
                        [[242]],
                        [[243]],
                        [[244]],
                        [[245]],
                        [[246]],
                        [[247]],
                        [[248]],
                        [[249]],
                        [[250]],
                        [[251]],
                        [[252]],
                        [[253]],
                        [[254]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'BHS',
                        iso_a2: 'BS',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Bahamas',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'BS'
                    }
                },
                {
                    arcs: [[255, 256, 257, 258, 259]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'BIH',
                        iso_a2: 'BA',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Bosnia and Herz.',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'BiH'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'BLM',
                        iso_a2: 'BL',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'St-Barthélemy',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'BL'
                    }
                },
                {
                    arcs: [[260, 261, 262, 263, 264]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'BLR',
                        iso_a2: 'BY',
                        sub_region: 'Eastern Europe',
                        continent: 'Europe',
                        name: 'Belarus',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'BY'
                    }
                },
                {
                    arcs: [[[265]], [[266, 267, 268]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'BLZ',
                        iso_a2: 'BZ',
                        sub_region: 'Central America',
                        continent: 'North America',
                        name: 'Belize',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'BZ'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'BMU',
                        iso_a2: 'BM',
                        sub_region: 'Northern America',
                        continent: 'North America',
                        name: 'Bermuda',
                        region_un: 'Americas',
                        region_wb: 'North America',
                        postal: 'BM'
                    }
                },
                {
                    arcs: [[[269, 270]], [[271, -41, 272, 273, 274, 275, 276]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'BOL',
                        iso_a2: 'BO',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Bolivia',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'BO'
                    }
                },
                {
                    arcs: [
                        [[277]],
                        [[278]],
                        [[279]],
                        [[280]],
                        [[281]],
                        [[282]],
                        [[283]],
                        [[284]],
                        [[285]],
                        [[286]],
                        [[287]],
                        [[288]],
                        [[289]],
                        [[290]],
                        [[291]],
                        [[292]],
                        [[293, 294, 295, 296, 297, 298, -37, 299, -277, 300, 301, 302, 303]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'BRA',
                        iso_a2: 'BR',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Brazil',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'BR'
                    }
                },
                {
                    arcs: [[304]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'BRB',
                        iso_a2: 'BB',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Barbados',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'BB'
                    }
                },
                {
                    arcs: [[[305, 306]], [[307, 308]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'BRN',
                        iso_a2: 'BN',
                        sub_region: 'South-Eastern Asia',
                        continent: 'Asia',
                        name: 'Brunei',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'BN'
                    }
                },
                {
                    arcs: [[309, 310]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'BTN',
                        iso_a2: 'BT',
                        sub_region: 'Southern Asia',
                        continent: 'Asia',
                        name: 'Bhutan',
                        region_un: 'Asia',
                        region_wb: 'South Asia',
                        postal: 'BT'
                    }
                },
                {
                    arcs: [[311, 312, 313]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'BWA',
                        iso_a2: 'BW',
                        sub_region: 'Southern Africa',
                        continent: 'Africa',
                        name: 'Botswana',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'BW'
                    }
                },
                {
                    arcs: [[314, 315, 316, 317, 318, 319]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'CAF',
                        iso_a2: 'CF',
                        sub_region: 'Middle Africa',
                        continent: 'Africa',
                        name: 'Central African Rep.',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'CF'
                    }
                },
                {
                    arcs: [
                        [[320]],
                        [[321]],
                        [[322]],
                        [[323]],
                        [[324]],
                        [[325]],
                        [[326]],
                        [[327]],
                        [[328]],
                        [[329]],
                        [[330]],
                        [[331]],
                        [[332]],
                        [[333]],
                        [[334]],
                        [[335, 336, 337, 338]],
                        [[339]],
                        [[340]],
                        [[341]],
                        [[342]],
                        [[343]],
                        [[344]],
                        [[345]],
                        [[346]],
                        [[347]],
                        [[348]],
                        [[349]],
                        [[350]],
                        [[351]],
                        [[352]],
                        [[353]],
                        [[354]],
                        [[355]],
                        [[356]],
                        [[357]],
                        [[358]],
                        [[359]],
                        [[360]],
                        [[361]],
                        [[362, 363]],
                        [[364]],
                        [[365]],
                        [[366]],
                        [[367]],
                        [[368]],
                        [[369]],
                        [[370]],
                        [[371]],
                        [[372]],
                        [[373]],
                        [[374]],
                        [[375]],
                        [[376]],
                        [[377]],
                        [[378]],
                        [[379]],
                        [[380]],
                        [[381]],
                        [[382]],
                        [[383]],
                        [[384]],
                        [[385]],
                        [[386]],
                        [[387]],
                        [[388]],
                        [[389]],
                        [[390]],
                        [[391]],
                        [[392]],
                        [[393]],
                        [[394]],
                        [[395]],
                        [[396]],
                        [[397]],
                        [[398]],
                        [[399]],
                        [[400]],
                        [[401]],
                        [[402]],
                        [[403]],
                        [[404]],
                        [[405]],
                        [[406]],
                        [[407]],
                        [[408]],
                        [[409]],
                        [[410, 411, 412, 413, 414, 415, 416, 417, 418, 419]],
                        [[420]],
                        [[421]],
                        [[422]],
                        [[423]],
                        [[424]],
                        [[425]],
                        [[426]],
                        [[427]],
                        [[428]],
                        [[429]],
                        [[430]],
                        [[431]],
                        [[432]],
                        [[433]],
                        [[434]],
                        [[435]],
                        [[436]],
                        [[437]],
                        [[438]],
                        [[439]],
                        [[440]],
                        [[441]],
                        [[442]],
                        [[443]],
                        [[444]],
                        [[445]],
                        [[446]],
                        [[447]],
                        [[448]],
                        [[449]],
                        [[450]],
                        [[451]],
                        [[452]],
                        [[453]],
                        [[454]],
                        [[455]],
                        [[456]],
                        [[457]],
                        [[458]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'CAN',
                        iso_a2: 'CA',
                        sub_region: 'Northern America',
                        continent: 'North America',
                        name: 'Canada',
                        region_un: 'Americas',
                        region_wb: 'North America',
                        postal: 'CA'
                    }
                },
                {
                    arcs: [[459, -195, 460, -193, 461, 462, 463]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'CHE',
                        iso_a2: 'CH',
                        sub_region: 'Western Europe',
                        continent: 'Europe',
                        name: 'Switzerland',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'CH'
                    }
                },
                {
                    arcs: [
                        [[464]],
                        [[465]],
                        [[466]],
                        [[467]],
                        [[468]],
                        [[469]],
                        [[470]],
                        [[471]],
                        [[472]],
                        [[-33, 473]],
                        [[474]],
                        [[475]],
                        [[476]],
                        [[477]],
                        [[478]],
                        [[479]],
                        [[480]],
                        [[481]],
                        [[482]],
                        [[483]],
                        [[484]],
                        [[485]],
                        [[486]],
                        [[487]],
                        [[488]],
                        [[489]],
                        [[490]],
                        [[491]],
                        [[492]],
                        [[-40, 493, 494, -273]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'CHL',
                        iso_a2: 'CL',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Chile',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'CL'
                    }
                },
                {
                    arcs: [
                        [[495]],
                        [[496]],
                        [[497]],
                        [[498]],
                        [[499]],
                        [[500]],
                        [[501]],
                        [[502]],
                        [[503]],
                        [
                            [
                                504,
                                505,
                                506,
                                507,
                                508,
                                509,
                                510,
                                511,
                                512,
                                513,
                                -311,
                                514,
                                515,
                                516,
                                517,
                                518,
                                519,
                                -2,
                                520,
                                521,
                                522,
                                523,
                                524,
                                525
                            ]
                        ]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'CHN',
                        iso_a2: 'CN',
                        sub_region: 'Eastern Asia',
                        continent: 'Asia',
                        name: 'China',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'CN'
                    }
                },
                {
                    arcs: [[-225, 527, 528, 529, 530, 531]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'CIV',
                        iso_a2: 'CI',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: "Côte d'Ivoire",
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'CI'
                    }
                },
                {
                    arcs: [[-319, 532, 533, 534, 535, 536, 537]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'CMR',
                        iso_a2: 'CM',
                        sub_region: 'Middle Africa',
                        continent: 'Africa',
                        name: 'Cameroon',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'CM'
                    }
                },
                {
                    arcs: [[538, 539, 540, 541, 542, 543, 544, 545, 546, -207, 547, 548, -11, 549, -14, 550, -317]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'COD',
                        iso_a2: 'CD',
                        sub_region: 'Middle Africa',
                        continent: 'Africa',
                        name: 'Dem. Rep. Congo',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'DRC'
                    }
                },
                {
                    arcs: [[-551, -13, 551, 552, -533, -318]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'COG',
                        iso_a2: 'CG',
                        sub_region: 'Middle Africa',
                        continent: 'Africa',
                        name: 'Congo',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'CG'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'COK',
                        iso_a2: 'CK',
                        sub_region: 'Polynesia',
                        continent: 'Oceania',
                        name: 'Cook Is.',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'CK'
                    }
                },
                {
                    arcs: [[553, -302, 554, 555, 556, 557, 558]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'COL',
                        iso_a2: 'CO',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Colombia',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'CO'
                    }
                },
                {
                    arcs: [[[559]], [[560]], [[561]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'COM',
                        iso_a2: 'KM',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Comoros',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'KM'
                    }
                },
                {
                    arcs: [[[562]], [[563]], [[564]], [[565]], [[566]], [[567]], [[568]], [[569]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'CPV',
                        iso_a2: 'CV',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Cabo Verde',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'CV'
                    }
                },
                {
                    arcs: [[570, 571, 572, 573]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'CRI',
                        iso_a2: 'CR',
                        sub_region: 'Central America',
                        continent: 'North America',
                        name: 'Costa Rica',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'CR'
                    }
                },
                {
                    arcs: [[[574]], [[575]], [[576]], [[577]], [[578]], [[579]], [[580]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'CUB',
                        iso_a2: 'CU',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Cuba',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'CU'
                    }
                },
                {
                    arcs: [[581]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'CUW',
                        iso_a2: 'CW',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Curaçao',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'CW'
                    }
                },
                {
                    arcs: [[582]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'CYM',
                        iso_a2: 'KY',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Cayman Is.',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'KY'
                    }
                },
                {
                    arcs: [[583, 584]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: '-99',
                        iso_a2: '-99',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'N. Cyprus',
                        region_un: 'Asia',
                        region_wb: 'Europe & Central Asia',
                        postal: 'CN'
                    }
                },
                {
                    arcs: [[-584, 585]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'CYP',
                        iso_a2: 'CY',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Cyprus',
                        region_un: 'Asia',
                        region_wb: 'Europe & Central Asia',
                        postal: 'CY'
                    }
                },
                {
                    arcs: [[586, 587, -198, 588]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'CZE',
                        iso_a2: 'CZ',
                        sub_region: 'Eastern Europe',
                        continent: 'Europe',
                        name: 'Czechia',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'CZ'
                    }
                },
                {
                    arcs: [[[589, 590]], [[591]], [[592]], [[593, 594, -589, -197, 595, -464, 596, 597, -211, 598, 599, 600]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'DEU',
                        iso_a2: 'DE',
                        sub_region: 'Western Europe',
                        continent: 'Europe',
                        name: 'Germany',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'D'
                    }
                },
                {
                    arcs: [[601, 602, 603, 604]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'DJI',
                        iso_a2: 'DJ',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Djibouti',
                        region_un: 'Africa',
                        region_wb: 'Middle East & North Africa',
                        postal: 'DJ'
                    }
                },
                {
                    arcs: [[605]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'DMA',
                        iso_a2: 'DM',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Dominica',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'DM'
                    }
                },
                {
                    arcs: [[[606]], [[607]], [[608]], [[609]], [[610]], [[611]], [[612]], [[613]], [[-601, 614]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'DNK',
                        iso_a2: 'DK',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Denmark',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'DK'
                    }
                },
                {
                    arcs: [[615, 616]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'DOM',
                        iso_a2: 'DO',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Dominican Rep.',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'DO'
                    }
                },
                {
                    arcs: [[617, 618, 619, 620, 621, 622, 623, 624]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'DZA',
                        iso_a2: 'DZ',
                        sub_region: 'Northern Africa',
                        continent: 'Africa',
                        name: 'Algeria',
                        region_un: 'Africa',
                        region_wb: 'Middle East & North Africa',
                        postal: 'DZ'
                    }
                },
                {
                    arcs: [[[625]], [[626]], [[627]], [[628]], [[629]], [[630]], [[631]], [[632]], [[633, 634, -556]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'ECU',
                        iso_a2: 'EC',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Ecuador',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'EC'
                    }
                },
                {
                    arcs: [[635, 636, 637, 638, 639, 640]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'EGY',
                        iso_a2: 'EG',
                        sub_region: 'Northern Africa',
                        continent: 'Africa',
                        name: 'Egypt',
                        region_un: 'Africa',
                        region_wb: 'Middle East & North Africa',
                        postal: 'EG'
                    }
                },
                {
                    arcs: [[[641]], [[642]], [[643, -604, 644, 645]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'ERI',
                        iso_a2: 'ER',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Eritrea',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'ER'
                    }
                },
                {
                    arcs: [
                        [[646]],
                        [[647]],
                        [[648]],
                        [[649]],
                        [[650]],
                        [[651]],
                        [[652]],
                        [[653]],
                        [[654]],
                        [[655]],
                        [[656, -23, 657, 658, 659, 660]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'ESP',
                        iso_a2: 'ES',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Spain',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'E'
                    }
                },
                {
                    arcs: [[[661]], [[662]], [[663]], [[664, 665, 666, 667, 668]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'EST',
                        iso_a2: 'EE',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Estonia',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'EST'
                    }
                },
                {
                    arcs: [[-603, 669, 670, 671, 672, 673, -645]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ETH',
                        iso_a2: 'ET',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Ethiopia',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'ET'
                    }
                },
                {
                    arcs: [[[674]], [[675]], [[676]], [[677, 678, 679, 680]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'FIN',
                        iso_a2: 'FI',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Finland',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'FIN'
                    }
                },
                {
                    arcs: [[[681]], [[682]], [[683]], [[684]], [[685]], [[686]], [[687]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'FJI',
                        iso_a2: 'FJ',
                        sub_region: 'Melanesia',
                        continent: 'Oceania',
                        name: 'Fiji',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'FJ'
                    }
                },
                {
                    arcs: [[[688]], [[689]], [[690]], [[691]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'FLK',
                        iso_a2: 'FK',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Falkland Is.',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'FK'
                    }
                },
                {
                    arcs: [
                        [[692]],
                        [[693]],
                        [[696]],
                        [[697]],
                        [[698]],
                        [[699]],
                        [[700]],
                        [[701]],
                        [[702, -597, -463, 703, 704, -658, -24, -657, 705, -213]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'FRA',
                        iso_a2: 'FR',
                        sub_region: 'Western Europe',
                        continent: 'Europe',
                        name: 'France',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'F'
                    }
                },
                {
                    arcs: [[[-295, 694, 695]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'GUF',
                        iso_a2: 'GF',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'French Guiana',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'F'
                    }
                },
                {
                    arcs: [[[706]], [[707]], [[708]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'FRO',
                        iso_a2: 'FO',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Faeroe Is.',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'FO'
                    }
                },
                {
                    arcs: [[[709]], [[710]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'FSM',
                        iso_a2: 'FM',
                        sub_region: 'Micronesia',
                        continent: 'Oceania',
                        name: 'Micronesia',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'FSM'
                    }
                },
                {
                    arcs: [[-553, 711, 712, -534]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'GAB',
                        iso_a2: 'GA',
                        sub_region: 'Middle Africa',
                        continent: 'Africa',
                        name: 'Gabon',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'GA'
                    }
                },
                {
                    arcs: [
                        [[713]],
                        [[714]],
                        [[715, 716]],
                        [[717]],
                        [[718]],
                        [[719]],
                        [[720]],
                        [[721]],
                        [[722]],
                        [[723]],
                        [[724]],
                        [[725]],
                        [[726]],
                        [[727]],
                        [[728]],
                        [[729]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'GBR',
                        iso_a2: 'GB',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'United Kingdom',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'GB'
                    }
                },
                {
                    arcs: [[-203, -45, 730, 731, 732]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'GEO',
                        iso_a2: 'GE',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Georgia',
                        region_un: 'Asia',
                        region_wb: 'Europe & Central Asia',
                        postal: 'GE'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'GGY',
                        iso_a2: 'GG',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Guernsey',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'GG'
                    }
                },
                {
                    arcs: [[733, 734, -527, 735, -528, -224]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'GHA',
                        iso_a2: 'GH',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Ghana',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'GH'
                    }
                },
                {
                    arcs: [[736, -531, 737, 738, 739, 740, 741]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'GIN',
                        iso_a2: 'GN',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Guinea',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'GN'
                    }
                },
                {
                    arcs: [[742, 743]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'GMB',
                        iso_a2: 'GM',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Gambia',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'GM'
                    }
                },
                {
                    arcs: [[[744]], [[745]], [[746]], [[747, 748, -741]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'GNB',
                        iso_a2: 'GW',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Guinea-Bissau',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'GW'
                    }
                },
                {
                    arcs: [[[749, -535, -713]], [[750]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'GNQ',
                        iso_a2: 'GQ',
                        sub_region: 'Middle Africa',
                        continent: 'Africa',
                        name: 'Eq. Guinea',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'GQ'
                    }
                },
                {
                    arcs: [
                        [[751]],
                        [[752]],
                        [[753]],
                        [[754]],
                        [[755]],
                        [[756]],
                        [[757]],
                        [[758]],
                        [[759]],
                        [[760]],
                        [[761]],
                        [[762]],
                        [[763]],
                        [[764]],
                        [[765]],
                        [[766]],
                        [[767]],
                        [[768]],
                        [[769]],
                        [[770]],
                        [[771]],
                        [[772]],
                        [[773]],
                        [[774]],
                        [[775]],
                        [[776]],
                        [[777]],
                        [[778]],
                        [[779]],
                        [[780]],
                        [[781]],
                        [[782, -17, 783, -236, 784]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'GRC',
                        iso_a2: 'GR',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Greece',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'GR'
                    }
                },
                {
                    arcs: [[785]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'GRD',
                        iso_a2: 'GD',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Grenada',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'GD'
                    }
                },
                {
                    arcs: [
                        [[786]],
                        [[787]],
                        [[788]],
                        [[789]],
                        [[790]],
                        [[791]],
                        [[792]],
                        [[793]],
                        [[794]],
                        [[795]],
                        [[796]],
                        [[797]],
                        [[798]],
                        [[799]],
                        [[800]],
                        [[801]],
                        [[802]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'GRL',
                        iso_a2: 'GL',
                        sub_region: 'Northern America',
                        continent: 'North America',
                        name: 'Greenland',
                        region_un: 'Americas',
                        region_wb: 'Europe & Central Asia',
                        postal: 'GL'
                    }
                },
                {
                    arcs: [[-267, 803, 804, 805, 806, 807]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'GTM',
                        iso_a2: 'GT',
                        sub_region: 'Central America',
                        continent: 'North America',
                        name: 'Guatemala',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'GT'
                    }
                },
                {
                    arcs: [[808]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'GUM',
                        iso_a2: 'GU',
                        sub_region: 'Micronesia',
                        continent: 'Oceania',
                        name: 'Guam',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'GU'
                    }
                },
                {
                    arcs: [[809, -304, 810, 811]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'GUY',
                        iso_a2: 'GY',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Guyana',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'GY'
                    }
                },
                {
                    arcs: [[[812]], [[-509, 813]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'HKG',
                        iso_a2: 'HK',
                        sub_region: 'Eastern Asia',
                        continent: 'Asia',
                        name: 'Hong Kong',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'HK'
                    }
                },
                {
                    arcs: [[814]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'HMD',
                        iso_a2: 'HM',
                        sub_region: 'Seven seas (open ocean)',
                        continent: 'Seven seas (open ocean)',
                        name: 'Heard I. and McDonald Is.',
                        region_un: 'Seven seas (open ocean)',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'HM'
                    }
                },
                {
                    arcs: [[815, 816, 817, -805, 818]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'HND',
                        iso_a2: 'HN',
                        sub_region: 'Central America',
                        continent: 'North America',
                        name: 'Honduras',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'HN'
                    }
                },
                {
                    arcs: [
                        [[819]],
                        [[-258, 820, 821]],
                        [[822]],
                        [[823]],
                        [[824]],
                        [[825]],
                        [[826]],
                        [[827]],
                        [[828, -260, 829, 830, 831]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'HRV',
                        iso_a2: 'HR',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Croatia',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'HR'
                    }
                },
                {
                    arcs: [[[832]], [[-616, 833]], [[834]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'HTI',
                        iso_a2: 'HT',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Haiti',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'HT'
                    }
                },
                {
                    arcs: [[835, 836, 837, -832, 838, -190, 839]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'HUN',
                        iso_a2: 'HU',
                        sub_region: 'Eastern Europe',
                        continent: 'Europe',
                        name: 'Hungary',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'HU'
                    }
                },
                {
                    arcs: [
                        [[840]],
                        [[841]],
                        [[842]],
                        [[843]],
                        [[844, 845, 846, 847]],
                        [[848]],
                        [[849]],
                        [[850]],
                        [[851]],
                        [[852]],
                        [[853]],
                        [[854]],
                        [[855]],
                        [[856]],
                        [[857]],
                        [[858]],
                        [[859]],
                        [[860]],
                        [[861]],
                        [[862]],
                        [[863]],
                        [[864]],
                        [[865]],
                        [[866]],
                        [[867]],
                        [[868]],
                        [[869]],
                        [[870]],
                        [[871]],
                        [[872]],
                        [[873]],
                        [[874]],
                        [[875]],
                        [[876]],
                        [[877]],
                        [[878]],
                        [[879]],
                        [[880]],
                        [[881]],
                        [[882]],
                        [[883]],
                        [[884]],
                        [[885]],
                        [[886]],
                        [[887]],
                        [[888]],
                        [[889]],
                        [[890]],
                        [[891]],
                        [[892]],
                        [[893]],
                        [[894]],
                        [[895]],
                        [[896]],
                        [[897]],
                        [[898]],
                        [[899]],
                        [[900]],
                        [[901]],
                        [[902]],
                        [[903]],
                        [[904]],
                        [[905]],
                        [[906]],
                        [[907]],
                        [[908]],
                        [[909]],
                        [[910]],
                        [[911]],
                        [[912]],
                        [[913]],
                        [[914]],
                        [[915]],
                        [[916]],
                        [[917]],
                        [[918]],
                        [[919]],
                        [[920]],
                        [[921]],
                        [[922, 923]],
                        [[924]],
                        [[925]],
                        [[926]],
                        [[927]],
                        [[928]],
                        [[929]],
                        [[930]],
                        [[931]],
                        [[932]],
                        [[933]],
                        [[934]],
                        [[935]],
                        [[936]],
                        [[937]],
                        [[938]],
                        [[939]],
                        [[940]],
                        [[941]],
                        [[942]],
                        [[943]],
                        [[944]],
                        [[945]],
                        [[946]],
                        [[947]],
                        [[948]],
                        [[949]],
                        [[950]],
                        [[951]],
                        [[952]],
                        [[953]],
                        [[954]],
                        [[955]],
                        [[956, 957]],
                        [[958]],
                        [[959, 960]],
                        [[961]],
                        [[962]],
                        [[963]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'IDN',
                        iso_a2: 'ID',
                        sub_region: 'South-Eastern Asia',
                        continent: 'Asia',
                        name: 'Indonesia',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'INDO'
                    }
                },
                {
                    arcs: [[964]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'IMN',
                        iso_a2: 'IM',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Isle of Man',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'IM'
                    }
                },
                {
                    arcs: [
                        [[965]],
                        [[966]],
                        [[967]],
                        [[968]],
                        [[969]],
                        [[970]],
                        [[971]],
                        [[-517, 972, -515, -310, -514, 973, -233, 974, 975, 976, -518]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'IND',
                        iso_a2: 'IN',
                        sub_region: 'Southern Asia',
                        continent: 'Asia',
                        name: 'India',
                        region_un: 'Asia',
                        region_wb: 'South Asia',
                        postal: 'IND'
                    }
                },
                {
                    arcs: [[977]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: '-99',
                        iso_a2: '-99',
                        sub_region: 'Seven seas (open ocean)',
                        continent: 'Asia',
                        name: 'Indian Ocean Ter.',
                        region_un: 'Seven seas (open ocean)',
                        region_wb: 'East Asia & Pacific',
                        postal: 'IOT'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'IOT',
                        iso_a2: 'IO',
                        sub_region: 'Seven seas (open ocean)',
                        continent: 'Seven seas (open ocean)',
                        name: 'Br. Indian Ocean Ter.',
                        region_un: 'Seven seas (open ocean)',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'IO'
                    }
                },
                {
                    arcs: [[978, -716]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'IRL',
                        iso_a2: 'IE',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Ireland',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'IRL'
                    }
                },
                {
                    arcs: [[[979]], [[-42, -202, 980, 981, -4, 982, 983, 984, 985, -199]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'IRN',
                        iso_a2: 'IR',
                        sub_region: 'Southern Asia',
                        continent: 'Asia',
                        name: 'Iran',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'IRN'
                    }
                },
                {
                    arcs: [[-985, 986, 987, 988, 989, 990, 991]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'IRQ',
                        iso_a2: 'IQ',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Iraq',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'IRQ'
                    }
                },
                {
                    arcs: [[992]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ISL',
                        iso_a2: 'IS',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Iceland',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'IS'
                    }
                },
                {
                    arcs: [[993, 994, 995, 996, -637, 997, 998, 999, 1000]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ISR',
                        iso_a2: 'IL',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Israel',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'IS'
                    }
                },
                {
                    arcs: [[[1001]], [[1002]], [[1003]], [[1004]], [[1005, 1006, -704, -462, -192]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'ITA',
                        iso_a2: 'IT',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Italy',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'I'
                    }
                },
                {
                    arcs: [[1007]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'JAM',
                        iso_a2: 'JM',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Jamaica',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'J'
                    }
                },
                {
                    arcs: [[1008]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'JEY',
                        iso_a2: 'JE',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Jersey',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'JE'
                    }
                },
                {
                    arcs: [[1009, 1010, -996, 1011, -994, 1012, -990]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'JOR',
                        iso_a2: 'JO',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Jordan',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'J'
                    }
                },
                {
                    arcs: [
                        [[1013]],
                        [[1014]],
                        [[1015]],
                        [[1016]],
                        [[1017]],
                        [[1018]],
                        [[1019]],
                        [[1020]],
                        [[1021]],
                        [[1022]],
                        [[1023]],
                        [[1024]],
                        [[1025]],
                        [[1026]],
                        [[1027]],
                        [[1028]],
                        [[1029]],
                        [[1030]],
                        [[1031]],
                        [[1032]],
                        [[1033]],
                        [[1034]],
                        [[1035]],
                        [[1036]],
                        [[1037]],
                        [[1038]],
                        [[1039]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'JPN',
                        iso_a2: 'JP',
                        sub_region: 'Eastern Asia',
                        continent: 'Asia',
                        name: 'Japan',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'J'
                    }
                },
                {
                    arcs: [[-977, 1040, -519]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: '-99',
                        iso_a2: '-99',
                        sub_region: 'Southern Asia',
                        continent: 'Asia',
                        name: 'Siachen Glacier',
                        region_un: 'Asia',
                        region_wb: 'South Asia',
                        postal: 'SG'
                    }
                },
                {
                    arcs: [[[1041]], [[1042, 1043]], [[-523, 1044, 1045, 1046, 1047, 1048, 1049, 1050]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'KAZ',
                        iso_a2: 'KZ',
                        sub_region: 'Central Asia',
                        continent: 'Asia',
                        name: 'Kazakhstan',
                        region_un: 'Asia',
                        region_wb: 'Europe & Central Asia',
                        postal: 'KZ'
                    }
                },
                {
                    arcs: [[[1051]], [[1052, 1053, 1054, 1055, 1056, 1057, -672]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'KEN',
                        iso_a2: 'KE',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Kenya',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'KE'
                    }
                },
                {
                    arcs: [[-522, 1058, 1059, -1045], [1060], [1061]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'KGZ',
                        iso_a2: 'KG',
                        sub_region: 'Central Asia',
                        continent: 'Asia',
                        name: 'Kyrgyzstan',
                        region_un: 'Asia',
                        region_wb: 'Europe & Central Asia',
                        postal: 'KG'
                    }
                },
                {
                    arcs: [[1062, 1063, 1064, 1065]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'KHM',
                        iso_a2: 'KH',
                        sub_region: 'South-Eastern Asia',
                        continent: 'Asia',
                        name: 'Cambodia',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'KH'
                    }
                },
                {
                    arcs: [[1066]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'KIR',
                        iso_a2: 'KI',
                        sub_region: 'Micronesia',
                        continent: 'Oceania',
                        name: 'Kiribati',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'KI'
                    }
                },
                {
                    arcs: [[[1067]], [[1068]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'KNA',
                        iso_a2: 'KN',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'St. Kitts and Nevis',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'KN'
                    }
                },
                {
                    arcs: [[[1069]], [[1070]], [[1071]], [[1072]], [[1073]], [[1074]], [[1075, 1076]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'KOR',
                        iso_a2: 'KR',
                        sub_region: 'Eastern Asia',
                        continent: 'Asia',
                        name: 'South Korea',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'KR'
                    }
                },
                {
                    arcs: [[1077, -15, 1078, 1079]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: '-99',
                        iso_a2: 'XK',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Kosovo',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'KO'
                    }
                },
                {
                    arcs: [[[1080]], [[1081, -988, 1082]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'KWT',
                        iso_a2: 'KW',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Kuwait',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'KW'
                    }
                },
                {
                    arcs: [[1083, -1065, 1084, 1085, -512]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'LAO',
                        iso_a2: 'LA',
                        sub_region: 'South-Eastern Asia',
                        continent: 'Asia',
                        name: 'Laos',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'LA'
                    }
                },
                {
                    arcs: [[-1000, 1086, 1087]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'LBN',
                        iso_a2: 'LB',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Lebanon',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'LB'
                    }
                },
                {
                    arcs: [[-530, 1088, 1089, -738]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'LBR',
                        iso_a2: 'LR',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Liberia',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'LR'
                    }
                },
                {
                    arcs: [[-640, 1090, 1091, 1092, -619, 1093, 1094]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'LBY',
                        iso_a2: 'LY',
                        sub_region: 'Northern Africa',
                        continent: 'Africa',
                        name: 'Libya',
                        region_un: 'Africa',
                        region_wb: 'Middle East & North Africa',
                        postal: 'LY'
                    }
                },
                {
                    arcs: [[1095]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'LCA',
                        iso_a2: 'LC',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Saint Lucia',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'LC'
                    }
                },
                {
                    arcs: [[-461, -194]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'LIE',
                        iso_a2: 'LI',
                        sub_region: 'Western Europe',
                        continent: 'Europe',
                        name: 'Liechtenstein',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'FL'
                    }
                },
                {
                    arcs: [[1096]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'LKA',
                        iso_a2: 'LK',
                        sub_region: 'Southern Asia',
                        continent: 'Asia',
                        name: 'Sri Lanka',
                        region_un: 'Asia',
                        region_wb: 'South Asia',
                        postal: 'LK'
                    }
                },
                {
                    arcs: [[1097]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'LSO',
                        iso_a2: 'LS',
                        sub_region: 'Southern Africa',
                        continent: 'Africa',
                        name: 'Lesotho',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'LS'
                    }
                },
                {
                    arcs: [[-264, 1099, 1100, 1101, 1102]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'LTU',
                        iso_a2: 'LT',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Lithuania',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'LT'
                    }
                },
                {
                    arcs: [[-598, -703, -212]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'LUX',
                        iso_a2: 'LU',
                        sub_region: 'Western Europe',
                        continent: 'Europe',
                        name: 'Luxembourg',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'L'
                    }
                },
                {
                    arcs: [[1103, -265, -1103, 1104, -668]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'LVA',
                        iso_a2: 'LV',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Latvia',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'LV'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'MAC',
                        iso_a2: 'MO',
                        sub_region: 'Eastern Asia',
                        continent: 'Asia',
                        name: 'Macao',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'MO'
                    }
                },
                {
                    arcs: [[1105, 1106]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'MAF',
                        iso_a2: 'MF',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'St-Martin',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'MF'
                    }
                },
                {
                    arcs: [[-624, 1107, 1108]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'MAR',
                        iso_a2: 'MA',
                        sub_region: 'Northern Africa',
                        continent: 'Africa',
                        name: 'Morocco',
                        region_un: 'Africa',
                        region_wb: 'Middle East & North Africa',
                        postal: 'MA'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'MCO',
                        iso_a2: 'MC',
                        sub_region: 'Western Europe',
                        continent: 'Europe',
                        name: 'Monaco',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'MC'
                    }
                },
                {
                    arcs: [[1109, 1110]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'MDA',
                        iso_a2: 'MD',
                        sub_region: 'Eastern Europe',
                        continent: 'Europe',
                        name: 'Moldova',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'MD'
                    }
                },
                {
                    arcs: [[[1111]], [[1112]], [[1113]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'MDG',
                        iso_a2: 'MG',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Madagascar',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'MG'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'MDV',
                        iso_a2: 'MV',
                        sub_region: 'Southern Asia',
                        continent: 'Seven seas (open ocean)',
                        name: 'Maldives',
                        region_un: 'Asia',
                        region_wb: 'South Asia',
                        postal: 'MV'
                    }
                },
                {
                    arcs: [
                        [[1114]],
                        [[1115]],
                        [[1116]],
                        [[1117]],
                        [[1118]],
                        [[1119]],
                        [[1120]],
                        [[1121]],
                        [[1122]],
                        [[1123]],
                        [[1124]],
                        [[1125, -268, -808, 1126, 1127]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'MEX',
                        iso_a2: 'MX',
                        sub_region: 'Central America',
                        continent: 'North America',
                        name: 'Mexico',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'MX'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'MHL',
                        iso_a2: 'MH',
                        sub_region: 'Micronesia',
                        continent: 'Oceania',
                        name: 'Marshall Is.',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'MH'
                    }
                },
                {
                    arcs: [[-237, -784, -16, -1078, 1128]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'MKD',
                        iso_a2: 'MK',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Macedonia',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'MK'
                    }
                },
                {
                    arcs: [[1129, -226, -532, -737, 1130, 1131, -621]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'MLI',
                        iso_a2: 'ML',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Mali',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'ML'
                    }
                },
                {
                    arcs: [[1132]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'MLT',
                        iso_a2: 'MT',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Malta',
                        region_un: 'Europe',
                        region_wb: 'Middle East & North Africa',
                        postal: 'M'
                    }
                },
                {
                    arcs: [
                        [[1133]],
                        [[1134]],
                        [[1135]],
                        [[1136]],
                        [[1137]],
                        [[1138]],
                        [[1139]],
                        [[1140]],
                        [[1141]],
                        [[1142]],
                        [[1143]],
                        [[1144]],
                        [[1145]],
                        [[-1086, 1146, 1147, -231, -974, -513]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'MMR',
                        iso_a2: 'MM',
                        sub_region: 'South-Eastern Asia',
                        continent: 'Asia',
                        name: 'Myanmar',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'MM'
                    }
                },
                {
                    arcs: [[1148, -1079, -21, 1149, -19, 1150, -821, -257]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'MNE',
                        iso_a2: 'ME',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Montenegro',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'ME'
                    }
                },
                {
                    arcs: [[-525, 1151]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'MNG',
                        iso_a2: 'MN',
                        sub_region: 'Eastern Asia',
                        continent: 'Asia',
                        name: 'Mongolia',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'MN'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'MNP',
                        iso_a2: 'MP',
                        sub_region: 'Micronesia',
                        continent: 'Oceania',
                        name: 'N. Mariana Is.',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'MP'
                    }
                },
                {
                    arcs: [[1152, 1153, 1154, 1155, 1156, 1157, 1158, 1159, 1160]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'MOZ',
                        iso_a2: 'MZ',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Mozambique',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'MZ'
                    }
                },
                {
                    arcs: [[[1161]], [[1162, 1163, 1164, -622, -1132]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'MRT',
                        iso_a2: 'MR',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Mauritania',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'MR'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'MSR',
                        iso_a2: 'MS',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Montserrat',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'MS'
                    }
                },
                {
                    arcs: [[1165]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'MUS',
                        iso_a2: 'MU',
                        sub_region: 'Eastern Africa',
                        continent: 'Seven seas (open ocean)',
                        name: 'Mauritius',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'MU'
                    }
                },
                {
                    arcs: [[[1166]], [[1167]], [[1170, -1158, 1171, 1172]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'MWI',
                        iso_a2: 'MW',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Malawi',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'MW'
                    }
                },
                {
                    arcs: [
                        [[1173]],
                        [[1174]],
                        [[-958, 1175]],
                        [[1176]],
                        [[1177]],
                        [[1178, 1179]],
                        [[-961, 1180, -308, -307, 1181]],
                        [[1182]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'MYS',
                        iso_a2: 'MY',
                        sub_region: 'South-Eastern Asia',
                        continent: 'Asia',
                        name: 'Malaysia',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'MY'
                    }
                },
                {
                    arcs: [[1183, -314, 1184, 1185, -9]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'NAM',
                        iso_a2: 'NA',
                        sub_region: 'Southern Africa',
                        continent: 'Africa',
                        name: 'Namibia',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'NA'
                    }
                },
                {
                    arcs: [[[1186]], [[1187]], [[1188]], [[1189]], [[1190]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'NCL',
                        iso_a2: 'NC',
                        sub_region: 'Melanesia',
                        continent: 'Oceania',
                        name: 'New Caledonia',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'NC'
                    }
                },
                {
                    arcs: [[1191, 1192, -221, -222, -1130, -620, -1093]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'NER',
                        iso_a2: 'NE',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Niger',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'NE'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'NFK',
                        iso_a2: 'NF',
                        sub_region: 'Australia and New Zealand',
                        continent: 'Oceania',
                        name: 'Norfolk Island',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'NF'
                    }
                },
                {
                    arcs: [[[1193]], [[1194, -537, 1195, -217, -1193]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'NGA',
                        iso_a2: 'NG',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Nigeria',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'NG'
                    }
                },
                {
                    arcs: [[1196, -574, 1197, -816]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'NIC',
                        iso_a2: 'NI',
                        sub_region: 'Central America',
                        continent: 'North America',
                        name: 'Nicaragua',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'NI'
                    }
                },
                {
                    arcs: [[1198]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'NIU',
                        iso_a2: 'NU',
                        sub_region: 'Polynesia',
                        continent: 'Oceania',
                        name: 'Niue',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'NU'
                    }
                },
                {
                    arcs: [[[1199]], [[-215, 1200]], [[1201]], [[1202]], [[1203]], [[1204, -599, -210, 1205, -216], [1206]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'NLD',
                        iso_a2: 'NL',
                        sub_region: 'Western Europe',
                        continent: 'Europe',
                        name: 'Netherlands',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'NL'
                    }
                },
                {
                    arcs: [
                        [[1207]],
                        [[1208]],
                        [[1209]],
                        [[1210]],
                        [[1211]],
                        [[1212]],
                        [[1213]],
                        [[1214]],
                        [[1215]],
                        [[1216]],
                        [[1217]],
                        [[1218]],
                        [[1219]],
                        [[1220]],
                        [[1221]],
                        [[1222]],
                        [[1223]],
                        [[1224]],
                        [[1225, -681, 1226, 1227]],
                        [[1228]],
                        [[1229]],
                        [[1230]],
                        [[1231]],
                        [[1232]],
                        [[1233]],
                        [[1234]],
                        [[1235]],
                        [[1236]],
                        [[1237]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'NOR',
                        iso_a2: 'NO',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Norway',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'N'
                    }
                },
                {
                    arcs: [[-973, -516]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'NPL',
                        iso_a2: 'NP',
                        sub_region: 'Southern Asia',
                        continent: 'Asia',
                        name: 'Nepal',
                        region_un: 'Asia',
                        region_wb: 'South Asia',
                        postal: 'NP'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'NRU',
                        iso_a2: 'NR',
                        sub_region: 'Micronesia',
                        continent: 'Oceania',
                        name: 'Nauru',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'NR'
                    }
                },
                {
                    arcs: [[[1238]], [[1239]], [[1240]], [[1241]], [[1242]], [[1243]], [[1244]], [[1245]], [[1246]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'NZL',
                        iso_a2: 'NZ',
                        sub_region: 'Australia and New Zealand',
                        continent: 'Oceania',
                        name: 'New Zealand',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'NZ'
                    }
                },
                {
                    arcs: [[[1247]], [[1248, 1249, 1250, -28]], [[-31, 1251]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'OMN',
                        iso_a2: 'OM',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Oman',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'OM'
                    }
                },
                {
                    arcs: [[-1041, -976, 1252, -983, -3, -520]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'PAK',
                        iso_a2: 'PK',
                        sub_region: 'Southern Asia',
                        continent: 'Asia',
                        name: 'Pakistan',
                        region_un: 'Asia',
                        region_wb: 'South Asia',
                        postal: 'PK'
                    }
                },
                {
                    arcs: [[[1253]], [[1254]], [[-558, 1255, -572, 1256]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'PAN',
                        iso_a2: 'PA',
                        sub_region: 'Central America',
                        continent: 'North America',
                        name: 'Panama',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'PA'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'PCN',
                        iso_a2: 'PN',
                        sub_region: 'Polynesia',
                        continent: 'Oceania',
                        name: 'Pitcairn Is.',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'PN'
                    }
                },
                {
                    arcs: [[-301, -276, 1257, -270, 1258, -274, -495, 1259, -634, -555]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'PER',
                        iso_a2: 'PE',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Peru',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'PE'
                    }
                },
                {
                    arcs: [
                        [[1260]],
                        [[1261]],
                        [[1262]],
                        [[1263]],
                        [[1264]],
                        [[1265]],
                        [[1266]],
                        [[1267]],
                        [[1268]],
                        [[1269]],
                        [[1270]],
                        [[1271]],
                        [[1272]],
                        [[1273]],
                        [[1274]],
                        [[1275]],
                        [[1276]],
                        [[1277]],
                        [[1278]],
                        [[1279]],
                        [[1280]],
                        [[1281]],
                        [[1282]],
                        [[1283]],
                        [[1284]],
                        [[1285]],
                        [[1286]],
                        [[1287]],
                        [[1288]],
                        [[1289]],
                        [[1290]],
                        [[1291]],
                        [[1292]],
                        [[1293]],
                        [[1294]],
                        [[1295]],
                        [[1296]],
                        [[1297]],
                        [[1298]],
                        [[1299]],
                        [[1300]],
                        [[1301]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'PHL',
                        iso_a2: 'PH',
                        sub_region: 'South-Eastern Asia',
                        continent: 'Asia',
                        name: 'Philippines',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'PH'
                    }
                },
                {
                    arcs: [[1302]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'PLW',
                        iso_a2: 'PW',
                        sub_region: 'Micronesia',
                        continent: 'Oceania',
                        name: 'Palau',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'PW'
                    }
                },
                {
                    arcs: [
                        [[1303]],
                        [[1304]],
                        [[1305]],
                        [[1306]],
                        [[1307]],
                        [[1308]],
                        [[1309]],
                        [[1310]],
                        [[1311]],
                        [[1312]],
                        [[1313]],
                        [[1314]],
                        [[1315]],
                        [[1316]],
                        [[1317]],
                        [[1318]],
                        [[1319]],
                        [[1320]],
                        [[1321]],
                        [[-923, 1322]],
                        [[1323]],
                        [[1324]],
                        [[1325]],
                        [[1326]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'PNG',
                        iso_a2: 'PG',
                        sub_region: 'Melanesia',
                        continent: 'Oceania',
                        name: 'Papua New Guinea',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'PG'
                    }
                },
                {
                    arcs: [[1327, -1100, -263, 1328, 1329, -587, -595, 1330, -591, 1331]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'POL',
                        iso_a2: 'PL',
                        sub_region: 'Eastern Europe',
                        continent: 'Europe',
                        name: 'Poland',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'PL'
                    }
                },
                {
                    arcs: [[1332]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'PRI',
                        iso_a2: 'PR',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Puerto Rico',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'PR'
                    }
                },
                {
                    arcs: [[1333, 1334, -1077, 1335, -507]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'PRK',
                        iso_a2: 'KP',
                        sub_region: 'Eastern Asia',
                        continent: 'Asia',
                        name: 'North Korea',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'KP'
                    }
                },
                {
                    arcs: [[[1336]], [[1337]], [[1338]], [[1339]], [[1340]], [[1341]], [[1342]], [[1343]], [[1344, -660]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'PRT',
                        iso_a2: 'PT',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Portugal',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'P'
                    }
                },
                {
                    arcs: [[-300, -36, -272]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'PRY',
                        iso_a2: 'PY',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Paraguay',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'PY'
                    }
                },
                {
                    arcs: [[[-636, 1345, -998]], [[-995, -1012]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'PSE',
                        iso_a2: 'PS',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Palestine',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'PAL'
                    }
                },
                {
                    arcs: [[[1346]], [[1347]], [[1348]], [[1349]], [[1350]], [[1351]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'PYF',
                        iso_a2: 'PF',
                        sub_region: 'Polynesia',
                        continent: 'Oceania',
                        name: 'Fr. Polynesia',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'PF'
                    }
                },
                {
                    arcs: [[1352, 1353]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'QAT',
                        iso_a2: 'QA',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Qatar',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'QA'
                    }
                },
                {
                    arcs: [[1354, 1355, -239, 1356, -837, 1357, -1110]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ROU',
                        iso_a2: 'RO',
                        sub_region: 'Eastern Europe',
                        continent: 'Europe',
                        name: 'Romania',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'RO'
                    }
                },
                {
                    arcs: [
                        [[1358]],
                        [[1359]],
                        [[1360]],
                        [[1361]],
                        [[1362, 1363]],
                        [[1364]],
                        [[1365]],
                        [[1366]],
                        [[1367]],
                        [[1368]],
                        [[1369]],
                        [[1370]],
                        [[1371]],
                        [[1372]],
                        [[1373]],
                        [[-1101, -1328, 1374, -1099, 1375]],
                        [[1376]],
                        [[1377]],
                        [[1378]],
                        [[1379]],
                        [[1380]],
                        [[1381]],
                        [[1382]],
                        [[1383]],
                        [[1384]],
                        [[1385]],
                        [[1386]],
                        [[1387]],
                        [[1388]],
                        [[1389]],
                        [[1390]],
                        [[1391]],
                        [[1392]],
                        [[1393]],
                        [[1394]],
                        [[1395]],
                        [[1396]],
                        [[1397]],
                        [[1398]],
                        [[1399]],
                        [[1400]],
                        [[1401]],
                        [[1402]],
                        [[1403]],
                        [[1404]],
                        [[1405]],
                        [[1406]],
                        [[1407]],
                        [[1408]],
                        [[1409]],
                        [[1410]],
                        [[1411]],
                        [[1412]],
                        [[1413]],
                        [[1414]],
                        [[1415]],
                        [[1416]],
                        [[1417]],
                        [
                            [
                                -1334,
                                -506,
                                1418,
                                -526,
                                -1152,
                                -524,
                                -1051,
                                1419,
                                -204,
                                -733,
                                1420,
                                1421,
                                -261,
                                -1104,
                                -667,
                                1422,
                                -665,
                                1423,
                                -678,
                                -1226,
                                1424
                            ]
                        ],
                        [[1425]],
                        [[1426]],
                        [[1427]],
                        [[1428]],
                        [[1429]],
                        [[1430]],
                        [[1431]],
                        [[1432]],
                        [[1433]],
                        [[1434]],
                        [[1435]],
                        [[1436]],
                        [[1437]],
                        [[1438]],
                        [[1439]],
                        [[1440]],
                        [[1441]],
                        [[1442]],
                        [[1443]],
                        [[1444]],
                        [[1445]],
                        [[1446]],
                        [[1447]],
                        [[1448]],
                        [[1449]],
                        [[1450]],
                        [[1451]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'RUS',
                        iso_a2: 'RU',
                        sub_region: 'Eastern Europe',
                        continent: 'Europe',
                        name: 'Russia',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'RUS'
                    }
                },
                {
                    arcs: [[1452, -208, -547, 1453, -545, 1454]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'RWA',
                        iso_a2: 'RW',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Rwanda',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'RW'
                    }
                },
                {
                    arcs: [[-1165, 1455, -1108, -623]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ESH',
                        iso_a2: 'EH',
                        sub_region: 'Northern Africa',
                        continent: 'Africa',
                        name: 'W. Sahara',
                        region_un: 'Africa',
                        region_wb: 'Middle East & North Africa',
                        postal: 'WS'
                    }
                },
                {
                    arcs: [[[1456]], [[1457]], [[-1082, 1458, -1353, 1459, -29, -1251, 1460, 1461, -1010, -989]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'SAU',
                        iso_a2: 'SA',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Saudi Arabia',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'SA'
                    }
                },
                {
                    arcs: [[1462, -646, -674, 1463, -315, 1464, -1091, -639]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SDN',
                        iso_a2: 'SD',
                        sub_region: 'Northern Africa',
                        continent: 'Africa',
                        name: 'Sudan',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'SD'
                    }
                },
                {
                    arcs: [[-673, -1058, 1465, -539, -316, -1464]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SSD',
                        iso_a2: 'SS',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'S. Sudan',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'SS'
                    }
                },
                {
                    arcs: [[-1131, -742, -749, 1466, -744, 1467, -1163]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SEN',
                        iso_a2: 'SN',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Senegal',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'SN'
                    }
                },
                {
                    arcs: [[1468]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SGP',
                        iso_a2: 'SG',
                        sub_region: 'South-Eastern Asia',
                        continent: 'Asia',
                        name: 'Singapore',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'SG'
                    }
                },
                {
                    arcs: [[1469]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SGS',
                        iso_a2: 'GS',
                        sub_region: 'Seven seas (open ocean)',
                        continent: 'Seven seas (open ocean)',
                        name: 'S. Geo. and the Is.',
                        region_un: 'Seven seas (open ocean)',
                        region_wb: 'Antarctica',
                        postal: 'GS'
                    }
                },
                {
                    arcs: [[[1470]], [[1471]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'SHN',
                        iso_a2: 'SH',
                        sub_region: 'Western Africa',
                        continent: 'Seven seas (open ocean)',
                        name: 'Saint Helena',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'SH'
                    }
                },
                {
                    arcs: [
                        [[1472]],
                        [[1473]],
                        [[1474]],
                        [[1475]],
                        [[1476]],
                        [[1477]],
                        [[1478]],
                        [[1479]],
                        [[1480]],
                        [[1481]],
                        [[1482]],
                        [[1483]],
                        [[1484]],
                        [[1485]],
                        [[1486]],
                        [[1487]],
                        [[1488]],
                        [[1489]],
                        [[1490]],
                        [[1491]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'SLB',
                        iso_a2: 'SB',
                        sub_region: 'Melanesia',
                        continent: 'Oceania',
                        name: 'Solomon Is.',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'SB'
                    }
                },
                {
                    arcs: [[[1492]], [[-1090, 1493, -739]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'SLE',
                        iso_a2: 'SL',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Sierra Leone',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'SL'
                    }
                },
                {
                    arcs: [[-818, 1494, -806]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SLV',
                        iso_a2: 'SV',
                        sub_region: 'Central America',
                        continent: 'North America',
                        name: 'El Salvador',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'SV'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'SMR',
                        iso_a2: 'SM',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'San Marino',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'RSM'
                    }
                },
                {
                    arcs: [[1495, -670, -602, 1496]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: '-99',
                        iso_a2: '-99',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Somaliland',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'SL'
                    }
                },
                {
                    arcs: [[-1053, -671, -1496, 1497]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SOM',
                        iso_a2: 'SO',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Somalia',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'SO'
                    }
                },
                {
                    arcs: [[1498]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SPM',
                        iso_a2: 'PM',
                        sub_region: 'Northern America',
                        continent: 'North America',
                        name: 'St. Pierre and Miquelon',
                        region_un: 'Americas',
                        region_wb: 'North America',
                        postal: 'PM'
                    }
                },
                {
                    arcs: [[-1357, -238, -1129, -1080, -1149, -256, -829, -838]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SRB',
                        iso_a2: 'RS',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Serbia',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'RS'
                    }
                },
                {
                    arcs: [[[1499]], [[1500]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'STP',
                        iso_a2: 'ST',
                        sub_region: 'Middle Africa',
                        continent: 'Africa',
                        name: 'São Tomé and Principe',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'ST'
                    }
                },
                {
                    arcs: [[-695, -294, -810, 1501]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SUR',
                        iso_a2: 'SR',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Suriname',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'SR'
                    }
                },
                {
                    arcs: [[1502, -840, -189, -588, -1330]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SVK',
                        iso_a2: 'SK',
                        sub_region: 'Eastern Europe',
                        continent: 'Europe',
                        name: 'Slovakia',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'SK'
                    }
                },
                {
                    arcs: [[-831, 1503, -1006, -191, -839]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SVN',
                        iso_a2: 'SI',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Slovenia',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'SLO'
                    }
                },
                {
                    arcs: [[[1504]], [[1505]], [[1506, -1227, -680]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'SWE',
                        iso_a2: 'SE',
                        sub_region: 'Northern Europe',
                        continent: 'Europe',
                        name: 'Sweden',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'S'
                    }
                },
                {
                    arcs: [[-1154, 1507]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SWZ',
                        iso_a2: 'SZ',
                        sub_region: 'Southern Africa',
                        continent: 'Africa',
                        name: 'Swaziland',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'SW'
                    }
                },
                {
                    arcs: [[-1106, 1508]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SXM',
                        iso_a2: 'SX',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Sint Maarten',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'SX'
                    }
                },
                {
                    arcs: [[1509]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SYC',
                        iso_a2: 'SC',
                        sub_region: 'Eastern Africa',
                        continent: 'Seven seas (open ocean)',
                        name: 'Seychelles',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'SC'
                    }
                },
                {
                    arcs: [[-991, -1013, -1001, -1088, 1510, 1511]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'SYR',
                        iso_a2: 'SY',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Syria',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'SYR'
                    }
                },
                {
                    arcs: [[[1512]], [[1513]], [[1514]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'TCA',
                        iso_a2: 'TC',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Turks and Caicos Is.',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'TC'
                    }
                },
                {
                    arcs: [[-1465, -320, -538, -1195, -1192, -1092]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'TCD',
                        iso_a2: 'TD',
                        sub_region: 'Middle Africa',
                        continent: 'Africa',
                        name: 'Chad',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'TD'
                    }
                },
                {
                    arcs: [[-219, 1515, -734, -223]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'TGO',
                        iso_a2: 'TG',
                        sub_region: 'Western Africa',
                        continent: 'Africa',
                        name: 'Togo',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'TG'
                    }
                },
                {
                    arcs: [
                        [[1516]],
                        [[1517]],
                        [[1518]],
                        [[1519]],
                        [[1520]],
                        [[1521]],
                        [[-1085, -1064, 1522, -1180, 1523, -1147]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'THA',
                        iso_a2: 'TH',
                        sub_region: 'South-Eastern Asia',
                        continent: 'Asia',
                        name: 'Thailand',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'TH'
                    }
                },
                {
                    arcs: [[[-1062]], [[-1059, -521, -7, 1524]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'TJK',
                        iso_a2: 'TJ',
                        sub_region: 'Central Asia',
                        continent: 'Asia',
                        name: 'Tajikistan',
                        region_un: 'Asia',
                        region_wb: 'Europe & Central Asia',
                        postal: 'TJ'
                    }
                },
                {
                    arcs: [[-5, -982, 1525, -1049, 1526, 1527, 1528]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'TKM',
                        iso_a2: 'TM',
                        sub_region: 'Central Asia',
                        continent: 'Asia',
                        name: 'Turkmenistan',
                        region_un: 'Asia',
                        region_wb: 'Europe & Central Asia',
                        postal: 'TM'
                    }
                },
                {
                    arcs: [[[1529, -846]], [[-848, 1530]], [[1531]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'TLS',
                        iso_a2: 'TL',
                        sub_region: 'South-Eastern Asia',
                        continent: 'Asia',
                        name: 'Timor-Leste',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'TL'
                    }
                },
                {
                    arcs: [[[1532]], [[1533]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'TON',
                        iso_a2: 'TO',
                        sub_region: 'Polynesia',
                        continent: 'Oceania',
                        name: 'Tonga',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'TO'
                    }
                },
                {
                    arcs: [[[1534]], [[1535]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'TTO',
                        iso_a2: 'TT',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'Trinidad and Tobago',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'TT'
                    }
                },
                {
                    arcs: [[[1536]], [[-1094, -618, 1537]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'TUN',
                        iso_a2: 'TN',
                        sub_region: 'Northern Africa',
                        continent: 'Africa',
                        name: 'Tunisia',
                        region_un: 'Africa',
                        region_wb: 'Middle East & North Africa',
                        postal: 'TN'
                    }
                },
                {
                    arcs: [[[1538]], [[-731, -44, -200, -986, -992, -1512, 1539]], [[1540, -785, -235]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'TUR',
                        iso_a2: 'TR',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Turkey',
                        region_un: 'Asia',
                        region_wb: 'Europe & Central Asia',
                        postal: 'TR'
                    }
                },
                {
                    arcs: [[[1541]], [[1542]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'TWN',
                        iso_a2: 'TW',
                        sub_region: 'Eastern Asia',
                        continent: 'Asia',
                        name: 'Taiwan',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'TW'
                    }
                },
                {
                    arcs: [
                        [[1543]],
                        [[1544]],
                        [[1545]],
                        [[1546]],
                        [[1547]],
                        [[1548, -1055, 1549, -1160, -1169, 1550, -1173, 1551, 1552, -205, -1453, 1553]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'TZA',
                        iso_a2: 'TZ',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Tanzania',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'TZ'
                    }
                },
                {
                    arcs: [[[1554]], [[1555]], [[1556, -1554, -1455, -544, 1557, -542, 1558, -540, -1466, -1057]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'UGA',
                        iso_a2: 'UG',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Uganda',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'UG'
                    }
                },
                {
                    arcs: [[[1559]], [[1560, -1364, 1561, -1355, -1111, -1358, -836, -1503, -1329, -262, -1422]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'UKR',
                        iso_a2: 'UA',
                        sub_region: 'Eastern Europe',
                        continent: 'Europe',
                        name: 'Ukraine',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'UA'
                    }
                },
                {
                    arcs: [[1562, -297, 1563, -38, -299]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'URY',
                        iso_a2: 'UY',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Uruguay',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'UY'
                    }
                },
                {
                    arcs: [
                        [[1564]],
                        [[1565]],
                        [[1566]],
                        [[1567]],
                        [[1568]],
                        [[1569]],
                        [[1570]],
                        [[1571]],
                        [[1572]],
                        [[1573]],
                        [[1574]],
                        [[1575]],
                        [[1576]],
                        [[1577]],
                        [[1578]],
                        [[1579]],
                        [[1580]],
                        [[1581]],
                        [[1582]],
                        [[1583]],
                        [[1584]],
                        [[1585]],
                        [[1586]],
                        [[1587]],
                        [[1588]],
                        [[1589]],
                        [[1590]],
                        [[1591]],
                        [[1592]],
                        [[1593]],
                        [[1594]],
                        [[1595]],
                        [[1596, -415, 1597, -413, 1598, -411, -339, 1599, -337, 1600, -1128, 1601, -417]],
                        [[1602]],
                        [[1603]],
                        [[1604]],
                        [[1605]],
                        [[1606]],
                        [[1607]],
                        [[1608]],
                        [[1609]],
                        [[1610]],
                        [[1611]],
                        [[1612]],
                        [[1613]],
                        [[1614]],
                        [[1615]],
                        [[1616]],
                        [[1617]],
                        [[1618]],
                        [[1619]],
                        [[1620]],
                        [[1621]],
                        [[1622]],
                        [[1623]],
                        [[1624]],
                        [[1625]],
                        [[1626]],
                        [[1627]],
                        [[1628]],
                        [[1629]],
                        [[1630]],
                        [[1631]],
                        [[1632]],
                        [[1633]],
                        [[1634]],
                        [[1635]],
                        [[1636]],
                        [[1637]],
                        [[1638]],
                        [[1639]],
                        [[1640]],
                        [[1641]],
                        [[1642]],
                        [[1643]],
                        [[1644]],
                        [[1645]],
                        [[1646]],
                        [[1647]],
                        [[1648]],
                        [[1649]],
                        [[1650]],
                        [[1651]],
                        [[1652]],
                        [[1653]],
                        [[1654]],
                        [[1655]],
                        [[1656]],
                        [[1657]],
                        [[-419, 1658, -363, 1659]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'USA',
                        iso_a2: 'US',
                        sub_region: 'Northern America',
                        continent: 'North America',
                        name: 'United States of America',
                        region_un: 'Americas',
                        region_wb: 'North America',
                        postal: 'US'
                    }
                },
                {
                    arcs: [[[-1061]], [[-1043, 1660, -1046, -1060, -1525, -6, -1529, 1661, -1527, -1048, 1662]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'UZB',
                        iso_a2: 'UZ',
                        sub_region: 'Central Asia',
                        continent: 'Asia',
                        name: 'Uzbekistan',
                        region_un: 'Asia',
                        region_wb: 'Europe & Central Asia',
                        postal: 'UZ'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'VAT',
                        iso_a2: 'VA',
                        sub_region: 'Southern Europe',
                        continent: 'Europe',
                        name: 'Vatican',
                        region_un: 'Europe',
                        region_wb: 'Europe & Central Asia',
                        postal: 'V'
                    }
                },
                {
                    arcs: [[1663]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'VCT',
                        iso_a2: 'VC',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'St. Vin. and Gren.',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'VC'
                    }
                },
                {
                    arcs: [[[1664]], [[1665]], [[1666]], [[1667]], [[-811, -303, -554, 1668]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'VEN',
                        iso_a2: 'VE',
                        sub_region: 'South America',
                        continent: 'South America',
                        name: 'Venezuela',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'VE'
                    }
                },
                {
                    type: null,
                    properties: {
                        iso_a3: 'VGB',
                        iso_a2: 'VG',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'British Virgin Is.',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'VG'
                    }
                },
                {
                    arcs: [[1669]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'VIR',
                        iso_a2: 'VI',
                        sub_region: 'Caribbean',
                        continent: 'North America',
                        name: 'U.S. Virgin Is.',
                        region_un: 'Americas',
                        region_wb: 'Latin America & Caribbean',
                        postal: 'VI'
                    }
                },
                {
                    arcs: [[[1670]], [[1671]], [[1672]], [[1673, -1066, -1084, -511]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'VNM',
                        iso_a2: 'VN',
                        sub_region: 'South-Eastern Asia',
                        continent: 'Asia',
                        name: 'Vietnam',
                        region_un: 'Asia',
                        region_wb: 'East Asia & Pacific',
                        postal: 'VN'
                    }
                },
                {
                    arcs: [
                        [[1674]],
                        [[1675]],
                        [[1676]],
                        [[1677]],
                        [[1678]],
                        [[1679]],
                        [[1680]],
                        [[1681]],
                        [[1682]],
                        [[1683]],
                        [[1684]],
                        [[1685]],
                        [[1686]],
                        [[1687]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'VUT',
                        iso_a2: 'VU',
                        sub_region: 'Melanesia',
                        continent: 'Oceania',
                        name: 'Vanuatu',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'VU'
                    }
                },
                {
                    arcs: [[1688]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'WLF',
                        iso_a2: 'WF',
                        sub_region: 'Polynesia',
                        continent: 'Oceania',
                        name: 'Wallis and Futuna Is.',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'WF'
                    }
                },
                {
                    arcs: [[[1689]], [[1690]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'WSM',
                        iso_a2: 'WS',
                        sub_region: 'Polynesia',
                        continent: 'Oceania',
                        name: 'Samoa',
                        region_un: 'Oceania',
                        region_wb: 'East Asia & Pacific',
                        postal: 'WS'
                    }
                },
                {
                    arcs: [[[1691]], [[1692]], [[1693, -1461, -1250]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'YEM',
                        iso_a2: 'YE',
                        sub_region: 'Western Asia',
                        continent: 'Asia',
                        name: 'Yemen',
                        region_un: 'Asia',
                        region_wb: 'Middle East & North Africa',
                        postal: 'YE'
                    }
                },
                {
                    arcs: [[[1694]], [[-1155, -1508, -1153, 1695, -1185, -313, 1696], [-1098]]],
                    type: 'MultiPolygon',
                    properties: {
                        iso_a3: 'ZAF',
                        iso_a2: 'ZA',
                        sub_region: 'Southern Africa',
                        continent: 'Africa',
                        name: 'South Africa',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'ZA'
                    }
                },
                {
                    arcs: [[-1552, -1172, -1157, 1698, 1699, 1700, -1184, -8, -549, 1701]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ZMB',
                        iso_a2: 'ZM',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Zambia',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'ZM'
                    }
                },
                {
                    arcs: [[-1699, -1156, -1697, -312, -1701, 1702, -1698, 1703]],
                    type: 'Polygon',
                    properties: {
                        iso_a3: 'ZWE',
                        iso_a2: 'ZW',
                        sub_region: 'Eastern Africa',
                        continent: 'Africa',
                        name: 'Zimbabwe',
                        region_un: 'Africa',
                        region_wb: 'Sub-Saharan Africa',
                        postal: 'ZW'
                    }
                }
            ]
        },
        states: {
            type: 'GeometryCollection',
            geometries: [
                {
                    arcs: [[[1704]], [[1705]], [[1706]], [[1707]], [[1708, 1709, 1710]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'WA',
                        name: 'Western Australia',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [
                        [[-1709, 1711, 1712, 1713]],
                        [[1714]],
                        [[1715]],
                        [[1716]],
                        [[1717]],
                        [[1718]],
                        [[1719]],
                        [[1720]],
                        [[1721]],
                        [[1722]],
                        [[1723]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'NT',
                        name: 'Northern Territory',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[[-1710, -1714, 1724, 1725, 1726, 1727]], [[1728]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'SA',
                        name: 'South Australia',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [
                        [[-1713, 1729, 1730, -1725]],
                        [[1731]],
                        [[1732]],
                        [[1733]],
                        [[1734]],
                        [[1735]],
                        [[1736]],
                        [[1737]],
                        [[1738]],
                        [[1739]],
                        [[1740]],
                        [[1741]],
                        [[1742]],
                        [[1743]],
                        [[1744]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'QL',
                        name: 'Queensland',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[[1745]], [[1746]], [[1747]], [[1748]], [[1749]], [[1750]], [[1751]], [[1752]], [[1753]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'TS',
                        name: 'Tasmania',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[[-1727, 1754, 1755]], [[1756]], [[1757]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'VI',
                        name: 'Victoria',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[1758]],
                    type: 'Polygon',
                    properties: {
                        postal: 'CT',
                        name: 'Australian Capital Territory',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[1759, 1760]],
                    type: 'Polygon',
                    properties: {
                        postal: 'JB',
                        name: 'Jervis Bay Territory',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1726, -1731, 1761, -1760, 1762, -1755], [-1759]],
                    type: 'Polygon',
                    properties: {
                        postal: 'NS',
                        name: 'New South Wales',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[1763, 1764, 1765]],
                    type: 'Polygon',
                    properties: {
                        postal: 'AC',
                        name: 'Acre',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1764, 1766, 1767, 1768]],
                    type: 'Polygon',
                    properties: {
                        postal: 'RO',
                        name: 'Rondônia',
                        region: '',
                        region_sub: 'Guaporé'
                    }
                },
                {
                    arcs: [[1769, 1770, 1771]],
                    type: 'Polygon',
                    properties: {
                        postal: 'RR',
                        name: 'Roraima',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1766, 1772, -1771, 1773, 1774, -1767]],
                    type: 'Polygon',
                    properties: {
                        postal: 'AM',
                        name: 'Amazonas',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [
                        [[-1770, 1775, 1776, 1777, 1778, 1779, 1780, -1774]],
                        [[1781]],
                        [[1782]],
                        [[1783]],
                        [[1784]],
                        [[1785]],
                        [[1786]],
                        [[1787]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'PA',
                        name: 'Pará',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[1788, 1789, 1790, 1791, 1792, 1793]],
                    type: 'Polygon',
                    properties: {
                        postal: 'MS',
                        name: 'Mato Grosso do Sul',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[[-1777, 1794]], [[1795]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'AP',
                        name: 'Amapá',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1768, -1775, -1781, 1796, 1797, -1794, 1798]],
                    type: 'Polygon',
                    properties: {
                        postal: 'MT',
                        name: 'Mato Grosso',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1792, 1799, 1800, 1801, 1802]],
                    type: 'Polygon',
                    properties: {
                        postal: 'PR',
                        name: 'Paraná',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[1803]],
                    type: 'Polygon',
                    properties: {
                        postal: 'DF',
                        name: 'Distrito Federal',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1789, -1798, 1804, 1805, 1806, -1804, 1807]],
                    type: 'Polygon',
                    properties: {
                        postal: 'GO',
                        name: 'Goiás',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1780, 1808, 1809, 1810, -1805, -1797]],
                    type: 'Polygon',
                    properties: {
                        postal: 'TO',
                        name: 'Tocantins',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[[-1791, 1811, 1812, 1813, -1800]], [[1814]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'SP',
                        name: 'São Paulo',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[[-1779, 1815, 1816, -1809]], [[1817]], [[1818]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'MA',
                        name: 'Maranhão',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[[-1813, 1819, 1820, 1821]], [[1822]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'RJ',
                        name: 'Rio de Janeiro',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1810, -1817, 1823, 1824, 1825, 1826]],
                    type: 'Polygon',
                    properties: {
                        postal: 'PI',
                        name: 'Piauí',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1790, -1808, -1807, 1827, 1828, -1820, -1812]],
                    type: 'Polygon',
                    properties: {
                        postal: 'MG',
                        name: 'Minas Gerais',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1821, -1829, 1829, 1830]],
                    type: 'Polygon',
                    properties: {
                        postal: 'ES',
                        name: 'Espírito Santo',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[[-1806, -1811, -1827, 1831, 1832, 1833, 1834, -1830, -1828]], [[1835]], [[1836]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'BA',
                        name: 'Bahia',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1825, 1837, 1838, 1839, 1840]],
                    type: 'Polygon',
                    properties: {
                        postal: 'CE',
                        name: 'Ceará',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1834, 1841, 1842]],
                    type: 'Polygon',
                    properties: {
                        postal: 'SE',
                        name: 'Sergipe',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1833, 1843, 1844, -1842]],
                    type: 'Polygon',
                    properties: {
                        postal: 'AL',
                        name: 'Alagoas',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1839, 1845, 1846]],
                    type: 'Polygon',
                    properties: {
                        postal: 'RN',
                        name: 'Rio Grande do Norte',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1826, -1841, 1847, 1848, -1844, -1832]],
                    type: 'Polygon',
                    properties: {
                        postal: 'PE',
                        name: 'Pernambuco',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1840, -1847, 1849, -1848]],
                    type: 'Polygon',
                    properties: {
                        postal: 'PB',
                        name: 'Paraíba',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[[-1802, 1850, 1851, 1852]], [[1853]], [[1854]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'SC',
                        name: 'Santa Catarina',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[-1852, 1855]],
                    type: 'Polygon',
                    properties: {
                        postal: 'RS',
                        name: 'Rio Grande do Sul',
                        region: '',
                        region_sub: ''
                    }
                },
                {
                    arcs: [[1856, 1857, 1858, 1859]],
                    type: 'Polygon',
                    properties: {
                        postal: 'AB',
                        name: 'Alberta',
                        region: 'Western Canada',
                        region_sub: 'Prairies'
                    }
                },
                {
                    arcs: [
                        [[-1858, 1860, 1861, 1862, 1863, 1864, 1865, 1866]],
                        [[1867]],
                        [[1868]],
                        [[1869]],
                        [[1870]],
                        [[1871]],
                        [[1872]],
                        [[1873]],
                        [[1874]],
                        [[1875]],
                        [[1876]],
                        [[1877]],
                        [[1878]],
                        [[1879]],
                        [[1880]],
                        [[1881]],
                        [[1882]],
                        [[1883]],
                        [[1884]],
                        [[1885]],
                        [[1886]],
                        [[1887, 1888]],
                        [[1889, 1890]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'BC',
                        name: 'British Columbia',
                        region: 'Western Canada',
                        region_sub: 'British Columbia'
                    }
                },
                {
                    arcs: [[1891, 1892, 1893, 1894, 1895, 1896]],
                    type: 'Polygon',
                    properties: {
                        postal: 'MB',
                        name: 'Manitoba',
                        region: 'Western Canada',
                        region_sub: 'Prairies'
                    }
                },
                {
                    arcs: [[[1897]], [[1898]], [[1899]], [[1900, 1901, 1902, 1903, 1904, 1905, 1906]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'NB',
                        name: 'New Brunswick',
                        region: 'Eastern Canada',
                        region_sub: 'Atlantic Canada'
                    }
                },
                {
                    arcs: [[[1907]], [[1908]], [[1909]], [[1910]], [[1911]], [[1912]], [[1913]], [[1914]], [[1915, 1916]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'NL',
                        name: 'Newfoundland and Labrador',
                        region: 'Eastern Canada',
                        region_sub: 'Atlantic Canada'
                    }
                },
                {
                    arcs: [[[-1901, 1917]], [[1918]], [[1919]], [[1920]], [[1921]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'NS',
                        name: 'Nova Scotia',
                        region: 'Eastern Canada',
                        region_sub: 'Atlantic Canada'
                    }
                },
                {
                    arcs: [
                        [[-1859, -1867, 1922, 1923, 1924, 1925]],
                        [[1926, 1927]],
                        [[1928]],
                        [[1929]],
                        [[1930]],
                        [[1931, 1932]],
                        [[1933, 1934]],
                        [[1935]],
                        [[1936]],
                        [[1937]],
                        [[1938, 1939]],
                        [[1940, 1941]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'NT',
                        name: 'Northwest Territories',
                        region: 'Northern Canada',
                        region_sub: ''
                    }
                },
                {
                    arcs: [
                        [[-1896, -1925, 1942]],
                        [[-1927, 1943]],
                        [[-1932, 1944, -1934, 1945]],
                        [[-1939, 1946]],
                        [[-1941, 1947]],
                        [[1948]],
                        [[1949]],
                        [[1950]],
                        [[1951]],
                        [[1952]],
                        [[1953]],
                        [[1954]],
                        [[1955]],
                        [[1956]],
                        [[1957]],
                        [[1958]],
                        [[1959]],
                        [[1960]],
                        [[1961]],
                        [[1962]],
                        [[1963]],
                        [[1964]],
                        [[1965]],
                        [[1966]],
                        [[1967]],
                        [[1968]],
                        [[1969]],
                        [[1970]],
                        [[1971]],
                        [[1972]],
                        [[1973]],
                        [[1974]],
                        [[1975]],
                        [[1976]],
                        [[1977]],
                        [[1978]],
                        [[1979]],
                        [[1980]],
                        [[1981]],
                        [[1982]],
                        [[1983]],
                        [[1984]],
                        [[1985]],
                        [[1986]],
                        [[1987]],
                        [[1988]],
                        [[1989]],
                        [[1990]],
                        [[1991]],
                        [[1992]],
                        [[1993]],
                        [[1994]],
                        [[1995]],
                        [[1996]],
                        [[1997]],
                        [[1998]],
                        [[1999]],
                        [[2000]],
                        [[2001]],
                        [[2002]],
                        [[2003]],
                        [[2004]],
                        [[2005]],
                        [[2006]],
                        [[2007]],
                        [[2008]],
                        [[2009]],
                        [[2010]],
                        [[2011]],
                        [[2012]],
                        [[2013]],
                        [[2014]],
                        [[2015]],
                        [[2016]],
                        [[2017]],
                        [[2018]],
                        [[2019]],
                        [[2020]],
                        [[2021]],
                        [[2022]],
                        [[2023]],
                        [[2024]],
                        [[2025]],
                        [[2026]],
                        [[2027]],
                        [[2028]],
                        [[2029]],
                        [[2030]],
                        [[2031]],
                        [[2032]],
                        [[2033]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'NU',
                        name: 'Nunavut',
                        region: 'Northern Canada',
                        region_sub: ''
                    }
                },
                {
                    arcs: [
                        [[-1892, 2034, 2035, 2036, 2037, 2038, 2039, 2040, 2041, 2042, 2043]],
                        [[2044]],
                        [[2045]],
                        [[2046]],
                        [[2047]],
                        [[2048]],
                        [[2049]],
                        [[2050]],
                        [[2051]],
                        [[2052]],
                        [[2053]],
                        [[2054]],
                        [[2055, 2056]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'ON',
                        name: 'Ontario',
                        region: 'Eastern Canada',
                        region_sub: 'Ontario'
                    }
                },
                {
                    arcs: [[2057]],
                    type: 'Polygon',
                    properties: {
                        postal: 'PE',
                        name: 'Prince Edward Island',
                        region: 'Eastern Canada',
                        region_sub: 'Atlantic Canada'
                    }
                },
                {
                    arcs: [
                        [[-1906, 2058, 2059, 2060, 2061, 2062]],
                        [[-1916, 2063, -2036, 2064, -2057, 2065]],
                        [[2066]],
                        [[2067]],
                        [[2068]],
                        [[2069]],
                        [[2070]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'QC',
                        name: 'Québec',
                        region: 'Eastern Canada',
                        region_sub: 'Québec'
                    }
                },
                {
                    arcs: [[-1860, -1926, -1895, 2071, 2072]],
                    type: 'Polygon',
                    properties: {
                        postal: 'SK',
                        name: 'Saskatchewan',
                        region: 'Western Canada',
                        region_sub: 'Prairies'
                    }
                },
                {
                    arcs: [[[-1866, 2073, 2074, -1923]], [[2075]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'YT',
                        name: 'Yukon',
                        region: 'Northern Canada',
                        region_sub: ''
                    }
                },
                {
                    arcs: [
                        [[-1889, 2076, -2074, -1865, -1890]],
                        [[2077]],
                        [[2078]],
                        [[2079]],
                        [[2080]],
                        [[2081]],
                        [[2082]],
                        [[2083]],
                        [[2084]],
                        [[2085]],
                        [[2086]],
                        [[2087]],
                        [[2088]],
                        [[2089]],
                        [[2090]],
                        [[2091]],
                        [[2092]],
                        [[2093]],
                        [[2094]],
                        [[2095]],
                        [[2096]],
                        [[2097]],
                        [[2098]],
                        [[2099]],
                        [[2100]],
                        [[2101]],
                        [[2102]],
                        [[2103]],
                        [[2104]],
                        [[2105]],
                        [[2106]],
                        [[2107]],
                        [[2108]],
                        [[2109]],
                        [[2110]],
                        [[2111]],
                        [[2112]],
                        [[2113]],
                        [[2114]],
                        [[2115]],
                        [[2116]],
                        [[2117]],
                        [[2118]],
                        [[2119]],
                        [[2120]],
                        [[2121]],
                        [[2122]],
                        [[2123]],
                        [[2124]],
                        [[2125]],
                        [[2126]],
                        [[2127]],
                        [[2128]],
                        [[2129]],
                        [[2130]],
                        [[2131]],
                        [[2132]],
                        [[2133]],
                        [[2134]],
                        [[2135]],
                        [[2136]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'AK',
                        name: 'Alaska',
                        region: 'West',
                        region_sub: 'Pacific'
                    }
                },
                {
                    arcs: [[[2137]], [[2138, 2139, 2140, 2141, 2142]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'AL',
                        name: 'Alabama',
                        region: 'South',
                        region_sub: 'East South Central'
                    }
                },
                {
                    arcs: [[2143, 2144, 2145, 2146, 2147, 2148]],
                    type: 'Polygon',
                    properties: {
                        postal: 'AR',
                        name: 'Arkansas',
                        region: 'South',
                        region_sub: 'West South Central'
                    }
                },
                {
                    arcs: [[2149, 2150, 2151, 2152, 2153]],
                    type: 'Polygon',
                    properties: {
                        postal: 'AZ',
                        name: 'Arizona',
                        region: 'West',
                        region_sub: 'Mountain'
                    }
                },
                {
                    arcs: [[[-2152, 2154, 2155, 2156]], [[2157]], [[2158]], [[2159]], [[2160]], [[2161]], [[2162]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'CA',
                        name: 'California',
                        region: 'West',
                        region_sub: 'Pacific'
                    }
                },
                {
                    arcs: [[2163, 2164, 2165, 2166, 2167, 2168]],
                    type: 'Polygon',
                    properties: {
                        postal: 'CO',
                        name: 'Colorado',
                        region: 'West',
                        region_sub: 'Mountain'
                    }
                },
                {
                    arcs: [[2169, 2170, 2171, 2172]],
                    type: 'Polygon',
                    properties: {
                        postal: 'CT',
                        name: 'Connecticut',
                        region: 'Northeast',
                        region_sub: 'New England'
                    }
                },
                {
                    arcs: [[2173, 2174]],
                    type: 'Polygon',
                    properties: {
                        postal: 'DC',
                        name: 'District of Columbia',
                        region: 'South',
                        region_sub: 'South Atlantic'
                    }
                },
                {
                    arcs: [[2175, 2176, 2177]],
                    type: 'Polygon',
                    properties: {
                        postal: 'DE',
                        name: 'Delaware',
                        region: 'South',
                        region_sub: 'South Atlantic'
                    }
                },
                {
                    arcs: [[[-2143, 2178, 2179]], [[2180]], [[2181]], [[2182]], [[2183]], [[2184]], [[2185]], [[2186]], [[2187]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'FL',
                        name: 'Florida',
                        region: 'South',
                        region_sub: 'South Atlantic'
                    }
                },
                {
                    arcs: [[[-2142, 2188, 2189, 2190, 2191, -2179]], [[2192]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'GA',
                        name: 'Georgia',
                        region: 'South',
                        region_sub: 'South Atlantic'
                    }
                },
                {
                    arcs: [[[2193]], [[2194]], [[2195]], [[2196]], [[2197]], [[2198]], [[2199]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'HI',
                        name: 'Hawaii',
                        region: 'West',
                        region_sub: 'Pacific'
                    }
                },
                {
                    arcs: [[2200, 2201, 2202, 2203, 2204, 2205]],
                    type: 'Polygon',
                    properties: {
                        postal: 'IA',
                        name: 'Iowa',
                        region: 'Midwest',
                        region_sub: 'West North Central'
                    }
                },
                {
                    arcs: [[-1862, 2206, 2207, 2208, 2209, 2210, 2211]],
                    type: 'Polygon',
                    properties: {
                        postal: 'ID',
                        name: 'Idaho',
                        region: 'West',
                        region_sub: 'Mountain'
                    }
                },
                {
                    arcs: [[-2201, 2212, 2213, 2214, 2215, 2216]],
                    type: 'Polygon',
                    properties: {
                        postal: 'IL',
                        name: 'Illinois',
                        region: 'Midwest',
                        region_sub: 'East North Central'
                    }
                },
                {
                    arcs: [[-2215, 2217, 2218, 2219, 2220]],
                    type: 'Polygon',
                    properties: {
                        postal: 'IN',
                        name: 'Indiana',
                        region: 'Midwest',
                        region_sub: 'East North Central'
                    }
                },
                {
                    arcs: [[-2164, 2221, 2222, 2223]],
                    type: 'Polygon',
                    properties: {
                        postal: 'KS',
                        name: 'Kansas',
                        region: 'Midwest',
                        region_sub: 'West North Central'
                    }
                },
                {
                    arcs: [[[-2216, -2221, 2224, 2225, 2226, 2227, 2228]], [[2229, 2230]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'KY',
                        name: 'Kentucky',
                        region: 'South',
                        region_sub: 'East South Central'
                    }
                },
                {
                    arcs: [[[-2146, 2231, 2232, 2233]], [[2234]], [[2235]], [[2236]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'LA',
                        name: 'Louisiana',
                        region: 'South',
                        region_sub: 'West South Central'
                    }
                },
                {
                    arcs: [[[-2173, 2237, 2238, 2239, 2240, 2241]], [[2242]], [[2243]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'MA',
                        name: 'Massachusetts',
                        region: 'Northeast',
                        region_sub: 'New England'
                    }
                },
                {
                    arcs: [[[-2175, 2244, 2245, 2246, -2177, 2247, 2248, 2249]], [[2250, 2251]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'MD',
                        name: 'Maryland',
                        region: 'South',
                        region_sub: 'South Atlantic'
                    }
                },
                {
                    arcs: [[[-1903, 2252, 2253, -2059, -1905, 2254]], [[2255]], [[2256]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'ME',
                        name: 'Maine',
                        region: 'Northeast',
                        region_sub: 'New England'
                    }
                },
                {
                    arcs: [
                        [[-2042, 2257, 2258, -2219, 2259]],
                        [[2260]],
                        [[2261]],
                        [[2262]],
                        [[2263]],
                        [[2264]],
                        [[2265]],
                        [[2266, 2267]],
                        [[2268]],
                        [[2269]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'MI',
                        name: 'Michigan',
                        region: 'Midwest',
                        region_sub: 'East North Central'
                    }
                },
                {
                    arcs: [[-1893, -2044, 2270, 2271, -2205, 2272, 2273]],
                    type: 'Polygon',
                    properties: {
                        postal: 'MN',
                        name: 'Minnesota',
                        region: 'Midwest',
                        region_sub: 'West North Central'
                    }
                },
                {
                    arcs: [[-2149, 2274, -2223, 2275, -2202, -2217, -2229, 2276, -2231, 2277]],
                    type: 'Polygon',
                    properties: {
                        postal: 'MO',
                        name: 'Missouri',
                        region: 'Midwest',
                        region_sub: 'West North Central'
                    }
                },
                {
                    arcs: [[[-2140, 2278, -2232, -2145, 2279]], [[2280]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'MS',
                        name: 'Mississippi',
                        region: 'South',
                        region_sub: 'East South Central'
                    }
                },
                {
                    arcs: [[-1857, -2073, 2281, 2282, 2283, -2207, -1861]],
                    type: 'Polygon',
                    properties: {
                        postal: 'MT',
                        name: 'Montana',
                        region: 'West',
                        region_sub: 'Mountain'
                    }
                },
                {
                    arcs: [[[-2190, 2284, 2285, 2286, 2287]], [[2288]], [[2289]], [[2290]], [[2291, 2292]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'NC',
                        name: 'North Carolina',
                        region: 'South',
                        region_sub: 'South Atlantic'
                    }
                },
                {
                    arcs: [[-1894, -2274, 2293, -2282, -2072]],
                    type: 'Polygon',
                    properties: {
                        postal: 'ND',
                        name: 'North Dakota',
                        region: 'Midwest',
                        region_sub: 'West North Central'
                    }
                },
                {
                    arcs: [[-2169, 2294, 2295, -2203, -2276, -2222]],
                    type: 'Polygon',
                    properties: {
                        postal: 'NE',
                        name: 'Nebraska',
                        region: 'Midwest',
                        region_sub: 'West North Central'
                    }
                },
                {
                    arcs: [[-2060, -2254, 2296, -2240, 2297]],
                    type: 'Polygon',
                    properties: {
                        postal: 'NH',
                        name: 'New Hampshire',
                        region: 'Northeast',
                        region_sub: 'New England'
                    }
                },
                {
                    arcs: [[[2298]], [[2299, 2300, 2301]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'NJ',
                        name: 'New Jersey',
                        region: 'Northeast',
                        region_sub: 'Middle Atlantic'
                    }
                },
                {
                    arcs: [[-2150, -2166, 2302, 2303, 2304]],
                    type: 'Polygon',
                    properties: {
                        postal: 'NM',
                        name: 'New Mexico',
                        region: 'West',
                        region_sub: 'Mountain'
                    }
                },
                {
                    arcs: [[-2153, -2157, 2305, -2210, 2306]],
                    type: 'Polygon',
                    properties: {
                        postal: 'NV',
                        name: 'Nevada',
                        region: 'West',
                        region_sub: 'Mountain'
                    }
                },
                {
                    arcs: [
                        [[-2038, -2062, 2307, -2238, -2172, 2308, -2301, 2309, 2310, -2040, 2311]],
                        [[2312]],
                        [[2313]],
                        [[2314]]
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'NY',
                        name: 'New York',
                        region: 'Northeast',
                        region_sub: 'Middle Atlantic'
                    }
                },
                {
                    arcs: [[-2220, -2259, 2315, 2316, 2317, -2225]],
                    type: 'Polygon',
                    properties: {
                        postal: 'OH',
                        name: 'Ohio',
                        region: 'Midwest',
                        region_sub: 'East North Central'
                    }
                },
                {
                    arcs: [[-2148, 2318, -2303, -2165, -2224, -2275]],
                    type: 'Polygon',
                    properties: {
                        postal: 'OK',
                        name: 'Oklahoma',
                        region: 'South',
                        region_sub: 'West South Central'
                    }
                },
                {
                    arcs: [[-2156, 2319, 2320, -2211, -2306]],
                    type: 'Polygon',
                    properties: {
                        postal: 'OR',
                        name: 'Oregon',
                        region: 'West',
                        region_sub: 'Pacific'
                    }
                },
                {
                    arcs: [[-2178, -2247, 2321, -2317, 2322, -2310, -2300, 2323]],
                    type: 'Polygon',
                    properties: {
                        postal: 'PA',
                        name: 'Pennsylvania',
                        region: 'Northeast',
                        region_sub: 'Middle Atlantic'
                    }
                },
                {
                    arcs: [[[-2170, -2242, 2324]], [[2325]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'RI',
                        name: 'Rhode Island',
                        region: 'Northeast',
                        region_sub: 'New England'
                    }
                },
                {
                    arcs: [[-2191, -2288, 2326]],
                    type: 'Polygon',
                    properties: {
                        postal: 'SC',
                        name: 'South Carolina',
                        region: 'South',
                        region_sub: 'South Atlantic'
                    }
                },
                {
                    arcs: [[-2204, -2296, 2327, -2283, -2294, -2273]],
                    type: 'Polygon',
                    properties: {
                        postal: 'SD',
                        name: 'South Dakota',
                        region: 'Midwest',
                        region_sub: 'West North Central'
                    }
                },
                {
                    arcs: [[-2141, -2280, -2144, -2278, -2230, -2277, -2228, 2328, -2285, -2189]],
                    type: 'Polygon',
                    properties: {
                        postal: 'TN',
                        name: 'Tennessee',
                        region: 'South',
                        region_sub: 'East South Central'
                    }
                },
                {
                    arcs: [[[-2147, -2234, 2329, -2304, -2319]], [[2330]], [[2331]], [[2332]], [[2333]], [[2334]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'TX',
                        name: 'Texas',
                        region: 'South',
                        region_sub: 'West South Central'
                    }
                },
                {
                    arcs: [[-2154, -2307, -2209, 2335, -2167]],
                    type: 'Polygon',
                    properties: {
                        postal: 'UT',
                        name: 'Utah',
                        region: 'West',
                        region_sub: 'Mountain'
                    }
                },
                {
                    arcs: [[[-2174, 2336, -2292, 2337, -2286, -2329, -2227, 2338, -2245]], [[-2251, 2339]], [[-2249, 2340]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'VA',
                        name: 'Virginia',
                        region: 'South',
                        region_sub: 'South Atlantic'
                    }
                },
                {
                    arcs: [[-2061, -2298, -2239, -2308]],
                    type: 'Polygon',
                    properties: {
                        postal: 'VT',
                        name: 'Vermont',
                        region: 'Northeast',
                        region_sub: 'New England'
                    }
                },
                {
                    arcs: [[[-1863, -2212, -2321, 2341]], [[2342]], [[2343]], [[2344]], [[2345]], [[2346]], [[2347]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'WA',
                        name: 'Washington',
                        region: 'West',
                        region_sub: 'Pacific'
                    }
                },
                {
                    arcs: [[[-2206, -2272, 2348, -2267, 2349, -2213]], [[2350]], [[2351]], [[2352]], [[2353]]],
                    type: 'MultiPolygon',
                    properties: {
                        postal: 'WI',
                        name: 'Wisconsin',
                        region: 'Midwest',
                        region_sub: 'East North Central'
                    }
                },
                {
                    arcs: [[-2226, -2318, -2322, -2246, -2339]],
                    type: 'Polygon',
                    properties: {
                        postal: 'WV',
                        name: 'West Virginia',
                        region: 'South',
                        region_sub: 'South Atlantic'
                    }
                },
                {
                    arcs: [[-2168, -2336, -2208, -2284, -2328, -2295]],
                    type: 'Polygon',
                    properties: {
                        postal: 'WY',
                        name: 'Wyoming',
                        region: 'West',
                        region_sub: 'Mountain'
                    }
                }
            ]
        }
    }
};
// convert JSON keys to lowercase
// replace regex "(\w+)"\s*: with "\L$1":
/*
For mapshaper, apply the following console command

-each 'this.properties =
{
    iso_a2: this.properties.ISO_A2,
    iso_a3: this.properties.ISO_A3,
    sub_region: this.properties.SUBREGION,
    continent: this.properties.CONTINENT,
    name: this.properties.NAME,
    region_un: this.properties.REGION_UN,
    region_wb: this.properties.REGION_WB,
    postal: this.properties.POSTAL
}'

// for US map
-each 'this.properties = {
    postal: this.properties.postal,
    name: this.properties.name,
    region: this.properties.region,
    region_sub: this.properties.region_sub
}'
*/
class BentoD3DataMapComponentWorld50 {
    get data() {
        const regionsMap = {
            'North America': 'NA',
            'South America': 'SA',
            Europe: 'EU',
            Africa: 'AF',
            Oceania: 'OC',
            Asia: 'AS',
            Antarctica: 'AC'
        };
        data.objects.countries.geometries.forEach(item => {
            item.properties['continent_code'] = regionsMap[item.properties.continent];
        });
        return data;
    }
}
BentoD3DataMapComponentWorld50.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoD3DataMapComponentWorld50, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BentoD3DataMapComponentWorld50.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoD3DataMapComponentWorld50 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoD3DataMapComponentWorld50, decorators: [{
            type: Injectable
        }] });

class BentoDataMapService {
    flattenObject(obj) {
        const toReturn = {};
        let flatObject;
        for (const i in obj) {
            if (!obj.hasOwnProperty(i)) {
                continue;
            }
            if (typeof obj[i] === 'object') {
                flatObject = this.flattenObject(obj[i]);
                for (const x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) {
                        continue;
                    }
                    toReturn[i + (isNaN(Number(x)) ? '.' + x : '')] = flatObject[x];
                }
            }
            else {
                toReturn[i] = obj[i];
            }
        }
        return toReturn;
    }
}
BentoDataMapService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDataMapService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BentoDataMapService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDataMapService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDataMapService, decorators: [{
            type: Injectable
        }] });

const bentoDataMapInitialLat = 22.5;
const bentoDataMapZoomOptions = {
    scaleFactor: 1,
    center: {
        lat: bentoDataMapInitialLat,
        lng: 0
    },
    translate: {
        x: 0,
        y: 0
    },
    transition: {
        duration: 300
    },
    onZoomComplete: () => { }
};
/**
 * #### Requires BentoD3DataMapModule from `@bento/bento-ng-datamap`
 * DataMap is an interactive world/USA map
 * with support for choropleths, zoom and drag, SVG overlays, custom topoJSON overlays and arc line overlays.
 * Please note, to have data visualized on the world map, the data
 * will need to have the three letter country code included
 * ([ISO 3166 alpha-3](http://en.wikipedia.org/wiki/ISO_3166-1_alpha-3)).
 *
 * The base map uses canvas in lieu of SVG for a smoother pan and zoom experience.
 * It also allows for greater fidelity in geographic features, such that small but significant countries like Bahrain and Singapore
 * are duly represented. If you need to create a custom SVG overlay, this DataMap will also allow you to do so.
 *
 * One caveat of using canvas is that it comes with a cost to the initial rendering time.
 * In future interations, we'll be exploring the use of web workers to handle the process of converting topoJSON data into canvas paths.
 *
 * **IMPORTANT:** In addition to the following dependencies in your node modules
 *([D3 library](http://d3js.org/), [d3-geo-projection](https://github.com/d3/d3-geo-projection) and
 * [topoJSON](https://github.com/topojson/topojson)),
 * please make sure to import the below modules for this component to work:
```typescript
import { BentoModule } from '@bento/bento-ng';
import { BentoD3DataMapModule } from '@bento/bento-ng-datamap';
```
 */
class BentoD3DataMapComponent {
    constructor(elRef, world50, http, dataMapService, windowRef, sanitizer, bentoNotification) {
        this.world50 = world50;
        this.http = http;
        this.dataMapService = dataMapService;
        this.windowRef = windowRef;
        this.sanitizer = sanitizer;
        /**
         * Click event handler (returns country/state object)
         */
        this.onDataMapClick = new EventEmitter();
        /**
         * Mouse over event handler (returns country/state object)
         */
        this.onDataMapHover = new EventEmitter();
        this.tooltipID = 'd3-tooltip-' + Math.round(Math.random() * 1000000);
        this.isBusyLoaderBusy = true;
        this._hasInit = false;
        this._defaultColor = '#cccccc';
        this._defaultStrokeColor = '#1f1f1f';
        this._defaultStrokeWidth = 1;
        this._tlast = { x: 0, y: 0 };
        this._ratio = 480 / 960;
        this._zoomExtent = [1, 50];
        this._colorToPath = {}; // map to track the colur of paths
        this._nextColor = 1;
        this._lastMouseOverObj = {};
        this._arcElements = [];
        this._featuresElements = [];
        this._pixelRatio = 2;
        this._hasResized = true;
        this.nativeEl = elRef.nativeElement;
        this._pixelRatio = windowRef.nativeWindow.devicePixelRatio || this._pixelRatio;
        bentoNotification.resizeNotification.subscribe(() => this._onResize());
        this._flatOptions = this.dataMapService.flattenObject(this.options);
    }
    ngAfterViewInit() {
        this._barTip = d3.select('#' + this.tooltipID);
        this._barTipNode = this.windowRef.nativeDocument.getElementById(this.tooltipID);
        this._onInit();
        this._onResize();
    }
    ngOnChanges(changes) {
        if (changes.options) {
            this._flatOptions = this.dataMapService.flattenObject(changes.options.currentValue);
            // TODO: Use deep extend, perhaps use lodash
            if (this._hasInit) {
                this._onResize();
            }
        }
    }
    /**
     * Zoom to a specific coordinate on the map
     */
    zoomTo(zoomOptions) {
        const self = this;
        if (!this._canvas.attr('data-width')) {
            return;
        }
        const options = { ...bentoDataMapZoomOptions, ...zoomOptions }; // shallow merge
        // if USA, change lat lng center point of map
        if (this.options.scope === 'usa') {
            if (options.center.lat === bentoDataMapInitialLat && options.center.lng === 0) {
                options.center = {
                    lat: 39,
                    lng: -97
                };
            }
        }
        if (options.scaleFactor < 0) {
            throw Error('Cannot zoom to a negative scale');
        }
        const centerCoordsXY = this.projection([options.center.lng, options.center.lat]);
        // Assume that the old center will be at the center of the svg element
        const oldCenterCoordsXY = [this.nativeEl.offsetWidth / 2, this.nativeEl.offsetHeight / 2];
        const newsize = self.nativeEl.clientWidth;
        const oldsize = self._canvas.attr('data-width') || newsize;
        const s = (options.scaleFactor * newsize) / oldsize;
        // Calculate the overall desired translation accounting for scale.
        // All we need to do is move from the old center point to the new
        // center point and multiply by the scaling factor.
        const t = {
            x: -centerCoordsXY[0],
            y: -centerCoordsXY[1]
        };
        const transX = t.x + options.translate.x;
        const transY = t.y + options.translate.y;
        this._canvas
            .transition()
            .duration(options.transition.duration)
            .call(this._zoom.transform, () => d3.zoomIdentity.translate(oldCenterCoordsXY[0], oldCenterCoordsXY[1]).scale(s).translate(transX, transY));
        return this;
    }
    /**
     * Call this method after updating data to refresh the visual representation
     */
    refresh() {
        this._flatOptions = this.dataMapService.flattenObject(this.options);
        this._removeAll();
        this._onInit();
        this._onResize();
        return this;
    }
    /**
     * Dynamically change fills of countries or states
     */
    updateChoropleth(data) {
        if (data && Object.keys(data).length > 0 && data.constructor === Object) {
            this._currentChoropleth = data;
            this._redraw();
        }
        return this;
    }
    /**
     * Draw arc lines
     */
    arc(data) {
        if (data) {
            this._arcData = data;
            this._recalculateArcPath();
            this._redraw();
        }
    }
    zoomIn() {
        this._zoomInOut(1.5);
        return this;
    }
    zoomOut() {
        this._zoomInOut(1 / 1.5);
        return this;
    }
    _zoomInOut(num) {
        this._zoom.scaleBy(this._canvas.transition().duration(300), num);
    }
    _removeAll() {
        const canvasElements = this.nativeEl.querySelectorAll('canvas');
        const svgElemenets = this.nativeEl.querySelectorAll('svg');
        canvasElements.forEach(canvasEl => {
            this.nativeEl.removeChild(canvasEl);
        });
        svgElemenets.forEach(svgEl => {
            this.nativeEl.removeChild(svgEl);
        });
    }
    _onInit() {
        this._hasInit = true;
        this._featuresCountry = [];
        this._featuresState = [];
        this._featuresCustom = [];
        // if projection property exists in options
        // check if d3 geo exists, else check if geoProjection exists
        // else default to geoMiller
        this.projection = this.options.projection
            ? (d3[this.options.projection] ? d3[this.options.projection]() : undefined) ||
                (geoProjection[this.options.projection] ? geoProjection[this.options.projection]() : undefined) ||
                geoProjection.geoMiller()
            : geoProjection.geoMiller();
        this._path = d3.geoPath(this.projection);
        const self = this;
        this._zoom = d3
            .zoom()
            .scaleExtent(self._zoomExtent)
            .on('zoom', () => {
            self._redraw();
        });
        this._canvas = d3
            .select(this.nativeEl)
            .append('canvas')
            .call(this._zoom)
            .on('mousemove', () => {
            this._onCanvasMouseMove();
        })
            .on('mouseout', () => {
            this._onMouseOut();
        })
            .on('click', () => {
            this._onCanvasClick();
        });
        if (this.options && this.options.svg) {
            // clear out any old svg
            d3.select(this.nativeEl).select('svg').remove();
            this._svg = d3.select(this.nativeEl).append('svg');
            this.svgGroup = this._svg.append('g').attr('class', 'world');
        }
        this._canvasContext = this._canvas.node().getContext('2d');
        this._canvasHidden = d3.select(this.nativeEl).append('canvas');
        this._canvasHiddenContext = this._canvasHidden.node().getContext('2d');
        // COUNTRIES
        if (this.options.scope && this.options.scope.indexOf('world') >= 0) {
            this._featuresCountry = topojson.feature(this.world50.data, this.world50.data.objects.countries).features;
        }
        // USA or CANADA
        if (this.options.scope && (this.options.scope.indexOf('usa') >= 0 || this.options.scope.indexOf('can') >= 0)) {
            this._featuresState = topojson.feature(this.world50.data, this.world50.data.objects.states).features;
        }
        if (this.options.customTopo && this.options.customTopo.dataUrl) {
            this.http.get(this.options.customTopo.dataUrl).subscribe(res => {
                const result = res;
                const resultObj = result.objects[Object.keys(result.objects)[0]];
                if (resultObj) {
                    this._featuresCustom = topojson.feature(result, resultObj).features;
                    this._redraw();
                }
            });
        }
        this._recalculatePath();
        this._recalculateArcPath();
        this._redraw();
        if (this.options.done) {
            this.options.done(this);
        }
    }
    _recalculatePath() {
        this.isBusyLoaderBusy = true;
        this._nextColor = 1;
        let strokeWidth = this._flatOptions['geographyConfig.strokeWidth'] || 0;
        let strokeColor = this._flatOptions['geographyConfig.strokeColor'] || '';
        if (this._hasResized || (this._featuresElements && this._featuresElements.length < 1)) {
            this._featuresElements = [];
            this._featuresCountry.forEach((item, i) => {
                this._addToFeaturesElement(item, 'country', { strokeWidth, strokeColor });
            });
            this._featuresState.forEach((item, i) => {
                this._addToFeaturesElement(item, 'state', { strokeWidth, strokeColor });
            });
            this._hasResized = false;
        }
        strokeWidth = this._flatOptions['customTopo.geographyConfig.strokeWidth'] || strokeWidth;
        strokeColor = this._flatOptions['customTopo.geographyConfig.strokeColor'] || strokeColor;
        this._featuresCustom.forEach((item, i) => {
            this._addToFeaturesElement(item, 'custom', { strokeWidth, strokeColor });
        });
        setTimeout(() => {
            this.isBusyLoaderBusy = false;
        });
    }
    _addToFeaturesElement(item, region, stroke) {
        const path = this._path(item);
        const p = new Path2D(path);
        const color = this._genColor();
        this._colorToPath[color] = item;
        this._featuresElements.push({
            d: item,
            hiddenFill: color,
            p,
            region,
            stroke
        });
    }
    _recalculateArcPath() {
        if (this._arcData) {
            this._arcElements = [];
            this._arcData.forEach(item => {
                const originXY = this.projection([item.origin.lng, item.origin.lat]);
                const destXY = this.projection([item.destination.lng, item.destination.lat]);
                const mx = (destXY[0] + originXY[0]) / 2;
                const my = (destXY[1] + originXY[1]) / 2;
                const dx = destXY[0] - originXY[0];
                const dy = destXY[1] - originXY[1];
                const dr = Math.sqrt(dx * dx + dy * dy) * 0.27;
                const angleRadian = Math.atan2(destXY[1] - originXY[1], destXY[0] - originXY[0]) + (-90 * Math.PI) / 180;
                const cx = mx + dr * Math.cos(angleRadian);
                const cy = my + dr * Math.sin(angleRadian);
                const controlXY = [cx, cy];
                const controlRadian = Math.atan2(destXY[1] - controlXY[1], destXY[0] - controlXY[0]) + (90 * Math.PI) / 180;
                this._arcElements.push({
                    originXY,
                    destXY,
                    controlXY,
                    options: item.options,
                    angle: controlRadian
                });
            });
        }
    }
    _onResize() {
        this._hasResized = true;
        this._redraw();
    }
    _redraw() {
        const width = this.nativeEl.getBoundingClientRect().width || 300;
        const height = width * this._ratio;
        let elScale = (width / 960) * 153;
        let heightDivisor = 1.57;
        // set up the scale extent and initial scale for the projection
        const transform = d3.zoomTransform(this._canvas.node());
        const currentMatrix = {
            x: transform.x,
            y: transform.y,
            k: transform.k
        };
        if (transform.k === 1) {
            currentMatrix.x = currentMatrix.y = 0;
        }
        if (d3.event) {
            const t = d3.event.transform;
            if (t) {
                const tx = Math.min(0, Math.max(t.x, width - width * t.k));
                const ty = Math.min(0, Math.max(t.y, height - height * t.k));
                currentMatrix.x = tx;
                currentMatrix.y = ty;
                currentMatrix.k = t.k;
            }
        }
        else {
            if (this.options.projection) {
                elScale = (width / 960) * 100;
                if (this.options.projection === 'geoAlbersUsa') {
                    elScale = (width / 960) * 1000;
                }
                heightDivisor = 2;
            }
            this.projection.scale(elScale);
            this._tlast = { x: width / 2, y: height / heightDivisor };
            this.projection.translate([this._tlast.x, this._tlast.y]);
            this._recalculatePath();
            this._recalculateArcPath();
        }
        this._canvas
            .attr('data-width', width)
            .attr('width', width * this._pixelRatio)
            .attr('height', height * this._pixelRatio)
            .style('width', width + 'px')
            .style('height', height + 'px');
        this._canvasHidden
            .attr('data-width', width)
            .attr('class', 'hidden-canvas')
            .attr('width', width)
            .attr('height', height);
        if (this._svg) {
            this._svg.attr('width', width).attr('height', height);
            this.svgGroup.attr('transform', ['translate(' + [currentMatrix.x, currentMatrix.y] + ')', 'scale(' + currentMatrix.k + ')'].join(' '));
        }
        if (this.options && this.options.onDrawing) {
            this.options.onDrawing(currentMatrix);
        }
        this._drawCanvas(currentMatrix);
    }
    _drawCanvas(matrix) {
        const context = this._canvasContext;
        const contextHidden = this._canvasHiddenContext;
        context.fillStyle = '#fff';
        context.rect(0, 0, this._canvas.attr('width'), this._canvas.attr('height'));
        context.transform(matrix.k * this._pixelRatio, 0, 0, matrix.k * this._pixelRatio, matrix.x * this._pixelRatio, matrix.y * this._pixelRatio);
        contextHidden.fillStyle = '#fff';
        contextHidden.rect(0, 0, this._canvasHidden.attr('width'), this._canvas.attr('height'));
        contextHidden.transform(matrix.k, 0, 0, matrix.k, matrix.x, matrix.y);
        // Draw all regional elements
        this._featuresElements.forEach(item => {
            this._drawFeature(context, contextHidden, item, matrix);
        });
        // Draw any arc data
        this._arcElements.forEach(item => {
            this._drawArc(context, item, matrix);
        });
    }
    _drawFeature(context, contextHidden, item, matrix) {
        context.beginPath();
        context.fillStyle = this._currentChoropleth
            ? this._getChoroplethColor(this._currentChoropleth, item.d, item.region) || this._getFillColor(item.d)
            : this._getFillColor(item.d);
        context.lineWidth = 0;
        if (item.stroke && (item.stroke.strokeColor || item.stroke.strokeWidth)) {
            context.lineWidth = item.stroke.strokeWidth / matrix.k || 0;
            context.strokeStyle = item.stroke.strokeColor || '#ffffff';
            context.stroke(item.p);
        }
        context.fill(item.p);
        context.closePath();
        contextHidden.beginPath();
        contextHidden.fillStyle = item.hiddenFill;
        contextHidden.lineWidth = 0;
        contextHidden.fill(item.p);
        contextHidden.closePath();
    }
    _drawArc(context, item, matrix) {
        context.beginPath();
        context.lineWidth =
            (item.options && item.options.strokeWidth ? item.options.strokeWidth : this._defaultStrokeWidth) / matrix.k;
        context.fillStyle = context.strokeStyle =
            item.options && item.options.strokeColor ? item.options.strokeColor : this._defaultStrokeColor;
        context.lineCap = item.options && item.options.lineCap ? item.options.lineCap : 'round';
        context.moveTo(item.originXY[0], item.originXY[1]);
        context.quadraticCurveTo(item.controlXY[0], item.controlXY[1], item.destXY[0], item.destXY[1]);
        context.stroke();
        this._drawCirclehead(context, item.originXY[0], item.originXY[1]);
        this._drawArrowhead(context, item.destXY[0], item.destXY[1], item.angle);
        context.closePath();
    }
    _drawCirclehead(ctx, x, y) {
        const scale = ctx.lineWidth;
        ctx.beginPath();
        ctx.arc(x, y, 1 * scale, 0, Math.PI * 2, false);
        ctx.closePath();
        ctx.fill();
        ctx.beginPath();
        ctx.arc(x, y, 2 * scale, 0, Math.PI * 2, false);
        ctx.closePath();
        ctx.stroke();
    }
    _drawArrowhead(ctx, x, y, radians) {
        const arrowScale = 1 / ctx.lineWidth;
        ctx.save();
        ctx.beginPath();
        ctx.translate(x, y);
        ctx.rotate(radians);
        ctx.moveTo(0, 0);
        ctx.lineTo(3 / arrowScale, 6 / arrowScale);
        ctx.lineTo(-3 / arrowScale, 6 / arrowScale);
        ctx.closePath();
        ctx.restore();
        ctx.fill();
    }
    _genColor() {
        const ret = [];
        // via http://stackoverflow.com/a/15804183
        /* eslint-disable  no-bitwise */
        if (this._nextColor < 16777215) {
            ret.push(this._nextColor & 0xff); // R
            ret.push((this._nextColor & 0xff00) >> 8); // G
            ret.push((this._nextColor & 0xff0000) >> 16); // B
            this._nextColor += 1000;
        }
        const col = 'rgb(' + ret.join(',') + ')';
        return col;
    }
    _getFillColor(d) {
        const defaultFill = this._flatOptions['fills.defaultFill'] || this._defaultColor;
        const a3 = d.properties ? d.properties.iso_a3 || '' : '';
        const fillKey = this._flatOptions['data.' + a3 + '.fillKey'];
        const postal = d.properties ? d.properties.postal || '' : '';
        const postalFillKey = this._flatOptions['data.' + postal + '.fillKey'];
        const continent = d.properties ? d.properties.continent || '' : '';
        const continentFillKey = this._flatOptions['data.' + continent + '.fillKey'];
        const continentCode = d.properties ? d.properties.continent_code || '' : '';
        const continentCodeFillKey = this._flatOptions['data.' + continentCode + '.fillKey'];
        const customTopoKey = this._flatOptions['customTopo.regionLabel']
            ? d.properties[this._flatOptions['customTopo.regionLabel']]
            : undefined;
        const customTopoFillKey = this._flatOptions['data.' + customTopoKey + '.fillKey'];
        // if current country has a3 country code and fillkey option exists
        // else if current country has continent code and fillkey option exists
        if (customTopoKey && customTopoFillKey) {
            return this._flatOptions['fills.' + customTopoFillKey] || defaultFill;
        }
        else if (a3 && fillKey) {
            return this._flatOptions['fills.' + fillKey] || defaultFill;
        }
        else if (continent && continentFillKey) {
            return this._flatOptions['fills.' + continentFillKey] || defaultFill;
        }
        else if (continentCode && continentCodeFillKey) {
            return this._flatOptions['fills.' + continentCodeFillKey] || defaultFill;
        }
        else if (postal && postalFillKey) {
            return this._flatOptions['fills.' + postalFillKey] || defaultFill;
        }
        else {
            return defaultFill;
        }
    }
    _getChoroplethColor(data, d, region) {
        let a3 = d.properties ? d.properties.iso_a3 || '' : '';
        if (region === 'custom') {
            a3 =
                d.properties && this.options.customTopo && this.options.customTopo.regionLabel
                    ? d.properties[this.options.customTopo.regionLabel] || ''
                    : '';
        }
        if (region === 'state') {
            a3 = d.properties ? d.properties['postal'] || '' : '';
        }
        const fillKey = data[a3];
        // if current country has a3 country code and fillkey option exists
        if (a3 && fillKey) {
            return fillKey;
        }
        return undefined;
    }
    _onMouseOver(d) {
        this.onDataMapHover.emit(d);
        if (this._flatOptions['geographyConfig.popupOnHover'] === false) {
            return;
        }
        const country = d.properties;
        if (this._flatOptions['geographyConfig.popupTemplate']) {
            this._barTipNode.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, this._flatOptions['geographyConfig.popupTemplate'](d));
        }
        else {
            this._barTip.select('.tooltip-inner').text(country ? country.name : '');
        }
        this._onMouseMove(d);
    }
    _onMouseMove(d, x, y) {
        if (this._flatOptions['geographyConfig.popupOnHover'] === false) {
            return;
        }
        const mousePos = d3.mouse(this.nativeEl);
        const ox = x || mousePos[0] - this.nativeEl.clientLeft;
        const oy = y || mousePos[1] - this.nativeEl.clientTop;
        this._barTip
            .attr('class', 'bento-d3-tooltip top tooltip in')
            .style('display', 'block')
            .style('left', ox - this._barTipNode.getBoundingClientRect().width / 2 + 'px')
            .style('top', oy - this._barTipNode.getBoundingClientRect().height - 10 + 'px');
    }
    _onClick(d) {
        this.onDataMapClick.emit(d);
    }
    _onMouseOut() {
        d3.select('#' + this.tooltipID)
            .style('display', 'none')
            .style('top', '-9999px');
    }
    _onCanvasMouseMove() {
        // get node value from canvas pixel color
        const node = this._getNodeData();
        if (node.nodeData) {
            if (node.nodeData !== this._lastMouseOverObj) {
                this._lastMouseOverObj = node.nodeData;
                this._onMouseOver(node.nodeData);
            }
            this._onMouseMove(node.nodeData);
        }
        else {
            this._onMouseOut();
        }
    }
    _onCanvasClick() {
        const node = this._getNodeData();
        this._onClick(node.nodeData);
    }
    _getNodeData() {
        const mousePos = d3.mouse(this.nativeEl);
        const mouseX = mousePos[0] - this.nativeEl.clientLeft;
        const mouseY = mousePos[1] - this.nativeEl.clientTop;
        // get the toolbox for the hidden canvas
        const hiddenCtx = this._canvasHidden.node().getContext('2d');
        // Now to pick the colours from where our mouse is then stringify it in a way our map-object can read it
        const col = hiddenCtx.getImageData(mouseX, mouseY, 1, 1).data;
        const colKey = 'rgb(' + col[0] + ',' + col[1] + ',' + col[2] + ')';
        // get the data from our map !
        const nodeData = this._colorToPath[colKey];
        return {
            nodeData,
            mouseX,
            mouseY
        };
    }
}
BentoD3DataMapComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoD3DataMapComponent, deps: [{ token: i0.ElementRef }, { token: BentoD3DataMapComponentWorld50 }, { token: i2.HttpClient }, { token: BentoDataMapService }, { token: i4.WindowRef }, { token: i5.DomSanitizer }, { token: i4.BentoNotification }], target: i0.ɵɵFactoryTarget.Component });
BentoD3DataMapComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoD3DataMapComponent, selector: "bento-d3-data-map", inputs: { options: "options" }, outputs: { onDataMapClick: "onDataMapClick", onDataMapHover: "onDataMapHover" }, providers: [BentoNotification, WindowRef], usesOnChanges: true, ngImport: i0, template: `
    <div class="datamap-main busy-loader" [bentoBusyLoader]="isBusyLoaderBusy"></div>
    <div [id]="tooltipID" class="bento-d3-tooltip top tooltip">
      <div class="tooltip-arrow"></div>
      <div class="tooltip-inner"></div>
    </div>
    <div id="zoom" class="zoom btn-group-vertical">
      <button aria-label="Zoom in" type="button" class="btn btn-icon btn-zoom" (click)="zoomIn()">
        <i class="bento-icon-plus-plain" aria-hidden="true"></i>
      </button>
      <button aria-label="Zoom out" type="button" class="btn btn-icon btn-zoom" (click)="zoomOut()">
        <i class="bento-icon-minus-plain" aria-hidden="true"></i>
      </button>
    </div>
  `, isInline: true, directives: [{ type: i4.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoD3DataMapComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bento-d3-data-map',
                    template: `
    <div class="datamap-main busy-loader" [bentoBusyLoader]="isBusyLoaderBusy"></div>
    <div [id]="tooltipID" class="bento-d3-tooltip top tooltip">
      <div class="tooltip-arrow"></div>
      <div class="tooltip-inner"></div>
    </div>
    <div id="zoom" class="zoom btn-group-vertical">
      <button aria-label="Zoom in" type="button" class="btn btn-icon btn-zoom" (click)="zoomIn()">
        <i class="bento-icon-plus-plain" aria-hidden="true"></i>
      </button>
      <button aria-label="Zoom out" type="button" class="btn btn-icon btn-zoom" (click)="zoomOut()">
        <i class="bento-icon-minus-plain" aria-hidden="true"></i>
      </button>
    </div>
  `,
                    providers: [BentoNotification, WindowRef]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BentoD3DataMapComponentWorld50 }, { type: i2.HttpClient }, { type: BentoDataMapService }, { type: i4.WindowRef }, { type: i5.DomSanitizer }, { type: i4.BentoNotification }]; }, propDecorators: { options: [{
                type: Input
            }], onDataMapClick: [{
                type: Output
            }], onDataMapHover: [{
                type: Output
            }] } });

class BentoD3DataMapModule {
}
BentoD3DataMapModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoD3DataMapModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BentoD3DataMapModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoD3DataMapModule, declarations: [BentoD3DataMapComponent], imports: [BentoBusyLoaderModule], exports: [BentoD3DataMapComponent] });
BentoD3DataMapModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoD3DataMapModule, providers: [BentoDataMapService, BentoD3DataMapComponentWorld50, BentoUtilsModule], imports: [[BentoBusyLoaderModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoD3DataMapModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [BentoBusyLoaderModule],
                    declarations: [BentoD3DataMapComponent],
                    providers: [BentoDataMapService, BentoD3DataMapComponentWorld50, BentoUtilsModule],
                    exports: [BentoD3DataMapComponent]
                }]
        }] });

/*
 * Public API Surface of bento-ng-datamap
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BentoD3DataMapComponent, BentoD3DataMapModule };
